var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/utils/name.ts
var name_exports = {};
__export(name_exports, {
  NAME_AND: () => NAME_AND,
  NAME_HONORIFIC: () => NAME_HONORIFIC,
  NAME_SUFFIX: () => NAME_SUFFIX,
  businessNameWords: () => businessNameWords,
  capitalizedOnlyBusinessWords: () => capitalizedOnlyBusinessWords,
  formatFullName: () => formatFullName,
  formatOwnerName: () => formatOwnerName,
  isBusinessName: () => isBusinessName,
  isSurnameFirst: () => isSurnameFirst,
  parseFullName: () => parseFullName,
  parseOwnerName: () => parseOwnerName
});
function formatFullName(firstName, lastName) {
  if (!firstName && !lastName) return "";
  if (!firstName) return lastName;
  if (!lastName) return firstName;
  return `${firstName} ${lastName}`.trim();
}
function parseFullName(fullName) {
  if (!fullName || typeof fullName !== "string") {
    return { firstName: "", lastName: "" };
  }
  const trimmed = fullName.trim();
  if (!trimmed) {
    return { firstName: "", lastName: "" };
  }
  const parts = trimmed.split(/\s+/);
  if (parts.length === 1) {
    return { firstName: parts[0], lastName: "" };
  }
  const firstName = parts[0];
  const lastName = parts.slice(1).join(" ");
  return { firstName, lastName };
}
function toTitleCase(str) {
  return str.toLowerCase().split(" ").map((word) => {
    if (!word) return word;
    if (["of", "the", "and", "llc", "llp", "inc", "lp"].includes(word)) {
      return word.toUpperCase() === "LLC" || word.toUpperCase() === "LLP" || word.toUpperCase() === "INC" || word.toUpperCase() === "LP" ? word.toUpperCase() : word;
    }
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join(" ");
}
function businessNameWords() {
  return [
    "LLC",
    "LLP",
    "LP",
    "PLLC",
    "INC",
    "INCORPORATED",
    "CORP",
    "CORPORATION",
    "COMPANY",
    "CO",
    "LTD",
    "LIMITED",
    "PC",
    "ASSOCIATION",
    "ASSOC",
    "ASSN",
    "ASSOCIATES",
    "AND SONS",
    "FOUNDATION",
    "FUND",
    "TRUST",
    "SOCIETY",
    "CLUB",
    "CHURCH",
    "MINISTRY",
    "MINISTRIES",
    "DIOCESE",
    "SYNAGOGUE",
    "MOSQUE",
    "BANK",
    "CREDIT UNION",
    "CITY OF",
    "COUNTY OF",
    "STATE OF",
    "TOWN OF",
    "VILLAGE OF",
    "BOROUGH OF",
    "TOWNSHIP",
    "DISTRICT",
    "SCHOOL",
    "ACADEMY",
    "UNIVERSITY",
    "COLLEGE",
    "HOSPITAL",
    "CLINIC",
    "DENTAL",
    "MEDICAL",
    "VETERINARY",
    "OWNERS",
    "COMMUNITY",
    "APARTMENTS",
    "APTS",
    "CONDOMINIUM",
    "CONDOMINIUMS",
    "CONDO",
    "CONDOS",
    "PROPERTIES",
    "PROPERTY",
    "REALTY",
    "REALTORS",
    "REAL ESTATE",
    "ESTATES",
    "COMMONS",
    "PLAZA",
    "MALL",
    "CENTER",
    "CENTRE",
    "DEVELOPMENT",
    "DEVELOPERS",
    "BUILDERS",
    "CONSTRUCTION",
    "HOLDINGS",
    "INVESTMENTS",
    "ENTERPRISES",
    "INDUSTRIES",
    "PARTNERS",
    "PARTNERSHIP",
    "VENTURES",
    "MANAGEMENT",
    "MGMT",
    "SERVICES",
    "SOLUTIONS",
    "GROUP",
    "BUSINESS",
    "OFFICES",
    "HOTEL",
    "MOTEL",
    "RESTAURANT",
    "CAFE",
    "GOLF",
    "FARMS",
    "RANCH",
    "STORAGE",
    "MOTORS"
  ];
}
function capitalizedOnlyBusinessWords() {
  return ["HOA", "POA", "COA", "PA"];
}
function isBusinessName(name) {
  if (!name) return false;
  const upper = name.toUpperCase().replace(/\./g, "").replace(/&/g, " AND ").replace(/\s+/g, " ").trim();
  const words = businessNameWords().map((w) => w.replace(/\s+/g, "\\s+"));
  if (new RegExp(`\\b(?:${words.join("|")})\\b`).test(upper)) return true;
  const asWritten = name.replace(/\./g, "");
  return asWritten !== asWritten.toUpperCase() && new RegExp(`\\b(?:${capitalizedOnlyBusinessWords().join("|")})\\b`).test(asWritten);
}
function nameLikeBusinessWords() {
  return /* @__PURE__ */ new Set([
    "DISTRICT",
    "ACADEMY",
    "CLINIC",
    "DENTAL",
    "MEDICAL",
    "VETERINARY",
    "OWNERS",
    "COMMUNITY",
    "ESTATES",
    "COMMONS",
    "PLAZA",
    "MALL",
    "CENTER",
    "CENTRE",
    "BUSINESS",
    "CAFE",
    "GOLF",
    "FARMS",
    "RANCH",
    "TRUST"
  ]);
}
function isParcelOwnerBusinessName(name) {
  if (!name) return false;
  const upper = name.toUpperCase().replace(/\./g, "").replace(/&/g, " AND ").replace(/\s+/g, " ").trim();
  const nameLike = nameLikeBusinessWords();
  const words = businessNameWords().filter((w) => !nameLike.has(w)).map((w) => w.replace(/\s+/g, "\\s+"));
  return new RegExp(`\\b(?:${words.join("|")})\\b`).test(upper);
}
function isTrustName(name) {
  const upper = name.toUpperCase();
  return /\bTRUST(EE)?\b/.test(upper);
}
function splitFirstLast(tokens) {
  const t = tokens.filter((w) => !HONORIFIC.test(w));
  if (t.length === 0) return { first: "", last: "" };
  if (t.length === 1) return { first: t[0], last: "" };
  let end = t.length;
  const suffixes = [];
  while (end > 1 && NAME_SUFFIX.test(t[end - 1].replace(/,$/, ""))) {
    suffixes.unshift(t[end - 1].replace(/,$/, ""));
    end--;
  }
  let start = end - 1;
  while (start > 1 && PARTICLE.test(t[start - 1])) start--;
  return { first: t.slice(0, start).join(" "), last: [...t.slice(start, end), ...suffixes].join(" ") };
}
function isSurnameFirst(text) {
  const comma = text.indexOf(",");
  if (comma <= 0) return false;
  const left = text.slice(0, comma).trim();
  const right = text.slice(comma + 1).trim();
  const surname = left.split(/\s+/).filter(Boolean);
  if (!right || surname.length === 0 || surname.length > 3 || /\d/.test(left)) return false;
  if (right.split(/\s+/).every((w) => NAME_SUFFIX.test(w))) return false;
  if (isBusinessName(right.replace(/,/g, " "))) return false;
  return surname.length === 1 || !isBusinessName(left) && !isTrustName(left);
}
function parseFirstLast(text) {
  let tokens = text.replace(/\s*&\s*/g, " & ").split(/\s+/).filter(Boolean);
  tokens = tokens.filter((w) => !HONORIFIC.test(w));
  while (tokens.length && AND.test(tokens[0])) tokens.shift();
  const at = tokens.findIndex((w) => AND.test(w));
  if (at < 0) {
    const { first, last } = splitFirstLast(tokens);
    return { firstName: first, lastName: last };
  }
  const left = tokens.slice(0, at);
  const right = tokens.slice(at + 1);
  if (left.length >= 2) {
    const one = splitFirstLast(left);
    const second = right.length >= 2 ? splitFirstLast(right).first : right[0] ?? "";
    return { firstName: [one.first, second].filter(Boolean).join(" & "), lastName: one.last };
  }
  const two = splitFirstLast(right);
  return { firstName: [left.join(" "), two.first].filter(Boolean).join(" & "), lastName: two.last };
}
function parseOwnerName(ownerName, options = {}) {
  if (!ownerName || typeof ownerName !== "string") {
    return { firstName: "", lastName: "" };
  }
  const trimmed = ownerName.trim();
  if (!trimmed) {
    return { firstName: "", lastName: "" };
  }
  const firstLast = options.order === "first_last";
  const fmt = (text) => options.titleCase === false ? text.replace(/\s+/g, " ").trim() : toTitleCase(text);
  if (trimmed.includes("/")) {
    const owners = trimmed.split("/").map((o) => fmt(o.trim())).filter(Boolean);
    return { firstName: "", lastName: owners.join(" / ") };
  }
  const surnameFirst = firstLast && isSurnameFirst(trimmed);
  const isBusiness = options.order ? isBusinessName : isParcelOwnerBusinessName;
  if (!surnameFirst && isBusiness(trimmed)) {
    return { firstName: "", lastName: fmt(trimmed) };
  }
  if (!surnameFirst && isTrustName(trimmed)) {
    return { firstName: "", lastName: fmt(trimmed) };
  }
  if (firstLast) {
    const comma = trimmed.indexOf(",");
    const left = comma >= 0 ? trimmed.slice(0, comma).trim() : trimmed;
    const right = comma >= 0 ? trimmed.slice(comma + 1).trim() : "";
    const rightIsSuffix = right !== "" && right.split(/\s+/).every((w) => NAME_SUFFIX.test(w));
    if (comma >= 0 && right && !rightIsSuffix) {
      const first = right.replace(/\s*&\s*/g, " & ").split(/\s+/).filter((w) => w && !HONORIFIC.test(w)).join(" ").replace(/^&\s*|\s*&$/g, "").trim();
      return { firstName: fmt(first), lastName: fmt(left) };
    }
    const { firstName: firstName2, lastName: lastName2 } = parseFirstLast(rightIsSuffix ? `${left} ${right}` : left);
    return { firstName: fmt(firstName2), lastName: fmt(lastName2) };
  }
  if (trimmed.includes(",")) {
    const [lastPart, ...restParts] = trimmed.split(",");
    const lastName2 = fmt(lastPart.trim());
    const firstPart = restParts.join(",").trim();
    const firstName2 = fmt(firstPart);
    return { firstName: firstName2, lastName: lastName2 };
  }
  const words = trimmed.split(/\s+/);
  if (words.length === 1) {
    return { firstName: "", lastName: fmt(words[0]) };
  }
  const lastName = fmt(words[0]);
  const firstName = fmt(words.slice(1).join(" "));
  return { firstName, lastName };
}
function formatOwnerName(ownerName) {
  if (!ownerName || typeof ownerName !== "string") {
    return "";
  }
  const { firstName, lastName } = parseOwnerName(ownerName);
  if (!firstName && !lastName) return "";
  if (!firstName) return lastName;
  if (!lastName) return firstName;
  return `${firstName} ${lastName}`;
}
var NAME_HONORIFIC, NAME_SUFFIX, NAME_AND, HONORIFIC, PARTICLE, AND;
var init_name = __esm({
  "src/utils/name.ts"() {
    "use strict";
    NAME_HONORIFIC = /^(?:mr|mrs|ms|miss|mx|dr|prof|rev|sir|madam|mme)\.?$/i;
    NAME_SUFFIX = /^(?:jr|sr|ii|iii|iv|v|md|m\.d\.|phd|ph\.d\.|esq|dds|cpa|dvm|rn)\.?$/i;
    NAME_AND = /^(?:&|and|\+)$/i;
    HONORIFIC = NAME_HONORIFIC;
    PARTICLE = /^(?:van|von|de|del|della|der|den|di|da|du|la|le|st\.?|ste\.?|dos|das|ten|ter|bin|ibn|al|el|mac|o')$/i;
    AND = NAME_AND;
  }
});

// src/domain/enums/common.ts
var EntityType = /* @__PURE__ */ ((EntityType2) => {
  EntityType2["INBOUND_EMAIL_RECEIPT"] = "INBOUND_EMAIL_RECEIPT";
  EntityType2["SERVICE_TEMPLATE"] = "SERVICE_TEMPLATE";
  EntityType2["CUSTOMER"] = "CUSTOMER";
  EntityType2["CUSTOMER_ACCOUNT"] = "CUSTOMER_ACCOUNT";
  EntityType2["ACCOUNT_PROPERTY"] = "ACCOUNT_PROPERTY";
  EntityType2["ACCOUNT_MEMBER"] = "ACCOUNT_MEMBER";
  EntityType2["ORGANIZATION_MEMBER"] = "ORGANIZATION_MEMBER";
  EntityType2["RATE_REQUEST"] = "RATE_REQUEST";
  EntityType2["CREW"] = "CREW";
  EntityType2["VISIT"] = "VISIT";
  EntityType2["INVOICE"] = "INVOICE";
  EntityType2["SERVICE_AREA"] = "SERVICE_AREA";
  EntityType2["CLOCK_EVENT"] = "CLOCK_EVENT";
  EntityType2["SUBSCRIPTION"] = "SUBSCRIPTION";
  EntityType2["ORGANIZATION"] = "ORGANIZATION";
  EntityType2["NOTIFICATION"] = "NOTIFICATION";
  EntityType2["MESSAGE"] = "MESSAGE";
  EntityType2["CREW_MESSAGE"] = "CREW_MESSAGE";
  EntityType2["MESSAGE_ACKNOWLEDGMENT"] = "MESSAGE_ACKNOWLEDGMENT";
  EntityType2["CONVERSATION_SUMMARY"] = "CONVERSATION_SUMMARY";
  EntityType2["PAYMENT_METHOD"] = "PAYMENT_METHOD";
  EntityType2["PAYMENT_METHOD_GROUP_MAPPING"] = "PAYMENT_METHOD_GROUP_MAPPING";
  EntityType2["LEDGER_ENTRY"] = "LEDGER_ENTRY";
  EntityType2["NOTE_READ"] = "NOTE_READ";
  EntityType2["PRIORITY_REMINDER"] = "PRIORITY_REMINDER";
  EntityType2["OTP"] = "OTP";
  EntityType2["LOCATION"] = "LOCATION";
  EntityType2["BATCH"] = "BATCH";
  EntityType2["PARCEL_MEASUREMENT"] = "PARCEL_MEASUREMENT";
  EntityType2["MESSAGE_CAMPAIGN"] = "MESSAGE_CAMPAIGN";
  EntityType2["MESSAGE_CAMPAIGN_SCHEDULE"] = "MESSAGE_CAMPAIGN_SCHEDULE";
  EntityType2["MESSAGE_DELIVERY"] = "MESSAGE_DELIVERY";
  EntityType2["MESSAGE_TEMPLATE"] = "MESSAGE_TEMPLATE";
  EntityType2["DISPOSAL_PILE"] = "DISPOSAL_PILE";
  EntityType2["DISPATCH_JOB"] = "DISPATCH_JOB";
  EntityType2["DISPATCH_BATCH"] = "DISPATCH_BATCH";
  EntityType2["AI_IMPORT_JOB"] = "AI_IMPORT_JOB";
  EntityType2["ROLE"] = "ROLE";
  EntityType2["CHAT_CONVERSATION"] = "CHAT_CONVERSATION";
  EntityType2["CHAT_MESSAGE"] = "CHAT_MESSAGE";
  EntityType2["CHAT_MEMBERSHIP"] = "CHAT_MEMBERSHIP";
  EntityType2["CHAT_MESSAGE_ACK"] = "CHAT_MESSAGE_ACK";
  EntityType2["SUBCONTRACTOR_COMPANY"] = "SUBCONTRACTOR_COMPANY";
  EntityType2["SUBCONTRACTOR_DAY_PAYMENT"] = "SUBCONTRACTOR_DAY_PAYMENT";
  EntityType2["WEATHER_FORECAST_ALERT"] = "WEATHER_FORECAST_ALERT";
  EntityType2["PICKLIST_ITEM"] = "PICKLIST_ITEM";
  EntityType2["NOTIFICATION_TEMPLATE_OVERRIDE"] = "NOTIFICATION_TEMPLATE_OVERRIDE";
  EntityType2["CUSTOMER_CONTACT"] = "CUSTOMER_CONTACT";
  EntityType2["SERVICE_BUNDLE"] = "SERVICE_BUNDLE";
  EntityType2["TERMS_ACCEPTANCE"] = "TERMS_ACCEPTANCE";
  EntityType2["PORTAL_LOGIN"] = "PORTAL_LOGIN";
  EntityType2["PAYMENT_PLAN"] = "PAYMENT_PLAN";
  EntityType2["DAILY_PERFORMANCE_METRICS"] = "DAILY_PERFORMANCE_METRICS";
  EntityType2["AI_CONVERSATION"] = "AI_CONVERSATION";
  EntityType2["PHOTO_PURGE_POINTER"] = "PHOTO_PURGE_POINTER";
  EntityType2["PLATFORM_INVOICE"] = "PLATFORM_INVOICE";
  EntityType2["AGENT_DRAFT"] = "AGENT_DRAFT";
  EntityType2["AGENT_RUN_LOG"] = "AGENT_RUN_LOG";
  EntityType2["SIGNUP_DRAFT"] = "SIGNUP_DRAFT";
  EntityType2["IMPORT_LAYOUT_RECIPE"] = "IMPORT_LAYOUT_RECIPE";
  EntityType2["IMPORT_LAYOUT_FAMILY"] = "IMPORT_LAYOUT_FAMILY";
  EntityType2["OPERATOR_NOTES"] = "OPERATOR_NOTES";
  EntityType2["OPERATOR_AUDIT"] = "OPERATOR_AUDIT";
  return EntityType2;
})(EntityType || {});
var DayOfWeek = /* @__PURE__ */ ((DayOfWeek2) => {
  DayOfWeek2["MONDAY"] = "monday";
  DayOfWeek2["TUESDAY"] = "tuesday";
  DayOfWeek2["WEDNESDAY"] = "wednesday";
  DayOfWeek2["THURSDAY"] = "thursday";
  DayOfWeek2["FRIDAY"] = "friday";
  DayOfWeek2["SATURDAY"] = "saturday";
  DayOfWeek2["SUNDAY"] = "sunday";
  return DayOfWeek2;
})(DayOfWeek || {});

// src/domain/enums/customer.ts
var CustomerStatus = /* @__PURE__ */ ((CustomerStatus2) => {
  CustomerStatus2["ACTIVE"] = "active";
  CustomerStatus2["INACTIVE"] = "inactive";
  CustomerStatus2["SUSPENDED"] = "suspended";
  CustomerStatus2["PROSPECT"] = "prospect";
  CustomerStatus2["CONTACTED"] = "contacted";
  CustomerStatus2["QUOTED"] = "quoted";
  CustomerStatus2["PENDING"] = "pending";
  CustomerStatus2["OUT_OF_SERVICE_AREA"] = "out_of_service_area";
  CustomerStatus2["UNCONFIGURED"] = "unconfigured";
  CustomerStatus2["PARTIALLY_CONFIGURED"] = "partially_configured";
  CustomerStatus2["FULLY_CONFIGURED"] = "fully_configured";
  return CustomerStatus2;
})(CustomerStatus || {});
var CustomerDeactivationReason = /* @__PURE__ */ ((CustomerDeactivationReason2) => {
  CustomerDeactivationReason2["MOVED"] = "moved";
  CustomerDeactivationReason2["OUT_OF_AREA"] = "out_of_area";
  CustomerDeactivationReason2["PRICING"] = "pricing";
  CustomerDeactivationReason2["NO_CONTACT"] = "no_contact";
  CustomerDeactivationReason2["OTHER"] = "other";
  return CustomerDeactivationReason2;
})(CustomerDeactivationReason || {});
var CUSTOMER_DEACTIVATION_REASONS = [
  "moved" /* MOVED */,
  "out_of_area" /* OUT_OF_AREA */,
  "pricing" /* PRICING */,
  "no_contact" /* NO_CONTACT */,
  "other" /* OTHER */
];
var CUSTOMER_DEACTIVATION_REASON_LABELS = {
  ["moved" /* MOVED */]: "Moved / sold the house",
  ["out_of_area" /* OUT_OF_AREA */]: "Outside our service area",
  ["pricing" /* PRICING */]: "Not a fit for our pricing",
  ["no_contact" /* NO_CONTACT */]: "Requested no contact",
  ["other" /* OTHER */]: "Other"
};
var CustomerSource = /* @__PURE__ */ ((CustomerSource2) => {
  CustomerSource2["RATE_REQUEST"] = "rate_request";
  CustomerSource2["MANUAL"] = "manual";
  CustomerSource2["REFERRAL"] = "referral";
  CustomerSource2["MARKETING"] = "marketing";
  CustomerSource2["IMPORT"] = "import";
  return CustomerSource2;
})(CustomerSource || {});
var CustomerMetricType = /* @__PURE__ */ ((CustomerMetricType2) => {
  CustomerMetricType2["ROCK"] = "rock";
  CustomerMetricType2["WOOD_MULCH"] = "wood_mulch";
  CustomerMetricType2["TURF"] = "turf";
  CustomerMetricType2["DRIVEWAY"] = "driveway";
  CustomerMetricType2["SIDEWALK"] = "sidewalk";
  CustomerMetricType2["WALKWAY"] = "walkway";
  return CustomerMetricType2;
})(CustomerMetricType || {});

// src/domain/enums/service.ts
var ServiceType = /* @__PURE__ */ ((ServiceType2) => {
  ServiceType2["ONE_TIME"] = "one_time";
  ServiceType2["RECURRING"] = "recurring";
  return ServiceType2;
})(ServiceType || {});
var ServiceTemplateStatus = /* @__PURE__ */ ((ServiceTemplateStatus2) => {
  ServiceTemplateStatus2["ACTIVE"] = "active";
  ServiceTemplateStatus2["INACTIVE"] = "inactive";
  ServiceTemplateStatus2["DRAFT"] = "draft";
  return ServiceTemplateStatus2;
})(ServiceTemplateStatus || {});
var NotifyCustomerOnReviewSetting = /* @__PURE__ */ ((NotifyCustomerOnReviewSetting2) => {
  NotifyCustomerOnReviewSetting2["SEND"] = "send";
  NotifyCustomerOnReviewSetting2["HOLD"] = "hold";
  NotifyCustomerOnReviewSetting2["INHERIT"] = "inherit";
  return NotifyCustomerOnReviewSetting2;
})(NotifyCustomerOnReviewSetting || {});
var BillingMethod = /* @__PURE__ */ ((BillingMethod2) => {
  BillingMethod2["PER_VISIT"] = "per_visit";
  BillingMethod2["PER_HOUR"] = "per_hour";
  BillingMethod2["PACKAGE"] = "package";
  BillingMethod2["CONSUMABLE"] = "consumable";
  return BillingMethod2;
})(BillingMethod || {});
function billingMethodOf(value) {
  const normalized = String(value ?? "").trim().replace(/-/g, "_").toLowerCase();
  const values = Object.values(BillingMethod);
  return values.includes(normalized) ? normalized : null;
}
function normalizeBillingMethod(raw) {
  if (raw == null || raw === "") return "per_visit" /* PER_VISIT */;
  const method = billingMethodOf(raw);
  if (method) return method;
  throw new Error(`Unknown billing method: ${raw}`);
}
var PricingMethod = /* @__PURE__ */ ((PricingMethod2) => {
  PricingMethod2["PER_HOUR"] = "per_hour";
  PricingMethod2["BILLABLE_LABOR_RATE"] = "billable_labor_rate";
  PricingMethod2["UNIT_BASED"] = "unit_based";
  PricingMethod2["FIXED_PRICE"] = "fixed_price";
  PricingMethod2["PACKAGE"] = "package";
  PricingMethod2["CONSUMABLE"] = "consumable";
  return PricingMethod2;
})(PricingMethod || {});
function requiresRateConfiguration(billingMethod, pricingMethod) {
  if (billingMethod === "per_hour" /* PER_HOUR */ || billingMethod === "consumable" /* CONSUMABLE */) return false;
  if (pricingMethod === "fixed_price" /* FIXED_PRICE */) return false;
  return true;
}
var ScheduleFrequency = /* @__PURE__ */ ((ScheduleFrequency2) => {
  ScheduleFrequency2["ONE_TIME"] = "one_time";
  ScheduleFrequency2["ON_DEMAND"] = "on_demand";
  ScheduleFrequency2["WEEKLY"] = "weekly";
  ScheduleFrequency2["MONTHLY"] = "monthly";
  ScheduleFrequency2["YEARLY"] = "yearly";
  ScheduleFrequency2["CUSTOM"] = "custom";
  return ScheduleFrequency2;
})(ScheduleFrequency || {});
var VolumePricingType = /* @__PURE__ */ ((VolumePricingType2) => {
  VolumePricingType2["PER_UNIT"] = "per_unit";
  VolumePricingType2["TIERED"] = "tiered";
  return VolumePricingType2;
})(VolumePricingType || {});
var ServiceOptionRateType = /* @__PURE__ */ ((ServiceOptionRateType2) => {
  ServiceOptionRateType2["FLAT"] = "flat";
  ServiceOptionRateType2["PER_UNIT"] = "per-unit";
  ServiceOptionRateType2["TIME_BASED"] = "time-based";
  ServiceOptionRateType2["MULTI_SELECT"] = "multi-select";
  return ServiceOptionRateType2;
})(ServiceOptionRateType || {});
var TimeBasedUnit = /* @__PURE__ */ ((TimeBasedUnit2) => {
  TimeBasedUnit2["HOURS"] = "hours";
  TimeBasedUnit2["MINUTES"] = "minutes";
  return TimeBasedUnit2;
})(TimeBasedUnit || {});
var UnitType = /* @__PURE__ */ ((UnitType2) => {
  UnitType2["SQFT"] = "sqft";
  UnitType2["LINFT"] = "linft";
  UnitType2["ACRE"] = "acre";
  return UnitType2;
})(UnitType || {});
var CustomScheduleUnit = /* @__PURE__ */ ((CustomScheduleUnit2) => {
  CustomScheduleUnit2["DAYS"] = "days";
  CustomScheduleUnit2["WEEKS"] = "weeks";
  CustomScheduleUnit2["MONTHS"] = "months";
  CustomScheduleUnit2["YEARS"] = "years";
  return CustomScheduleUnit2;
})(CustomScheduleUnit || {});
var DayPreferencePriority = /* @__PURE__ */ ((DayPreferencePriority2) => {
  DayPreferencePriority2["PREFERRED"] = "preferred";
  DayPreferencePriority2["REQUIRED"] = "required";
  DayPreferencePriority2["AVOIDED"] = "avoided";
  return DayPreferencePriority2;
})(DayPreferencePriority || {});
var PricingInputType = /* @__PURE__ */ ((PricingInputType2) => {
  PricingInputType2["HOURS"] = "hours";
  PricingInputType2["SQUARE_FOOTAGE"] = "square_footage";
  PricingInputType2["LINEAR_FOOTAGE"] = "linear_footage";
  PricingInputType2["PROPERTY_TYPE"] = "property_type";
  PricingInputType2["ACCESS_DIFFICULTY"] = "access_difficulty";
  PricingInputType2["MATERIAL_GRADE"] = "material_grade";
  PricingInputType2["URGENCY"] = "urgency";
  PricingInputType2["CUSTOM_TEXT"] = "custom_text";
  PricingInputType2["CUSTOM_NUMBER"] = "custom_number";
  PricingInputType2["CUSTOM_SELECT"] = "custom_select";
  return PricingInputType2;
})(PricingInputType || {});

// src/domain/enums/service-template.ts
var AutoSharePhotosSetting = /* @__PURE__ */ ((AutoSharePhotosSetting2) => {
  AutoSharePhotosSetting2["ON"] = "on";
  AutoSharePhotosSetting2["OFF"] = "off";
  AutoSharePhotosSetting2["INHERIT"] = "inherit";
  return AutoSharePhotosSetting2;
})(AutoSharePhotosSetting || {});
var ShowLaborHoursSetting = /* @__PURE__ */ ((ShowLaborHoursSetting2) => {
  ShowLaborHoursSetting2["ON"] = "on";
  ShowLaborHoursSetting2["OFF"] = "off";
  ShowLaborHoursSetting2["INHERIT"] = "inherit";
  return ShowLaborHoursSetting2;
})(ShowLaborHoursSetting || {});
var WeatherDimension = /* @__PURE__ */ ((WeatherDimension2) => {
  WeatherDimension2["TEMPERATURE"] = "temperature";
  WeatherDimension2["WIND"] = "wind";
  WeatherDimension2["PRECIPITATION"] = "precipitation";
  return WeatherDimension2;
})(WeatherDimension || {});

// src/domain/enums/visit.ts
var VisitStatus = /* @__PURE__ */ ((VisitStatus2) => {
  VisitStatus2["NOT_STARTED"] = "not-started";
  VisitStatus2["IN_PROGRESS"] = "in-progress";
  VisitStatus2["COMPLETED"] = "completed";
  VisitStatus2["PAID"] = "paid";
  VisitStatus2["PAUSED"] = "paused";
  VisitStatus2["SKIPPED"] = "skipped";
  VisitStatus2["NEEDS_REVIEW"] = "needs-review";
  VisitStatus2["CANCELLED"] = "cancelled";
  VisitStatus2["DISCARDED"] = "discarded";
  VisitStatus2["VOIDED"] = "voided";
  VisitStatus2["REFUNDED"] = "refunded";
  return VisitStatus2;
})(VisitStatus || {});
var VisitApprovalStatus = /* @__PURE__ */ ((VisitApprovalStatus2) => {
  VisitApprovalStatus2["APPROVED"] = "approved";
  VisitApprovalStatus2["NEEDS_PRICING"] = "needs-pricing";
  VisitApprovalStatus2["PENDING_ASSIGNMENT"] = "pending-assignment";
  return VisitApprovalStatus2;
})(VisitApprovalStatus || {});
var VisitReviewStatus = /* @__PURE__ */ ((VisitReviewStatus2) => {
  VisitReviewStatus2["PENDING_REVIEW"] = "pending-review";
  VisitReviewStatus2["APPROVED"] = "approved";
  VisitReviewStatus2["ADJUSTED"] = "adjusted";
  VisitReviewStatus2["DISMISSED"] = "dismissed";
  return VisitReviewStatus2;
})(VisitReviewStatus || {});
var VisitReviewReason = /* @__PURE__ */ ((VisitReviewReason2) => {
  VisitReviewReason2["HOURS_EXCEEDED_UPPER_BOUND"] = "hours_exceeded_upper_bound";
  VisitReviewReason2["HOURS_BELOW_LOWER_BOUND"] = "hours_below_lower_bound";
  VisitReviewReason2["MANUAL_FLAG"] = "manual_flag";
  VisitReviewReason2["QUALITY_ISSUE"] = "quality_issue";
  VisitReviewReason2["CUSTOMER_COMPLAINT"] = "customer_complaint";
  VisitReviewReason2["CREW_NOTE_NO_PHOTO"] = "crew_note_no_photo";
  VisitReviewReason2["CREW_TIMES_MISMATCH"] = "crew_times_mismatch";
  return VisitReviewReason2;
})(VisitReviewReason || {});
var VisitEventType = /* @__PURE__ */ ((VisitEventType2) => {
  VisitEventType2["START"] = "start";
  VisitEventType2["PAUSE"] = "pause";
  VisitEventType2["RESUME"] = "resume";
  VisitEventType2["COMPLETE"] = "complete";
  VisitEventType2["SKIP"] = "skip";
  return VisitEventType2;
})(VisitEventType || {});
var VisitPosition = /* @__PURE__ */ ((VisitPosition2) => {
  VisitPosition2["FIRST"] = "first";
  VisitPosition2["LAST"] = "last";
  VisitPosition2["BEFORE"] = "before";
  VisitPosition2["AFTER"] = "after";
  return VisitPosition2;
})(VisitPosition || {});
var NoteType = /* @__PURE__ */ ((NoteType2) => {
  NoteType2["ADMIN_NOTE"] = "adminNote";
  NoteType2["PRIORITY_NOTE"] = "priorityNote";
  return NoteType2;
})(NoteType || {});
var VisitType = /* @__PURE__ */ ((VisitType2) => {
  VisitType2["SERVICE"] = "service";
  VisitType2["ASSESSMENT"] = "assessment";
  VisitType2["FOLLOW_UP"] = "follow_up";
  return VisitType2;
})(VisitType || {});
var JobStatus = VisitStatus;

// src/domain/enums/organization.ts
var OrganizationMemberStatus = /* @__PURE__ */ ((OrganizationMemberStatus2) => {
  OrganizationMemberStatus2["PENDING_ONBOARDING"] = "pending_onboarding";
  OrganizationMemberStatus2["INVITED"] = "invited";
  OrganizationMemberStatus2["ACTIVE"] = "active";
  OrganizationMemberStatus2["INACTIVE"] = "inactive";
  OrganizationMemberStatus2["REMOVED"] = "removed";
  return OrganizationMemberStatus2;
})(OrganizationMemberStatus || {});
var EmploymentType = /* @__PURE__ */ ((EmploymentType2) => {
  EmploymentType2["EMPLOYEE"] = "employee";
  EmploymentType2["SUBCONTRACTOR"] = "subcontractor";
  EmploymentType2["SEASONAL"] = "seasonal";
  EmploymentType2["TEMPORARY"] = "temporary";
  return EmploymentType2;
})(EmploymentType || {});
var ChargingMode = /* @__PURE__ */ ((ChargingMode2) => {
  ChargingMode2["PER_VISIT"] = "per_visit";
  ChargingMode2["DAILY_BATCH"] = "daily_batch";
  return ChargingMode2;
})(ChargingMode || {});

// src/domain/enums/crew.ts
var CrewRole = /* @__PURE__ */ ((CrewRole2) => {
  CrewRole2["LEADER"] = "leader";
  CrewRole2["MEMBER"] = "member";
  return CrewRole2;
})(CrewRole || {});

// src/domain/enums/subscription.ts
var SubscriptionStatus = /* @__PURE__ */ ((SubscriptionStatus2) => {
  SubscriptionStatus2["ACTIVE"] = "active";
  SubscriptionStatus2["INACTIVE"] = "inactive";
  SubscriptionStatus2["CANCELLED"] = "cancelled";
  SubscriptionStatus2["PAYMENT_PENDING"] = "payment_pending";
  return SubscriptionStatus2;
})(SubscriptionStatus || {});
var RateVisibility = /* @__PURE__ */ ((RateVisibility2) => {
  RateVisibility2["VISIBLE"] = "visible";
  RateVisibility2["INVISIBLE"] = "invisible";
  return RateVisibility2;
})(RateVisibility || {});
var CrewAssignmentSource = /* @__PURE__ */ ((CrewAssignmentSource2) => {
  CrewAssignmentSource2["MANUAL"] = "manual";
  CrewAssignmentSource2["AUTO_RELATED"] = "auto_related";
  CrewAssignmentSource2["AUTO_GEO"] = "auto_geo";
  return CrewAssignmentSource2;
})(CrewAssignmentSource || {});
var SubscriptionAction = /* @__PURE__ */ ((SubscriptionAction2) => {
  SubscriptionAction2["ACCEPT"] = "accept";
  SubscriptionAction2["REJECT"] = "reject";
  SubscriptionAction2["ACTIVATE"] = "activate";
  SubscriptionAction2["PAUSE"] = "pause";
  SubscriptionAction2["UPDATE_PAUSE"] = "update_pause";
  SubscriptionAction2["CANCEL"] = "cancel";
  SubscriptionAction2["MAKE_VISIBLE"] = "make_visible";
  SubscriptionAction2["MAKE_INVISIBLE"] = "make_invisible";
  SubscriptionAction2["DISMISS"] = "dismiss";
  SubscriptionAction2["CANCEL_DEACTIVATION"] = "cancel_deactivation";
  SubscriptionAction2["CANCEL_ACTIVATION"] = "cancel_activation";
  SubscriptionAction2["RESCHEDULE_ACTIVATION"] = "reschedule_activation";
  SubscriptionAction2["SKIP_PERIOD"] = "skip_period";
  SubscriptionAction2["UNSKIP_PERIOD"] = "unskip_period";
  SubscriptionAction2["FINALIZE_PLAN_CHANGE"] = "finalize_plan_change";
  SubscriptionAction2["DECLINE_PLAN_CHANGE"] = "decline_plan_change";
  SubscriptionAction2["START_PLAN_CHANGE"] = "start_plan_change";
  SubscriptionAction2["REFUND_PACKAGE_CHARGE"] = "refund_package_charge";
  SubscriptionAction2["CLEAR_NEXT_VISIT"] = "clear_next_visit";
  return SubscriptionAction2;
})(SubscriptionAction || {});
var SubscriptionTier = /* @__PURE__ */ ((SubscriptionTier2) => {
  SubscriptionTier2["STARTER"] = "starter";
  SubscriptionTier2["GROWTH"] = "growth";
  SubscriptionTier2["PRO"] = "pro";
  SubscriptionTier2["PROFESSIONAL"] = "professional";
  SubscriptionTier2["ENTERPRISE"] = "enterprise";
  return SubscriptionTier2;
})(SubscriptionTier || {});

// src/domain/enums/payment.ts
var PaymentStatus = /* @__PURE__ */ ((PaymentStatus2) => {
  PaymentStatus2["SUCCEEDED"] = "succeeded";
  PaymentStatus2["FAILED"] = "failed";
  PaymentStatus2["PENDING"] = "pending";
  PaymentStatus2["PROCESSING"] = "processing";
  return PaymentStatus2;
})(PaymentStatus || {});
var InvoiceStatus = /* @__PURE__ */ ((InvoiceStatus2) => {
  InvoiceStatus2["PENDING"] = "pending";
  InvoiceStatus2["PAID"] = "paid";
  InvoiceStatus2["FAILED"] = "failed";
  InvoiceStatus2["PROCESSING"] = "processing";
  InvoiceStatus2["OVERDUE"] = "overdue";
  return InvoiceStatus2;
})(InvoiceStatus || {});
var ProvisioningStatus = /* @__PURE__ */ ((ProvisioningStatus2) => {
  ProvisioningStatus2["NOT_CONNECTED"] = "not_connected";
  ProvisioningStatus2["PENDING"] = "pending";
  ProvisioningStatus2["SUBMITTED"] = "submitted";
  ProvisioningStatus2["APPROVED"] = "approved";
  ProvisioningStatus2["REJECTED"] = "rejected";
  ProvisioningStatus2["REQUIRES_INFO"] = "requires_info";
  return ProvisioningStatus2;
})(ProvisioningStatus || {});

// src/domain/enums/notification.ts
var NotificationType = /* @__PURE__ */ ((NotificationType2) => {
  NotificationType2["RATE_REQUEST_SUBMITTED"] = "rate_request_submitted";
  NotificationType2["RATE_REQUEST_UPDATED"] = "rate_request_updated";
  NotificationType2["RATE_ACCEPTED"] = "rate_accepted";
  NotificationType2["RATE_DECLINED"] = "rate_declined";
  NotificationType2["RATE_REQUEST_RESURFACED"] = "rate_request_resurfaced";
  NotificationType2["CUSTOMER_RATE_REQUEST_RECEIVED"] = "customer_rate_request_received";
  NotificationType2["VISIT_SCHEDULED"] = "visit_scheduled";
  NotificationType2["VISIT_REMINDER"] = "visit_reminder";
  NotificationType2["VISIT_STARTED"] = "visit_started";
  NotificationType2["VISIT_PAUSED"] = "visit_paused";
  NotificationType2["VISIT_RESUMED"] = "visit_resumed";
  NotificationType2["VISIT_COMPLETED"] = "visit_completed";
  NotificationType2["VISIT_SKIPPED"] = "visit_skipped";
  NotificationType2["VISIT_DISCARDED"] = "visit_discarded";
  NotificationType2["VISIT_CANCELLED"] = "visit_cancelled";
  NotificationType2["VISIT_RESCHEDULED"] = "visit_rescheduled";
  NotificationType2["VISIT_PRIORITY_SET"] = "visit_priority_set";
  NotificationType2["VISIT_PRIORITY_REMINDER"] = "visit_priority_reminder";
  NotificationType2["VISIT_FOLLOWUP_CREATED"] = "visit_followup_created";
  NotificationType2["VISIT_NOTES_ADDED"] = "visit_notes_added";
  NotificationType2["VISIT_PHOTOS_ADDED"] = "visit_photos_added";
  NotificationType2["VISIT_PHOTO_APPROVAL_NEEDED"] = "visit_photo_approval_needed";
  NotificationType2["FOLLOWUP_VISIT_COMPLETED"] = "followup_visit_completed";
  NotificationType2["VISIT_COMPLETED_REMINDER"] = "visit_completed_reminder";
  NotificationType2["CREW_ASSIGNED"] = "crew_assigned";
  NotificationType2["CREW_REGISTRATION"] = "crew_registration";
  NotificationType2["CREW_CLOCK_IN"] = "crew_clock_in";
  NotificationType2["CREW_CLOCK_OUT"] = "crew_clock_out";
  NotificationType2["CREW_BULK_CLOCK_OUT"] = "crew_bulk_clock_out";
  NotificationType2["CREW_NEW_VISIT_SCHEDULED"] = "crew_new_visit_scheduled";
  NotificationType2["CREW_ASSESSMENT_CREATED"] = "crew_assessment_created";
  NotificationType2["CREW_DISPATCH_EXECUTED"] = "crew_dispatch_executed";
  NotificationType2["CREW_AUTO_ASSIGNED"] = "crew_auto_assigned";
  NotificationType2["CREW_ASSIGNMENT_CONFLICT"] = "crew_assignment_conflict";
  NotificationType2["CREW_SERVICE_REMOVED"] = "crew_service_removed";
  NotificationType2["CREW_SERVICE_DEACTIVATED"] = "crew_service_deactivated";
  NotificationType2["CREW_VISITS_DISPATCHED"] = "crew_visits_dispatched";
  NotificationType2["CREW_MEMBER_ADDED"] = "crew_member_added";
  NotificationType2["CREW_INACTIVE_2H"] = "crew_inactive_2h";
  NotificationType2["CREW_LOCATION_DROPPED"] = "crew_location_dropped";
  NotificationType2["CREW_LEFT_GEOFENCE"] = "crew_left_geofence";
  NotificationType2["CREW_APP_OUTDATED"] = "crew_app_outdated";
  NotificationType2["CREW_URGENT_MESSAGE_ACKNOWLEDGED"] = "crew_urgent_message_acknowledged";
  NotificationType2["CREW_NOTE_ACKNOWLEDGED"] = "crew_note_acknowledged";
  NotificationType2["CREW_ROUTE_ORDER_CHANGED"] = "crew_route_order_changed";
  NotificationType2["TEAM_DAY_STARTED"] = "team_day_started";
  NotificationType2["TEAM_DAY_ENDED"] = "team_day_ended";
  NotificationType2["PAYMENT_SUCCESSFUL"] = "payment_successful";
  NotificationType2["VISIT_PAYMENT_RECEIVED"] = "visit_payment_received";
  NotificationType2["BATCH_CHARGE_COMPLETED"] = "batch_charge_completed";
  NotificationType2["DAILY_COLLECTED_SUMMARY"] = "daily_collected_summary";
  NotificationType2["PAYMENT_FAILED"] = "payment_failed";
  NotificationType2["CUSTOMER_ADD_CARD_REMINDER"] = "customer_add_card_reminder";
  NotificationType2["PAYMENT_RETRY"] = "payment_retry";
  NotificationType2["PAYMENT_OVERDUE"] = "payment_overdue";
  NotificationType2["INVOICE_READY"] = "invoice_ready";
  NotificationType2["PAYMENT_METHOD_ADDED"] = "payment_method_added";
  NotificationType2["SERVICE_COMPLETED"] = "service_completed";
  NotificationType2["SERVICE_ACTIVATED"] = "service_activated";
  NotificationType2["SERVICE_SUSPENDED"] = "service_suspended";
  NotificationType2["SERVICE_CANCELLED"] = "service_cancelled";
  NotificationType2["SERVICE_DEACTIVATION_COMPLETED"] = "service_deactivation_completed";
  NotificationType2["ONE_TIME_DEADLINE_AT_RISK"] = "one_time_deadline_at_risk";
  NotificationType2["SUBSCRIPTION_REQUESTED"] = "subscription_requested";
  NotificationType2["SUBSCRIPTION_RATE_PROVIDED"] = "subscription_rate_provided";
  NotificationType2["SUBSCRIPTION_RATE_NOT_YET_AVAILABLE"] = "subscription_rate_not_yet_available";
  NotificationType2["SUBSCRIPTION_BATCH_RATES_RELEASED"] = "subscription_batch_rates_released";
  NotificationType2["SUBSCRIPTION_BATCH_CANCELLED"] = "subscription_batch_cancelled";
  NotificationType2["SUBSCRIPTION_ACCEPTED"] = "subscription_accepted";
  NotificationType2["SUBSCRIPTION_PAUSED"] = "subscription_paused";
  NotificationType2["SUBSCRIPTION_RESUMED"] = "subscription_resumed";
  NotificationType2["SUBSCRIPTION_NOTES_UPDATED"] = "subscription_notes_updated";
  NotificationType2["SUBSCRIPTION_CUSTOMER_SELECTIONS_CHANGED"] = "subscription_customer_selections_changed";
  NotificationType2["SUBSCRIPTION_PACKAGE_OPTION_CHANGED"] = "subscription_package_option_changed";
  NotificationType2["SUBSCRIPTION_PLAN_CHANGE_REQUESTED"] = "subscription_plan_change_requested";
  NotificationType2["JOB_REVIEW_REQUIRED"] = "job_review_required";
  NotificationType2["JOB_APPROVED"] = "job_approved";
  NotificationType2["JOB_REJECTED"] = "job_rejected";
  NotificationType2["SYSTEM_ALERT"] = "system_alert";
  NotificationType2["ACCOUNT_UPDATE"] = "account_update";
  NotificationType2["CUSTOMER_WELCOME"] = "customer_welcome";
  NotificationType2["CUSTOMER_PORTAL_REGISTERED"] = "customer_portal_registered";
  NotificationType2["CUSTOMER_PORTAL_LOGIN_REMINDER"] = "customer_portal_login_reminder";
  NotificationType2["ACCESS_REQUEST_SUBMITTED"] = "access_request_submitted";
  NotificationType2["ORGANIZATION_UPDATE"] = "organization_update";
  NotificationType2["HOLIDAY_DELAY_WARNING"] = "holiday_delay_warning";
  NotificationType2["CUSTOMER_MESSAGE"] = "customer_message";
  NotificationType2["ADMIN_MESSAGE"] = "admin_message";
  NotificationType2["SERVICE_ENROLLMENT_SCHEDULED"] = "service_enrollment_scheduled";
  NotificationType2["SHOP_ADVISOR"] = "shop_advisor";
  NotificationType2["FEEDBACK_RESOLVED"] = "feedback_resolved";
  return NotificationType2;
})(NotificationType || {});
var NotificationPriority = /* @__PURE__ */ ((NotificationPriority2) => {
  NotificationPriority2["LOW"] = "low";
  NotificationPriority2["MEDIUM"] = "medium";
  NotificationPriority2["HIGH"] = "high";
  NotificationPriority2["URGENT"] = "urgent";
  return NotificationPriority2;
})(NotificationPriority || {});
var NotificationStatus = /* @__PURE__ */ ((NotificationStatus2) => {
  NotificationStatus2["OK"] = "ok";
  NotificationStatus2["ERROR"] = "error";
  return NotificationStatus2;
})(NotificationStatus || {});
var MessageSender = /* @__PURE__ */ ((MessageSender2) => {
  MessageSender2["CUSTOMER"] = "customer";
  MessageSender2["ADMIN"] = "admin";
  MessageSender2["SYSTEM"] = "system";
  return MessageSender2;
})(MessageSender || {});
var PushNotificationType = /* @__PURE__ */ ((PushNotificationType2) => {
  PushNotificationType2["JOB_ASSIGNMENT"] = "job_assignment";
  PushNotificationType2["SCHEDULE_CHANGE"] = "schedule_change";
  PushNotificationType2["JOB_CANCELLATION"] = "job_cancellation";
  PushNotificationType2["ADMIN_MESSAGE"] = "admin_message";
  PushNotificationType2["EMERGENCY"] = "emergency";
  PushNotificationType2["CREW_MESSAGE"] = "crew_message";
  PushNotificationType2["CREW_MEMBER_ADDED"] = "crew_member_added";
  PushNotificationType2["CREW_MEMBER_REMOVED"] = "crew_member_removed";
  PushNotificationType2["CHAT_MESSAGE"] = "chat_message";
  PushNotificationType2["VISIT_COMPLETED_SYNC"] = "visit_completed_sync";
  PushNotificationType2["VISIT_STARTED"] = "visit_started";
  PushNotificationType2["CLOCK_OUT_REMINDER"] = "clock_out_reminder";
  PushNotificationType2["VISIT_PRIORITY_SET"] = "visit_priority_set";
  PushNotificationType2["VISIT_PRIORITY_REMINDER"] = "visit_priority_reminder";
  PushNotificationType2["VISIT_REASSIGNED"] = "visit_reassigned";
  PushNotificationType2["LOCATION_NUDGE"] = "location_nudge";
  PushNotificationType2["LOCATION_WAKE"] = "location_wake";
  PushNotificationType2["APP_UPDATE_REQUIRED"] = "app_update_required";
  return PushNotificationType2;
})(PushNotificationType || {});
var NotificationChannel = /* @__PURE__ */ ((NotificationChannel2) => {
  NotificationChannel2["EMAIL"] = "email";
  NotificationChannel2["SMS"] = "sms";
  NotificationChannel2["IN_APP"] = "in_app";
  NotificationChannel2["PUSH"] = "push";
  return NotificationChannel2;
})(NotificationChannel || {});

// src/domain/enums/service-area.ts
var ServiceAreaType = /* @__PURE__ */ ((ServiceAreaType2) => {
  ServiceAreaType2["POLYGON"] = "polygon";
  ServiceAreaType2["ZIPCODE"] = "zipcode";
  ServiceAreaType2["CITY"] = "city";
  return ServiceAreaType2;
})(ServiceAreaType || {});

// src/domain/enums/rate-request.ts
var RateRequestStatus = /* @__PURE__ */ ((RateRequestStatus2) => {
  RateRequestStatus2["PENDING"] = "pending";
  RateRequestStatus2["PRICING_PROVIDED"] = "pricing_provided";
  RateRequestStatus2["FINALIZED"] = "finalized";
  RateRequestStatus2["CANCELLED"] = "cancelled";
  return RateRequestStatus2;
})(RateRequestStatus || {});
var ServiceRateStatus = /* @__PURE__ */ ((ServiceRateStatus2) => {
  ServiceRateStatus2["NOT_AVAILABLE"] = "not_available";
  ServiceRateStatus2["REQUESTED"] = "requested";
  ServiceRateStatus2["AVAILABLE"] = "available";
  ServiceRateStatus2["ACCEPTED"] = "accepted";
  ServiceRateStatus2["ACTIVE"] = "active";
  return ServiceRateStatus2;
})(ServiceRateStatus || {});

// src/domain/enums/clock.ts
var TimeEntryEventType = /* @__PURE__ */ ((TimeEntryEventType2) => {
  TimeEntryEventType2["CLOCK_IN"] = "clock-in";
  TimeEntryEventType2["CLOCK_OUT"] = "clock-out";
  TimeEntryEventType2["BREAK_START"] = "break-start";
  TimeEntryEventType2["BREAK_END"] = "break-end";
  return TimeEntryEventType2;
})(TimeEntryEventType || {});
var CrewMemberClockStatus = /* @__PURE__ */ ((CrewMemberClockStatus2) => {
  CrewMemberClockStatus2["CLOCKED_OUT"] = "clocked-out";
  CrewMemberClockStatus2["CLOCKED_IN"] = "clocked-in";
  CrewMemberClockStatus2["ON_BREAK"] = "on-break";
  return CrewMemberClockStatus2;
})(CrewMemberClockStatus || {});

// src/domain/enums/ledger.ts
var LedgerEntryType = /* @__PURE__ */ ((LedgerEntryType2) => {
  LedgerEntryType2["DEBIT"] = "debit";
  LedgerEntryType2["PAYMENT"] = "payment";
  LedgerEntryType2["REFUND"] = "refund";
  LedgerEntryType2["CREDIT"] = "credit";
  LedgerEntryType2["CREDIT_APPLIED"] = "credit_applied";
  return LedgerEntryType2;
})(LedgerEntryType || {});

// src/domain/enums/location.ts
var LocationTrackingStatus = /* @__PURE__ */ ((LocationTrackingStatus2) => {
  LocationTrackingStatus2["ON_VISIT"] = "On Visit";
  LocationTrackingStatus2["TRAVELING_AVAILABLE"] = "Traveling / Available";
  LocationTrackingStatus2["NOT_ACTIVE"] = "Not Active";
  return LocationTrackingStatus2;
})(LocationTrackingStatus || {});
var LOCATION_RECORD_TYPE = "LOCATION_UPDATE";

// src/domain/enums/general.ts
var GeneralStatus = /* @__PURE__ */ ((GeneralStatus2) => {
  GeneralStatus2["ACTIVE"] = "active";
  GeneralStatus2["INACTIVE"] = "inactive";
  return GeneralStatus2;
})(GeneralStatus || {});
var CreationStatus = /* @__PURE__ */ ((CreationStatus2) => {
  CreationStatus2["CREATED"] = "created";
  CreationStatus2["EXISTS"] = "exists";
  CreationStatus2["ERROR"] = "error";
  return CreationStatus2;
})(CreationStatus || {});
var PermissionStatus = /* @__PURE__ */ ((PermissionStatus2) => {
  PermissionStatus2["GRANTED"] = "granted";
  PermissionStatus2["DENIED"] = "denied";
  PermissionStatus2["UNDETERMINED"] = "undetermined";
  return PermissionStatus2;
})(PermissionStatus || {});

// src/domain/enums/crew-message.ts
var MessagePriority = /* @__PURE__ */ ((MessagePriority2) => {
  MessagePriority2["NORMAL"] = "normal";
  MessagePriority2["URGENT"] = "urgent";
  return MessagePriority2;
})(MessagePriority || {});

// src/domain/enums/upload.ts
var UploadPurpose = /* @__PURE__ */ ((UploadPurpose2) => {
  UploadPurpose2["CUSTOMER_AVATAR"] = "customer-avatar";
  UploadPurpose2["MEMBER_AVATAR"] = "member-avatar";
  UploadPurpose2["SERVICE_TEMPLATE_IMAGE"] = "service-template-image";
  UploadPurpose2["CREW_MESSAGE_MEDIA"] = "crew-message-media";
  UploadPurpose2["SUBSCRIPTION_ATTACHMENT"] = "subscription-attachment";
  UploadPurpose2["VISIT_PHOTO"] = "visit-photo";
  UploadPurpose2["CUSTOMER_MESSAGE_ATTACHMENT"] = "customer-message-attachment";
  UploadPurpose2["CAMPAIGN_MESSAGE_ATTACHMENT"] = "campaign-message-attachment";
  UploadPurpose2["TEAM_CHAT_MEDIA"] = "team-chat-media";
  return UploadPurpose2;
})(UploadPurpose || {});

// src/domain/enums/message-campaign.ts
var MessageCampaignStatus = /* @__PURE__ */ ((MessageCampaignStatus2) => {
  MessageCampaignStatus2["QUEUED"] = "queued";
  MessageCampaignStatus2["PROCESSING"] = "processing";
  MessageCampaignStatus2["COMPLETED"] = "completed";
  MessageCampaignStatus2["PARTIAL_FAILURE"] = "partial_failure";
  MessageCampaignStatus2["FAILED"] = "failed";
  MessageCampaignStatus2["CANCELLED"] = "cancelled";
  return MessageCampaignStatus2;
})(MessageCampaignStatus || {});
var MessageCampaignScheduleStatus = /* @__PURE__ */ ((MessageCampaignScheduleStatus2) => {
  MessageCampaignScheduleStatus2["ACTIVE"] = "active";
  MessageCampaignScheduleStatus2["PAUSED"] = "paused";
  MessageCampaignScheduleStatus2["STOPPED"] = "stopped";
  return MessageCampaignScheduleStatus2;
})(MessageCampaignScheduleStatus || {});
var MessageDeliveryStatus = /* @__PURE__ */ ((MessageDeliveryStatus2) => {
  MessageDeliveryStatus2["PENDING"] = "pending";
  MessageDeliveryStatus2["PROCESSING"] = "processing";
  MessageDeliveryStatus2["SENT"] = "sent";
  MessageDeliveryStatus2["FAILED"] = "failed";
  return MessageDeliveryStatus2;
})(MessageDeliveryStatus || {});
var MessageChannel = /* @__PURE__ */ ((MessageChannel2) => {
  MessageChannel2["EMAIL"] = "email";
  MessageChannel2["SMS"] = "sms";
  return MessageChannel2;
})(MessageChannel || {});

// src/domain/enums/geofence.ts
var GeofenceEventType = /* @__PURE__ */ ((GeofenceEventType2) => {
  GeofenceEventType2["ENTER"] = "enter";
  GeofenceEventType2["EXIT"] = "exit";
  return GeofenceEventType2;
})(GeofenceEventType || {});
var GEOFENCE_RECORD_TYPE = "GEOFENCE_EVENT";
var GEOFENCE_TTL_DAYS = 90;

// src/domain/enums/contact.ts
var ContactRole = /* @__PURE__ */ ((ContactRole2) => {
  ContactRole2["CUSTOMER"] = "CUSTOMER";
  ContactRole2["SPOUSE"] = "SPOUSE";
  ContactRole2["MANAGER"] = "MANAGER";
  ContactRole2["TENANT"] = "TENANT";
  ContactRole2["BILLING"] = "BILLING";
  ContactRole2["OTHER"] = "OTHER";
  return ContactRole2;
})(ContactRole || {});
var PhoneType = /* @__PURE__ */ ((PhoneType2) => {
  PhoneType2["MOBILE"] = "MOBILE";
  PhoneType2["OFFICE"] = "OFFICE";
  PhoneType2["HOME"] = "HOME";
  return PhoneType2;
})(PhoneType || {});

// src/domain/enums/disposal.ts
var DisposalPileStatus = /* @__PURE__ */ ((DisposalPileStatus2) => {
  DisposalPileStatus2["PENDING"] = "pending";
  DisposalPileStatus2["SCHEDULED"] = "scheduled";
  DisposalPileStatus2["COMPLETED"] = "completed";
  return DisposalPileStatus2;
})(DisposalPileStatus || {});

// src/domain/enums/dispatch-job.ts
var DispatchJobStatus = /* @__PURE__ */ ((DispatchJobStatus2) => {
  DispatchJobStatus2["QUEUED"] = "queued";
  DispatchJobStatus2["PROCESSING"] = "processing";
  DispatchJobStatus2["COMPLETED"] = "completed";
  DispatchJobStatus2["PARTIAL_FAILURE"] = "partial_failure";
  DispatchJobStatus2["FAILED"] = "failed";
  DispatchJobStatus2["CANCELLED"] = "cancelled";
  return DispatchJobStatus2;
})(DispatchJobStatus || {});
var DispatchBatchStatus = /* @__PURE__ */ ((DispatchBatchStatus2) => {
  DispatchBatchStatus2["PENDING"] = "pending";
  DispatchBatchStatus2["PROCESSING"] = "processing";
  DispatchBatchStatus2["COMPLETED"] = "completed";
  DispatchBatchStatus2["FAILED"] = "failed";
  return DispatchBatchStatus2;
})(DispatchBatchStatus || {});

// src/domain/enums/permission.ts
var Permission = /* @__PURE__ */ ((Permission2) => {
  Permission2["TEAM_INVITE"] = "team:invite";
  Permission2["TEAM_MANAGE"] = "team:manage";
  Permission2["TEAM_CREWS"] = "team:crews";
  Permission2["CUSTOMERS_VIEW"] = "customers:view";
  Permission2["CUSTOMERS_MANAGE"] = "customers:manage";
  Permission2["SERVICES_VIEW"] = "services:view";
  Permission2["SERVICES_MANAGE"] = "services:manage";
  Permission2["SCHEDULE_VIEW"] = "schedule:view";
  Permission2["SCHEDULE_MANAGE"] = "schedule:manage";
  Permission2["VISITS_PERFORM"] = "visits:perform";
  Permission2["VISITS_MANAGE"] = "visits:manage";
  Permission2["BILLING_VIEW"] = "billing:view";
  Permission2["BILLING_MANAGE"] = "billing:manage";
  Permission2["CREW_MESSAGES_VIEW"] = "crew-messages:view";
  Permission2["CREW_MESSAGES_SEND"] = "crew-messages:send";
  Permission2["CUSTOMER_MESSAGES_VIEW"] = "customer-messages:view";
  Permission2["CUSTOMER_MESSAGES_SEND"] = "customer-messages:send";
  Permission2["CAMPAIGNS_VIEW"] = "campaigns:view";
  Permission2["CAMPAIGNS_MANAGE"] = "campaigns:manage";
  Permission2["REPORTS_VIEW"] = "reports:view";
  Permission2["SETTINGS_VIEW"] = "settings:view";
  Permission2["SETTINGS_MANAGE"] = "settings:manage";
  Permission2["ROLES_MANAGE"] = "roles:manage";
  Permission2["MAP_VIEW"] = "map:view";
  Permission2["SERVICE_TEMPLATES_VIEW"] = "service-templates:view";
  Permission2["SERVICE_TEMPLATES_MANAGE"] = "service-templates:manage";
  Permission2["SERVICE_AREAS_VIEW"] = "service-areas:view";
  Permission2["SERVICE_AREAS_MANAGE"] = "service-areas:manage";
  Permission2["COMPANY_VIEW"] = "company:view";
  Permission2["COMPANY_MANAGE"] = "company:manage";
  Permission2["PRICING_VIEW"] = "pricing:view";
  Permission2["PRICING_MANAGE"] = "pricing:manage";
  Permission2["CHAT_SEND_URGENT"] = "chat:send-urgent";
  Permission2["CLOCK_IN_EXEMPT"] = "clock-in:exempt";
  return Permission2;
})(Permission || {});
var PERMISSION_ORDER = [
  "team:invite" /* TEAM_INVITE */,
  "team:manage" /* TEAM_MANAGE */,
  "team:crews" /* TEAM_CREWS */,
  "customers:view" /* CUSTOMERS_VIEW */,
  "customers:manage" /* CUSTOMERS_MANAGE */,
  "services:view" /* SERVICES_VIEW */,
  "services:manage" /* SERVICES_MANAGE */,
  "schedule:view" /* SCHEDULE_VIEW */,
  "schedule:manage" /* SCHEDULE_MANAGE */,
  "visits:perform" /* VISITS_PERFORM */,
  "visits:manage" /* VISITS_MANAGE */,
  "billing:view" /* BILLING_VIEW */,
  "billing:manage" /* BILLING_MANAGE */,
  "crew-messages:view" /* CREW_MESSAGES_VIEW */,
  "crew-messages:send" /* CREW_MESSAGES_SEND */,
  "customer-messages:view" /* CUSTOMER_MESSAGES_VIEW */,
  "customer-messages:send" /* CUSTOMER_MESSAGES_SEND */,
  "campaigns:view" /* CAMPAIGNS_VIEW */,
  "campaigns:manage" /* CAMPAIGNS_MANAGE */,
  "reports:view" /* REPORTS_VIEW */,
  "settings:view" /* SETTINGS_VIEW */,
  "settings:manage" /* SETTINGS_MANAGE */,
  "roles:manage" /* ROLES_MANAGE */,
  "map:view" /* MAP_VIEW */,
  "service-templates:view" /* SERVICE_TEMPLATES_VIEW */,
  "service-templates:manage" /* SERVICE_TEMPLATES_MANAGE */,
  "service-areas:view" /* SERVICE_AREAS_VIEW */,
  "service-areas:manage" /* SERVICE_AREAS_MANAGE */,
  "company:view" /* COMPANY_VIEW */,
  "company:manage" /* COMPANY_MANAGE */,
  "pricing:view" /* PRICING_VIEW */,
  "pricing:manage" /* PRICING_MANAGE */,
  "chat:send-urgent" /* CHAT_SEND_URGENT */,
  "clock-in:exempt" /* CLOCK_IN_EXEMPT */
];
var permissionToBit = new Map(
  PERMISSION_ORDER.map((p, i) => [p, i])
);
var bitValue = (i) => 2 ** i;
var isBitSet = (mask, i) => Math.floor(mask / bitValue(i)) % 2 === 1;
var ALL_PERMISSIONS_MASK = PERMISSION_ORDER.reduce((mask, _, i) => mask + bitValue(i), 0);
function permissionsToMask(permissions) {
  let mask = 0;
  const seen = /* @__PURE__ */ new Set();
  for (const p of permissions) {
    const bit = permissionToBit.get(p);
    if (bit !== void 0 && !seen.has(bit)) {
      seen.add(bit);
      mask += bitValue(bit);
    }
  }
  return mask;
}
function maskToPermissions(mask) {
  const result = [];
  for (let i = 0; i < PERMISSION_ORDER.length; i++) {
    if (isBitSet(mask, i)) {
      result.push(PERMISSION_ORDER[i]);
    }
  }
  return result;
}
function maskHasPermission(mask, permission) {
  const bit = permissionToBit.get(permission);
  if (bit === void 0) return false;
  return isBitSet(mask, bit);
}

// src/domain/enums/picklist.ts
var PicklistCategory = /* @__PURE__ */ ((PicklistCategory2) => {
  PicklistCategory2["SKIP_REASON"] = "skip_reason";
  PicklistCategory2["DISCARD_REASON"] = "discard_reason";
  PicklistCategory2["CANCELLATION_REASON"] = "cancellation_reason";
  PicklistCategory2["REVIEW_REASON"] = "review_reason";
  PicklistCategory2["LEAD_SOURCE"] = "lead_source";
  PicklistCategory2["MOVE_REASON"] = "move_reason";
  PicklistCategory2["DEACTIVATION_REASON"] = "deactivation_reason";
  PicklistCategory2["PAUSE_REASON"] = "pause_reason";
  return PicklistCategory2;
})(PicklistCategory || {});

// src/domain/enums/ai-import.ts
var AiImportJobKind = /* @__PURE__ */ ((AiImportJobKind2) => {
  AiImportJobKind2["EXTRACT"] = "EXTRACT";
  AiImportJobKind2["EXECUTE"] = "EXECUTE";
  return AiImportJobKind2;
})(AiImportJobKind || {});
var AiImportJobStatus = /* @__PURE__ */ ((AiImportJobStatus2) => {
  AiImportJobStatus2["QUEUED"] = "QUEUED";
  AiImportJobStatus2["RUNNING"] = "RUNNING";
  AiImportJobStatus2["COMPLETED"] = "COMPLETED";
  AiImportJobStatus2["FAILED"] = "FAILED";
  return AiImportJobStatus2;
})(AiImportJobStatus || {});

// src/domain/enums/photo.ts
var PhotoTag = /* @__PURE__ */ ((PhotoTag2) => {
  PhotoTag2["BEFORE"] = "before";
  PhotoTag2["AFTER"] = "after";
  PhotoTag2["DAMAGE"] = "damage";
  PhotoTag2["QUESTION"] = "question";
  PhotoTag2["OPPORTUNITY"] = "opportunity";
  return PhotoTag2;
})(PhotoTag || {});

// src/domain/enums/shop-advisor.ts
var ShopAdvisorAgent = /* @__PURE__ */ ((ShopAdvisorAgent2) => {
  ShopAdvisorAgent2["VISIT_INTEGRITY"] = "visit_integrity";
  ShopAdvisorAgent2["CUSTOMER_ADVISOR"] = "customer_advisor";
  ShopAdvisorAgent2["OPERATIONS_ADVISOR"] = "operations_advisor";
  ShopAdvisorAgent2["FINANCIAL_ADVISOR"] = "financial_advisor";
  return ShopAdvisorAgent2;
})(ShopAdvisorAgent || {});
var AgentDraftKind = /* @__PURE__ */ ((AgentDraftKind2) => {
  AgentDraftKind2["MESSAGE"] = "message";
  AgentDraftKind2["RATE"] = "rate";
  AgentDraftKind2["CAMPAIGN"] = "campaign";
  AgentDraftKind2["REVIEW_FLAG"] = "review-flag";
  return AgentDraftKind2;
})(AgentDraftKind || {});
var AgentDraftStatus = /* @__PURE__ */ ((AgentDraftStatus2) => {
  AgentDraftStatus2["DRAFTED"] = "drafted";
  AgentDraftStatus2["APPROVED"] = "approved";
  AgentDraftStatus2["DISCARDED"] = "discarded";
  return AgentDraftStatus2;
})(AgentDraftStatus || {});
var SHOP_ADVISOR_AGENT_DISPLAY_NAMES = {
  ["visit_integrity" /* VISIT_INTEGRITY */]: "Visit Integrity",
  ["customer_advisor" /* CUSTOMER_ADVISOR */]: "Customer Advisor",
  ["operations_advisor" /* OPERATIONS_ADVISOR */]: "Operations Advisor",
  ["financial_advisor" /* FINANCIAL_ADVISOR */]: "Financial Advisor"
};
function shopAdvisorAgentDisplayName(agent) {
  return SHOP_ADVISOR_AGENT_DISPLAY_NAMES[agent];
}

// src/domain/models/Period.ts
var MONTH_ABBR = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
function monthAbbr(month) {
  return MONTH_ABBR[month - 1] ?? "";
}
function formatSeasonMonthRange(periods) {
  if (!periods || periods.length === 0) return void 0;
  const ranges = periods.map((p) => {
    const start = monthAbbr(p.startMonth);
    const end = monthAbbr(p.endMonth);
    if (!start || !end) return start || end;
    return p.startMonth === p.endMonth ? start : `${start}\u2013${end}`;
  });
  const unique = Array.from(new Set(ranges.filter(Boolean)));
  return unique.length ? unique.join(", ") : void 0;
}

// src/domain/models/Schedule.ts
var ScheduleType = {
  RECURRING: "recurring",
  LIMITED: "limited",
  WINDOWED: "windowed"
};
var ScheduleFulfillmentStatus = {
  PENDING: "pending",
  IN_PROGRESS: "in_progress",
  FULFILLED: "fulfilled",
  EXPIRED: "expired"
};

// src/domain/models/cadenceLabel.ts
var NO_SCHEDULE_LABEL = "No schedule set";
var CUSTOM_SCHEDULE_LABEL = "Custom schedule";
var ON_DEMAND_LABEL = "On demand";
function formatCadenceLabel(frequency, customConfig) {
  switch (frequency) {
    case "weekly" /* WEEKLY */:
      return "Weekly";
    case "monthly" /* MONTHLY */:
      return "Monthly";
    case "yearly" /* YEARLY */:
      return "Once a year";
    case "on_demand" /* ON_DEMAND */:
      return ON_DEMAND_LABEL;
    case "one_time" /* ONE_TIME */:
      return "One time";
    case "custom" /* CUSTOM */:
      return formatCustomInterval(customConfig);
    default:
      return NO_SCHEDULE_LABEL;
  }
}
var LEGACY_FREQUENCY_LABEL = {
  biweekly: "Every other week",
  "bi-weekly": "Every other week",
  quarterly: "Every 3 months",
  annually: "Once a year",
  daily: "Daily"
};
function formatCustomInterval(customConfig) {
  if (!customConfig) return CUSTOM_SCHEDULE_LABEL;
  const { interval, unit } = customConfig;
  if (interval === 1) return UNIT_EVERY_ONE[unit] ?? CUSTOM_SCHEDULE_LABEL;
  if (interval === 2) {
    const singular = UNIT_SINGULAR[unit] ?? unit;
    return `Every other ${singular}`;
  }
  return `Every ${interval} ${unit}`;
}
function formatScheduleCadence(schedule) {
  if (!schedule) return NO_SCHEDULE_LABEL;
  switch (schedule.type) {
    case ScheduleType.RECURRING:
      return schedule.frequency ? formatCadenceLabel(schedule.frequency, schedule.customConfig) : NO_SCHEDULE_LABEL;
    case ScheduleType.LIMITED:
      return formatVisitCount(schedule.visitLimit, schedule.period);
    case ScheduleType.WINDOWED:
      return schedule.visitLimit ? formatVisitCount(schedule.visitLimit, schedule.period ?? "season") : SEASONAL_LABEL;
    default:
      return NO_SCHEDULE_LABEL;
  }
}
var SEASONAL_LABEL = "Seasonal";
function formatVisitCount(visitLimit, period) {
  const scope = period === "season" ? "a season" : period === "year" ? "a year" : null;
  if (!scope) {
    return visitLimit === 1 ? "One time" : `${visitLimit} visits total`;
  }
  if (visitLimit === 1) return `Once ${scope}`;
  if (visitLimit === 2) return `Twice ${scope}`;
  return `${visitLimit} times ${scope}`;
}
function formatTemplateCadence(template) {
  if (!template) return NO_SCHEDULE_LABEL;
  if (template.serviceType === "one_time") return formatCadenceLabel("one_time" /* ONE_TIME */);
  return resolveCadenceLabelOrDefault(
    template.scheduleConfig?.frequency,
    template.scheduleConfig?.customConfig
  );
}
var KNOWN_FREQUENCIES = new Set(Object.values(ScheduleFrequency));
function resolveCadenceLabel(frequency, customConfig) {
  if (!frequency) return null;
  if (KNOWN_FREQUENCIES.has(frequency)) {
    return formatCadenceLabel(frequency, customConfig);
  }
  return LEGACY_FREQUENCY_LABEL[frequency.toLowerCase()] ?? null;
}
function resolveCadenceLabelOrDefault(frequency, customConfig) {
  return resolveCadenceLabel(frequency, customConfig) ?? NO_SCHEDULE_LABEL;
}
function isOnDemandFrequency(frequency) {
  return frequency === "on_demand" /* ON_DEMAND */;
}
function resolveCustomerCadenceLabel(frequency, customConfig) {
  if (isOnDemandFrequency(frequency)) return null;
  return resolveCadenceLabel(frequency, customConfig);
}
function formatCustomerScheduleCadence(schedule) {
  if (!schedule) return null;
  if (schedule.type === ScheduleType.RECURRING && isOnDemandFrequency(schedule.frequency)) {
    return null;
  }
  const label = formatScheduleCadence(schedule);
  return label === ON_DEMAND_LABEL ? null : label;
}
function joinDisplayParts(parts, separator = " \xB7 ") {
  return parts.map((part) => part?.trim()).filter((part) => Boolean(part)).join(separator);
}
function formatCustomerRatePricingLine(amountLabel, frequency, customConfig) {
  return joinDisplayParts([amountLabel, resolveCustomerCadenceLabel(frequency, customConfig)]);
}
var UNIT_SINGULAR = {
  ["days" /* DAYS */]: "day",
  ["weeks" /* WEEKS */]: "week",
  ["months" /* MONTHS */]: "month",
  ["years" /* YEARS */]: "year"
};
var UNIT_EVERY_ONE = {
  ["days" /* DAYS */]: "Daily",
  ["weeks" /* WEEKS */]: "Weekly",
  ["months" /* MONTHS */]: "Monthly",
  ["years" /* YEARS */]: "Once a year"
};

// src/domain/models/CustomerAccount.ts
var CUSTOMER_ACCOUNT_MAX_CHANGES_PER_SAVE = 32;
var CUSTOMER_ACCOUNT_LISTED_PROPERTIES = 100;
var CUSTOMER_ACCOUNT_KIND_LABELS = {
  individual: "Individual",
  organization: "Organization"
};
var customerAccountTypeLabel = (account) => account.label?.trim() || CUSTOMER_ACCOUNT_KIND_LABELS[account.kind];
var customerAccountReference = ({
  id,
  name,
  kind,
  label
}) => ({
  id,
  name,
  kind,
  ...label ? { label } : {}
});

// src/domain/models/PlatformPolicies.ts
var RUTA_TERMS_URL = "https://app.termly.io/policy-viewer/policy.html?policyUUID=dbab55ca-f75f-48d8-a30c-53d3024699fa";
var RUTA_PRIVACY_URL = "https://app.termly.io/policy-viewer/policy.html?policyUUID=39e1e698-8046-43a5-91d3-e125761d8c00";
var POLICY_DOCUMENTS = ["terms", "privacy"];
var POLICY_DOCUMENT_LABELS = {
  terms: "Terms of Service",
  privacy: "Privacy Policy"
};
var POLICY_DOCUMENT_CONTENT_TYPE = "application/pdf";
var MAX_POLICY_DOCUMENT_BYTES = 10 * 1024 * 1024;
var POLICY_DOCUMENT_REJECTION = "Upload a PDF. Other file types are not accepted.";
var POLICY_DOCUMENT_TOO_LARGE = "That file is larger than 10 MB. Upload a smaller PDF.";
function policyDocumentStorageKey(document, fileId) {
  return `platform/policies/${document}/${fileId}.pdf`;
}
function isValidPolicyUrl(value) {
  if (typeof value !== "string" || value.trim() === "") return false;
  try {
    return new URL(value.trim()).protocol === "https:";
  } catch {
    return false;
  }
}
var POLICY_URL_REJECTION = "Enter a full https:// web address, for example https://example.com/terms";
function resolvePlatformPolicies(stored) {
  const termsConfigured = isValidPolicyUrl(stored?.termsUrl);
  const privacyConfigured = isValidPolicyUrl(stored?.privacyUrl);
  return {
    termsUrl: termsConfigured ? stored.termsUrl.trim() : RUTA_TERMS_URL,
    privacyUrl: privacyConfigured ? stored.privacyUrl.trim() : RUTA_PRIVACY_URL,
    termsSource: termsConfigured ? "configured" : "built-in",
    privacySource: privacyConfigured ? "configured" : "built-in"
  };
}
function builtInPlatformPolicies() {
  return resolvePlatformPolicies(null);
}

// src/domain/models/smsReachability.ts
function summarizeSmsReachability(phones, emailCount = 0) {
  const optedOutCount = (phones ?? []).filter((p) => p.smsOptedOut === true).length;
  return {
    optedOutCount,
    textsBlocked: optedOutCount > 0,
    hasEmailOnFile: emailCount > 0
  };
}

// src/domain/models/Subscription.ts
var SubscriptionChangeTriggeredBy = {
  CUSTOMER: "customer",
  SYSTEM: "system"
};
var SubscriptionChangeType = {
  STATUS_CHANGE: "status_change",
  VISIBILITY_CHANGE: "visibility_change",
  RATE_CHANGE: "rate_change",
  ASSIGNMENT_CHANGE: "assignment_change",
  CREATION: "creation",
  CANCELLATION: "cancellation",
  DISCOUNT_CHANGE: "discount_change",
  CUSTOMER_SELECTED_OPTIONS_CHANGE: "customer_selected_options_change",
  PACKAGE_RESET: "package_reset",
  PACKAGE_OPTION_CHANGE: "package_option_change",
  PLAN_CHANGE_REQUEST: "plan_change_request",
  PLAN_CHANGE_FINALIZED: "plan_change_finalized"
};
function isRateRequestSnoozeActive(snooze, todayStr) {
  return !!snooze && snooze.snoozedUntil > todayStr;
}
var SUBSCRIPTION_IMPORTED_FIELD_NAMES = [
  "rate",
  "billingMethod",
  "cadence",
  "subscriptionStatus",
  "budgetedHours",
  "crewName"
];

// src/domain/models/TemporaryNote.ts
var LOCAL_DAY = /^\d{4}-\d{2}-\d{2}$/;
function isTemporaryNoteActive(note, today) {
  if (note.expiry.mode === "visits") {
    return typeof note.expiry.visitsRemaining === "number" && note.expiry.visitsRemaining > 0;
  }
  if (note.expiry.mode === "range") {
    const { from, until } = note.expiry;
    return typeof from === "string" && typeof until === "string" && today >= from && today <= until;
  }
  return typeof note.expiry.date === "string" && today <= note.expiry.date;
}
function isTemporaryNoteActiveForVisit(note, visitDate, today) {
  if (note.expiry.mode === "range") {
    const { from, until } = note.expiry;
    return typeof from === "string" && typeof until === "string" && visitDate >= from && visitDate <= until;
  }
  return isTemporaryNoteActive(note, today);
}
function getActiveTemporaryNotes(notes, today, visitDate) {
  if (visitDate) {
    return (notes ?? []).filter((n) => isTemporaryNoteActiveForVisit(n, visitDate, today));
  }
  return (notes ?? []).filter((n) => isTemporaryNoteActive(n, today));
}
function mergeTemporaryNoteEdits(incoming, stored) {
  const storedById = new Map((stored ?? []).map((n) => [n.id, n]));
  return incoming.map((note) => {
    if (note.expiry.mode !== "visits") return note;
    const existing = storedById.get(note.id);
    const existingVisitsExpiry = existing?.expiry.mode === "visits" ? existing.expiry : void 0;
    return {
      ...note,
      expiry: {
        ...note.expiry,
        // An existing note keeps the countdown the processor left on it. A new
        // note starts fresh — never from a client-supplied consumed list, which
        // would otherwise let a caller pre-spend a visit and stop the note from
        // ever expiring.
        visitsRemaining: existingVisitsExpiry?.visitsRemaining ?? note.expiry.visitsRemaining,
        consumedByVisitIds: existingVisitsExpiry?.consumedByVisitIds ?? []
      }
    };
  });
}
function validateTemporaryNotes(notes) {
  if (!Array.isArray(notes)) return "temporaryNotes must be an array";
  for (const note of notes) {
    if (!note || typeof note !== "object") return "temporaryNotes entries must be objects";
    const n = note;
    if (!n.id || typeof n.id !== "string") return "temporary note is missing an id";
    if (!n.text || typeof n.text !== "string" || !n.text.trim()) return "temporary note text is required";
    if (!n.createdAt || typeof n.createdAt !== "string") return "temporary note is missing createdAt";
    if (!n.expiry || typeof n.expiry !== "object") return "temporary note is missing its expiration";
    if (n.expiry.mode === "visits") {
      if (!Number.isInteger(n.expiry.visitsRemaining) || n.expiry.visitsRemaining < 1) {
        return "temporary note visit expiration must be a whole number of visits (1 or more)";
      }
    } else if (n.expiry.mode === "date") {
      if (typeof n.expiry.date !== "string" || !LOCAL_DAY.test(n.expiry.date)) {
        return "temporary note date expiration must be a YYYY-MM-DD date";
      }
    } else if (n.expiry.mode === "range") {
      const from = n.expiry.from;
      const until = n.expiry.until;
      if (typeof from !== "string" || !LOCAL_DAY.test(from) || typeof until !== "string" || !LOCAL_DAY.test(until)) {
        return "temporary note date range requires from and until as YYYY-MM-DD dates";
      }
      if (from > until) {
        return "temporary note date range from must be on or before until";
      }
    } else {
      return "temporary note expiration must be by visits, by date, or by date range";
    }
  }
  return null;
}

// src/domain/models/MessageCampaignSchedule.ts
function filterNamesAnAudience(filter) {
  return filter.rules.some((r) => r.serviceTemplateId && !r.exclude) || filter.customerCities.length > 0 || filter.activeOnly || !!filter.paymentStatus || !!filter.balanceFilter || !!filter.customerType;
}
var CAMPAIGN_PAYMENT_STATUS_FILTERS = [
  "issues",
  "missing",
  "expired",
  "expiring",
  "valid"
];
var CAMPAIGN_CUSTOMER_TYPE_FILTERS = [
  "active",
  "inactive",
  "prospect",
  "out_of_service_area"
];
var CAMPAIGN_BALANCE_FILTERS = ["has_balance", "has_credit", "no_balance"];
var MIN_CAMPAIGN_REPEAT_DAYS = 1;
var MAX_CAMPAIGN_REPEAT_DAYS = 365;

// src/domain/models/SubcontractorCompany.ts
var SubcontractorPayType = /* @__PURE__ */ ((SubcontractorPayType2) => {
  SubcontractorPayType2["VISIT_PERCENTAGE"] = "visit_percentage";
  SubcontractorPayType2["FLAT_AMOUNT"] = "flat_amount";
  return SubcontractorPayType2;
})(SubcontractorPayType || {});

// src/domain/models/ImportLayoutRecipe.ts
var IMPORT_LAYOUT_RECIPE_STATUSES = ["candidate", "confirmed", "retired"];
var IMPORT_LAYOUT_RECIPE_MAX_ORG_HASHES = 50;

// src/domain/constants/builtInRoles.ts
var BUILT_IN_ROLE_IDS = {
  OWNER: "built-in-owner",
  ADMIN: "built-in-admin",
  CREW_LEADER: "built-in-crew-leader",
  CREW_MEMBER: "built-in-crew-member",
  SUBCONTRACTOR_LEAD: "built-in-subcontractor-lead"
};
function isOfficeStaffRoleId(roleId) {
  return roleId === BUILT_IN_ROLE_IDS.OWNER || roleId === BUILT_IN_ROLE_IDS.ADMIN;
}
var BUILT_IN_ROLE_TEMPLATES = [
  {
    id: BUILT_IN_ROLE_IDS.OWNER,
    name: "Owner",
    description: "Full access to everything. Cannot be edited or deleted.",
    permissions: Object.values(Permission),
    isBuiltIn: true
  },
  {
    id: BUILT_IN_ROLE_IDS.ADMIN,
    name: "Admin",
    description: "Full access except role management.",
    permissions: Object.values(Permission).filter(
      (p) => p !== "roles:manage" /* ROLES_MANAGE */
    ),
    isBuiltIn: true
  },
  {
    id: BUILT_IN_ROLE_IDS.CREW_LEADER,
    name: "Crew Leader",
    description: "Field crew leader. Can view schedules and manage crew work.",
    permissions: [
      "visits:perform" /* VISITS_PERFORM */,
      "visits:manage" /* VISITS_MANAGE */,
      "schedule:view" /* SCHEDULE_VIEW */,
      "schedule:manage" /* SCHEDULE_MANAGE */,
      "team:crews" /* TEAM_CREWS */,
      "chat:send-urgent" /* CHAT_SEND_URGENT */
    ],
    isBuiltIn: true
  },
  {
    id: BUILT_IN_ROLE_IDS.CREW_MEMBER,
    name: "Crew Member",
    description: "Field crew member. Can perform visits.",
    permissions: ["visits:perform" /* VISITS_PERFORM */],
    isBuiltIn: true
  },
  {
    id: BUILT_IN_ROLE_IDS.SUBCONTRACTOR_LEAD,
    name: "Subcontractor Lead",
    description: "Subcontractor company lead. Can manage company crews and invite members.",
    permissions: [
      "visits:perform" /* VISITS_PERFORM */,
      "visits:manage" /* VISITS_MANAGE */,
      "schedule:view" /* SCHEDULE_VIEW */,
      "team:crews" /* TEAM_CREWS */,
      "team:invite" /* TEAM_INVITE */,
      "chat:send-urgent" /* CHAT_SEND_URGENT */
    ],
    isBuiltIn: true
  }
];

// src/domain/constants/roleAssignment.ts
var SUBCONTRACTOR_LEAD_ASSIGNABLE_ROLE_IDS = [
  BUILT_IN_ROLE_IDS.CREW_MEMBER,
  BUILT_IN_ROLE_IDS.CREW_LEADER
];
function canAssignRole(assignerRoleId, targetRoleId) {
  if (targetRoleId === BUILT_IN_ROLE_IDS.OWNER) {
    return assignerRoleId === BUILT_IN_ROLE_IDS.OWNER;
  }
  if (assignerRoleId === BUILT_IN_ROLE_IDS.SUBCONTRACTOR_LEAD) {
    return SUBCONTRACTOR_LEAD_ASSIGNABLE_ROLE_IDS.includes(targetRoleId);
  }
  return true;
}

// src/domain/constants/builtInPicklistItems.ts
var BUILT_IN_PICKLIST_ITEMS = [
  // Skip reasons
  { id: "skip-customer-request", category: "skip_reason" /* SKIP_REASON */, label: "Customer request", icon: "hand", sortOrder: 1 },
  { id: "skip-too-wet-dry", category: "skip_reason" /* SKIP_REASON */, label: "Too wet/dry", icon: "droplets", sortOrder: 2 },
  { id: "skip-access-blocked", category: "skip_reason" /* SKIP_REASON */, label: "Site access blocked", icon: "ban", sortOrder: 3 },
  { id: "skip-equipment", category: "skip_reason" /* SKIP_REASON */, label: "Equipment issue", icon: "wrench", sortOrder: 4 },
  { id: "skip-weather", category: "skip_reason" /* SKIP_REASON */, label: "Weather conditions", icon: "cloud-rain", sortOrder: 5 },
  { id: "skip-customer-unavailable", category: "skip_reason" /* SKIP_REASON */, label: "Customer not available", icon: "user-x", sortOrder: 6 },
  { id: "skip-safety", category: "skip_reason" /* SKIP_REASON */, label: "Safety concerns", icon: "shield-alert", sortOrder: 7 },
  { id: "skip-other", category: "skip_reason" /* SKIP_REASON */, label: "Other", icon: "message-square-more", sortOrder: 8 },
  // Discard reasons
  { id: "discard-wrong-address", category: "discard_reason" /* DISCARD_REASON */, label: "Wrong address", icon: "map-pin-off", sortOrder: 1 },
  { id: "discard-accidental", category: "discard_reason" /* DISCARD_REASON */, label: "Accidental start", icon: "undo-2", sortOrder: 2 },
  { id: "discard-equipment", category: "discard_reason" /* DISCARD_REASON */, label: "Equipment issue", icon: "wrench", sortOrder: 3 },
  { id: "discard-customer-cancelled", category: "discard_reason" /* DISCARD_REASON */, label: "Customer cancelled", icon: "user-x", sortOrder: 4 },
  { id: "discard-billing-error", category: "discard_reason" /* DISCARD_REASON */, label: "Billing error", icon: "receipt", sortOrder: 5 },
  { id: "discard-safety", category: "discard_reason" /* DISCARD_REASON */, label: "Safety concern", icon: "shield-alert", sortOrder: 6 },
  { id: "discard-other", category: "discard_reason" /* DISCARD_REASON */, label: "Other", icon: "message-square-more", sortOrder: 7 },
  // Cancellation reasons
  { id: "cancel-customer-request", category: "cancellation_reason" /* CANCELLATION_REASON */, label: "Customer request", icon: "hand", sortOrder: 1 },
  { id: "cancel-weather", category: "cancellation_reason" /* CANCELLATION_REASON */, label: "Weather", icon: "cloud-rain", sortOrder: 2 },
  { id: "cancel-access-blocked", category: "cancellation_reason" /* CANCELLATION_REASON */, label: "Access blocked", icon: "ban", sortOrder: 3 },
  { id: "cancel-equipment", category: "cancellation_reason" /* CANCELLATION_REASON */, label: "Equipment issue", icon: "wrench", sortOrder: 4 },
  { id: "cancel-customer-unavailable", category: "cancellation_reason" /* CANCELLATION_REASON */, label: "Customer not available", icon: "user-x", sortOrder: 5 },
  { id: "cancel-safety", category: "cancellation_reason" /* CANCELLATION_REASON */, label: "Safety concern", icon: "shield-alert", sortOrder: 6 },
  { id: "cancel-too-wet-dry", category: "cancellation_reason" /* CANCELLATION_REASON */, label: "Too wet/dry", icon: "droplets", sortOrder: 7 },
  { id: "cancel-other", category: "cancellation_reason" /* CANCELLATION_REASON */, label: "Other", icon: "message-square-more", sortOrder: 8 },
  // Review reasons (user-selectable only; system reasons stay as enum)
  { id: "review-manual-flag", category: "review_reason" /* REVIEW_REASON */, label: "Manual flag", icon: "flag", sortOrder: 1 },
  { id: "review-quality-issue", category: "review_reason" /* REVIEW_REASON */, label: "Quality issue", icon: "alert-triangle", sortOrder: 2 },
  { id: "review-customer-complaint", category: "review_reason" /* REVIEW_REASON */, label: "Customer complaint", icon: "message-circle", sortOrder: 3 },
  // Lead sources (user-selectable only; RATE_REQUEST and IMPORT stay as enum)
  { id: "lead-referral", category: "lead_source" /* LEAD_SOURCE */, label: "Referral", icon: "users", sortOrder: 1 },
  { id: "lead-marketing", category: "lead_source" /* LEAD_SOURCE */, label: "Marketing", icon: "megaphone", sortOrder: 2 },
  { id: "lead-manual", category: "lead_source" /* LEAD_SOURCE */, label: "Manual", icon: "pen-line", sortOrder: 3 },
  { id: "lead-other", category: "lead_source" /* LEAD_SOURCE */, label: "Other", icon: "message-square-more", sortOrder: 4 },
  // Move reasons
  { id: "move-schedule-conflict", category: "move_reason" /* MOVE_REASON */, label: "Schedule conflict", icon: "calendar-x", sortOrder: 1 },
  { id: "move-crew-capacity", category: "move_reason" /* MOVE_REASON */, label: "Crew capacity issue", icon: "users", sortOrder: 2 },
  { id: "move-geographic", category: "move_reason" /* MOVE_REASON */, label: "Geographic optimization", icon: "map-pin", sortOrder: 3 },
  { id: "move-skill-requirement", category: "move_reason" /* MOVE_REASON */, label: "Skill requirement", icon: "wrench", sortOrder: 4 },
  { id: "move-other", category: "move_reason" /* MOVE_REASON */, label: "Other", icon: "message-square-more", sortOrder: 5 },
  // Deactivation reasons (why a customer's service was deactivated). "Custom" lets the admin enter free text.
  { id: "deactivate-moved-sold-home", category: "deactivation_reason" /* DEACTIVATION_REASON */, label: "Moved/sold home", icon: "home", sortOrder: 1 },
  { id: "deactivate-doing-themselves", category: "deactivation_reason" /* DEACTIVATION_REASON */, label: "Doing themselves", icon: "hand", sortOrder: 2 },
  { id: "deactivate-relationship", category: "deactivation_reason" /* DEACTIVATION_REASON */, label: "Trying another service due to a relationship", icon: "handshake", sortOrder: 3 },
  { id: "deactivate-not-happy", category: "deactivation_reason" /* DEACTIVATION_REASON */, label: "Not happy with service", icon: "frown", sortOrder: 4 },
  { id: "deactivate-price-too-high", category: "deactivation_reason" /* DEACTIVATION_REASON */, label: "Price is too high (saving money)", icon: "piggy-bank", sortOrder: 5 },
  { id: "deactivate-no-reason", category: "deactivation_reason" /* DEACTIVATION_REASON */, label: "No reason given", icon: "circle-help", sortOrder: 6 },
  { id: "deactivate-custom", category: "deactivation_reason" /* DEACTIVATION_REASON */, label: "Custom", icon: "message-square-more", sortOrder: 7 },
  // Pause reasons (why a customer wants a short break). "Other" is a fixed
  // portal-only choice, not a seeded picklist item.
  { id: "pause-construction", category: "pause_reason" /* PAUSE_REASON */, label: "Construction project", icon: "hard-hat", sortOrder: 1 },
  { id: "pause-traveling", category: "pause_reason" /* PAUSE_REASON */, label: "Traveling / away", icon: "plane", sortOrder: 2 },
  { id: "pause-new-lawn", category: "pause_reason" /* PAUSE_REASON */, label: "New lawn or landscaping", icon: "sprout", sortOrder: 3 },
  { id: "pause-budget", category: "pause_reason" /* PAUSE_REASON */, label: "Budget", icon: "piggy-bank", sortOrder: 4 },
  { id: "pause-weather", category: "pause_reason" /* PAUSE_REASON */, label: "Weather or season", icon: "cloud-sun", sortOrder: 5 }
];
var BUILT_IN_CUSTOMER_LABELS = {
  "deactivate-moved-sold-home": "I'm moving or sold my home",
  "deactivate-doing-themselves": "I'm going to do it myself",
  "deactivate-relationship": "I'm going with someone I know",
  "deactivate-not-happy": "I'm not happy with the service",
  "deactivate-price-too-high": "It costs more than I want to spend",
  "pause-construction": "I have a construction project",
  "pause-traveling": "I'll be away for a while",
  "pause-new-lawn": "New lawn or landscaping is going in",
  "pause-budget": "I need a break for budget reasons",
  "pause-weather": "Weather or the season"
};
var PORTAL_SOMETHING_ELSE_ID = "portal-something-else";
var PORTAL_OTHER_ID = "portal-other";
var LEAD_SOURCE_OTHER_ID = "lead-other";

// src/domain/constants/measurementTypes.ts
var METRIC_TYPE_TO_KEY = {
  ["rock" /* ROCK */]: "rock",
  ["wood_mulch" /* WOOD_MULCH */]: "woodMulch",
  ["turf" /* TURF */]: "turf",
  ["driveway" /* DRIVEWAY */]: "driveway",
  ["sidewalk" /* SIDEWALK */]: "sidewalk",
  ["walkway" /* WALKWAY */]: "walkway"
};
var METRIC_KEY_TO_TYPE = {
  rock: "rock" /* ROCK */,
  woodMulch: "wood_mulch" /* WOOD_MULCH */,
  turf: "turf" /* TURF */,
  driveway: "driveway" /* DRIVEWAY */,
  sidewalk: "sidewalk" /* SIDEWALK */,
  walkway: "walkway" /* WALKWAY */
};
var ALL_METRIC_TYPES = [
  "turf" /* TURF */,
  "rock" /* ROCK */,
  "wood_mulch" /* WOOD_MULCH */,
  "driveway" /* DRIVEWAY */,
  "sidewalk" /* SIDEWALK */,
  "walkway" /* WALKWAY */
];
function zeroFilledMetrics(source) {
  const out = {};
  for (const type of ALL_METRIC_TYPES) {
    const key = METRIC_TYPE_TO_KEY[type];
    out[key] = Number(source?.[key]) || 0;
  }
  return out;
}
var MEASUREMENT_TYPE_LABELS = {
  ["rock" /* ROCK */]: "Rock",
  ["wood_mulch" /* WOOD_MULCH */]: "Wood Mulch",
  ["turf" /* TURF */]: "Turf",
  ["driveway" /* DRIVEWAY */]: "Driveway",
  ["sidewalk" /* SIDEWALK */]: "Sidewalk",
  ["walkway" /* WALKWAY */]: "Walkway"
};
function hasAnyMetricValue(metrics) {
  if (!metrics) return false;
  return Object.values(METRIC_TYPE_TO_KEY).some((key) => {
    const value = metrics[key];
    return typeof value === "number" && value > 0;
  });
}
var MEASUREMENT_TYPE_COLORS = {
  ["rock" /* ROCK */]: {
    bg: "bg-slate-500",
    fill: "#64748b",
    line: "#475569"
  },
  ["wood_mulch" /* WOOD_MULCH */]: {
    bg: "bg-amber-600",
    fill: "#d97706",
    line: "#b45309"
  },
  ["turf" /* TURF */]: {
    bg: "bg-green-500",
    fill: "#22c55e",
    line: "#16a34a"
  },
  // Paved surfaces read as "not landscape" on the satellite image: warm orange for the
  // driveway, sky blue for the public sidewalk, yellow for the private walks.
  ["driveway" /* DRIVEWAY */]: {
    bg: "bg-orange-500",
    fill: "#f97316",
    line: "#c2410c"
  },
  ["sidewalk" /* SIDEWALK */]: {
    bg: "bg-sky-500",
    fill: "#0ea5e9",
    line: "#0369a1"
  },
  ["walkway" /* WALKWAY */]: {
    bg: "bg-yellow-400",
    fill: "#facc15",
    line: "#a16207"
  }
};

// src/domain/constants/photoRetention.ts
var PHOTO_RETENTION_DAYS = 30;
var PHOTO_RETENTION_MS = PHOTO_RETENTION_DAYS * 24 * 60 * 60 * 1e3;

// src/domain/constants/photoTags.ts
var PHOTO_TAG_ORDER = [
  "before" /* BEFORE */,
  "after" /* AFTER */,
  "damage" /* DAMAGE */,
  "question" /* QUESTION */,
  "opportunity" /* OPPORTUNITY */
];
function togglePhotoTag(current, tag) {
  const next = new Set(current ?? []);
  if (next.has(tag)) {
    next.delete(tag);
  } else {
    if (tag === "before" /* BEFORE */) next.delete("after" /* AFTER */);
    if (tag === "after" /* AFTER */) next.delete("before" /* BEFORE */);
    next.add(tag);
  }
  return PHOTO_TAG_ORDER.filter((t) => next.has(t));
}
var PHOTO_TAG_LABELS = {
  ["before" /* BEFORE */]: "Before",
  ["after" /* AFTER */]: "After",
  ["damage" /* DAMAGE */]: "Damage",
  ["question" /* QUESTION */]: "Question",
  ["opportunity" /* OPPORTUNITY */]: "Opportunity"
};
var PHOTO_TAG_LABELS_ES = {
  ["before" /* BEFORE */]: "Antes",
  ["after" /* AFTER */]: "Despu\xE9s",
  ["damage" /* DAMAGE */]: "Da\xF1o",
  ["question" /* QUESTION */]: "Pregunta",
  ["opportunity" /* OPPORTUNITY */]: "Oportunidad"
};
function photoTagLabel(tag, locale = "en") {
  if (locale === "es") return PHOTO_TAG_LABELS_ES[tag] ?? PHOTO_TAG_LABELS[tag];
  return PHOTO_TAG_LABELS[tag];
}
var PHOTO_TAG_DESCRIPTIONS = {
  ["before" /* BEFORE */]: "Property condition on arrival",
  ["after" /* AFTER */]: "Completed work",
  ["damage" /* DAMAGE */]: "Property damage to document",
  ["question" /* QUESTION */]: "Something the office or customer should weigh in on",
  ["opportunity" /* OPPORTUNITY */]: "Extra or upsell work spotted on site"
};
function isPhotoTag(value) {
  return typeof value === "string" && PHOTO_TAG_ORDER.includes(value);
}
function normalizePhotoTags(input) {
  if (!Array.isArray(input)) return [];
  const seen = /* @__PURE__ */ new Set();
  for (const value of input) {
    if (isPhotoTag(value)) seen.add(value);
  }
  return PHOTO_TAG_ORDER.filter((tag) => seen.has(tag));
}

// src/domain/constants/locationTracking.ts
var LOCATION_FLUSH_INTERVAL_MS = 3e4;
var LOCATION_SEGMENT_WINDOW_MS = 6e4;
var LOCATION_MIN_BUFFER_SPACING_MS = 5e3;
var LOCATION_SEGMENT_MAX_POINTS = 500;
var LOCATION_SEGMENT_RECORD_TYPE = "LOCATION_SEGMENT";
var MAX_OFFLINE_LOCATION_AGE_MS = 24 * 60 * 60 * 1e3;
var LOCATION_CLOCK_SKEW_ALLOWANCE_MS = 60 * 60 * 1e3;
function locationSegmentWindowStart(timestamp) {
  const ms = timestamp instanceof Date ? timestamp.getTime() : new Date(timestamp).getTime();
  if (Number.isNaN(ms)) {
    throw new Error(`locationSegmentWindowStart: invalid timestamp "${String(timestamp)}"`);
  }
  return new Date(
    Math.floor(ms / LOCATION_SEGMENT_WINDOW_MS) * LOCATION_SEGMENT_WINDOW_MS
  ).toISOString();
}

// src/domain/constants/insightsApiRoutes.ts
var INSIGHTS_API_ROUTES = [
  { method: "GET", path: "/platform-operator/configuration", public: true },
  { method: "POST", path: "/platform-operator/sessions", public: true },
  { method: "GET", path: "/platform-operator/password-resets", public: true },
  { method: "POST", path: "/platform-operator/password-resets", public: true },
  { method: "PATCH", path: "/platform-operator/password-resets", public: true },
  { method: "GET", path: "/platform-operator/session" },
  { method: "DELETE", path: "/platform-operator/session" },
  { method: "GET", path: "/organizations" },
  { method: "PATCH", path: "/organizations/{orgId}" },
  { method: "POST", path: "/organizations/{id}/texting-campaigns" },
  { method: "POST", path: "/organizations/{id}/rcs-upgrades" },
  { method: "GET", path: "/organizations/{orgId}/roles" },
  { method: "GET", path: "/organizations/{orgId}/members" },
  { method: "POST", path: "/organizations/{orgId}/members" },
  { method: "GET", path: "/organizations/{orgId}/members/{memberId}" },
  { method: "PATCH", path: "/organizations/{orgId}/members/{memberId}" },
  { method: "DELETE", path: "/organizations/{orgId}/members/{memberId}" },
  { method: "POST", path: "/organizations/{orgId}/staff-session" },
  { method: "GET", path: "/organizations/{id}/history" },
  { method: "GET", path: "/organizations/{id}/follow-up" },
  { method: "POST", path: "/organizations/{id}/notes" },
  { method: "POST", path: "/organizations/{id}/tasks" },
  { method: "PATCH", path: "/organizations/{id}/tasks/{taskId}" },
  { method: "PATCH", path: "/organizations/{id}/success-owner" },
  { method: "GET", path: "/platform-operator/teammates" },
  { method: "GET", path: "/costs/platform" },
  { method: "GET", path: "/payment-economics" },
  { method: "GET", path: "/unit-economics" },
  { method: "GET", path: "/costs/integrations" },
  { method: "GET", path: "/platform-operator/policies" },
  { method: "PATCH", path: "/platform-operator/policies" }
];
function insightsApiRoute(method, path) {
  return INSIGHTS_API_ROUTES.find((route) => route.method === method && new RegExp("^" + route.path.split("/").map(
    (segment) => /^\{[^}]+\}$/.test(segment) ? "[^/]+" : segment.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  ).join("/") + "$").test(path));
}

// src/domain/cost/integrations.ts
var IntegrationId = /* @__PURE__ */ ((IntegrationId2) => {
  IntegrationId2["JUSTIFI"] = "justifi";
  IntegrationId2["TWILIO"] = "twilio";
  IntegrationId2["TYPESENSE"] = "typesense";
  IntegrationId2["API_NINJAS"] = "api_ninjas";
  IntegrationId2["API_NINJAS_HOLIDAYS"] = "api_ninjas_holidays";
  IntegrationId2["GEOAPIFY"] = "geoapify";
  IntegrationId2["MAPBOX"] = "mapbox";
  IntegrationId2["MAPBOX_MAP_LOADS"] = "mapbox_map_loads";
  IntegrationId2["GOOGLE_MAPS"] = "google_maps";
  IntegrationId2["GOOGLE_STREET_VIEW"] = "google_street_view";
  IntegrationId2["ROBOFLOW"] = "roboflow";
  IntegrationId2["GEMINI"] = "gemini";
  IntegrationId2["ANTHROPIC"] = "anthropic";
  IntegrationId2["POSTHOG"] = "posthog";
  IntegrationId2["SENTRY"] = "sentry";
  IntegrationId2["CLOUDFLARE"] = "cloudflare";
  IntegrationId2["EXPO"] = "expo";
  IntegrationId2["NWS"] = "nws";
  IntegrationId2["ACIS"] = "acis";
  IntegrationId2["TWILIO_MMS"] = "twilio_mms";
  IntegrationId2["XAI"] = "xai";
  return IntegrationId2;
})(IntegrationId || {});
var INTEGRATION_COSTS = {
  ["justifi" /* JUSTIFI */]: {
    id: "justifi" /* JUSTIFI */,
    name: "Justifi",
    purpose: "Card payment processing",
    category: "Payments",
    billingModel: "usage",
    unit: "api_call",
    notes: "Justifi's cut (0.12% + $0.10/txn) is modeled in the admin payments endpoint fee split against real volume \u2014 not double-counted here.",
    source: "https://justifi.ai"
  },
  ["twilio" /* TWILIO */]: {
    id: "twilio" /* TWILIO */,
    name: "Twilio",
    purpose: "Outbound/inbound SMS (notifications, OTP, campaigns)",
    category: "Customer messaging (SMS)",
    billingModel: "vendor_api",
    unit: "sms_segment",
    unitRate: 83e-4,
    hasVendorBillingApi: true,
    notes: "Real billed cost pulled via the Twilio Usage Records API (totalprice category). AWS End User Messaging covers only the number lease, not per-message cost.",
    source: "https://www.twilio.com/en-us/sms/pricing/us"
  },
  ["twilio_mms" /* TWILIO_MMS */]: {
    id: "twilio_mms" /* TWILIO_MMS */,
    name: "Twilio MMS",
    purpose: "Outbound/inbound MMS picture messages",
    category: "Customer messaging (MMS)",
    billingModel: "vendor_api",
    unit: "mms_segment",
    unitRate: 0.022,
    hasVendorBillingApi: true,
    notes: "Per-org outbound MMS count metered at send time via recordIntegrationUsage. Carrier fees not included in unitRate.",
    source: "https://www.twilio.com/en-us/sms/pricing/us"
  },
  ["typesense" /* TYPESENSE */]: {
    id: "typesense" /* TYPESENSE */,
    name: "Typesense Cloud",
    purpose: "Full-text search (customers, subscriptions, visits)",
    category: "Search",
    billingModel: "flat",
    monthlyCost: 66.69,
    notes: "Billed $15.39/week \u2192 normalized to a month (\xD752\xF712 \u2248 $66.69). Two clusters (primary + parcel).",
    source: "https://cloud.typesense.org/pricing"
  },
  ["api_ninjas" /* API_NINJAS */]: {
    id: "api_ninjas" /* API_NINJAS */,
    name: "API Ninjas (sales tax)",
    purpose: "Sales-tax rate lookups by ZIP/address (`/v1/salestax`)",
    category: "Tax",
    billingModel: "usage",
    unit: "api_call",
    notes: "Same Developer-tier plan (~$39/mo) as holidays \u2014 metered separately so each endpoint is visible. Tax rates are cached 24h. Plan unconfirmed \u2014 meter before costing.",
    source: "https://api-ninjas.com/pricing"
  },
  ["api_ninjas_holidays" /* API_NINJAS_HOLIDAYS */]: {
    id: "api_ninjas_holidays" /* API_NINJAS_HOLIDAYS */,
    name: "API Ninjas (holidays)",
    purpose: "US federal holiday calendar (`/v1/holidays`)",
    category: "Scheduling",
    billingModel: "usage",
    unit: "api_call",
    notes: "Same plan as sales tax. Cached permanently per country-year \u2014 typically one fetch per year, a rounding error on the plan.",
    source: "https://api-ninjas.com/pricing"
  },
  ["geoapify" /* GEOAPIFY */]: {
    id: "geoapify" /* GEOAPIFY */,
    name: "Geoapify",
    purpose: "Geocoding, ZIP boundaries, routing, route optimization",
    category: "Maps & geocoding",
    billingModel: "usage",
    // Vendor bills one shared credit pool — see geoapifyCredits.ts for per-API amounts.
    unit: "credit",
    notes: "Free under ~3,000 credits/day (~90k/mo); first paid tier ~$59/mo. Metered in vendor credits (postcode/geocode = 1; routing = waypoint pairs (+ distance); route planner = n\xD7min(n,10)). Server and browser call sites both report (browser via POST /integrations/usage).",
    source: "https://www.geoapify.com/pricing",
    freeTier: {
      limit: 3e3,
      per: "day",
      unit: "credits",
      nextStep: "about $59 a month, the first paid tier",
      metered: true
    }
  },
  ["mapbox" /* MAPBOX */]: {
    id: "mapbox" /* MAPBOX */,
    name: "Mapbox (API)",
    purpose: "Address geocoding, Search Box, and satellite Static Images",
    category: "Maps & geocoding",
    billingModel: "usage",
    unit: "api_call",
    unitRate: 5e-3,
    notes: "Server geocoding + measurement Static Images; browser/portal Geocoding, Search Box, and office customer-detail Static Images via POST /integrations/usage. Interactive map loads are MAPBOX_MAP_LOADS. COST TRAP: Temporary vs Permanent geocoding SKU \u2014 confirm on invoice.",
    source: "https://www.mapbox.com/pricing"
  },
  ["mapbox_map_loads" /* MAPBOX_MAP_LOADS */]: {
    id: "mapbox_map_loads" /* MAPBOX_MAP_LOADS */,
    name: "Mapbox (map loads)",
    purpose: "Interactive Mapbox GL / MapView map constructions",
    category: "Maps & geocoding",
    billingModel: "usage",
    unit: "map_load",
    notes: "One load per successful `new mapboxgl.Map` construction in office/portal, reported via POST /integrations/usage. Free under 50k/mo then ~$5/1k. Mobile MapViews are not wired yet.",
    source: "https://www.mapbox.com/pricing",
    freeTier: {
      limit: 5e4,
      per: "month",
      unit: "map loads",
      nextStep: "about $5 per 1,000 loads past the limit",
      metered: true,
      meterGap: "crew app maps are not counted yet"
    }
  },
  ["google_maps" /* GOOGLE_MAPS */]: {
    id: "google_maps" /* GOOGLE_MAPS */,
    name: "Google Maps",
    purpose: "Satellite Static Maps (measurement) + Static Street View images",
    category: "Maps & geocoding",
    billingModel: "usage",
    unit: "api_call",
    notes: "Server Static Maps (measurement) and client Static Street View images reported via POST /integrations/usage. Interactive panoramas are GOOGLE_STREET_VIEW. The Street View availability check (StreetViewService / metadata) and deep links to google.com/maps are free.",
    source: "https://mapsplatform.google.com/pricing/"
  },
  ["google_street_view" /* GOOGLE_STREET_VIEW */]: {
    id: "google_street_view" /* GOOGLE_STREET_VIEW */,
    name: "Google Street View (interactive)",
    purpose: "Look-around Street View: office map + Measure and price",
    category: "Maps & geocoding",
    billingModel: "usage",
    unit: "panorama_load",
    notes: "Dynamic Street View (Pro SKU 658E-F885-E11A): billed once per successful panorama load; moving, turning and zooming inside it are free. Reported via POST /integrations/usage. No unitRate on purpose: the first 5k/mo are free, so loads \xD7 list price would overstate.",
    source: "https://developers.google.com/maps/billing-and-pricing/pricing",
    freeTier: {
      limit: 5e3,
      per: "month",
      unit: "panorama loads",
      nextStep: "about $14 per 1,000 loads past the limit",
      metered: true
    }
  },
  ["roboflow" /* ROBOFLOW */]: {
    id: "roboflow" /* ROBOFLOW */,
    name: "Roboflow",
    purpose: "Computer-vision lawn/parcel measurement from photos",
    category: "Measurement (CV)",
    billingModel: "usage",
    unit: "cv_inference",
    notes: "Free (open projects) or ~$79/mo Core for private models. Plan unconfirmed \u2014 meter usage.",
    source: "https://roboflow.com/pricing"
  },
  ["gemini" /* GEMINI */]: {
    id: "gemini" /* GEMINI */,
    name: "Google Gemini",
    purpose: "Unused \u2014 service-template image generation was removed (RUT-4030)",
    category: "AI features",
    billingModel: "usage",
    unit: "image",
    unitRate: 0.067,
    notes: "Per-image (token-based), ~$0.067 per 1k-px image. Pin the model id; rates vary by version.",
    source: "https://ai.google.dev/gemini-api/docs/pricing"
  },
  ["anthropic" /* ANTHROPIC */]: {
    id: "anthropic" /* ANTHROPIC */,
    name: "Anthropic",
    purpose: "AI assistant chat and customer data import (Claude Sonnet 5.5)",
    category: "AI features",
    billingModel: "usage",
    unit: "ai_request",
    notes: "Claude chat: official Anthropic API (Haiku 5.5 / Sonnet 5.5) when ASSISTANT_MODEL_PROVIDER=anthropic, or Bedrock Haiku 4.5 (api:bedrockModelId override) when provider=bedrock. Customer data import: Sonnet 5.5 on the official API (effort high), metered with the model id. Admin insights prices assistant chat calls at the model that ran (RUT-4185). Bedrock shows $0 in AWS Cost Explorer; the official API bills on Anthropic. Meter requests/tokens; pull real cost from the vendor usage/cost API.",
    source: "https://www.anthropic.com/pricing"
  },
  ["xai" /* XAI */]: {
    id: "xai" /* XAI */,
    name: "xAI (Grok)",
    purpose: "AI assistant chat, writing helper, campaign suggestions, and message action suggestions (Grok 4.6)",
    category: "AI features",
    billingModel: "usage",
    unit: "ai_request",
    notes: "Grok 4.6 via the Anthropic-compatible Messages endpoint. $2/M input, $6/M output. Reasoning tokens bill as output and are included in the reported output total, so per-request cost runs above the headline rate. Product calls send reasoning_effort low to hold it down. Cached input is billed at a steep discount and is metered but excluded from customer credits.",
    source: "https://docs.x.ai/docs/models"
  },
  ["posthog" /* POSTHOG */]: {
    id: "posthog" /* POSTHOG */,
    name: "PostHog",
    purpose: "Product analytics / event tracking",
    category: "Analytics",
    billingModel: "free",
    unit: "analytics_event",
    notes: "Free under 1M events/mo. NEAR THE CEILING: mobile location batches alone are ~500k/mo. One more high-volume client event flips this to paid (~$0.00005/event).",
    source: "https://posthog.com/pricing",
    freeTier: {
      limit: 1e6,
      per: "month",
      unit: "events",
      nextStep: "usage billing at about $0.00005 an event",
      metered: false
    }
  },
  ["sentry" /* SENTRY */]: {
    id: "sentry" /* SENTRY */,
    name: "Sentry",
    purpose: "Error tracking & performance monitoring",
    category: "Error monitoring",
    billingModel: "free",
    notes: "Free solo tier today; flips to Team (~$26/mo) with multiple users or >5k errors/mo.",
    source: "https://sentry.io/pricing",
    freeTier: {
      limit: 5e3,
      per: "month",
      unit: "errors",
      nextStep: "Team plan, about $26 a month (a second seat also needs it)",
      metered: false
    }
  },
  ["cloudflare" /* CLOUDFLARE */]: {
    id: "cloudflare" /* CLOUDFLARE */,
    name: "Cloudflare",
    purpose: "CDN, DNS, R2 asset storage, custom portal domains",
    category: "Content delivery & DNS",
    billingModel: "flat",
    monthlyCost: 0,
    notes: "R2 free under 10GB + millions of ops, zero egress. $0 today; revisit as storage grows.",
    source: "https://developers.cloudflare.com/r2/pricing"
  },
  ["expo" /* EXPO */]: {
    id: "expo" /* EXPO */,
    name: "Expo (EAS)",
    purpose: "Mobile builds, OTA updates, push infrastructure",
    category: "Mobile builds",
    billingModel: "free",
    notes: "Plan-dependent ($0 / $19 Starter / $199 Production). Confirm current plan before costing.",
    source: "https://expo.dev/pricing"
  },
  ["nws" /* NWS */]: {
    id: "nws" /* NWS */,
    name: "National Weather Service",
    purpose: "Forecasts (gridpoints) + observations for weather-sensitive visits",
    category: "Weather",
    billingModel: "free",
    unit: "api_call",
    notes: "Free public API (api.weather.gov), no auth, no cost. Metered so volume stays visible as weather-sensitive visit share grows. User-Agent required.",
    source: "https://www.weather.gov/documentation/services-web-api"
  },
  ["acis" /* ACIS */]: {
    id: "acis" /* ACIS */,
    name: "ACIS (RCC)",
    purpose: "Historical storm snowfall for snow-service billing",
    category: "Weather",
    billingModel: "free",
    unit: "api_call",
    notes: "Free Applied Climate Information System MultiStnData (data.rcc-acis.org). Distinct from NWS \u2014 this is the station snowfall source behind visitSnowfallProcessor.",
    source: "https://www.rcc-acis.org/docs_webservices.html"
  }
};
function listIntegrationCosts() {
  return Object.values(INTEGRATION_COSTS);
}
function getFixedMonthlySaasCosts() {
  return listIntegrationCosts().filter((i) => i.billingModel === "flat" && typeof i.monthlyCost === "number").map((i) => ({ service: i.name, category: i.category, monthlyCost: i.monthlyCost }));
}
var MESSAGING_INFRA_FIXED_MONTHLY = {
  /** A2P 10DLC campaign carrier fee, USD/mo (confirmed June 2026 Twilio bill). */
  a2p10dlcCampaign: 11.5,
  /** Local number monthly leases, USD/mo (2 numbers × $1.15). */
  numberLeases: 2.3
};
function getMessagingInfraMonthlyFixedCost() {
  return MESSAGING_INFRA_FIXED_MONTHLY.a2p10dlcCampaign + MESSAGING_INFRA_FIXED_MONTHLY.numberLeases;
}

// src/domain/cost/geoapifyCredits.ts
function geoapifySimpleRequestCredits() {
  return 1;
}
function geoapifyRoutingCredits(waypointCount, distanceMeters) {
  const pairs = Math.max(0, waypointCount - 1);
  let credits = pairs;
  if (typeof distanceMeters === "number" && Number.isFinite(distanceMeters) && distanceMeters > 0) {
    credits += Math.floor(distanceMeters / 5e5);
  }
  return Math.max(credits, 0);
}
function geoapifyRoutePlannerCredits(locationCount) {
  const n = Math.max(0, Math.floor(locationCount));
  if (n === 0) return 0;
  return n * Math.min(n, 10);
}

// src/domain/cost/clientReportableIntegrations.ts
var MAX_CLIENT_INTEGRATION_USAGE_AMOUNT = 1e4;
var CLIENT_REPORTABLE_INTEGRATION_IDS = [
  "geoapify" /* GEOAPIFY */,
  "mapbox" /* MAPBOX */,
  "mapbox_map_loads" /* MAPBOX_MAP_LOADS */,
  "google_maps" /* GOOGLE_MAPS */,
  "google_street_view" /* GOOGLE_STREET_VIEW */
];
function isClientReportableIntegrationId(id) {
  return CLIENT_REPORTABLE_INTEGRATION_IDS.includes(id);
}

// src/utils/date.ts
function getISOWeekNumber(date) {
  const target = new Date(date.valueOf());
  const dayNr = (date.getDay() + 6) % 7;
  target.setDate(target.getDate() - dayNr + 3);
  const firstThursday = target.valueOf();
  target.setMonth(0, 1);
  if (target.getDay() !== 4) {
    target.setMonth(0, 1 + (4 - target.getDay() + 7) % 7);
  }
  return 1 + Math.ceil((firstThursday - target.valueOf()) / 6048e5);
}
function getISOWeekYear(date) {
  const target = new Date(date.valueOf());
  const dayNr = (date.getDay() + 6) % 7;
  target.setDate(target.getDate() - dayNr + 3);
  return target.getFullYear();
}
function getISOWeekString(date = /* @__PURE__ */ new Date()) {
  const weekNum = getISOWeekNumber(date);
  const year = getISOWeekYear(date);
  return `${year}-W${weekNum.toString().padStart(2, "0")}`;
}
function parseISOWeekString(weekString) {
  const match = weekString.match(/^(\d{4})-W(\d{2})$/);
  if (!match) {
    throw new Error(`Invalid ISO week string: ${weekString}. Expected format: YYYY-WNN`);
  }
  const year = parseInt(match[1], 10);
  const weekNum = parseInt(match[2], 10);
  const jan4 = new Date(year, 0, 4);
  const dayOfWeek = jan4.getDay() || 7;
  const week1Monday = new Date(jan4);
  week1Monday.setDate(jan4.getDate() - dayOfWeek + 1);
  const targetMonday = new Date(week1Monday);
  targetMonday.setDate(week1Monday.getDate() + (weekNum - 1) * 7);
  return targetMonday;
}
function getISOWeekStart(date) {
  const result = new Date(date.valueOf());
  const dayNr = (date.getDay() + 6) % 7;
  result.setDate(result.getDate() - dayNr);
  result.setHours(0, 0, 0, 0);
  return result;
}
function getISOWeekEnd(date) {
  const start = getISOWeekStart(date);
  const end = new Date(start);
  end.setDate(end.getDate() + 6);
  end.setHours(23, 59, 59, 999);
  return end;
}
function getWeekDateRange(weekString) {
  const monday = parseISOWeekString(weekString);
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);
  const formatDate = (d) => {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  return {
    startDate: formatDate(monday),
    endDate: formatDate(sunday)
  };
}
function getLocalDateFromISO(isoString) {
  const date = new Date(isoString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
function getTodayLocalDateString() {
  const today = /* @__PURE__ */ new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
function getLocalISOString(date = /* @__PURE__ */ new Date()) {
  const offset = -date.getTimezoneOffset();
  const sign = offset >= 0 ? "+" : "-";
  const absOffset = Math.abs(offset);
  const hours = String(Math.floor(absOffset / 60)).padStart(2, "0");
  const minutes = String(absOffset % 60).padStart(2, "0");
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hour = String(date.getHours()).padStart(2, "0");
  const min = String(date.getMinutes()).padStart(2, "0");
  const sec = String(date.getSeconds()).padStart(2, "0");
  const ms = String(date.getMilliseconds()).padStart(3, "0");
  return `${year}-${month}-${day}T${hour}:${min}:${sec}.${ms}${sign}${hours}:${minutes}`;
}
function extractLocalDate(isoString) {
  return isoString.substring(0, 10);
}
var dateTimeFormatCache = /* @__PURE__ */ new Map();
function cachedDateTimeFormat(locale, options) {
  const key = `${locale ?? ""}|${JSON.stringify(options)}`;
  let formatter = dateTimeFormatCache.get(key);
  if (!formatter) {
    formatter = new Intl.DateTimeFormat(locale, options);
    dateTimeFormatCache.set(key, formatter);
  }
  return formatter;
}
function getDateInTimezone(isoString, timezone) {
  const date = new Date(isoString);
  const formatter = cachedDateTimeFormat("en-CA", {
    timeZone: timezone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  });
  return formatter.format(date);
}
var DEFAULT_DISPLAY_TIMEZONE = "America/Chicago";
var SUPPORTED_ORG_TIMEZONES = [
  { value: "America/New_York", label: "Eastern Time (New York)" },
  { value: "America/Chicago", label: "Central Time (Chicago)" },
  { value: "America/Denver", label: "Mountain Time (Denver)" },
  { value: "America/Phoenix", label: "Mountain Time - no DST (Phoenix)" },
  { value: "America/Los_Angeles", label: "Pacific Time (Los Angeles)" },
  { value: "America/Anchorage", label: "Alaska Time (Anchorage)" },
  { value: "Pacific/Honolulu", label: "Hawaii Time (Honolulu)" }
];
function formatTimeForDisplay(timestamp, timezone = DEFAULT_DISPLAY_TIMEZONE) {
  const date = typeof timestamp === "string" ? new Date(timestamp) : timestamp;
  return date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: timezone
  });
}
function getHourInTimezone(nowUtc, timezone) {
  const hourStr = cachedDateTimeFormat("en-US", {
    timeZone: timezone,
    hour: "2-digit",
    hour12: false
  }).format(nowUtc);
  return Number(hourStr) % 24;
}
function isWithinQuietHours(nowUtc, timezone, startHour, endHour) {
  const hour = getHourInTimezone(nowUtc, timezone);
  if (startHour === endHour) return false;
  if (startHour < endHour) {
    return hour >= startHour && hour < endHour;
  }
  return hour >= startHour || hour < endHour;
}
function getTimezoneOffsetMinutes(instantUtc, timezone) {
  const dtf = cachedDateTimeFormat("en-US", {
    timeZone: timezone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false
  });
  const parts = dtf.formatToParts(instantUtc);
  const map = {};
  for (const p of parts) {
    if (p.type !== "literal") map[p.type] = Number(p.value);
  }
  const hour = map.hour % 24;
  const asUtc = Date.UTC(map.year, map.month - 1, map.day, hour, map.minute, map.second);
  return Math.round((asUtc - instantUtc.getTime()) / 6e4);
}
function localDateTimeToUtc(dateStr, timezone, hour = 0, minute = 0, second = 0, ms = 0) {
  const [year, month, day] = dateStr.split("-").map(Number);
  const naiveUtcMs = Date.UTC(year, month - 1, day, hour, minute, second, ms);
  const offsetMin = getTimezoneOffsetMinutes(new Date(naiveUtcMs), timezone);
  let utcMs = naiveUtcMs - offsetMin * 6e4;
  const offsetMin2 = getTimezoneOffsetMinutes(new Date(utcMs), timezone);
  if (offsetMin2 !== offsetMin) {
    utcMs = naiveUtcMs - offsetMin2 * 6e4;
  }
  return new Date(utcMs);
}
function endOfDayInTimezone(dateStr, timezone) {
  return localDateTimeToUtc(dateStr, timezone, 23, 59, 59, 999);
}
function startOfDayInTimezone(dateStr, timezone) {
  return localDateTimeToUtc(dateStr, timezone, 0, 0, 0, 0);
}
function getViewerTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function getZoneAbbrev(instant, timezone) {
  const parts = cachedDateTimeFormat("en-US", {
    timeZone: timezone,
    timeZoneName: "short"
  }).formatToParts(instant);
  return parts.find((p) => p.type === "timeZoneName")?.value ?? "";
}
function formatVisitTimeWithZone(instant, jobTimezone, viewerTimezone = getViewerTimezone(), locale = "en-US") {
  const date = typeof instant === "string" ? new Date(instant) : instant;
  const zone = jobTimezone || viewerTimezone;
  const time = cachedDateTimeFormat(locale, {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: zone
  }).format(date);
  if (getTimezoneOffsetMinutes(date, zone) === getTimezoneOffsetMinutes(date, viewerTimezone)) {
    return time;
  }
  const abbrev = getZoneAbbrev(date, zone);
  return abbrev ? `${time} ${abbrev}` : time;
}
var CALENDAR_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
var MS_PER_CALENDAR_DAY = 24 * 60 * 60 * 1e3;
function isCalendarDate(value) {
  if (!CALENDAR_DATE_PATTERN.test(value)) return false;
  const parsed = /* @__PURE__ */ new Date(`${value}T00:00:00Z`);
  if (Number.isNaN(parsed.getTime())) return false;
  return parsed.toISOString().slice(0, 10) === value;
}
function addCalendarDays(date, days) {
  if (!isCalendarDate(date)) {
    throw new Error(`Expected a YYYY-MM-DD date, received "${date}"`);
  }
  const shifted = (/* @__PURE__ */ new Date(`${date}T00:00:00Z`)).getTime() + days * MS_PER_CALENDAR_DAY;
  return new Date(shifted).toISOString().slice(0, 10);
}
function toCalendarDate(instant) {
  return instant.toISOString().slice(0, 10);
}
function formatCalendarDateShort(dateStr) {
  const [y, m, d] = dateStr.slice(0, 10).split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" });
}
function calendarDateToUtcSeconds(dateStr) {
  const [year, month, day] = dateStr.split("-").map(Number);
  return Date.UTC(year, month - 1, day) / 1e3;
}
function calendarDateUtcBounds(dateStr) {
  const start = calendarDateToUtcSeconds(dateStr);
  return { start, end: start + 86399 };
}

// src/domain/cost/platformBilling.ts
var PLATFORM_PLAN_IDS = ["starter"];
var SMS_SEGMENTS_PER_BILLED_TEXT = 3;
function billedTextsFrom(smsSegments, mms, rcs = 0) {
  const sms = Number.isFinite(smsSegments) && smsSegments > 0 ? smsSegments : 0;
  const m = Number.isFinite(mms) && mms > 0 ? mms : 0;
  const r = Number.isFinite(rcs) && rcs > 0 ? rcs : 0;
  return Math.ceil(sms / SMS_SEGMENTS_PER_BILLED_TEXT) + m + r;
}
function safeCount(value) {
  return typeof value === "number" && Number.isFinite(value) && value > 0 ? value : 0;
}
function outboundMessagingFromDailyUsage(item) {
  const counts = item.counts ?? {};
  return {
    sms: safeCount(counts["twilio" /* TWILIO */]),
    mms: safeCount(counts["twilio_mms" /* TWILIO_MMS */]),
    billedTexts: safeCount(item.billedTexts)
  };
}
var PLATFORM_OVERAGE = {
  billedTextUnitPrice: 0.05,
  /** @deprecated Retired pack — do not bill. Kept so older readers don't throw. */
  textSegmentPackSize: 1,
  /** @deprecated Use billedTextUnitPrice. */
  textSegmentPackPrice: 0.05,
  aiCreditPackSize: 0,
  aiCreditPackPrice: 0
};
var PLATFORM_AI_OVERAGE_ENABLED = false;
var PLATFORM_AI_INCLUDED_COPY = "AI is included in your plan.";
var STARTER_AI_CREDIT_ALLOWANCE = 100;
var PLATFORM_OVERAGE_STANDALONE_MINIMUM = 10;
function overageMayInvoiceStandalone(overageTotal) {
  return overageTotal >= PLATFORM_OVERAGE_STANDALONE_MINIMUM;
}
var PLATFORM_COST_BASIS = {
  texts: {
    twilioPerSegment: 0.0124,
    /** Not live. */
    telnyxPerSegment: 85e-4,
    telnyxLive: false
  },
  card: {
    justifiPct: 2.35
  }
};
var PLATFORM_TIERS = {
  starter: {
    id: "starter",
    name: "Ruta",
    monthlyPrice: 150,
    priceWithoutPayments: 375,
    includedBilledTexts: 0,
    starterTexts: 200,
    includedAiCredits: 0,
    cardPercent: 3.99,
    cardFixed: 0.3,
    achPercent: 1,
    achFixed: 0,
    achCap: 25
  }
};
var STARTER_TEXTS_COUNTED_FROM = "2026-09-22";
function textsCountFrom(createdAt) {
  const signup = typeof createdAt === "string" ? createdAt.slice(0, 10) : "";
  return signup > STARTER_TEXTS_COUNTED_FROM ? signup : STARTER_TEXTS_COUNTED_FROM;
}
function textsPrepaidThrough(lastChargeDate) {
  const charged = typeof lastChargeDate === "string" ? lastChargeDate.slice(0, 10) : "";
  if (!isCalendarDate(charged) || charged >= STARTER_TEXTS_COUNTED_FROM) return null;
  const [y, m, d] = charged.split("-").map(Number);
  const through = new Date(Date.UTC(y, m, d)).toISOString().slice(0, 10);
  return through > STARTER_TEXTS_COUNTED_FROM ? through : null;
}
function starterTextsCountFrom(createdAt, periodStart) {
  const from = textsCountFrom(createdAt);
  if (periodStart < from) return null;
  if (from > STARTER_TEXTS_COUNTED_FROM) return from;
  const [y, m, d] = periodStart.split("-").map(Number);
  let first = periodStart;
  for (let k = 1; k < 1200; k += 1) {
    const earlier = new Date(Date.UTC(y, m - 1 - k, d)).toISOString().slice(0, 10);
    if (earlier < from) break;
    first = earlier;
  }
  return first;
}
var DEFAULT_PLATFORM_PLAN_ID = "starter";
function normalizePlatformPlanId(tier) {
  if (!tier) return null;
  const t = tier.toLowerCase();
  if (t === "starter" || t === "pro" || t === "professional" || t === "growth") {
    return "starter";
  }
  return null;
}
function getPlatformTier(tier) {
  const id = normalizePlatformPlanId(tier);
  return id ? PLATFORM_TIERS[id] : null;
}
function planFromTier(def) {
  return {
    tier: def.id,
    basePrice: def.monthlyPrice,
    priceWithoutPayments: def.priceWithoutPayments,
    includedTexts: def.includedBilledTexts,
    starterTexts: def.starterTexts,
    includedAiCredits: def.includedAiCredits,
    topUpTextsPrice: PLATFORM_OVERAGE.billedTextUnitPrice,
    topUpTexts: 1,
    topUpAiCreditsPrice: PLATFORM_AI_OVERAGE_ENABLED ? PLATFORM_OVERAGE.aiCreditPackPrice : 0,
    topUpAiCredits: PLATFORM_AI_OVERAGE_ENABLED ? PLATFORM_OVERAGE.aiCreditPackSize : 0,
    cardPercent: def.cardPercent,
    cardFixed: def.cardFixed,
    achPercent: def.achPercent,
    achFixed: def.achFixed,
    achCap: def.achCap
  };
}
var DEFAULT_PLATFORM_BILLING_PLAN = planFromTier(
  PLATFORM_TIERS[DEFAULT_PLATFORM_PLAN_ID]
);
var DEFAULT_PAYMENT_FEE_RATES = {
  cardPercent: PLATFORM_TIERS.starter.cardPercent,
  cardFixed: PLATFORM_TIERS.starter.cardFixed,
  achPercent: PLATFORM_TIERS.starter.achPercent,
  achFixed: PLATFORM_TIERS.starter.achFixed,
  achCap: PLATFORM_TIERS.starter.achCap
};
var RETIRED_PLAN_LEVERS = [
  "rutaPayPrice",
  "rutaPayThresholdPct",
  "revenueCreditPct",
  "minPrice",
  "mmsTextMultiplier",
  "topUpPrice"
  // replaced by per-meter pack prices
];
function resolvePlatformBillingPlan(tier, overrides) {
  const def = getPlatformTier(tier);
  if (!def) return null;
  const base = planFromTier(def);
  if (!overrides) return base;
  const safe = { ...overrides };
  for (const key of RETIRED_PLAN_LEVERS) {
    delete safe[key];
  }
  const merged = { ...base, ...safe, tier: base.tier };
  if (typeof safe.basePrice === "number" && typeof safe.priceWithoutPayments !== "number") {
    merged.priceWithoutPayments = safe.basePrice;
  }
  return merged;
}
var PLATFORM_TRIAL_DAYS = 30;
function platformTrialEndsAt(start) {
  const end = new Date(start);
  end.setUTCDate(end.getUTCDate() + PLATFORM_TRIAL_DAYS);
  return end.toISOString();
}
function isEligibleForPlatformTrial(org) {
  return !org.trialEndsAt && !org.lastChargeId && !org.lastChargeDate && org.subscriptionStatus !== "active" /* ACTIVE */ && org.subscriptionStatus !== "payment_pending" /* PAYMENT_PENDING */;
}
function platformTrialPeriod(trialEndsAt) {
  const end = new Date(trialEndsAt);
  const start = new Date(end);
  start.setUTCDate(start.getUTCDate() - PLATFORM_TRIAL_DAYS);
  end.setUTCDate(end.getUTCDate() - 1);
  return { start: start.toISOString().slice(0, 10), end: end.toISOString().slice(0, 10) };
}
function isOnPlatformTrial(org, now = /* @__PURE__ */ new Date()) {
  return isFirstChargeAfterPlatformTrial(org) && new Date(org.trialEndsAt) > now;
}
function platformTrialDaysLeft(org, now = /* @__PURE__ */ new Date()) {
  if (!isOnPlatformTrial(org, now)) return null;
  const msLeft = new Date(org.trialEndsAt).getTime() - now.getTime();
  return Math.max(1, Math.ceil(msLeft / 864e5));
}
function rutaPayPriceGap(plan) {
  if (!plan) return null;
  const withRutaPay = plan.basePrice;
  const withoutRutaPay = plan.priceWithoutPayments;
  if (!Number.isFinite(withRutaPay) || !Number.isFinite(withoutRutaPay)) return null;
  const monthlySavings = withoutRutaPay - withRutaPay;
  if (monthlySavings <= 0) return null;
  return { withRutaPay, withoutRutaPay, monthlySavings };
}
function isFirstChargeAfterPlatformTrial(org) {
  return Boolean(org.trialEndsAt) && !org.lastChargeId && !org.lastChargeDate;
}
function isLockedAfterPlatformTrial(org) {
  return isFirstChargeAfterPlatformTrial(org) && org.subscriptionStatus === "payment_pending" /* PAYMENT_PENDING */;
}
function planWithOrgAiAllowance(plan, org) {
  const allowance = org.aiCreditLimit;
  if (typeof allowance === "number" && Number.isFinite(allowance) && allowance >= 0) {
    return { ...plan, includedAiCredits: allowance };
  }
  return { ...plan, includedAiCredits: STARTER_AI_CREDIT_ALLOWANCE };
}
function roundCents(value) {
  return Math.round(value * 100) / 100;
}
function safeNonNegative(value) {
  return Number.isFinite(value) && value > 0 ? value : 0;
}
function projectSmsCampaign(meter, additionalSms) {
  const additionalSegments = Number.isFinite(additionalSms) && additionalSms > 0 ? Math.floor(additionalSms) : 0;
  const additional = billedTextsFrom(additionalSegments, 0);
  const includedRemaining = Math.max(0, meter.included - meter.used);
  const beforeOverage = Math.max(0, meter.used - meter.included);
  const afterOverage = Math.max(0, meter.used + additional - meter.included);
  const newlyOverageSms = afterOverage - beforeOverage;
  const packSize = meter.packSize > 0 ? meter.packSize : 1;
  const packsBefore = Math.ceil(beforeOverage / packSize);
  const packsAfter = Math.ceil(afterOverage / packSize);
  const additionalPacks = packsAfter - packsBefore;
  return {
    additionalSms: additional,
    includedRemaining,
    newlyOverageSms,
    additionalPacks,
    additionalCost: roundCents(additionalPacks * meter.packPrice)
  };
}
function buildMeter(used, included, packSize, packPrice) {
  const safeUsed = safeNonNegative(used);
  const overage = Math.max(0, safeUsed - included);
  const safePackSize = packSize > 0 ? packSize : 1;
  const packs = overage > 0 ? Math.ceil(overage / safePackSize) : 0;
  return {
    used: safeUsed,
    included,
    overage,
    packSize,
    packPrice,
    packs,
    overageAmount: roundCents(packs * packPrice)
  };
}
function computePlatformUsageSummary(usage, plan, period) {
  const textsUsed = safeNonNegative(usage.billedTexts);
  const starterTextsRemaining = Math.max(
    0,
    safeNonNegative(plan.starterTexts) - safeNonNegative(usage.starterTextsUsedBefore ?? 0)
  );
  const textsIncludedThrough = usage.textsPrepaidThrough || null;
  const texts = buildMeter(
    textsUsed,
    textsIncludedThrough ? textsUsed + starterTextsRemaining : starterTextsRemaining + safeNonNegative(plan.includedTexts),
    plan.topUpTexts > 0 ? plan.topUpTexts : 1,
    plan.topUpTextsPrice
  );
  const aiCredits = PLATFORM_AI_OVERAGE_ENABLED ? buildMeter(
    usage.aiCredits,
    plan.includedAiCredits,
    plan.topUpAiCredits > 0 ? plan.topUpAiCredits : 1,
    plan.topUpAiCreditsPrice
  ) : buildMeter(usage.aiCredits, plan.includedAiCredits, 1, 0);
  const withoutPaymentsPrice = usage.tookRutaPayPayments === false && (safeNonNegative(usage.generatedRevenue ?? 0) > 0 || usage.hasRutaPayHistory === false);
  const priceWithPayments = roundCents(safeNonNegative(plan.basePrice));
  const priceWithoutPayments = roundCents(
    safeNonNegative(plan.priceWithoutPayments ?? plan.basePrice)
  );
  const basePrice = withoutPaymentsPrice ? priceWithoutPayments : priceWithPayments;
  const overageTotal = roundCents(texts.overageAmount + aiCredits.overageAmount);
  return {
    periodStart: period.start,
    periodEnd: period.end,
    currency: "USD",
    tier: plan.tier,
    listPrice: basePrice,
    basePrice,
    withoutPaymentsPrice,
    priceWithPayments,
    priceWithoutPayments,
    starterTextsRemaining,
    textsIncludedThrough,
    visits: safeNonNegative(usage.visits),
    texts,
    aiCredits,
    overageTotal,
    estimatedTotal: roundCents(basePrice + overageTotal),
    paymentRates: {
      cardPercent: plan.cardPercent,
      cardFixed: plan.cardFixed,
      achPercent: plan.achPercent,
      achFixed: plan.achFixed,
      achCap: plan.achCap
    },
    processedRevenue: safeNonNegative(usage.onlineRevenue)
  };
}
function formatPaymentFeeRateReminder(rates) {
  const r = {
    cardPercent: rates?.cardPercent ?? DEFAULT_PAYMENT_FEE_RATES.cardPercent,
    cardFixed: rates?.cardFixed ?? DEFAULT_PAYMENT_FEE_RATES.cardFixed,
    achPercent: rates?.achPercent ?? DEFAULT_PAYMENT_FEE_RATES.achPercent,
    achFixed: rates?.achFixed ?? DEFAULT_PAYMENT_FEE_RATES.achFixed,
    achCap: rates?.achCap ?? DEFAULT_PAYMENT_FEE_RATES.achCap
  };
  const money2 = (n) => n.toLocaleString("en-US", { style: "currency", currency: "USD" });
  const part = (percent, fixed) => fixed > 0 ? `${percent}% + ${money2(fixed)}` : `${percent}%`;
  return `Card ${part(r.cardPercent, r.cardFixed)} \xB7 Bank (ACH) ${part(r.achPercent, r.achFixed)} (capped at ${money2(r.achCap)})`;
}
function buildPlatformInvoiceLineItems(usage, planLabel) {
  const lines = [
    {
      description: usage.withoutPaymentsPrice ? `${planLabel} platform plan \u2014 no Ruta Pay payments last month` : `${planLabel} platform plan`,
      amount: usage.listPrice
    }
  ];
  if (usage.texts.overageAmount > 0) {
    lines.push({
      description: "Text overage",
      quantity: usage.texts.overage,
      unitPrice: usage.texts.packPrice,
      amount: usage.texts.overageAmount
    });
  }
  if (PLATFORM_AI_OVERAGE_ENABLED && usage.aiCredits.overageAmount > 0) {
    lines.push({
      description: "AI credit overage",
      quantity: usage.aiCredits.packs,
      unitPrice: usage.aiCredits.packPrice,
      amount: usage.aiCredits.overageAmount
    });
  }
  return lines;
}

// src/domain/cost/platformCustomer.ts
var CARD_COST_PERCENT_ALL_IN = 2.35;
var PLACEHOLDER_PAYMENT_METHOD = "skipped";
function isDemoOrg(orgId) {
  return orgId.toUpperCase().startsWith("DEMO");
}
function classifyPlatformCustomer(org) {
  if (isDemoOrg(org.orgId)) return { paying: false, reason: "demo" };
  if (org.isActive === false) return { paying: false, reason: "inactive" };
  if (!normalizePlatformPlanId(org.subscriptionTier)) {
    return { paying: false, reason: "no_plan" };
  }
  const method = org.paymentMethodId?.trim();
  const billed = !!method && method.toLowerCase() !== PLACEHOLDER_PAYMENT_METHOD && !!org.lastChargeDate;
  if (!billed) return { paying: false, reason: "never_billed" };
  return { paying: true, reason: null };
}
function nonPayingLabel(reason) {
  switch (reason) {
    case "demo":
      return "Demo account";
    case "inactive":
      return "Switched off";
    case "no_plan":
      return "No plan";
    case "never_billed":
      return "Never billed";
  }
}
function cardCostOfVolume(volume) {
  return Math.max(0, volume) * (CARD_COST_PERCENT_ALL_IN / 100);
}
function cardNet(feesCollected, volume) {
  return feesCollected - cardCostOfVolume(volume);
}

// src/domain/cost/subscriptionSettings.ts
var PLATFORM_PER_TEXT_LABEL = `${Math.round(PLATFORM_OVERAGE.billedTextUnitPrice * 100)}\xA2`;
var PLATFORM_OVERAGE_COPY = `After your free texts, each text is ${PLATFORM_PER_TEXT_LABEL}. A text is up to 3 SMS segments, or 1 picture message.`;
var LEGACY_PLATFORM_DEAL_NAME = "Legacy platform deal";
var LEGACY_PLATFORM_FEE = 999.99;
var JUSTIFI_LOCKED_PLATFORM_INVOICES = {
  be8221e5: {
    amount: LEGACY_PLATFORM_FEE,
    status: "paid",
    planName: LEGACY_PLATFORM_DEAL_NAME
  },
  "14669f8a": {
    amount: LEGACY_PLATFORM_FEE,
    status: "paid",
    planName: LEGACY_PLATFORM_DEAL_NAME
  },
  f419bee7: {
    amount: LEGACY_PLATFORM_FEE,
    status: "paid",
    planName: LEGACY_PLATFORM_DEAL_NAME
  },
  cdccf0d2: {
    amount: LEGACY_PLATFORM_FEE,
    status: "open",
    planName: LEGACY_PLATFORM_DEAL_NAME,
    openReason: "Four declines \xB7 $0 captured"
  },
  f8978c7e: {
    amount: LEGACY_PLATFORM_FEE,
    status: "paid",
    planName: LEGACY_PLATFORM_DEAL_NAME
  }
};
var EXTRA_VISITS_RE = /extra\s+visits/i;
var NAMED_OVERAGE_RE = /text overage|text segment overage|ai credit overage/i;
function roundCents2(value) {
  return Math.round(value * 100) / 100;
}
function isFiniteAmount(value) {
  return Number.isFinite(value);
}
function isLegacyPlatformFee(amount) {
  if (!isFiniteAmount(amount)) return false;
  const cents = Math.round(amount * 100);
  return cents === 99900 || cents === 99999;
}
var CATALOG_FEE_CENTS = new Set(
  Object.values(PLATFORM_TIERS).flatMap((t) => [
    Math.round(t.monthlyPrice * 100),
    Math.round(t.priceWithoutPayments * 100)
  ])
);
function isCatalogPlatformFee(amount) {
  if (!isFiniteAmount(amount)) return false;
  return CATALOG_FEE_CENTS.has(Math.round(amount * 100));
}
function platformDealName(tier) {
  return getPlatformTier(tier)?.name ?? null;
}
function invoicedDealName(tier) {
  const t = tier?.toLowerCase();
  if (t === "pro" || t === "professional") return "Ruta Pro";
  return platformDealName(tier);
}
function isNamedOverageLine(description) {
  return NAMED_OVERAGE_RE.test(description);
}
function isExcludedInvoiceLine(description) {
  return EXTRA_VISITS_RE.test(description);
}
function lockKeyFromInvoice(invoice) {
  const id = invoice.id.toLowerCase();
  const number = invoice.invoiceNumber.toLowerCase();
  const charge = (invoice.chargeId ?? "").toLowerCase();
  for (const key of Object.keys(JUSTIFI_LOCKED_PLATFORM_INVOICES)) {
    const k = key.toLowerCase();
    if (id === k || number === k || charge === k) return key;
    if (number.endsWith(`-${k}`)) return key;
    if (charge.endsWith(k) && charge.length >= k.length) return key;
  }
  return void 0;
}
function presentPlatformInvoice(invoice) {
  const lockKey = lockKeyFromInvoice(invoice);
  const lock = lockKey ? JUSTIFI_LOCKED_PLATFORM_INVOICES[lockKey] : void 0;
  const keptLines = invoice.lineItems.filter((l) => !isExcludedInvoiceLine(l.description));
  const overageLines = keptLines.filter((l) => isNamedOverageLine(l.description));
  const platformLines = keptLines.filter((l) => !isNamedOverageLine(l.description));
  const overageAmount = roundCents2(overageLines.reduce((sum, l) => sum + l.amount, 0));
  const platformAmount = roundCents2(platformLines.reduce((sum, l) => sum + l.amount, 0));
  const rawTotal = platformLines.length + overageLines.length > 0 ? roundCents2(platformAmount + overageAmount) : roundCents2(invoice.total);
  let amount = lock?.amount ?? rawTotal;
  if (!lock && isLegacyPlatformFee(rawTotal) && overageAmount === 0) {
    amount = LEGACY_PLATFORM_FEE;
  }
  const isLegacyDeal = Boolean(
    lock || invoice.planName === LEGACY_PLATFORM_DEAL_NAME || isLegacyPlatformFee(amount) && overageAmount === 0 && !isCatalogPlatformFee(amount)
  );
  const planName2 = lock?.planName ?? invoice.planName ?? (isLegacyDeal ? LEGACY_PLATFORM_DEAL_NAME : invoicedDealName(invoice.tier) ?? "Ruta");
  const status = lock?.status ?? invoice.status;
  const openReason = status === "open" ? lock?.openReason ?? invoice.openReason ?? "Not collected" : void 0;
  const sanitizedLines = [
    ...platformLines.map(
      (l) => isLegacyDeal && isLegacyPlatformFee(l.amount) ? { ...l, amount: LEGACY_PLATFORM_FEE } : l
    ),
    ...overageLines
  ];
  const sanitized = {
    ...invoice,
    lineItems: sanitizedLines.length > 0 ? sanitizedLines : invoice.lineItems,
    total: amount,
    status,
    planName: planName2,
    openReason,
    // Processor volume/fees stay off the invoice row and the PDF headline.
    paymentSummary: void 0
  };
  return {
    id: invoice.id,
    billedAt: invoice.billedAt,
    periodStart: invoice.periodStart,
    periodEnd: invoice.periodEnd,
    planName: planName2,
    isLegacyDeal,
    amount,
    status,
    openReason,
    billingType: invoice.billingType,
    overageLines,
    invoice: sanitized
  };
}
function money(n) {
  return n.toLocaleString("en-US", { style: "currency", currency: "USD" });
}
function ratePart(percent, fixed) {
  return fixed != null && fixed > 0 ? `${percent}% + ${money(fixed)}` : `${percent}%`;
}
function formatMerchantContractRates(rates) {
  if (!rates) return void 0;
  const parts = [];
  if (rates.cardPercent != null) {
    parts.push(`Card ${ratePart(rates.cardPercent, rates.cardFixed)}`);
  }
  if (rates.achPercent != null) {
    const ach = `Bank (ACH) ${ratePart(rates.achPercent, rates.achFixed)}`;
    parts.push(
      rates.achCap != null ? `${ach} (capped at ${money(rates.achCap)})` : ach
    );
  }
  if (parts.length === 0) return void 0;
  return `Merchant contract \xB7 ${parts.join(" \xB7 ")}.`;
}
function merchantContractRatesFromOrg(org) {
  const rutaPay = org.rutaPayStatus;
  const webhookRates = rutaPay?.lastWebhookData?.data?.application_fee_rates;
  const fromWebhook = {};
  if (Array.isArray(webhookRates)) {
    for (const r of webhookRates) {
      if (typeof r.basis_point_rate !== "number") continue;
      const percent = r.basis_point_rate / 100;
      const fixed = (r.transaction_fee ?? 0) / 100;
      const capCents = r.fee_cap_cents ?? r.fee_cap;
      const cap = typeof capCents === "number" ? capCents / 100 : void 0;
      const type = (r.rate_type ?? "").toLowerCase();
      if (type.includes("ach") || type.includes("bank")) {
        fromWebhook.achPercent = percent;
        fromWebhook.achFixed = fixed;
        if (cap != null) fromWebhook.achCap = cap;
      } else if (type.includes("card") || type.includes("credit") || type.includes("debit") || type.includes("visa") || type.includes("ecomm")) {
        fromWebhook.cardPercent = percent;
        fromWebhook.cardFixed = fixed;
      }
    }
  }
  const overrides = org.billingPlan;
  const fromOverrides = {};
  if (overrides) {
    if (overrides.cardPercent != null) fromOverrides.cardPercent = overrides.cardPercent;
    if (overrides.cardFixed != null) fromOverrides.cardFixed = overrides.cardFixed;
    if (overrides.achPercent != null) fromOverrides.achPercent = overrides.achPercent;
    if (overrides.achFixed != null) fromOverrides.achFixed = overrides.achFixed;
    if (overrides.achCap != null) fromOverrides.achCap = overrides.achCap;
  }
  const merged = {
    ...fromOverrides,
    ...fromWebhook
  };
  if (merged.cardPercent == null && merged.achPercent == null) {
    return void 0;
  }
  return merged;
}
function buildProcessorActivity(input) {
  const collected = roundCents2(Number.isFinite(input.collected) ? input.collected : 0);
  const processorTook = roundCents2(
    Number.isFinite(input.processorTook) ? input.processorTook : 0
  );
  const rates = input.rates;
  return {
    collected,
    processorTook,
    rates,
    ratesLabel: formatMerchantContractRates(rates)
  };
}

// src/domain/reviewHoldText.ts
var REVIEW_HOLD_TEXT = {
  /** `reviewMetadata.reviewRequired` was set — an office flag. */
  manual: "Manual review required",
  /** A follow-up that will notify the customer (RUT-2921). */
  followUpNotifies: "Follow-up customer notification requires review first",
  /** First visit under auto-pricing — the greater-of price is approved, not assumed (RUT-2746). */
  firstVisitPricing: "First visit on this property requires review",
  /** First visit after (re)activation with proof of service on. */
  proofOfService: "First visit requires proof of service review",
  /** Template cadence (RUT-2618): every visit or first X — no `reviewReason` is written. */
  templateReview: "Service template requires review of this visit",
  /** Per-subscription visit review (RUT-3630): `Visit requires admin review (1/3)`. */
  subscriptionReviewPrefix: "Visit requires admin review",
  /** Crew left a note and no photo — `checkCrewNoteWithoutPhoto`. */
  crewNoteNoPhoto: "Crew added a note with no photo attached",
  /** `Service option "<name>": <qty> <unit> exceeds review threshold of <n>` */
  serviceOptionPrefix: 'Service option "',
  /** `Crew times don't match: <who> started <gap> after <who>, more than the <window> allowed.` */
  crewTimesPrefix: "Crew times don't match",
  /** `Hours exceeded upper bound: <h>h > <bound>h` */
  hoursUpperPrefix: "Hours exceeded upper bound",
  /** `Hours below lower bound: <h>h < <bound>h` */
  hoursLowerPrefix: "Hours below lower bound",
  /** `Actual time variance exceeds 25%: <h>h vs <h>h budgeted (<pct>% variance)` */
  variancePrefix: "Actual time variance exceeds"
};

// src/storage/keys/patterns.ts
var DDB_KEY_PATTERNS = {
  INBOUND_EMAIL_RECEIPT_PREFIX: "INBOUND_EMAIL_RECEIPT#",
  // Entity prefixes
  ORG_PREFIX: "ORG#",
  CUSTOMER_PREFIX: "CUSTOMER#",
  CUSTOMER_ACCOUNT_PREFIX: "CUSTOMER_ACCOUNT#",
  ACCOUNT_PROPERTY_PREFIX: "ACCOUNT_PROPERTY#",
  ACCOUNT_MEMBER_PREFIX: "ACCOUNT_MEMBER#",
  SERVICE_TEMPLATE_PREFIX: "SERVICE_TEMPLATE#",
  RATE_REQUEST_PREFIX: "RATE_REQUEST#",
  MEMBER_PREFIX: "MEMBER#",
  CREW_PREFIX: "CREW#",
  VISIT_PREFIX: "VISIT#",
  INVOICE_PREFIX: "INVOICE#",
  SERVICE_AREA_PREFIX: "SERVICE_AREA#",
  CLOCK_EVENT_PREFIX: "CLOCK_EVENT#",
  SUBSCRIPTION_PREFIX: "SUBSCRIPTION#",
  RATE_BATCH_PREFIX: "RATE_BATCH#",
  CANCELLATION_BATCH_PREFIX: "CANCELLATION_BATCH#",
  PAYMENT_METHOD_PREFIX: "PAYMENT_METHOD#",
  PAYMENT_METHOD_GROUP_PREFIX: "PAYMENT_METHOD_GROUP#",
  OTP_PREFIX: "OTP#",
  /**
   * Short link, keyed by its code (RUT-3112). Global, NOT org-scoped: the
   * redirect resolves a bare code with no idea which org minted it.
   * These records are permanent — a link texted today lives in the customer's
   * message history forever, so they carry no TTL.
   */
  SHORT_LINK_PREFIX: "SHORTLINK#",
  /** Reverse index: destination → existing code, so the same link reuses one code. */
  SHORT_LINK_TARGET_PREFIX: "SHORTLINK_TARGET#",
  MEMBER_LOCATION_PREFIX: "MEMBER_LOCATION#",
  /** Legacy one-item-per-ping trail record. Nothing writes this shape after RUT-2838; existing rows age out on their 90-day TTL. */
  TIMESTAMP_PREFIX: "TIMESTAMP#",
  /** One item per LOCATION_SEGMENT_WINDOW_MS of a member's trail (RUT-2838). Sorts BEFORE TIMESTAMP# — every query over this partition must be prefix-scoped. */
  LOCATION_SEGMENT_PREFIX: "SEG#",
  MESSAGE_PREFIX: "MESSAGE#",
  SCHEDULED_MESSAGE_PREFIX: "SCHEDULED_MESSAGE#",
  CREW_MESSAGE_PREFIX: "CREW_MESSAGE#",
  ACK_PREFIX: "ACK#",
  CONVERSATION_PREFIX: "CONVERSATION#",
  REVENUE_PREFIX: "REVENUE#",
  INTEGRATION_USAGE_PREFIX: "INTEGRATION_USAGE#",
  CONTACT_PREFIX: "CONTACT#",
  LEDGER_PREFIX: "LEDGER#",
  LEDGER_ENTRY_PREFIX: "LEDGER_ENTRY#",
  ANALYTICS_PREFIX: "ANALYTICS#",
  NOTE_READ_PREFIX: "NOTEREAD#",
  PRIORITY_REMINDER_PREFIX: "PRIORITY_REMINDER#",
  PHOTO_PURGE_PREFIX: "PHOTO_PURGE",
  PHOTO_PREFIX: "PHOTO#",
  NOTIFICATION_PREFIX: "NOTIFICATION#",
  PARCEL_MEASUREMENT_PREFIX: "PARCEL_MEASUREMENT#",
  IMPORT_JOB_PREFIX: "IMPORT_JOB#",
  AI_IMPORT_JOB_PREFIX: "AI_IMPORT_JOB#",
  MESSAGE_CAMPAIGN_PREFIX: "MESSAGE_CAMPAIGN#",
  MESSAGE_CAMPAIGN_SCHEDULE_PREFIX: "MESSAGE_CAMPAIGN_SCHEDULE#",
  MESSAGE_DELIVERY_PREFIX: "MESSAGE_DELIVERY#",
  MESSAGE_TEMPLATE_PREFIX: "MESSAGE_TEMPLATE#",
  DELIVERY_PREFIX: "DELIVERY#",
  GEOFENCE_EVENT_PREFIX: "GEOFENCE_EVENT#",
  DISPOSAL_PILE_PREFIX: "DISPOSAL_PILE#",
  DISPOSAL_DATE_PREFIX: "DISPOSAL_DATE#",
  DISPATCH_JOB_PREFIX: "DISPATCH_JOB#",
  DISPATCH_BATCH_PREFIX: "DISPATCH_BATCH#",
  CHAT_CONVO_PREFIX: "CHAT_CONVO#",
  CHAT_MSG_PREFIX: "CHAT_MSG#",
  CHAT_USER_PREFIX: "CHAT_USER#",
  CHAT_MEMBERSHIP_PREFIX: "CHAT_MEMBERSHIP#",
  LAST_MSG_PREFIX: "LAST_MSG#",
  SCHEDULED_CANCELLATION_PREFIX: "SCHEDULED_CANCELLATION#",
  SCHEDULED_ACTIVATION_PREFIX: "SCHEDULED_ACTIVATION#",
  SCHEDULED_DISCOUNT_EXPIRATION_PREFIX: "SCHEDULED_DISCOUNT_EXPIRATION#",
  SCHEDULED_RATE_RESURFACE_PREFIX: "SCHEDULED_RATE_RESURFACE#",
  /** SK: RATE_REQUEST_DIGEST#<customerId> — one held acknowledgment per customer (RUT-3372). */
  RATE_REQUEST_DIGEST_PREFIX: "RATE_REQUEST_DIGEST#",
  SUBCONTRACTOR_COMPANY_PREFIX: "SUBCONTRACTOR_COMPANY#",
  /** SK: SUBCONTRACTOR_DAY_PAYMENT#<companyId>#YYYY-MM-DD — paid marker for one work day. */
  SUBCONTRACTOR_DAY_PAYMENT_PREFIX: "SUBCONTRACTOR_DAY_PAYMENT#",
  WEATHER_ALERT_PREFIX: "WEATHER_ALERT#",
  PICKLIST_ITEM_PREFIX: "PICKLIST_ITEM#",
  NOTIFICATION_TEMPLATE_PREFIX: "NOTIFICATION_TEMPLATE#",
  SERVICE_BUNDLE_PREFIX: "SERVICE_BUNDLE#",
  // Append-only customer-child history records (nested under the customer item,
  // mirroring the LEDGER#/SUBSCRIPTION# nesting: SK = CUSTOMER#<id>#<PREFIX><ts>).
  TERMS_ACCEPTANCE_PREFIX: "TERMS_ACCEPTANCE#",
  PORTAL_LOGIN_PREFIX: "PORTAL_LOGIN#",
  PAYMENT_PLAN_PREFIX: "PAYMENT_PLAN#",
  /** Org-level Ruta platform subscription invoices (SK under ORG#). */
  PLATFORM_INVOICE_PREFIX: "PLATFORM_INVOICE#",
  /**
   * Platform-level settings a platform operator edits from admin insights.
   * Global, NOT org-scoped: one value governs every organization.
   */
  PLATFORM_SETTINGS_PREFIX: "PLATFORM_SETTINGS#",
  /**
   * Cached public holiday calendar. Global, NOT org-scoped: the federal holiday
   * calendar is the same for every org, so it is fetched once and shared.
   * One item per country-year (PK = SK = HOLIDAY#US#2026) holding the whole
   * calendar as a list, so a save is a single atomic put.
   */
  HOLIDAY_PREFIX: "HOLIDAY#",
  /** SK: AGENT_DRAFT#{draftId} — Shop Advisor draft the office accepts (RUT-3751). */
  AGENT_DRAFT_PREFIX: "AGENT_DRAFT#",
  /** SK: AGENT_RUN_LOG#{runId} — what a Shop Advisor saw, drafted, who acted. */
  AGENT_RUN_LOG_PREFIX: "AGENT_RUN_LOG#",
  /**
   * One watch per filed in-app report (RUT-3900). Global, not org-scoped:
   * the Linear webhook arrives with the issue identifier and no org id.
   * PK = FEEDBACKWATCH#RUT-3900, SK = WATCH.
   */
  FEEDBACK_WATCH_PREFIX: "FEEDBACKWATCH#",
  FEEDBACK_WATCH_SK: "WATCH",
  /**
   * Partial shop signup (RUT-4518). Global rather than org-scoped — there is
   * no company yet, and Lead Desk must still see the email if they never
   * confirm. PK = SK = SIGNUP_DRAFT#{id}.
   */
  SIGNUP_DRAFT_PREFIX: "SIGNUP_DRAFT#",
  /** GSI1: email → draft. Public POST never resumes by email; the index is for Lead Desk. */
  SIGNUP_DRAFT_EMAIL_PREFIX: "SIGNUP_DRAFT_EMAIL#",
  /** Per-IP write window for the public draft endpoint. */
  SIGNUP_DRAFT_RATE_PREFIX: "SIGNUP_DRAFT_RATE#",
  SIGNUP_DRAFT_RATE_SK: "WINDOW",
  /**
   * The AI import's shared reading recipes (book engine DESIGN.md §6.6). Global, NOT org-scoped:
   * one export layout reads the same for every shop. PK = IMPORT_LAYOUT#{fingerprint};
   * SK = RECIPE#v{schemaVersion} (current) or RECIPE#v{schemaVersion}#r{revision} (history).
   */
  IMPORT_LAYOUT_PREFIX: "IMPORT_LAYOUT#",
  IMPORT_LAYOUT_RECIPE_PREFIX: "RECIPE#",
  /** PK = IMPORT_LAYOUT_FAMILY#{familyKey}, SK = FP#{fingerprint}: layouts sharing a header set. */
  IMPORT_LAYOUT_FAMILY_PREFIX: "IMPORT_LAYOUT_FAMILY#",
  IMPORT_LAYOUT_FINGERPRINT_PREFIX: "FP#",
  /** GSI1 partition listing every current recipe (status#updatedAt#fingerprint) for the recipes CLI. */
  IMPORT_LAYOUT_RECIPES_INDEX: "IMPORT_LAYOUT_RECIPES",
  // GSI patterns
  ORG_CLOCK_EVENTS_PREFIX: "ORG_CLOCK_EVENTS#",
  CUSTOMER_STATUS_PREFIX: "CUSTOMER_STATUS#",
  RATE_REQUEST_STATUS_PREFIX: "RATE_REQUEST_STATUS#",
  CUSTOMER_ADDRESS_PREFIX: "CUSTOMER_ADDRESS#",
  CUSTOMER_PHONE_PREFIX: "CUSTOMER_PHONE#",
  ORG_MEMBER_PHONE_PREFIX: "ORG_MEMBER_PHONE#",
  INVITE_TOKEN_PREFIX: "INVITE_TOKEN#",
  ROLE_PREFIX: "ROLE#",
  STATUS_PREFIX: "STATUS#",
  CLOCK_SESSION_PREFIX: "CLOCK_SESSION#",
  CREW_MEMBER_PREFIX: "CREW_MEMBER#",
  SUBSCRIPTION_STATE_PREFIX: "SUBSCRIPTION_STATE#",
  CUSTOMER_MAPPING_PREFIX: "CUSTOMER_MAPPING",
  // Messaging patterns
  MESSAGES_PREFIX: "MESSAGES#",
  // For GSI queries
  MESSAGE_SENDER_PREFIX: "MESSAGE_SENDER#",
  CREATED_AT_PREFIX: "CREATED_AT#",
  ACK_AT_PREFIX: "ACK_AT#",
  // Special patterns
  USER_PREFIX: "USER#",
  CODE_PREFIX: "CODE#",
  OTP_SEND_LIMIT: "SEND_LIMIT",
  OTP_VERIFY_LIMIT: "VERIFY_LIMIT",
  METADATA_PREFIX: "METADATA#",
  AI_CONVO_PREFIX: "AI_CONVO#"
};
var CUSTOMER_METRIC_TYPES = {
  ROCK: "rock",
  WOOD_MULCH: "wood_mulch",
  TURF: "turf"
};

// src/storage/keys/builders.ts
var DDB_KEY_BUILDERS = {
  inboundEmailReceiptSK: (deliveryId) => `${DDB_KEY_PATTERNS.INBOUND_EMAIL_RECEIPT_PREFIX}${deliveryId}`,
  // Primary keys
  orgPK: (orgId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}`,
  customerPK: (customerId) => `${DDB_KEY_PATTERNS.CUSTOMER_PREFIX}${customerId}`,
  otpPK: (phoneNumber) => `${DDB_KEY_PATTERNS.OTP_PREFIX}${phoneNumber}`,
  /**
   * Short link by code (RUT-3112). The redirect receives only a code, so this
   * partition is global rather than nested under an org.
   */
  shortLinkPK: (code) => `${DDB_KEY_PATTERNS.SHORT_LINK_PREFIX}${code}`,
  shortLinkSK: (code) => `${DDB_KEY_PATTERNS.SHORT_LINK_PREFIX}${code}`,
  /**
   * Cached holiday calendar for one country-year. Global rather than org-scoped
   * — every org in a country observes the same federal holidays. The whole
   * year is one item (SK mirrors the PK, as with short links), so a save is a
   * single atomic put and a year can never be half-written.
   */
  holidayPK: (country, year) => `${DDB_KEY_PATTERNS.HOLIDAY_PREFIX}${country}#${year}`,
  holidaySK: (country, year) => `${DDB_KEY_PATTERNS.HOLIDAY_PREFIX}${country}#${year}`,
  /**
   * One platform-level setting, keyed by name. Global rather than org-scoped —
   * these govern the whole platform, so there is exactly one item per name and
   * a save is a single atomic put (SK mirrors the PK, as with short links).
   */
  platformSettingsPK: (name) => `${DDB_KEY_PATTERNS.PLATFORM_SETTINGS_PREFIX}${name}`,
  platformSettingsSK: (name) => `${DDB_KEY_PATTERNS.PLATFORM_SETTINGS_PREFIX}${name}`,
  /**
   * The AI import's shared reading recipe for one file layout (book engine DESIGN.md §6.6). Global,
   * like platform settings: a layout reads the same for every shop. The current revision sits at
   * RECIPE#v{schemaVersion}; every revision is kept at RECIPE#v{schemaVersion}#r{revision}, zero-padded
   * so revisions sort in order. A schema version bump changes the sort key, so old recipes miss.
   */
  importLayoutPK: (fingerprint) => `${DDB_KEY_PATTERNS.IMPORT_LAYOUT_PREFIX}${fingerprint}`,
  importLayoutRecipeSK: (schemaVersion) => `${DDB_KEY_PATTERNS.IMPORT_LAYOUT_RECIPE_PREFIX}v${schemaVersion}`,
  importLayoutRevisionSK: (schemaVersion, revision) => `${DDB_KEY_PATTERNS.IMPORT_LAYOUT_RECIPE_PREFIX}v${schemaVersion}#r${String(revision).padStart(6, "0")}`,
  importLayoutRevisionSKPrefix: (schemaVersion) => `${DDB_KEY_PATTERNS.IMPORT_LAYOUT_RECIPE_PREFIX}v${schemaVersion}#r`,
  /** Layouts sharing one header set (any column order): PK by family key, one pointer per fingerprint. */
  importLayoutFamilyPK: (familyKey) => `${DDB_KEY_PATTERNS.IMPORT_LAYOUT_FAMILY_PREFIX}${familyKey}`,
  importLayoutFamilySK: (fingerprint) => `${DDB_KEY_PATTERNS.IMPORT_LAYOUT_FINGERPRINT_PREFIX}${fingerprint}`,
  /** GSI1 over every current recipe, newest first within a status — what the recipes CLI lists. */
  importLayoutRecipesGSI1PK: () => DDB_KEY_PATTERNS.IMPORT_LAYOUT_RECIPES_INDEX,
  importLayoutRecipesGSI1SK: (status, updatedAt, fingerprint) => `${status}#${updatedAt}#${fingerprint}`,
  /**
   * Reverse index keyed by org + a hash of the destination, so re-sending the
   * same link reuses its existing code instead of minting a new record per text.
   */
  shortLinkTargetPK: (orgId, targetHash) => `${DDB_KEY_PATTERNS.SHORT_LINK_TARGET_PREFIX}${orgId}#${targetHash}`,
  shortLinkTargetSK: (orgId, targetHash) => `${DDB_KEY_PATTERNS.SHORT_LINK_TARGET_PREFIX}${orgId}#${targetHash}`,
  // Sort keys
  serviceTemplateSK: (templateId) => `${DDB_KEY_PATTERNS.SERVICE_TEMPLATE_PREFIX}${templateId}`,
  customerSK: (customerId) => `${DDB_KEY_PATTERNS.CUSTOMER_PREFIX}${customerId}`,
  customerAccountSK: (id) => `${DDB_KEY_PATTERNS.CUSTOMER_ACCOUNT_PREFIX}${id}`,
  customerAccountMembershipSK: (customerId) => `${DDB_KEY_PATTERNS.ACCOUNT_PROPERTY_PREFIX}${customerId}`,
  /** Account-to-property link; lets an account list its properties without a scan. */
  customerAccountMemberSK: (accountId, customerId) => `${DDB_KEY_PATTERNS.ACCOUNT_MEMBER_PREFIX}${accountId}#${customerId}`,
  customerAccountMemberPrefix: (accountId) => `${DDB_KEY_PATTERNS.ACCOUNT_MEMBER_PREFIX}${accountId}#`,
  rateRequestSK: (requestId) => `${DDB_KEY_PATTERNS.RATE_REQUEST_PREFIX}${requestId}`,
  memberSK: (memberId) => `${DDB_KEY_PATTERNS.MEMBER_PREFIX}${memberId}`,
  crewSK: (crewId) => `${DDB_KEY_PATTERNS.CREW_PREFIX}${crewId}`,
  visitSK: (visitId) => `${DDB_KEY_PATTERNS.VISIT_PREFIX}${visitId}`,
  invoiceSK: (invoiceId) => `${DDB_KEY_PATTERNS.INVOICE_PREFIX}${invoiceId}`,
  serviceAreaSK: (areaId) => `${DDB_KEY_PATTERNS.SERVICE_AREA_PREFIX}${areaId}`,
  rateBatchSK: (batchId) => `${DDB_KEY_PATTERNS.RATE_BATCH_PREFIX}${batchId}`,
  clockEventSK: (eventId) => `${DDB_KEY_PATTERNS.CLOCK_EVENT_PREFIX}${eventId}`,
  subscriptionSK: (customerId, templateId) => `CUSTOMER#${customerId}#${DDB_KEY_PATTERNS.SUBSCRIPTION_PREFIX}${templateId}`,
  paymentMethodSK: (customerId, paymentMethodId) => `CUSTOMER#${customerId}#${DDB_KEY_PATTERNS.PAYMENT_METHOD_PREFIX}${paymentMethodId}`,
  paymentMethodGroupPK: (paymentMethodGroupId) => `${DDB_KEY_PATTERNS.PAYMENT_METHOD_GROUP_PREFIX}${paymentMethodGroupId}`,
  customerMappingSK: () => DDB_KEY_PATTERNS.CUSTOMER_MAPPING_PREFIX,
  codeSK: (timestamp) => `${DDB_KEY_PATTERNS.CODE_PREFIX}${timestamp}`,
  otpSendLimitSK: () => DDB_KEY_PATTERNS.OTP_SEND_LIMIT,
  otpVerifyLimitSK: () => DDB_KEY_PATTERNS.OTP_VERIFY_LIMIT,
  userSK: (userId) => `${DDB_KEY_PATTERNS.USER_PREFIX}${userId}`,
  importJobSK: (importId) => `${DDB_KEY_PATTERNS.IMPORT_JOB_PREFIX}${importId}`,
  // AI import background job: PK: ORG#{orgId}, SK: AI_IMPORT_JOB#{importId}#{kind}
  //
  // The kind is IN the key on purpose. One import has two jobs — reading the files, then writing
  // the org — and each must arrive as its own INSERT for the processor to claim. Two records, one
  // key convention, one stream filter (the AI_IMPORT_JOB# prefix catches both).
  aiImportJobSK: (importId, kind) => `${DDB_KEY_PATTERNS.AI_IMPORT_JOB_PREFIX}${importId}#${kind}`,
  roleSK: (roleId) => `${DDB_KEY_PATTERNS.ROLE_PREFIX}${roleId}`,
  subcontractorCompanySK: (companyId) => `${DDB_KEY_PATTERNS.SUBCONTRACTOR_COMPANY_PREFIX}${companyId}`,
  /**
   * Paid marker for a subcontractor company's work day.
   * SK: SUBCONTRACTOR_DAY_PAYMENT#<companyId>#YYYY-MM-DD
   * Lives outside REVENUE#DAY so revenue rebuilds never erase settlement state.
   */
  subcontractorDayPaymentSK: (companyId, date) => `${DDB_KEY_PATTERNS.SUBCONTRACTOR_DAY_PAYMENT_PREFIX}${companyId}#${date}`,
  /** SK prefix for all day-payment markers for one company. */
  subcontractorDayPaymentCompanyPrefix: (companyId) => `${DDB_KEY_PATTERNS.SUBCONTRACTOR_DAY_PAYMENT_PREFIX}${companyId}#`,
  notificationTemplateSK: (notificationType) => `${DDB_KEY_PATTERNS.NOTIFICATION_TEMPLATE_PREFIX}${notificationType}`,
  // GSI keys
  customerStatusGSI: (orgId, status) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#${DDB_KEY_PATTERNS.CUSTOMER_STATUS_PREFIX}${status}`,
  rateRequestStatusGSI: (orgId, status) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#${DDB_KEY_PATTERNS.RATE_REQUEST_STATUS_PREFIX}${status}`,
  customerAddressGSI: (orgId, normalizedAddress) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#${DDB_KEY_PATTERNS.CUSTOMER_ADDRESS_PREFIX}${normalizedAddress}`,
  customerPhoneGSI: (cleanPhone) => `${DDB_KEY_PATTERNS.CUSTOMER_PHONE_PREFIX}${cleanPhone}`,
  orgMemberPhoneGSI: (cleanPhone) => `${DDB_KEY_PATTERNS.ORG_MEMBER_PHONE_PREFIX}${cleanPhone}`,
  inviteTokenGSI: (token) => `${DDB_KEY_PATTERNS.INVITE_TOKEN_PREFIX}${token}`,
  roleGSI: (orgId, role) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#${DDB_KEY_PATTERNS.ROLE_PREFIX}${role}`,
  statusGSI: (status, timestamp) => `${DDB_KEY_PATTERNS.STATUS_PREFIX}${status}#${timestamp}`,
  clockSessionGSI: (memberId) => `${DDB_KEY_PATTERNS.CLOCK_SESSION_PREFIX}${memberId}`,
  crewMemberGSI: (memberId) => `${DDB_KEY_PATTERNS.CREW_MEMBER_PREFIX}${memberId}`,
  subscriptionStateGSI: (state) => `${DDB_KEY_PATTERNS.SUBSCRIPTION_STATE_PREFIX}${state}`,
  paymentMethodGSI1PK: (customerId) => `${DDB_KEY_PATTERNS.CUSTOMER_PREFIX}${customerId}`,
  paymentMethodGSI1SK: (paymentMethodId) => `${DDB_KEY_PATTERNS.PAYMENT_METHOD_PREFIX}${paymentMethodId}`,
  paymentMethodGSI2SK: (type, createdAt) => `${DDB_KEY_PATTERNS.PAYMENT_METHOD_PREFIX}${type}#${createdAt}`,
  // Additional GSI keys for email and cognitoSub lookups
  customerEmailGSI: (email) => `EMAIL#${email}`,
  memberCognitoSubGSI: (cognitoSub) => `COGNITO#${cognitoSub}`,
  memberEntityTypeStatusGSI: (entityType, status, timestamp) => timestamp ? `${entityType}#${status}#${timestamp}` : `${entityType}#${status}`,
  // Complex patterns
  orgUserPK: (orgId, userId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#${DDB_KEY_PATTERNS.USER_PREFIX}${userId}`,
  orgCrewPK: (orgId, crewId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#${DDB_KEY_PATTERNS.CREW_PREFIX}${crewId}`,
  customerSubscriptionGSI: (customerId, serviceId) => `${DDB_KEY_PATTERNS.CUSTOMER_PREFIX}${customerId}#${DDB_KEY_PATTERNS.SUBSCRIPTION_PREFIX}${serviceId}`,
  // Time event patterns
  timeEventSK: (eventId) => `TIME_EVENT#${eventId}`,
  timeEventGSI: (timestamp) => `TIME_EVENT#${timestamp}`,
  // Clock event org-wide query patterns (GSI3)
  clockEventOrgGSI3PK: (orgId) => `${DDB_KEY_PATTERNS.ORG_CLOCK_EVENTS_PREFIX}${orgId}`,
  clockEventTimestampGSI3SK: (timestamp) => timestamp,
  // Visit-specific GSI keys (Dispatch Queue Model)
  visitCustomerGSI1PK: (orgId, customerId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#${DDB_KEY_PATTERNS.CUSTOMER_PREFIX}${customerId}`,
  // Customer-history sort key. `sortTimestamp` is the visit's terminal
  // timestamp (full ISO) for terminal visits, or createdAt for non-terminal —
  // see getVisitTerminalTimestamp. Querying always uses begins_with('DISPATCHED#').
  visitCustomerGSI1SK: (sortTimestamp, visitId) => `DISPATCHED#${sortTimestamp}#VISIT#${visitId}`,
  visitStatusGSI2PK: (orgId, status) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#${DDB_KEY_PATTERNS.STATUS_PREFIX}${status}`,
  visitCrewGSI3PK: (orgId, crewId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#${DDB_KEY_PATTERNS.CREW_PREFIX}${crewId}`,
  // GSI2 sort keys: pending vs terminal
  visitStatusCrewRankGSI2SK: (crewId, rank) => `CREW#${crewId}#RANK#${rank}`,
  visitStatusCompletionDateGSI2SK: (date, visitId) => `COMPLETION_DATE#${date}#${DDB_KEY_PATTERNS.VISIT_PREFIX}${visitId}`,
  // GSI3 sort keys: queue (pending) vs done (terminal)
  visitCrewQueueGSI3SK: (rank) => `QUEUE#${rank}`,
  visitCrewDoneGSI3SK: (completionDate, visitId) => `DONE#${completionDate}#${DDB_KEY_PATTERNS.VISIT_PREFIX}${visitId}`,
  // GSI4: Completion date billing (sparse, terminal only)
  visitCompletionDateGSI4PK: (orgId, date) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#COMPLETION_DATE#${date}`,
  // Location tracking patterns
  memberLocationPK: (memberId) => `${DDB_KEY_PATTERNS.MEMBER_LOCATION_PREFIX}${memberId}`,
  timestampSK: (timestamp) => `${DDB_KEY_PATTERNS.TIMESTAMP_PREFIX}${timestamp}`,
  locationSegmentSK: (windowStartIso) => `${DDB_KEY_PATTERNS.LOCATION_SEGMENT_PREFIX}${windowStartIso}`,
  // Messaging patterns
  messagePK: (orgId, customerId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#${DDB_KEY_PATTERNS.CUSTOMER_PREFIX}${customerId}`,
  messageSK: (messageId) => `${DDB_KEY_PATTERNS.MESSAGE_PREFIX}${messageId}`,
  conversationSK: (customerId) => `${DDB_KEY_PATTERNS.CONVERSATION_PREFIX}${DDB_KEY_PATTERNS.CUSTOMER_PREFIX}${customerId}`,
  messageGSI1PK: (orgId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#${DDB_KEY_PATTERNS.MESSAGES_PREFIX}`,
  messageGSI1SK: (timestamp) => `${DDB_KEY_PATTERNS.TIMESTAMP_PREFIX}${timestamp}`,
  // Message-specific patterns
  messageConversationId: (orgId, customerId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#${DDB_KEY_PATTERNS.CUSTOMER_PREFIX}${customerId}`,
  // Partition every message of one conversation lives in (table PK, not the GSI1PK).
  conversationPK: (orgId, conversationId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#${DDB_KEY_PATTERNS.CONVERSATION_PREFIX}${conversationId}`,
  messageBeginsWith: () => DDB_KEY_PATTERNS.MESSAGE_PREFIX,
  conversationBeginsWith: () => DDB_KEY_PATTERNS.CONVERSATION_PREFIX,
  // Conversation summary GSI2: time-sorted list
  conversationGSI2PK: (orgId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#CONVERSATIONS`,
  conversationGSI2SK: (lastMessageTime) => `${DDB_KEY_PATTERNS.LAST_MSG_PREFIX}${lastMessageTime}`,
  // Scheduled-message due index (sparse GSI2 on the message record, RUT-2256).
  // A future-dated draft carries these keys until it is delivered or canceled;
  // the 1-minute poller queries GSI2PK = SCHEDULED_MESSAGE#DUE with
  // GSI2SK <= now (ISO) to pick up messages whose send time has arrived. The
  // partition value is distinct from the conversation-summary GSI2 partition,
  // so the two never collide. GSI2SK is the raw ISO scheduledFor so the range
  // comparison sorts chronologically.
  scheduledMessageDueGSI2PK: () => `${DDB_KEY_PATTERNS.SCHEDULED_MESSAGE_PREFIX}DUE`,
  scheduledMessageDueGSI2SK: (scheduledFor) => scheduledFor,
  // Held rate-request acknowledgment (RUT-3372). One record per customer while a
  // hold is open, so a customer clicking through several services in one sitting
  // collapses to a single held acknowledgment rather than one per click. Rides
  // the same sparse GSI2 due index and the same 1-minute poller as the scheduled
  // drafts above, under its own partition value so the two never collide.
  rateRequestDigestSK: (customerId) => `${DDB_KEY_PATTERNS.RATE_REQUEST_DIGEST_PREFIX}${customerId}`,
  rateRequestDigestDueGSI2PK: () => `${DDB_KEY_PATTERNS.RATE_REQUEST_DIGEST_PREFIX}DUE`,
  rateRequestDigestDueGSI2SK: (dueAt) => dueAt,
  // Platform subscription invoices: reverse-chrono under the org partition
  // (SK = PLATFORM_INVOICE#<billedAtISO>#<id> so Query scanIndexForward=false is newest-first).
  platformInvoiceSK: (billedAt, invoiceId) => `${DDB_KEY_PATTERNS.PLATFORM_INVOICE_PREFIX}${billedAt}#${invoiceId}`,
  platformInvoiceSKPrefix: () => DDB_KEY_PATTERNS.PLATFORM_INVOICE_PREFIX,
  // Integration usage aggregation patterns (per-org, per-day vendor call counts)
  integrationUsageDailySK: (date) => `${DDB_KEY_PATTERNS.INTEGRATION_USAGE_PREFIX}DAY#${date}`,
  // Revenue aggregation patterns
  revenueDailySK: (date) => `${DDB_KEY_PATTERNS.REVENUE_PREFIX}DAY#${date}`,
  revenueMonthlySK: (yearMonth) => `${DDB_KEY_PATTERNS.REVENUE_PREFIX}MONTH#${yearMonth}`,
  revenueServiceTemplateDailySK: (serviceTemplateId, date) => `${DDB_KEY_PATTERNS.REVENUE_PREFIX}TEMPLATE#${serviceTemplateId}#DAY#${date}`,
  revenueServiceTemplateMonthlySK: (serviceTemplateId, yearMonth) => `${DDB_KEY_PATTERNS.REVENUE_PREFIX}TEMPLATE#${serviceTemplateId}#MONTH#${yearMonth}`,
  // Analytics aggregation patterns
  analyticsLifecycleSK: (month) => `${DDB_KEY_PATTERNS.ANALYTICS_PREFIX}LIFECYCLE#${month}`,
  analyticsMRRSK: (month) => `${DDB_KEY_PATTERNS.ANALYTICS_PREFIX}MRR#${month}`,
  // Daily performance aggregate (YYYY-MM-DD). Date sorts lexically so a
  // BETWEEN range query returns the days in order.
  analyticsDailyPerformanceSK: (date) => `${DDB_KEY_PATTERNS.ANALYTICS_PREFIX}PERFORMANCE#${date}`,
  // Contact patterns for multi-email support
  // customerId is included in SK to allow same email/phone for multiple customers
  contactEmailSK: (email, customerId) => `${DDB_KEY_PATTERNS.CONTACT_PREFIX}EMAIL#${email}#${DDB_KEY_PATTERNS.CUSTOMER_PREFIX}${customerId}`,
  contactPhoneSK: (phone, customerId) => `${DDB_KEY_PATTERNS.CONTACT_PREFIX}PHONE#${phone}#${DDB_KEY_PATTERNS.CUSTOMER_PREFIX}${customerId}`,
  contactEmailGSI3PK: (email) => `${DDB_KEY_PATTERNS.CONTACT_PREFIX}EMAIL#${email}`,
  contactPhoneGSI3PK: (phone) => `${DDB_KEY_PATTERNS.CONTACT_PREFIX}PHONE#${phone}`,
  contactCustomerGSI3SK: (customerId) => `${DDB_KEY_PATTERNS.CUSTOMER_PREFIX}${customerId}`,
  // Ledger patterns
  ledgerSK: (customerId, timestamp, ulid) => `${DDB_KEY_PATTERNS.CUSTOMER_PREFIX}${customerId}#${DDB_KEY_PATTERNS.LEDGER_PREFIX}${timestamp}#${ulid}`,
  // Base-table SK prefix for all of a customer's ledger entries. More specific
  // than the customer item (`CUSTOMER#{id}`) and the subscription prefix
  // (`CUSTOMER#{id}#SUBSCRIPTION#`), so a begins_with on it returns ledger
  // entries only. Enables a strongly-consistent base-table read (GSI1 can't be
  // read consistently).
  ledgerSKPrefix: (customerId) => `${DDB_KEY_PATTERNS.CUSTOMER_PREFIX}${customerId}#${DDB_KEY_PATTERNS.LEDGER_PREFIX}`,
  ledgerCustomerGSI1PK: (orgId, customerId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#${DDB_KEY_PATTERNS.CUSTOMER_PREFIX}${customerId}`,
  ledgerEntryGSI1SK: (timestamp) => `${DDB_KEY_PATTERNS.LEDGER_ENTRY_PREFIX}${timestamp}`,
  ledgerTypeGSI2SK: (type, timestamp) => `TYPE#${type}#${timestamp}`,
  ledgerVisitGSI3PK: (orgId, visitId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#${DDB_KEY_PATTERNS.VISIT_PREFIX}${visitId}`,
  // Subscription GSI patterns
  subscriptionStatusGSI1PK: (orgId, status) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#${DDB_KEY_PATTERNS.STATUS_PREFIX}${status}`,
  subscriptionTemplateGSI2PK: (orgId, templateId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#TEMPLATE#${templateId}`,
  subscriptionActiveGSI3PK: (orgId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#ACTIVE`,
  /**
   * Active-subscription GSI3 sort key, crew-scoped (RUT-4355).
   * Crewed: `SCHEDULING#scheduled#CREW#{crewId}#{customerId}#{templateId}`
   * Crewless: `SCHEDULING#unscheduled#CREW#none#{customerId}#{templateId}`
   * `findActiveBySchedulingStatus` still uses begins_with(`SCHEDULING#scheduled`)
   * / `SCHEDULING#unscheduled` and does not parse the rest of the key.
   */
  subscriptionSchedulingGSI3SK: (args) => {
    const hasCrew = Boolean(args.assignedCrewId);
    const crewId = hasCrew ? args.assignedCrewId : "none";
    const schedulingStatus = hasCrew ? "scheduled" : "unscheduled";
    return `SCHEDULING#${schedulingStatus}#CREW#${crewId}#${args.customerId}#${args.serviceTemplateId}`;
  },
  /** GSI3 begins_with prefix for one crew's active scheduled stops. */
  subscriptionCrewGSI3SKPrefix: (crewId) => `SCHEDULING#scheduled#CREW#${crewId}#`,
  subscriptionSchedulingStatusGSI3SKPrefix: (schedulingStatus) => `SCHEDULING#${schedulingStatus}`,
  /**
   * Per-org marker written last by the GSI3 crew-key backfill. Until this
   * item exists, `listAllForCrew` (active) keeps the org-wide CUSTOMER# query.
   */
  subscriptionGsi3CrewBackfillSK: () => `${DDB_KEY_PATTERNS.METADATA_PREFIX}SUBSCRIPTION_GSI3_CREW_KEY`,
  // Query prefix patterns
  subscriptionSKPrefix: (customerId) => `${DDB_KEY_PATTERNS.CUSTOMER_PREFIX}${customerId}#${DDB_KEY_PATTERNS.SUBSCRIPTION_PREFIX}`,
  // Note read patterns
  noteReadPK: (orgId, userId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#${DDB_KEY_PATTERNS.USER_PREFIX}${userId}`,
  noteReadSK: (noteId) => `${DDB_KEY_PATTERNS.NOTE_READ_PREFIX}${noteId}`,
  noteReadVisitGSI1PK: (orgId, visitId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#${DDB_KEY_PATTERNS.VISIT_PREFIX}${visitId}`,
  noteReadSubscriptionGSI1PK: (orgId, subscriptionId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#SUB#${subscriptionId}`,
  noteReadUserGSI1SK: (userId) => `${DDB_KEY_PATTERNS.USER_PREFIX}${userId}`,
  // Priority reminder pointer PK — groups an org's reminders due on a local date
  // (sparse same-table date index).
  priorityReminderPK: (orgId, remindOn) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#${DDB_KEY_PATTERNS.PRIORITY_REMINDER_PREFIX}${remindOn}`,
  // Soft-deleted photo purge pointer (RUT-2714). One partition per org, SK
  // sorted by the ISO purge instant so the daily cron range-queries SK <= now.
  photoPurgePK: (orgId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#${DDB_KEY_PATTERNS.PHOTO_PURGE_PREFIX}`,
  photoPurgeSK: (purgeAt, visitId, photoId) => `${purgeAt}#${DDB_KEY_PATTERNS.VISIT_PREFIX}${visitId}#${DDB_KEY_PATTERNS.PHOTO_PREFIX}${photoId}`,
  // Crew message patterns
  crewMessagePK: (orgId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}`,
  crewMessageSK: (messageId) => `${DDB_KEY_PATTERNS.CREW_MESSAGE_PREFIX}${messageId}`,
  crewMessageSenderGSI1PK: (orgId, senderId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#${DDB_KEY_PATTERNS.MESSAGE_SENDER_PREFIX}${senderId}`,
  crewMessageCreatedAtGSI1SK: (timestamp) => `${DDB_KEY_PATTERNS.CREATED_AT_PREFIX}${timestamp}`,
  crewMessageCrewGSI2PK: (orgId, crewId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#${DDB_KEY_PATTERNS.CREW_PREFIX}${crewId}`,
  crewMessageCreatedAtGSI2SK: (timestamp) => `${DDB_KEY_PATTERNS.CREATED_AT_PREFIX}${timestamp}`,
  // Message acknowledgment patterns
  messageAckPK: (messageId) => `${DDB_KEY_PATTERNS.MESSAGE_PREFIX}${messageId}`,
  messageAckSK: (userId) => `${DDB_KEY_PATTERNS.ACK_PREFIX}${userId}`,
  messageAckUserGSI1PK: (orgId, userId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#${DDB_KEY_PATTERNS.USER_PREFIX}${userId}`,
  messageAckAtGSI1SK: (timestamp) => `${DDB_KEY_PATTERNS.ACK_AT_PREFIX}${timestamp}`,
  // Parcel measurement patterns
  parcelMeasurementSK: (measurementId) => `${DDB_KEY_PATTERNS.PARCEL_MEASUREMENT_PREFIX}${measurementId}`,
  parcelMeasurementCustomerGSI1PK: (customerId) => `${DDB_KEY_PATTERNS.CUSTOMER_PREFIX}${customerId}`,
  parcelMeasurementGSI1SK: (measurementId) => `${DDB_KEY_PATTERNS.PARCEL_MEASUREMENT_PREFIX}${measurementId}`,
  // Message campaign patterns
  messageCampaignSK: (campaignId) => `${DDB_KEY_PATTERNS.MESSAGE_CAMPAIGN_PREFIX}${campaignId}`,
  messageCampaignStatusGSI1PK: (status) => `${DDB_KEY_PATTERNS.MESSAGE_CAMPAIGN_PREFIX}STATUS#${status}`,
  messageCampaignOrgGSI2PK: (orgId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#MESSAGE_CAMPAIGNS`,
  // Repeating campaign (schedule) patterns — RUT-1394
  messageCampaignScheduleSK: (scheduleId) => `${DDB_KEY_PATTERNS.MESSAGE_CAMPAIGN_SCHEDULE_PREFIX}${scheduleId}`,
  /** Sparse: only ACTIVE schedules carry this, so the runner cannot see a paused one. */
  messageCampaignScheduleDueGSI1PK: () => `${DDB_KEY_PATTERNS.MESSAGE_CAMPAIGN_SCHEDULE_PREFIX}DUE`,
  messageCampaignScheduleOrgGSI2PK: (orgId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#MESSAGE_CAMPAIGN_SCHEDULES`,
  // Message template patterns
  messageTemplateSK: (templateId) => `${DDB_KEY_PATTERNS.MESSAGE_TEMPLATE_PREFIX}${templateId}`,
  messageTemplateOrgGSI2PK: (orgId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#MESSAGE_TEMPLATES`,
  // Message delivery patterns
  messageDeliveryPK: (campaignId) => `${DDB_KEY_PATTERNS.MESSAGE_CAMPAIGN_PREFIX}${campaignId}`,
  messageDeliverySK: (deliveryId) => `${DDB_KEY_PATTERNS.DELIVERY_PREFIX}${deliveryId}`,
  messageDeliveryPendingGSI1PK: () => `${DDB_KEY_PATTERNS.MESSAGE_DELIVERY_PREFIX}PENDING`,
  messageDeliveryOrgCampaignGSI2PK: (orgId, campaignId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#CAMPAIGN#${campaignId}#DELIVERIES`,
  messageDeliveryStatusGSI2SK: (status, createdAt) => `STATUS#${status}#${createdAt}`,
  // Geofence event patterns (audit trail for crew enter/exit parcel boundaries)
  geofenceEventPK: (visitId) => `${DDB_KEY_PATTERNS.VISIT_PREFIX}${visitId}`,
  geofenceEventSK: (timestamp, memberId) => `${DDB_KEY_PATTERNS.GEOFENCE_EVENT_PREFIX}${timestamp}#${memberId}`,
  // Disposal pile patterns
  disposalPileSK: (pileId) => `${DDB_KEY_PATTERNS.DISPOSAL_PILE_PREFIX}${pileId}`,
  disposalPileCrewGSI3PK: (orgId, crewId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#${DDB_KEY_PATTERNS.CREW_PREFIX}${crewId}`,
  disposalPileDateGSI3SK: (date, pileId) => `${DDB_KEY_PATTERNS.DISPOSAL_DATE_PREFIX}${date}#${DDB_KEY_PATTERNS.DISPOSAL_PILE_PREFIX}${pileId}`,
  // Dispatch job patterns
  // Job by ID: PK: ORG#{orgId}, SK: DISPATCH_JOB#{jobId}
  dispatchJobSK: (jobId) => `${DDB_KEY_PATTERNS.DISPATCH_JOB_PREFIX}${jobId}`,
  // Batch by ID: PK: DISPATCH_JOB#{jobId}, SK: DISPATCH_BATCH#{batchId}
  dispatchBatchPK: (jobId) => `${DDB_KEY_PATTERNS.DISPATCH_JOB_PREFIX}${jobId}`,
  dispatchBatchSK: (batchId) => `${DDB_KEY_PATTERNS.DISPATCH_BATCH_PREFIX}${batchId}`,
  // Dispatch job GSI2: Active-dispatch sparse index (only jobs still working visits)
  // PK groups all active jobs per org; SK sorts newest-first by createdAt.
  dispatchJobActiveGSI2PK: (orgId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#ACTIVE_DISPATCH`,
  dispatchJobActiveGSI2SK: (createdAt, jobId) => `${createdAt}#${jobId}`,
  // Visit GSI5: Dispatch job queries (sparse - only visits created by dispatch)
  visitDispatchJobGSI5PK: (orgId, dispatchJobId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#${DDB_KEY_PATTERNS.DISPATCH_JOB_PREFIX}${dispatchJobId}`,
  // Chat conversation patterns
  chatConvoSK: (conversationId) => `${DDB_KEY_PATTERNS.CHAT_CONVO_PREFIX}${conversationId}`,
  // Chat message patterns
  chatMsgPK: (conversationId) => `${DDB_KEY_PATTERNS.CHAT_CONVO_PREFIX}${conversationId}`,
  chatMsgSK: (messageId) => `${DDB_KEY_PATTERNS.CHAT_MSG_PREFIX}${messageId}`,
  // Chat membership patterns (per-user conversation list)
  chatMembershipPK: (orgId, userId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#${DDB_KEY_PATTERNS.CHAT_USER_PREFIX}${userId}`,
  chatMembershipSK: (conversationId) => `${DDB_KEY_PATTERNS.CHAT_MEMBERSHIP_PREFIX}${conversationId}`,
  chatMembershipGSI1PK: (orgId, userId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#${DDB_KEY_PATTERNS.CHAT_USER_PREFIX}${userId}#CHATS`,
  chatMembershipGSI1SK: (lastMessageAt) => `${DDB_KEY_PATTERNS.LAST_MSG_PREFIX}${lastMessageAt}`,
  // Chat message acknowledgment patterns
  chatMsgAckPK: (messageId) => `${DDB_KEY_PATTERNS.CHAT_MSG_PREFIX}${messageId}`,
  chatMsgAckSK: (userId) => `${DDB_KEY_PATTERNS.ACK_PREFIX}${userId}`,
  // Scheduled cancellation TTL patterns. Date-suffixed so a reschedule can
  // retire every earlier record for the same subscription (RUT-4058).
  scheduledCancellationSK: (subscriptionId, cancellationDate) => `${DDB_KEY_PATTERNS.SCHEDULED_CANCELLATION_PREFIX}${subscriptionId}#${cancellationDate}`,
  scheduledCancellationSKPrefix: (subscriptionId) => `${DDB_KEY_PATTERNS.SCHEDULED_CANCELLATION_PREFIX}${subscriptionId}#`,
  /** Pre-date-suffix shape. Query prefix that also matches this legacy SK. */
  scheduledCancellationQueryPrefix: (subscriptionId) => `${DDB_KEY_PATTERNS.SCHEDULED_CANCELLATION_PREFIX}${subscriptionId}`,
  // Scheduled activation (deferred start) TTL patterns. Date-suffixed, the
  // mirror of scheduled cancellation: a moved or cleared start retires every
  // record for the subscription so an old one cannot go live (RUT-4066).
  scheduledActivationSK: (subscriptionId, startDate) => `${DDB_KEY_PATTERNS.SCHEDULED_ACTIVATION_PREFIX}${subscriptionId}#${startDate}`,
  scheduledActivationSKPrefix: (subscriptionId) => `${DDB_KEY_PATTERNS.SCHEDULED_ACTIVATION_PREFIX}${subscriptionId}#`,
  // Scheduled discount expiration TTL patterns
  scheduledDiscountExpirationSK: (subscriptionId) => `${DDB_KEY_PATTERNS.SCHEDULED_DISCOUNT_EXPIRATION_PREFIX}${subscriptionId}`,
  // Scheduled rate-request resurface TTL patterns (RUT-2698).
  // Keyed by subscription only, so re-snoozing overwrites (replaces) the
  // pending reminder instead of stacking a second one.
  scheduledRateResurfaceSK: (subscriptionId) => `${DDB_KEY_PATTERNS.SCHEDULED_RATE_RESURFACE_PREFIX}${subscriptionId}`,
  // Weather alert patterns
  weatherAlertSK: (serviceAreaId) => `${DDB_KEY_PATTERNS.WEATHER_ALERT_PREFIX}${serviceAreaId}`,
  // Picklist item patterns
  picklistItemSK: (itemId) => `${DDB_KEY_PATTERNS.PICKLIST_ITEM_PREFIX}${itemId}`,
  // Service bundle patterns: PK: ORG#{orgId}, SK: SERVICE_BUNDLE#{bundleId}
  serviceBundleSK: (bundleId) => `${DDB_KEY_PATTERNS.SERVICE_BUNDLE_PREFIX}${bundleId}`,
  // Append-only customer history records. PK: ORG#{orgId}.
  // SK nests under the customer item so a begins_with returns only these rows,
  // and the ISO timestamp keeps them chronologically sorted.
  termsAcceptanceSK: (customerId, timestamp) => `${DDB_KEY_PATTERNS.CUSTOMER_PREFIX}${customerId}#${DDB_KEY_PATTERNS.TERMS_ACCEPTANCE_PREFIX}${timestamp}`,
  termsAcceptanceSKPrefix: (customerId) => `${DDB_KEY_PATTERNS.CUSTOMER_PREFIX}${customerId}#${DDB_KEY_PATTERNS.TERMS_ACCEPTANCE_PREFIX}`,
  portalLoginSK: (customerId, timestamp) => `${DDB_KEY_PATTERNS.CUSTOMER_PREFIX}${customerId}#${DDB_KEY_PATTERNS.PORTAL_LOGIN_PREFIX}${timestamp}`,
  portalLoginSKPrefix: (customerId) => `${DDB_KEY_PATTERNS.CUSTOMER_PREFIX}${customerId}#${DDB_KEY_PATTERNS.PORTAL_LOGIN_PREFIX}`,
  // Payment plan patterns: PK: ORG#{orgId}, SK: CUSTOMER#{customerId}#PAYMENT_PLAN#{planId}
  paymentPlanSK: (customerId, planId) => `${DDB_KEY_PATTERNS.CUSTOMER_PREFIX}${customerId}#${DDB_KEY_PATTERNS.PAYMENT_PLAN_PREFIX}${planId}`,
  paymentPlanSKPrefix: (customerId) => `${DDB_KEY_PATTERNS.CUSTOMER_PREFIX}${customerId}#${DDB_KEY_PATTERNS.PAYMENT_PLAN_PREFIX}`,
  // AI conversation patterns (per org-member, sorted by creation time)
  // PK: ORG#{orgId}#USER#{userId}  SK: AI_CONVO#{id}
  aiConvoPK: (orgId, userId) => `${DDB_KEY_PATTERNS.ORG_PREFIX}${orgId}#${DDB_KEY_PATTERNS.USER_PREFIX}${userId}`,
  aiConvoSK: (conversationId) => `${DDB_KEY_PATTERNS.AI_CONVO_PREFIX}${conversationId}`,
  aiConvoSKPrefix: () => DDB_KEY_PATTERNS.AI_CONVO_PREFIX,
  // Shop Advisor rails (RUT-3751). PK: ORG#{orgId}.
  agentDraftSK: (draftId) => `${DDB_KEY_PATTERNS.AGENT_DRAFT_PREFIX}${draftId}`,
  agentRunLogSK: (runId) => `${DDB_KEY_PATTERNS.AGENT_RUN_LOG_PREFIX}${runId}`,
  /**
   * In-app report watch (RUT-3900). Global partition keyed by Linear
   * identifier so a Linear webhook can look the reporter up without an org.
   */
  feedbackWatchPK: (issueIdentifier) => `${DDB_KEY_PATTERNS.FEEDBACK_WATCH_PREFIX}${issueIdentifier.trim().toUpperCase()}`,
  feedbackWatchSK: () => DDB_KEY_PATTERNS.FEEDBACK_WATCH_SK,
  /**
   * Partial shop signup (RUT-4518). Global — no org exists yet. SK mirrors PK
   * so a save is a single atomic put, as with short links.
   */
  signupDraftPK: (draftId) => `${DDB_KEY_PATTERNS.SIGNUP_DRAFT_PREFIX}${draftId}`,
  signupDraftSK: (draftId) => `${DDB_KEY_PATTERNS.SIGNUP_DRAFT_PREFIX}${draftId}`,
  signupDraftEmailGSI1PK: (email) => `${DDB_KEY_PATTERNS.SIGNUP_DRAFT_EMAIL_PREFIX}${email.trim().toLowerCase()}`,
  signupDraftEmailGSI1SK: (draftId) => `${DDB_KEY_PATTERNS.SIGNUP_DRAFT_PREFIX}${draftId}`,
  signupDraftRatePK: (ip) => `${DDB_KEY_PATTERNS.SIGNUP_DRAFT_RATE_PREFIX}${ip}`,
  signupDraftRateSK: () => DDB_KEY_PATTERNS.SIGNUP_DRAFT_RATE_SK
};

// src/utils/address.ts
function formatAddressToString(address) {
  if (typeof address === "string") {
    return address;
  }
  if (address && typeof address === "object") {
    const parts = [];
    if (address.street1) parts.push(address.street1);
    if (address.street2) parts.push(address.street2);
    if (address.street) parts.push(address.street);
    const cityStateZip = [];
    if (address.city) cityStateZip.push(address.city);
    if (address.state) cityStateZip.push(address.state);
    if (address.postalCode) cityStateZip.push(address.postalCode);
    if (address.zip) cityStateZip.push(address.zip);
    if (cityStateZip.length > 0) {
      parts.push(cityStateZip.join(" "));
    }
    const result = parts.join(", ");
    if (result && !result.includes("undefined")) {
      return result;
    }
  }
  return "";
}
function isValidAddressString(address) {
  return typeof address === "string" && address.trim().length > 0 && !address.includes("undefined");
}
function formatAddressForDisplay(address) {
  if (!address) return null;
  const stateAbbreviations = {
    alabama: "AL",
    alaska: "AK",
    arizona: "AZ",
    arkansas: "AR",
    california: "CA",
    colorado: "CO",
    connecticut: "CT",
    delaware: "DE",
    florida: "FL",
    georgia: "GA",
    hawaii: "HI",
    idaho: "ID",
    illinois: "IL",
    indiana: "IN",
    iowa: "IA",
    kansas: "KS",
    kentucky: "KY",
    louisiana: "LA",
    maine: "ME",
    maryland: "MD",
    massachusetts: "MA",
    michigan: "MI",
    minnesota: "MN",
    mississippi: "MS",
    missouri: "MO",
    montana: "MT",
    nebraska: "NE",
    nevada: "NV",
    "new hampshire": "NH",
    "new jersey": "NJ",
    "new mexico": "NM",
    "new york": "NY",
    "north carolina": "NC",
    "north dakota": "ND",
    ohio: "OH",
    oklahoma: "OK",
    oregon: "OR",
    pennsylvania: "PA",
    "rhode island": "RI",
    "south carolina": "SC",
    "south dakota": "SD",
    tennessee: "TN",
    texas: "TX",
    utah: "UT",
    vermont: "VT",
    virginia: "VA",
    washington: "WA",
    "west virginia": "WV",
    wisconsin: "WI",
    wyoming: "WY",
    "district of columbia": "DC"
  };
  if (typeof address === "object") {
    const street = address.street1 || address.street || "";
    const city = address.city || "";
    const state = address.state || "";
    const zip = address.postalCode || address.zip || "";
    if (!street && !city) return null;
    const stateAbbr = stateAbbreviations[state.toLowerCase()] || state;
    const cityStateZipParts = [city, stateAbbr, zip].filter(Boolean);
    return {
      street: street.trim(),
      cityStateZip: cityStateZipParts.join(city && stateAbbr ? ", " : " ").replace(/, (\d)/, " $1"),
      ...city ? { city } : {},
      ...stateAbbr ? { state: stateAbbr } : {},
      ...zip ? { zip } : {}
    };
  }
  if (typeof address === "string") {
    const withoutCountry = address.replace(/,?\s*(United States|USA|US|Canada|CA)$/i, "").trim();
    const parts = withoutCountry.split(",").map((p) => p.trim());
    if (parts.length === 0) return null;
    const street = parts[0];
    const remaining = parts.slice(1);
    if (remaining.length === 0) {
      return { street, cityStateZip: "" };
    }
    let city = "";
    let state = "";
    let zip = "";
    const cityStateZipStr = remaining.join(", ");
    const zipMatch = cityStateZipStr.match(/(\d{5}(-\d{4})?)\s*$/);
    if (zipMatch) {
      zip = zipMatch[1];
    }
    const withoutZip = cityStateZipStr.replace(/,?\s*\d{5}(-\d{4})?\s*$/, "").trim();
    const cityStateParts = withoutZip.split(/,\s*/);
    if (cityStateParts.length >= 2) {
      city = cityStateParts[0];
      state = cityStateParts[1];
    } else if (cityStateParts.length === 1) {
      const lastSpaceMatch = cityStateParts[0].match(/^(.+)\s+(\S+)$/);
      if (lastSpaceMatch && stateAbbreviations[lastSpaceMatch[2].toLowerCase()]) {
        city = lastSpaceMatch[1];
        state = lastSpaceMatch[2];
      } else {
        city = cityStateParts[0];
      }
    }
    const stateAbbr = stateAbbreviations[state.toLowerCase()] || state;
    const cityStateZipParts = [city, stateAbbr, zip].filter(Boolean);
    const cityStateZip = cityStateZipParts.length > 0 ? `${city}${stateAbbr ? `, ${stateAbbr}` : ""}${zip ? ` ${zip}` : ""}` : "";
    return {
      street,
      cityStateZip,
      ...city ? { city } : {},
      ...stateAbbr ? { state: stateAbbr } : {},
      ...zip ? { zip } : {}
    };
  }
  return null;
}
function contactPostalAddress(address, stored) {
  const parts = address ? formatAddressForDisplay(address) : null;
  let street = parts?.street?.trim() || void 0;
  if (street?.includes(",")) {
    street = street.split(",")[0]?.trim() || void 0;
  }
  const city = stored?.city?.trim() || parts?.city || void 0;
  const state = parts?.state || void 0;
  const zip = stored?.zipCode?.trim() || parts?.zip || void 0;
  if (!street && !city && !state && !zip) return void 0;
  return {
    ...street ? { street } : {},
    ...city ? { city } : {},
    ...state ? { state } : {},
    ...zip ? { zip } : {},
    ...state || zip ? { country: "United States" } : {}
  };
}
function formatLocalAddress(address) {
  const parts = formatAddressForDisplay(address);
  if (!parts) return "";
  return [parts.street, parts.cityStateZip].filter(Boolean).join(", ");
}

// src/utils/addressNormalization.ts
var STREET_SUFFIX_MAP = {
  STREET: "ST",
  STR: "ST",
  AVENUE: "AVE",
  AVEN: "AVE",
  AVENU: "AVE",
  AVN: "AVE",
  BOULEVARD: "BLVD",
  BOUL: "BLVD",
  DRIVE: "DR",
  DRIV: "DR",
  DRV: "DR",
  LANE: "LN",
  COURT: "CT",
  CIRCLE: "CIR",
  CIRC: "CIR",
  CIRCL: "CIR",
  CRCL: "CIR",
  CRCLE: "CIR",
  PLACE: "PL",
  ROAD: "RD",
  PARKWAY: "PKWY",
  PARKWY: "PKWY",
  PKWAY: "PKWY",
  PKY: "PKWY",
  TERRACE: "TER",
  TERR: "TER",
  TRAIL: "TRL",
  TRLS: "TRL",
  WAY: "WAY",
  HIGHWAY: "HWY",
  HIWAY: "HWY",
  HIWY: "HWY",
  HWAY: "HWY",
  ALLEY: "ALY",
  ALLY: "ALY",
  ANNEX: "ANX",
  ANEX: "ANX",
  ARCADE: "ARC",
  BAYOU: "BYU",
  BEACH: "BCH",
  BEND: "BND",
  BLUFF: "BLF",
  BLUFFS: "BLFS",
  BOTTOM: "BTM",
  BOTTM: "BTM",
  BRANCH: "BR",
  BRNCH: "BR",
  BRIDGE: "BRG",
  BRDGE: "BRG",
  BROOK: "BRK",
  BROOKS: "BRKS",
  BURG: "BG",
  BURGS: "BGS",
  BYPASS: "BYP",
  BYPA: "BYP",
  BYPAS: "BYP",
  CAMP: "CP",
  CANYON: "CYN",
  CANYN: "CYN",
  CNYN: "CYN",
  CAPE: "CPE",
  CAUSEWAY: "CSWY",
  CAUSWA: "CSWY",
  CENTER: "CTR",
  CENTR: "CTR",
  CENTRE: "CTR",
  CNTER: "CTR",
  CNTR: "CTR",
  CENTERS: "CTRS",
  CLIFF: "CLF",
  CLIFFS: "CLFS",
  CLUB: "CLB",
  COMMON: "CMN",
  COMMONS: "CMNS",
  CORNER: "COR",
  CORNERS: "CORS",
  COURSE: "CRSE",
  COVE: "CV",
  COVES: "CVS",
  CREEK: "CRK",
  CRESCENT: "CRES",
  CREST: "CRST",
  CROSSING: "XING",
  CRSSNG: "XING",
  CROSSROAD: "XRD",
  CROSSROADS: "XRDS",
  CURVE: "CURV",
  DALE: "DL",
  DAM: "DM",
  DIVIDE: "DV",
  ESTATE: "EST",
  ESTATES: "ESTS",
  EXPRESSWAY: "EXPY",
  EXPRESS: "EXPY",
  EXPR: "EXPY",
  EXPW: "EXPY",
  EXTENSION: "EXT",
  EXTN: "EXT",
  EXTNSN: "EXT",
  EXTENSIONS: "EXTS",
  FALL: "FALL",
  FALLS: "FLS",
  FERRY: "FRY",
  FRRY: "FRY",
  FIELD: "FLD",
  FIELDS: "FLDS",
  FLAT: "FLT",
  FLATS: "FLTS",
  FORD: "FRD",
  FORDS: "FRDS",
  FOREST: "FRST",
  FORESTS: "FRST",
  FORGE: "FRG",
  FORGES: "FRGS",
  FORK: "FRK",
  FORKS: "FRKS",
  FORT: "FT",
  FRT: "FT",
  FREEWAY: "FWY",
  FREEWY: "FWY",
  FRWAY: "FWY",
  FRWY: "FWY",
  GARDEN: "GDN",
  GARDN: "GDN",
  GRDEN: "GDN",
  GRDN: "GDN",
  GARDENS: "GDNS",
  GRDNS: "GDNS",
  GATEWAY: "GTWY",
  GATEWY: "GTWY",
  GATWAY: "GTWY",
  GTWAY: "GTWY",
  GLEN: "GLN",
  GLENS: "GLNS",
  GREEN: "GRN",
  GREENS: "GRNS",
  GROVE: "GRV",
  GROVES: "GRVS",
  HARBOR: "HBR",
  HARBR: "HBR",
  HARB: "HBR",
  HRBOR: "HBR",
  HARBORS: "HBRS",
  HAVEN: "HVN",
  HEIGHTS: "HTS",
  HILL: "HL",
  HILLS: "HLS",
  HOLLOW: "HOLW",
  HOLLOWS: "HOLW",
  HOLWS: "HOLW",
  INLET: "INLT",
  ISLAND: "IS",
  ISLND: "IS",
  ISLANDS: "ISS",
  ISLNDS: "ISS",
  ISLE: "ISLE",
  ISLES: "ISLE",
  JUNCTION: "JCT",
  JCTION: "JCT",
  JCTN: "JCT",
  JUNCTN: "JCT",
  JUNCTON: "JCT",
  JUNCTIONS: "JCTS",
  KEY: "KY",
  KEYS: "KYS",
  KNOLL: "KNL",
  KNOL: "KNL",
  KNOLLS: "KNLS",
  LAKE: "LK",
  LAKES: "LKS",
  LAND: "LAND",
  LANDING: "LNDG",
  LNDNG: "LNDG",
  LIGHT: "LGT",
  LIGHTS: "LGTS",
  LOAF: "LF",
  LOCK: "LCK",
  LOCKS: "LCKS",
  LODGE: "LDG",
  LDGE: "LDG",
  LODG: "LDG",
  LOOP: "LOOP",
  LOOPS: "LOOP",
  MALL: "MALL",
  MANOR: "MNR",
  MANORS: "MNRS",
  MEADOW: "MDW",
  MEADOWS: "MDWS",
  MEDOWS: "MDWS",
  MEWS: "MEWS",
  MILL: "ML",
  MILLS: "MLS",
  MISSION: "MSN",
  MISSN: "MSN",
  MSSN: "MSN",
  MOTORWAY: "MTWY",
  MOUNT: "MT",
  MNT: "MT",
  MOUNTAIN: "MTN",
  MNTAIN: "MTN",
  MNTN: "MTN",
  MOUNTIN: "MTN",
  MTIN: "MTN",
  MOUNTAINS: "MTNS",
  MNTNS: "MTNS",
  NECK: "NCK",
  ORCHARD: "ORCH",
  ORCHRD: "ORCH",
  OVAL: "OVAL",
  OVL: "OVAL",
  OVERPASS: "OPAS",
  PARK: "PARK",
  PRK: "PARK",
  PARKS: "PARK",
  PASS: "PASS",
  PASSAGE: "PSGE",
  PATH: "PATH",
  PATHS: "PATH",
  PIKE: "PIKE",
  PIKES: "PIKE",
  PINE: "PNE",
  PINES: "PNES",
  PLAIN: "PLN",
  PLAINS: "PLNS",
  PLAZA: "PLZ",
  PLZA: "PLZ",
  POINT: "PT",
  POINTS: "PTS",
  PORT: "PRT",
  PORTS: "PRTS",
  PRAIRIE: "PR",
  PRR: "PR",
  RADIAL: "RADL",
  RAD: "RADL",
  RADIEL: "RADL",
  RAMP: "RAMP",
  RANCH: "RNCH",
  RANCHES: "RNCH",
  RNCHS: "RNCH",
  RAPID: "RPD",
  RAPIDS: "RPDS",
  REST: "RST",
  RIDGE: "RDG",
  RDGE: "RDG",
  RIDGES: "RDGS",
  RIVER: "RIV",
  RVR: "RIV",
  RIVR: "RIV",
  ROW: "ROW",
  RUE: "RUE",
  RUN: "RUN",
  SHOAL: "SHL",
  SHOALS: "SHLS",
  SHORE: "SHR",
  SHOAR: "SHR",
  SHORES: "SHRS",
  SHOARS: "SHRS",
  SKYWAY: "SKWY",
  SPRING: "SPG",
  SPNG: "SPG",
  SPRNG: "SPG",
  SPRINGS: "SPGS",
  SPNGS: "SPGS",
  SPRNGS: "SPGS",
  SPUR: "SPUR",
  SPURS: "SPUR",
  SQUARE: "SQ",
  SQR: "SQ",
  SQRE: "SQ",
  SQU: "SQ",
  SQUARES: "SQS",
  SQRS: "SQS",
  STATION: "STA",
  STATN: "STA",
  STN: "STA",
  STRAVENUE: "STRA",
  STRAV: "STRA",
  STRAVEN: "STRA",
  STRAVN: "STRA",
  STRVN: "STRA",
  STRVNUE: "STRA",
  STREAM: "STRM",
  STREME: "STRM",
  SUMMIT: "SMT",
  SUMIT: "SMT",
  SUMITT: "SMT",
  THROUGHWAY: "TRWY",
  TRACE: "TRCE",
  TRACES: "TRCE",
  TRACK: "TRAK",
  TRACKS: "TRAK",
  TRK: "TRAK",
  TRKS: "TRAK",
  TRAFFICWAY: "TRFY",
  TUNNEL: "TUNL",
  TUNEL: "TUNL",
  TUNLS: "TUNL",
  TUNNELS: "TUNL",
  TUNNL: "TUNL",
  TURNPIKE: "TPKE",
  TRNPK: "TPKE",
  TURNPK: "TPKE",
  UNDERPASS: "UPAS",
  UNION: "UN",
  UNIONS: "UNS",
  VALLEY: "VLY",
  VALLY: "VLY",
  VLLY: "VLY",
  VALLEYS: "VLYS",
  VIADUCT: "VIA",
  VDCT: "VIA",
  VIADCT: "VIA",
  VIEW: "VW",
  VIEWS: "VWS",
  VILLAGE: "VLG",
  VILL: "VLG",
  VILLAG: "VLG",
  VILLG: "VLG",
  VILLIAGE: "VLG",
  VILLAGES: "VLGS",
  VILLE: "VL",
  VISTA: "VIS",
  VIST: "VIS",
  VST: "VIS",
  VSTA: "VIS",
  WALK: "WALK",
  WALKS: "WALK",
  WALL: "WALL",
  WAYS: "WAYS",
  WELL: "WL",
  WELLS: "WLS"
};
var DIRECTIONAL_MAP = {
  NORTH: "N",
  SOUTH: "S",
  EAST: "E",
  WEST: "W",
  NORTHEAST: "NE",
  NORTHWEST: "NW",
  SOUTHEAST: "SE",
  SOUTHWEST: "SW",
  NO: "N",
  SO: "S",
  EA: "E",
  WE: "W"
};
var UNIT_TYPE_MAP = {
  APARTMENT: "APT",
  APRTMNT: "APT",
  APTMNT: "APT",
  SUITE: "STE",
  UNIT: "UNIT",
  BUILDING: "BLDG",
  FLOOR: "FL",
  ROOM: "RM",
  DEPARTMENT: "DEPT",
  OFFICE: "OFC",
  PENTHOUSE: "PH",
  BASEMENT: "BSMT",
  FRONT: "FRNT",
  REAR: "REAR",
  SIDE: "SIDE",
  UPPER: "UPPR",
  LOWER: "LOWR",
  LOBBY: "LBBY",
  HANGAR: "HNGR",
  LOT: "LOT",
  PIER: "PIER",
  SLIP: "SLIP",
  SPACE: "SPC",
  STOP: "STOP",
  TRAILER: "TRLR"
};
var STATE_MAP = {
  ALABAMA: "AL",
  ALASKA: "AK",
  ARIZONA: "AZ",
  ARKANSAS: "AR",
  CALIFORNIA: "CA",
  COLORADO: "CO",
  CONNECTICUT: "CT",
  DELAWARE: "DE",
  "DISTRICT OF COLUMBIA": "DC",
  FLORIDA: "FL",
  GEORGIA: "GA",
  HAWAII: "HI",
  IDAHO: "ID",
  ILLINOIS: "IL",
  INDIANA: "IN",
  IOWA: "IA",
  KANSAS: "KS",
  KENTUCKY: "KY",
  LOUISIANA: "LA",
  MAINE: "ME",
  MARYLAND: "MD",
  MASSACHUSETTS: "MA",
  MICHIGAN: "MI",
  MINNESOTA: "MN",
  MISSISSIPPI: "MS",
  MISSOURI: "MO",
  MONTANA: "MT",
  NEBRASKA: "NE",
  NEVADA: "NV",
  "NEW HAMPSHIRE": "NH",
  "NEW JERSEY": "NJ",
  "NEW MEXICO": "NM",
  "NEW YORK": "NY",
  "NORTH CAROLINA": "NC",
  "NORTH DAKOTA": "ND",
  OHIO: "OH",
  OKLAHOMA: "OK",
  OREGON: "OR",
  PENNSYLVANIA: "PA",
  "RHODE ISLAND": "RI",
  "SOUTH CAROLINA": "SC",
  "SOUTH DAKOTA": "SD",
  TENNESSEE: "TN",
  TEXAS: "TX",
  UTAH: "UT",
  VERMONT: "VT",
  VIRGINIA: "VA",
  WASHINGTON: "WA",
  "WEST VIRGINIA": "WV",
  WISCONSIN: "WI",
  WYOMING: "WY",
  "PUERTO RICO": "PR",
  GUAM: "GU",
  "VIRGIN ISLANDS": "VI",
  ALBERTA: "AB",
  "BRITISH COLUMBIA": "BC",
  MANITOBA: "MB",
  "NEW BRUNSWICK": "NB",
  "NEWFOUNDLAND AND LABRADOR": "NL",
  "NOVA SCOTIA": "NS",
  ONTARIO: "ON",
  "PRINCE EDWARD ISLAND": "PE",
  QUEBEC: "QC",
  SASKATCHEWAN: "SK",
  "NORTHWEST TERRITORIES": "NT",
  NUNAVUT: "NU",
  YUKON: "YT"
};
var ORDINAL_MAP = {
  FIRST: "1ST",
  SECOND: "2ND",
  THIRD: "3RD",
  FOURTH: "4TH",
  FIFTH: "5TH",
  SIXTH: "6TH",
  SEVENTH: "7TH",
  EIGHTH: "8TH",
  NINTH: "9TH",
  TENTH: "10TH",
  ELEVENTH: "11TH",
  TWELFTH: "12TH"
};
function normalizeCity(city) {
  return city.toUpperCase().replace(/\./g, "").replace(/\s+/g, " ").trim();
}
function normalizeStreetNumber(streetNumber) {
  const trimmed = streetNumber.trim().toUpperCase();
  return trimmed.replace(/^0+/, "") || "0";
}
function normalizeStreetName(street) {
  let normalized = street.toUpperCase().replace(/\./g, "").replace(/,/g, "").replace(/'/g, "").replace(/-/g, " ").replace(/\s+/g, " ").trim();
  for (const [word, ordinal] of Object.entries(ORDINAL_MAP)) {
    normalized = normalized.replace(new RegExp(`\\b${word}\\b`, "g"), ordinal);
  }
  for (const [word, abbrev] of Object.entries(DIRECTIONAL_MAP)) {
    normalized = normalized.replace(new RegExp(`\\b${word}\\b`, "g"), abbrev);
  }
  for (const [word, abbrev] of Object.entries(STREET_SUFFIX_MAP)) {
    normalized = normalized.replace(new RegExp(`\\b${word}\\b`, "g"), abbrev);
  }
  return normalized.replace(/\s+/g, " ").trim();
}
function removeUnitDesignation(address) {
  const unitPatterns = [
    /\s+#\s*\w+$/i,
    /\s+(APT|APARTMENT|UNIT|STE|SUITE|BLDG|BUILDING|FL|FLOOR|RM|ROOM)\s*#?\s*\w+$/i,
    /\s+(APT|APARTMENT|UNIT|STE|SUITE|BLDG|BUILDING|FL|FLOOR|RM|ROOM)\.?\s*#?\s*\w*$/i
  ];
  let result = address;
  for (const pattern of unitPatterns) {
    result = result.replace(pattern, "");
  }
  return result.trim();
}
function normalizeState(state) {
  const upper = state.toUpperCase().trim();
  return STATE_MAP[upper] || upper;
}
var STATE_NAMES_MAPPED_BEFORE_OCT_2026 = /* @__PURE__ */ new Set(["MINNESOTA", "WISCONSIN", "IOWA", "NORTH DAKOTA", "SOUTH DAKOTA"]);
function legacyAddressMatchKeys(matchKey) {
  const parts = matchKey.split("|");
  if (parts.length !== 5) return [];
  const code = parts[3].toUpperCase();
  const names = Object.keys(STATE_MAP).filter((name) => STATE_MAP[name] === code && !STATE_NAMES_MAPPED_BEFORE_OCT_2026.has(name));
  return names.map((name) => [...parts.slice(0, 3), name.toLowerCase(), parts[4]].join("|"));
}
function normalizeZip(zip) {
  const match = zip.match(/^\d{5}/);
  return match ? match[0] : zip.trim();
}
function normalizeAddress(streetAddress, city, state, zip) {
  const addressWithoutUnit = removeUnitDesignation(streetAddress);
  const match = addressWithoutUnit.match(/^(\d+\w*)\s+(.+)$/);
  const streetNumber = match ? normalizeStreetNumber(match[1]) : "";
  const streetName = match ? normalizeStreetName(match[2]) : normalizeStreetName(addressWithoutUnit);
  const normalizedCity = normalizeCity(city);
  const normalizedState = normalizeState(state);
  const normalizedZip = normalizeZip(zip);
  const streetAddressNormalized = streetNumber ? `${streetNumber} ${streetName}` : streetName;
  const formatted = `${streetAddressNormalized}, ${normalizedCity}, ${normalizedState} ${normalizedZip}`;
  const matchKey = `${streetNumber}|${streetName}|${normalizedCity}|${normalizedState}|${normalizedZip}`.toLowerCase();
  return {
    streetAddress: streetAddressNormalized,
    streetNumber,
    streetName,
    city: normalizedCity,
    state: normalizedState,
    zip: normalizedZip,
    formatted,
    matchKey
  };
}
function normalizeAddressString(fullAddress) {
  let normalized = fullAddress.toUpperCase().replace(/\./g, "").replace(/,/g, " ").replace(/'/g, "").replace(/-/g, " ").replace(/\s+/g, " ").trim();
  normalized = removeUnitDesignation(normalized);
  for (const [word, ordinal] of Object.entries(ORDINAL_MAP)) {
    normalized = normalized.replace(new RegExp(`\\b${word}\\b`, "g"), ordinal);
  }
  for (const [word, abbrev] of Object.entries(DIRECTIONAL_MAP)) {
    normalized = normalized.replace(new RegExp(`\\b${word}\\b`, "g"), abbrev);
  }
  for (const [word, abbrev] of Object.entries(STREET_SUFFIX_MAP)) {
    normalized = normalized.replace(new RegExp(`\\b${word}\\b`, "g"), abbrev);
  }
  for (const [word, abbrev] of Object.entries(STATE_MAP)) {
    normalized = normalized.replace(new RegExp(`\\b${word}\\b`, "g"), abbrev);
  }
  return normalized.replace(/\s+/g, " ").trim();
}
function parseGeocodedAddress(formattedAddress) {
  const address = formattedAddress.replace(/,?\s*(USA|United States|US)$/i, "").trim();
  const match = address.match(/^(.+?),\s*([^,]+),\s*([A-Z]{2})\s*(\d{5}(?:-\d{4})?)$/i);
  if (match) {
    return {
      streetAddress: match[1].trim(),
      city: match[2].trim(),
      state: match[3].toUpperCase(),
      zip: match[4],
      country: "US"
    };
  }
  const altMatch = address.match(/^(.+?),\s*([^,]+),\s*(\w+(?:\s+\w+)?)\s+(\d{5}(?:-\d{4})?)$/i);
  if (altMatch) {
    return {
      streetAddress: altMatch[1].trim(),
      city: altMatch[2].trim(),
      state: normalizeState(altMatch[3]),
      zip: altMatch[4],
      country: "US"
    };
  }
  return null;
}
function addressHasStreetNumber(formattedAddress) {
  if (!formattedAddress?.trim()) return false;
  const street = formatAddressForDisplay(formattedAddress)?.street ?? formattedAddress.trim();
  return /^(\d+\w*)\s+\S/.test(street);
}
var STREET_NUMBER_REQUIRED_MESSAGE = "Enter a complete street address that includes the house number.";
function compareAddresses(addr1, addr2) {
  const n1 = normalizeAddress(
    `${addr1.streetNumber} ${addr1.streetName}`,
    addr1.city,
    addr1.state,
    addr1.zip
  );
  const n2 = normalizeAddress(
    `${addr2.streetNumber} ${addr2.streetName}`,
    addr2.city,
    addr2.state,
    addr2.zip
  );
  if (n1.matchKey === n2.matchKey) return 1;
  let score = 0;
  if (n1.streetNumber === n2.streetNumber) {
    score += 0.3;
  } else {
    return 0;
  }
  if (n1.streetName === n2.streetName) {
    score += 0.3;
  } else if (n1.streetName.includes(n2.streetName) || n2.streetName.includes(n1.streetName)) {
    score += 0.15;
  }
  if (n1.city === n2.city) score += 0.2;
  if (n1.state === n2.state) score += 0.1;
  if (n1.zip === n2.zip) score += 0.1;
  return score;
}

// src/storage/keys/metroParcel.ts
function normalizeCity2(city) {
  return normalizeCity(city);
}
function normalizeStreet(street) {
  return normalizeStreetName(street);
}
function normalizeStreetNumber2(streetNumber) {
  return normalizeStreetNumber(streetNumber);
}
var METRO_PARCEL_KEY_BUILDERS = {
  /**
   * Build primary key from PIN
   * @example "1234567890" → "PIN#1234567890"
   */
  pk: (pin) => `PIN#${pin}`,
  /**
   * Sort key is always "PARCEL" (single record per PIN)
   */
  sk: () => "PARCEL",
  /**
   * Build GSI1 partition key from city (normalized)
   * @example "Plymouth" → "ADDR#PLYMOUTH"
   */
  gsi1pk: (city) => `ADDR#${normalizeCity2(city)}`,
  /**
   * Build GSI1 sort key from street and number (normalized)
   * @example ("Main Street", "123") → "MAIN ST#123"
   */
  gsi1sk: (street, streetNumber) => `${normalizeStreet(street)}#${normalizeStreetNumber2(streetNumber)}`,
  /**
   * Build GSI1 sort key prefix for street-only searches (begins_with)
   * @example "Main Street" → "MAIN ST#"
   */
  gsi1skPrefix: (street) => `${normalizeStreet(street)}#`
};

// src/storage/keys/operatorNotes.ts
var OPERATOR_NOTES_KEYS = {
  partition: (orgId) => `OPERATOR_NOTES#COMPANY#${orgId}`,
  note: (noteId) => `NOTE#${noteId}`,
  notePrefix: () => "NOTE#",
  task: (taskId) => `TASK#${taskId}`,
  taskPrefix: () => "TASK#",
  /** One current record per company; clearing the owner rewrites it instead of deleting. */
  owner: () => "SUCCESS_OWNER"
};

// src/storage/keys/operatorAudit.ts
var OPERATOR_AUDIT_KEYS = {
  partition: (orgId) => orgId === null ? "OPERATOR_AUDIT#PLATFORM" : `OPERATOR_AUDIT#COMPANY#${orgId}`,
  record: (occurredAt, id) => `CHANGE#${occurredAt}#${id}`,
  prefix: () => "CHANGE#"
};

// src/storage/records/aiConversation.ts
function aiConversationToDdbRecord(conversation) {
  return {
    ...conversation,
    PK: DDB_KEY_BUILDERS.aiConvoPK(conversation.orgId, conversation.userId),
    SK: DDB_KEY_BUILDERS.aiConvoSK(conversation.id),
    entityType: "AI_CONVERSATION" /* AI_CONVERSATION */
  };
}
function aiConversationFromDdbRecord(record) {
  const { PK: _PK, SK: _SK, entityType: _entityType, ...conversation } = record;
  return conversation;
}

// src/storage/gsiUpdates.ts
function calculateGsiUpdates(currentEntity, updates, configs) {
  const gsiUpdates = {};
  const merged = { ...currentEntity, ...updates };
  for (const config of configs) {
    const needsUpdate = !config.affectedFields || config.affectedFields.some((field) => field in updates);
    if (!needsUpdate) {
      continue;
    }
    if (config.condition && !config.condition(merged)) {
      gsiUpdates[`${config.gsi}PK`] = null;
      gsiUpdates[`${config.gsi}SK`] = null;
    } else {
      gsiUpdates[`${config.gsi}PK`] = config.pkBuilder(merged);
      gsiUpdates[`${config.gsi}SK`] = config.skBuilder(merged);
    }
  }
  return gsiUpdates;
}
function fieldChanged(updates, ...fields) {
  return fields.some((field) => field in updates);
}

// src/storage/pagination.ts
function encodeCursor(data) {
  return Buffer.from(JSON.stringify(data)).toString("base64url");
}
function decodeCursor(cursor) {
  try {
    const decoded = Buffer.from(cursor, "base64url").toString("utf-8");
    return JSON.parse(decoded);
  } catch {
    return null;
  }
}
function buildPaginatedResult(items, lastEvaluatedKey, limit) {
  const hasMore = !!lastEvaluatedKey || limit !== void 0 && items.length >= limit;
  return {
    items,
    cursor: lastEvaluatedKey ? encodeCursor({ lastEvaluatedKey, timestamp: Date.now() }) : void 0,
    hasMore,
    count: items.length
  };
}
function extractPaginationParams(options = {}) {
  const limit = options.limit || 50;
  let exclusiveStartKey;
  if (options.cursor) {
    const cursorData = decodeCursor(options.cursor);
    exclusiveStartKey = cursorData?.lastEvaluatedKey;
  }
  return { limit, exclusiveStartKey };
}

// src/invoices/buildInvoiceFromLedgerEntry.ts
function calculateDueDate(serviceDate) {
  const date = new Date(serviceDate);
  date.setDate(date.getDate() + 30);
  return date.toISOString();
}
function setupFeePaymentDescriptionFor(debit) {
  const prefix = "Setup fee for ";
  if (!debit.description?.startsWith(prefix)) return null;
  return `Setup fee payment for ${debit.description.slice(prefix.length)}`;
}
function sumAppliedToDebit(debit, allEntries) {
  let paid = 0;
  const expectedSetupFeePayment = setupFeePaymentDescriptionFor(debit);
  const debitAmount = Math.abs(debit.amount);
  for (const e of allEntries) {
    const t = e.type.toLowerCase();
    if (t === "credit_applied" /* CREDIT_APPLIED */ && e.appliedToDebitId === debit.id) {
      paid += Math.abs(e.amount);
    }
    if (t === "payment" /* PAYMENT */) {
      if (debit.visitId && e.visitId === debit.visitId) {
        paid += Math.abs(e.amount);
      } else if (!debit.visitId && !e.visitId && expectedSetupFeePayment && e.description === expectedSetupFeePayment && Math.abs(e.amount) === debitAmount) {
        paid += Math.abs(e.amount);
      }
    }
  }
  return paid;
}
function buildInvoiceFromLedgerEntry({
  entry,
  allEntries,
  customer,
  organization
}) {
  const amount = Math.abs(entry.amount);
  const paid = Math.min(sumAppliedToDebit(entry, allEntries), amount);
  const outstanding = Math.max(0, amount - paid);
  const status = paid >= amount ? "paid" : "pending";
  const idSlice = String(entry.id).slice(-8).toUpperCase();
  const createdAt = entry.createdAt;
  const customerName = customer?.displayName || [customer?.firstName, customer?.lastName].filter(Boolean).join(" ") || "Customer";
  return {
    invoice: {
      id: `inv-adj-${entry.id}`,
      invoiceNumber: `INV-ADJ-${idSlice}`,
      customerId: entry.customerId,
      customerName,
      customerEmail: customer?.email,
      customerPhone: customer?.phone,
      customerAddress: customer?.address,
      organizationName: organization?.name,
      organizationAddress: organization?.companyAddress ?? organization?.address,
      organizationPhone: organization?.phoneNumber ?? organization?.phone,
      organizationEmail: organization?.contactEmail ?? organization?.email,
      organizationWebsite: organization?.website,
      organizationLogoUrl: organization?.logoUrl,
      status,
      subtotal: amount,
      tax: 0,
      total: amount,
      outstandingBalanceCollected: 0,
      totalCharged: paid,
      lineItems: [
        {
          id: "adjustment",
          type: "service",
          description: entry.description || "Charge adjustment",
          amount,
          quantity: 1,
          rate: amount
        }
      ],
      createdAt,
      dueDate: outstanding > 0 ? calculateDueDate(createdAt) : null,
      paidAt: paid >= amount ? createdAt : void 0,
      serviceDate: createdAt,
      serviceAddress: customer?.address,
      metadata: {
        adjustmentReason: entry.description,
        notes: entry.notes
      },
      invoiceNotes: entry.notes
    }
  };
}

// src/pricing/types.ts
var LineItemType = /* @__PURE__ */ ((LineItemType2) => {
  LineItemType2["SERVICE"] = "service";
  LineItemType2["LABOR"] = "labor";
  LineItemType2["VOLUME"] = "volume";
  LineItemType2["OPTION"] = "option";
  LineItemType2["MINIMUM_ADJUSTMENT"] = "minimum_adjustment";
  LineItemType2["TAX"] = "tax";
  LineItemType2["PACKAGE_INCLUDED"] = "package_included";
  LineItemType2["ADDITIONAL_VISIT"] = "additional_visit";
  return LineItemType2;
})(LineItemType || {});
function roundCurrency(amount) {
  return Math.round(amount * 100) / 100;
}

// src/invoices/buildBatchInvoice.ts
function visitServiceDate(v) {
  return v.completedAt ?? v.createdAt;
}
function formatServiceDate(iso) {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric"
  });
}
function buildBatchInvoice(visits) {
  const sorted = [...visits].sort(
    (a, b) => (visitServiceDate(a) ?? "").localeCompare(visitServiceDate(b) ?? "")
  );
  let subtotal = 0;
  let tax = 0;
  let total = 0;
  const lineItems = sorted.map((v) => {
    const vSubtotal = v.finalPricing?.subtotal ?? v.baseAmount ?? 0;
    const vTax = v.finalPricing?.taxAmount ?? v.taxAmount ?? 0;
    const vTotal = v.finalPricing?.totalAmount ?? v.totalAmount ?? 0;
    subtotal += vSubtotal;
    tax += vTax;
    total += vTotal;
    const serviceDate = visitServiceDate(v);
    return {
      id: v.id,
      type: "service" /* SERVICE */,
      description: v.serviceName || "Service",
      serviceDate,
      details: serviceDate ? formatServiceDate(serviceDate) : void 0,
      amount: vSubtotal,
      quantity: 1,
      rate: vSubtotal,
      serviceTemplateId: v.serviceTemplateId,
      bundleId: v.bundleId
    };
  });
  return {
    lineItems,
    subtotal,
    tax,
    total,
    visitIds: sorted.map((v) => v.id),
    visitCount: sorted.length
  };
}
function nestBundleInvoiceLines(lineItems, bundleNameById) {
  const byBundle = /* @__PURE__ */ new Map();
  for (const item of lineItems) {
    if (!item.bundleId) continue;
    const list = byBundle.get(item.bundleId) ?? [];
    list.push(item);
    byBundle.set(item.bundleId, list);
  }
  const emitted = /* @__PURE__ */ new Set();
  const out = [];
  for (const item of lineItems) {
    const members = item.bundleId ? byBundle.get(item.bundleId) : void 0;
    if (!item.bundleId || !members || members.length < 2) {
      out.push(item);
      continue;
    }
    if (emitted.has(item.bundleId)) continue;
    emitted.add(item.bundleId);
    const amount = members.reduce((sum, m) => sum + m.amount, 0);
    out.push({
      ...members[0],
      id: `bundle-${item.bundleId}`,
      description: bundleNameById.get(item.bundleId) ?? members[0].description,
      amount,
      rate: amount,
      memberNames: members.map((m) => m.description)
    });
  }
  return out;
}

// src/helpers/displayNameHelpers.ts
function getCustomerDisplayName(customer) {
  if (!customer) return "Unknown Customer";
  if (customer.displayName) return customer.displayName;
  const fullName = [customer.firstName, customer.lastName].filter(Boolean).join(" ").trim();
  if (fullName) return fullName;
  return customer.name || customer.email || "Unknown Customer";
}
function getUserDisplayName(user) {
  if (!user) return "Unknown User";
  if (user.name) return capitalizeWords(user.name);
  if (user.given_name) return capitalizeWords(user.given_name);
  if (user.email) {
    const username = user.email.split("@")[0];
    if (username) return capitalizeWords(username);
  }
  return "Unknown User";
}
function capitalizeWords(str) {
  return str.replace(/\b\w/g, (c) => c.toUpperCase());
}
function getServiceDisplayName(service) {
  if (!service) return "Unknown Service";
  return service.serviceName || service.serviceTemplateName || service.name || "Unknown Service";
}
function getMemberDisplayName(member) {
  if (!member) return "Unknown Member";
  return member.crewMemberName || member.memberName || member.memberId || "Unknown Member";
}
function getDeviceIdentifier(deviceType, deviceId) {
  return {
    deviceType: deviceType || "unknown",
    deviceId: deviceId || "unknown"
  };
}
function getOrganizationMemberDisplayName(member) {
  if (!member) return "Unknown Member";
  const { formatFullName: formatFullName2 } = (init_name(), __toCommonJS(name_exports));
  const fullName = formatFullName2(member.firstName || "", member.lastName || "");
  return fullName || "Unknown Member";
}
function getContactPersonName(contact) {
  return [contact.firstName, contact.lastName].filter(Boolean).join(" ").trim();
}
function getCustomerDisplayAddress(customer) {
  if (!customer) return "";
  return customer.address || "";
}

// src/pricing/minimumChargeCoverage.ts
var HOUR_STEP = 0.5;
var EPSILON = 1e-6;
function minimumChargeCoverageHours(minimumCharge, hourlyRate) {
  if (typeof minimumCharge !== "number" || typeof hourlyRate !== "number" || minimumCharge <= 0 || hourlyRate <= 0) {
    return null;
  }
  const hours = minimumCharge / hourlyRate;
  const nearestStep = Math.round(hours / HOUR_STEP) * HOUR_STEP;
  if (nearestStep < HOUR_STEP) return null;
  if (Math.abs(hours - nearestStep) > EPSILON) return null;
  return nearestStep;
}

// src/pricing/lineItemDisplay.ts
var QUANTITY_DECIMALS = 2;
var LINE_ITEM_ROUNDING_NOTE = "Hours are rounded to the nearest hundredth; the amount reflects the exact labor time worked.";
var ADDITIONAL_LABOR_HOURS_DESCRIPTION = "Additional Labor Hours";
var LEGACY_ADDITIONAL_LABOR_DESCRIPTION = "Additional Labor";
function customerLineItemDescription(description) {
  if (description === LEGACY_ADDITIONAL_LABOR_DESCRIPTION) {
    return ADDITIONAL_LABOR_HOURS_DESCRIPTION;
  }
  return description ?? "";
}
function formatLineItemQuantity(quantity, rate, amount) {
  if (Number.isInteger(quantity)) {
    return { text: String(quantity), isApproximate: false };
  }
  const text = quantity.toFixed(QUANTITY_DECIMALS);
  if (!Number.isFinite(rate) || rate === 0) {
    return { text, isApproximate: false };
  }
  const roundedQuantity = Number(text);
  const reconciles = roundCurrency(roundedQuantity * rate) === roundCurrency(amount);
  const isApproximate = roundedQuantity !== quantity && !reconciles;
  return { text, isApproximate };
}
function hasApproximateLineQuantity(lineItems) {
  if (!lineItems) return false;
  return lineItems.some(
    (item) => formatLineItemQuantity(item.quantity, item.rate, item.amount).isApproximate
  );
}
var MINIMUM_LINE_PREFIX = "Minimum Charge";
function minimumLineSubLabel(lineItems) {
  if (!lineItems || lineItems.length === 0) return null;
  const first = lineItems[0];
  if (!first) return null;
  const isMinimumServiceLine = first.type === "service" /* SERVICE */ && typeof first.description === "string" && first.description.startsWith(MINIMUM_LINE_PREFIX);
  if (!isMinimumServiceLine) return null;
  const laborLine = lineItems.find(
    (item) => item.type === "labor" /* LABOR */ && typeof item.description === "string" && item.description.startsWith("Additional Labor")
  );
  const coverageHours = laborLine ? minimumChargeCoverageHours(first.rate, laborLine.rate) : null;
  if (coverageHours !== null) {
    return `${coverageHours}-hour minimum`;
  }
  return first.description;
}
function isLaborLineItem(item) {
  if (!item) return false;
  return item.type === "labor" /* LABOR */;
}
function formatLaborCrewSize(count) {
  if (count === null || count === void 0) return null;
  if (!Number.isFinite(count) || count <= 0) return null;
  const whole = Math.floor(count);
  if (whole <= 0) return null;
  return whole === 1 ? "1 crew member" : `${whole} crew members`;
}

// src/pricing/visitPriceCalculator.ts
var lineItemCounter = 0;
function generateLineItemId(prefix) {
  return `${prefix}-${++lineItemCounter}`;
}
function resetLineItemCounter() {
  lineItemCounter = 0;
}
function calculateServiceOptions(serviceOptions) {
  if (!serviceOptions || serviceOptions.selections.length === 0) {
    return { cost: 0, lineItems: [] };
  }
  const { definitions, selections } = serviceOptions;
  let totalCost = 0;
  const lineItems = [];
  for (const selection of selections) {
    const selectionWithSnapshot = selection;
    const quantity = selectionWithSnapshot.quantity ?? 0;
    let optionData;
    if (selectionWithSnapshot.rate !== void 0 && selectionWithSnapshot.name && selectionWithSnapshot.rateType && selectionWithSnapshot.billable !== void 0) {
      const def = definitions.find((d) => d.id === selection.optionId);
      optionData = {
        rate: selectionWithSnapshot.rate,
        name: selectionWithSnapshot.name,
        description: def?.description,
        rateType: selectionWithSnapshot.rateType,
        billable: selectionWithSnapshot.billable,
        taxable: selectionWithSnapshot.taxable ?? false,
        unit: selectionWithSnapshot.unit,
        builtInAmount: selectionWithSnapshot.builtInAmount,
        invoiceDisplay: selectionWithSnapshot.invoiceDisplay,
        zeroValueDisplay: selectionWithSnapshot.zeroValueDisplay,
        choices: def?.choices
      };
    } else {
      const def = definitions.find((d) => d.id === selection.optionId);
      if (def) {
        optionData = def;
      }
    }
    if (!optionData || quantity < 0) {
      continue;
    }
    const timeUsed = selectionWithSnapshot.timeUsed ?? 0;
    const hasPositivePick = (selectionWithSnapshot.selectedChoices ?? []).some((p) => p.quantity > 0);
    if (quantity === 0 && timeUsed === 0 && !hasPositivePick) {
      continue;
    }
    if (!optionData.billable && optionData.rateType !== "multi-select" /* MULTI_SELECT */) {
      lineItems.push({
        id: generateLineItemId("option"),
        type: "option" /* OPTION */,
        description: optionData.name,
        quantity: quantity > 0 ? quantity : timeUsed,
        rate: optionData.rate,
        amount: 0,
        taxable: false,
        unit: optionData.unit,
        details: optionData.description,
        invoiceDisplay: optionData.invoiceDisplay,
        zeroValueDisplay: optionData.rate > 0 ? "show-as-included" : "show"
      });
      continue;
    }
    let optionCost = 0;
    let lineQuantity = quantity;
    let lineUnit = optionData.unit;
    let details;
    switch (optionData.rateType) {
      case "flat" /* FLAT */:
        optionCost = quantity > 0 ? optionData.rate : 0;
        lineQuantity = 1;
        lineUnit = void 0;
        break;
      case "per-unit" /* PER_UNIT */: {
        const builtIn = optionData.builtInAmount || 0;
        const billableQuantity = Math.max(0, quantity - builtIn);
        optionCost = roundCurrency(billableQuantity * optionData.rate);
        lineQuantity = billableQuantity > 0 ? billableQuantity : quantity;
        if (builtIn > 0) {
          details = `First ${builtIn} ${optionData.unit || "units"} included`;
        }
        break;
      }
      case "time-based" /* TIME_BASED */: {
        const builtIn = optionData.builtInAmount || 0;
        const billable = Math.max(0, timeUsed - builtIn);
        optionCost = roundCurrency(billable * optionData.rate);
        lineQuantity = billable > 0 ? billable : timeUsed;
        lineUnit = optionData.unit || "hours" /* HOURS */;
        if (builtIn > 0) {
          details = `First ${builtIn} ${lineUnit} included`;
        }
        break;
      }
      case "multi-select" /* MULTI_SELECT */: {
        const picks = selectionWithSnapshot.selectedChoices ?? [];
        let descriptionEmitted = false;
        for (const pick of picks) {
          if (!pick.choiceId || pick.quantity <= 0) continue;
          let choiceName;
          let choiceRate;
          if (pick.name !== void 0) {
            choiceName = pick.name;
            choiceRate = pick.rate;
          } else {
            const defChoice = optionData.choices?.find((c) => c.id === pick.choiceId);
            if (!defChoice) continue;
            choiceName = defChoice.name;
            choiceRate = defChoice.rate;
          }
          if (!choiceName) continue;
          const normalizedChoice = choiceName.trim().toLowerCase();
          if (normalizedChoice === "no") continue;
          const description = normalizedChoice === "yes" ? optionData.name : `${optionData.name} \u2014 ${choiceName}`;
          const rate = choiceRate ?? 0;
          const choiceCost = roundCurrency(pick.quantity * rate);
          totalCost += choiceCost;
          lineItems.push({
            id: generateLineItemId("option"),
            type: "option" /* OPTION */,
            description,
            quantity: pick.quantity,
            rate,
            amount: choiceCost,
            taxable: optionData.taxable,
            unit: optionData.unit,
            details: descriptionEmitted ? void 0 : optionData.description,
            invoiceDisplay: optionData.invoiceDisplay,
            zeroValueDisplay: optionData.billable ? optionData.zeroValueDisplay : (choiceRate ?? 0) > 0 ? "show-as-included" : "show"
          });
          if (optionData.description) descriptionEmitted = true;
        }
        continue;
      }
    }
    totalCost += optionCost;
    lineItems.push({
      id: generateLineItemId("option"),
      type: "option" /* OPTION */,
      description: optionData.name,
      quantity: lineQuantity,
      rate: optionData.rate,
      amount: optionCost,
      taxable: optionData.taxable,
      unit: lineUnit,
      details: [optionData.description, details].filter(Boolean).join(" \xB7 ") || void 0,
      invoiceDisplay: optionData.invoiceDisplay,
      zeroValueDisplay: optionData.zeroValueDisplay
    });
  }
  return { cost: roundCurrency(totalCost), lineItems };
}
function calculateTax(taxableAmount, taxRate) {
  if (taxRate <= 0 || taxableAmount <= 0) {
    return {
      taxAmount: 0,
      taxBreakdown: {
        rate: 0,
        stateAmount: 0,
        countyAmount: 0,
        cityAmount: 0,
        additionalAmount: 0,
        totalAmount: 0
      }
    };
  }
  const totalTax = roundCurrency(taxableAmount * taxRate);
  return {
    taxAmount: totalTax,
    taxBreakdown: {
      rate: taxRate,
      stateAmount: totalTax,
      // All tax attributed to state for now
      countyAmount: 0,
      cityAmount: 0,
      additionalAmount: 0,
      totalAmount: totalTax
    }
  };
}
function truncateToTwo(n) {
  return Math.trunc(n * 100) / 100;
}
function minimumChargeDescription(builtInHours) {
  if (!Number.isFinite(builtInHours) || builtInHours <= 0) {
    return "Minimum Charge";
  }
  const hours = truncateToTwo(builtInHours);
  const unit = hours === 1 ? "labor hour" : "labor hours";
  return `Minimum Charge (Includes ${hours} ${unit})`;
}
function timeBasedHoursFromSelections(serviceOptions) {
  if (!serviceOptions) return 0;
  let total = 0;
  for (const sel of serviceOptions.selections) {
    const s = sel;
    const def = serviceOptions.definitions.find((d) => d.id === sel.optionId);
    const rateType = s.rateType ?? def?.rateType;
    if (rateType !== "time-based" /* TIME_BASED */) continue;
    const unit = s.unit ?? def?.unit;
    const timeUsed = s.timeUsed ?? 0;
    total += unit === "minutes" /* MINUTES */ ? timeUsed / 60 : timeUsed;
  }
  return total;
}
function calculateHourlyVisitPrice(input) {
  resetLineItemCounter();
  const {
    hourlyRate,
    actualHours: rawActualHours,
    minimumCharge = 0,
    builtInHours = 0,
    serviceOptions,
    taxRate,
    serviceTaxable = true
    // Default to true for backwards compatibility
  } = input;
  const lineItems = [];
  let baseAmount = 0;
  const timeBasedHours = timeBasedHoursFromSelections(serviceOptions);
  const actualHours = Math.max(0, rawActualHours - timeBasedHours);
  if (actualHours > 0) {
    if (minimumCharge > 0 && builtInHours > 0) {
      if (actualHours <= builtInHours) {
        baseAmount = minimumCharge;
        lineItems.push({
          id: generateLineItemId("minimum"),
          type: "service" /* SERVICE */,
          description: minimumChargeDescription(builtInHours),
          quantity: 1,
          rate: minimumCharge,
          amount: minimumCharge,
          taxable: serviceTaxable
        });
      } else {
        const additionalHours = actualHours - builtInHours;
        const additionalCost = roundCurrency(additionalHours * hourlyRate);
        baseAmount = minimumCharge + additionalCost;
        lineItems.push({
          id: generateLineItemId("minimum"),
          type: "service" /* SERVICE */,
          description: minimumChargeDescription(builtInHours),
          quantity: 1,
          rate: minimumCharge,
          amount: minimumCharge,
          taxable: serviceTaxable
        });
        lineItems.push({
          id: generateLineItemId("labor"),
          type: "labor" /* LABOR */,
          description: ADDITIONAL_LABOR_HOURS_DESCRIPTION,
          quantity: additionalHours,
          rate: hourlyRate,
          amount: additionalCost,
          taxable: serviceTaxable
        });
      }
    } else {
      const laborCost = roundCurrency(actualHours * hourlyRate);
      if (minimumCharge > 0 && laborCost < minimumCharge) {
        baseAmount = minimumCharge;
        lineItems.push({
          id: generateLineItemId("labor"),
          type: "labor" /* LABOR */,
          description: `Labor (${truncateToTwo(actualHours)} hours @ $${hourlyRate}/hr)`,
          quantity: actualHours,
          rate: hourlyRate,
          amount: laborCost,
          taxable: serviceTaxable
        });
        lineItems.push({
          id: generateLineItemId("minimum"),
          type: "minimum_adjustment" /* MINIMUM_ADJUSTMENT */,
          description: "Minimum Charge Adjustment",
          quantity: 1,
          rate: minimumCharge - laborCost,
          amount: minimumCharge - laborCost,
          taxable: serviceTaxable
        });
      } else {
        baseAmount = laborCost;
        lineItems.push({
          id: generateLineItemId("labor"),
          type: "labor" /* LABOR */,
          description: `Labor (${truncateToTwo(actualHours)} hours @ $${hourlyRate}/hr)`,
          quantity: actualHours,
          rate: hourlyRate,
          amount: laborCost,
          taxable: serviceTaxable
        });
      }
    }
  }
  const optionsResult = calculateServiceOptions(serviceOptions);
  lineItems.push(...optionsResult.lineItems);
  const subtotal = roundCurrency(baseAmount + optionsResult.cost);
  let taxableAmount = serviceTaxable ? baseAmount : 0;
  for (const item of optionsResult.lineItems) {
    if (item.taxable) {
      taxableAmount += item.amount;
    }
  }
  const { taxAmount, taxBreakdown } = calculateTax(taxableAmount, taxRate);
  if (taxAmount > 0) {
    lineItems.push({
      id: generateLineItemId("tax"),
      type: "tax" /* TAX */,
      description: `Tax (${(taxRate * 100).toFixed(2)}%)`,
      quantity: 1,
      rate: taxRate,
      amount: taxAmount,
      taxable: false
    });
  }
  const total = roundCurrency(subtotal + taxAmount);
  return {
    billingMethod: "per_hour" /* PER_HOUR */,
    actualHours,
    baseAmount,
    serviceOptionsAmount: optionsResult.cost,
    subtotal,
    taxAmount,
    total,
    lineItems,
    taxBreakdown,
    calculatedAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}
function applyFirstVisitGreaterOf(regularRate, firstVisitLabor, serviceTaxable, lineItems, serviceName) {
  const { hourlyRate, actualHours } = firstVisitLabor;
  if (!Number.isFinite(hourlyRate) || hourlyRate <= 0 || !Number.isFinite(actualHours) || actualHours <= 0 || !Number.isFinite(regularRate)) {
    return null;
  }
  const laborCharge = roundCurrency(actualHours * hourlyRate);
  lineItems.push({
    id: generateLineItemId("service"),
    type: "service" /* SERVICE */,
    description: serviceName || "Service",
    quantity: 1,
    rate: regularRate,
    amount: regularRate,
    taxable: serviceTaxable
  });
  if (laborCharge <= regularRate) {
    return regularRate;
  }
  const additionalCost = roundCurrency(laborCharge - regularRate);
  const includedHours = regularRate / hourlyRate;
  const additionalHours = actualHours - includedHours;
  lineItems.push({
    id: generateLineItemId("labor"),
    type: "labor" /* LABOR */,
    description: ADDITIONAL_LABOR_HOURS_DESCRIPTION,
    quantity: additionalHours,
    rate: hourlyRate,
    amount: additionalCost,
    taxable: serviceTaxable
  });
  return laborCharge;
}
function calculateFixedVisitPrice(input) {
  resetLineItemCounter();
  const {
    subscriptionRate,
    serviceOptions,
    taxRate,
    serviceTaxable = true,
    multiplier = 1,
    firstVisitLabor,
    serviceName
  } = input;
  const lineItems = [];
  const regularRate = roundCurrency(subscriptionRate * multiplier);
  let baseAmount;
  if (firstVisitLabor) {
    const firstVisitBase = applyFirstVisitGreaterOf(
      regularRate,
      firstVisitLabor,
      serviceTaxable,
      lineItems,
      serviceName
    );
    if (firstVisitBase !== null) {
      baseAmount = firstVisitBase;
    } else {
      baseAmount = regularRate;
      lineItems.push({
        id: generateLineItemId("service"),
        type: "service" /* SERVICE */,
        description: serviceName || "Service",
        quantity: multiplier,
        rate: subscriptionRate,
        amount: baseAmount,
        taxable: serviceTaxable
      });
    }
  } else {
    baseAmount = regularRate;
    lineItems.push({
      id: generateLineItemId("service"),
      type: "service" /* SERVICE */,
      description: serviceName || "Service",
      quantity: multiplier,
      rate: subscriptionRate,
      amount: baseAmount,
      taxable: serviceTaxable
    });
  }
  const optionsResult = calculateServiceOptions(serviceOptions);
  lineItems.push(...optionsResult.lineItems);
  const subtotal = roundCurrency(baseAmount + optionsResult.cost);
  let taxableAmount = serviceTaxable ? baseAmount : 0;
  for (const item of optionsResult.lineItems) {
    if (item.taxable) {
      taxableAmount += item.amount;
    }
  }
  const { taxAmount, taxBreakdown } = calculateTax(taxableAmount, taxRate);
  if (taxAmount > 0) {
    lineItems.push({
      id: generateLineItemId("tax"),
      type: "tax" /* TAX */,
      description: `Tax (${(taxRate * 100).toFixed(2)}%)`,
      quantity: 1,
      rate: taxRate,
      amount: taxAmount,
      taxable: false
    });
  }
  const total = roundCurrency(subtotal + taxAmount);
  return {
    billingMethod: "per_visit" /* PER_VISIT */,
    baseAmount,
    serviceOptionsAmount: optionsResult.cost,
    subtotal,
    taxAmount,
    total,
    lineItems,
    taxBreakdown,
    calculatedAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}
function calculatePackageVisitPrice(input) {
  resetLineItemCounter();
  const {
    visitsRemaining,
    pricePerAdditionalVisit,
    serviceOptions,
    taxRate,
    serviceTaxable = true,
    multiplier = 1,
    multiplierActionName,
    selectedPackageOptionName
  } = input;
  const lineItems = [];
  const isUnlimited = visitsRemaining === "unlimited";
  const numRemaining = isUnlimited ? Infinity : typeof visitsRemaining === "number" ? visitsRemaining : 0;
  const includedQty = isUnlimited ? multiplier : Math.min(multiplier, numRemaining);
  const additionalQty = multiplier - includedQty;
  const isIncludedInPackage = includedQty > 0;
  const isAdditionalVisit = additionalQty > 0;
  let baseAmount = 0;
  if (includedQty > 0) {
    const description = multiplierActionName ? multiplierActionName : isUnlimited ? "Package Visit (Unlimited)" : `Package Visit (${numRemaining} remaining)`;
    lineItems.push({
      id: generateLineItemId("package"),
      type: "package_included" /* PACKAGE_INCLUDED */,
      description,
      quantity: includedQty,
      rate: 0,
      amount: 0,
      taxable: false
    });
  }
  if (additionalQty > 0) {
    const additionalAmount = roundCurrency(additionalQty * pricePerAdditionalVisit);
    baseAmount = additionalAmount;
    const description = multiplierActionName ? multiplierActionName : selectedPackageOptionName ? `${selectedPackageOptionName} (visit beyond package minimum)` : "Additional Visit (beyond package minimum)";
    lineItems.push({
      id: generateLineItemId("additional"),
      type: "additional_visit" /* ADDITIONAL_VISIT */,
      description,
      quantity: additionalQty,
      rate: pricePerAdditionalVisit,
      amount: additionalAmount,
      taxable: serviceTaxable
    });
  }
  const optionsResult = calculateServiceOptions(serviceOptions);
  lineItems.push(...optionsResult.lineItems);
  const subtotal = roundCurrency(baseAmount + optionsResult.cost);
  let taxableAmount = isAdditionalVisit && serviceTaxable ? baseAmount : 0;
  for (const item of optionsResult.lineItems) {
    if (item.taxable) {
      taxableAmount += item.amount;
    }
  }
  const { taxAmount, taxBreakdown } = calculateTax(taxableAmount, taxRate);
  if (taxAmount > 0) {
    lineItems.push({
      id: generateLineItemId("tax"),
      type: "tax" /* TAX */,
      description: `Tax (${(taxRate * 100).toFixed(2)}%)`,
      quantity: 1,
      rate: taxRate,
      amount: taxAmount,
      taxable: false
    });
  }
  const total = roundCurrency(subtotal + taxAmount);
  let newVisitsRemaining;
  if (isUnlimited) {
    newVisitsRemaining = "unlimited";
  } else if (typeof visitsRemaining === "number" && visitsRemaining > 0) {
    newVisitsRemaining = Math.max(0, visitsRemaining - includedQty);
  } else {
    newVisitsRemaining = 0;
  }
  return {
    billingMethod: "package" /* PACKAGE */,
    isIncludedInPackage,
    isAdditionalVisit,
    visitsRemaining: newVisitsRemaining,
    baseAmount,
    serviceOptionsAmount: optionsResult.cost,
    subtotal,
    taxAmount,
    total,
    lineItems,
    taxBreakdown,
    calculatedAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}
function calculateConsumableVisitPrice(input) {
  resetLineItemCounter();
  const { minimumCharge = 0, serviceOptions, taxRate, serviceTaxable = true } = input;
  const lineItems = [];
  const baseAmount = 0;
  const optionsResult = calculateServiceOptions(serviceOptions);
  lineItems.push(...optionsResult.lineItems);
  let subtotal = optionsResult.cost;
  let minimumChargeApplied = false;
  if (minimumCharge > 0 && subtotal < minimumCharge) {
    const adjustment = roundCurrency(minimumCharge - subtotal);
    minimumChargeApplied = true;
    lineItems.push({
      id: generateLineItemId("minimum"),
      type: "minimum_adjustment" /* MINIMUM_ADJUSTMENT */,
      description: "Minimum Charge Adjustment",
      quantity: 1,
      rate: adjustment,
      amount: adjustment,
      taxable: serviceTaxable
    });
    subtotal = minimumCharge;
  }
  let taxableAmount = 0;
  for (const item of optionsResult.lineItems) {
    if (item.taxable) {
      taxableAmount += item.amount;
    }
  }
  if (minimumChargeApplied && serviceTaxable) {
    taxableAmount += roundCurrency(minimumCharge - optionsResult.cost);
  }
  const { taxAmount, taxBreakdown } = calculateTax(taxableAmount, taxRate);
  if (taxAmount > 0) {
    lineItems.push({
      id: generateLineItemId("tax"),
      type: "tax" /* TAX */,
      description: `Tax (${(taxRate * 100).toFixed(2)}%)`,
      quantity: 1,
      rate: taxRate,
      amount: taxAmount,
      taxable: false
    });
  }
  const total = roundCurrency(subtotal + taxAmount);
  return {
    billingMethod: "consumable" /* CONSUMABLE */,
    baseAmount,
    serviceOptionsAmount: optionsResult.cost,
    minimumChargeApplied,
    subtotal,
    taxAmount,
    total,
    lineItems,
    taxBreakdown,
    calculatedAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}
function calculateVisitPrice(input) {
  switch (input.billingMethod) {
    case "per_hour" /* PER_HOUR */:
      return calculateHourlyVisitPrice(input);
    case "per_visit" /* PER_VISIT */:
      return calculateFixedVisitPrice(input);
    case "package" /* PACKAGE */:
      return calculatePackageVisitPrice(input);
    case "consumable" /* CONSUMABLE */:
      return calculateConsumableVisitPrice(input);
    default:
      const _exhaustive = input;
      throw new Error(
        `Unknown billing method: ${_exhaustive.billingMethod}`
      );
  }
}
function buildServiceOptionsInput(definitions, selections) {
  return { definitions, selections };
}

// src/pricing/rounding.ts
function appliesRoundUpToCents(billingMethod) {
  let normalized;
  try {
    normalized = normalizeBillingMethod(billingMethod);
  } catch {
    return false;
  }
  return normalized === "per_visit" /* PER_VISIT */ || normalized === "package" /* PACKAGE */;
}
function applyDisplayRounding(amount, options) {
  let rate = roundCurrency(amount);
  if (rate <= 0 || !options) return rate;
  const { roundUpToCents, roundToNearest } = options;
  if (roundToNearest != null && roundToNearest > 0) {
    rate = roundCurrency(Math.round(rate / roundToNearest) * roundToNearest);
  }
  if (roundUpToCents != null) {
    const targetFraction = roundUpToCents / 100;
    const floor = Math.floor(rate);
    const currentCents = roundCurrency(rate - floor);
    if (currentCents <= targetFraction) {
      rate = roundCurrency(floor + targetFraction);
    } else {
      rate = roundCurrency(floor + 1 + targetFraction);
    }
  } else if (roundToNearest != null && roundToNearest > 0) {
    rate = roundCurrency(rate - 0.01);
  }
  return rate;
}

// src/pricing/moneyEnding.ts
var MONEY_ENDING_PRESETS = [
  { id: "c99", label: ".99", step: 1, ending: 0.99 },
  { id: "c00", label: ".00", step: 1, ending: 0 },
  { id: "c95", label: ".95", step: 1, ending: 0.95 },
  { id: "c50", label: ".50", step: 1, ending: 0.5 },
  { id: "d5", label: "$5", step: 5, ending: 0 },
  { id: "d10", label: "$10", step: 10, ending: 0 },
  { id: "d999", label: "$9.99", step: 10, ending: 9.99 },
  { id: "d25", label: "$25", step: 25, ending: 0 },
  { id: "d9999", label: "$99.99", step: 100, ending: 99.99 },
  { id: "d100", label: "$100", step: 100, ending: 0 }
];
var round2 = (n) => Math.round(n * 100) / 100;
function normalizeMoneyEnding(step, ending) {
  if (!(step > 0) || !Number.isFinite(ending)) return 0;
  let e = ending % step;
  if (e < 0) e += step;
  if (Math.abs(e - step) < 1e-9) e = 0;
  return round2(e);
}
function roundUpToMoneyEnding(value, step, ending) {
  if (!Number.isFinite(value) || value <= 0 || !(step > 0)) return value;
  const e = normalizeMoneyEnding(step, ending);
  const k = Math.ceil((value - e) / step - 1e-12);
  return round2(Math.max(0, k) * step + e);
}
function roundDownToMoneyEnding(value, step, ending) {
  if (!Number.isFinite(value) || value <= 0 || !(step > 0)) return value;
  const e = normalizeMoneyEnding(step, ending);
  const k = Math.floor((value - e) / step + 1e-12);
  if (k < 0) {
    return e > 0 && e <= value + 1e-12 ? e : 0;
  }
  return round2(k * step + e);
}
function roundNearestToMoneyEnding(value, step, ending) {
  if (!Number.isFinite(value) || value <= 0 || !(step > 0)) return value;
  const up = roundUpToMoneyEnding(value, step, ending);
  const down = roundDownToMoneyEnding(value, step, ending);
  if (Math.abs(up - value) <= Math.abs(value - down)) return up;
  return down;
}
function roundToMoneyEnding(value, step, ending, direction) {
  if (direction === "up") return roundUpToMoneyEnding(value, step, ending);
  if (direction === "down") return roundDownToMoneyEnding(value, step, ending);
  return roundNearestToMoneyEnding(value, step, ending);
}
function roundToCentsEnding(value, endingCents, direction) {
  return roundToMoneyEnding(value, 1, endingCents / 100, direction);
}
function pickExampleBefore(step, ending) {
  if (!(step > 0) || !Number.isFinite(ending)) return 20.6;
  if (step <= 1) {
    if (ending === 0.99) return 20.6;
    if (ending === 0.5) return 20.37;
    if (ending === 0.95) return 20.4;
    return 20.6;
  }
  const lo = ending > 0 ? ending : step;
  const hi = lo + step;
  return round2(lo + (hi - lo) * 0.35 + 0.07);
}
function applyMoneyEndingRound(amount, rounding) {
  if (!rounding || !(rounding.step > 0)) return amount;
  return roundToMoneyEnding(
    amount,
    rounding.step,
    rounding.ending,
    rounding.direction
  );
}
function applyCharmThenMoneyEnding(amount, options) {
  const afterCharm = applyDisplayRounding(amount, {
    roundUpToCents: options.roundUpToCents
  });
  return applyMoneyEndingRound(afterCharm, options.rateRounding);
}
function charmCentsFromRateRounding(rounding) {
  if (rounding.direction !== "up" || rounding.step !== 1) return void 0;
  const applyTo = rounding.applyTo ?? "season";
  if (applyTo !== "season") return void 0;
  if (rounding.ending < 0 || rounding.ending >= 1) return void 0;
  const cents = Math.round(rounding.ending * 100);
  if (cents < 0 || cents > 99) return void 0;
  return cents;
}
function unifiedRoundUpFromStorage(stored) {
  if (stored.rateRounding) return stored.rateRounding;
  if (stored.roundUpToCents != null) {
    return {
      direction: "up",
      step: 1,
      ending: stored.roundUpToCents / 100
    };
  }
  return null;
}
function unifiedRoundUpToStorage(next, previous) {
  if (next == null) {
    return {
      roundUpToCents: previous.roundUpToCents == null ? void 0 : null,
      rateRounding: previous.rateRounding == null ? void 0 : null
    };
  }
  const cents = charmCentsFromRateRounding(next);
  if (cents != null) {
    return {
      roundUpToCents: cents,
      rateRounding: previous.rateRounding == null ? void 0 : null
    };
  }
  return {
    roundUpToCents: previous.roundUpToCents == null ? void 0 : null,
    rateRounding: next
  };
}
function formatUnifiedRoundUp(stored) {
  const rounding = unifiedRoundUpFromStorage(stored);
  return rounding ? formatRateRounding(rounding) : null;
}
function rateRoundingAppliesToSeason(rounding) {
  if (!rounding) return false;
  const applyTo = rounding.applyTo ?? "season";
  return applyTo === "season" || applyTo === "both";
}
function rateRoundingAppliesToPerVisit(rounding) {
  if (!rounding) return false;
  const applyTo = rounding.applyTo ?? "season";
  return applyTo === "perVisit" || applyTo === "both";
}
function isValidRateRounding(value) {
  if (!value || typeof value !== "object") return false;
  const v = value;
  if (v.direction !== "up" && v.direction !== "down" && v.direction !== "nearest") {
    return false;
  }
  if (!(typeof v.step === "number" && Number.isFinite(v.step) && v.step > 0)) {
    return false;
  }
  if (!(typeof v.ending === "number" && Number.isFinite(v.ending) && v.ending >= 0)) {
    return false;
  }
  if (v.ending >= v.step + 1e-9) return false;
  if (v.applyTo != null && v.applyTo !== "season" && v.applyTo !== "perVisit" && v.applyTo !== "both") {
    return false;
  }
  return true;
}
function normalizeRateRounding(value) {
  const normalized = {
    direction: value.direction,
    step: round2(value.step),
    ending: normalizeMoneyEnding(value.step, value.ending)
  };
  if (value.applyTo) normalized.applyTo = value.applyTo;
  return normalized;
}
function formatRateRounding(rounding) {
  const preset = MONEY_ENDING_PRESETS.find(
    (p) => p.step === rounding.step && p.ending === rounding.ending
  );
  const endingLabel = preset?.label ?? `$${rounding.step} ending ${rounding.ending}`;
  const dir = rounding.direction === "up" ? "up" : rounding.direction === "down" ? "down" : "nearest";
  const apply = rounding.applyTo === "perVisit" ? " \xB7 per-visit" : rounding.applyTo === "both" ? " \xB7 season + per-visit" : "";
  return `${dir} ${endingLabel}${apply}`;
}

// src/helpers/budgetedVisitsForPricing.ts
function budgetedVisitsForPricing(option) {
  const budgeted = option.budgetedVisits;
  if (typeof budgeted === "number" && Number.isFinite(budgeted) && budgeted > 0) {
    return Math.round(budgeted);
  }
  const included = option.builtInVisits;
  if (typeof included === "number" && Number.isFinite(included) && included > 0) {
    return Math.round(included);
  }
  return 0;
}

// src/pricing/subscriptionRateCalculator.ts
var lineItemCounter2 = 0;
function generateLineItemId2(prefix) {
  return `${prefix}-${++lineItemCounter2}`;
}
function resetLineItemCounter2() {
  lineItemCounter2 = 0;
}
function volumeUnitRateFor(volumePricing, quantity) {
  if (!volumePricing || quantity <= 0) return null;
  if (volumePricing.type === "tiered" /* TIERED */ && volumePricing.tiers) {
    let previousBound = 0;
    for (const tier of sortedTiers(volumePricing.tiers)) {
      const tierUpperBound = tier.upperBound ?? Infinity;
      if (quantity > previousBound && quantity <= tierUpperBound) {
        const tierRange = tier.upperBound ? `${previousBound}-${tier.upperBound}` : `${previousBound}+`;
        return { rate: tier.rate, tierRange };
      }
      previousBound = tierUpperBound;
    }
    return null;
  }
  if (volumePricing.type === "per_unit" /* PER_UNIT */ && volumePricing.perUnitRate) {
    return { rate: volumePricing.perUnitRate };
  }
  return null;
}
function sortedTiers(tiers) {
  return [...tiers].sort((a, b) => {
    if (a.upperBound === void 0) return 1;
    if (b.upperBound === void 0) return -1;
    return a.upperBound - b.upperBound;
  });
}
function calculateVolumeCost(input) {
  const { volumePricing, customerMetrics } = input;
  if (!volumePricing?.enabled || !customerMetrics) {
    return { cost: 0, lineItems: [] };
  }
  const applicableMetrics = volumePricing.applicableMetrics || [];
  if (applicableMetrics.length === 0) {
    return { cost: 0, lineItems: [] };
  }
  let totalVolumeCost = 0;
  const lineItems = [];
  const unit = volumePricing.unit || "sqft";
  for (const metricType of applicableMetrics) {
    const metricKey = METRIC_TYPE_TO_KEY[metricType];
    const metricValue = metricKey ? customerMetrics[metricKey] || 0 : 0;
    const metricLabel = MEASUREMENT_TYPE_LABELS[metricType] ?? String(metricType);
    if (metricValue <= 0) continue;
    const priced = volumeUnitRateFor(volumePricing, metricValue);
    if (!priced) continue;
    const metricCost = roundCurrency(metricValue * priced.rate);
    totalVolumeCost += metricCost;
    lineItems.push({
      id: generateLineItemId2("volume"),
      type: "volume" /* VOLUME */,
      description: priced.tierRange !== void 0 ? `${metricLabel} (${metricValue} ${unit}, tier ${priced.tierRange})` : `${metricLabel} (${metricValue} ${unit})`,
      quantity: metricValue,
      rate: priced.rate,
      amount: metricCost
    });
  }
  return { cost: roundCurrency(totalVolumeCost), lineItems };
}
function calculateHourlyRate(input) {
  resetLineItemCounter2();
  const { hourlyRate, minimumCharge = 0, builtInHours = 0 } = input;
  const lineItems = [];
  lineItems.push({
    id: generateLineItemId2("hourly"),
    type: "labor" /* LABOR */,
    description: `Hourly Rate`,
    quantity: 1,
    rate: hourlyRate,
    amount: hourlyRate
  });
  if (minimumCharge > 0) {
    lineItems.push({
      id: generateLineItemId2("minimum"),
      type: "service" /* SERVICE */,
      description: `Minimum Charge (covers ${builtInHours} hours)`,
      quantity: 1,
      rate: minimumCharge,
      amount: minimumCharge
    });
  }
  return {
    billingMethod: "per_hour" /* PER_HOUR */,
    hourlyRate,
    minimumCharge,
    builtInHours,
    lineItems,
    calculatedAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}
function calculateFixedRate(input) {
  resetLineItemCounter2();
  const {
    pricingMethod,
    hourlyRate,
    budgetedHours,
    minimumCharge = 0,
    builtInHours = 0
  } = input;
  const lineItems = [];
  let laborCost = 0;
  let volumeCost = 0;
  let minimumChargeApplied = 0;
  const isUnitBased = pricingMethod === "unit_based" /* UNIT_BASED */;
  const isFixedPrice = pricingMethod === "fixed_price" /* FIXED_PRICE */;
  if (isFixedPrice) {
    laborCost = roundCurrency(hourlyRate);
    lineItems.push({
      id: generateLineItemId2("labor"),
      type: "service" /* SERVICE */,
      description: "Fixed Price",
      quantity: 1,
      rate: hourlyRate,
      amount: laborCost
    });
  }
  if (isUnitBased) {
    const volumeResult = calculateVolumeCost(input);
    volumeCost = volumeResult.cost;
    lineItems.push(...volumeResult.lineItems);
  }
  if (!isUnitBased && !isFixedPrice && budgetedHours > 0) {
    if (minimumCharge > 0 && builtInHours > 0) {
      if (budgetedHours <= builtInHours) {
        laborCost = 0;
        lineItems.push({
          id: generateLineItemId2("labor"),
          type: "labor" /* LABOR */,
          description: `Labor (${budgetedHours} hours covered by minimum)`,
          quantity: budgetedHours,
          rate: hourlyRate,
          amount: 0
        });
      } else {
        const additionalHours = budgetedHours - builtInHours;
        laborCost = roundCurrency(additionalHours * hourlyRate);
        lineItems.push({
          id: generateLineItemId2("labor"),
          type: "labor" /* LABOR */,
          description: "Additional Hours",
          quantity: additionalHours,
          rate: hourlyRate,
          amount: laborCost
        });
      }
    } else {
      laborCost = roundCurrency(budgetedHours * hourlyRate);
      lineItems.push({
        id: generateLineItemId2("labor"),
        type: "labor" /* LABOR */,
        description: `Labor (${budgetedHours} hours)`,
        quantity: budgetedHours,
        rate: hourlyRate,
        amount: laborCost
      });
    }
  }
  const subtotal = laborCost + volumeCost;
  let finalTotal = subtotal;
  if (minimumCharge > 0) {
    if (isUnitBased) {
      if (subtotal < minimumCharge) {
        minimumChargeApplied = minimumCharge;
        finalTotal = minimumCharge;
        lineItems.unshift({
          id: generateLineItemId2("minimum"),
          type: "minimum_adjustment" /* MINIMUM_ADJUSTMENT */,
          description: "Minimum Charge Applied",
          quantity: 1,
          rate: minimumCharge,
          amount: minimumCharge
        });
      }
    } else if (builtInHours > 0) {
      if (budgetedHours <= builtInHours) {
        finalTotal = minimumCharge;
        minimumChargeApplied = minimumCharge;
      } else {
        finalTotal = minimumCharge + laborCost + volumeCost;
        minimumChargeApplied = minimumCharge;
      }
      lineItems.unshift({
        id: generateLineItemId2("minimum"),
        type: "service" /* SERVICE */,
        description: `Minimum Charge (covers ${builtInHours} hours)`,
        quantity: 1,
        rate: minimumCharge,
        amount: minimumCharge
      });
    } else {
      if (subtotal < minimumCharge) {
        minimumChargeApplied = minimumCharge;
        finalTotal = minimumCharge;
        lineItems.unshift({
          id: generateLineItemId2("minimum"),
          type: "minimum_adjustment" /* MINIMUM_ADJUSTMENT */,
          description: "Minimum Charge Applied",
          quantity: 1,
          rate: minimumCharge,
          amount: minimumCharge
        });
      }
    }
  }
  const rawRate = roundCurrency(finalTotal);
  const rate = applyCharmThenMoneyEnding(rawRate, {
    roundUpToCents: input.roundUpToCents,
    rateRounding: input.rateRounding
  });
  const preRoundingRate = rate !== rawRate ? rawRate : void 0;
  return {
    billingMethod: "per_visit" /* PER_VISIT */,
    pricingMethod,
    rate,
    preRoundingRate,
    components: {
      laborCost,
      volumeCost,
      minimumChargeApplied
    },
    lineItems,
    calculatedAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}
function calculatePackageRate(input) {
  resetLineItemCounter2();
  const { hourlyRate, hoursPerVisit, selectedOption } = input;
  const { builtInVisits, isUnlimitedVisits, name } = selectedOption;
  const visitsForPricing2 = budgetedVisitsForPricing(selectedOption);
  const lineItems = [];
  const calculatedPricePerVisit = roundCurrency(hourlyRate * hoursPerVisit);
  const rawPackageAmount = roundCurrency(calculatedPricePerVisit * visitsForPricing2);
  const packageAmount = applyCharmThenMoneyEnding(rawPackageAmount, {
    roundUpToCents: input.roundUpToCents,
    rateRounding: rateRoundingAppliesToSeason(input.rateRounding) ? input.rateRounding : void 0
  });
  const preRoundingRate = packageAmount !== rawPackageAmount ? rawPackageAmount : void 0;
  let pricePerAdditionalVisit = calculatedPricePerVisit;
  if (rateRoundingAppliesToPerVisit(input.rateRounding)) {
    pricePerAdditionalVisit = applyMoneyEndingRound(
      pricePerAdditionalVisit,
      input.rateRounding
    );
  }
  if (isUnlimitedVisits) {
    lineItems.push({
      id: generateLineItemId2("package"),
      type: "service" /* SERVICE */,
      description: `${name} (${visitsForPricing2} visits for pricing @ $${calculatedPricePerVisit}/visit)`,
      quantity: visitsForPricing2,
      rate: calculatedPricePerVisit,
      amount: rawPackageAmount
    });
  } else {
    lineItems.push({
      id: generateLineItemId2("package"),
      type: "service" /* SERVICE */,
      description: `${name} (${visitsForPricing2} visits @ $${calculatedPricePerVisit}/visit)`,
      quantity: visitsForPricing2,
      rate: calculatedPricePerVisit,
      amount: rawPackageAmount
    });
  }
  return {
    billingMethod: "package" /* PACKAGE */,
    packageAmount,
    preRoundingRate,
    pricePerAdditionalVisit: isUnlimitedVisits ? void 0 : pricePerAdditionalVisit,
    builtInVisits,
    isUnlimitedVisits,
    lineItems,
    calculatedAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}
function calculateConsumableRate(input) {
  resetLineItemCounter2();
  const { minimumCharge = 0 } = input;
  const lineItems = [];
  lineItems.push({
    id: generateLineItemId2("consumable"),
    type: "service" /* SERVICE */,
    description: "Usage-based pricing (service options)",
    quantity: 1,
    rate: 0,
    amount: 0
  });
  if (minimumCharge > 0) {
    lineItems.push({
      id: generateLineItemId2("minimum"),
      type: "minimum_adjustment" /* MINIMUM_ADJUSTMENT */,
      description: `Minimum Charge`,
      quantity: 1,
      rate: minimumCharge,
      amount: minimumCharge
    });
  }
  return {
    billingMethod: "consumable" /* CONSUMABLE */,
    minimumCharge,
    lineItems,
    calculatedAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}
function calculateSubscriptionRate(input) {
  switch (input.billingMethod) {
    case "per_hour" /* PER_HOUR */:
      return calculateHourlyRate(input);
    case "per_visit" /* PER_VISIT */:
      return calculateFixedRate(input);
    case "package" /* PACKAGE */:
      return calculatePackageRate(input);
    case "consumable" /* CONSUMABLE */:
      return calculateConsumableRate(input);
    default:
      const _exhaustive = input;
      throw new Error(`Unknown billing method: ${_exhaustive.billingMethod}`);
  }
}
function calculateSubscriptionRateFromEntities(template, customerMetrics, budgetedHours, selectedPackageOptionId) {
  const billingMethod = normalizeBillingMethod(template.billingMethod);
  switch (billingMethod) {
    case "per_hour" /* PER_HOUR */:
      return calculateSubscriptionRate({
        billingMethod: "per_hour" /* PER_HOUR */,
        hourlyRate: template.hourlyRate || 0,
        minimumCharge: template.minimumCharge ?? void 0,
        builtInHours: template.builtInHours ?? void 0
      });
    case "per_visit" /* PER_VISIT */:
      return calculateSubscriptionRate({
        billingMethod: "per_visit" /* PER_VISIT */,
        pricingMethod: template.pricingMethod || "billable_labor_rate" /* BILLABLE_LABOR_RATE */,
        hourlyRate: template.hourlyRate || 0,
        budgetedHours: budgetedHours ?? template.hourBounds?.budgetedHours ?? 0,
        minimumCharge: template.minimumCharge ?? void 0,
        builtInHours: template.builtInHours ?? void 0,
        roundUpToCents: template.roundUpToCents,
        rateRounding: template.rateRounding,
        volumePricing: template.volumePricing ? {
          enabled: template.volumePricing.enabled,
          type: template.volumePricing.type,
          unit: template.volumePricing.unit,
          perUnitRate: template.volumePricing.perUnitRate,
          tiers: template.volumePricing.tiers,
          applicableMetrics: template.volumePricing.applicableMetrics
        } : void 0,
        // Snapshot every surface, not just the landscape three, so a template
        // priced by driveway or sidewalk sq ft sees its metric.
        customerMetrics: customerMetrics ? { ...customerMetrics } : void 0
      });
    case "package" /* PACKAGE */: {
      const packagePricing = template.packagePricing;
      if (!packagePricing?.options?.length) {
        throw new Error("Package billing requires at least one package option");
      }
      const selectedOption = selectedPackageOptionId ? packagePricing.options.find((o) => o.id === selectedPackageOptionId) : packagePricing.options.find((o) => o.isActive);
      if (!selectedOption) {
        throw new Error("No valid package option found");
      }
      return calculateSubscriptionRate({
        billingMethod: "package" /* PACKAGE */,
        hourlyRate: template.hourlyRate || 0,
        hoursPerVisit: budgetedHours ?? template.hourBounds?.budgetedHours ?? template.builtInHours ?? 1,
        selectedOption,
        roundUpToCents: template.roundUpToCents,
        rateRounding: template.rateRounding
      });
    }
    case "consumable" /* CONSUMABLE */:
      return calculateSubscriptionRate({
        billingMethod: "consumable" /* CONSUMABLE */,
        minimumCharge: template.minimumCharge ?? void 0
      });
    default: {
      const _exhaustive = billingMethod;
      throw new Error(`Unknown billing method: ${_exhaustive}`);
    }
  }
}
function calculateHoursFromPrice(template, targetPrice, customerMetrics = {}) {
  if (targetPrice <= 0) return 0;
  if (template.billingMethod === "consumable" /* CONSUMABLE */) return 0;
  const hourlyRate = template.hourlyRate || 0;
  if (hourlyRate <= 0) return 0;
  const minimumCharge = template.minimumCharge || 0;
  const builtInHours = template.builtInHours || 0;
  let volumeCost = 0;
  const isUnitBased = template.pricingMethod === "unit_based" /* UNIT_BASED */;
  if (isUnitBased && template.volumePricing?.enabled) {
    const applicableMetrics = template.volumePricing.applicableMetrics || [];
    for (const metricType of applicableMetrics) {
      const metricKey = METRIC_TYPE_TO_KEY[metricType];
      const metricValue = metricKey ? customerMetrics[metricKey] || 0 : 0;
      if (metricValue > 0) {
        if (template.volumePricing.type === "tiered" /* TIERED */ && template.volumePricing.tiers) {
          const sortedTiers2 = [...template.volumePricing.tiers].sort((a, b) => {
            if (a.upperBound === void 0) return 1;
            if (b.upperBound === void 0) return -1;
            return a.upperBound - b.upperBound;
          });
          let previousBound = 0;
          for (const tier of sortedTiers2) {
            const tierUpperBound = tier.upperBound ?? Infinity;
            if (metricValue > previousBound && metricValue <= tierUpperBound) {
              volumeCost += metricValue * tier.rate;
              break;
            }
            previousBound = tierUpperBound;
          }
        } else if (template.volumePricing.type === "per_unit" /* PER_UNIT */ && template.volumePricing.perUnitRate) {
          volumeCost += metricValue * template.volumePricing.perUnitRate;
        }
      }
    }
  }
  if (minimumCharge > 0) {
    if (targetPrice <= minimumCharge) {
      return builtInHours;
    }
    if (builtInHours > 0) {
      const laborCostNeeded2 = targetPrice - minimumCharge - volumeCost;
      if (laborCostNeeded2 <= 0) {
        return builtInHours;
      }
      const additionalHours = laborCostNeeded2 / hourlyRate;
      return builtInHours + additionalHours;
    }
  }
  const laborCostNeeded = targetPrice - volumeCost;
  if (laborCostNeeded <= 0) return 0;
  const hoursNeeded = laborCostNeeded / hourlyRate;
  return Math.max(0, Math.round(hoursNeeded * 4) / 4);
}

// src/types/contact.ts
var ContactType = /* @__PURE__ */ ((ContactType2) => {
  ContactType2["EMAIL"] = "EMAIL";
  ContactType2["PHONE"] = "PHONE";
  return ContactType2;
})(ContactType || {});
var ContactVerificationStatus = /* @__PURE__ */ ((ContactVerificationStatus2) => {
  ContactVerificationStatus2["PENDING"] = "PENDING";
  ContactVerificationStatus2["VERIFIED"] = "VERIFIED";
  ContactVerificationStatus2["FAILED"] = "FAILED";
  return ContactVerificationStatus2;
})(ContactVerificationStatus || {});
var SMS_CONSENT_DISCLOSURE = "I agree to receive text messages, including service visit reminders, scheduling and payment alerts, service completion updates, and account verification codes. Frequency varies (2\u20138 messages/month). Message and data rates may apply. Reply STOP to unsubscribe at any time.";
var SMS_CONSENT_VERSION = 1;
var SMS_PROGRAM_CONSENT_VERSION = 3;
var SMS_CONSENT_DETAILS = "Message frequency varies. Message & data rates may apply. Reply STOP to opt out or HELP for help. Consent is optional and is not a condition of purchase. We do not sell or share mobile information with third parties for marketing.";
function buildSmsConsentLabel(name, marketing = false) {
  return marketing ? `I agree to marketing texts from ${name} (offers and promotions).` : `I agree to service texts from ${name} (appointments, billing and support).`;
}
function buildSmsConsentDisclosure(name, marketing = false) {
  return `${buildSmsConsentLabel(name, marketing)} ${SMS_CONSENT_DETAILS}`;
}
function smsConsentEvidenceFields(consent) {
  return {
    ...consent.granted !== false ? { smsConsentAt: consent.at } : {},
    smsConsentSource: consent.source,
    smsConsentText: consent.text,
    smsConsentVersion: consent.version,
    ...consent.granted !== void 0 ? {
      smsConsentGranted: consent.granted,
      smsMarketingConsentGranted: consent.marketingGranted === true,
      smsConsentRecordedAt: consent.at,
      ...consent.marketingGranted ? {
        smsMarketingConsentAt: consent.at,
        smsMarketingConsentText: consent.marketingText
      } : {}
    } : {}
  };
}
var SmsConsentSource = /* @__PURE__ */ ((SmsConsentSource2) => {
  SmsConsentSource2["PORTAL_SIGNUP"] = "portal_signup";
  SmsConsentSource2["PHONE_REPLACEMENT"] = "phone_replacement";
  SmsConsentSource2["INBOUND_KEYWORD"] = "inbound_keyword";
  SmsConsentSource2["STAFF_ATTESTED"] = "staff_attested";
  SmsConsentSource2["IMPORT_ATTESTED"] = "import_attested";
  return SmsConsentSource2;
})(SmsConsentSource || {});
var EmailValidation = {
  /**
   * Check if email format is valid
   */
  isValidEmail: (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  },
  /**
   * Check if email is a business email (not free providers)
   */
  isBusinessEmail: (email) => {
    const freeProviders = [
      "gmail.com",
      "yahoo.com",
      "hotmail.com",
      "outlook.com",
      "aol.com",
      "icloud.com",
      "protonmail.com",
      "mail.com"
    ];
    const domain = email.split("@")[1]?.toLowerCase();
    return domain ? !freeProviders.includes(domain) : false;
  },
  /**
   * Normalize email for comparison
   */
  normalizeEmail: (email) => {
    return email.trim().toLowerCase();
  }
};

// src/types/tax.ts
var TaxApiError = class extends Error {
  constructor(message, code, status) {
    super(message);
    this.code = code;
    this.status = status;
    this.name = "TaxApiError";
  }
};

// src/helpers/period.ts
function validatePeriods(periods) {
  for (const period of periods) {
    if (!period.name || period.name.trim().length === 0) {
      return "Period name is required";
    }
    if (period.startMonth < 1 || period.startMonth > 12) {
      return "Start month must be between 1 and 12";
    }
    if (period.endMonth < 1 || period.endMonth > 12) {
      return "End month must be between 1 and 12";
    }
    if (period.startDay < 1 || period.startDay > 31) {
      return "Start day must be between 1 and 31";
    }
    if (period.endDay < 1 || period.endDay > 31) {
      return "End day must be between 1 and 31";
    }
  }
  return null;
}
var PeriodHelpers = {
  /**
   * Sort periods in calendar order — earliest start date first
   * (month, then day). The same rule applies to periods that cross
   * year boundaries: a Nov–Mar season sorts by November and lands
   * at the end of the year, after July/September seasons.
   *
   * Always returns a new array so the input is never mutated.
   */
  sortByCalendarOrder(periods) {
    if (!periods?.length) return [];
    return [...periods].sort((a, b) => {
      const aKey = a.startMonth * 100 + a.startDay;
      const bKey = b.startMonth * 100 + b.startDay;
      return aKey - bKey;
    });
  },
  /**
   * Check if a specific period is currently active based on its date range.
   * Handles periods that cross year boundaries (e.g., Nov 1 - Mar 31).
   */
  isPeriodActive(period, currentDate = /* @__PURE__ */ new Date()) {
    if (!period.isActive) return false;
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth() + 1;
    const day = currentDate.getDate();
    const currentMonthDay = month * 100 + day;
    const startMonthDay = period.startMonth * 100 + period.startDay;
    const endMonthDay = period.endMonth * 100 + period.endDay;
    if (startMonthDay > endMonthDay) {
      return currentMonthDay >= startMonthDay || currentMonthDay <= endMonthDay;
    }
    return currentMonthDay >= startMonthDay && currentMonthDay <= endMonthDay;
  },
  /**
   * Get the currently active period from a list of periods.
   */
  getActivePeriod(periods, currentDate = /* @__PURE__ */ new Date()) {
    if (!periods?.length) return void 0;
    return periods.find((period) => this.isPeriodActive(period, currentDate));
  },
  /**
   * Check if today is the charge date (period start) for a period.
   * For packages: charge happens on the first day of the period.
   *
   * @deprecated Server-local time, no snow cutoff. Package charge and reset
   * days come from `getPackageSeasonDates` /
   * `ServiceTemplateHelpers.isPackageChargeDateToday` / `isPackageResetDateToday`
   * (RUT-4051). No callers remain.
   */
  isChargeDate(period, currentDate = /* @__PURE__ */ new Date()) {
    if (!period.isActive) return false;
    const month = currentDate.getMonth() + 1;
    const day = currentDate.getDate();
    return month === period.startMonth && day === period.startDay;
  },
  /**
   * Check if today is the reset date (period end) for a period.
   * For packages: visit counts reset on the last day of the period.
   *
   * @deprecated Server-local time, no snow cutoff. Package charge and reset
   * days come from `getPackageSeasonDates` /
   * `ServiceTemplateHelpers.isPackageChargeDateToday` / `isPackageResetDateToday`
   * (RUT-4051). No callers remain.
   */
  isResetDate(period, currentDate = /* @__PURE__ */ new Date()) {
    if (!period.isActive) return false;
    const month = currentDate.getMonth() + 1;
    const day = currentDate.getDate();
    return month === period.endMonth && day === period.endDay;
  },
  /**
   * Check if acceptance is currently open for a period given a deadline.
   * Acceptance is only available between the reset date (period end) and the deadline.
   * If we're inside the active period or past the deadline, acceptance is closed.
   *
   * @param period The period to check
   * @param deadlineMonth Optional deadline month (1-12), from PackageOption
   * @param deadlineDay Optional deadline day (1-31), from PackageOption
   * @param currentDate Current date for testing
   */
  isAcceptanceOpen(period, deadlineMonth, deadlineDay, currentDate = /* @__PURE__ */ new Date()) {
    if (!period.isActive || !deadlineMonth || !deadlineDay) {
      return true;
    }
    if (this.isPeriodActive(period, currentDate)) {
      return false;
    }
    const month = currentDate.getMonth() + 1;
    const day = currentDate.getDate();
    const currentMonthDay = month * 100 + day;
    const deadlineMonthDay = deadlineMonth * 100 + deadlineDay;
    const endMonthDay = period.endMonth * 100 + period.endDay;
    const startMonthDay = period.startMonth * 100 + period.startDay;
    const periodCrossesYear = startMonthDay > endMonthDay;
    if (periodCrossesYear) {
      return currentMonthDay <= deadlineMonthDay;
    }
    if (deadlineMonthDay < startMonthDay) {
      return currentMonthDay > endMonthDay || currentMonthDay <= deadlineMonthDay;
    }
    return currentMonthDay > endMonthDay && currentMonthDay <= deadlineMonthDay;
  },
  /**
   * Get the period start date for the current or most recent occurrence.
   * Handles periods that span year boundaries.
   */
  getPeriodStartDate(period, currentDate = /* @__PURE__ */ new Date()) {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth() + 1;
    const startThisYear = new Date(
      year,
      period.startMonth - 1,
      period.startDay
    );
    if (currentDate >= startThisYear) {
      return startThisYear;
    }
    return new Date(year - 1, period.startMonth - 1, period.startDay);
  },
  /**
   * Get the period end date for the current occurrence.
   * Handles periods that span year boundaries.
   */
  getPeriodEndDate(period, currentDate = /* @__PURE__ */ new Date()) {
    const year = currentDate.getFullYear();
    const startDate = this.getPeriodStartDate(period, currentDate);
    const startYear = startDate.getFullYear();
    if (period.startMonth > period.endMonth) {
      return new Date(startYear + 1, period.endMonth - 1, period.endDay);
    }
    return new Date(startYear, period.endMonth - 1, period.endDay);
  },
  /**
   * Get a human-readable name for the period for the current year.
   * E.g., "Snow Season 2024-25" for a Nov-Mar period in late 2024.
   */
  getPeriodDisplayName(period, currentDate = /* @__PURE__ */ new Date()) {
    const startDate = this.getPeriodStartDate(period, currentDate);
    const endDate = this.getPeriodEndDate(period, currentDate);
    const startYear = startDate.getFullYear();
    const endYear = endDate.getFullYear();
    if (startYear === endYear) {
      return `${period.name} ${startYear}`;
    }
    return `${period.name} ${startYear}-${String(endYear).slice(-2)}`;
  },
  /**
   * Get period info for visit counting purposes.
   * Returns the period start date and display name.
   */
  getCurrentPeriodInfo(periods, currentDate = /* @__PURE__ */ new Date()) {
    const activePeriod = this.getActivePeriod(periods, currentDate);
    if (!activePeriod) return null;
    const startDate = this.getPeriodStartDate(activePeriod, currentDate);
    const displayName = this.getPeriodDisplayName(activePeriod, currentDate);
    return {
      periodStartDate: startDate.toISOString().split("T")[0],
      periodName: displayName
    };
  },
  /**
   * Find any period where today is the charge date (period start).
   * Used by billing jobs to determine which templates to charge.
   *
   * @deprecated Server-local time, no snow cutoff. Package charge and reset
   * days come from `getPackageSeasonDates` /
   * `ServiceTemplateHelpers.isPackageChargeDateToday` / `isPackageResetDateToday`
   * (RUT-4051). No callers remain.
   */
  findPeriodToCharge(periods, currentDate = /* @__PURE__ */ new Date()) {
    if (!periods?.length) return void 0;
    return periods.find(
      (period) => period.isActive && this.isChargeDate(period, currentDate)
    );
  },
  /**
   * Find any period where today is the reset date (period end).
   * Used by billing jobs to determine which templates to reset.
   *
   * @deprecated Server-local time, no snow cutoff. Package charge and reset
   * days come from `getPackageSeasonDates` /
   * `ServiceTemplateHelpers.isPackageChargeDateToday` / `isPackageResetDateToday`
   * (RUT-4051). No callers remain.
   */
  findPeriodToReset(periods, currentDate = /* @__PURE__ */ new Date()) {
    if (!periods?.length) return void 0;
    return periods.find(
      (period) => period.isActive && this.isResetDate(period, currentDate)
    );
  }
};

// src/helpers/serviceTemplate.ts
function appliesToAbsentMetric(applicableMetrics, absentMetrics) {
  if (!absentMetrics?.length || !applicableMetrics?.length) return false;
  return applicableMetrics.some((m) => absentMetrics.includes(m));
}
function isTemplateOfferableForProperty(template, absentMetrics) {
  return !appliesToAbsentMetric(
    template.volumePricing?.applicableMetrics,
    absentMetrics
  );
}
function resolveTemplateCustomerVisibility(template) {
  if (template.customerVisible !== false) return "everyone";
  return template.visibleToActiveSubscribers === true ? "existing" : "no-one";
}
function isRetiredForActiveSubscribers(template) {
  return resolveTemplateCustomerVisibility(template) === "existing";
}
function resolvePairedTemplateIds(templateId, templates) {
  const ids = /* @__PURE__ */ new Set();
  const self = templates.find((t) => t.id === templateId);
  for (const id of self?.pairedServices ?? []) {
    if (id !== templateId) ids.add(id);
  }
  for (const t of templates) {
    if (t.id === templateId) continue;
    if (t.pairedServices?.includes(templateId)) ids.add(t.id);
  }
  return [...ids];
}
function resolveEffectiveMinimumCharge(subscription, template) {
  const min = subscription?.minimumCharge ?? template?.minimumCharge;
  return typeof min === "number" && min > 0 ? min : null;
}
function resolveEffectiveBuiltInHours(subscription, template) {
  const hours = subscription?.builtInHours ?? template?.builtInHours;
  return typeof hours === "number" && hours > 0 ? hours : null;
}
function compareByServiceTemplateOrder(a, b, getSortOrder, getName) {
  const aOrder = getSortOrder(a);
  const bOrder = getSortOrder(b);
  const aHas = aOrder != null;
  const bHas = bOrder != null;
  if (aHas && bHas) {
    if (aOrder !== bOrder) return aOrder - bOrder;
    return getName(a).localeCompare(getName(b));
  }
  if (aHas) return -1;
  if (bHas) return 1;
  return getName(a).localeCompare(getName(b));
}
function isPhotoRequiredForVisit(photoRequirement, completedAllTimeCount) {
  if (!photoRequirement) return false;
  if (photoRequirement.mode === "every-visit") return true;
  if (photoRequirement.mode === "every-n-visits") {
    const n = photoRequirement.n;
    if (n === void 0 || n <= 0) return false;
    const position = completedAllTimeCount + 1;
    return position % n === 0;
  }
  return false;
}
function resolveEffectiveReviewCadence(template) {
  if (!template) return void 0;
  if (template.reviewCadence) return template.reviewCadence;
  return template.alwaysReviewVisits ? { mode: "every-visit" } : void 0;
}
function isReviewRequiredForVisit(reviewCadence, completedAllTimeCount) {
  if (!reviewCadence) return false;
  if (reviewCadence.mode === "every-visit") return true;
  if (reviewCadence.mode === "first-x-visits") {
    const x = reviewCadence.x;
    if (x === void 0 || x <= 0) return false;
    const position = completedAllTimeCount + 1;
    return position <= x;
  }
  return false;
}
function hasVisitCountedSince(subscription, since) {
  const counts = subscription?.visitCounts;
  if (!counts?.allTime) return false;
  const countedAt = counts.lastUpdatedAt;
  if (!since || !countedAt) return true;
  return countedAt >= since;
}
function isProofOfServiceVisit(requireProofOfService, subscription) {
  const templateArmed = !!requireProofOfService && !hasVisitCountedSince(subscription, subscription?.activatedAt);
  const armedByHand = subscription?.proofOfServiceArmedAt;
  const leverArmed = !!armedByHand && !hasVisitCountedSince(subscription, armedByHand);
  return templateArmed || leverArmed;
}
var SNOW_PLAN_CUTOFF = { month: 10, day: 15 };
var SNOW_SEASON_END = { month: 4, day: 15 };
var SNOW_PLAN_TIMEZONE = DEFAULT_DISPLAY_TIMEZONE;
function isSnowSeasonPackage(template) {
  if (template.billingMethod && template.billingMethod !== "package" /* PACKAGE */) {
    return false;
  }
  const fields = [template.category, template.name, template.serviceTemplateName].filter((s) => !!s).map((s) => s.toLowerCase());
  return fields.some((field) => field.includes("snow"));
}
function getChicagoYmd(instant = /* @__PURE__ */ new Date()) {
  const ymd2 = getDateInTimezone(instant.toISOString(), SNOW_PLAN_TIMEZONE);
  const [year, month, day] = ymd2.split("-").map(Number);
  return { year, month, day };
}
function isOnOrAfterSnowPlanCutoff(instant = /* @__PURE__ */ new Date()) {
  const { year } = getChicagoYmd(instant);
  const month = String(SNOW_PLAN_CUTOFF.month).padStart(2, "0");
  const day = String(SNOW_PLAN_CUTOFF.day).padStart(2, "0");
  const cutoff = startOfDayInTimezone(`${year}-${month}-${day}`, SNOW_PLAN_TIMEZONE);
  return instant.getTime() >= cutoff.getTime();
}
function getSnowPlanLockReason(instant = /* @__PURE__ */ new Date()) {
  const { month, day } = getChicagoYmd(instant);
  const md = month * 100 + day;
  const cutoffMd = SNOW_PLAN_CUTOFF.month * 100 + SNOW_PLAN_CUTOFF.day;
  const seasonEndMd = SNOW_SEASON_END.month * 100 + SNOW_SEASON_END.day;
  if (md >= cutoffMd) return "past_cutoff";
  if (md <= seasonEndMd) return "in_season";
  return null;
}
function getPackagePlanEditMode(svc, now = /* @__PURE__ */ new Date()) {
  const isPackage = svc.billingMethod === "package" /* PACKAGE */;
  const isActive = svc.subscriptionStatus === "active" /* ACTIVE */;
  const isSnow = isSnowSeasonPackage(svc);
  const canChange = ServiceTemplateHelpers.canChangePackagePlan(svc, now);
  return {
    canSavePlanChange: !!(isPackage && isActive && isSnow && canChange),
    isPlanPickerLocked: !!(isPackage && isActive && isSnow && !canChange)
  };
}
var ymdKey = (d) => d.year * 1e4 + d.month * 100 + d.day;
var ymdDayNumber = (d) => Date.UTC(d.year, d.month - 1, d.day) / 864e5;
var pad2 = (n) => String(n).padStart(2, "0");
function seasonOccurrence(period, today) {
  const s = period.startMonth * 100 + period.startDay;
  const e = period.endMonth * 100 + period.endDay;
  const t = today.month * 100 + today.day;
  const y = today.year;
  const at = (year, month, day) => ({ year, month, day });
  const crossesYear = s > e;
  if (crossesYear) {
    if (t >= s) {
      return { start: at(y, period.startMonth, period.startDay), end: at(y + 1, period.endMonth, period.endDay), inSeason: true };
    }
    if (t <= e) {
      return { start: at(y - 1, period.startMonth, period.startDay), end: at(y, period.endMonth, period.endDay), inSeason: true };
    }
    return { start: at(y, period.startMonth, period.startDay), end: at(y + 1, period.endMonth, period.endDay), inSeason: false };
  }
  if (t < s) {
    return { start: at(y, period.startMonth, period.startDay), end: at(y, period.endMonth, period.endDay), inSeason: false };
  }
  if (t <= e) {
    return { start: at(y, period.startMonth, period.startDay), end: at(y, period.endMonth, period.endDay), inSeason: true };
  }
  return { start: at(y + 1, period.startMonth, period.startDay), end: at(y + 1, period.endMonth, period.endDay), inSeason: false };
}
function snowCutoffForSeason(seasonStart, seasonEnd) {
  const candidates = [seasonStart.year - 1, seasonStart.year, seasonStart.year + 1].map(
    (year) => ({ year, month: SNOW_PLAN_CUTOFF.month, day: SNOW_PLAN_CUTOFF.day })
  );
  const inside = candidates.find(
    (c) => ymdKey(c) >= ymdKey(seasonStart) && ymdKey(c) <= ymdKey(seasonEnd)
  );
  if (inside) return inside;
  const startDay = ymdDayNumber(seasonStart);
  const nearest = candidates.reduce(
    (best, c) => Math.abs(ymdDayNumber(c) - startDay) < Math.abs(ymdDayNumber(best) - startDay) ? c : best
  );
  return ymdKey(nearest) > ymdKey(seasonEnd) ? seasonStart : nearest;
}
function getPackageSeasonDates(template, now = /* @__PURE__ */ new Date()) {
  const periods = template.periods?.length ? template.periods : template.seasonalAvailability;
  const enabled = (periods ?? []).filter((p) => p?.isActive);
  if (!enabled.length) return null;
  const today = getChicagoYmd(now);
  const occurrences = enabled.map((period) => ({ period, ...seasonOccurrence(period, today) }));
  const running = occurrences.filter((o) => o.inSeason);
  const chosen = running.length ? running.reduce((a, b) => ymdKey(b.start) > ymdKey(a.start) ? b : a) : occurrences.reduce((a, b) => ymdKey(b.start) < ymdKey(a.start) ? b : a);
  const chargeOn = isSnowSeasonPackage(template) ? snowCutoffForSeason(chosen.start, chosen.end) : chosen.start;
  const chargeAt = startOfDayInTimezone(
    `${chargeOn.year}-${pad2(chargeOn.month)}-${pad2(chargeOn.day)}`,
    SNOW_PLAN_TIMEZONE
  );
  return {
    period: chosen.period,
    inSeason: chosen.inSeason,
    seasonStart: chosen.start,
    seasonEnd: chosen.end,
    chargeOn,
    resetOn: chosen.end,
    chargeAt,
    seasonKey: chargeOn.year
  };
}
function formatPackageMonthDay(d) {
  return `${monthAbbr(d.month)} ${d.day}`;
}
function describePackageChargeDates(template, now = /* @__PURE__ */ new Date()) {
  const dates = getPackageSeasonDates(template, now);
  if (!dates) return "No charge date. Add a season";
  return `Charged on ${formatPackageMonthDay(dates.chargeOn)} \xB7 resets ${formatPackageMonthDay(dates.resetOn)}`;
}
var ServiceTemplateHelpers = {
  /**
   * Get the periods to check for a template.
   * Returns periods if available, otherwise falls back to seasonalAvailability.
   */
  getPeriods(template) {
    if (template.periods?.length) return template.periods;
    return template.seasonalAvailability;
  },
  /**
   * Check if a service template is currently in season (or active period).
   * Periods take precedence over the stored `isYearRound` flag: if any period
   * is configured on the template, the flag is ignored. Templates with no
   * period config (and the isYearRound=true case) fall back to year-round.
   */
  isCurrentlyInSeason(template, currentDate = /* @__PURE__ */ new Date()) {
    const periods = this.getPeriods(template);
    if (periods?.length) {
      return periods.some((period) => PeriodHelpers.isPeriodActive(period, currentDate));
    }
    return true;
  },
  /**
   * Whether the template is currently in its OFFSEASON — i.e. not in season.
   * The inverse of {@link isCurrentlyInSeason}. Templates with no period config
   * are year-round, so they are never in offseason.
   *
   * This is the window in which a customer may change their plan
   * (package option) selection for the upcoming season (RUT-1947).
   */
  isInOffseason(template, currentDate = /* @__PURE__ */ new Date()) {
    return !this.isCurrentlyInSeason(template, currentDate);
  },
  /**
   * Whether a customer may change their selected package option (plan) right
   * now (RUT-1947, RUT-3597).
   *
   * Snow packages use a fixed America/Chicago window (the day after Apr 15
   * through the day before Oct 15) so a wrapping or early-start period cannot
   * lock the picker before the Oct 15 cutoff. Other seasonal packages stay
   * on the offseason rule. Year-round non-snow packages stay changeable.
   */
  canChangePackagePlan(template, currentDate = /* @__PURE__ */ new Date()) {
    return this.getPackagePlanLockReason(template, currentDate) === null;
  },
  /**
   * Why a package plan is locked right now, or null when it may be changed.
   */
  getPackagePlanLockReason(template, currentDate = /* @__PURE__ */ new Date()) {
    if (isSnowSeasonPackage(template)) {
      return getSnowPlanLockReason(currentDate);
    }
    if (!this.getPeriods(template)?.length) return null;
    if (!this.isInOffseason(template, currentDate)) return "in_season";
    return null;
  },
  /**
   * Month/day this package is charged, in America/Chicago: its season start
   * (snow: Oct 15). Null when it has no enabled season. Thin wrapper over
   * {@link getPackageSeasonDates} (RUT-4051).
   */
  getPackageChargeMonthDay(template, now = /* @__PURE__ */ new Date()) {
    const dates = getPackageSeasonDates(template, now);
    return dates ? { month: dates.chargeOn.month, day: dates.chargeOn.day } : null;
  },
  /**
   * True when `now` is this template's package charge day in America/Chicago
   * — the day the scheduled package run bills it. Same dates the accept path,
   * preview and portal use ({@link getPackageSeasonDates}).
   */
  isPackageChargeDateToday(template, now = /* @__PURE__ */ new Date()) {
    if (!this.hasPackageConfiguration(template)) return false;
    const dates = getPackageSeasonDates(template, now);
    if (!dates) return false;
    const today = getChicagoYmd(now);
    return ymdKey(dates.chargeOn) === ymdKey(today);
  },
  /**
   * True when `now` is the day this package's visit allowance resets (its
   * season end) in America/Chicago — the day the scheduled reset job runs it.
   */
  isPackageResetDateToday(template, now = /* @__PURE__ */ new Date()) {
    if (!this.hasPackageConfiguration(template)) return false;
    const today = ymdKey(getChicagoYmd(now));
    const periods = this.getPeriods(template) ?? [];
    return periods.some((period) => {
      const dates = getPackageSeasonDates({ ...template, periods: [period] }, now);
      return !!dates?.inSeason && ymdKey(dates.resetOn) === today;
    });
  },
  /**
   * Get the seasonal status for a service template.
   * Periods take precedence over the stored `isYearRound` flag.
   */
  getSeasonalStatus(template, currentDate = /* @__PURE__ */ new Date()) {
    const periods = this.getPeriods(template);
    if (!periods?.length) {
      return {
        isCurrentlyInSeason: true,
        activeSeasons: ["Year-round"]
      };
    }
    const activeSeasons = [];
    let nextSeasonStart;
    periods.forEach((period) => {
      if (!period.isActive) return;
      if (PeriodHelpers.isPeriodActive(period, currentDate)) {
        activeSeasons.push(period.name);
      } else {
        const nextStart = this.getNextSeasonStart(period, currentDate);
        if (!nextSeasonStart || nextStart.daysUntil < nextSeasonStart.daysUntil) {
          nextSeasonStart = {
            seasonName: period.name,
            startDate: nextStart.startDate,
            daysUntil: nextStart.daysUntil
          };
        }
      }
    });
    return {
      isCurrentlyInSeason: activeSeasons.length > 0,
      activeSeasons,
      nextSeasonStart
    };
  },
  /**
   * Check if a specific season/period is currently active.
   * Delegates to PeriodHelpers.isPeriodActive.
   */
  isSeasonActive(season, currentDate) {
    return PeriodHelpers.isPeriodActive(season, currentDate);
  },
  /**
   * Get the next start date for a season
   */
  getNextSeasonStart(season, currentDate) {
    const year = currentDate.getFullYear();
    let startDate = new Date(year, season.startMonth - 1, season.startDay);
    if (startDate <= currentDate) {
      startDate = new Date(year + 1, season.startMonth - 1, season.startDay);
    }
    const daysUntil = Math.ceil(
      (startDate.getTime() - currentDate.getTime()) / (1e3 * 60 * 60 * 24)
    );
    return { startDate, daysUntil };
  },
  // Returns the soonest upcoming season start across active periods — unlike
  // getSeasonalStatus.nextSeasonStart, works even while currently in season.
  getUpcomingSeasonStart(template, currentDate = /* @__PURE__ */ new Date()) {
    const periods = this.getPeriods(template);
    if (!periods?.length) return void 0;
    let soonest;
    for (const period of periods) {
      if (!period.isActive) continue;
      const next = this.getNextSeasonStart(period, currentDate);
      if (!soonest || next.daysUntil < soonest.daysUntil) {
        soonest = {
          seasonName: period.name,
          startDate: next.startDate,
          daysUntil: next.daysUntil
        };
      }
    }
    return soonest;
  },
  // Returns next-season context when a seasonal package's acceptance window is
  // closed (in season or past deadline) so the portal can offer next-season sign-up.
  getNextSeasonRateContext(template, optionId, currentDate = /* @__PURE__ */ new Date()) {
    if (!this.hasPackageConfiguration(template)) {
      return { appliesToNextSeason: false };
    }
    let acceptanceOpen;
    if (optionId) {
      acceptanceOpen = this.isPackageAcceptanceOpen(template, optionId, currentDate);
    } else {
      const activeOptions2 = template.packagePricing?.options?.filter((o) => o.isActive) ?? [];
      const optionsWithDeadlines = activeOptions2.filter(
        (o) => o.acceptanceDeadlineMonth && o.acceptanceDeadlineDay
      );
      acceptanceOpen = optionsWithDeadlines.length === 0 ? this.isPackageAcceptanceOpen(template, void 0, currentDate) : optionsWithDeadlines.some(
        (o) => this.isPackageAcceptanceOpen(template, o.id, currentDate)
      );
    }
    if (acceptanceOpen) {
      return { appliesToNextSeason: false };
    }
    const upcoming = this.getUpcomingSeasonStart(template, currentDate);
    if (!upcoming) {
      return { appliesToNextSeason: false };
    }
    return {
      appliesToNextSeason: true,
      upcomingSeasonStart: upcoming.startDate,
      upcomingSeasonName: upcoming.seasonName
    };
  },
  /**
   * Get preferred days for scheduling a service template
   */
  getPreferredDays(template) {
    if (!template.dayPreferences?.length) return [];
    return template.dayPreferences.filter(
      (pref) => pref.priority === "preferred" /* PREFERRED */ || pref.priority === "required" /* REQUIRED */
    ).map((pref) => pref.day);
  },
  /**
   * Get required days for scheduling a service template
   */
  getRequiredDays(template) {
    if (!template.dayPreferences?.length) return [];
    return template.dayPreferences.filter((pref) => pref.priority === "required" /* REQUIRED */).map((pref) => pref.day);
  },
  /**
   * Get days to avoid for scheduling a service template
   */
  getAvoidedDays(template) {
    if (!template.dayPreferences?.length) return [];
    return template.dayPreferences.filter((pref) => pref.priority === "avoided" /* AVOIDED */).map((pref) => pref.day);
  },
  /**
   * Check if a specific day is suitable for scheduling based on preferences
   */
  isDaySuitableForScheduling(template, dayOfWeek) {
    if (!template.dayPreferences?.length) return "allowed";
    const preference = template.dayPreferences.find(
      (pref) => pref.day === dayOfWeek
    );
    if (!preference) return "allowed";
    switch (preference.priority) {
      case "required" /* REQUIRED */:
        return "required";
      case "preferred" /* PREFERRED */:
        return "preferred";
      case "avoided" /* AVOIDED */:
        return "avoided";
      default:
        return "allowed";
    }
  },
  /** @deprecated Use `isScheduleTypeAllowed(template, 'limited')` from helpers/subscription. Removed in Phase 8. */
  isOneTimeService(template) {
    return template.serviceType === "one_time" /* ONE_TIME */;
  },
  /**
   * An active template with no `scheduleConfig.frequency` is silently
   * undispatchable: the dispatch board (`getDispatchable`: `if (!frequency)
   * continue`) and the nightly auto-dispatch both key off the frequency, so
   * the template — and every subscriber on it — never appears anywhere to be
   * scheduled. The editor only shows a soft warning, which is how a live
   * service ends up stranded (RUT: "Snow Plowing Plus", 578 subscribers).
   *
   * Drafts (inactive templates) may be half-configured, so this only flags
   * ACTIVE templates. Used to guard template writes (postServiceTemplates /
   * patchServiceTemplateId) so the broken state can't be saved or activated.
   */
  isActiveWithoutDispatchFrequency(template) {
    return template.isActive === true && !template.scheduleConfig?.frequency;
  },
  /** @deprecated Use `isScheduleTypeAllowed(template, 'recurring')` from helpers/subscription. Removed in Phase 8. */
  isRecurringService(template) {
    return template.serviceType === "recurring" /* RECURRING */;
  },
  /** @deprecated Use `isScheduleTypeAllowed(template, 'limited')` from helpers/subscription. Removed in Phase 8. */
  canBeOrderedAsOneTime(template) {
    return template.serviceType === "recurring" /* RECURRING */ && template.allowOneTimeService === true;
  },
  /** @deprecated Tie display strings to `Schedule.type` instead. Removed in Phase 8. */
  getServiceTypeDisplay(serviceType) {
    switch (serviceType) {
      case "one_time" /* ONE_TIME */:
        return "One-Time Service";
      case "recurring" /* RECURRING */:
        return "Recurring Service";
      default:
        return "Unknown";
    }
  },
  /** @deprecated Derive from `template.allowedScheduleTypes`. Removed in Phase 8. */
  getAvailableFrequencies(serviceType) {
    if (serviceType === "one_time" /* ONE_TIME */) {
      return ["one_time" /* ONE_TIME */];
    }
    return [
      "on_demand" /* ON_DEMAND */,
      "weekly" /* WEEKLY */,
      "monthly" /* MONTHLY */,
      "yearly" /* YEARLY */,
      "custom" /* CUSTOM */
    ];
  },
  /**
   * Check if a service template has package configuration
   */
  hasPackageConfiguration(template) {
    return template.billingMethod === "package" /* PACKAGE */ && !!template.packagePricing?.enabled;
  },
  /**
   * Check if package acceptance is still open for a specific option (before its deadline).
   * Looks up the option's deadline fields, then checks against periods or legacy config.
   *
   * @param template The service template
   * @param optionId The selected package option ID (uses its deadline)
   * @param currentDate Current date for testing
   */
  isPackageAcceptanceOpen(template, optionId, currentDate = /* @__PURE__ */ new Date()) {
    if (!this.hasPackageConfiguration(template)) {
      return true;
    }
    const option = optionId ? template.packagePricing.options.find((o) => o.id === optionId) : void 0;
    const deadlineMonth = option?.acceptanceDeadlineMonth;
    const deadlineDay = option?.acceptanceDeadlineDay;
    if (!deadlineMonth || !deadlineDay) {
      const legacyDeadline = template.packagePricing?.acceptanceDeadline;
      if (!legacyDeadline) {
        return true;
      }
      const year2 = currentDate.getFullYear();
      const deadlineDate2 = new Date(year2, legacyDeadline.month - 1, legacyDeadline.day);
      if (deadlineDate2 < currentDate) {
        const nextYearDeadline = new Date(year2 + 1, legacyDeadline.month - 1, legacyDeadline.day);
        return currentDate < nextYearDeadline;
      }
      return currentDate <= deadlineDate2;
    }
    const periods = this.getPeriods(template);
    if (periods?.length) {
      const activePeriod = PeriodHelpers.getActivePeriod(periods, currentDate);
      if (activePeriod) {
        return PeriodHelpers.isAcceptanceOpen(activePeriod, deadlineMonth, deadlineDay, currentDate);
      }
      const anyActivePeriod = periods.find((p) => p.isActive);
      if (anyActivePeriod) {
        return PeriodHelpers.isAcceptanceOpen(anyActivePeriod, deadlineMonth, deadlineDay, currentDate);
      }
      return true;
    }
    const year = currentDate.getFullYear();
    const deadlineDate = new Date(year, deadlineMonth - 1, deadlineDay);
    if (deadlineDate < currentDate) {
      const nextYearDeadline = new Date(year + 1, deadlineMonth - 1, deadlineDay);
      return currentDate < nextYearDeadline;
    }
    return currentDate <= deadlineDate;
  },
  /**
   * Whether accepting this package now charges the season on the spot: its
   * season's charge date has arrived, or its season is already running
   * ({@link getPackageSeasonDates}). Between seasons, before the charge date,
   * or with no enabled season: false — the scheduled package run collects on
   * the charge date (RUT-4048, RUT-4051). "Season running" only differs from
   * "charge date arrived" for a snow package whose season starts before the
   * Oct 15 cutoff; it keeps charging those on acceptance, as before.
   */
  shouldChargeImmediately(template, currentDate = /* @__PURE__ */ new Date()) {
    if (!this.hasPackageConfiguration(template)) return false;
    const dates = getPackageSeasonDates(template, currentDate);
    if (!dates) return false;
    return dates.inSeason || currentDate.getTime() >= dates.chargeAt.getTime();
  },
  getSelectedPackageOption(template, selectedOptionId) {
    if (!template.packagePricing?.enabled || !selectedOptionId) return void 0;
    return template.packagePricing.options.find((o) => o.id === selectedOptionId);
  },
  getActivePackageOptions(template) {
    if (!template.packagePricing?.enabled) return [];
    return template.packagePricing.options.filter((o) => o.isActive).sort((a, b) => a.sortOrder - b.sortOrder);
  },
  shouldChargeForVisit(template, visitsUsed, selectedOptionId) {
    if (!this.hasPackageConfiguration(template)) {
      return true;
    }
    const option = this.getSelectedPackageOption(template, selectedOptionId);
    if (!option) {
      return true;
    }
    if (option.isUnlimitedVisits) {
      return false;
    }
    return visitsUsed > option.builtInVisits;
  },
  /**
   * Get the current period information for visit counting.
   *
   * Priority for the new model:
   * 1. periods[] (new unified model) - uses PeriodHelpers
   *
   * Fallback for legacy data:
   * 2. packagePricing.resetDate (for packages)
   * 3. seasonalAvailability (for seasonal services)
   * 4. calendar year (default)
   *
   * For packages with periods:
   * - Period start = charge date
   * - Period end = reset date (visit counts reset here)
   *
   * @returns Period start date and human-readable name
   */
  getCurrentPeriodInfo(template, currentDate = /* @__PURE__ */ new Date()) {
    const year = currentDate.getFullYear();
    const periods = template.periods;
    if (periods?.length) {
      const periodInfo = PeriodHelpers.getCurrentPeriodInfo(periods, currentDate);
      if (periodInfo) {
        return periodInfo;
      }
    }
    if (this.hasPackageConfiguration(template) && template.packagePricing?.resetDate) {
      const resetDate = template.packagePricing.resetDate;
      const resetThisYear = new Date(year, resetDate.month - 1, resetDate.day);
      if (currentDate >= resetThisYear) {
        return {
          periodStartDate: resetThisYear.toISOString().split("T")[0],
          periodName: `Package Year ${year}`
        };
      } else {
        const resetLastYear = new Date(year - 1, resetDate.month - 1, resetDate.day);
        return {
          periodStartDate: resetLastYear.toISOString().split("T")[0],
          periodName: `Package Year ${year - 1}`
        };
      }
    }
    if (template.seasonalAvailability?.length) {
      const activeSeason = template.seasonalAvailability.find(
        (season) => season.isActive && this.isSeasonActive(season, currentDate)
      );
      if (activeSeason) {
        const startThisYear = new Date(
          year,
          activeSeason.startMonth - 1,
          activeSeason.startDay
        );
        if (activeSeason.startMonth > activeSeason.endMonth) {
          if (currentDate.getMonth() + 1 < activeSeason.startMonth) {
            const startLastYear2 = new Date(
              year - 1,
              activeSeason.startMonth - 1,
              activeSeason.startDay
            );
            return {
              periodStartDate: startLastYear2.toISOString().split("T")[0],
              periodName: `${activeSeason.name} ${year - 1}`
            };
          }
        }
        if (currentDate >= startThisYear) {
          return {
            periodStartDate: startThisYear.toISOString().split("T")[0],
            periodName: `${activeSeason.name} ${year}`
          };
        }
        const startLastYear = new Date(
          year - 1,
          activeSeason.startMonth - 1,
          activeSeason.startDay
        );
        return {
          periodStartDate: startLastYear.toISOString().split("T")[0],
          periodName: `${activeSeason.name} ${year - 1}`
        };
      }
    }
    const jan1 = new Date(year, 0, 1);
    return {
      periodStartDate: jan1.toISOString().split("T")[0],
      periodName: `${year}`
    };
  },
  /**
   * Check if a given date falls within the current period for a service template.
   * Used by stream processor to determine if a visit counts toward currentPeriod.
   */
  isDateInCurrentPeriod(template, visitDate, currentDate = /* @__PURE__ */ new Date()) {
    const periodInfo = this.getCurrentPeriodInfo(template, currentDate);
    const periodStart = new Date(periodInfo.periodStartDate);
    return visitDate >= periodStart;
  }
};
var UNCATEGORIZED_SERVICE_CATEGORY = "Other";
function resolveServiceItemCategory(item, templatesById) {
  if (item.category) return item.category;
  const templateId = item.serviceTemplateId ?? item.id;
  const templateCategory = templateId ? templatesById.get(templateId)?.category : void 0;
  return templateCategory || UNCATEGORIZED_SERVICE_CATEGORY;
}
function groupServiceItemsByCategory(items, templatesById, getCategorizable = (item) => item) {
  const buckets = /* @__PURE__ */ new Map();
  for (const item of items) {
    const category = resolveServiceItemCategory(
      getCategorizable(item),
      templatesById
    );
    const bucket = buckets.get(category);
    if (bucket) bucket.push(item);
    else buckets.set(category, [item]);
  }
  return Array.from(buckets.entries()).sort(
    ([a], [b]) => compareServiceCategories(a, b)
  );
}
function isServiceTemplateActivatable(template) {
  return template.isActive !== false;
}
function compareServiceCategories(a, b) {
  if (a === b) return 0;
  if (a === UNCATEGORIZED_SERVICE_CATEGORY) return 1;
  if (b === UNCATEGORIZED_SERVICE_CATEGORY) return -1;
  return a.localeCompare(b);
}
function allowsCustomerStartDate(template) {
  return template?.allowCustomerStartDate === true;
}
var CUSTOMER_ACTIVATION_MAX_PHOTOS = 5;

// src/constants/index.ts
var PAYMENT_STATUS = {
  PENDING: "pending",
  PROCESSING: "processing",
  AWAITING_BATCH: "awaiting_batch",
  // Held for a paired sibling, a RUT-4164 charge wait, or nightly cleanup
  PAID: "paid",
  PAYMENT_FAILED: "payment_failed",
  PROCESSING_ERROR: "processing_error",
  NO_PAYMENT_METHOD: "no_payment_method",
  // Completed visit for a manual-payment customer: a DEBIT is on the ledger but no
  // card is auto-charged — it awaits a manually recorded payment (check or cash). RUT-2206.
  AWAITING_MANUAL_PAYMENT: "awaiting_manual_payment",
  VOIDED: "voided",
  REFUNDED: "refunded"
};
var PRICING_STATE = {
  ESTIMATED: "estimated",
  IN_PROGRESS: "in_progress",
  FINAL: "final"
};
var SUBSCRIPTION_STATE = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  PAUSED: "paused",
  CANCELLED: "cancelled"
};
var SUBSCRIPTION_FREQUENCY = {
  WEEKLY: "weekly",
  BIWEEKLY: "biweekly",
  MONTHLY: "monthly",
  QUARTERLY: "quarterly",
  YEARLY: "yearly"
};
var NOTIFICATION_PRIORITY = {
  LOW: "low",
  MEDIUM: "medium",
  HIGH: "high",
  URGENT: "urgent"
};
var ADMIN_NOTIFICATION_TYPE = {
  JOB_REVIEW_REQUIRED: "job_review_required",
  VISIT_STATUS_CHANGE: "visit_status_change"
};
var LANGUAGE = {
  ENGLISH: "en",
  SPANISH: "es"
};
var FIELD_NAMES = {
  NOTES: "notes",
  NOTES_ES: "notes_es",
  PHOTOS: "photos",
  UPDATED_AT: "updatedAt",
  PAYMENT_STATUS: "paymentStatus",
  PRICING_STATE: "pricingState",
  TOTAL_AMOUNT: "totalAmount"
};
var DEFAULT_VALUES = {
  SKIP_REASON: "No reason provided",
  REVIEW_REASON: "Time or disposal limit exceeded",
  RESCHEDULE_UNKNOWN: "Unknown",
  UNKNOWN_ERROR: "Unknown error"
};
var VISIT_STATUS_TRANSITIONS = {
  NOT_STARTED_TO_IN_PROGRESS: "VISIT_STARTED",
  PAUSED_TO_IN_PROGRESS: "VISIT_RESUMED",
  IN_PROGRESS_TO_PAUSED: "VISIT_PAUSED",
  ANY_TO_SKIPPED: "VISIT_SKIPPED"
};
var MAX_IMAGE_UPLOAD_MB = 25;
var MAX_IMAGE_UPLOAD_BYTES = MAX_IMAGE_UPLOAD_MB * 1024 * 1024;
var MMS_MAX_BYTES = 1 * 1024 * 1024;
var MMS_MAX_MEDIA = 10;
var MMS_CONTENT_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif"
];
var CUSTOMER_MESSAGE_IMAGE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif",
  "image/webp"
];
var CUSTOMER_MESSAGE_DOCUMENT_TYPES = [
  "application/pdf",
  "application/msword",
  // .doc
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  // .docx
  "application/vnd.ms-excel",
  // .xls
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  // .xlsx
  "application/vnd.ms-powerpoint",
  // .ppt
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  // .pptx
  "text/plain",
  "text/csv"
];
var CUSTOMER_MESSAGE_ATTACHMENT_TYPES = [
  ...CUSTOMER_MESSAGE_IMAGE_TYPES,
  ...CUSTOMER_MESSAGE_DOCUMENT_TYPES
];
var CUSTOMER_MESSAGE_DOCUMENT_EXTENSIONS = [
  ".pdf",
  ".doc",
  ".docx",
  ".xls",
  ".xlsx",
  ".ppt",
  ".pptx",
  ".txt",
  ".csv"
];

// src/helpers/firstVisitAutoPricing.ts
function isFirstVisitOnSubscription(subscription) {
  return (subscription?.visitCounts?.allTime ?? 0) === 0;
}
function isFirstVisitAutoPricingEnabled(serviceTemplate) {
  return serviceTemplate?.firstVisitAutoPricing === true;
}
function shouldApplyFirstVisitAutoPricing(serviceTemplate, subscription) {
  return isFirstVisitAutoPricingEnabled(serviceTemplate) && isFirstVisitOnSubscription(subscription);
}

// src/pricing/visitPricingService.ts
function applyDiscount(baseAmount, discount) {
  if (!discount || baseAmount <= 0) return baseAmount;
  if (discount.type === "percentage") {
    return roundCurrency(baseAmount * (1 - discount.value / 100));
  }
  return Math.max(0, roundCurrency(baseAmount - discount.value));
}
var VisitPricingService = class {
  // All-zero pricing result for visits that never bill on their own:
  // consumable base and bundle-included visits (RUT-2211).
  static zeroPricing() {
    return {
      baseAmount: 0,
      serviceOptionsAmount: 0,
      subtotal: 0,
      preDiscountSubtotal: 0,
      lineItems: [],
      calculatedAt: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Calculate estimated pricing at visit creation
   * Uses subscription rate if available, otherwise template calculation
   */
  static calculateEstimatedPricing(input) {
    const { visit, serviceTemplate, customerMetrics, subscription } = input;
    if (visit.bundleId) return this.zeroPricing();
    if (serviceTemplate.billingMethod === "consumable" /* CONSUMABLE */) {
      return this.zeroPricing();
    }
    const billingMethod = visit.billingMethod || serviceTemplate.billingMethod || "per_visit" /* PER_VISIT */;
    if (billingMethod === "package" /* PACKAGE */) {
      let visitPriceInput;
      if (this.shouldUsePackageVisit(visit, subscription)) {
        const visitsRemaining = subscription.packageState.isUnlimitedVisits ? "unlimited" : subscription.packageState.visitsRemaining;
        visitPriceInput = {
          billingMethod: "package" /* PACKAGE */,
          visitsRemaining,
          pricePerAdditionalVisit: visit.pricePerAdditionalVisit || subscription?.pricePerAdditionalVisit || 0,
          taxRate: 0,
          multiplier: input.multiplier,
          multiplierActionName: input.multiplierActionName,
          selectedPackageOptionName: visit.selectedPackageOptionName
        };
      } else {
        visitPriceInput = {
          billingMethod: "package" /* PACKAGE */,
          visitsRemaining: 0,
          pricePerAdditionalVisit: visit.pricePerAdditionalVisit || subscription?.pricePerAdditionalVisit || 0,
          taxRate: 0,
          multiplier: input.multiplier,
          multiplierActionName: input.multiplierActionName,
          selectedPackageOptionName: visit.selectedPackageOptionName
        };
      }
      const result = calculateVisitPrice(visitPriceInput);
      let { baseAmount: baseAmount2, serviceOptionsAmount: serviceOptionsAmount2 } = result;
      let lineItems = result.lineItems.filter((li) => li.type !== "tax" /* TAX */);
      const preDiscountBase2 = baseAmount2;
      const discount = visit.visitDiscount ?? visit.subscriptionDiscount ?? subscription?.discount;
      if (discount && baseAmount2 > 0) {
        const discountedBase = applyDiscount(baseAmount2, discount);
        const delta = baseAmount2 - discountedBase;
        baseAmount2 = discountedBase;
        if (delta > 0) {
          const serviceItems = lineItems.filter(
            (li) => li.type !== "option" /* OPTION */ && li.type !== "tax" /* TAX */
          );
          const totalServiceAmount = serviceItems.reduce((sum, li) => sum + li.amount, 0);
          if (totalServiceAmount > 0) {
            for (const li of serviceItems) {
              const share = li.amount / totalServiceAmount;
              li.amount = roundCurrency(li.amount - delta * share);
            }
          }
        }
      }
      const subtotal2 = roundCurrency(baseAmount2 + serviceOptionsAmount2);
      return {
        baseAmount: baseAmount2,
        serviceOptionsAmount: serviceOptionsAmount2,
        subtotal: subtotal2,
        preDiscountSubtotal: roundCurrency(preDiscountBase2 + serviceOptionsAmount2),
        lineItems,
        calculatedAt: (/* @__PURE__ */ new Date()).toISOString()
      };
    }
    let baseAmount = visit.subscriptionRate ?? 0;
    if (visit.subscriptionRate == null) {
      const estimatedBudgetedHours = visit.budgetedHours || serviceTemplate.builtInHours || 1;
      const result = calculateSubscriptionRateFromEntities(
        serviceTemplate,
        customerMetrics,
        estimatedBudgetedHours
      );
      if (result.billingMethod === "per_hour" /* PER_HOUR */) {
        baseAmount = Math.max(
          estimatedBudgetedHours * result.hourlyRate,
          result.minimumCharge
        );
      } else {
        baseAmount = result.rate;
      }
    }
    const multiplier = input.multiplier ?? 1;
    if (multiplier > 1) {
      baseAmount = roundCurrency(baseAmount * multiplier);
    }
    const preDiscountBase = baseAmount;
    baseAmount = this.applyDiscount(baseAmount, visit.visitDiscount ?? visit.subscriptionDiscount);
    const serviceOptionsAmount = 0;
    const subtotal = baseAmount + serviceOptionsAmount;
    return {
      baseAmount,
      serviceOptionsAmount,
      subtotal,
      preDiscountSubtotal: roundCurrency(preDiscountBase + serviceOptionsAmount),
      lineItems: [],
      calculatedAt: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Calculate current pricing during visit execution
   * Updates based on actual hours and service options used
   *
   * All billing methods route through calculateVisitPrice() to produce
   * consistent VisitLineItem[] breakdowns.
   */
  static calculateCurrentPricing(input) {
    const {
      visit,
      serviceTemplate,
      subscription,
      actualHours,
      actualServiceOptions = [],
      skipMinimumFee = false
    } = input;
    if (visit.bundleId) {
      return { ...this.zeroPricing(), actualHours };
    }
    if (visit.currentPricing) {
      return {
        baseAmount: visit.currentPricing.baseAmount,
        serviceOptionsAmount: visit.currentPricing.serviceOptionsAmount,
        subtotal: visit.currentPricing.subtotal,
        preDiscountSubtotal: visit.currentPricing.preDiscountSubtotal ?? visit.currentPricing.subtotal,
        lineItems: visit.currentPricing.lineItems || [],
        actualHours: visit.currentPricing.actualHours || actualHours,
        calculatedAt: visit.currentPricing.calculatedAt
      };
    }
    const billingMethod = visit.billingMethod || serviceTemplate?.billingMethod || "per_visit" /* PER_VISIT */;
    const serviceOptionsInput = actualServiceOptions.length > 0 && serviceTemplate.serviceOptions ? buildServiceOptionsInput(serviceTemplate.serviceOptions, actualServiceOptions) : void 0;
    let visitPriceInput;
    if (this.shouldUsePackageVisit(visit, subscription)) {
      const visitsRemaining = subscription.packageState.isUnlimitedVisits ? "unlimited" : subscription.packageState.visitsRemaining;
      visitPriceInput = {
        billingMethod: "package" /* PACKAGE */,
        visitsRemaining,
        pricePerAdditionalVisit: visit.pricePerAdditionalVisit || subscription?.pricePerAdditionalVisit || 0,
        serviceOptions: serviceOptionsInput,
        taxRate: 0,
        // Tax handled in calculateFinalPricing
        multiplier: input.multiplier,
        multiplierActionName: input.multiplierActionName,
        selectedPackageOptionName: visit.selectedPackageOptionName
      };
    } else if (billingMethod === "package" /* PACKAGE */) {
      visitPriceInput = {
        billingMethod: "package" /* PACKAGE */,
        visitsRemaining: 0,
        pricePerAdditionalVisit: visit.pricePerAdditionalVisit || subscription?.pricePerAdditionalVisit || 0,
        serviceOptions: serviceOptionsInput,
        taxRate: 0,
        multiplier: input.multiplier,
        multiplierActionName: input.multiplierActionName,
        selectedPackageOptionName: visit.selectedPackageOptionName
      };
    } else if (billingMethod === "consumable" /* CONSUMABLE */) {
      visitPriceInput = {
        billingMethod: "consumable" /* CONSUMABLE */,
        minimumCharge: serviceTemplate.minimumCharge,
        serviceOptions: serviceOptionsInput,
        taxRate: 0
      };
    } else if (billingMethod === "per_visit" /* PER_VISIT */ || // Skip make-up (RUT-3744): per-visit services bill max(regular, hours ×
    // modal rate). createVisit used to stamp these PER_HOUR (RUT-2923); route
    // those in-flight visits through the same greater-of math via the live
    // template method, not the visit snapshot.
    visit.skipMakeupHourly === true && serviceTemplate?.billingMethod === "per_visit" /* PER_VISIT */) {
      const subscriptionRate = visit.subscriptionRate ?? subscription?.rate;
      const resolvedSubscriptionRate = typeof subscriptionRate === "number" ? subscriptionRate : 0;
      const applyFirstVisit = shouldApplyFirstVisitAutoPricing(
        serviceTemplate,
        subscription
      );
      const applySkipMakeupGreaterOf = visit.skipMakeupHourly === true;
      const hourlyRate = visit.hourlyRate ?? serviceTemplate?.hourlyRate;
      const firstVisitLabor = (applyFirstVisit || applySkipMakeupGreaterOf) && actualHours !== void 0 && actualHours > 0 && typeof hourlyRate === "number" && hourlyRate > 0 ? { hourlyRate, actualHours } : void 0;
      visitPriceInput = {
        billingMethod: "per_visit" /* PER_VISIT */,
        subscriptionRate: resolvedSubscriptionRate,
        serviceOptions: serviceOptionsInput,
        taxRate: 0,
        multiplier: input.multiplier,
        firstVisitLabor,
        serviceName: visit.serviceName
      };
    } else {
      const useVisitPricing = visit.visitType === "follow_up" /* FOLLOW_UP */ || visit.isFollowupVisit === true || visit.skipMakeupHourly === true;
      if (actualHours !== void 0 && actualHours > 0) {
        visitPriceInput = {
          billingMethod: "per_hour" /* PER_HOUR */,
          hourlyRate: (useVisitPricing ? visit.hourlyRate : serviceTemplate.hourlyRate) || 0,
          actualHours,
          minimumCharge: skipMinimumFee ? 0 : useVisitPricing ? visit.minimumCharge : serviceTemplate.minimumCharge,
          builtInHours: useVisitPricing ? visit.builtInHours : serviceTemplate.builtInHours,
          serviceOptions: serviceOptionsInput,
          taxRate: 0
        };
      } else {
        return {
          baseAmount: 0,
          serviceOptionsAmount: 0,
          subtotal: 0,
          preDiscountSubtotal: 0,
          lineItems: [],
          actualHours,
          calculatedAt: (/* @__PURE__ */ new Date()).toISOString()
        };
      }
    }
    const result = calculateVisitPrice(visitPriceInput);
    let { baseAmount, serviceOptionsAmount } = result;
    let lineItems = result.lineItems.filter((li) => li.type !== "tax" /* TAX */);
    let discountDelta = 0;
    const discount = visit.visitDiscount ?? visit.subscriptionDiscount ?? subscription?.discount;
    if (discount) {
      if (billingMethod === "consumable" /* CONSUMABLE */) {
        const discountedOptions = applyDiscount(serviceOptionsAmount, discount);
        const delta = serviceOptionsAmount - discountedOptions;
        discountDelta = delta;
        serviceOptionsAmount = discountedOptions;
        if (delta > 0) {
          const optionItems = lineItems.filter((li) => li.type === "option" /* OPTION */);
          const totalOptionAmount = optionItems.reduce((sum, li) => sum + li.amount, 0);
          if (totalOptionAmount > 0) {
            for (const li of optionItems) {
              const share = li.amount / totalOptionAmount;
              li.amount = roundCurrency(li.amount - delta * share);
            }
          }
        }
      } else {
        const discountedBase = applyDiscount(baseAmount, discount);
        const delta = baseAmount - discountedBase;
        discountDelta = delta;
        baseAmount = discountedBase;
        if (delta > 0) {
          const serviceItems = lineItems.filter(
            (li) => li.type !== "option" /* OPTION */ && li.type !== "tax" /* TAX */
          );
          const totalServiceAmount = serviceItems.reduce((sum, li) => sum + li.amount, 0);
          if (totalServiceAmount > 0) {
            for (const li of serviceItems) {
              const share = li.amount / totalServiceAmount;
              li.amount = roundCurrency(li.amount - delta * share);
            }
          }
        }
      }
    }
    let subtotal = roundCurrency(baseAmount + serviceOptionsAmount);
    if (billingMethod === "consumable" /* CONSUMABLE */) {
      lineItems = lineItems.filter(
        (li) => li.type !== "minimum_adjustment" /* MINIMUM_ADJUSTMENT */
      );
      const minimumCharge = skipMinimumFee ? 0 : serviceTemplate.minimumCharge ?? 0;
      if (minimumCharge > subtotal) {
        const adjustment = roundCurrency(minimumCharge - subtotal);
        lineItems.push({
          id: "minimum-adjustment",
          type: "minimum_adjustment" /* MINIMUM_ADJUSTMENT */,
          description: "Minimum Charge Adjustment",
          quantity: 1,
          rate: adjustment,
          amount: adjustment,
          taxable: serviceTemplate.isTaxable !== false
        });
        subtotal = minimumCharge;
      }
    }
    return {
      baseAmount,
      serviceOptionsAmount,
      subtotal,
      // Gross (pre-discount) pre-tax subtotal = discounted subtotal + the
      // dollars the discount removed. Equals `subtotal` when no discount.
      preDiscountSubtotal: roundCurrency(subtotal + discountDelta),
      lineItems,
      actualHours,
      calculatedAt: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Calculate final pricing at visit completion
   * Includes tax calculation and locks the pricing
   */
  static calculateFinalPricing(input) {
    const { actualHours, customerTaxRate = 0, serviceTemplate } = input;
    if (input.visit.isBillable === false) {
      return {
        baseAmount: 0,
        serviceOptionsAmount: 0,
        subtotal: 0,
        preDiscountSubtotal: 0,
        lineItems: [],
        finalHours: actualHours,
        taxRate: 0,
        taxAmount: 0,
        totalAmount: 0,
        isLocked: true,
        calculatedAt: (/* @__PURE__ */ new Date()).toISOString()
      };
    }
    const currentPricing = this.calculateCurrentPricing({
      ...input,
      visit: { ...input.visit, currentPricing: void 0 }
    });
    const serviceTaxable = serviceTemplate.isTaxable !== false;
    const effectiveTaxRate = serviceTaxable ? customerTaxRate : 0;
    const taxAmount = roundCurrency(currentPricing.subtotal * effectiveTaxRate);
    const totalAmount = roundCurrency(currentPricing.subtotal + taxAmount);
    const lineItems = [...currentPricing.lineItems];
    if (taxAmount > 0) {
      lineItems.push({
        id: "tax-final",
        type: "tax" /* TAX */,
        description: `Tax (${(effectiveTaxRate * 100).toFixed(2)}%)`,
        quantity: 1,
        rate: effectiveTaxRate,
        amount: taxAmount,
        taxable: false
      });
    }
    return {
      ...currentPricing,
      finalHours: actualHours,
      taxRate: effectiveTaxRate,
      taxAmount,
      totalAmount,
      lineItems,
      isLocked: true
    };
  }
  /**
   * Update visit pricing state and calculate new pricing
   */
  static updateVisitPricing(visit, newState, input) {
    const updates = {
      pricingState: newState,
      updatedAt: (/* @__PURE__ */ new Date()).toISOString()
    };
    switch (newState) {
      case PRICING_STATE.ESTIMATED:
        const estimated = this.calculateEstimatedPricing(input);
        updates.estimatedPricing = estimated;
        break;
      case PRICING_STATE.IN_PROGRESS:
        const current = this.calculateCurrentPricing(input);
        updates.currentPricing = current;
        break;
      case PRICING_STATE.FINAL:
        const final = this.calculateFinalPricing(input);
        updates.finalPricing = final;
        updates.totalAmount = final.totalAmount;
        updates.taxAmount = final.taxAmount;
        updates.taxRate = final.taxRate;
        break;
    }
    return updates;
  }
  /**
   * Get the current pricing amount based on visit state
   * Returns the most appropriate pricing for the current visit state
   */
  static getCurrentAmount(visit) {
    if (visit.finalPricing?.isLocked) {
      return visit.finalPricing.totalAmount;
    }
    if (visit.currentPricing) {
      return visit.currentPricing.subtotal;
    }
    if (visit.estimatedPricing) {
      return visit.estimatedPricing.subtotal;
    }
    return visit.totalAmount || 0;
  }
  /**
   * Apply a discount (percentage or fixed) to a base amount.
   * Delegates to the standalone exported applyDiscount function.
   */
  static applyDiscount(baseAmount, discount) {
    return applyDiscount(baseAmount, discount);
  }
  /**
   * Check if visit has package visits remaining and should use $0 base amount
   * Package visits are prepaid, so they use $0 base amount
   */
  static shouldUsePackageVisit(visit, subscription) {
    if (!subscription?.packageState) return false;
    if (subscription.packageState.isUnlimitedVisits) return true;
    return (subscription.packageState.visitsRemaining ?? 0) > 0;
  }
  /**
   * Calculate pricing directly from service template inputs
   * This method bypasses visit state management for scenarios like pricing examples
   */
  static calculateTemplateBasedPrice(input) {
    const {
      template,
      budgetedHours = 0,
      customerMetrics = {},
      serviceOptions = []
    } = input;
    const result = calculateSubscriptionRateFromEntities(
      template,
      customerMetrics,
      budgetedHours
    );
    let total;
    let preRoundingTotal;
    if (result.billingMethod === "per_hour" /* PER_HOUR */) {
      total = Math.max(budgetedHours * result.hourlyRate, result.minimumCharge);
    } else if (result.billingMethod === "package" /* PACKAGE */) {
      total = result.packageAmount;
      preRoundingTotal = result.preRoundingRate;
    } else if (result.billingMethod === "consumable" /* CONSUMABLE */) {
      total = 0;
    } else {
      total = result.rate;
      preRoundingTotal = result.preRoundingRate;
    }
    const breakdown = result.lineItems.map(
      (item) => `${item.description}: $${item.amount.toFixed(2)}`
    );
    const lineItems = result.lineItems.map((item) => ({
      id: item.id,
      type: item.type,
      description: item.description,
      quantity: item.quantity,
      rate: item.rate,
      amount: item.amount
    }));
    const scheduleDescription = this.getScheduleDescription(
      template.scheduleConfig
    );
    const billingDescription = this.getBillingDescription(
      template.billingMethod,
      scheduleDescription,
      template
    );
    return {
      total,
      preRoundingTotal,
      breakdown,
      lineItems,
      billingDescription,
      scheduleDescription
    };
  }
  /**
   * Generate user-friendly schedule description from schedule configuration
   */
  static getScheduleDescription(scheduleConfig) {
    if (!scheduleConfig?.frequency) return "";
    const { frequency, customFrequency, customUnit } = scheduleConfig;
    switch (frequency) {
      case "weekly":
        return "weekly";
      case "bi-weekly":
        return "every 2 weeks";
      case "monthly":
        return "monthly";
      case "quarterly":
        return "every 3 months";
      case "seasonally":
        return "seasonally";
      case "custom":
        return customFrequency && customUnit ? `every ${customFrequency} ${customUnit}${customFrequency > 1 ? "s" : ""}` : "on a custom schedule";
      case "on_demand":
        return "";
      default:
        return "";
    }
  }
  /**
   * Format a date object {month, day} into a readable string
   */
  static formatPackageDate(dateObj) {
    const { month, day } = dateObj;
    const date = new Date((/* @__PURE__ */ new Date()).getFullYear(), month - 1, day);
    return date.toLocaleDateString("en-US", { month: "long", day: "numeric" });
  }
  /**
   * Generate user-friendly billing description combining billing method and schedule
   */
  static getBillingDescription(billingMethod, scheduleDesc, template) {
    const method = billingMethod || "per_visit" /* PER_VISIT */;
    if (method === "consumable" /* CONSUMABLE */) {
      return "Usage-based billing (service options)";
    } else if (method === "per_visit" /* PER_VISIT */) {
      return scheduleDesc ? `Per visit, billed ${scheduleDesc}` : "Per visit billing";
    } else if (method === "per_hour" /* PER_HOUR */) {
      return scheduleDesc ? `Hourly, billed ${scheduleDesc}` : "Hourly billing";
    } else if (method === "package" /* PACKAGE */) {
      const descriptionParts = [];
      const seasonDates = template ? getPackageSeasonDates(template) : null;
      if (seasonDates) {
        descriptionParts.push(`Charged every ${this.formatPackageDate(seasonDates.chargeOn)}`);
        descriptionParts.push(`Renews every ${this.formatPackageDate(seasonDates.resetOn)}`);
      }
      return descriptionParts.join("\n") || "Package billing";
    } else {
      return "Package billing";
    }
  }
};

// src/helpers/packageChargeSeason.ts
function packageChargeSeasonKey(now = /* @__PURE__ */ new Date()) {
  return getChicagoYmd(now).year;
}
function packageChargeSeasonFromStamp(stamp) {
  const instant = stamp instanceof Date ? stamp : new Date(stamp);
  if (Number.isNaN(instant.getTime())) {
    throw new Error(`packageChargeSeasonFromStamp: invalid stamp ${String(stamp)}`);
  }
  return instant.getUTCFullYear();
}
function packageChargeInvoiceId(subscriptionId, season, refundedAt) {
  const base = `package-${subscriptionId}-${season}`;
  if (!refundedAt) return base;
  return `${base}-r${refundedAt.replace(/[^0-9A-Za-z]/g, "")}`;
}
function seasonFromPackageInvoiceId(invoiceId) {
  const match = /-(\d{4})(?:-r[A-Za-z0-9]+)?$/.exec(invoiceId);
  if (!match) return void 0;
  return Number(match[1]);
}
function openPackageInvoiceOnDeactivate(subscription) {
  const invoiceId = subscription.packageChargeFailedInvoiceId;
  if (!invoiceId) return null;
  const season = seasonFromPackageInvoiceId(invoiceId);
  if (season === void 0) return null;
  if (isPackageChargedForSeason(subscription, season)) return null;
  const amount = resolvePackageChargeAmount({
    ...subscription,
    discount: subscription.discount ?? void 0
  });
  return { invoiceId, ...amount !== void 0 ? { amount } : {} };
}
function packageChargeStableMetadataDate(template, season) {
  const monthDay = ServiceTemplateHelpers.getPackageChargeMonthDay(template);
  if (!monthDay) return `${season}-01-01`;
  const month = String(monthDay.month).padStart(2, "0");
  const day = String(monthDay.day).padStart(2, "0");
  return `${season}-${month}-${day}`;
}
function packageChargeSeasonBounds(season) {
  return {
    startInclusive: `${season}-01-01T00:00:00.000Z`,
    endExclusive: `${season + 1}-01-01T06:00:00.000Z`
  };
}
function isPackageChargedForSeason(subscription, season) {
  if (subscription.packageRefundedAt) {
    return false;
  }
  const stamp = subscription.packageChargedAt;
  const hasPayment = Boolean(subscription.packageChargePaymentId);
  if (!stamp && !hasPayment) {
    return false;
  }
  if (stamp) {
    const chargedAt = new Date(stamp);
    if (Number.isNaN(chargedAt.getTime())) {
      return hasPayment;
    }
    const { startInclusive, endExclusive } = packageChargeSeasonBounds(season);
    return chargedAt >= new Date(startInclusive) && chargedAt < new Date(endExclusive);
  }
  return hasPayment;
}
function seasonExtraPayments(subscription, season) {
  const payments = subscription.packageSeasonPayments;
  if (!Array.isArray(payments) || payments.length === 0) return [];
  const chargePaymentId = subscription.packageChargePaymentId ?? void 0;
  const chargedAt = subscription.packageChargedAt ?? void 0;
  if (!chargePaymentId && !chargedAt) return [];
  if (!isPackageChargedForSeason(
    { ...subscription, packageRefundedAt: void 0 },
    season
  )) {
    return [];
  }
  return payments.filter((payment) => {
    if (!payment || !payment.paymentId) return false;
    if (typeof payment.amount !== "number" || !(payment.amount > 0)) return false;
    if (chargePaymentId && payment.seasonChargePaymentId) {
      return payment.seasonChargePaymentId === chargePaymentId;
    }
    return Boolean(chargedAt) && payment.seasonChargedAt === chargedAt;
  });
}
function unrefundedSeasonExtraPayments(subscription, season) {
  return seasonExtraPayments(subscription, season).filter((p) => !p.refundedAt);
}
function unrefundedSeasonExtraTotal(subscription, season) {
  const cents = unrefundedSeasonExtraPayments(subscription, season).reduce(
    (sum, p) => sum + Math.round(p.amount * 100),
    0
  );
  return cents / 100;
}
function packageChargeRefundable(subscription, now = /* @__PURE__ */ new Date()) {
  if (subscription.packageRefundedAt) return null;
  const paymentId = subscription.packageChargePaymentId;
  const chargedAt = subscription.packageChargedAt;
  const chargedAmount = subscription.packageChargeAmount;
  if (!paymentId || !chargedAt || !chargedAmount || chargedAmount <= 0) {
    return null;
  }
  if (!isPackageChargedForSeason(subscription, packageChargeSeasonKey(now))) {
    return null;
  }
  const refundedTotal = Math.max(0, subscription.packageRefundedTotal ?? 0);
  const refundable = Math.round((chargedAmount - refundedTotal) * 100) / 100;
  if (refundable <= 0) return null;
  const paidAt = subscription.packageChargePaidAt ?? void 0;
  return {
    paymentId,
    chargedAt,
    ...paidAt ? { paidAt } : {},
    chargedAmount,
    refundedTotal,
    refundable
  };
}
function isOpenPackagePaymentIssue(subscription, season) {
  const failedInvoiceId = subscription.packageChargeFailedInvoiceId;
  if (!failedInvoiceId) return false;
  if (isPackageChargedForSeason(subscription, season)) return false;
  return failedInvoiceId === packageChargeInvoiceId(subscription.id, season, subscription.packageRefundedAt);
}
function resolvePackageChargeListRate(subscription) {
  const selectedPricing = subscription.packageOptionPricing?.find(
    (p) => p.optionId === subscription.selectedPackageOptionId
  );
  const amount = selectedPricing?.rate ?? subscription.rate;
  if (typeof amount !== "number" || !Number.isFinite(amount) || amount <= 0) {
    return void 0;
  }
  return amount;
}
function resolvePackageChargeAmount(subscription) {
  const listRate = resolvePackageChargeListRate(subscription);
  if (listRate === void 0) {
    return void 0;
  }
  return applyDiscount(listRate, subscription.discount);
}
function waivedPackagePaymentId(invoiceId) {
  return `waived_${invoiceId}`;
}
function evaluatePackageSubscriptionCharge(subscription, template, today) {
  const season = packageChargeSeasonKey(today);
  if (subscription.serviceTemplateId !== template.id) {
    return { action: "skip", reason: "wrong_template", season };
  }
  if (subscription.bundleId) {
    return { action: "skip", reason: "bundle_member", season };
  }
  if (isPackageChargedForSeason(subscription, season)) {
    return { action: "skip", reason: "already_charged", season };
  }
  if (isOpenPackagePaymentIssue(subscription, season)) {
    return { action: "skip", reason: "open_payment_issue", season };
  }
  const amount = resolvePackageChargeAmount(subscription);
  if (amount === void 0) {
    return { action: "skip", reason: "invalid_amount", season };
  }
  return { action: "charge", amount, season };
}
function planPackageCharges(params) {
  const { templates, subscriptions, today } = params;
  const season = packageChargeSeasonKey(today);
  const chargingTemplates = templates.filter(
    (template) => ServiceTemplateHelpers.isPackageChargeDateToday(template, today)
  );
  const toCharge = [];
  const skipped = [];
  for (const template of chargingTemplates) {
    for (const subscription of subscriptions) {
      if (subscription.serviceTemplateId !== template.id) {
        continue;
      }
      const decision = evaluatePackageSubscriptionCharge(
        subscription,
        template,
        today
      );
      if (decision.action === "charge") {
        toCharge.push({
          subscription,
          template,
          amount: decision.amount,
          season: decision.season
        });
      } else {
        skipped.push({
          subscription,
          template,
          reason: decision.reason,
          season: decision.season
        });
      }
    }
  }
  return { season, chargingTemplates, toCharge, skipped };
}

// src/invoices/buildPackageChargeInvoice.ts
var PACKAGE_CHARGE_TYPE = "package";
function packageChargeInvoiceNumber(season, subscriptionId) {
  const tail = subscriptionId.slice(-6);
  return `PKG-${season}-${tail}`;
}
function packageChargeLineDescription(templateName, planName2) {
  const template = templateName?.trim() || void 0;
  const plan = planName2?.trim() || void 0;
  if (!template && !plan) return void 0;
  if (template && plan && plan !== template) return `${template} \u2014 ${plan}`;
  return plan ?? template;
}
function packageChargeLedgerDescription(customerName, templateName, planName2) {
  const customer = customerName?.trim() || void 0;
  const template = templateName?.trim() || void 0;
  const plan = planName2?.trim() || void 0;
  if (!customer) return void 0;
  if (template && plan) return `${customer} - ${template} - ${plan}`;
  if (template) return `${customer} - ${template}`;
  if (plan) return `${customer} - ${plan}`;
  return void 0;
}
function namesFromPackageInvoiceLine(line) {
  const trimmed = line?.trim();
  if (!trimmed) return {};
  const emParts = trimmed.split(/\s+—\s+/);
  if (emParts.length >= 2) {
    return { templateName: emParts[0], planName: emParts.slice(1).join(" \u2014 ") };
  }
  const dashParts = trimmed.split(" - ");
  if (dashParts.length >= 3) {
    return { templateName: dashParts[1], planName: dashParts.slice(2).join(" - ") };
  }
  if (dashParts.length === 2) {
    return { templateName: dashParts[1] };
  }
  return { templateName: trimmed };
}
function packageChargeCollectionLabel(params) {
  return packageChargeLedgerDescription(
    params.customerName,
    params.templateName,
    params.planName
  ) ?? `Package charge ${params.invoiceId}`;
}
function resolvePackageChargeCustomerName(customer, snapshot) {
  const live = getCustomerDisplayName(customer);
  if (live !== "Unknown Customer") return live;
  const fromSnapshot = getCustomerDisplayName({
    firstName: snapshot?.customerFirstName,
    lastName: snapshot?.customerLastName
  });
  return fromSnapshot === "Unknown Customer" ? void 0 : fromSnapshot;
}
function finiteRate(value) {
  return typeof value === "number" && Number.isFinite(value) && value >= 0 ? value : void 0;
}
function chargedPlanListRate(subscription) {
  const planId = subscription.packageChargePlanId;
  const fromPlan = planId ? subscription.packageOptionPricing?.find((p) => p.optionId === planId)?.rate : void 0;
  return finiteRate(fromPlan) ?? finiteRate(subscription.rate);
}
function buildPackageChargeInvoice(subscription, options = {}) {
  const chargedAt = options.createdAt ?? subscription.packageChargedAt ?? options.paidAt ?? subscription.packageChargePaidAt ?? (/* @__PURE__ */ new Date()).toISOString();
  const stamp = subscription.packageChargedAt ?? chargedAt;
  const season = options.season ?? packageChargeSeasonFromStamp(stamp);
  const amount = options.amount ?? subscription.packageChargeAmount ?? 0;
  const paymentId = options.paymentId ?? subscription.packageChargePaymentId ?? "";
  const invoiceId = options.invoiceId ?? packageChargeInvoiceId(subscription.id, season, subscription.packageRefundedAt);
  const paidAt = options.paidAt ?? subscription.packageChargePaidAt ?? chargedAt;
  const dueDate = options.dueDate ?? paidAt;
  const planName2 = options.planName ?? subscription.packageChargePlanName ?? subscription.selectedPackageOptionName ?? void 0;
  const templateName = options.templateName ?? subscription.serviceTemplateName ?? planName2 ?? "Package";
  const listRate = chargedPlanListRate(subscription) ?? amount;
  const expectedCollected = applyDiscount(listRate, subscription.discount ?? void 0);
  const discount = subscription.discount && roundCurrency(expectedCollected) === roundCurrency(amount) ? Math.max(0, roundCurrency(listRate - amount)) : 0;
  return {
    id: invoiceId,
    orgId: subscription.orgId,
    customerId: subscription.customerId,
    subscriptionId: subscription.id,
    serviceTemplateId: subscription.serviceTemplateId,
    invoiceNumber: packageChargeInvoiceNumber(season, subscription.id),
    amount,
    status: "paid",
    createdAt: chargedAt,
    paidAt,
    dueDate,
    paymentId,
    paymentIntentId: paymentId,
    paymentMethodType: options.paymentMethodType ?? "card",
    chargeType: PACKAGE_CHARGE_TYPE,
    lineItems: [
      {
        description: packageChargeLineDescription(templateName, planName2) ?? templateName,
        quantity: 1,
        rate: listRate,
        unitPrice: listRate,
        discount,
        amount
      }
    ]
  };
}

// src/invoices/applyPackageChargeInvoiceRefund.ts
var PACKAGE_INVOICE_REFUND_LINE = "Season package refund";
var PACKAGE_INVOICE_PARTIAL_REFUND_LINE = "Season package partial refund";
function isRefundCreditLine(line) {
  return line.description === PACKAGE_INVOICE_REFUND_LINE || line.description === PACKAGE_INVOICE_PARTIAL_REFUND_LINE || typeof line.amount === "number" && line.amount < 0;
}
function applyPackageChargeInvoiceRefund(invoice, params) {
  const refundedTotal = Math.max(0, roundCurrency(params.refundedTotal));
  const chargeLines = (invoice.lineItems ?? []).filter((line) => !isRefundCreditLine(line));
  const creditLine = {
    description: params.lineDescription ?? (params.fullyRefunded ? PACKAGE_INVOICE_REFUND_LINE : PACKAGE_INVOICE_PARTIAL_REFUND_LINE),
    quantity: 1,
    rate: 0,
    unitPrice: 0,
    discount: 0,
    amount: -refundedTotal
  };
  return {
    ...invoice,
    status: params.fullyRefunded ? "refunded" : "paid",
    refundedAmount: refundedTotal,
    refundId: params.refundId ?? invoice.refundId,
    refundedAt: params.refundedAt,
    updatedAt: params.refundedAt,
    lineItems: refundedTotal > 0 ? [...chargeLines, creditLine] : chargeLines
  };
}

// src/invoices/repricePackageChargeInvoice.ts
function finiteNonNegative(value) {
  return typeof value === "number" && Number.isFinite(value) && value >= 0 ? value : void 0;
}
function currentPackageInvoiceTotal(params) {
  const selected = finiteNonNegative(params.selectedPlanAmount);
  if (selected !== void 0) return selected;
  return finiteNonNegative(params.storedInvoiceAmount);
}
function retryChargeableAfterPackageReprice(params) {
  return Math.max(
    0,
    roundCurrency(
      params.outstanding - params.packageLedgerDebitTotal + params.currentPackageInvoiceTotal
    )
  );
}
function repricePackageChargeInvoice(invoice, params) {
  const amount = roundCurrency(params.amount);
  const paidAmount = Math.max(0, roundCurrency(params.paidAmount ?? 0));
  const covered = paidAmount > 0 && paidAmount >= amount;
  const now = params.now ?? (/* @__PURE__ */ new Date()).toISOString();
  const label = params.lineDescription?.trim() || packageChargeLineDescription(params.templateName, params.planName);
  let patchedCharge = false;
  const lineItems = invoice.lineItems?.map((line) => {
    if (patchedCharge || isRefundCreditLine(line)) return line;
    patchedCharge = true;
    return {
      ...line,
      ...label ? { description: label } : {},
      ...typeof line.rate === "number" ? { rate: amount } : {},
      ...typeof line.unitPrice === "number" ? { unitPrice: amount } : {},
      amount
    };
  });
  const next = {
    ...invoice,
    amount,
    ...lineItems ? { lineItems } : {}
  };
  if (covered && invoice.status !== "paid") {
    next.status = "paid";
    if (!next.paidAt) next.paidAt = invoice.paidAt ?? now;
  } else if (!covered && invoice.status === "paid") {
    next.status = "pending";
  }
  return next;
}

// src/invoices/invoiceDiscountDisplay.ts
function visitInvoiceDiscountAmount(visit) {
  const fp = visit.finalPricing;
  if (!fp) return 0;
  if (typeof fp.preDiscountSubtotal === "number" && typeof fp.subtotal === "number") {
    return Math.max(0, roundCurrency(fp.preDiscountSubtotal - fp.subtotal));
  }
  const discount = visit.visitDiscount ?? visit.subscriptionDiscount;
  if (!discount || !fp.baseAmount || fp.baseAmount <= 0) return 0;
  if (discount.type === "percentage") {
    if (discount.value >= 100) return 0;
    const preDiscountBase = fp.baseAmount / (1 - discount.value / 100);
    return Math.max(0, roundCurrency(preDiscountBase - fp.baseAmount));
  }
  return Math.max(0, discount.value);
}
function isDiscountedLine(li, consumable) {
  if (li.type === "tax" /* TAX */) return false;
  if (consumable) return li.type === "option" /* OPTION */;
  return li.type !== "option" /* OPTION */;
}
function restoreDiscountedLineAmounts(lineItems, discountAmount, billingMethod) {
  const out = lineItems.map((li) => ({ ...li }));
  if (!(discountAmount > 0)) return out;
  const consumable = billingMethod === "consumable";
  const targets = out.filter((li) => isDiscountedLine(li, consumable));
  const postTotal = targets.reduce((sum, li) => sum + li.amount, 0);
  if (targets.length === 0) return out;
  const expected = roundCurrency(postTotal + discountAmount);
  const atRate = targets.map(
    (li) => typeof li.rate === "number" && typeof li.quantity === "number" ? roundCurrency(li.rate * li.quantity) : null
  );
  if (atRate.every((a) => a !== null && a >= 0) && roundCurrency(atRate.reduce((s, a) => s + a, 0)) === expected) {
    targets.forEach((li, i) => {
      li.amount = atRate[i];
    });
    return out;
  }
  if (postTotal <= 0) {
    targets[0].amount = roundCurrency(targets[0].amount + discountAmount);
    return out;
  }
  let added = 0;
  let largest = targets[0];
  for (const li of targets) {
    const share = roundCurrency(discountAmount * li.amount / postTotal);
    li.amount = roundCurrency(li.amount + share);
    added = roundCurrency(added + share);
    if (li.amount > largest.amount) largest = li;
  }
  const residual = roundCurrency(discountAmount - added);
  if (residual !== 0) largest.amount = roundCurrency(largest.amount + residual);
  return out;
}
function visitInvoiceLinesWithoutDiscount(visit, lineItems) {
  const discountAmount = visitInvoiceDiscountAmount(visit);
  return {
    lineItems: restoreDiscountedLineAmounts(
      lineItems,
      discountAmount,
      visit.billingMethod
    ),
    discountAmount
  };
}

// src/invoices/presentStoredInvoice.ts
function isStoredPackageInvoice(invoice) {
  return invoice.chargeType === PACKAGE_CHARGE_TYPE || typeof invoice.invoiceNumber === "string" && invoice.invoiceNumber.startsWith("PKG-") || typeof invoice.id === "string" && invoice.id.startsWith("package-");
}
function invoiceModalParams(invoice) {
  if (isStoredPackageInvoice(invoice) || !invoice.visitId) {
    return { invoiceId: invoice.id };
  }
  return { visitId: invoice.visitId };
}
function invoiceDetailPath(invoice) {
  const target = invoiceModalParams(invoice);
  if (target.visitId) return `/visits/${target.visitId}/invoice`;
  return `/invoices/${target.invoiceId}`;
}
function storedInvoiceDiscountAmount(invoice) {
  const lines = invoice.lineItems ?? [];
  return lines.filter((line) => !isRefundCreditLine(line)).reduce((sum, line) => sum + (typeof line.discount === "number" && line.discount > 0 ? line.discount : 0), 0);
}
function storedInvoiceDiscountInfo(invoice) {
  const amount = storedInvoiceDiscountAmount(invoice);
  if (!(amount > 0)) return null;
  return { type: "fixed", value: amount, amount };
}
function storedInvoiceRefundMetadata(invoice) {
  const refundedAmount = typeof invoice.refundedAmount === "number" ? invoice.refundedAmount : 0;
  if (!(refundedAmount > 0) && invoice.status !== "refunded") return void 0;
  const credit = (invoice.lineItems ?? []).find((line) => isRefundCreditLine(line));
  const amount = refundedAmount > 0 ? refundedAmount : Math.abs(credit?.amount ?? 0);
  if (!(amount > 0) && invoice.status !== "refunded") return void 0;
  return {
    refundAmount: amount,
    refundType: "refund",
    refundReason: credit?.description || (invoice.status === "refunded" ? PACKAGE_INVOICE_REFUND_LINE : PACKAGE_INVOICE_PARTIAL_REFUND_LINE),
    refundedAt: invoice.refundedAt || invoice.updatedAt || (/* @__PURE__ */ new Date()).toISOString(),
    refundStatus: "succeeded"
  };
}
function presentStoredInvoiceLineItems(invoice) {
  return (invoice.lineItems ?? []).map((line, index) => {
    const quantity = line.quantity ?? 1;
    const rate = line.rate ?? line.unitPrice ?? (quantity ? line.amount / quantity : line.amount);
    const discount = typeof line.discount === "number" && line.discount > 0 ? line.discount : 0;
    const isCredit = isRefundCreditLine(line);
    const amount = isCredit ? line.amount : discount > 0 ? rate * quantity : line.amount;
    return {
      id: `line-${index}`,
      type: isCredit ? "credit" : "service",
      description: line.description,
      quantity,
      rate: isCredit ? line.amount : rate,
      unitPrice: isCredit ? line.amount : line.unitPrice ?? rate,
      amount,
      ...discount > 0 ? { discount } : {}
    };
  });
}
function presentStoredInvoiceForView(invoice, extras = {}) {
  const discountInfo = storedInvoiceDiscountInfo(invoice);
  const refundMetadata = storedInvoiceRefundMetadata(invoice);
  const jobType = invoice.lineItems?.find((line) => !isRefundCreditLine(line))?.description || invoice.invoiceNumber;
  return {
    id: invoice.id,
    visitId: invoice.visitId,
    jobId: invoice.subscriptionId || invoice.id,
    customerId: invoice.customerId,
    customerName: extras.customerName || "Customer",
    customerEmail: extras.customerEmail,
    customerPhone: extras.customerPhone,
    customerAddress: extras.customerAddress,
    organizationName: extras.organizationName,
    organizationAddress: extras.organizationAddress,
    organizationPhone: extras.organizationPhone,
    organizationEmail: extras.organizationEmail,
    organizationWebsite: extras.organizationWebsite,
    organizationLogoUrl: extras.organizationLogoUrl,
    orgId: invoice.orgId,
    amount: invoice.amount,
    subtotal: invoice.amount,
    tax: 0,
    total: invoice.amount,
    status: invoice.status,
    lineItems: presentStoredInvoiceLineItems(invoice),
    createdAt: invoice.createdAt,
    updatedAt: invoice.updatedAt || invoice.createdAt,
    dueDate: invoice.dueDate || invoice.paidAt || invoice.createdAt,
    paidAt: invoice.paidAt,
    serviceDate: invoice.paidAt || invoice.createdAt,
    invoiceNumber: invoice.invoiceNumber,
    jobType,
    serviceTemplateName: jobType,
    metadata: { serviceTemplateName: jobType },
    transactionId: invoice.paymentId,
    paymentMethodType: invoice.paymentMethodType,
    chargeType: invoice.chargeType,
    subscriptionId: invoice.subscriptionId,
    serviceTemplateId: invoice.serviceTemplateId,
    refundedAmount: invoice.refundedAmount,
    ...discountInfo ? { discountInfo } : { discountInfo: null },
    ...refundMetadata ? { refundMetadata } : {}
  };
}
function presentStoredInvoiceForList(invoice, extras = {}) {
  const view = presentStoredInvoiceForView(invoice, extras);
  return {
    id: view.id,
    visitId: view.visitId,
    jobId: view.jobId,
    customerId: view.customerId,
    customerName: extras.customerName || view.customerName,
    orgId: view.orgId,
    amount: view.amount,
    status: view.status,
    lineItems: view.lineItems,
    createdAt: view.createdAt,
    updatedAt: view.updatedAt,
    dueDate: view.dueDate,
    paidAt: view.paidAt,
    invoiceNumber: view.invoiceNumber,
    jobType: view.jobType,
    propertyAddress: extras.propertyAddress,
    transactionId: view.transactionId,
    chargeType: view.chargeType,
    subscriptionId: view.subscriptionId,
    refundedAmount: view.refundedAmount,
    discountInfo: view.discountInfo,
    refundMetadata: view.refundMetadata
  };
}

// src/invoices/invoiceDetailDisplay.ts
var SERVICE_DISCOUNT_100_LABEL = "Service discount (100%)";
var REFUNDED_TO_CARD_LABEL = "Refunded to card";
function isInvoiceRefundDisplayLine(line) {
  const type = (line.type ?? "").toLowerCase();
  if (type === "credit" || type === "refund") return true;
  const description = line.description ?? "";
  return description === PACKAGE_INVOICE_REFUND_LINE || description === PACKAGE_INVOICE_PARTIAL_REFUND_LINE || typeof line.amount === "number" && line.amount < 0;
}
function invoiceChargeLineItems(lineItems) {
  return (lineItems ?? []).filter((line) => !isInvoiceRefundDisplayLine(line));
}
function lineRateTotal(line) {
  const quantity = line.quantity ?? 1;
  if (typeof line.rate === "number" && Number.isFinite(line.rate)) {
    return roundCurrency(line.rate * quantity);
  }
  return 0;
}
function lineDiscountAmount(line) {
  if (typeof line.discount === "number" && line.discount > 0) {
    return roundCurrency(line.discount);
  }
  const rateTotal = lineRateTotal(line);
  if (rateTotal > 0 && roundCurrency(line.amount) === 0) {
    return rateTotal;
  }
  return 0;
}
function isFullLineDiscount(line) {
  const rateTotal = lineRateTotal(line);
  if (!(rateTotal > 0)) return false;
  return lineDiscountAmount(line) === rateTotal;
}
function invoiceDiscountRow(invoice) {
  const info = invoice.discountInfo;
  const amount = info && info.amount > 0 ? roundCurrency(info.amount) : 0;
  if (!(amount > 0)) return null;
  const charges = invoiceChargeLineItems(invoice.lineItems);
  const rateSum = roundCurrency(
    charges.reduce((sum, line) => sum + lineRateTotal(line), 0)
  );
  const fullLine = charges.some(isFullLineDiscount);
  const coversRates = rateSum > 0 && amount === rateSum;
  const fullPercent = info?.type === "percentage" && info.value >= 100;
  if (fullLine || coversRates || fullPercent) {
    return { label: SERVICE_DISCOUNT_100_LABEL, amount };
  }
  if (info?.type === "percentage") {
    return { label: `Discount (${info.value}%)`, amount };
  }
  return { label: "Discount", amount };
}
function refundedDisplayAmount(invoice) {
  if (typeof invoice.refundedAmount === "number" && invoice.refundedAmount > 0) {
    return roundCurrency(invoice.refundedAmount);
  }
  if (invoice.refundMetadata?.refundStatus === "succeeded" && typeof invoice.refundMetadata.refundAmount === "number" && invoice.refundMetadata.refundAmount > 0) {
    return roundCurrency(invoice.refundMetadata.refundAmount);
  }
  const credits = (invoice.lineItems ?? []).filter(isInvoiceRefundDisplayLine);
  const fromLines = roundCurrency(
    credits.reduce((sum, line) => sum + Math.abs(line.amount), 0)
  );
  return fromLines;
}
function invoicePaymentSection(invoice) {
  const refunded = refundedDisplayAmount(invoice);
  const refundedStatus = (invoice.status ?? "").toLowerCase() === "refunded";
  if (!(refunded > 0) && !refundedStatus) return null;
  const paid = roundCurrency(
    typeof invoice.totalCharged === "number" && invoice.totalCharged > 0 ? invoice.totalCharged : typeof invoice.total === "number" ? invoice.total : refunded
  );
  return {
    paid,
    refunded,
    net: roundCurrency(paid - refunded)
  };
}
function formatInvoiceSignedAmount(amount, formatCurrency) {
  if (amount < 0) return `-${formatCurrency(Math.abs(amount))}`;
  return formatCurrency(amount);
}

// src/statements/buildCustomerStatement.ts
function cleanStatementDescription(description) {
  return description.replace(/^Service:\s*/i, "").replace(/\s*on\s+\d{1,2}\/\d{1,2}\/\d{4}$/, "").replace(/\bvisit\s+[A-Z0-9]+/gi, "visit").trim();
}
function normalizeType(type) {
  return type.toLowerCase();
}
function isChargeType(type) {
  const t = normalizeType(type);
  return t === "debit" /* DEBIT */ || t === "adjustment";
}
function buildCustomerStatement(entries, range) {
  const fromMs = range ? range.from.getTime() : -Infinity;
  const toMs2 = range ? range.to.getTime() : Infinity;
  const sorted = [...entries].sort(
    (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
  );
  const buckets = /* @__PURE__ */ new Map();
  for (const e of sorted) {
    if (!isChargeType(e.type)) continue;
    const key = e.visitId || e.id;
    let b = buckets.get(key);
    if (!b) {
      b = { key, debitIds: /* @__PURE__ */ new Set(), charge: 0, date: e.createdAt, visitId: e.visitId, firstDebit: e };
      buckets.set(key, b);
    }
    b.charge += Math.abs(e.amount);
    b.debitIds.add(e.id);
  }
  const lineItems = [];
  for (const b of buckets.values()) {
    const setupFeePrefix = "Setup fee for ";
    const isSetupFee = !b.visitId && b.firstDebit?.description?.startsWith(setupFeePrefix);
    const expectedSetupFeePayment = isSetupFee ? `Setup fee payment for ${b.firstDebit.description.slice(setupFeePrefix.length)}` : null;
    let applied = 0;
    for (const e of sorted) {
      const t = normalizeType(e.type);
      if (t === "credit_applied" /* CREDIT_APPLIED */ && e.appliedToDebitId && b.debitIds.has(e.appliedToDebitId)) {
        applied += Math.abs(e.amount);
      }
      if (t === "payment" /* PAYMENT */) {
        if (b.visitId && e.visitId === b.visitId) {
          applied += Math.abs(e.amount);
        } else if (expectedSetupFeePayment && !e.visitId && e.description === expectedSetupFeePayment && Math.abs(e.amount) === b.charge) {
          applied += Math.abs(e.amount);
        }
      }
    }
    const chargeMs = new Date(b.date).getTime();
    if (chargeMs < fromMs || chargeMs > toMs2) continue;
    const paidAmount = Math.min(applied, b.charge);
    lineItems.push({
      id: b.firstDebit?.id ?? b.key,
      date: b.date,
      serviceName: b.firstDebit ? cleanStatementDescription(b.firstDebit.description) : "Service",
      amount: b.charge,
      paidAmount,
      paid: b.charge - paidAmount < 0.01,
      visitId: b.visitId
    });
  }
  lineItems.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  const totalServices = lineItems.reduce((sum, l) => sum + l.amount, 0);
  const totalPaid = lineItems.reduce((sum, l) => sum + l.paidAmount, 0);
  return {
    lineItems,
    totalServices,
    totalPaid,
    totalOutstanding: Math.max(0, totalServices - totalPaid)
  };
}

// src/types/organization.ts
var LEGACY_RCS_STATUS_BUSINESS_VERIFIED = "business_verified";
function normalizeRcsStatus(status) {
  if (status === LEGACY_RCS_STATUS_BUSINESS_VERIFIED || status === "carrier_launched") return "carrier_launched";
  if (status === "pending" || status === "live") return status;
  return "off";
}
function normalizeRcsUpgradeKind(kind) {
  return kind === "business" || kind === "carrier_launch" ? "carrier_launch" : "upgrade";
}
function normalizeRcsRegistrationStatus(raw) {
  if (!raw) return void 0;
  return {
    ...raw,
    status: normalizeRcsStatus(raw.status),
    carrierLaunchChargeId: raw.carrierLaunchChargeId ?? raw.businessChargeId,
    carrierLaunchRefundId: raw.carrierLaunchRefundId ?? raw.businessRefundId
  };
}
var SETUP_CHECKLIST_ITEM_KEYS = [
  "importCustomers",
  "activatePayments",
  "inviteCrewMembers",
  "organizeCrews",
  "reviewServices",
  "setUpSubcontractors",
  // Registration asks for one phone number and which it is; whichever was not
  // given becomes a reminder here instead of a second ask.
  "addCompanyPhone",
  "addYourMobile"
];

// src/types/auth.ts
var UserRole = /* @__PURE__ */ ((UserRole2) => {
  UserRole2["ADMIN"] = "admin";
  UserRole2["CREW"] = "crew";
  UserRole2["CUSTOMER"] = "customer";
  return UserRole2;
})(UserRole || {});

// src/types/integrationUsage.ts
var PLATFORM_USAGE_ORG_ID = "PLATFORM";

// src/reporting/dailySales.ts
var NON_SALES_VISIT_STATUSES = /* @__PURE__ */ new Set([
  "skipped" /* SKIPPED */,
  "cancelled" /* CANCELLED */,
  "discarded" /* DISCARDED */,
  "refunded" /* REFUNDED */
]);
var UNKNOWN_CUSTOMER = "Unknown customer";
var OTHER_SERVICES = "Other services";
function resolveServiceName(serviceName) {
  return serviceName?.trim() || OTHER_SERVICES;
}
function resolveAmount(totalAmount) {
  if (typeof totalAmount === "number" && Number.isFinite(totalAmount)) {
    return { amount: totalAmount, amountMissing: false };
  }
  return { amount: 0, amountMissing: true };
}
function summarizeDailySales(visits, date) {
  const lineItems = [];
  let totalSales = 0;
  let collectedSales = 0;
  let paidCount = 0;
  for (const visit of visits) {
    if (NON_SALES_VISIT_STATUSES.has(visit.status)) continue;
    const { amount, amountMissing } = resolveAmount(visit.totalAmount);
    const isPaid = visit.status === "paid" /* PAID */;
    totalSales += amount;
    if (isPaid) {
      collectedSales += amount;
      paidCount += 1;
    }
    lineItems.push({
      visitId: visit.id,
      customerId: visit.customerId,
      customerName: visit.customerName?.trim() || UNKNOWN_CUSTOMER,
      serviceName: visit.serviceName?.trim() || void 0,
      serviceTemplateId: visit.serviceTemplateId,
      crewId: visit.crewId,
      completedAt: visit.completedAt,
      amount: roundCurrency(amount),
      status: visit.status,
      isPaid,
      ...visit.paymentStatus != null ? { paymentStatus: visit.paymentStatus } : {},
      ...visit.chargeAfter != null ? { chargeAfter: visit.chargeAfter } : {},
      ...amountMissing ? { amountMissing: true } : {}
    });
  }
  lineItems.sort((a, b) => b.amount - a.amount);
  const serviceGroups = groupByService(lineItems);
  const roundedTotal = roundCurrency(totalSales);
  const roundedCollected = roundCurrency(collectedSales);
  return {
    date,
    totalSales: roundedTotal,
    collectedSales: roundedCollected,
    outstandingSales: roundCurrency(roundedTotal - roundedCollected),
    visitCount: lineItems.length,
    paidCount,
    serviceGroups,
    lineItems
  };
}
function groupByService(lineItems) {
  const groups = /* @__PURE__ */ new Map();
  for (const item of lineItems) {
    const serviceName = resolveServiceName(item.serviceName);
    let group = groups.get(serviceName);
    if (!group) {
      group = {
        serviceName,
        total: 0,
        collected: 0,
        outstanding: 0,
        visitCount: 0,
        paidCount: 0
      };
      groups.set(serviceName, group);
    }
    group.total += item.amount;
    group.visitCount += 1;
    if (item.isPaid) {
      group.collected += item.amount;
      group.paidCount += 1;
    }
    if (item.amountMissing) group.amountMissing = true;
  }
  const result = [...groups.values()].map((group) => {
    const total = roundCurrency(group.total);
    const collected = roundCurrency(group.collected);
    return {
      ...group,
      total,
      collected,
      outstanding: roundCurrency(total - collected)
    };
  });
  result.sort((a, b) => b.total - a.total || a.serviceName.localeCompare(b.serviceName));
  return result;
}

// src/api/payments.ts
var PaymentMethodType = /* @__PURE__ */ ((PaymentMethodType2) => {
  PaymentMethodType2["CARD"] = "card";
  PaymentMethodType2["BANK_ACCOUNT"] = "bank_account";
  return PaymentMethodType2;
})(PaymentMethodType || {});
var PaymentMethodStatus = /* @__PURE__ */ ((PaymentMethodStatus2) => {
  PaymentMethodStatus2["ACTIVE"] = "active";
  PaymentMethodStatus2["INACTIVE"] = "inactive";
  PaymentMethodStatus2["EXPIRED"] = "expired";
  PaymentMethodStatus2["FAILED"] = "failed";
  return PaymentMethodStatus2;
})(PaymentMethodStatus || {});
var RutaPayStatus = /* @__PURE__ */ ((RutaPayStatus2) => {
  RutaPayStatus2["PENDING"] = "pending";
  RutaPayStatus2["SUBMITTED"] = "submitted";
  RutaPayStatus2["APPROVED"] = "approved";
  RutaPayStatus2["REJECTED"] = "rejected";
  RutaPayStatus2["REQUIRES_INFO"] = "requires_info";
  return RutaPayStatus2;
})(RutaPayStatus || {});

// src/types/api/refunds/index.ts
var RefundType = /* @__PURE__ */ ((RefundType2) => {
  RefundType2["REFUND"] = "refund";
  RefundType2["CREDIT"] = "credit";
  return RefundType2;
})(RefundType || {});
var RefundStatus = /* @__PURE__ */ ((RefundStatus2) => {
  RefundStatus2["PENDING"] = "pending";
  RefundStatus2["SUCCEEDED"] = "succeeded";
  RefundStatus2["FAILED"] = "failed";
  return RefundStatus2;
})(RefundStatus || {});
var RefundReason = /* @__PURE__ */ ((RefundReason2) => {
  RefundReason2["SERVICE_NOT_COMPLETED"] = "Service not completed";
  RefundReason2["WEATHER_PREVENTED"] = "Weather prevented completion";
  RefundReason2["EQUIPMENT_FAILURE"] = "Equipment failure";
  RefundReason2["CUSTOMER_DISSATISFACTION"] = "Customer dissatisfaction";
  RefundReason2["BILLING_ERROR"] = "Billing error";
  RefundReason2["GOODWILL_ADJUSTMENT"] = "Goodwill adjustment";
  RefundReason2["OTHER"] = "Other (specify)";
  return RefundReason2;
})(RefundReason || {});

// src/api/customers.ts
var MESSAGE_CONTACT_MODE = {
  ALL: "all",
  ALL_EMAILS: "all_emails",
  PRIMARY_ONLY: "primary_only"
};

// src/pricing/bundlePriceCalculator.ts
function isPendingCustomerDetails(template, customerMetrics) {
  if (template.billingMethod !== "per_visit" /* PER_VISIT */) return false;
  if (!template.volumePricing?.enabled) return false;
  const applicable = template.volumePricing.applicableMetrics ?? [];
  if (applicable.length > 0) {
    return !applicable.some((type) => {
      const value = customerMetrics?.[METRIC_TYPE_TO_KEY[type]];
      return typeof value === "number" && value > 0;
    });
  }
  return !hasAnyMetricValue(customerMetrics);
}
function scalarFromRate(result) {
  if (result.billingMethod === "per_hour" /* PER_HOUR */) return result.hourlyRate;
  if (result.billingMethod === "package" /* PACKAGE */) return result.packageAmount;
  if (result.billingMethod === "consumable" /* CONSUMABLE */) return 0;
  return result.rate;
}
function calculateBundlePrice(input) {
  const {
    policy,
    templates,
    customerMetrics,
    budgetedHoursByTemplateId,
    quotedAmountsByTemplateId
  } = input;
  const calculatedAt = (/* @__PURE__ */ new Date()).toISOString();
  if (policy.mode === "fixed") {
    return {
      mode: "fixed",
      breakdown: [],
      subtotal: policy.amount,
      discountAmount: 0,
      preRoundingTotal: policy.amount,
      total: policy.amount,
      pendingCustomerDetails: false,
      calculatedAt
    };
  }
  const breakdown = templates.map((template) => {
    const quoted = quotedAmountsByTemplateId?.[template.id];
    if (quoted !== void 0) {
      return {
        templateId: template.id,
        templateName: template.name,
        billingMethod: template.billingMethod || "per_visit" /* PER_VISIT */,
        amount: quoted,
        pendingCustomerDetails: false
      };
    }
    const pending = isPendingCustomerDetails(template, customerMetrics);
    const rate = calculateSubscriptionRateFromEntities(
      template,
      customerMetrics,
      budgetedHoursByTemplateId?.[template.id]
    );
    return {
      templateId: template.id,
      templateName: template.name,
      billingMethod: template.billingMethod || "per_visit" /* PER_VISIT */,
      amount: scalarFromRate(rate),
      pendingCustomerDetails: pending
    };
  });
  const subtotal = roundCurrency(
    breakdown.reduce((sum, item) => sum + item.amount, 0)
  );
  let discounted = subtotal;
  if (policy.discount) {
    if (policy.discount.type === "percentage") {
      discounted = roundCurrency(subtotal * (1 - policy.discount.value / 100));
    } else {
      discounted = roundCurrency(Math.max(0, subtotal - policy.discount.value));
    }
  }
  const discountAmount = roundCurrency(subtotal - discounted);
  const preRoundingTotal = discounted;
  const total = applyDisplayRounding(preRoundingTotal, policy.displayRounding);
  return {
    mode: "derived",
    breakdown,
    subtotal,
    discountAmount,
    preRoundingTotal,
    total,
    pendingCustomerDetails: breakdown.some((item) => item.pendingCustomerDetails),
    calculatedAt
  };
}
function quotedAmountsFromMemberRates(members) {
  const amounts = {};
  for (const m of members) {
    if (typeof m.rate === "number" && Number.isFinite(m.rate)) amounts[m.templateId] = m.rate;
  }
  return amounts;
}
function bundleTotalFromMemberRates(policy, members, customerMetrics) {
  if (policy.mode !== "fixed") {
    if (members.length === 0) return null;
    if (members.some((m) => typeof m.rate !== "number" || !Number.isFinite(m.rate))) return null;
    const varies = members.some((m) => {
      const method = m.template?.billingMethod ?? m.billingMethod;
      return method === "per_hour" /* PER_HOUR */ || method === "consumable" /* CONSUMABLE */;
    });
    if (varies) return null;
  }
  const quotedAmountsByTemplateId = quotedAmountsFromMemberRates(members);
  return calculateBundlePrice({
    policy,
    templates: members.map(
      (m) => m.template ?? { id: m.templateId, name: m.name ?? m.templateId, billingMethod: "per_visit" /* PER_VISIT */ }
    ),
    customerMetrics,
    quotedAmountsByTemplateId
  }).total;
}

// src/pricing/serviceOptionLineAmount.ts
function resolvePricing(definition, usage) {
  const hasSnapshot = usage?.rate !== void 0 && !!usage.name && !!usage.rateType && usage.billable !== void 0;
  if (hasSnapshot) {
    return {
      rate: usage.rate,
      rateType: usage.rateType,
      billable: usage.billable,
      unit: usage.unit,
      builtInAmount: usage.builtInAmount,
      choices: definition.choices
    };
  }
  return {
    ...definition,
    rateType: definition.rateType
  };
}
function calculateServiceOptionLineAmount(definition, usage) {
  const pricing = resolvePricing(definition, usage);
  const quantity = usage?.quantity ?? 0;
  const timeUsed = usage?.timeUsed ?? 0;
  const isTimeBased = pricing.rateType === "time-based" /* TIME_BASED */;
  const recorded = isTimeBased ? timeUsed : quantity;
  const usesIncluded = pricing.rateType === "per-unit" /* PER_UNIT */ || isTimeBased;
  const included = usesIncluded ? pricing.builtInAmount || 0 : 0;
  const billableQuantity = usesIncluded ? Math.max(0, recorded - included) : recorded;
  const result = {
    rateType: pricing.rateType,
    rate: pricing.rate,
    billable: pricing.billable,
    unit: isTimeBased ? pricing.unit || "hours" /* HOURS */ : pricing.unit,
    amount: 0,
    recorded,
    included,
    billableQuantity,
    withinIncluded: included > 0 && recorded <= included,
    choices: []
  };
  if (quantity < 0) return result;
  if (pricing.rateType === "multi-select" /* MULTI_SELECT */) {
    for (const pick of usage?.selectedChoices ?? []) {
      if (!pick.choiceId || pick.quantity <= 0) continue;
      let name;
      let rate;
      if (pick.name !== void 0) {
        name = pick.name;
        rate = pick.rate;
      } else {
        const def = pricing.choices?.find((c) => c.id === pick.choiceId);
        if (!def) continue;
        name = def.name;
        rate = def.rate;
      }
      if (!name) continue;
      if (name.trim().toLowerCase() === "no") continue;
      const choiceRate = rate ?? 0;
      const amount = roundCurrency(pick.quantity * choiceRate);
      result.choices.push({
        choiceId: pick.choiceId,
        name,
        rate: choiceRate,
        quantity: pick.quantity,
        amount
      });
    }
    result.amount = roundCurrency(
      result.choices.reduce((sum, c) => sum + c.amount, 0)
    );
    return result;
  }
  if (!pricing.billable) return result;
  switch (pricing.rateType) {
    case "flat" /* FLAT */:
      result.amount = quantity > 0 ? pricing.rate : 0;
      break;
    case "per-unit" /* PER_UNIT */:
    case "time-based" /* TIME_BASED */:
      result.amount = roundCurrency(billableQuantity * pricing.rate);
      break;
  }
  return result;
}
function formatIncludedQuantityNote(line, formatCurrency) {
  if (line.included <= 0 || !line.billable) return null;
  if (line.rateType !== "per-unit" /* PER_UNIT */ && line.rateType !== "time-based" /* TIME_BASED */) {
    return null;
  }
  if (line.withinIncluded) return "(within included)";
  const fmt = (n) => n.toLocaleString("en-US", { maximumFractionDigits: 2 });
  return `${fmt(line.included)} included + ${fmt(line.billableQuantity)} \xD7 ${formatCurrency(line.rate)}`;
}

// src/pricing/subcontractorPayout.ts
function calculateSubcontractorPayoutForVisit(visit, payStructure) {
  if (!payStructure) return { baseline: 0, payout: 0 };
  if (payStructure.type === "flat_amount" /* FLAT_AMOUNT */) {
    return { baseline: payStructure.value, payout: payStructure.value };
  }
  if (payStructure.type === "visit_percentage" /* VISIT_PERCENTAGE */) {
    const multiplier = visit.appliedVisitCountMultiplier ?? 1;
    const isBundleVisit = !!visit.bundleId;
    const isPackageBilling = !!visit.selectedPackageOptionId;
    let baseline;
    if (isBundleVisit) {
      baseline = (visit.bundleMemberValue || 0) * multiplier;
    } else if (isPackageBilling) {
      baseline = (visit.pricePerAdditionalVisit || 0) * multiplier;
    } else if (visit.visitDiscount?.payOnGross && visit.finalPricing?.preDiscountSubtotal != null) {
      baseline = visit.finalPricing.preDiscountSubtotal;
    } else {
      baseline = (visit.totalAmount || 0) - (visit.taxAmount || 0);
    }
    return { baseline, payout: baseline * (payStructure.value / 100) };
  }
  return { baseline: 0, payout: 0 };
}
function validateSubcontractorRateOverrides(overrides) {
  if (overrides === void 0) return null;
  if (!Array.isArray(overrides)) {
    return "subcontractorRateOverrides must be an array";
  }
  for (const override of overrides) {
    if (!override.companyId || typeof override.companyId !== "string") {
      return "Each subcontractor rate override must have a valid companyId";
    }
    if (!override.rate || !Object.values(SubcontractorPayType).includes(override.rate.type)) {
      return `Invalid rate type for company ${override.companyId}`;
    }
    if (typeof override.rate.value !== "number" || override.rate.value < 0) {
      return `Rate value must be a non-negative number for company ${override.companyId}`;
    }
    if (override.rate.type === "visit_percentage" /* VISIT_PERCENTAGE */ && override.rate.value > 100) {
      return `Percentage rate must be between 0 and 100 for company ${override.companyId}`;
    }
  }
  return null;
}

// src/pricing/revenueSplit.ts
function visitTaxRatePercent(visit) {
  const fraction = visit.finalPricing?.taxRate ?? visit.taxRate ?? 0;
  return Math.round(fraction * 1e4) / 100;
}
function taxRatePercentToHundredths(percent) {
  return Math.round(percent * 100);
}
function computeVisitRevenueSplit(visit) {
  const fp = visit.finalPricing;
  const taxCharged = visit.taxAmount ?? 0;
  const subtotal = roundCurrency(
    fp?.subtotal ?? Math.max(0, (visit.totalAmount ?? 0) - taxCharged)
  );
  const serviceOptionsAmount = roundCurrency(
    fp?.serviceOptionsAmount ?? visit.serviceOptionsAmount ?? 0
  );
  const baseServiceAmount = roundCurrency(Math.max(0, subtotal - serviceOptionsAmount));
  const lineItems = fp?.lineItems;
  let taxableSubtotal;
  if (taxCharged <= 0) {
    taxableSubtotal = 0;
  } else if (lineItems && lineItems.length > 0) {
    const taxable = lineItems.reduce(
      (sum, li) => sum + (li.taxable === true ? li.amount ?? 0 : 0),
      0
    );
    taxableSubtotal = Math.min(Math.max(roundCurrency(taxable), 0), subtotal);
  } else {
    taxableSubtotal = subtotal;
  }
  const nonTaxableSubtotal = roundCurrency(subtotal - taxableSubtotal);
  return {
    subtotal,
    baseServiceAmount,
    serviceOptionsAmount,
    taxableSubtotal,
    nonTaxableSubtotal
  };
}

// src/pricing/estimatedServiceValue.ts
var DEFAULT_HOURLY_ESTIMATE_HOURS = 1;
function isPositiveFiniteNumber(value) {
  return typeof value === "number" && Number.isFinite(value) && value > 0;
}
function isFiniteNumber(value) {
  return typeof value === "number" && Number.isFinite(value);
}
function estimateServiceValue(input) {
  switch (input.billingMethod) {
    case "per_visit" /* PER_VISIT */:
    case "package" /* PACKAGE */:
      return isFiniteNumber(input.rate) ? input.rate : null;
    case "per_hour" /* PER_HOUR */: {
      if (isPositiveFiniteNumber(input.minimumCharge)) {
        return input.minimumCharge;
      }
      if (!isFiniteNumber(input.hourlyRate)) return null;
      const hours = isPositiveFiniteNumber(input.budgetedHours) ? input.budgetedHours : DEFAULT_HOURLY_ESTIMATE_HOURS;
      return roundCurrency(input.hourlyRate * hours);
    }
    case "consumable" /* CONSUMABLE */:
      return null;
    default: {
      const _exhaustive = input.billingMethod;
      throw new Error(`Unknown billing method: ${_exhaustive}`);
    }
  }
}
function estimateNotStartedVisitValue(input) {
  const { billingMethod, minimumCharge } = input;
  const floor = isPositiveFiniteNumber(minimumCharge) ? minimumCharge : null;
  if (!billingMethod) {
    if (isFiniteNumber(input.subscriptionRate)) {
      return floor != null ? Math.max(input.subscriptionRate, floor) : input.subscriptionRate;
    }
    return floor;
  }
  if (billingMethod === "package" /* PACKAGE */) return null;
  const estimate = estimateServiceValue({
    billingMethod,
    rate: input.subscriptionRate,
    minimumCharge,
    // PER_HOUR stores the hourly rate in `subscriptionRate`; fall back to it
    // when the visit's own `hourlyRate` snapshot is absent.
    hourlyRate: input.hourlyRate ?? input.subscriptionRate,
    budgetedHours: input.budgetedHours
  });
  if (estimate == null) return floor;
  return floor != null ? Math.max(estimate, floor) : estimate;
}
function estimateSubscriptionValue(subscription, template) {
  const billingMethod = subscription.billingMethod ?? template?.billingMethod;
  if (!billingMethod) return null;
  return estimateServiceValue({
    billingMethod,
    rate: subscription.rate,
    minimumCharge: subscription.minimumCharge ?? template?.minimumCharge,
    hourlyRate: subscription.pricingInputs?.hourlyRate ?? template?.hourlyRate,
    budgetedHours: subscription.pricingInputs?.budgetedHours ?? subscription.hourBounds?.budgetedHours ?? template?.hourBounds?.budgetedHours
  });
}
function frequencyVisitsPerYear(frequency, customConfig) {
  switch (frequency) {
    case "one_time" /* ONE_TIME */:
    case "yearly" /* YEARLY */:
      return 1;
    case "monthly" /* MONTHLY */:
      return 12;
    case "weekly" /* WEEKLY */:
      return 52;
    case "on_demand" /* ON_DEMAND */:
      return null;
    case "custom" /* CUSTOM */: {
      if (!customConfig || !isPositiveFiniteNumber(customConfig.interval)) {
        return null;
      }
      switch (customConfig.unit) {
        case "days" /* DAYS */:
          return 365 / customConfig.interval;
        case "weeks" /* WEEKS */:
          return 52 / customConfig.interval;
        case "months" /* MONTHS */:
          return 12 / customConfig.interval;
        case "years" /* YEARS */:
          return 1 / customConfig.interval;
        default:
          return null;
      }
    }
    default:
      return null;
  }
}
function getScheduleVisitsPerYear(schedule) {
  switch (schedule.type) {
    case "recurring":
      return frequencyVisitsPerYear(schedule.frequency, schedule.customConfig);
    case "limited":
      if ((schedule.period === "year" || schedule.period === "season") && isPositiveFiniteNumber(schedule.visitLimit)) {
        return schedule.visitLimit;
      }
      return null;
    case "windowed":
      return isPositiveFiniteNumber(schedule.visitLimit) ? schedule.visitLimit : null;
    default:
      return null;
  }
}
function getTemplateVisitsPerYear(template) {
  if (template.serviceType === "one_time" /* ONE_TIME */) return 1;
  const cfg = template.scheduleConfig;
  if (!cfg) return null;
  return frequencyVisitsPerYear(cfg.frequency, cfg.customConfig);
}
function getSubscriptionVisitsPerYear(subscription, fallbackVisitsPerYear) {
  const schedules = subscription.schedules ?? [];
  let total = 0;
  let hasDeterminate = false;
  for (const schedule of schedules) {
    const vpy = getScheduleVisitsPerYear(schedule);
    if (vpy != null) {
      total += vpy;
      hasDeterminate = true;
    }
  }
  if (hasDeterminate) return total;
  return isPositiveFiniteNumber(fallbackVisitsPerYear) ? fallbackVisitsPerYear : null;
}
function estimateAnnualSubscriptionRevenue(subscription, options) {
  const value = estimateSubscriptionValue(subscription, options?.template);
  if (value == null) return null;
  if (subscription.billingMethod === "package" /* PACKAGE */) {
    return value;
  }
  const visitsPerYear = getSubscriptionVisitsPerYear(
    subscription,
    options?.fallbackVisitsPerYear
  );
  if (visitsPerYear == null) return null;
  return roundCurrency(value * visitsPerYear);
}

// src/helpers/subscription.ts
var ONE_OFF_TEMPLATE_PREFIX = "ONE_OFF_";
var GENERIC_SERVICE_LABEL = "Service";
function resolveRealServiceName(sub) {
  const name = sub.serviceTemplateName?.trim();
  if (!name) return void 0;
  if (name === GENERIC_SERVICE_LABEL) return void 0;
  return name;
}
function resolvePeriodIdsForSchedule(template, selectedPeriodIds) {
  if (selectedPeriodIds && selectedPeriodIds.length > 0) {
    return [...new Set(selectedPeriodIds)];
  }
  if (!template || template.periodsSelectable) return void 0;
  const activeIds = (template.periods ?? []).filter((p) => p.isActive).map((p) => p.id);
  return activeIds.length > 0 ? activeIds : void 0;
}
function buildImportedSubscriptionSchedule(params) {
  const { scheduleId, now, scheduleConfig, resolvedPeriodIds, subscriptionStatus, activatedAt } = params;
  const fulfillmentStatus = subscriptionStatus === "active" /* ACTIVE */ ? ScheduleFulfillmentStatus.IN_PROGRESS : ScheduleFulfillmentStatus.PENDING;
  return {
    id: scheduleId,
    type: ScheduleType.RECURRING,
    frequency: scheduleConfig?.frequency ?? "on_demand" /* ON_DEMAND */,
    customConfig: scheduleConfig?.customConfig,
    periodIds: resolvedPeriodIds,
    effectiveFrom: activatedAt ?? now,
    activatedAt: subscriptionStatus === "active" /* ACTIVE */ ? activatedAt ?? now : void 0,
    createdAt: now,
    fulfillment: {
      status: fulfillmentStatus,
      completedCount: 0
    }
  };
}
function isOneOffSubscription(sub) {
  if (sub.isOneOffService === true) return true;
  return typeof sub.serviceTemplateId === "string" && sub.serviceTemplateId.startsWith(ONE_OFF_TEMPLATE_PREFIX);
}
function getVisitSubscriptionId(sub) {
  return `${sub.customerId}#${sub.serviceTemplateId}`;
}
function synthesizeServiceTemplateFromSubscription(sub, orgId) {
  const hourlyRate = sub.pricingInputs?.hourlyRate;
  const isHourly = typeof hourlyRate === "number" && hourlyRate > 0;
  const now = (/* @__PURE__ */ new Date()).toISOString();
  const inline = sub.oneOffTemplate ?? {};
  const scheduleTypes = /* @__PURE__ */ new Set();
  for (const s of sub.schedules ?? []) scheduleTypes.add(s.type);
  if (scheduleTypes.size === 0) scheduleTypes.add(ScheduleType.LIMITED);
  const allowedScheduleTypes = Array.from(scheduleTypes);
  const hasRecurring = scheduleTypes.has(ScheduleType.RECURRING);
  const serviceType = hasRecurring ? "recurring" /* RECURRING */ : "one_time" /* ONE_TIME */;
  return {
    id: sub.serviceTemplateId,
    organizationId: orgId,
    name: sub.serviceTemplateName || "Custom Service",
    description: sub.serviceTemplateDescription || "",
    isActive: true,
    // Legacy fields kept in dual-write window; Phase 8 drops them
    serviceType,
    allowOneTimeService: scheduleTypes.has(ScheduleType.LIMITED),
    allowedScheduleTypes,
    billingMethod: sub.billingMethod ?? (isHourly ? "per_hour" /* PER_HOUR */ : "per_visit" /* PER_VISIT */),
    pricingMethod: inline.pricingMethod ?? (isHourly ? "per_hour" /* PER_HOUR */ : "fixed_price" /* FIXED_PRICE */),
    hourlyRate: hourlyRate ?? 0,
    minimumCharge: sub.minimumCharge ?? null,
    builtInHours: sub.builtInHours ?? sub.pricingInputs?.hours ?? null,
    hourBounds: sub.hourBounds,
    // Inline template-equivalent config — fields are `Pick`ed straight from
    // `ServiceTemplate`, so any future template-shape change surfaces here
    // as a compile error rather than silent drift.
    category: inline.category,
    isTaxable: inline.isTaxable,
    // RUT-1828: a custom (one-off) service's season(s) live inline on the
    // subscription's `seasonalAvailability` (it has no ServiceTemplate row).
    // Surfacing them as `periods` lets the shared dispatch period gate
    // (`dispatchBatchProcessor`) and the webapp's merged-service view read the
    // season exactly as they would for a templated service.
    periods: sub.seasonalAvailability ?? [],
    serviceOptions: inline.serviceOptions ?? [],
    packagePricing: inline.packagePricing,
    volumePricing: inline.volumePricing,
    dayPreferences: inline.dayPreferences,
    // RUT-1826: carry the one-off's subcontractor income-% overrides so the
    // shared payout resolver reads them exactly as it would for a recurring
    // service's template.
    subcontractorRateOverrides: inline.subcontractorRateOverrides,
    createdAt: sub.createdAt || now,
    updatedAt: sub.updatedAt || now
  };
}
function resolveEffectiveServiceTemplate(templateFromRepo, subscription, orgId) {
  if (subscription && isOneOffSubscription(subscription)) {
    return synthesizeServiceTemplateFromSubscription(subscription, orgId);
  }
  return templateFromRepo ?? null;
}
function getSchedules(sub) {
  return sub.schedules ?? [];
}
function findScheduleIndex(sub, scheduleId) {
  const list = getSchedules(sub);
  return list.findIndex((s) => s.id === scheduleId);
}
function findScheduleById(sub, scheduleId) {
  return getSchedules(sub).find((s) => s.id === scheduleId);
}
function activeSchedules(sub, now = /* @__PURE__ */ new Date()) {
  return getSchedules(sub).filter((s) => isScheduleActive(s, now));
}
function isScheduleActive(s, now = /* @__PURE__ */ new Date()) {
  if (s.deactivatedAt) return false;
  if (s.fulfillment.status === ScheduleFulfillmentStatus.FULFILLED || s.fulfillment.status === ScheduleFulfillmentStatus.EXPIRED) {
    return false;
  }
  const nowIso = now.toISOString();
  if (s.effectiveFrom && nowIso < s.effectiveFrom) return false;
  if (s.effectiveUntil && nowIso > s.effectiveUntil) return false;
  return true;
}
function hasLimitedSchedule(sub) {
  return getSchedules(sub).some((s) => s.type === ScheduleType.LIMITED);
}
function hasRecurringSchedule(sub) {
  return getSchedules(sub).some((s) => s.type === ScheduleType.RECURRING);
}
function effectiveWindowsOverlap(a, b) {
  const aStart = a.effectiveFrom ?? "";
  const aEnd = a.effectiveUntil ?? "\uFFFF";
  const bStart = b.effectiveFrom ?? "";
  const bEnd = b.effectiveUntil ?? "\uFFFF";
  return aStart <= bEnd && bStart <= aEnd;
}
function rollupSubscriptionStatus(sub) {
  if (sub.subscriptionStatus === "cancelled" /* CANCELLED */) {
    return "cancelled" /* CANCELLED */;
  }
  if (sub.subscriptionStatus === "payment_pending" /* PAYMENT_PENDING */) {
    return "payment_pending" /* PAYMENT_PENDING */;
  }
  return hasOpenSchedule(sub) ? "active" /* ACTIVE */ : "inactive" /* INACTIVE */;
}
function isOpenSchedule(s) {
  return !s.deactivatedAt && (s.fulfillment.status === ScheduleFulfillmentStatus.PENDING || s.fulfillment.status === ScheduleFulfillmentStatus.IN_PROGRESS);
}
function hasOpenSchedule(sub) {
  return getSchedules(sub).some(isOpenSchedule);
}
function buildActivationSchedule(params) {
  const { id, now, oneTime, subscription, template, periodIds } = params;
  const fulfillment = { status: ScheduleFulfillmentStatus.PENDING, completedCount: 0 };
  if (oneTime) {
    return { id, type: ScheduleType.LIMITED, visitLimit: 1, periodIds, createdAt: now, fulfillment };
  }
  return {
    id,
    type: ScheduleType.RECURRING,
    frequency: subscription.scheduleConfig?.frequency ?? template?.scheduleConfig?.frequency ?? "weekly" /* WEEKLY */,
    customConfig: subscription.scheduleConfig?.customConfig ?? template?.scheduleConfig?.customConfig,
    periodIds,
    createdAt: now,
    fulfillment
  };
}
function inheritedPeriodIds(sub, template) {
  const committed = Array.from(
    new Set(getSchedules(sub).flatMap((s) => s.periodIds ?? []))
  );
  if (committed.length > 0) return committed;
  const fromTemplate = resolvePeriodIdsForSchedule(template, void 0);
  return fromTemplate && fromTemplate.length > 0 ? fromTemplate : void 0;
}
function isScheduleTypeAllowed(template, type) {
  if (template.allowedScheduleTypes && template.allowedScheduleTypes.length > 0) {
    return template.allowedScheduleTypes.includes(type);
  }
  const isOneTime = template.serviceType === "one_time";
  if (type === ScheduleType.RECURRING) return !isOneTime;
  if (type === ScheduleType.LIMITED) return isOneTime || template.allowOneTimeService === true;
  return false;
}
function activeRecurringSchedule(sub, now = /* @__PURE__ */ new Date()) {
  return activeSchedules(sub, now).find(
    (s) => s.type === ScheduleType.RECURRING
  );
}
function recurringPeriodRestriction(schedules) {
  const live = (schedules ?? []).filter(
    (s) => s.type === ScheduleType.RECURRING && !s.deactivatedAt && s.fulfillment.status !== ScheduleFulfillmentStatus.FULFILLED && s.fulfillment.status !== ScheduleFulfillmentStatus.EXPIRED
  );
  if (live.length === 0) return null;
  const ids = /* @__PURE__ */ new Set();
  let sawRestricted = false;
  let sawUnrestricted = false;
  for (const s of live) {
    if (!s.periodIds || s.periodIds.length === 0) {
      sawUnrestricted = true;
      continue;
    }
    sawRestricted = true;
    for (const id of s.periodIds) ids.add(id);
  }
  if (!sawRestricted) return null;
  if (sawUnrestricted) return null;
  return ids;
}
function isOneOffScheduleInSeason(seasonalAvailability, schedule, now = /* @__PURE__ */ new Date()) {
  const ids = schedule.periodIds;
  if (!ids || ids.length === 0) return true;
  const seasons = (seasonalAvailability ?? []).filter((p) => ids.includes(p.id));
  if (seasons.length === 0) return true;
  return seasons.some((p) => PeriodHelpers.isPeriodActive(p, now));
}
function shouldAcceptAsOneTimeSchedule(template, scheduleConfig) {
  if (scheduleConfig?.frequency === "one_time" /* ONE_TIME */) return true;
  if (!template) return false;
  const asTemplate = template;
  const recurringAllowed = isScheduleTypeAllowed(asTemplate, ScheduleType.RECURRING);
  const limitedAllowed = isScheduleTypeAllowed(asTemplate, ScheduleType.LIMITED);
  return !recurringAllowed && limitedAllowed;
}
function activeLimitedScheduleWithCapacity(sub, now = /* @__PURE__ */ new Date()) {
  return activeSchedules(sub, now).find(
    (s) => s.type === ScheduleType.LIMITED && s.fulfillment.completedCount < s.visitLimit
  );
}
function isOneTimeWindowSchedule(s) {
  return s.type === ScheduleType.LIMITED && s.visitLimit === 1 && (!!s.effectiveFrom || !!s.effectiveUntil);
}
function pickDueOneTimeWindowSchedule(sub, now = /* @__PURE__ */ new Date()) {
  return getSchedules(sub).find(
    (s) => isOneTimeWindowSchedule(s) && isScheduleActive(s, now) && !s.lastAutoDispatchDate
  );
}
function pickDispatchSchedule(sub, providedScheduleId, now = /* @__PURE__ */ new Date(), periods) {
  if (providedScheduleId) {
    const found = findScheduleById(sub, providedScheduleId);
    if (found) return found;
  }
  const active = activeSchedules(sub, now);
  const inSeason = (s) => {
    const pids = s.periodIds ?? [];
    if (pids.length === 0) return true;
    return (periods ?? []).some(
      (p) => pids.includes(p.id) && PeriodHelpers.isPeriodActive(p, now)
    );
  };
  const preferInSeason = (list) => {
    if (!periods?.length) return list;
    const live = list.filter(inSeason);
    return live.length > 0 ? live : list;
  };
  const limitedWithCapacity = preferInSeason(
    active.filter(
      (s) => s.type === ScheduleType.LIMITED && s.fulfillment.completedCount < s.visitLimit
    )
  );
  const limitedNoPeriod = limitedWithCapacity.find((s) => !s.periodIds?.length);
  if (limitedNoPeriod) return limitedNoPeriod;
  if (limitedWithCapacity.length > 0) return limitedWithCapacity[0];
  const recurring = preferInSeason(
    active.filter(
      (s) => s.type === ScheduleType.RECURRING
    )
  );
  const recurringNoPeriod = recurring.find((s) => !s.periodIds?.length);
  if (recurringNoPeriod) return recurringNoPeriod;
  return recurring[0];
}
function validateScheduleAddition(sub, newSchedule) {
  const existing = getSchedules(sub);
  if (newSchedule.type === ScheduleType.RECURRING) {
    const clash = existing.find(
      (s) => s.id !== newSchedule.id && s.type === ScheduleType.RECURRING && !s.deactivatedAt && s.fulfillment.status !== ScheduleFulfillmentStatus.FULFILLED && s.fulfillment.status !== ScheduleFulfillmentStatus.EXPIRED && effectiveWindowsOverlap(s, newSchedule)
    );
    if (clash) {
      return {
        valid: false,
        reason: `Recurring schedule overlaps an existing active recurring schedule`,
        conflictingScheduleId: clash.id
      };
    }
  }
  if (newSchedule.type === ScheduleType.LIMITED) {
    const newPeriods = newSchedule.periodIds ?? [];
    const clash = existing.find((s) => {
      if (s.id === newSchedule.id) return false;
      if (s.type !== ScheduleType.LIMITED || s.deactivatedAt) return false;
      if (s.fulfillment.status !== ScheduleFulfillmentStatus.PENDING && s.fulfillment.status !== ScheduleFulfillmentStatus.IN_PROGRESS) {
        return false;
      }
      const existingPeriods = s.periodIds ?? [];
      if (existingPeriods.length === 0 || newPeriods.length === 0) return true;
      return existingPeriods.some((p) => newPeriods.includes(p));
    });
    if (clash) {
      return {
        valid: false,
        reason: `Limited schedule overlaps an existing active limited schedule`,
        conflictingScheduleId: clash.id
      };
    }
  }
  return { valid: true };
}
function limitedScheduleCoversPeriod(s, periodId, options = {}) {
  if (s.type !== ScheduleType.LIMITED || s.deactivatedAt) return false;
  if (!(s.periodIds ?? []).includes(periodId)) return false;
  const status = s.fulfillment.status;
  if (status === ScheduleFulfillmentStatus.EXPIRED) return false;
  if (status === ScheduleFulfillmentStatus.FULFILLED) return !options.rebookFulfilledOneTime;
  return true;
}
function applyPeriodScheduleAssignment(sub, template, assignment, now, newId, options = {}) {
  const activePeriods = (template?.periods ?? []).filter((p) => p.isActive);
  const activeIds = new Set(activePeriods.map((p) => p.id));
  const { recurring: recurringIds, limited: limitedIds } = assignment;
  const allAssigned = [...recurringIds ?? [], ...limitedIds ?? []];
  const committedIds = new Set(
    getSchedules(sub).flatMap((s) => s.periodIds ?? [])
  );
  if (allAssigned.some((id) => !activeIds.has(id) && !committedIds.has(id))) {
    return { ok: false, reason: "One or more selected periods are not valid" };
  }
  if (activePeriods.length > 0 && allAssigned.length === 0) {
    return { ok: false, reason: "At least one period must be selected" };
  }
  const schedules = [...getSchedules(sub)];
  const deactivatedScheduleIds = [];
  const isOpen = (s) => !s.deactivatedAt && (s.fulfillment.status === ScheduleFulfillmentStatus.PENDING || s.fulfillment.status === ScheduleFulfillmentStatus.IN_PROGRESS);
  const deactivate = (idx) => {
    deactivatedScheduleIds.push(schedules[idx].id);
    schedules[idx] = {
      ...schedules[idx],
      deactivatedAt: now,
      fulfillment: {
        ...schedules[idx].fulfillment,
        status: ScheduleFulfillmentStatus.EXPIRED
      }
    };
  };
  if (recurringIds !== void 0) {
    const openIdx = schedules.findIndex(
      (s) => s.type === ScheduleType.RECURRING && isOpen(s)
    );
    if (recurringIds.length > 0) {
      if (openIdx >= 0) {
        schedules[openIdx] = { ...schedules[openIdx], periodIds: [...recurringIds] };
      } else {
        const created = {
          id: newId(),
          type: ScheduleType.RECURRING,
          frequency: sub.scheduleConfig?.frequency ?? template?.scheduleConfig?.frequency ?? "weekly" /* WEEKLY */,
          customConfig: sub.scheduleConfig?.customConfig ?? template?.scheduleConfig?.customConfig,
          periodIds: [...recurringIds],
          createdAt: now,
          activatedAt: now,
          fulfillment: { status: ScheduleFulfillmentStatus.PENDING, completedCount: 0 }
        };
        const validation = validateScheduleAddition({ ...sub, schedules }, created);
        if (!validation.valid) return { ok: false, reason: validation.reason };
        schedules.push(created);
      }
    } else if (openIdx >= 0) {
      deactivate(openIdx);
    }
    if (recurringIds.length > 0) {
      const recurringSet = new Set(recurringIds);
      schedules.forEach((s, idx) => {
        if (s.type !== ScheduleType.LIMITED || s.deactivatedAt) return;
        if (s.fulfillment.status !== ScheduleFulfillmentStatus.FULFILLED) return;
        if ((s.periodIds ?? []).some((pid) => recurringSet.has(pid))) deactivate(idx);
      });
    }
  }
  if (limitedIds !== void 0) {
    const desired = new Set(limitedIds);
    schedules.forEach((s, idx) => {
      if (s.type !== ScheduleType.LIMITED || !isOpen(s)) return;
      const periods = s.periodIds ?? [];
      if (periods.length === 1 && !desired.has(periods[0])) deactivate(idx);
    });
    for (const pid of desired) {
      const covered = schedules.some((s) => limitedScheduleCoversPeriod(s, pid, options));
      if (covered) continue;
      const created = {
        id: newId(),
        type: ScheduleType.LIMITED,
        visitLimit: 1,
        periodIds: [pid],
        createdAt: now,
        activatedAt: now,
        fulfillment: { status: ScheduleFulfillmentStatus.PENDING, completedCount: 0 }
      };
      const validation = validateScheduleAddition({ ...sub, schedules }, created);
      if (!validation.valid) return { ok: false, reason: validation.reason };
      schedules.push(created);
    }
  }
  return { ok: true, schedules, deactivatedScheduleIds };
}
function convertScheduleCadence(sub, scheduleId, cadence, now, newId) {
  const schedules = [...getSchedules(sub)];
  const idx = schedules.findIndex((s) => s.id === scheduleId);
  if (idx < 0) return { ok: false, reason: "Schedule not found" };
  const source = schedules[idx];
  const sourceOpen = !source.deactivatedAt && (source.fulfillment.status === ScheduleFulfillmentStatus.PENDING || source.fulfillment.status === ScheduleFulfillmentStatus.IN_PROGRESS);
  const usedUpOneTimeToRecurring = !source.deactivatedAt && source.type === ScheduleType.LIMITED && source.fulfillment.status === ScheduleFulfillmentStatus.FULFILLED && cadence.type === ScheduleType.RECURRING;
  if (!sourceOpen && !usedUpOneTimeToRecurring) {
    return { ok: false, reason: "Only an open schedule can change cadence" };
  }
  if (source.type === cadence.type) {
    return { ok: false, reason: "Schedule already runs on that cadence" };
  }
  if (!(source.type === ScheduleType.RECURRING && cadence.type === ScheduleType.LIMITED || source.type === ScheduleType.LIMITED && cadence.type === ScheduleType.RECURRING)) {
    return { ok: false, reason: "Only recurring and one-time schedules can swap cadence" };
  }
  schedules[idx] = {
    ...source,
    deactivatedAt: now,
    fulfillment: { ...source.fulfillment, status: ScheduleFulfillmentStatus.EXPIRED }
  };
  const deactivatedScheduleIds = [source.id];
  const createdScheduleIds = [];
  const carried = {
    ...source.effectiveFrom !== void 0 ? { effectiveFrom: source.effectiveFrom } : {},
    ...source.effectiveUntil !== void 0 ? { effectiveUntil: source.effectiveUntil } : {}
  };
  const sourcePeriods = source.periodIds ?? [];
  const append = (created) => {
    const validation = validateScheduleAddition({ ...sub, schedules }, created);
    if (!validation.valid) return validation.reason;
    schedules.push(created);
    createdScheduleIds.push(created.id);
    return null;
  };
  if (cadence.type === ScheduleType.LIMITED) {
    const periodSets = sourcePeriods.length > 0 ? sourcePeriods.map((pid) => [pid]) : [void 0];
    for (const periodIds of periodSets) {
      const created = {
        id: newId(),
        type: ScheduleType.LIMITED,
        visitLimit: 1,
        ...periodIds ? { periodIds } : {},
        ...carried,
        createdAt: now,
        activatedAt: now,
        fulfillment: { status: ScheduleFulfillmentStatus.PENDING, completedCount: 0 }
      };
      const err = append(created);
      if (err) return { ok: false, reason: err };
    }
  } else {
    const created = {
      id: newId(),
      type: ScheduleType.RECURRING,
      frequency: cadence.frequency,
      customConfig: cadence.frequency === "custom" /* CUSTOM */ ? cadence.customConfig : void 0,
      ...sourcePeriods.length > 0 ? { periodIds: [...sourcePeriods] } : {},
      ...carried,
      createdAt: now,
      activatedAt: now,
      fulfillment: { status: ScheduleFulfillmentStatus.PENDING, completedCount: 0 }
    };
    const err = append(created);
    if (err) return { ok: false, reason: err };
  }
  return { ok: true, schedules, deactivatedScheduleIds, createdScheduleIds };
}
var MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
function monthName(n) {
  return MONTH_NAMES[n - 1] ?? "";
}
function resolveVisitScheduleDisplay(subscription, scheduleId, template) {
  if (!subscription) {
    return { typeLabel: "Recurring", periodLabels: [] };
  }
  let schedule = scheduleId ? findScheduleById(subscription, scheduleId) : void 0;
  if (!schedule) {
    const all = getSchedules(subscription);
    schedule = activeSchedules(subscription)[0] ?? (all.length === 1 ? all[0] : void 0);
  }
  const typeLabel = schedule?.type === ScheduleType.LIMITED ? "One time" : "Recurring";
  const scheduleCadence = schedule ? formatScheduleCadence(schedule) : void 0;
  const cadenceLabel = scheduleCadence === typeLabel ? void 0 : scheduleCadence;
  const periodEntries = [];
  if (schedule) {
    const periodIds = schedule.periodIds;
    if (periodIds?.length) {
      const templatePeriods = template?.periods ?? [];
      for (const id of periodIds) {
        const period = templatePeriods.find((p) => p.id === id);
        if (period?.name) {
          periodEntries.push({
            name: period.name,
            startMonth: period.startMonth,
            startDay: period.startDay
          });
        }
      }
    }
    if (schedule.type === ScheduleType.WINDOWED && schedule.months?.length) {
      for (const m of schedule.months) {
        const name = monthName(m);
        if (name) periodEntries.push({ name, startMonth: m, startDay: 0 });
      }
    }
  }
  const periodLabels = periodEntries.sort((a, b) => a.startMonth - b.startMonth || a.startDay - b.startDay).map((e) => e.name);
  return { typeLabel, cadenceLabel, periodLabels };
}
function resolveCrewPeriodDisplay(subscription, scheduleId, template) {
  const scheduleDisplay = resolveVisitScheduleDisplay(
    subscription,
    scheduleId,
    template
  );
  if (!subscription) return scheduleDisplay;
  const enrolled = enrolledServicePeriods(subscription, template);
  if (enrolled.length === 0) return scheduleDisplay;
  const enrolledLabels = enrolled.slice().sort(
    (a, b) => a.startMonth - b.startMonth || a.startDay - b.startDay
  ).map((p) => p.name).filter((name) => !!name);
  if (enrolledLabels.length === 0) return scheduleDisplay;
  const enrolledSet = new Set(enrolledLabels);
  const extras = scheduleDisplay.periodLabels.filter(
    (label) => !enrolledSet.has(label)
  );
  return {
    typeLabel: scheduleDisplay.typeLabel,
    cadenceLabel: scheduleDisplay.cadenceLabel,
    periodLabels: [...enrolledLabels, ...extras]
  };
}
function serviceDetailPeriodLabels(subscription, template) {
  if (subscription) {
    const { periodLabels } = resolveCrewPeriodDisplay(
      subscription,
      void 0,
      template
    );
    if (periodLabels.length > 0) return periodLabels;
  }
  return currentServicePeriods(
    subscription ?? { seasonalAvailability: void 0 },
    template
  ).map((p) => p.name).filter((name) => !!name);
}
function isSubscriptionPackageUnlimited(sub, template) {
  if (!sub) return false;
  if (sub.packageState?.isUnlimitedVisits === true) return true;
  const optionId = sub.selectedPackageOptionId;
  if (!optionId) return false;
  const option = template?.packagePricing?.options?.find((o) => o.id === optionId);
  return option?.isUnlimitedVisits === true;
}
function deriveRateLifecycle(input) {
  const entries = [];
  if (input.requestedAt) {
    entries.push({ stage: "requested", date: input.requestedAt });
  }
  const intrinsicSelfSignup = input.rateProvidedBy === SubscriptionChangeTriggeredBy.SYSTEM && !input.requestedAt;
  if (input.rateProvidedAt && !intrinsicSelfSignup) {
    entries.push({ stage: "rate_set", date: input.rateProvidedAt });
    if (input.rateVisibility === "visible" /* VISIBLE */) {
      entries.push({ stage: "sent", date: input.rateProvidedAt });
    }
  }
  if (input.rateViewedAt) {
    entries.push({ stage: "viewed", date: input.rateViewedAt });
  }
  const accepted = input.subscriptionStatus === "active" /* ACTIVE */ || !!input.activatedAt;
  if (accepted && input.activatedAt) {
    entries.push({ stage: "accepted", date: input.activatedAt });
  }
  const statusEvents = (input.changeHistory ?? []).filter(
    (ev) => !ev.changes?.some(
      (c) => (c.field === "scheduledActivationDate" || c.field === "nextVisitClearedAt") && !!c.to
    )
  ).map((ev) => ({
    timestamp: ev.timestamp,
    change: ev.changes?.find((c) => c.field === "subscriptionStatus")
  })).filter(
    (e) => !!e.change
  ).sort(
    (a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime()
  );
  let hasBeenActive = false;
  for (const { timestamp, change } of statusEvents) {
    if (change.to === "active" /* ACTIVE */) {
      if (hasBeenActive) entries.push({ stage: "reactivated", date: timestamp });
      hasBeenActive = true;
    } else if (change.to === "inactive" /* INACTIVE */ && hasBeenActive) {
      entries.push({ stage: "deactivated", date: timestamp });
    }
  }
  if (statusEvents.length === 0 && input.deactivatedAt && input.subscriptionStatus === "inactive" /* INACTIVE */) {
    entries.push({ stage: "deactivated", date: input.deactivatedAt });
  }
  const reactivatedDates = new Set(
    entries.filter((e) => e.stage === "reactivated").map((e) => e.date)
  );
  const deduped = entries.filter(
    (e) => !(e.stage === "accepted" && reactivatedDates.has(e.date))
  );
  deduped.sort(
    (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
  );
  return deduped;
}
function isLiveEnrollmentSchedule(s) {
  return !s.deactivatedAt && s.fulfillment?.status !== ScheduleFulfillmentStatus.EXPIRED;
}
function currentServicePeriods(sub, template) {
  const source = (template?.periods?.length ? template.periods : void 0) ?? (template?.seasonalAvailability?.length ? template.seasonalAvailability : void 0) ?? sub.seasonalAvailability ?? [];
  return source.filter((p) => p.isActive !== false);
}
function enrolledServicePeriods(sub, template) {
  const current = currentServicePeriods(sub, template);
  const ids = (sub.schedules ?? []).filter(isLiveEnrollmentSchedule).flatMap((s) => s.periodIds ?? []);
  if (ids.length === 0) return current;
  const idSet = new Set(ids);
  return current.filter((p) => idSet.has(p.id));
}
function seasonPackageChargeToRefund(sub) {
  const refundable = packageChargeRefundable(sub);
  if (!refundable) return null;
  return {
    amount: refundable.refundable,
    paymentId: refundable.paymentId,
    chargedAt: refundable.chargedAt,
    ...refundable.paidAt ? { paidAt: refundable.paidAt } : {}
  };
}
function seasonRefundOnDeactivate(sub, now = /* @__PURE__ */ new Date()) {
  const season = seasonPackageChargeToRefund(sub);
  if (!season && !sub.packageRefundedAt) return null;
  const extras = unrefundedSeasonExtraPayments(sub, packageChargeSeasonKey(now));
  const items = extras.map((payment) => ({
    kind: "extra",
    amount: payment.amount,
    paymentId: payment.paymentId,
    paidAt: payment.paidAt,
    reason: payment.reason,
    payment
  }));
  if (season) items.push({ kind: "season", ...season });
  if (items.length === 0) return null;
  const cents = items.reduce((sum, item) => sum + Math.round(item.amount * 100), 0);
  return {
    total: cents / 100,
    chargedAt: season?.chargedAt ?? sub.packageChargedAt,
    items
  };
}

// src/helpers/dispatchCadence.ts
var RECURRING_FREQUENCIES = /* @__PURE__ */ new Set([
  "weekly" /* WEEKLY */,
  "monthly" /* MONTHLY */,
  "yearly" /* YEARLY */,
  "custom" /* CUSTOM */
]);
function isRecurringFrequency(frequency) {
  return RECURRING_FREQUENCIES.has(frequency);
}
function resolveDispatchCadence(sub, template, now = /* @__PURE__ */ new Date()) {
  const recurring = activeRecurringSchedule(sub, now);
  const frequency = recurring?.frequency ?? template.scheduleConfig?.frequency;
  if (!frequency || !isRecurringFrequency(frequency)) return null;
  return {
    frequency,
    customConfig: recurring?.customConfig ?? template.scheduleConfig?.customConfig
  };
}
function maxOpenVisitsForAutoDispatch(cadence) {
  if (cadence.frequency === "weekly" /* WEEKLY */) return 2;
  if (cadence.frequency === "custom" /* CUSTOM */ && cadence.customConfig?.unit === "weeks" /* WEEKS */ && cadence.customConfig.interval === 1) {
    return 2;
  }
  return 1;
}
function isActiveServiceWithoutDispatchCadence(sub, template, now = /* @__PURE__ */ new Date()) {
  if (sub.subscriptionStatus !== "active" /* ACTIVE */) return false;
  const recurring = activeRecurringSchedule(sub, now);
  if (!recurring) return false;
  if (recurring.frequency === "on_demand" /* ON_DEMAND */) return false;
  return resolveDispatchCadence(sub, template ?? { scheduleConfig: void 0 }, now) === null;
}
var PERIOD_CATCHUP_FREQUENCIES = /* @__PURE__ */ new Set([
  "monthly" /* MONTHLY */
]);
function isPeriodCatchUpCadence(cadence) {
  return PERIOD_CATCHUP_FREQUENCIES.has(cadence.frequency);
}
function currentDispatchWindow(cadence, now = /* @__PURE__ */ new Date()) {
  if (cadence.frequency !== "monthly" /* MONTHLY */) return null;
  const start = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1));
  const end = lastDayOfMonthUtc(now);
  return { start: toUtcDay(start), end: toUtcDay(end) };
}
function shouldSeedActivePeriod(params) {
  const {
    cadence,
    inActiveSelectedPeriod,
    hasVisitInCurrentWindow,
    alreadyAutoDispatchedInWindow = false,
    lastCompletedInCurrentWindow = false
  } = params;
  if (!isPeriodCatchUpCadence(cadence)) return false;
  if (!inActiveSelectedPeriod) return false;
  if (hasVisitInCurrentWindow) return false;
  if (alreadyAutoDispatchedInWindow) return false;
  if (lastCompletedInCurrentWindow) return false;
  return true;
}
function isWithinDispatchWindow(lastAutoDispatchDate, window) {
  if (!lastAutoDispatchDate || !window) return false;
  return lastAutoDispatchDate >= window.start && lastAutoDispatchDate <= window.end;
}
function intervalInDays(customConfig) {
  if (!customConfig) return Infinity;
  const { interval, unit } = customConfig;
  switch (unit) {
    case "days" /* DAYS */:
      return interval;
    case "weeks" /* WEEKS */:
      return interval * 7;
    case "months" /* MONTHS */:
      return interval * 30;
    // Approximate — mirrors nightlyAutoDispatch.
    case "years" /* YEARS */:
      return interval * 365;
    default:
      return Infinity;
  }
}
function cadenceIntervalDays(cadence) {
  switch (cadence.frequency) {
    case "weekly" /* WEEKLY */:
      return 7;
    case "yearly" /* YEARLY */:
      return 365;
    case "custom" /* CUSTOM */:
      return intervalInDays(cadence.customConfig);
    case "monthly" /* MONTHLY */:
      return Infinity;
    default:
      return Infinity;
  }
}
function toYmd(value) {
  return value ? value.split("T")[0] : void 0;
}
function cadenceCountFromDate(lastAutoDispatchDate, lastCompletedVisitDate) {
  const dispatch = toYmd(lastAutoDispatchDate);
  const completed = toYmd(lastCompletedVisitDate);
  if (!dispatch) return completed;
  if (!completed) return dispatch;
  return completed > dispatch ? completed : dispatch;
}
function isOpenVisitEarlierThanCadenceInterval(params) {
  const completed = toYmd(params.lastCompletedVisitDate);
  const scheduled = toYmd(params.openVisitScheduledDate);
  if (!completed || !scheduled) return false;
  if (params.cadence.frequency === "weekly" /* WEEKLY */) return false;
  if (params.cadence.frequency === "monthly" /* MONTHLY */) {
    return scheduled.slice(0, 7) === completed.slice(0, 7);
  }
  const days = cadenceIntervalDays(params.cadence);
  if (!Number.isFinite(days)) return false;
  const earliest = addUtcDays(parseUtcDay(completed), days);
  return parseUtcDay(scheduled).getTime() < earliest.getTime();
}
function parseUtcDay(ymd2) {
  return /* @__PURE__ */ new Date(`${ymd2}T00:00:00Z`);
}
function toUtcDay(date) {
  return date.toISOString().split("T")[0];
}
function addUtcDays(date, days) {
  const next = new Date(date);
  next.setUTCDate(next.getUTCDate() + days);
  return next;
}
function lastDayOfMonthUtc(date) {
  return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 0));
}
function nextAutoDispatchDate(cadence, lastAutoDispatchDate, now = /* @__PURE__ */ new Date(), anchorDate, lastCompletedVisitDate) {
  const today = parseUtcDay(toUtcDay(now));
  const last = lastAutoDispatchDate ? parseUtcDay(lastAutoDispatchDate) : void 0;
  const anchor = anchorDate ? parseUtcDay(anchorDate) : void 0;
  const floor = last && last.getTime() >= today.getTime() ? addUtcDays(last, 1) : today;
  switch (cadence.frequency) {
    case "weekly" /* WEEKLY */: {
      const daysUntilSunday = (7 - floor.getUTCDay()) % 7;
      return toUtcDay(addUtcDays(floor, daysUntilSunday));
    }
    case "monthly" /* MONTHLY */: {
      let candidate = lastDayOfMonthUtc(floor);
      if (candidate.getTime() < floor.getTime()) {
        candidate = lastDayOfMonthUtc(addUtcDays(candidate, 1));
      }
      return toUtcDay(candidate);
    }
    case "yearly" /* YEARLY */: {
      let candidate = new Date(Date.UTC(floor.getUTCFullYear(), 11, 31));
      if (candidate.getTime() < floor.getTime()) {
        candidate = new Date(Date.UTC(floor.getUTCFullYear() + 1, 11, 31));
      }
      return toUtcDay(candidate);
    }
    case "custom" /* CUSTOM */: {
      const { customConfig } = cadence;
      const days = intervalInDays(customConfig);
      if (!Number.isFinite(days)) return last ? null : toUtcDay(today);
      if (customConfig?.unit === "weeks" /* WEEKS */) {
        const countFromYmd2 = cadenceCountFromDate(
          lastAutoDispatchDate,
          lastCompletedVisitDate
        );
        const countFrom2 = countFromYmd2 ? parseUtcDay(countFromYmd2) : anchor;
        if (!countFrom2) {
          const daysUntilSunday = (7 - today.getUTCDay()) % 7;
          return toUtcDay(addUtcDays(today, daysUntilSunday));
        }
        const weekStart = addUtcDays(countFrom2, -countFrom2.getUTCDay());
        const candidate2 = addUtcDays(weekStart, days);
        return toUtcDay(
          candidate2.getTime() >= today.getTime() ? candidate2 : today
        );
      }
      const countFromYmd = cadenceCountFromDate(
        lastAutoDispatchDate,
        lastCompletedVisitDate
      );
      const countFrom = countFromYmd ? parseUtcDay(countFromYmd) : anchor;
      if (!countFrom) return toUtcDay(today);
      const candidate = addUtcDays(countFrom, days);
      return toUtcDay(
        candidate.getTime() >= today.getTime() ? candidate : today
      );
    }
    default:
      return null;
  }
}
var MAX_ENUMERATED_OCCURRENCES = 500;
function enumerateAutoDispatchDates(cadence, options) {
  const { from, to, anchorDate, lastCompletedVisitDate } = options;
  if (from > to) return [];
  const cap = options.maxOccurrences ?? MAX_ENUMERATED_OCCURRENCES;
  const seed = options.lastAutoDispatchDate && options.lastAutoDispatchDate < from ? options.lastAutoDispatchDate : void 0;
  const dates = [];
  let last = seed;
  let cursor = from;
  while (dates.length < cap) {
    const next = nextAutoDispatchDate(
      cadence,
      last,
      parseUtcDay(cursor),
      anchorDate,
      lastCompletedVisitDate
    );
    if (!next || next > to) break;
    if (next >= from) dates.push(next);
    last = next;
    cursor = toUtcDay(addUtcDays(parseUtcDay(next), 1));
  }
  return dates;
}
function cadenceAnchorDate(sub) {
  const raw = sub.firstVisitDate ?? sub.serviceStartDate ?? sub.activatedAt;
  return raw ? raw.split("T")[0] : void 0;
}
function computeNextDueDate(sub, template, now = /* @__PURE__ */ new Date()) {
  try {
    const cadence = resolveDispatchCadence(
      sub,
      template ?? { scheduleConfig: void 0 },
      now
    );
    if (!cadence) return null;
    return nextAutoDispatchDate(
      cadence,
      sub.lastAutoDispatchDate,
      now,
      cadenceAnchorDate(sub),
      sub.lastCompletedVisitDate
    );
  } catch {
    return null;
  }
}

// src/pricing/revenueProjection.ts
var EXCLUDED = {
  visitCount: 0,
  subtotal: 0,
  tax: 0,
  total: 0,
  setupFee: 0,
  excluded: true
};
function excluded(reason) {
  return { ...EXCLUDED, reason };
}
function parseLocalDay(ymd2) {
  const [y, m, d] = ymd2.split("-").map(Number);
  return new Date(y, m - 1, d);
}
function windowMonths(from, to) {
  const months = /* @__PURE__ */ new Set();
  const cursor = parseLocalDay(from);
  cursor.setDate(1);
  const end = parseLocalDay(to);
  while (cursor.getTime() <= end.getTime() && months.size < 12) {
    months.add(cursor.getMonth() + 1);
    cursor.setMonth(cursor.getMonth() + 1);
  }
  return months;
}
function dispatchablePeriods(sub, template) {
  const periods = template?.periods;
  if (!periods || periods.length === 0) return null;
  const restriction = recurringPeriodRestriction(sub.schedules);
  return restriction ? periods.filter((p) => restriction.has(p.id)) : periods;
}
function projectSubscriptionRevenue(input) {
  const { subscription: sub, template, window } = input;
  const now = input.now ?? /* @__PURE__ */ new Date();
  if (sub.subscriptionStatus !== "active" /* ACTIVE */) return excluded("inactive");
  if (!sub.reviewedAt) return excluded("not-reviewed");
  if (!sub.assignedCrewId) return excluded("not-staffed");
  if (sub.bundleId) return excluded("bundle-member");
  if (isOneOffSubscription(sub)) return excluded("one-time");
  if (sub.billingMethod === "consumable" /* CONSUMABLE */) return excluded("consumable");
  const from = sub.serviceStartDate ? maxDay(window.from, sub.serviceStartDate.split("T")[0]) : window.from;
  const to = sub.serviceEndDate ? minDay(window.to, sub.serviceEndDate.split("T")[0]) : window.to;
  if (from > to) return excluded("ended");
  const cadence = resolveDispatchCadence(sub, template ?? { scheduleConfig: void 0 }, now);
  const schedules = getSchedules(sub);
  let occurrenceCount = 0;
  if (cadence) {
    let dates = enumerateAutoDispatchDates(cadence, {
      from,
      to,
      lastAutoDispatchDate: sub.lastAutoDispatchDate,
      anchorDate: cadenceAnchorDate(sub)
    });
    const periods = dispatchablePeriods(sub, template);
    if (periods) {
      dates = dates.filter(
        (d) => periods.some((p) => PeriodHelpers.isPeriodActive(p, parseLocalDay(d)))
      );
    }
    occurrenceCount = dates.length;
    const limitedRemaining = limitedRemainingVisits(sub, now);
    if (limitedRemaining != null) {
      occurrenceCount = Math.min(occurrenceCount, limitedRemaining);
    }
  } else {
    const rawFrequency = schedules.find((s) => s.type === ScheduleType.RECURRING)?.frequency ?? template?.scheduleConfig?.frequency;
    if (rawFrequency === "on_demand" /* ON_DEMAND */) return excluded("on-demand");
    if (rawFrequency === "one_time" /* ONE_TIME */) return excluded("one-time");
    const limitedRemaining = limitedRemainingVisits(sub, now);
    if (limitedRemaining != null) {
      const periods = dispatchablePeriods(sub, template);
      const overlaps = !periods || periods.some((p) => periodOverlapsWindow(p, from, to));
      occurrenceCount += overlaps ? limitedRemaining : 0;
    }
    occurrenceCount += windowedVisitsInWindow(sub, from, to, now);
    if (occurrenceCount === 0 && limitedRemaining == null) return excluded("no-cadence");
  }
  let visitSubtotal = 0;
  if (sub.billingMethod === "package" /* PACKAGE */) {
    if (!sub.packageState?.isUnlimitedVisits) {
      const allowance = sub.packageState?.visitsRemaining ?? sub.packageState?.builtInVisits ?? occurrenceCount;
      const overage = Math.max(0, occurrenceCount - Math.max(0, allowance));
      const perVisit = applyDiscount(sub.pricePerAdditionalVisit ?? 0, sub.discount);
      visitSubtotal = roundCurrency(perVisit * overage);
    }
  } else {
    const value = estimateSubscriptionValue(sub, template);
    if (value == null) return excluded("unpriced");
    visitSubtotal = roundCurrency(applyDiscount(value, sub.discount) * occurrenceCount);
  }
  const setupFee = sub.setupFee && !sub.setupFeeChargedAt ? sub.setupFee : 0;
  const taxable = template?.isTaxable !== false;
  const tax = taxable ? roundCurrency(visitSubtotal * (input.customerTaxRate ?? 0)) : 0;
  const subtotal = roundCurrency(visitSubtotal + setupFee);
  return {
    visitCount: occurrenceCount,
    subtotal,
    tax,
    total: roundCurrency(subtotal + tax),
    setupFee,
    excluded: false
  };
}
function limitedRemainingVisits(sub, now) {
  const limited = getSchedules(sub).filter(
    (s) => s.type === ScheduleType.LIMITED && isScheduleActive(s, now)
  );
  if (limited.length === 0) return null;
  return limited.reduce(
    (sum, s) => sum + Math.max(0, s.visitLimit - s.fulfillment.completedCount),
    0
  );
}
function windowedVisitsInWindow(sub, from, to, now) {
  const months = windowMonths(from, to);
  let total = 0;
  for (const s of getSchedules(sub)) {
    if (s.type !== ScheduleType.WINDOWED || !isScheduleActive(s, now)) continue;
    if (!s.visitLimit || s.months.length === 0) continue;
    const overlap = s.months.filter((m) => months.has(m)).length;
    total += Math.round(s.visitLimit * (overlap / s.months.length));
  }
  return total;
}
function periodOverlapsWindow(period, from, to) {
  const cursor = parseLocalDay(from);
  const end = parseLocalDay(to);
  for (let i = 0; i < 366 && cursor.getTime() <= end.getTime(); i++) {
    if (PeriodHelpers.isPeriodActive(period, cursor)) return true;
    cursor.setDate(cursor.getDate() + 1);
  }
  return false;
}
function maxDay(a, b) {
  return a >= b ? a : b;
}
function minDay(a, b) {
  return a <= b ? a : b;
}

// src/utils/propertyAssessment.ts
var PROPERTY_ASSESSMENT_SERVICE_TEMPLATE_ID = "PROPERTY_ASSESSMENT";
var PROPERTY_ASSESSMENT_SERVICE_NAME = "Property Assessment";
var PROPERTY_ASSESSMENT_METRICS = [
  "turf" /* TURF */,
  "rock" /* ROCK */,
  "wood_mulch" /* WOOD_MULCH */
];
function buildPropertyAssessmentVolumePricing() {
  return {
    enabled: true,
    type: "per_unit" /* PER_UNIT */,
    unit: "sqft" /* SQFT */,
    applicableMetrics: [...PROPERTY_ASSESSMENT_METRICS]
  };
}
function isPropertyAssessmentTemplateId(serviceTemplateId) {
  return serviceTemplateId === PROPERTY_ASSESSMENT_SERVICE_TEMPLATE_ID;
}
function isPropertyAssessmentVisit(visit) {
  return visit.visitType === "assessment" /* ASSESSMENT */ && isPropertyAssessmentTemplateId(visit.serviceTemplateId);
}

// src/pricing/pricingMetric.ts
function areApplicableMetricsAbsent(absentMetrics, applicableMetrics) {
  if (!absentMetrics || absentMetrics.length === 0) return false;
  const applicable = applicableMetrics && applicableMetrics.length > 0 ? applicableMetrics : PROPERTY_ASSESSMENT_METRICS;
  return applicable.every((type) => absentMetrics.includes(type));
}
function resolveUnitBasedMetrics(pricingInputs, customerMetrics) {
  return pricingInputs?.customerMetrics || customerMetrics || void 0;
}
function isUnitBasedMetricSet(pricingInputs, customerMetrics, applicableMetrics) {
  if (areApplicableMetricsAbsent(pricingInputs?.absentMetrics, applicableMetrics)) {
    return true;
  }
  const metrics = resolveUnitBasedMetrics(pricingInputs, customerMetrics);
  if (applicableMetrics && applicableMetrics.length > 0) {
    return applicableMetrics.some((type) => {
      const value = metrics?.[METRIC_TYPE_TO_KEY[type]];
      return typeof value === "number" && value > 0;
    });
  }
  return hasAnyMetricValue(metrics);
}

// src/pricing/listRateDisplay.ts
var ONE_CENT = 0.015;
function isPositiveNumber(value) {
  return typeof value === "number" && Number.isFinite(value) && value > 0;
}
function customerHasOwnHours(input) {
  return isPositiveNumber(input.pricingInputs?.budgetedHours);
}
function customerHasOwnMetrics(input) {
  if (input.pricingInputs?.useMinimumRate === true) return true;
  return isUnitBasedMetricSet(
    input.pricingInputs,
    input.customerMetrics,
    input.applicableMetrics
  );
}
function asPricingMethod(value) {
  if (!value) return void 0;
  const values = Object.values(PricingMethod);
  return values.includes(value) ? value : void 0;
}
function asBillingMethod(value) {
  return billingMethodOf(value) ?? void 0;
}
function storedPerVisit(input) {
  const optionId = input.selectedPackageOptionId;
  if (optionId) {
    const fromOption = (input.packageOptionPricing ?? []).find(
      (p) => p.optionId === optionId
    );
    if (isPositiveNumber(fromOption?.pricePerAdditionalVisit)) {
      return fromOption.pricePerAdditionalVisit;
    }
  }
  if (isPositiveNumber(input.pricePerAdditionalVisit)) {
    return input.pricePerAdditionalVisit;
  }
  return null;
}
function listPerVisitAmount(input) {
  const stored = storedPerVisit(input);
  if (stored != null) return stored;
  const billing = asBillingMethod(input.billingMethod);
  if (billing === "package" /* PACKAGE */) return null;
  if (isPositiveNumber(input.rate)) return input.rate;
  return null;
}
function officeStoredPlanSeasonTotal(input) {
  const rate = input.rate;
  if (!isPositiveNumber(rate)) return false;
  const pricing = input.packageOptionPricing ?? [];
  const candidates = input.selectedPackageOptionId ? pricing.filter((p) => p.optionId === input.selectedPackageOptionId) : pricing;
  return candidates.some(
    (p) => isPositiveNumber(p.rate) && Math.abs(p.rate - rate) < ONE_CENT
  );
}
function matchesInventedOneHourRate(perVisit, hourlyRate) {
  return Math.abs(perVisit - hourlyRate) < ONE_CENT;
}
function isHourlyOffering(input) {
  return asBillingMethod(input.billingMethod) === "per_hour" /* PER_HOUR */ || asPricingMethod(input.pricingMethod) === "per_hour" /* PER_HOUR */;
}
function resolveListBillingMethod(input) {
  const templateBilling = asBillingMethod(input.templateBillingMethod);
  const subBilling = asBillingMethod(input.billingMethod);
  const pricing = asPricingMethod(input.pricingMethod);
  const templateIsHourly = templateBilling === "per_hour" /* PER_HOUR */ || pricing === "per_hour" /* PER_HOUR */;
  const publishesHourlyOrMin = isPositiveNumber(input.hourlyRate) || isPositiveNumber(input.minimumCharge);
  if (templateIsHourly && publishesHourlyOrMin) {
    return "per_hour" /* PER_HOUR */;
  }
  return subBilling ?? templateBilling;
}
function resolveListPricingMethod(input) {
  const template = asPricingMethod(input.templatePricingMethod);
  if (template === "per_hour" /* PER_HOUR */) return template;
  return asPricingMethod(input.pricingMethod) ?? template;
}
function isFabricatedDefaultListRate(input) {
  const pricing = asPricingMethod(input.pricingMethod);
  const billing = asBillingMethod(input.billingMethod);
  if (!billing && !pricing) {
    return false;
  }
  if (billing === "per_hour" /* PER_HOUR */ || billing === "consumable" /* CONSUMABLE */ || pricing === "fixed_price" /* FIXED_PRICE */ || pricing === "per_hour" /* PER_HOUR */ || pricing === "consumable" /* CONSUMABLE */) {
    return false;
  }
  if (pricing === "unit_based" /* UNIT_BASED */) {
    return !customerHasOwnMetrics(input);
  }
  if (customerHasOwnHours(input) || customerHasOwnMetrics(input)) {
    return false;
  }
  const hourly = input.hourlyRate;
  if (!isPositiveNumber(hourly)) {
    return false;
  }
  const perVisit = listPerVisitAmount(input);
  if (perVisit == null) {
    if (billing !== "package" /* PACKAGE */ || !isPositiveNumber(input.rate)) {
      return false;
    }
    return !officeStoredPlanSeasonTotal(input);
  }
  return matchesInventedOneHourRate(perVisit, hourly);
}
function hasListableServiceRate(input) {
  if (isFabricatedDefaultListRate(input)) return false;
  const billing = asBillingMethod(input.billingMethod);
  if (billing === "package" /* PACKAGE */) {
    return storedPerVisit(input) != null || isPositiveNumber(input.rate);
  }
  if (billing === "consumable" /* CONSUMABLE */) return true;
  if (isPositiveNumber(input.rate) || isPositiveNumber(input.hourlyRate)) return true;
  return isHourlyOffering(input) && isPositiveNumber(input.minimumCharge);
}

// src/pricing/midSeasonProration.ts
function seasonKey(date) {
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
}
function seasonOrdinal(month, day, seasonStartMonth, seasonStartDay) {
  const md = month * 100 + day;
  const start = seasonStartMonth * 100 + seasonStartDay;
  return md >= start ? md : md + 1300;
}
function percentOfFullRateOn(schedule, now, seasonStart) {
  if (!schedule?.length) return 100;
  const startMonth = seasonStart.getMonth() + 1;
  const startDay = seasonStart.getDate();
  const nowOrd = seasonOrdinal(now.getMonth() + 1, now.getDate(), startMonth, startDay);
  const rows = [...schedule].sort(
    (a, b) => seasonOrdinal(a.month, a.day, startMonth, startDay) - seasonOrdinal(b.month, b.day, startMonth, startDay)
  );
  let percent = 100;
  for (const row of rows) {
    if (seasonOrdinal(row.month, row.day, startMonth, startDay) <= nowOrd) {
      percent = row.percentOfFullRate;
    } else {
      break;
    }
  }
  return percent;
}
function validateMidSeasonProrationSchedule(schedule) {
  if (schedule == null) return null;
  if (!Array.isArray(schedule)) {
    return "Mid-season sign-up schedule must be a list of date and percentage rows";
  }
  if (schedule.length === 0) return null;
  const seen = /* @__PURE__ */ new Set();
  for (const row of schedule) {
    if (!row || typeof row !== "object") {
      return "Each schedule row needs a date and a percentage";
    }
    const { month, day, percentOfFullRate } = row;
    if (typeof month !== "number" || month < 1 || month > 12) {
      return "Each schedule row's month must be between 1 and 12";
    }
    if (typeof day !== "number" || day < 1 || day > 31) {
      return "Each schedule row's day must be between 1 and 31";
    }
    if (typeof percentOfFullRate !== "number" || !Number.isFinite(percentOfFullRate) || percentOfFullRate < 1 || percentOfFullRate > 100) {
      return "Each schedule row's percentage must be between 1 and 100";
    }
    const key = month * 100 + day;
    if (seen.has(key)) {
      return "Each schedule row must have a different date";
    }
    seen.add(key);
  }
  return null;
}
function calculateMidSeasonSignOn(input) {
  const { fullSeasonAmount, percentOfFullRate, optionId, seasonStart, now } = input;
  const clamped = Math.min(Math.max(percentOfFullRate, 0), 100);
  const signOnAmount = roundCurrency(fullSeasonAmount * (clamped / 100));
  return {
    optionId,
    fullSeasonAmount,
    signOnAmount,
    percentOfFullRate: clamped,
    seasonStartedAt: seasonStart ? seasonKey(seasonStart) : void 0,
    calculatedAt: (now ?? /* @__PURE__ */ new Date()).toISOString()
  };
}
function quoteMidSeasonSignOn(template, optionId, fullSeasonAmount, now = /* @__PURE__ */ new Date()) {
  const eligibility = getMidSeasonEligibility(template, optionId, now);
  if (!eligibility.eligible || !eligibility.seasonStart) return null;
  const schedule = template?.packagePricing?.midSeasonProrationSchedule;
  if (!schedule?.length) return null;
  if (fullSeasonAmount == null || fullSeasonAmount <= 0) return null;
  const percent = percentOfFullRateOn(schedule, now, eligibility.seasonStart);
  if (percent >= 100) return null;
  const quote = calculateMidSeasonSignOn({
    fullSeasonAmount,
    percentOfFullRate: percent,
    optionId,
    seasonStart: eligibility.seasonStart,
    now
  });
  if (quote.signOnAmount >= quote.fullSeasonAmount) return null;
  if (quote.signOnAmount <= 0) return null;
  return quote;
}
function getEffectiveSeasonPrice(subscription, template, now = /* @__PURE__ */ new Date()) {
  const fullAmount = subscription?.rate ?? void 0;
  const signOn = subscription?.midSeasonSignOn;
  const notProrated = {
    amount: fullAmount,
    fullAmount,
    isProrated: false
  };
  if (!signOn) return notProrated;
  if (signOn.optionId && subscription?.selectedPackageOptionId && signOn.optionId !== subscription.selectedPackageOptionId) {
    return notProrated;
  }
  const activePeriod = PeriodHelpers.getActivePeriod(seasonPeriods(template), now);
  if (!activePeriod) return notProrated;
  if (signOn.seasonStartedAt) {
    const currentSeasonStart = PeriodHelpers.getPeriodStartDate(activePeriod, now);
    if (seasonKey(currentSeasonStart) !== signOn.seasonStartedAt.slice(0, 10)) {
      return notProrated;
    }
  }
  return {
    amount: signOn.signOnAmount,
    fullAmount: signOn.fullSeasonAmount ?? fullAmount,
    isProrated: true,
    signOn
  };
}
function seasonPeriods(template) {
  if (!template) return void 0;
  return ServiceTemplateHelpers.getPeriods(template);
}
function getMidSeasonEligibility(template, optionId, now = /* @__PURE__ */ new Date()) {
  if (!template || !ServiceTemplateHelpers.hasPackageConfiguration(template)) {
    return { eligible: false };
  }
  const option = optionId ? template.packagePricing?.options?.find((o) => o.id === optionId) : void 0;
  if (!option || option.isActive === false) return { eligible: false };
  if (option.acceptanceDeadlineMonth && option.acceptanceDeadlineDay) {
    return { eligible: false };
  }
  if (template.packagePricing?.acceptanceDeadline) return { eligible: false };
  const activePeriod = PeriodHelpers.getActivePeriod(seasonPeriods(template), now);
  if (!activePeriod) return { eligible: false };
  return {
    eligible: true,
    activePeriod,
    seasonStart: PeriodHelpers.getPeriodStartDate(activePeriod, now)
  };
}

// src/pricing/planChangeProration.ts
function inclusiveCalendarDays(from, to) {
  const a = Date.UTC(from.getFullYear(), from.getMonth(), from.getDate());
  const b = Date.UTC(to.getFullYear(), to.getMonth(), to.getDate());
  return Math.max(1, Math.round((b - a) / 864e5) + 1);
}
function optionRate(subscription, optionId) {
  const priced = subscription.packageOptionPricing?.find((p) => p.optionId === optionId);
  if (priced && typeof priced.rate === "number" && Number.isFinite(priced.rate)) {
    return priced.rate;
  }
  if (subscription.selectedPackageOptionId === optionId && typeof subscription.rate === "number" && Number.isFinite(subscription.rate)) {
    return subscription.rate;
  }
  return void 0;
}
function remainingCycleFraction(period, now) {
  const cycleStart = PeriodHelpers.getPeriodStartDate(period, now);
  const cycleEnd = PeriodHelpers.getPeriodEndDate(period, now);
  const totalDays = inclusiveCalendarDays(cycleStart, cycleEnd);
  const remainingDays = now > cycleEnd ? 0 : inclusiveCalendarDays(now, cycleEnd);
  return {
    remainingFraction: Math.min(1, remainingDays / totalDays),
    cycleStart,
    cycleEnd
  };
}
function seasonForQuote(template, now, cycleStart) {
  const dates = getPackageSeasonDates(template, now);
  if (dates) return dates.seasonKey;
  return getChicagoYmd(cycleStart).year;
}
function paidThisSeason(subscription, fromRate, season) {
  const paid = subscription.packageChargeAmount;
  if (typeof paid !== "number" || !Number.isFinite(paid) || paid <= 0) return fromRate;
  const refunded = subscription.packageRefundedTotal;
  const refundedSoFar = typeof refunded === "number" && Number.isFinite(refunded) ? Math.max(0, refunded) : 0;
  const extras = unrefundedSeasonExtraTotal(subscription, season);
  return roundCurrency(Math.max(0, paid - refundedSoFar) + extras);
}
function directionOf(difference) {
  if (difference > 0) return "upgrade";
  if (difference < 0) return "downgrade";
  return "even";
}
function quotePlanChange(input) {
  const now = input.now ?? /* @__PURE__ */ new Date();
  const template = input.template;
  const options = template?.packagePricing?.options ?? [];
  const toOption = options.find((o) => o.id === input.toOptionId && o.isActive !== false);
  if (!toOption) return null;
  const fromOptionId = input.subscription.selectedPackageOptionId ?? "";
  if (!fromOptionId || fromOptionId === toOption.id) return null;
  const fromOption = options.find((o) => o.id === fromOptionId);
  const fromOptionName = fromOption?.name || input.subscription.selectedPackageOptionName || "Current plan";
  const fromRate = optionRate(input.subscription, fromOptionId);
  const toRate = optionRate(input.subscription, toOption.id);
  const periods = template ? ServiceTemplateHelpers.getPeriods(template) : void 0;
  const activePeriod = PeriodHelpers.getActivePeriod(periods, now);
  if (!activePeriod) {
    return {
      fromOptionId,
      fromOptionName,
      toOptionId: toOption.id,
      toOptionName: toOption.name,
      fromRate,
      toRate,
      remainingFraction: 0,
      chargedThisCycle: false,
      difference: 0,
      direction: "even",
      applyMoney: false,
      explanation: "no_active_cycle"
    };
  }
  const { remainingFraction, cycleStart, cycleEnd } = remainingCycleFraction(activePeriod, now);
  const quoteSeason = seasonForQuote(template, now, cycleStart);
  const chargedThisCycle = isPackageChargedForSeason(input.subscription, quoteSeason);
  const paidAmount = chargedThisCycle ? paidThisSeason(input.subscription, fromRate, quoteSeason) : void 0;
  const base = {
    fromOptionId,
    fromOptionName,
    toOptionId: toOption.id,
    toOptionName: toOption.name,
    fromRate,
    toRate,
    remainingFraction,
    cycleStart: seasonKey(cycleStart),
    cycleEnd: seasonKey(cycleEnd),
    chargedThisCycle,
    ...paidAmount != null ? { paidAmount } : {}
  };
  if (fromRate == null || toRate == null) {
    return {
      ...base,
      difference: 0,
      direction: "even",
      applyMoney: false,
      explanation: "missing_rate"
    };
  }
  if (fromRate === toRate && !chargedThisCycle) {
    return {
      ...base,
      difference: 0,
      direction: "even",
      applyMoney: false,
      explanation: "same_price"
    };
  }
  if (!chargedThisCycle) {
    return {
      ...base,
      difference: 0,
      direction: directionOf(toRate - fromRate),
      applyMoney: false,
      explanation: "uncharged_cycle"
    };
  }
  const difference = roundCurrency(toRate - (paidAmount ?? fromRate));
  if (difference === 0) {
    return {
      ...base,
      difference: 0,
      direction: "even",
      applyMoney: false,
      explanation: "same_price"
    };
  }
  return {
    ...base,
    difference,
    direction: directionOf(difference),
    applyMoney: true,
    explanation: "full_season"
  };
}
function describePlanChangeMoney(preview) {
  if (preview.explanation === "missing_rate") {
    return { kind: "missing_rate", amount: 0, shortLabel: "price to be confirmed" };
  }
  if (!preview.applyMoney || preview.difference === 0) {
    return { kind: "none", amount: 0, shortLabel: "no charge or refund this season" };
  }
  const amount = Math.abs(preview.difference);
  const dollars = `$${amount.toFixed(2)}`;
  if (preview.difference > 0) {
    return { kind: "charge", amount, shortLabel: `${dollars} additional charge` };
  }
  return { kind: "refund", amount, shortLabel: `${dollars} refund to card` };
}
function nextPackageState(prior, option, timestamp) {
  const usedVisits = Math.max(
    0,
    (prior?.totalVisits ?? 0) - (prior?.visitsRemaining ?? 0)
  );
  const newBuiltIn = option.isUnlimitedVisits ? 0 : option.builtInVisits;
  return {
    createdAt: prior?.createdAt ?? timestamp,
    usageHistory: prior?.usageHistory ?? [],
    ...prior,
    builtInVisits: newBuiltIn,
    isUnlimitedVisits: option.isUnlimitedVisits || void 0,
    totalVisits: option.isUnlimitedVisits ? void 0 : newBuiltIn,
    visitsRemaining: option.isUnlimitedVisits ? void 0 : Math.max(0, newBuiltIn - usedVisits)
  };
}

// src/pricing/solveExactHours.ts
function solveExactHours(template, targetPerVisit, customerMetrics) {
  if (targetPerVisit <= 0) return 0;
  const hourlyRate = template.hourlyRate || 0;
  if (hourlyRate <= 0) return null;
  const minimumCharge = template.minimumCharge || 0;
  const builtInHours = template.builtInHours || 0;
  let volumeCost = 0;
  if (template.pricingMethod === "unit_based" /* UNIT_BASED */ && template.volumePricing?.enabled) {
    for (const m of template.volumePricing.applicableMetrics ?? []) {
      const key = METRIC_TYPE_TO_KEY[m];
      const v = customerMetrics[key] ?? 0;
      if (v <= 0) continue;
      if (template.volumePricing.type === "tiered" && template.volumePricing.tiers) {
        const sorted = [...template.volumePricing.tiers].sort((a, b) => {
          if (a.upperBound === void 0) return 1;
          if (b.upperBound === void 0) return -1;
          return a.upperBound - b.upperBound;
        });
        let prev = 0;
        for (const tier of sorted) {
          const upper = tier.upperBound ?? Infinity;
          if (v > prev && v <= upper) {
            volumeCost += v * tier.rate;
            break;
          }
          prev = upper;
        }
      } else if (template.volumePricing.perUnitRate) {
        volumeCost += v * template.volumePricing.perUnitRate;
      }
    }
  }
  if (minimumCharge > 0) {
    if (builtInHours <= 0 && targetPerVisit < minimumCharge - 5e-3) return null;
    if (targetPerVisit <= minimumCharge) return builtInHours;
    if (builtInHours > 0) {
      const labor2 = targetPerVisit - minimumCharge - volumeCost;
      if (labor2 <= 0) return builtInHours;
      return builtInHours + labor2 / hourlyRate;
    }
  }
  const labor = targetPerVisit - volumeCost;
  if (labor <= 0) return 0;
  return labor / hourlyRate;
}

// src/helpers/packagePerVisitPricing.ts
function roundMoneyToCents(n) {
  return Math.round(n * 100) / 100;
}
function roundHoursToHundredths(n) {
  return parseFloat(n.toFixed(2));
}
function exactHoursFromPerVisit(perVisit, hourlyRate) {
  if (!(hourlyRate > 0) || !Number.isFinite(perVisit) || perVisit <= 0) return 0;
  return perVisit / hourlyRate;
}
function resolvePackageOption(options, selectedPackageOptionId) {
  if (!options || options.length === 0) return null;
  const opt = (selectedPackageOptionId ? options.find((o) => o.id === selectedPackageOptionId) : void 0) ?? options.find((o) => o.isActive !== false) ?? options[0];
  if (!opt) return null;
  return {
    id: opt.id,
    name: opt.name,
    builtInVisits: typeof opt.builtInVisits === "number" ? opt.builtInVisits : null,
    budgetedVisits: typeof opt.budgetedVisits === "number" ? opt.budgetedVisits : null,
    isUnlimited: !!opt.isUnlimitedVisits
  };
}
function packageOptionDisplayName(option, fallback) {
  const name = option?.name?.trim();
  if (name) return name;
  const fb = fallback?.trim();
  if (fb) return fb;
  return "Package";
}
function packageVisitsForPricing(args) {
  if (args.option) {
    const n = budgetedVisitsForPricing({
      budgetedVisits: args.option.budgetedVisits,
      builtInVisits: args.option.builtInVisits
    });
    if (n > 0) return n;
  }
  const fromState = args.packageStateTotalVisits;
  return typeof fromState === "number" && fromState > 0 ? fromState : 0;
}
function packagePerVisitInputValue(args) {
  const fromOption = args.optionId ? (args.packageOptionPricing ?? []).find((p) => p.optionId === args.optionId) : void 0;
  const fromOptionRate = fromOption?.pricePerAdditionalVisit;
  if (typeof fromOptionRate === "number" && Number.isFinite(fromOptionRate) && fromOptionRate > 0) {
    return fromOptionRate;
  }
  if (typeof args.pricePerAdditionalVisit === "number" && Number.isFinite(args.pricePerAdditionalVisit) && args.pricePerAdditionalVisit > 0) {
    return args.pricePerAdditionalVisit;
  }
  const rate = typeof args.rate === "number" && Number.isFinite(args.rate) ? args.rate : null;
  if (rate != null && args.visits > 0) return rate / args.visits;
  return null;
}
function seasonStoredRateFromPerVisit(perVisit, visits) {
  if (!(visits > 0) || !Number.isFinite(perVisit) || perVisit < 0) return null;
  return roundMoneyToCents(perVisit * visits);
}
function upsertPackageOptionPricing(existing, optionId, next) {
  const rest = (existing ?? []).filter((p) => p.optionId !== optionId);
  return [...rest, { optionId, ...next }];
}
function packagePerVisitFormulaLabel(planName2) {
  const name = planName2.trim();
  return name ? `${name} \xB7 Rate/Visit \xF7 BLR = Hours` : "Rate/Visit \xF7 BLR = Hours";
}
function seedPackageCalculatorEdit(args) {
  const perVisit = packagePerVisitInputValue(args);
  const fromRate = perVisit != null && args.hourlyRate > 0 ? exactHoursFromPerVisit(perVisit, args.hourlyRate) : 0;
  const stored = typeof args.storedHours === "number" && args.storedHours > 0 ? args.storedHours : 0;
  const hours = fromRate > 0 ? fromRate : stored;
  const season = perVisit != null ? seasonStoredRateFromPerVisit(perVisit, args.visits) : null;
  return { perVisit, hours, season };
}
function applyPackagePerVisitEdit(perVisit, hourlyRate, visits) {
  const hoursDisplay = hourlyRate > 0 ? roundHoursToHundredths(
    exactHoursFromPerVisit(perVisit, hourlyRate)
  ).toFixed(2) : "";
  return {
    hoursDisplay,
    season: seasonStoredRateFromPerVisit(perVisit, visits)
  };
}
function packagePricingSaveFromPerVisit(args) {
  if (!Number.isFinite(args.perVisit) || args.perVisit <= 0) return null;
  const perVisitValue = roundMoneyToCents(args.perVisit);
  const derived = applyPackagePerVisitEdit(
    perVisitValue,
    args.hourlyRate,
    args.visits
  );
  const hoursValue = derived.hoursDisplay ? parseFloat(derived.hoursDisplay) : 0;
  const season = derived.season;
  const packageOptionPricing = args.optionId ? upsertPackageOptionPricing(args.existingOptionPricing, args.optionId, {
    rate: season ?? (typeof args.priorOptionRate === "number" ? args.priorOptionRate : 0),
    pricePerAdditionalVisit: perVisitValue
  }) : void 0;
  return {
    ...season != null ? { rate: season } : {},
    pricePerAdditionalVisit: perVisitValue,
    ...packageOptionPricing ? { packageOptionPricing } : {},
    pricingInputs: {
      ...args.pricingInputs || {},
      budgetedHours: hoursValue
    }
  };
}

// src/pricing/rateInputs.ts
function applicableMetricKeys(template) {
  return (template.volumePricing?.applicableMetrics ?? []).map((metric) => ({
    metric,
    key: METRIC_TYPE_TO_KEY[metric]
  }));
}
function isPerVisit(template) {
  return normalizeBillingMethod(template.billingMethod) === "per_visit" /* PER_VISIT */;
}
function rateForInputs(template, inputs) {
  try {
    const result = calculateSubscriptionRateFromEntities(
      template,
      inputs.metrics,
      inputs.budgetedHours,
      inputs.packageOptionId
    );
    if (result.billingMethod === "per_visit" /* PER_VISIT */) return result.rate;
    if (result.billingMethod === "package" /* PACKAGE */) return result.packageAmount;
    if (result.billingMethod === "per_hour" /* PER_HOUR */) return result.hourlyRate;
    return null;
  } catch {
    return null;
  }
}
function rateBreakdown(template, inputs) {
  if (!isPerVisit(template)) return null;
  const result = calculateSubscriptionRateFromEntities(template, inputs.metrics, inputs.budgetedHours);
  if (result.billingMethod !== "per_visit" /* PER_VISIT */) return null;
  const pricingMethod = template.pricingMethod ?? "billable_labor_rate" /* BILLABLE_LABOR_RATE */;
  const minimumCharge = template.minimumCharge || 0;
  const builtInHours = template.builtInHours || 0;
  const hourlyRate = template.hourlyRate || 0;
  const hours = inputs.budgetedHours ?? template.hourBounds?.budgetedHours ?? 0;
  const lines = [];
  if (pricingMethod === "fixed_price" /* FIXED_PRICE */) {
    lines.push({ kind: "fixed", amount: result.components.laborCost });
  } else if (pricingMethod === "unit_based" /* UNIT_BASED */) {
    if (template.volumePricing?.enabled) {
      for (const { metric, key } of applicableMetricKeys(template)) {
        const quantity = inputs.metrics[key] || 0;
        const priced = volumeUnitRateFor(template.volumePricing, quantity);
        if (!priced) continue;
        lines.push({ kind: "measurement", metric, key, quantity, unitRate: priced.rate, amount: roundCurrency(quantity * priced.rate) });
      }
    }
  } else if (hours > 0) {
    const billed = minimumCharge > 0 && builtInHours > 0 ? Math.max(0, hours - builtInHours) : hours;
    lines.push({ kind: "time", hours, hourlyRate, amount: roundCurrency(billed * hourlyRate) });
  }
  const minimumApplied = result.components.minimumChargeApplied > 0;
  if (minimumApplied) {
    const coversTime = pricingMethod !== "unit_based" /* UNIT_BASED */ && builtInHours > 0;
    lines.unshift({ kind: "minimum", amount: minimumCharge, floor: !coversTime, ...coversTime ? { coversHours: builtInHours } : {} });
  }
  return {
    rate: result.rate,
    ...result.preRoundingRate !== void 0 ? { preRoundingRate: result.preRoundingRate } : {},
    lines,
    minimumApplied
  };
}
function measurementCost(template, quantity) {
  const priced = volumeUnitRateFor(template.volumePricing, quantity);
  return priced ? quantity * priced.rate : 0;
}
function tierBounds(template) {
  const vp = template.volumePricing;
  if (vp?.type !== "tiered" /* TIERED */ || !vp.tiers) return [];
  return sortedTiers(vp.tiers).map((t) => t.upperBound).filter((b) => b !== void 0 && b > 0);
}
function solveScale(template, quantities, target) {
  const bounds = tierBounds(template);
  const breaks = /* @__PURE__ */ new Set([0]);
  for (const q of quantities) for (const b of bounds) breaks.add(b / q);
  const edges = [...breaks].sort((a, b) => a - b);
  edges.push(Infinity);
  let best = null;
  for (let i = 0; i < edges.length - 1; i++) {
    const lo = edges[i];
    const hi = edges[i + 1];
    const probe = Number.isFinite(hi) ? (lo + hi) / 2 : lo + 1;
    let slope = 0;
    for (const q of quantities) {
      const priced = volumeUnitRateFor(template.volumePricing, q * probe);
      slope += priced ? q * priced.rate : 0;
    }
    if (slope <= 0) continue;
    const f = target / slope;
    if (f > lo && f <= hi && (best === null || Math.abs(f - 1) < Math.abs(best - 1))) best = f;
  }
  return best;
}
function solveQuantity(template, need, current) {
  if (need === 0) return 0;
  const bounds = [0, ...tierBounds(template), Infinity];
  let best = null;
  for (let i = 0; i < bounds.length - 1; i++) {
    const lo = bounds[i];
    const hi = bounds[i + 1];
    const priced = volumeUnitRateFor(template.volumePricing, Number.isFinite(hi) ? (lo + hi) / 2 : lo + 1);
    if (!priced) continue;
    const q = need / priced.rate;
    if (q > lo && q <= hi && (best === null || Math.abs(q - current) < Math.abs(best - current))) best = q;
  }
  return best;
}
function hundredthsInSameMinute(hours) {
  const minute = Math.round(hours * 60);
  const plain = roundHoursToHundredths(hours);
  if (Math.round(plain * 60) === minute) return plain;
  const lo = Math.max(0, Math.ceil((minute - 0.5) / 60 * 100 - 1e-9) / 100);
  const hi = Math.floor((minute + 0.5) / 60 * 100 - 1e-9) / 100;
  const inMinute = [lo, hi].filter((h) => Math.round(h * 60) === minute);
  if (inMinute.length === 0) return plain;
  return inMinute.reduce((a, b) => Math.abs(b - hours) < Math.abs(a - hours) ? b : a);
}
function solveTime(template, target, inputs) {
  const pm = template.pricingMethod;
  const hourlyRate = template.hourlyRate || 0;
  if (!(hourlyRate > 0)) return null;
  let hours;
  if (pm === "package" /* PACKAGE */) {
    hours = target > 0 ? target / hourlyRate : 0;
  } else {
    if (target < (template.minimumCharge || 0) - 5e-3) return null;
    hours = solveExactHours(template, target, inputs.metrics);
    const minimumCharge = template.minimumCharge || 0;
    const builtInHours = template.builtInHours || 0;
    const current = inputs.budgetedHours ?? 0;
    if (hours !== null && minimumCharge > 0 && Math.abs(target - minimumCharge) < 5e-3) {
      const ceiling = builtInHours > 0 ? builtInHours : minimumCharge / hourlyRate;
      if (current > 0 && current <= ceiling) hours = current;
    }
  }
  if (hours === null || !Number.isFinite(hours) || hours < 0) return null;
  const blh = hundredthsInSameMinute(hours);
  const rate = pm === "package" /* PACKAGE */ ? roundCurrency(hourlyRate * blh) : rateForInputs(template, { ...inputs, budgetedHours: blh });
  if (rate === null) return null;
  return { kind: "blh", blh, rate };
}
function solveMeasurements(template, target, inputs, change) {
  const vp = template.volumePricing;
  const applicable = applicableMetricKeys(template);
  if (!vp?.enabled || applicable.length === 0) return null;
  if (target < (template.minimumCharge || 0) - 5e-3) return null;
  const current = (key) => inputs.metrics[key] || 0;
  const next = { ...inputs.metrics };
  const changed = [];
  const scaleKeys = change === "all-measurements" ? applicable.map((a) => a.key).filter((k) => current(k) > 0) : [];
  if (change === "all-measurements" && scaleKeys.length > 0) {
    const f = solveScale(template, scaleKeys.map(current), target);
    if (f === null) return null;
    for (const k of scaleKeys) {
      next[k] = current(k) * f;
      changed.push(k);
    }
  } else {
    const key = change === "all-measurements" ? applicable[0].key : change.metric;
    if (!applicable.some((a) => a.key === key)) return null;
    const others = applicable.filter((a) => a.key !== key).reduce((sum, a) => sum + measurementCost(template, current(a.key)), 0);
    const q = solveQuantity(template, target - others, current(key));
    if (q === null || q < 0) return null;
    next[key] = q;
    changed.push(key);
  }
  const rate = rateForInputs(template, { ...inputs, metrics: next });
  if (rate === null) return null;
  return { kind: "metrics", metrics: next, changed, rate };
}
function solveInputsForRate(template, targetRate, inputs, change = "auto") {
  if (!Number.isFinite(targetRate) || targetRate < 0) return null;
  const pm = template.pricingMethod;
  if (change === "time") {
    return pm === "billable_labor_rate" /* BILLABLE_LABOR_RATE */ || pm === "package" /* PACKAGE */ ? solveTime(template, targetRate, inputs) : null;
  }
  if (pm === "unit_based" /* UNIT_BASED */) {
    return solveMeasurements(template, targetRate, inputs, change === "auto" ? "all-measurements" : change);
  }
  if (change !== "auto") return null;
  if (pm === "billable_labor_rate" /* BILLABLE_LABOR_RATE */ || pm === "package" /* PACKAGE */) {
    return solveTime(template, targetRate, inputs);
  }
  return null;
}
function timeAgreesWithRate(template, hours, rate, metrics) {
  if (!(typeof hours === "number" && hours > 0) || !(typeof rate === "number" && rate > 0)) return false;
  const exact = solveExactHours(template, rate, metrics);
  if (exact == null || !Number.isFinite(exact)) return false;
  return Math.round(exact * 60) === Math.round(hours * 60);
}
function rateAgreesWithInputs(template, rate, inputs) {
  const calculated = rateForInputs(template, inputs);
  if (calculated === null) return true;
  if (Math.abs(rate - calculated) < 0.01) return true;
  return template.pricingMethod === "billable_labor_rate" /* BILLABLE_LABOR_RATE */ && timeAgreesWithRate(template, inputs.budgetedHours, rate, inputs.metrics);
}

// src/pricing/index.ts
function calculatePricing(pricing, serviceOptions = [], reviewTriggers = {
  requirePhotoOnExcess: false,
  requireNoteOnExcess: false
}, parameters) {
  const {
    hours,
    squareFootage = 0,
    linearFootage = 0,
    visits = 1,
    serviceOptions: optionQuantities = {}
  } = parameters;
  let basePrice = 0;
  const breakdown = [];
  const warnings = [];
  if (reviewTriggers?.timeExceeded && hours > reviewTriggers.timeExceeded) {
    warnings.push({
      type: "time-exceeded",
      message: `Time limit exceeded: ${hours}h > ${reviewTriggers.timeExceeded}h limit`,
      severity: "error"
    });
  }
  const targetedHourlyRate = pricing.targetedHourlyRate || 0;
  const hourlyTotal = targetedHourlyRate * hours;
  if (pricing.prepaidVisits?.enabled && pricing.prepaidVisits.numberOfVisits) {
    const prepaidVisits = pricing.prepaidVisits.numberOfVisits;
    const packageCost = targetedHourlyRate * hours * prepaidVisits;
    basePrice = packageCost;
    breakdown.push({
      type: "prepaid-package",
      label: "Prepaid Package (Upfront)",
      amount: packageCost,
      description: `${prepaidVisits} visits \xD7 ${hours}h \xD7 $${targetedHourlyRate}/hr`
    });
    if (visits > prepaidVisits) {
      const extraVisits = visits - prepaidVisits;
      const extraCost = extraVisits * (targetedHourlyRate * hours);
      basePrice += extraCost;
      breakdown.push({
        type: "extra-visits",
        label: "Extra Visits (Per Visit)",
        amount: extraCost,
        description: `${extraVisits} additional visits \xD7 ${hours}h \xD7 $${targetedHourlyRate}/hr`
      });
    }
  } else {
    basePrice = hourlyTotal;
    breakdown.push({
      type: "labor",
      label: "Labor Cost",
      amount: hourlyTotal,
      description: `${hours} hours \xD7 $${targetedHourlyRate}/hr`
    });
  }
  if (pricing.unitPricing?.enabled) {
    const units = pricing.unitPricing.unitType === "square-foot" ? squareFootage : linearFootage;
    let unitCost = 0;
    if (pricing.unitPricing.useTieredPricing && pricing.unitPricing.pricingTiers) {
      const tier = pricing.unitPricing.pricingTiers.find(
        (t) => units >= t.minUnits && units <= t.maxUnits
      );
      if (tier) {
        unitCost = units * tier.pricePerUnit;
        breakdown.push({
          type: "unit-pricing",
          label: `${pricing.unitPricing.unitType.replace("-", " ")} charge`,
          amount: unitCost,
          description: `${units} ${pricing.unitPricing.unitType} \xD7 $${tier.pricePerUnit}`
        });
      }
    } else if (pricing.unitPricing.basePricePerUnit) {
      unitCost = units * pricing.unitPricing.basePricePerUnit;
      breakdown.push({
        type: "unit-pricing",
        label: `${pricing.unitPricing.unitType.replace("-", " ")} charge`,
        amount: unitCost,
        description: `${units} ${pricing.unitPricing.unitType} \xD7 $${pricing.unitPricing.basePricePerUnit}`
      });
    }
    basePrice += unitCost;
  }
  serviceOptions.forEach((option) => {
    if (option.billable) {
      const quantity = optionQuantities[option.id] || 0;
      if (quantity > 0) {
        let optionCost = 0;
        if (option.rateType === "flat") {
          optionCost = option.rate;
        } else if (option.rateType === "per-unit") {
          const billableQuantity = Math.max(
            0,
            quantity - (option.builtInAmount || 0)
          );
          optionCost = option.rate * billableQuantity;
        } else if (option.rateType === "time-based") {
          const billableHours = Math.max(
            0,
            hours - (option.builtInAmount || 0)
          );
          optionCost = option.rate * billableHours;
        }
        if (optionCost > 0 || quantity > 0) {
          if (optionCost > 0) {
            basePrice += optionCost;
          }
          let description = "";
          if (option.rateType === "flat") {
            description = "Flat rate";
          } else if (option.rateType === "per-unit") {
            const billableQuantity = Math.max(
              0,
              quantity - (option.builtInAmount || 0)
            );
            const freeQuantity = Math.min(quantity, option.builtInAmount || 0);
            if (freeQuantity > 0 && billableQuantity > 0) {
              description = `${freeQuantity} free + ${billableQuantity} \xD7 $${option.rate}`;
            } else if (freeQuantity > 0) {
              description = `${freeQuantity} ${option.unit || "units"} (included free)`;
            } else {
              description = `${billableQuantity} ${option.unit || "units"} \xD7 $${option.rate}`;
            }
          } else if (option.rateType === "time-based") {
            const billableHours = Math.max(
              0,
              hours - (option.builtInAmount || 0)
            );
            const freeHours = Math.min(hours, option.builtInAmount || 0);
            if (freeHours > 0 && billableHours > 0) {
              description = `${freeHours}h free + ${billableHours}h \xD7 $${option.rate}/hr`;
            } else if (freeHours > 0) {
              description = `${freeHours} hours (included free)`;
            } else {
              description = `${billableHours} hours \xD7 $${option.rate}/hr`;
            }
          }
          breakdown.push({
            type: "service-option",
            optionId: option.id,
            label: option.name,
            amount: optionCost,
            description
          });
        }
      }
    }
  });
  if (pricing.minimumCharge?.enabled) {
    let minimumAmount = 0;
    if (pricing.minimumCharge.type === "dollar" && pricing.minimumCharge.minimumDollarAmount) {
      minimumAmount = pricing.minimumCharge.minimumDollarAmount;
    } else if (pricing.minimumCharge.type === "hours" && pricing.minimumCharge.minimumHours) {
      minimumAmount = pricing.minimumCharge.minimumHours * targetedHourlyRate;
    } else if (!pricing.minimumCharge.type) {
      if (pricing.minimumCharge.minimumDollarAmount) {
        minimumAmount = pricing.minimumCharge.minimumDollarAmount;
      } else if (pricing.minimumCharge.minimumHours) {
        minimumAmount = pricing.minimumCharge.minimumHours * targetedHourlyRate;
      }
    }
    if (basePrice < minimumAmount) {
      breakdown.push({
        type: "minimum-adjustment",
        label: "Minimum Charge Adjustment",
        amount: minimumAmount - basePrice,
        description: `Minimum ${pricing.minimumCharge.type === "dollar" || pricing.minimumCharge.minimumDollarAmount ? `$${minimumAmount.toFixed(2)}` : `${pricing.minimumCharge.minimumHours} hours ($${minimumAmount.toFixed(2)})`}`
      });
      basePrice = minimumAmount;
    }
  }
  return {
    subtotal: basePrice,
    total: basePrice,
    breakdown,
    warnings
  };
}

// src/events/types.ts
var TranslatableEntityType = /* @__PURE__ */ ((TranslatableEntityType2) => {
  TranslatableEntityType2["VISIT"] = "visit";
  TranslatableEntityType2["CUSTOMER"] = "customer";
  TranslatableEntityType2["SERVICE_TEMPLATE"] = "serviceTemplate";
  TranslatableEntityType2["CUSTOMER_SUBSCRIPTION"] = "customerSubscription";
  TranslatableEntityType2["CHAT_MESSAGE"] = "chat_message";
  return TranslatableEntityType2;
})(TranslatableEntityType || {});
var EVENT_TYPES = {
  ORGANIZATION_CREATED: "OrganizationCreated",
  ORGANIZATION_UPDATED: "OrganizationUpdated",
  ORGANIZATION_DELETED: "OrganizationDeleted",
  RATE_REQUEST_CREATED: "RateRequestCreated",
  SERVICE_RATES_PROVIDED: "ServiceRatesProvided",
  CUSTOMER_RATE_CREATED: "CustomerRateCreated",
  CUSTOMER_CREATED: "CustomerCreated",
  CUSTOMER_UPDATED: "CustomerUpdated",
  CREW_CREATED: "CrewCreated",
  CREW_MEMBER_ADDED: "CrewMemberAdded",
  CREW_MEMBER_REMOVED: "CrewMemberRemoved",
  VISIT_CREATED: "VisitCreated",
  VISIT_STATUS_CHANGED: "VisitStatusChanged",
  VISIT_ASSIGNED: "VisitAssigned",
  VISIT_COMPLETED: "VisitCompleted",
  INVOICE_CREATED: "InvoiceCreated",
  INVOICE_PAYMENT_PROCESSED: "InvoicePaymentProcessed",
  SERVICE_TEMPLATE_CREATED: "ServiceTemplateCreated",
  SERVICE_TEMPLATE_UPDATED: "ServiceTemplateUpdated",
  USER_INVITED: "UserInvited",
  USER_JOINED_ORGANIZATION: "UserJoinedOrganization",
  NOTIFICATION_TRIGGERED: "NotificationTriggered",
  SUBSCRIPTION_REQUESTED: "SubscriptionRequested",
  SUBSCRIPTION_RATE_PROVIDED: "SubscriptionRateProvided",
  SUBSCRIPTION_BATCH_RATES_RELEASED: "SubscriptionBatchRatesReleased",
  SUBSCRIPTION_ACCEPTED: "SubscriptionAccepted",
  SUBSCRIPTION_REJECTED: "SubscriptionRejected",
  TRANSLATION_REQUESTED: "TranslationRequested",
  TRANSLATION_COMPLETED: "TranslationCompleted",
  TRANSLATION_FAILED: "TranslationFailed"
};

// src/validation/visit.ts
import { z } from "zod";
var CreateVisitSchema = z.object({
  // === IDENTITY (Required) ===
  id: z.string().min(1, "Visit ID is required"),
  orgId: z.string().min(1, "Organization ID is required"),
  customerId: z.string().min(1, "Customer ID is required"),
  serviceTemplateId: z.string().min(1, "Service template ID is required"),
  // === SCHEDULING ===
  status: z.nativeEnum(VisitStatus).optional(),
  // Defaults to NOT_STARTED in createVisit()
  // === BILLING-CRITICAL ===
  // budgetedHours is required for non-hourly billing, optional for PER_HOUR
  budgetedHours: z.number().nonnegative("budgetedHours must be non-negative").optional(),
  // === ASSIGNMENT (Optional) ===
  crewId: z.string().optional(),
  order: z.number().int().optional(),
  priority: z.boolean().optional(),
  // === SUBSCRIPTION LINK (Optional) ===
  subscriptionId: z.string().optional(),
  isFirstSubscriptionVisit: z.boolean().optional(),
  // === FOLLOW-UP (Optional) ===
  isFollowupVisit: z.boolean().optional(),
  originalVisitId: z.string().optional(),
  // === NOTES (Optional) ===
  adminNotes: z.string().optional(),
  adminNotes_es: z.string().optional(),
  // === DENORMALIZED DATA (Optional but recommended) ===
  // These are populated from related entities at creation time
  customerFirstName: z.string().optional(),
  customerLastName: z.string().optional(),
  customerAddress: z.string().optional(),
  customerCoordinates: z.tuple([z.number(), z.number()]).optional(),
  customerParcelPin: z.string().optional(),
  serviceName: z.string().optional(),
  billingMethod: z.nativeEnum(BillingMethod).optional(),
  hourlyRate: z.number().nonnegative().optional(),
  minimumCharge: z.number().nonnegative().optional(),
  builtInHours: z.number().nonnegative().optional(),
  subscriptionRate: z.number().nonnegative().optional()
});
var VisitSaveSchema = z.object({
  // === IDENTITY (Required) ===
  id: z.string().min(1, "Visit ID is required"),
  orgId: z.string().min(1, "Organization ID is required"),
  customerId: z.string().min(1, "Customer ID is required"),
  serviceTemplateId: z.string().min(1, "Service template ID is required"),
  // === SCHEDULING ===
  status: z.nativeEnum(VisitStatus),
  createdAt: z.string(),
  updatedAt: z.string(),
  // === BILLING ===
  // budgetedHours is required for non-hourly billing, validated in validateVisitForSave
  budgetedHours: z.number().nonnegative("budgetedHours must be non-negative").optional(),
  billingMethod: z.nativeEnum(BillingMethod).optional()
  // Allow all other fields as passthrough
}).passthrough();
function validateVisitForSave(visit) {
  const result = VisitSaveSchema.safeParse(visit);
  const warnings = [];
  const errors = [];
  if (!result.success) {
    return {
      success: false,
      errors: result.error.issues.map((issue) => ({
        path: issue.path.join("."),
        message: issue.message
      }))
    };
  }
  const data = result.data;
  if (errors.length > 0) {
    return {
      success: false,
      errors
    };
  }
  if (!data.billingMethod) {
    warnings.push("billingMethod not set - pricing calculations may fail");
  }
  if (!data.customerDisplayName) {
    warnings.push("Customer name not denormalized - display may be affected");
  }
  if (!data.serviceName) {
    warnings.push("serviceName not denormalized - display may be affected");
  }
  return {
    success: true,
    data,
    warnings: warnings.length > 0 ? warnings : void 0
  };
}
function validateVisitForCreation(input) {
  const result = CreateVisitSchema.safeParse(input);
  if (!result.success) {
    return {
      success: false,
      errors: result.error.issues.map((issue) => ({
        path: issue.path.join("."),
        message: issue.message
      }))
    };
  }
  return {
    success: true,
    data: result.data
  };
}
function formatValidationErrors(result) {
  if (result.success) return "";
  return result.errors?.map((e) => `${e.path}: ${e.message}`).join(", ") ?? "Unknown validation error";
}

// src/utils/slug.ts
function generateSlug(name) {
  return name.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_]+/g, "-").replace(/^-+|-+$/g, "").replace(/-+/g, "-");
}
function isValidSlug(slug) {
  if (slug.length < 3 || slug.length > 50) {
    return false;
  }
  const slugRegex = /^[a-z0-9][a-z0-9-]*[a-z0-9]$/;
  if (slug.length === 3) {
    return /^[a-z0-9]{3}$/.test(slug) || /^[a-z0-9]-[a-z0-9]$/.test(slug);
  }
  return slugRegex.test(slug) && !slug.includes("--");
}
function generateUniqueSlug(baseSlug, existingSlugs) {
  let slug = baseSlug;
  let counter = 1;
  const existingSet = new Set(existingSlugs);
  while (existingSet.has(slug)) {
    slug = `${baseSlug}-${counter}`;
    counter++;
  }
  return slug;
}
function suggestSlug(name) {
  const slug = generateSlug(name);
  if (slug.length < 3) {
    return null;
  }
  const truncatedSlug = slug.substring(0, 50);
  const finalSlug = truncatedSlug.replace(/-+$/, "");
  return isValidSlug(finalSlug) ? finalSlug : null;
}
var RESERVED_SLUGS = /* @__PURE__ */ new Set([
  "api",
  "app",
  "admin",
  "dashboard",
  "login",
  "signup",
  "register",
  "settings",
  "profile",
  "billing",
  "support",
  "help",
  "docs",
  "documentation",
  "blog",
  "about",
  "contact",
  "terms",
  "privacy",
  "legal",
  "home",
  "www",
  "mail",
  "email",
  "test",
  "demo",
  "staging",
  "production",
  "dev",
  "development",
  "dev.api",
  "api-staging",
  "api-prod",
  "ruta",
  "getruta",
  "customer",
  "portal",
  "cdn",
  "assets",
  "static",
  "ns1",
  "ns2"
]);
function isReservedSlug(slug) {
  return RESERVED_SLUGS.has(slug.toLowerCase());
}
function validateSlug(slug) {
  if (!slug || slug.trim() === "") {
    return { isValid: false, error: "Slug cannot be empty" };
  }
  if (slug.length < 3) {
    return { isValid: false, error: "Slug must be at least 3 characters long" };
  }
  if (slug.length > 50) {
    return {
      isValid: false,
      error: "Slug cannot be more than 50 characters long"
    };
  }
  if (!isValidSlug(slug)) {
    return {
      isValid: false,
      error: "Slug must contain only lowercase letters, numbers, and hyphens, and cannot start or end with a hyphen"
    };
  }
  if (isReservedSlug(slug)) {
    return {
      isValid: false,
      error: "This slug is reserved and cannot be used"
    };
  }
  return { isValid: true };
}

// src/utils/url.ts
function ensureUrlScheme(value) {
  const trimmed = value.trim();
  if (!trimmed) return "";
  return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
}

// src/utils/serviceTemplateSlug.ts
function slugifyServiceName(name) {
  return name.toLowerCase().trim().normalize("NFKD").replace(/[̀-ͯ]/g, "").replace(/[^a-z0-9\s-]/g, "").replace(/[\s_]+/g, "-").replace(/-+/g, "-").replace(/^-+|-+$/g, "").substring(0, 60);
}
function isValidServiceTemplateSlug(slug) {
  if (slug.length < 1 || slug.length > 60) return false;
  if (slug.includes("--")) return false;
  return /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(slug);
}
function deriveUniqueServiceTemplateSlug(name, existingSlugs) {
  const base = slugifyServiceName(name);
  if (!base) return null;
  const taken = new Set(existingSlugs);
  if (!taken.has(base)) return base;
  let counter = 2;
  let candidate = `${base}-${counter}`;
  while (taken.has(candidate)) {
    counter += 1;
    candidate = `${base}-${counter}`;
  }
  return candidate;
}

// src/utils/phone.ts
function validateAndNormalizePhone(phoneNumber) {
  if (!phoneNumber || typeof phoneNumber !== "string") {
    return {
      isValid: false,
      cleanPhone: "",
      formattedPhone: "",
      originalPhone: phoneNumber || ""
    };
  }
  const cleanPhone = phoneNumber.replace(/\D/g, "");
  const phoneRegex = /^(?:1)?([2-9]\d{2})([2-9]\d{2})(\d{4})$/;
  const match = cleanPhone.match(phoneRegex);
  if (!match) {
    return {
      isValid: false,
      cleanPhone,
      formattedPhone: "",
      originalPhone: phoneNumber
    };
  }
  const tenDigitPhone = match[1] + match[2] + match[3];
  const formattedPhone = `+1${tenDigitPhone}`;
  return {
    isValid: true,
    cleanPhone: tenDigitPhone,
    formattedPhone,
    originalPhone: phoneNumber
  };
}
function normalizePhone(phoneNumber) {
  const result = validateAndNormalizePhone(phoneNumber);
  return result.isValid ? result.cleanPhone : "";
}
function formatPhoneE164(phoneNumber) {
  const result = validateAndNormalizePhone(phoneNumber);
  return result.isValid ? result.formattedPhone : "";
}
function isValidPhone(phoneNumber) {
  const result = validateAndNormalizePhone(phoneNumber);
  return result.isValid;
}
function formatPhoneDisplay(phoneNumber) {
  const result = validateAndNormalizePhone(phoneNumber);
  if (!result.isValid) {
    return phoneNumber;
  }
  const clean = result.cleanPhone;
  return `(${clean.slice(0, 3)}) ${clean.slice(3, 6)}-${clean.slice(6)}`;
}
function normalizePhoneSearchQuery(query) {
  if (!query || typeof query !== "string") {
    return query;
  }
  const trimmed = query.trim();
  if (!/^[+()\-.\s\d]+$/.test(trimmed)) {
    return query;
  }
  const digits = trimmed.replace(/\D/g, "");
  if (digits.length < 7) {
    return query;
  }
  if (digits.length === 11 && digits.startsWith("1")) {
    return digits.slice(1);
  }
  return digits;
}
function isAddressLikeSearchQuery(query) {
  if (!query || query === "*") {
    return false;
  }
  return /[A-Za-z]/.test(query) && /\d/.test(query);
}
function isValidPhoneType(value) {
  return typeof value === "string" && Object.values(PhoneType).includes(value);
}

// src/utils/linkifyMessageText.ts
var TOKEN_REGEX = new RegExp(
  [
    // URL
    "(https?:\\/\\/[^\\s]+)",
    // Phone: optional +1/1 country code, then 10 digits with optional ()/separators
    "(?:\\+?1[-.\\s]?)?\\(?[2-9]\\d{2}\\)?[-.\\s]?[2-9]\\d{2}[-.\\s]?\\d{4}"
  ].join("|"),
  "g"
);
var TRAILING_URL_PUNCT = /[.,!?;:)\]}'"]+$/;
function linkifyMessageText(text) {
  if (!text) {
    return [];
  }
  const segments = [];
  let lastIndex = 0;
  const pushText = (value) => {
    if (!value) return;
    const previous = segments[segments.length - 1];
    if (previous && previous.type === "text") {
      previous.value += value;
      return;
    }
    segments.push({ type: "text", value });
  };
  TOKEN_REGEX.lastIndex = 0;
  let match;
  while ((match = TOKEN_REGEX.exec(text)) !== null) {
    const matchStart = match.index;
    const matchedValue = match[0];
    if (matchedValue.length === 0) {
      TOKEN_REGEX.lastIndex += 1;
      continue;
    }
    pushText(text.slice(lastIndex, matchStart));
    const isUrl = matchedValue.startsWith("http://") || matchedValue.startsWith("https://");
    if (isUrl) {
      const stripped = matchedValue.replace(TRAILING_URL_PUNCT, "");
      const trailing = matchedValue.slice(stripped.length);
      segments.push({ type: "url", value: stripped, href: stripped });
      lastIndex = matchStart + matchedValue.length;
      pushText(trailing);
      continue;
    }
    if (isValidPhone(matchedValue)) {
      segments.push({
        type: "phone",
        value: matchedValue,
        href: `tel:${formatPhoneE164(matchedValue)}`
      });
      lastIndex = matchStart + matchedValue.length;
      continue;
    }
    pushText(matchedValue);
    lastIndex = matchStart + matchedValue.length;
  }
  pushText(text.slice(lastIndex));
  return segments;
}

// src/index.ts
init_name();

// src/utils/hourBoundsValidation.ts
function validatePerHourBounds(actualHours, bounds) {
  const violations = [];
  if (bounds.upperBound && actualHours > bounds.upperBound) {
    violations.push({
      type: "upper_bound_exceeded",
      message: `Hours exceeded upper bound: ${actualHours.toFixed(2)}h > ${bounds.upperBound}h`,
      actualHours,
      expectedValue: bounds.upperBound
    });
  }
  if (bounds.lowerBound && actualHours < bounds.lowerBound) {
    violations.push({
      type: "lower_bound_not_met",
      message: `Hours below lower bound: ${actualHours.toFixed(2)}h < ${bounds.lowerBound}h`,
      actualHours,
      expectedValue: bounds.lowerBound
    });
  }
  return {
    isValid: violations.length === 0,
    violations
  };
}
function validatePerVisitBudget(actualHours, budgetedHours, varianceThreshold = 0.25) {
  const violations = [];
  if (budgetedHours <= 0) {
    return { isValid: true, violations: [] };
  }
  const variance = Math.abs(actualHours - budgetedHours) / budgetedHours;
  if (variance > varianceThreshold) {
    violations.push({
      type: "budget_variance_high",
      message: `Budget variance too high: ${(variance * 100).toFixed(1)}% variance exceeds ${(varianceThreshold * 100).toFixed(0)}% threshold`,
      actualHours,
      expectedValue: budgetedHours,
      variance
    });
  }
  return {
    isValid: violations.length === 0,
    violations
  };
}
function validateHourBounds(actualHours, bounds, billingMethod, varianceThreshold) {
  if (billingMethod === "per_visit" && bounds.budgetedHours) {
    return validatePerVisitBudget(
      actualHours,
      bounds.budgetedHours,
      varianceThreshold
    );
  } else if (billingMethod === "per_hour" || billingMethod === void 0) {
    return validatePerHourBounds(actualHours, bounds);
  } else {
    return { isValid: true, violations: [] };
  }
}
function shouldFlagForReview(actualHours, bounds, billingMethod, varianceThreshold) {
  if (!bounds || actualHours <= 0 || !billingMethod) {
    return { shouldFlag: false };
  }
  const validation = validateHourBounds(
    actualHours,
    bounds,
    billingMethod,
    varianceThreshold
  );
  if (!validation.isValid) {
    const primaryViolation = validation.violations[0];
    let reason;
    switch (primaryViolation.type) {
      case "upper_bound_exceeded":
        reason = "hours_exceeded_upper_bound";
        break;
      case "lower_bound_not_met":
        reason = "hours_below_lower_bound";
        break;
      case "budget_variance_high":
        reason = "manual_flag";
        break;
      default:
        reason = "manual_flag";
    }
    return { shouldFlag: true, reason };
  }
  return { shouldFlag: false };
}

// src/utils/currency.ts
function formatUsd(amount) {
  return amount.toLocaleString("en-US", { style: "currency", currency: "USD" });
}
function formatWholeDollars(amount) {
  return formatUsd(amount).replace(/\.00$/, "");
}
function formatRoundDollars(amount) {
  return formatWholeDollars(Math.round(amount));
}

// src/aiImport/contract.ts
import { z as z2 } from "zod";
var IMPORT_ENGINES = ["book"];
function isBookEngineProposal(proposal) {
  return proposal?.engine?.name === "book";
}
var OLD_IMPORTER_REVIEW_MESSAGE = "This review was made by the old importer. Nothing was saved \u2014 upload your files again to review them with the new one.";
var OLD_IMPORTER_REVIEW_REASON = "IMPORT_MADE_BY_OLD_IMPORTER";
var DISCREPANCY_KINDS = [
  "arithmetic",
  "billing_vs_history",
  "cadence_vs_history",
  "visits_vs_package",
  "activity_after_end",
  "dormant_but_active",
  "implausible_price",
  "unreadable_rows",
  "ambiguous_reading",
  "variant_sprawl",
  "missing_price",
  "unrepresentable_adjustment",
  "reupload_difference"
];
var QUESTION_SEVERITIES = ["blocking", "important", "fyi"];
var CUSTOM_AMOUNT_FIELDS = ["rate", "hourlyRate", "builtInVisits", "pricePerAdditionalVisit", "unitCount"];
var LEFT_OUT_REASONS = [
  "past_visit",
  "invoice_or_payment",
  "expense",
  "completed_one_time_job",
  "declined_quote",
  "fee_or_surcharge",
  "tax_line",
  "note",
  "structural",
  "duplicate_row",
  "unreadable",
  /**
   * Older proposals only: no import writes it now. Rows the stage deadline leaves unread with money
   * at stake fail the import closed instead. Kept so proposals stored before that still validate.
   */
  "out_of_time",
  /**
   * Past the row reader's limits for one upload (rows not read before, or dollars of reading). Rows
   * read on an earlier upload don't count toward the limit, so the next upload reads the next ones.
   */
  "reading_limit",
  /** A customer's second service of one type: Ruta keeps one per customer and type (the running one). Counts services, not rows. */
  "one_service_per_type"
];
var LEFT_OUT_WORDS = {
  past_visit: { label: "Past visits", one: "Past visit", why: "Used to check prices and how often, not imported." },
  invoice_or_payment: { label: "Invoices and payments", one: "Invoice or payment", why: "Used to check what you billed, not imported." },
  expense: { label: "Expenses", one: "Expense", why: "Your own costs, not your customers' \u2014 not imported." },
  completed_one_time_job: { label: "One-time jobs already done", one: "One-time job already done", why: "Finished work with nothing coming up." },
  declined_quote: { label: "Quotes nobody took", one: "Quote nobody took", why: "Work the customer never signed on for." },
  fee_or_surcharge: {
    label: "Fees and surcharges",
    one: "Fee or surcharge",
    why: "Not a service of their own; one that rides on a customer\u2019s price was asked about."
  },
  tax_line: { label: "Sales tax lines", one: "Sales tax line", why: "Ruta works out tax itself." },
  note: { label: "Notes on rows of their own", one: "Note on a row of its own", why: "No customer or service in them to bring in." },
  structural: { label: "Headings, blank rows and totals", one: "Heading, blank row or total", why: "Report titles, subtotals and spacing." },
  duplicate_row: { label: "Repeated rows", one: "Repeated row", why: "The same row twice \u2014 brought in once." },
  unreadable: { label: "Rows we couldn\u2019t read", one: "Row we couldn\u2019t read", why: "Nothing in them matched the rest of the file." },
  /** Older proposals only: no import writes it now. */
  out_of_time: { label: "Rows we didn\u2019t get to", one: "Row we didn\u2019t get to", why: "The file was too big to finish; upload it again to read the rest." },
  reading_limit: {
    label: "Rows past the reading limit",
    one: "Row past the reading limit",
    why: "Ruta reads rows that don\u2019t match the rest of the file one at a time, up to a limit each upload, and these were past it. Upload the file again and Ruta reads the next ones."
  },
  one_service_per_type: {
    label: "Services of a type the customer already has",
    one: "Service of a type the customer already has",
    why: "Ruta keeps one service of each type per customer. Where a customer had a running one, it was kept; each other service of that type \u2014 ended, paused, starting later, or the same one listed twice \u2014 is listed here instead."
  }
};
var VISITS_IN_FILE_WORDS = {
  label: "Visits in your file",
  one: "Visit in your file",
  why: "Past visits were used to check prices and how often, scheduled ones to see what is still running. Ruta schedules its own; none were imported."
};
function leftOutLabel(g) {
  if (g.rowCount !== 1) return g.label;
  return [...Object.values(LEFT_OUT_WORDS), VISITS_IN_FILE_WORDS].find((w) => w.label === g.label)?.one ?? g.label;
}
var LEFT_OUT_SERVICE_REASONS = /* @__PURE__ */ new Set(["one_service_per_type"]);
function leftOutTotals(groups) {
  let rows = 0;
  let services = 0;
  for (const g of groups) {
    if (LEFT_OUT_SERVICE_REASONS.has(g.reason)) services += g.rowCount;
    else rows += g.rowCount;
  }
  return { rows, services };
}
var RECIPE_SOURCES = ["org_override", "cache_exact", "cache_family", "authored"];
var TEMPLATE_ORIGINS = ["price_list", "agreements", "variant"];
var IMPORT_CUSTOMER_STATUSES = ["ACTIVE", "INACTIVE", "PROSPECT"];
var IMPORT_SUBSCRIPTION_STATUSES = ["active" /* ACTIVE */, "inactive" /* INACTIVE */, "cancelled" /* CANCELLED */];
var IMPORT_DISCOUNT_TYPES = ["percentage", "fixed"];
var zImportCadence = z2.object({
  frequency: z2.enum(ScheduleFrequency),
  interval: z2.number().optional(),
  unit: z2.enum(CustomScheduleUnit).optional()
});
var zImportScheduleConfig = z2.object({
  frequency: z2.enum(ScheduleFrequency),
  customConfig: z2.object({ interval: z2.number(), unit: z2.enum(CustomScheduleUnit) }).optional()
});
var zImportChangeValue = z2.union([z2.string(), z2.number(), z2.boolean(), z2.null()]);
var zSubscriptionChange = z2.object({
  field: z2.enum(SUBSCRIPTION_IMPORTED_FIELD_NAMES),
  /** What Ruta has now. */
  from: zImportChangeValue,
  /** What the file says. */
  to: zImportChangeValue,
  /** True when the owner edited this field after the last import, so the import keeps theirs. */
  keptOwnerEdit: z2.boolean()
});
var zImportDiscount = z2.object({ type: z2.enum(IMPORT_DISCOUNT_TYPES), value: z2.number() });
var zRateBreakdownLine = z2.object({ label: z2.string(), amount: z2.number() });
var zSourceExample = z2.object({ fileName: z2.string(), locator: z2.string(), text: z2.string() });
var zQuestionSubject = z2.object({
  clientId: z2.string(),
  subscriptionId: z2.string().optional(),
  customerName: z2.string(),
  serviceName: z2.string()
});
var zCustomAmountSpec = z2.object({
  field: z2.enum(CUSTOM_AMOUNT_FIELDS),
  label: z2.string(),
  unitPrice: z2.number().optional(),
  unit: z2.string().optional()
});
var zStoredAnswer = z2.object({ optionId: z2.string(), customValue: z2.number().optional(), answeredAt: z2.string() });
var zLeftOutGroup = z2.object({
  reason: z2.enum(LEFT_OUT_REASONS),
  /** Plain words, e.g. "Past visits". */
  label: z2.string(),
  /** Plain words, e.g. "Used to check prices and cadence, not imported." */
  why: z2.string(),
  /** How many rows — or services, for a reason in `LEFT_OUT_SERVICE_REASONS` (`leftOutTotals`). */
  rowCount: z2.number(),
  /** Money on those rows, when they carried any. */
  dollars: z2.number().optional(),
  examples: z2.array(zSourceExample)
});
var zEngineRecipeInfo = z2.object({
  /** sha256 of the layout's normalized raw headers, in order. */
  fingerprint: z2.string(),
  revision: z2.number(),
  source: z2.enum(RECIPE_SOURCES),
  /** Plain words: how this layout was read — the recipe's own `reading`. */
  reading: z2.string(),
  /** The sheets that share this layout. */
  sheets: z2.array(z2.object({ fileName: z2.string(), sheet: z2.string().optional() })),
  /** Rows the recipe read. */
  rows: z2.number()
});
var zEngineInfo = z2.object({ name: z2.enum(IMPORT_ENGINES), version: z2.string(), recipes: z2.array(zEngineRecipeInfo) });
var zChecksSummary = z2.object({
  servicesChecked: z2.number(),
  matchedHistory: z2.number(),
  autoCorrected: z2.number(),
  questions: z2.number(),
  dollarsAtStake: z2.number()
});
var MONEY_QUESTION_KINDS = /* @__PURE__ */ new Set([
  "arithmetic",
  "billing_vs_history",
  "visits_vs_package",
  "implausible_price",
  "missing_price",
  "ambiguous_reading",
  "unrepresentable_adjustment",
  "variant_sprawl",
  "unreadable_rows",
  "reupload_difference"
]);
function isMoneyQuestion(question) {
  return MONEY_QUESTION_KINDS.has(question.kind);
}
var SEVERITY_RANK = { blocking: 0, important: 1, fyi: 2 };
function compareQuestions(a, b) {
  return SEVERITY_RANK[a.severity] - SEVERITY_RANK[b.severity] || Number(isMoneyQuestion(b)) - Number(isMoneyQuestion(a)) || b.dollarsAtStake - a.dollarsAtStake || a.id.localeCompare(b.id);
}
var zSet = z2.record(z2.string(), z2.unknown());
function zProposalPatchOf(template) {
  return z2.discriminatedUnion("target", [
    z2.object({ target: z2.literal("subscription"), subscriptionId: z2.string(), set: zSet }),
    z2.object({ target: z2.literal("template"), tempId: z2.string(), set: zSet }),
    z2.object({ target: z2.literal("addTemplate"), template }),
    z2.object({ target: z2.literal("customer"), clientId: z2.string(), set: zSet })
  ]);
}
function zImportQuestionOf(template) {
  return z2.object({
    id: z2.string(),
    kind: z2.enum(DISCREPANCY_KINDS),
    severity: z2.enum(QUESTION_SEVERITIES),
    headline: z2.string(),
    detail: z2.string(),
    dollarsAtStake: z2.number(),
    subjects: z2.array(zQuestionSubject),
    evidence: z2.array(zSourceExample),
    options: z2.array(
      z2.object({
        id: z2.string(),
        label: z2.string(),
        effect: z2.string(),
        patches: z2.array(zProposalPatchOf(template)),
        recommended: z2.boolean().optional()
      })
    ),
    customAmount: zCustomAmountSpec.optional(),
    answer: zStoredAnswer.optional()
  });
}

// src/aiImport/variantKey.ts
function keyAmount(n) {
  return Number.isInteger(n) ? String(n) : n.toFixed(2);
}
function variantKey(shape) {
  const parts = [shape.kindKey, shape.billingMethod, shape.pricingMethod];
  if (shape.billingMethod === "per_hour" /* PER_HOUR */) parts.push(typeof shape.hourlyRate === "number" ? `@${keyAmount(shape.hourlyRate)}` : "@?");
  if (shape.billingMethod === "package" /* PACKAGE */) parts.push(`plans:${[...shape.plans ?? []].sort().join("+") || "?"}`);
  return parts.join("|");
}
function kindKeyOfVariant(importKey) {
  return importKey.split("|")[0];
}
function planName(plan) {
  if (plan.isUnlimited) return "Unlimited";
  if (plan.builtInVisits !== null) return `${plan.builtInVisits} ${plan.builtInVisits === 1 ? "visit" : "visits"}`;
  return "Full season";
}

// src/utils/words.ts
function plural(count, one, many = `${one}s`) {
  return `${count.toLocaleString("en-US")} ${count === 1 ? one : many}`;
}
function joinWords(items) {
  if (items.length <= 1) return items[0] ?? "";
  return `${items.slice(0, -1).join(", ")} and ${items[items.length - 1]}`;
}
function capitalizeFirst(s) {
  return s.length > 0 ? s[0].toUpperCase() + s.slice(1) : s;
}
function lowerFirst(s) {
  return s.length > 0 && !/^[A-Z]{2}/.test(s) ? s[0].toLowerCase() + s.slice(1) : s;
}

// src/aiImport/priceWords.ts
var UNIT_WORDS = {
  visit: ["visit", "visits"],
  hour: ["hour", "hours"],
  season: ["season", "seasons"],
  month: ["month", "months"],
  year: ["year", "years"],
  application: ["application", "applications"],
  event: ["visit", "visits"],
  each: ["item", "items"],
  zone: ["zone", "zones"],
  dog: ["dog", "dogs"],
  yard: ["yard", "yards"],
  cubic_yard: ["yard", "yards"],
  bag: ["bag", "bags"],
  ton: ["ton", "tons"],
  sqft: ["sq ft", "sq ft"],
  sqft_1000: ["1,000 sq ft", "1,000 sq ft"],
  linear_ft: ["ft", "ft"],
  acre: ["acre", "acres"],
  inch: ["inch", "inches"],
  unknown: ["unit", "units"]
};
function unitWords(unit, count = 1) {
  const known = unit ? UNIT_WORDS[unit] ?? Object.values(UNIT_WORDS).find(([one2]) => one2 === unit) : void 0;
  if (known) return count === 1 ? known[0] : known[1];
  const one = unit || "unit";
  return count === 1 || /s$/.test(one) ? one : `${one}s`;
}
function unitsAtPrice(count, unit, unitPrice) {
  const total = roundMoneyToCents(count * unitPrice);
  const label = `${count} ${unitWords(unit, count)} \xD7 ${formatWholeDollars(unitPrice)}`;
  return { label, total, reading: `${label} = ${formatWholeDollars(total)} a visit` };
}
function hoursWords(hours) {
  return plural(roundHoursToHundredths(hours), "hour");
}
function visitsIncluded(plan) {
  if (plan.isUnlimited) return "Unlimited visits";
  const visits = typeof plan.builtInVisits === "number" && plan.builtInVisits > 0 ? Math.round(plan.builtInVisits) : null;
  return visits !== null ? `${plural(visits, "visit")} included` : null;
}
function priceReadingOf(p) {
  if (typeof p.rate !== "number") return null;
  const price = formatWholeDollars(p.rate);
  switch (billingMethodOf(p.billingMethod)) {
    case "package" /* PACKAGE */: {
      if (p.plan?.unlimited) return `${price} for the season, unlimited visits`;
      const season = p.plan?.visits ? `${price} for a ${p.plan.visits}-visit season` : `${price} for the season`;
      return typeof p.extraVisit === "number" && p.extraVisit > 0 ? `${season} (${formatWholeDollars(p.extraVisit)} an extra visit)` : season;
    }
    case "per_hour" /* PER_HOUR */:
      return `${price} an hour${typeof p.hours === "number" && p.hours > 0 ? `, about ${hoursWords(p.hours)} a visit` : ""}`;
    case "per_visit" /* PER_VISIT */:
      return `${price} a visit`;
    default:
      return null;
  }
}
var BILLING_METHOD_WORDS = {
  ["per_visit" /* PER_VISIT */]: "per visit",
  ["per_hour" /* PER_HOUR */]: "by the hour",
  ["package" /* PACKAGE */]: "season price",
  ["consumable" /* CONSUMABLE */]: "materials used"
};
function chargedAs(method) {
  const words = BILLING_METHOD_WORDS[method];
  if (method === "package" /* PACKAGE */) return `as a ${words}`;
  if (method === "consumable" /* CONSUMABLE */) return `for ${words}`;
  return words;
}
var CHANGE_FIELD_WORDS = {
  rate: "price",
  billingMethod: "way it's charged",
  cadence: "schedule",
  subscriptionStatus: "status",
  budgetedHours: "hours a visit",
  crewName: "crew"
};
var STATUS_WORDS = {
  ["active" /* ACTIVE */]: "running",
  ["inactive" /* INACTIVE */]: "on hold",
  ["cancelled" /* CANCELLED */]: "ended",
  ["payment_pending" /* PAYMENT_PENDING */]: "waiting on payment"
};
function changeValueWords(field, value) {
  if (value === null || value === void 0 || value === "") return "none";
  switch (field) {
    case "rate":
      return typeof value === "number" ? formatWholeDollars(value) : String(value);
    case "billingMethod": {
      const method = billingMethodOf(value);
      return method ? BILLING_METHOD_WORDS[method] : String(value);
    }
    case "subscriptionStatus": {
      const status = String(value).toLowerCase();
      return status in STATUS_WORDS ? STATUS_WORDS[status] : String(value);
    }
    case "budgetedHours":
      return typeof value === "number" ? hoursWords(value) : String(value);
    default:
      return String(value);
  }
}
function changeLine(change) {
  const label = CHANGE_FIELD_WORDS[change.field] ?? change.field;
  const from = changeValueWords(change.field, change.from);
  const to = changeValueWords(change.field, change.to);
  if (change.keptOwnerEdit) return `${label}: kept your change (${from}; your file says ${to})`;
  return change.field === "rate" ? `${label} ${from} \u2192 ${to}` : `${label}: ${from} \u2192 ${to}`;
}

// src/aiImport/seasonPlan.ts
var isPositive = (n) => typeof n === "number" && Number.isFinite(n) && n > 0;
function extraVisitPriceFits(extra, seasonPrice) {
  return isPositive(extra) && !(isPositive(seasonPrice) && extra >= seasonPrice);
}
var NO_EXTRA_VISIT_PRICE_WARNING = "Your file gives this plan's season price but no per-visit rate for extra visits. Once the plan's included visits are used, Ruta won't schedule more until you set one.";
function extraVisitFields(current, plan, candidate) {
  const fits = extraVisitPriceFits(candidate, plan.seasonPrice);
  const others = (current.flags ?? []).filter((f) => !(f.field === "pricePerAdditionalVisit" && f.reason === NO_EXTRA_VISIT_PRICE_WARNING));
  const warn = !fits && isPositive(plan.seasonPrice) && isPositive(plan.visits);
  return {
    pricePerAdditionalVisit: fits ? candidate : null,
    flags: warn ? [...others, { field: "pricePerAdditionalVisit", reason: NO_EXTRA_VISIT_PRICE_WARNING, severity: "warn" }] : others
  };
}
function extraVisitPriceProblem(value, plan) {
  if (extraVisitPriceFits(value, plan.seasonPrice) || !isPositive(plan.seasonPrice) || !(value > 0)) return null;
  const season = formatWholeDollars(plan.seasonPrice);
  const included = isPositive(plan.visits) ? ` past the ${plan.visits} included` : "";
  const perVisit = isPositive(plan.visits) ? roundMoneyToCents(plan.seasonPrice / plan.visits) : null;
  const what = value === plan.seasonPrice ? `${season} is the whole season` : `${formatWholeDollars(value)} is more than the whole season (${season})`;
  const suggest = perVisit !== null && extraVisitPriceFits(perVisit, plan.seasonPrice) ? ` The season comes to ${formatWholeDollars(perVisit)} a visit.` : "";
  return `${what}, so it can't be the price of one extra visit \u2014 Ruta would bill it for every visit${included}.${suggest}`;
}

// src/aiImport/proposalPatches.ts
var CUSTOM_OPTION_ID = "custom";
var NO_PRICE_OPTION_ID = "no_price";
var CUSTOM_TEMPLATE_MARK = "~";
function subscriptionKey(clientId, index) {
  return `${clientId}:${index}`;
}
function parseSubscriptionKey(key) {
  const at = key.lastIndexOf(":");
  if (at <= 0) return null;
  const index = Number(key.slice(at + 1));
  return Number.isInteger(index) && index >= 0 ? { clientId: key.slice(0, at), index } : null;
}
var BANNED_WORDS = [
  /\bsubscriptions?\b/i,
  /\btemplates?\b/i,
  /\bbilling method\b/i,
  /per_visit/i,
  /\bpackages?\b/i,
  /\bconsumables?\b/i,
  /\bBLR\b/
];
function isPlainCopy(text) {
  return !BANNED_WORDS.some((re) => re.test(text)) && !/\$-/.test(text) && !/\$\d[\d,]*\.\d(?!\d)/.test(text);
}
var NULLABLE_FIELDS = /* @__PURE__ */ new Set([
  "rate",
  "hourlyRate",
  "budgetedHours",
  "matchedTemplateId",
  "newTemplateTempId",
  "nextDueDate",
  "packageSeasonPrice",
  "packageVisitsPerSeason"
]);
function withSet(record, set) {
  const next = { ...record };
  for (const [field, value] of Object.entries(set)) {
    if (value !== null || NULLABLE_FIELDS.has(field)) next[field] = value;
    else if (field !== "frequency") delete next[field];
  }
  return next;
}
function applyProposalPatches(proposal, patches) {
  if (patches.length === 0) return proposal;
  let customers = null;
  let templates = null;
  const customerIndex = /* @__PURE__ */ new Map();
  proposal.customers.forEach((c, i) => customerIndex.set(c.clientId, i));
  const writableCustomers = () => customers ?? (customers = [...proposal.customers]);
  const writableTemplates = () => templates ?? (templates = [...proposal.serviceTemplates]);
  for (const patch of patches) {
    switch (patch.target) {
      case "subscription": {
        const key = parseSubscriptionKey(patch.subscriptionId);
        const ci = key ? customerIndex.get(key.clientId) : void 0;
        if (!key || ci === void 0) break;
        const list = writableCustomers();
        const customer = list[ci];
        if (key.index >= customer.subscriptions.length) break;
        const subscriptions = [...customer.subscriptions];
        subscriptions[key.index] = withSet(subscriptions[key.index], patch.set);
        list[ci] = { ...customer, subscriptions };
        break;
      }
      case "customer": {
        const ci = customerIndex.get(patch.clientId);
        if (ci === void 0) break;
        const list = writableCustomers();
        list[ci] = withSet(list[ci], patch.set);
        break;
      }
      case "template": {
        const list = writableTemplates();
        const ti = list.findIndex((t) => t.tempId === patch.tempId);
        if (ti >= 0) list[ti] = withSet(list[ti], patch.set);
        break;
      }
      case "addTemplate": {
        const list = writableTemplates();
        if (!list.some((t) => t.tempId === patch.template.tempId)) list.push(patch.template);
        break;
      }
    }
  }
  return {
    ...proposal,
    customers: customers ?? proposal.customers,
    serviceTemplates: templates ?? proposal.serviceTemplates
  };
}
function subscriptionAtKey(proposal, key) {
  const parsed = parseSubscriptionKey(key);
  if (!parsed) return null;
  const customer = proposal.customers.find((c) => c.clientId === parsed.clientId);
  return customer?.subscriptions[parsed.index] ?? null;
}
function questionTemplateIds(questions) {
  const ids = /* @__PURE__ */ new Set();
  for (const q of questions ?? []) for (const option of q.options) for (const patch of option.patches) if (patch.target === "addTemplate") ids.add(patch.template.tempId);
  return ids;
}
function prunableTemplateIds(proposal) {
  const ids = questionTemplateIds(proposal.questions);
  for (const t of proposal.serviceTemplates) if (t.tempId.includes(CUSTOM_TEMPLATE_MARK)) ids.add(t.tempId);
  return ids;
}
function pruneUnusedTemplates(proposal, candidates = prunableTemplateIds(proposal)) {
  if (candidates.size === 0) return proposal;
  const used = /* @__PURE__ */ new Set();
  for (const c of proposal.customers) for (const s of c.subscriptions) if (s.newTemplateTempId) used.add(s.newTemplateTempId);
  const kept = proposal.serviceTemplates.filter((t) => !candidates.has(t.tempId) || used.has(t.tempId));
  return kept.length === proposal.serviceTemplates.length ? proposal : { ...proposal, serviceTemplates: kept };
}
function isValidCustomAmount(field, value) {
  if (!Number.isFinite(value) || value < 0) return false;
  if (field === "builtInVisits" || field === "unitCount") return Number.isInteger(value) && value >= 1;
  return true;
}
function customVariant(base, change, templates) {
  const kindKey = base.importKey ? kindKeyOfVariant(base.importKey) : void 0;
  if ("visits" in change) {
    const name = planName({ isUnlimited: false, builtInVisits: change.visits });
    const importKey2 = kindKey ? variantKey({ kindKey, billingMethod: "package" /* PACKAGE */, pricingMethod: "package" /* PACKAGE */, plans: [name] }) : void 0;
    const existing2 = importKey2 ? templates.find((t) => t.importKey === importKey2) : void 0;
    if (existing2) return existing2;
    return {
      ...base,
      tempId: `${base.tempId}${CUSTOM_TEMPLATE_MARK}v${change.visits}`,
      billingMethod: "package" /* PACKAGE */,
      packageOptions: [{ name, builtInVisits: change.visits, isUnlimitedVisits: false }],
      packageVisitsPerSeason: change.visits,
      matchedExistingId: null,
      ...importKey2 ? { importKey: importKey2 } : {},
      origin: "variant"
    };
  }
  const rate = roundMoneyToCents(change.hourlyRate);
  const importKey = kindKey ? variantKey({ kindKey, billingMethod: "per_hour" /* PER_HOUR */, pricingMethod: "per_hour" /* PER_HOUR */, hourlyRate: rate }) : void 0;
  const existing = importKey ? templates.find((t) => t.importKey === importKey) : void 0;
  if (existing) return existing;
  return {
    ...base,
    tempId: `${base.tempId}${CUSTOM_TEMPLATE_MARK}h${keyAmount(rate)}`,
    hourlyRate: rate,
    matchedExistingId: null,
    ...importKey ? { importKey } : {},
    origin: "variant"
  };
}
function seasonPlanOf(proposal, sub) {
  const template = proposal.serviceTemplates.find((t) => t.tempId === sub.newTemplateTempId);
  const plan = template?.packageOptions?.find((o) => o.name === sub.packageOptionName) ?? template?.packageOptions?.[0];
  const visits = plan ? plan.isUnlimitedVisits ? null : plan.builtInVisits : template?.packageVisitsPerSeason ?? null;
  return { seasonPrice: typeof sub.rate === "number" ? sub.rate : null, visits: typeof visits === "number" && visits > 0 ? visits : null, unlimited: plan?.isUnlimitedVisits ?? false };
}
function typedReading(sub, set, plan) {
  const next = { ...sub, ...set };
  return priceReadingOf({ billingMethod: next.billingMethod, rate: next.rate, plan, extraVisit: next.pricePerAdditionalVisit, hours: next.budgetedHours });
}
function customAmountProblem(proposal, question, value) {
  const spec = question.customAmount;
  if (spec?.field !== "pricePerAdditionalVisit") return null;
  for (const subject of question.subjects) {
    const sub = subject.subscriptionId ? subscriptionAtKey(proposal, subject.subscriptionId) : null;
    if (!sub || sub.billingMethod.toLowerCase() !== "package" /* PACKAGE */) continue;
    const problem = extraVisitPriceProblem(value, seasonPlanOf(proposal, sub));
    if (problem) return problem;
  }
  return null;
}
function customAmountPatches(proposal, question, value) {
  const spec = question.customAmount;
  if (!spec || !isValidCustomAmount(spec.field, value)) return [];
  const patches = [];
  for (const subject of question.subjects) {
    const key = subject.subscriptionId;
    const sub = key ? subscriptionAtKey(proposal, key) : null;
    if (!key || !sub) continue;
    const season = sub.billingMethod.toLowerCase() === "package" /* PACKAGE */ ? seasonPlanOf(proposal, sub) : null;
    if (spec.field === "pricePerAdditionalVisit") {
      const set = season ? extraVisitFields(sub, season, value) : { pricePerAdditionalVisit: value };
      patches.push({ target: "subscription", subscriptionId: key, set: { ...set, priceReading: typedReading(sub, set, season) } });
      continue;
    }
    if (spec.field === "rate") {
      const extra2 = season && typeof sub.pricePerAdditionalVisit === "number" ? extraVisitFields(sub, { ...season, seasonPrice: value }, sub.pricePerAdditionalVisit) : {};
      const set = { rate: value, ...extra2 };
      patches.push({ target: "subscription", subscriptionId: key, set: { ...set, priceReading: typedReading(sub, set, season) } });
      continue;
    }
    if (spec.field === "unitCount") {
      if (typeof spec.unitPrice !== "number" || !(spec.unitPrice > 0)) continue;
      const { label, total, reading } = unitsAtPrice(value, spec.unit, spec.unitPrice);
      patches.push({ target: "subscription", subscriptionId: key, set: { rate: total, rateBreakdown: [{ label, amount: total }], priceReading: reading } });
      continue;
    }
    const base = proposal.serviceTemplates.find((t) => t.tempId === sub.newTemplateTempId);
    if (!base) continue;
    const method = sub.billingMethod.toLowerCase();
    if (spec.field === "hourlyRate") {
      if (method !== "per_hour" /* PER_HOUR */) continue;
      const variant2 = customVariant(base, { hourlyRate: value }, proposal.serviceTemplates);
      const set = { rate: roundMoneyToCents(value), newTemplateTempId: variant2.tempId };
      patches.push({ target: "addTemplate", template: variant2 }, { target: "subscription", subscriptionId: key, set: { ...set, priceReading: typedReading(sub, set, null) } });
      continue;
    }
    if (method !== "package" /* PACKAGE */) continue;
    const variant = customVariant(base, { visits: value }, proposal.serviceTemplates);
    const plan = variant.packageOptions?.[0]?.name ?? `${value} visits`;
    const candidate = typeof sub.pricePerAdditionalVisit === "number" && sub.pricePerAdditionalVisit > 0 ? sub.pricePerAdditionalVisit : typeof sub.rate === "number" ? roundMoneyToCents(sub.rate / value) : null;
    const extra = extraVisitFields(sub, { seasonPrice: sub.rate, visits: value }, candidate);
    patches.push(
      { target: "addTemplate", template: variant },
      {
        target: "subscription",
        subscriptionId: key,
        set: { newTemplateTempId: variant.tempId, matchedTemplateId: null, packageOptionName: plan, ...extra, priceReading: typedReading(sub, extra, { visits: value }) }
      }
    );
  }
  return patches;
}
function answerQuestion(proposal, questionId, optionId, options) {
  const question = proposal.questions?.find((q) => q.id === questionId);
  const option = question?.options.find((o) => o.id === optionId);
  if (!question || !option) return proposal;
  const { customValue, answeredAt } = options;
  const custom = typeof customValue === "number" && question.customAmount && isValidCustomAmount(question.customAmount.field, customValue) ? customValue : void 0;
  let next = applyProposalPatches(proposal, option.patches);
  if (custom !== void 0) next = applyProposalPatches(next, customAmountPatches(next, question, custom));
  next = pruneUnusedTemplates(next);
  return {
    ...next,
    questions: (next.questions ?? []).map((q) => q.id === questionId ? { ...q, answer: { optionId, ...custom !== void 0 ? { customValue: custom } : {}, answeredAt } } : q)
  };
}
function applyAnswers(proposal, questions, answers = /* @__PURE__ */ new Map(), alsoPrunable = /* @__PURE__ */ new Set()) {
  let next = proposal;
  const stamped = [];
  for (const q of questions) {
    const stored = answers.get(q.id);
    const answered = stored ? q.options.find((o) => o.id === stored.optionId) : void 0;
    const safe = q.severity === "blocking" ? q.options.find((o) => o.id === NO_PRICE_OPTION_ID) : void 0;
    const option = answered ?? safe ?? q.options.find((o) => o.recommended);
    if (option) next = applyProposalPatches(next, option.patches);
    let answer;
    if (answered && stored) {
      const custom = typeof stored.customValue === "number" && q.customAmount && isValidCustomAmount(q.customAmount.field, stored.customValue) ? stored.customValue : void 0;
      if (custom !== void 0) next = applyProposalPatches(next, customAmountPatches(next, q, custom));
      answer = { optionId: stored.optionId, ...custom !== void 0 ? { customValue: custom } : {}, answeredAt: stored.answeredAt };
    }
    stamped.push(answer ? { ...q, answer } : q);
  }
  const withQuestions = { ...next, questions: stamped };
  const pruned = pruneUnusedTemplates(withQuestions, /* @__PURE__ */ new Set([...prunableTemplateIds(withQuestions), ...alsoPrunable]));
  return markAsked(pruned, stamped);
}
function markAsked(proposal, questions) {
  const ids = /* @__PURE__ */ new Map();
  for (const q of questions) for (const s of q.subjects) if (s.subscriptionId) ids.set(s.subscriptionId, [...ids.get(s.subscriptionId) ?? [], q.id]);
  if (ids.size === 0) return proposal;
  return {
    ...proposal,
    customers: proposal.customers.map((c) => {
      let changed = false;
      const subscriptions = c.subscriptions.map((s, i) => {
        const asked = ids.get(subscriptionKey(c.clientId, i));
        if (!asked) return s;
        changed = true;
        return { ...s, questionIds: [.../* @__PURE__ */ new Set([...s.questionIds ?? [], ...asked])] };
      });
      return changed ? { ...c, subscriptions } : c;
    })
  };
}

// src/helpers/packageChargeRevenue.ts
var PACKAGE_CHARGE_LEDGER_SOURCE = "package_charge";
var PACKAGE_INVOICE_ID_PATTERN = /package-[A-Za-z0-9_-]+-\d{4}(?:-r[A-Za-z0-9]+)?/;
function textContainsPackageInvoiceId(text) {
  return extractPackageInvoiceId(text) != null;
}
function extractPackageInvoiceId(text) {
  if (!text) return void 0;
  const match = text.match(PACKAGE_INVOICE_ID_PATTERN);
  return match?.[0];
}
var VOIDED_PACKAGE_DEBIT_PREFIX = "Cancelled on deactivation: ";
var VOIDED_PACKAGE_DEBIT_PREFIX_RE = /^Cancelled on deactivation:\s*/i;
function isRawPackageChargeLedgerDescription(description) {
  const rest = (description ?? "").replace(VOIDED_PACKAGE_DEBIT_PREFIX_RE, "").trim();
  return /^Package charge /i.test(rest) && textContainsPackageInvoiceId(rest);
}
function subscriptionIdFromPackageInvoiceId(invoiceId) {
  if (!invoiceId) return void 0;
  const match = invoiceId.match(
    /^package-(.+)-(\d{4})(?:-r[A-Za-z0-9]+)?$/
  );
  return match?.[1];
}
function isPackagePaymentLedgerEntry(entry, knownPackagePaymentIds) {
  if (entry.type !== "payment" /* PAYMENT */ && entry.type !== "payment") {
    return false;
  }
  if (entry.source === PACKAGE_CHARGE_LEDGER_SOURCE) return true;
  if (entry.paymentId && knownPackagePaymentIds?.has(entry.paymentId)) {
    return true;
  }
  return textContainsPackageInvoiceId(entry.notes) || textContainsPackageInvoiceId(entry.description);
}
function isPackageRefundLedgerEntry(entry, knownPackagePaymentIds) {
  const type = entry.type;
  if (type !== "refund" /* REFUND */ && type !== "refund" && type !== "credit" /* CREDIT */ && type !== "credit") {
    return false;
  }
  if (entry.visitId) return false;
  if (entry.source === PACKAGE_CHARGE_LEDGER_SOURCE) return true;
  if (entry.paymentId && knownPackagePaymentIds?.has(entry.paymentId)) {
    return true;
  }
  return textContainsPackageInvoiceId(entry.notes) || textContainsPackageInvoiceId(entry.description);
}
function packagePaymentRevenueAmount(amount) {
  if (amount == null || !Number.isFinite(amount)) return 0;
  return Math.abs(amount);
}
function packagePaymentProcessingFee(processingFees) {
  const fee = processingFees?.totalFee;
  if (fee == null || !Number.isFinite(fee) || fee <= 0) return 0;
  return roundCurrency(fee);
}
function resolvePackageTemplateIdFromMaps(entry, templateIdByPaymentId, templateIdBySubscriptionId) {
  const paymentId = typeof entry.paymentId === "string" ? entry.paymentId : void 0;
  if (paymentId) {
    const byPayment = templateIdByPaymentId?.get(paymentId);
    if (byPayment) return byPayment;
  }
  const invoice = extractPackageInvoiceId(entry.notes) ?? extractPackageInvoiceId(entry.description);
  const subscriptionId = subscriptionIdFromPackageInvoiceId(invoice);
  if (subscriptionId) {
    return templateIdBySubscriptionId?.get(subscriptionId);
  }
  return void 0;
}
function packageTemplateMapsFromSubscriptions(subscriptions) {
  const templateIdByPaymentId = /* @__PURE__ */ new Map();
  const templateIdBySubscriptionId = /* @__PURE__ */ new Map();
  const templateIdByRefundId = /* @__PURE__ */ new Map();
  const templateIdsByCustomerId = /* @__PURE__ */ new Map();
  for (const item of subscriptions) {
    if (!item.serviceTemplateId) continue;
    if (item.packageChargePaymentId) {
      templateIdByPaymentId.set(
        item.packageChargePaymentId,
        item.serviceTemplateId
      );
    }
    if (item.id) {
      templateIdBySubscriptionId.set(item.id, item.serviceTemplateId);
    }
    if (item.packageRefundId) {
      templateIdByRefundId.set(item.packageRefundId, item.serviceTemplateId);
    }
    if (item.customerId && (item.packageChargePaymentId || item.packageRefundId || item.packageRefundedAt)) {
      const ids = templateIdsByCustomerId.get(item.customerId) ?? /* @__PURE__ */ new Set();
      ids.add(item.serviceTemplateId);
      templateIdsByCustomerId.set(item.customerId, ids);
    }
  }
  const templateIdByCustomerId = /* @__PURE__ */ new Map();
  for (const [customerId, ids] of templateIdsByCustomerId) {
    if (ids.size === 1) templateIdByCustomerId.set(customerId, [...ids][0]);
  }
  return {
    templateIdByPaymentId,
    templateIdBySubscriptionId,
    templateIdByRefundId,
    templateIdByCustomerId
  };
}
function resolvePackageRefundTemplateIdFromMaps(entry, maps) {
  const byPaymentOrInvoice = resolvePackageTemplateIdFromMaps(
    entry,
    maps.templateIdByPaymentId,
    maps.templateIdBySubscriptionId
  );
  if (byPaymentOrInvoice) return byPaymentOrInvoice;
  if (entry.refundId) {
    const byRefund = maps.templateIdByRefundId?.get(entry.refundId);
    if (byRefund) return byRefund;
  }
  if (entry.customerId) {
    return maps.templateIdByCustomerId?.get(entry.customerId);
  }
  return void 0;
}

// src/utils/ledgerActivityDisplay.ts
var KIND = {
  debit: "Charge",
  adjustment: "Charge",
  payment: "Payment",
  refund: "Refund",
  credit: "Credit",
  credit_applied: "Credit applied"
};
function isLedgerRefundType(type) {
  return type.toLowerCase() === "refund";
}
function ledgerDisplaySignedAmount(entry) {
  return isLedgerRefundType(entry.type) ? Math.abs(entry.amount) : entry.amount;
}
function ledgerActivityKind(type) {
  const normalized = type.toLowerCase();
  if (KIND[normalized]) return KIND[normalized];
  return normalized.charAt(0).toUpperCase() + normalized.slice(1).replace(/_/g, " ");
}
function packageChargeActivityDescription(description, hint) {
  const raw = (description ?? "").trim();
  if (!isRawPackageChargeLedgerDescription(raw)) return raw;
  const label = packageChargeLedgerDescription(
    hint.customerName,
    hint.templateName,
    hint.planName
  );
  if (!label) return raw;
  return raw.startsWith(VOIDED_PACKAGE_DEBIT_PREFIX) ? `${VOIDED_PACKAGE_DEBIT_PREFIX}${label}` : label;
}
function hintForPackageChargeEntry(entry, context) {
  const invoiceId = extractPackageInvoiceId(entry.notes) ?? extractPackageInvoiceId(entry.description);
  const byId = invoiceId ? context?.packageChargeByInvoiceId?.[invoiceId] : void 0;
  return {
    customerName: byId?.customerName ?? context?.customerName,
    templateName: byId?.templateName,
    planName: byId?.planName
  };
}
function ledgerActivityDescription(entry, context) {
  const labeled = packageChargeActivityDescription(
    entry.description,
    hintForPackageChargeEntry(entry, context)
  );
  if (!isLedgerRefundType(entry.type)) return labeled;
  const voided = /^void:\s*/i.test(labeled);
  const rest = labeled.replace(/^(refund|void):\s*/i, "");
  const prefix = voided ? "Void to card" : "Refund to card";
  return rest ? `${prefix}: ${rest}` : prefix;
}
function withLedgerActivityDisplay(entries, context) {
  return entries.map((entry) => {
    const signedAmount = ledgerDisplaySignedAmount(entry);
    return {
      ...entry,
      kind: ledgerActivityKind(entry.type),
      displayDescription: ledgerActivityDescription(entry, context),
      signedAmount,
      reducesBalance: signedAmount < 0,
      displayBalanceAfter: entry.balanceAfter
    };
  });
}

// src/utils/taxFiling.ts
var DEFAULT_MN_LOCATION_NUMBER = "001";
function normalizeMnLocationNumber(value) {
  const digits = (value ?? "").replace(/\D/g, "").slice(0, 3);
  if (!digits) return DEFAULT_MN_LOCATION_NUMBER;
  return digits.padStart(3, "0");
}
function taxFilingSettingsWritePayload(settings, opts) {
  const includePaid = opts?.includePaidPeriods !== false;
  return {
    cadence: settings.cadence,
    dueDay: settings.dueDay,
    ...settings.state ? { state: settings.state } : {},
    ...settings.mnLocationNumber ? { mnLocationNumber: normalizeMnLocationNumber(settings.mnLocationNumber) } : {},
    ...includePaid && settings.paidPeriods ? { paidPeriods: settings.paidPeriods } : {}
  };
}
var ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;
function pad22(n) {
  return n < 10 ? `0${n}` : String(n);
}
function toIsoDate(y, m0, d) {
  return `${y}-${pad22(m0 + 1)}-${pad22(d)}`;
}
function parseIsoDate(iso) {
  if (!ISO_DATE.test(iso)) throw new Error(`Invalid ISO date: ${iso}`);
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d);
}
function formatIsoDate(date) {
  return toIsoDate(date.getFullYear(), date.getMonth(), date.getDate());
}
function nextBusinessDay(isoDate) {
  const d = parseIsoDate(isoDate);
  const day = d.getDay();
  if (day === 6) d.setDate(d.getDate() + 2);
  else if (day === 0) d.setDate(d.getDate() + 1);
  return formatIsoDate(d);
}
function clampDueDay(dueDay) {
  if (!Number.isFinite(dueDay)) return 20;
  return Math.min(28, Math.max(1, Math.floor(dueDay)));
}
function dueDateForPeriodEnd(periodEndIso, dueDay) {
  const end = parseIsoDate(periodEndIso);
  const nextMonth = new Date(end.getFullYear(), end.getMonth() + 1, 1);
  const day = clampDueDay(dueDay);
  const calendar = new Date(nextMonth.getFullYear(), nextMonth.getMonth(), day);
  const calendarDueDate = formatIsoDate(calendar);
  return { calendarDueDate, dueDate: nextBusinessDay(calendarDueDate) };
}
function periodBounds(cadence, year, monthOrQuarter) {
  if (cadence === "monthly") {
    const m0 = monthOrQuarter - 1;
    const start = toIsoDate(year, m0, 1);
    const end = formatIsoDate(new Date(year, m0 + 1, 0));
    return { id: `${year}-${pad22(monthOrQuarter)}`, periodStart: start, periodEnd: end };
  }
  if (cadence === "quarterly") {
    const q = monthOrQuarter;
    const startMonth0 = (q - 1) * 3;
    const start = toIsoDate(year, startMonth0, 1);
    const end = formatIsoDate(new Date(year, startMonth0 + 3, 0));
    return { id: `${year}-Q${q}`, periodStart: start, periodEnd: end };
  }
  return {
    id: String(year),
    periodStart: toIsoDate(year, 0, 1),
    periodEnd: toIsoDate(year, 11, 31)
  };
}
function listTaxFilingPeriods(settings, asOfIso, lookback = 6) {
  const asOf = parseIsoDate(asOfIso);
  const dueDay = clampDueDay(settings.dueDay);
  const periods = [];
  if (settings.cadence === "monthly") {
    let y = asOf.getFullYear();
    let m = asOf.getMonth() + 1;
    for (let i = 0; i < lookback + 1; i++) {
      const b = periodBounds("monthly", y, m);
      periods.push(buildPeriod("monthly", b, dueDay, asOfIso));
      m -= 1;
      if (m < 1) {
        m = 12;
        y -= 1;
      }
    }
  } else if (settings.cadence === "quarterly") {
    let y = asOf.getFullYear();
    let q = Math.floor(asOf.getMonth() / 3) + 1;
    for (let i = 0; i < lookback + 1; i++) {
      const b = periodBounds("quarterly", y, q);
      periods.push(buildPeriod("quarterly", b, dueDay, asOfIso));
      q -= 1;
      if (q < 1) {
        q = 4;
        y -= 1;
      }
    }
  } else {
    let y = asOf.getFullYear();
    for (let i = 0; i < lookback + 1; i++) {
      const b = periodBounds("annual", y, 1);
      periods.push(buildPeriod("annual", b, dueDay, asOfIso));
      y -= 1;
    }
  }
  return periods.sort((a, b) => a.periodEnd < b.periodEnd ? 1 : -1);
}
function buildPeriod(cadence, b, dueDay, asOfIso) {
  const { calendarDueDate, dueDate } = dueDateForPeriodEnd(b.periodEnd, dueDay);
  const isClosed = asOfIso > b.periodEnd;
  const isPastDue = isClosed && asOfIso >= dueDate;
  return {
    id: b.id,
    cadence,
    periodStart: b.periodStart,
    periodEnd: b.periodEnd,
    calendarDueDate,
    dueDate,
    isClosed,
    isPastDue
  };
}
function latestReadyPeriod(settings, asOfIso) {
  const periods = listTaxFilingPeriods(settings, asOfIso, 3);
  return periods.find((p) => p.isClosed) ?? null;
}
function isPeriodPaid(settings, periodId) {
  return Boolean(settings.paidPeriods?.[periodId]?.paidAt);
}
function unpaidClosedPeriods(settings, asOfIso, lookback = 6) {
  return listTaxFilingPeriods(settings, asOfIso, lookback).filter(
    (p) => p.isClosed && !isPeriodPaid(settings, p.id)
  );
}
function formatTaxFilingPeriodLabel(period, month = "short") {
  if (period.cadence === "monthly") {
    const [y, m] = period.periodStart.split("-").map(Number);
    return new Date(y, m - 1, 1).toLocaleDateString("en-US", { month, year: "numeric" });
  }
  if (period.cadence === "quarterly") {
    const parts = period.id.split("-Q");
    return parts.length === 2 ? `Q${parts[1]} ${parts[0]}` : period.id;
  }
  return period.id;
}
function withPeriodPaid(settings, periodId, paidAtIso) {
  return {
    ...settings,
    paidPeriods: {
      ...settings.paidPeriods ?? {},
      [periodId]: { paidAt: paidAtIso }
    }
  };
}
function withPeriodUnpaid(settings, periodId) {
  if (!settings.paidPeriods?.[periodId]) return settings;
  const paidPeriods = { ...settings.paidPeriods };
  delete paidPeriods[periodId];
  return {
    ...settings,
    paidPeriods: Object.keys(paidPeriods).length > 0 ? paidPeriods : void 0
  };
}

// src/utils/mnSalesTaxExport.ts
var MN_GENERAL_RATE_TAX_TYPE = "100";
var MN_ESERVICES_FILE_FORMATS_URL = "https://www.revenue.state.mn.us/sales-tax-file-formats";
var MN_ESERVICES_LOCATION_INFO_URL = "https://www.revenue.state.mn.us/manage-location-information";
var MN_MONTH_MMM = [
  "jan",
  "feb",
  "mar",
  "apr",
  "may",
  "jun",
  "jul",
  "aug",
  "sep",
  "oct",
  "nov",
  "dec"
];
function roundMnWholeDollars(amount) {
  if (!Number.isFinite(amount)) return 0;
  return Math.round(amount);
}
function formatMnFilingPeriodEnd(periodEndIso) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(periodEndIso);
  if (!match) {
    throw new Error(`Invalid ISO date for MN filing period: ${periodEndIso}`);
  }
  const year = match[1];
  const month = Number(match[2]);
  const day = Number(match[3]);
  if (month < 1 || month > 12 || day < 1 || day > 31) {
    throw new Error(`Invalid ISO date for MN filing period: ${periodEndIso}`);
  }
  return `${String(day).padStart(2, "0")}-${MN_MONTH_MMM[month - 1]}-${year}`;
}
function mnEservicesAmountsFromRevenue(totals) {
  return {
    grossReceipts: totals.totalTaxableSubtotal + totals.totalNonTaxableSubtotal,
    taxableUnits: totals.totalTaxableSubtotal,
    taxDue: totals.totalTax
  };
}
function csvCell(value) {
  return String(value);
}
function buildMnEservicesSalesTaxCsv(input) {
  if (input.returnKind !== "O" && input.returnKind !== "A") {
    throw new Error("MN return kind must be O (Original) or A (Amend)");
  }
  const locationNumber = normalizeMnLocationNumber(input.locationNumber);
  const periodEndDisplay = formatMnFilingPeriodEnd(input.periodEndIso);
  const wholeDollars = {
    grossReceipts: roundMnWholeDollars(input.grossReceipts),
    taxableUnits: roundMnWholeDollars(input.taxableUnits),
    taxDue: roundMnWholeDollars(input.taxDue)
  };
  const rowLabel = (input.rowLabel ?? "Ruta").replace(/,/g, " ");
  const lines = [
    [csvCell(rowLabel), "FILING PERIOD", "AMEND/ORIG"].join(","),
    [csvCell(rowLabel), periodEndDisplay, input.returnKind].join(","),
    [csvCell(rowLabel), "LOCATION", "RECEIPTS", "TAX TYPE", "TAXABLE", "TAX DUE"].join(","),
    [
      csvCell(`LOC-${locationNumber}`),
      locationNumber,
      wholeDollars.grossReceipts,
      MN_GENERAL_RATE_TAX_TYPE,
      wholeDollars.taxableUnits,
      wholeDollars.taxDue
    ].join(",")
  ];
  return {
    csv: `${lines.join("\n")}
`,
    filename: `mn-eservices-sales-tax-${input.periodEndIso}-${input.returnKind}.csv`,
    locationNumber,
    periodEndDisplay,
    returnKind: input.returnKind,
    wholeDollars
  };
}

// src/utils/holidaySchedule.ts
var DEFAULT_HOLIDAY_WARNING_DAYS = 7;
function findHolidaysToWarnAbout(holidays, today, daysAhead = DEFAULT_HOLIDAY_WARNING_DAYS) {
  if (!isCalendarDate(today)) {
    throw new Error(`Expected a YYYY-MM-DD date, received "${today}"`);
  }
  const target = addCalendarDays(today, daysAhead);
  return holidays.filter((holiday) => holiday.date === target);
}
function formatHolidayDate(date) {
  if (!isCalendarDate(date)) return date;
  return (/* @__PURE__ */ new Date(`${date}T00:00:00Z`)).toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
    timeZone: "UTC"
  });
}

// src/utils/subscriptionStateUtils.ts
function isActiveService(status) {
  return status === "active" /* ACTIVE */;
}
function isInactiveService(status) {
  return status === "inactive" /* INACTIVE */;
}
function isPendingStartStatus(entity) {
  const date = entity.scheduledActivationDate?.trim();
  if (!date) return false;
  if (entity.subscriptionStatus !== "inactive" /* INACTIVE */) return false;
  if (entity.deactivatedAt) return false;
  const today = getDateInTimezone((/* @__PURE__ */ new Date()).toISOString(), DEFAULT_DISPLAY_TIMEZONE);
  return date >= today;
}
function isNextVisitCleared(entity) {
  return !!entity.nextVisitClearedAt && entity.subscriptionStatus === "inactive" /* INACTIVE */ && !entity.scheduledActivationDate && !entity.pausedAt && !entity.deactivatedAt;
}
function isPausedService(entity) {
  return !!entity.pausedAt && entity.subscriptionStatus === "inactive" /* INACTIVE */ && !entity.deactivatedAt;
}
function shouldShowScheduledDeactivation(entity, now = /* @__PURE__ */ new Date()) {
  if (entity.subscriptionStatus !== "active" /* ACTIVE */) return false;
  return resolveDeactivationBanner(entity, now)?.kind === "scheduled";
}
function isAwaitingStop(entity) {
  return entity.subscriptionStatus === "active" /* ACTIVE */ || entity.subscriptionStatus === "inactive" /* INACTIVE */ && !entity.deactivatedAt && !!(entity.pausedAt || entity.pausedUntil);
}
function scheduledStopOf(entity, today) {
  const date = entity.deactivationDate?.trim().slice(0, 10);
  if (!date || date < today) return null;
  if (!entity.subscriptionStatus) return date;
  return isAwaitingStop(entity) ? date : null;
}
function resolveDeactivationBanner(entity, now = /* @__PURE__ */ new Date()) {
  const date = entity.deactivationDate?.trim().slice(0, 10);
  if (!date) return null;
  const today = getDateInTimezone(now.toISOString(), DEFAULT_DISPLAY_TIMEZONE);
  const scheduled = scheduledStopOf(entity, today);
  if (scheduled) return { kind: "scheduled", date: scheduled };
  const status = entity.subscriptionStatus;
  if (!status) {
    return { kind: "deactivated", date };
  }
  if (isAwaitingStop(entity)) {
    return null;
  }
  if (!entity.deactivatedAt) {
    return date < today ? { kind: "deactivated", date } : null;
  }
  const stampedDay = getDateInTimezone(entity.deactivatedAt, DEFAULT_DISPLAY_TIMEZONE);
  return { kind: "deactivated", date: stampedDay < date ? stampedDay : date };
}
function isRateVisible(visibility) {
  return visibility === "visible" /* VISIBLE */;
}
function isRateInvisible(visibility) {
  return visibility === "invisible" /* INVISIBLE */;
}
function isBillableService(status, visibility) {
  return status === "active" /* ACTIVE */ && visibility === "visible" /* VISIBLE */;
}
function requiresPaymentMethod(status) {
  return status === "active" /* ACTIVE */;
}
function filterActiveSubscriptions(subscriptions) {
  return subscriptions.filter((sub) => isActiveService(sub.subscriptionStatus));
}
function filterInactiveSubscriptions(subscriptions) {
  return subscriptions.filter(
    (sub) => isInactiveService(sub.subscriptionStatus)
  );
}
function countActiveSubscriptions(subscriptions) {
  return filterActiveSubscriptions(subscriptions).length;
}
function countInactiveSubscriptions(subscriptions) {
  return filterInactiveSubscriptions(subscriptions).length;
}
function getSubscriptionDescription(status, visibility, hasRate, isAccepted) {
  if (status === "active" /* ACTIVE */) {
    if (visibility === "visible" /* VISIBLE */) {
      return "Service is active and being provided (REQUIRES PAYMENT)";
    }
    return "Service is active but rate is hidden from customer";
  }
  if (visibility === "invisible" /* INVISIBLE */) {
    if (hasRate) {
      return "Rate configured but not yet visible to customer";
    }
    return "Service requested, awaiting rate configuration";
  }
  if (isAccepted) {
    return "Customer accepted rate, service ready for activation";
  }
  return "Rate visible to customer, awaiting acceptance";
}
function isPendingService(status, visibility) {
  return status === "inactive" /* INACTIVE */ && visibility === "invisible" /* INVISIBLE */;
}
function isAwaitingCustomerAction(status, visibility, isAccepted) {
  return status === "inactive" /* INACTIVE */ && visibility === "visible" /* VISIBLE */ && !isAccepted;
}
function hasPricedRate(service) {
  if (!service) return false;
  if (service.rate == null) return false;
  if (service.rate > 0) return true;
  return (service.rateBreakdown?.length ?? 0) > 0;
}
function isRateReadyForCustomer(service) {
  if (!service) return false;
  if (isPausedService(service)) return false;
  if (isNextVisitCleared({
    subscriptionStatus: service.subscriptionStatus ?? void 0,
    nextVisitClearedAt: service.nextVisitClearedAt ?? void 0,
    scheduledActivationDate: service.scheduledActivationDate ?? void 0,
    pausedAt: service.pausedAt ?? void 0,
    deactivatedAt: service.deactivatedAt ?? void 0
  })) return false;
  return isAwaitingCustomerAction(
    service.subscriptionStatus,
    service.rateVisibility,
    service.isAccepted ?? void 0
  ) && hasPricedRate(service);
}

// src/utils/subscriptionStateMapping.ts
function generateCompositeStateKey(subscriptionStatus, rateVisibility) {
  return `SUBSCRIPTION_STATUS#${subscriptionStatus}#RATE_VISIBILITY#${rateVisibility}`;
}

// src/utils/fractionalRanking.ts
var FractionalRanking = class {
  /**
   * Generates a rank between two given ranks.
   * If no ranks are provided, generates an initial rank.
   * If only prevRank is provided, generates a rank after it.
   * If only nextRank is provided, generates a rank before it.
   */
  static generateRankBetween(prevRank, nextRank) {
    const prev = prevRank || "";
    const next = nextRank || "";
    if (!prev && !next) {
      return this.MID_CHAR;
    }
    if (!prev) {
      return this.decrementRank(next);
    }
    if (!next) {
      return this.incrementRank(prev);
    }
    return this.calculateMidpoint(prev, next);
  }
  /**
   * Decrements a rank to generate a rank that comes before it.
   * Uses base-36 decrement: 'a' wraps to '9', '0' borrows from previous position.
   */
  static decrementRank(rank) {
    const parts = rank.split("");
    let i = parts.length - 1;
    while (i >= 0) {
      const value = this.charToValue(parts[i]);
      if (value > 0) {
        parts[i] = this.valueToChar(value - 1);
        break;
      }
      parts[i] = this.MAX_CHAR;
      i--;
    }
    if (i < 0) {
      return this.MIN_CHAR + parts.join("");
    }
    return parts.join("");
  }
  /**
   * Increments a rank to generate a rank that comes after it.
   * Uses base-36 increment: '9' wraps to 'a', 'z' carries to previous position.
   */
  static incrementRank(rank) {
    const parts = rank.split("");
    let i = parts.length - 1;
    while (i >= 0) {
      const value = this.charToValue(parts[i]);
      if (value < this.BASE_36 - 1) {
        parts[i] = this.valueToChar(value + 1);
        return parts.join("");
      }
      parts[i] = this.MIN_CHAR;
      i--;
    }
    return rank + "1";
  }
  /**
   * Calculates the midpoint between two ranks
   */
  static calculateMidpoint(prev, next) {
    if (prev >= next) {
      throw new Error(
        `Invalid rank order: ${prev} should be less than ${next}`
      );
    }
    const maxLength = Math.max(prev.length, next.length) + 1;
    const paddedPrev = prev.padEnd(maxLength, this.MIN_CHAR);
    const paddedNext = next.padEnd(maxLength, this.MIN_CHAR);
    const result = [];
    let carry = 0;
    for (let i = 0; i < maxLength; i++) {
      const prevCode = this.charToValue(paddedPrev[i]);
      const nextCode = this.charToValue(paddedNext[i]);
      const sum = prevCode + nextCode + carry;
      const mid = Math.floor(sum / 2);
      result.push(this.valueToChar(mid % this.BASE_36));
      carry = sum % 2 * this.BASE_36;
    }
    let resultStr = result.join("");
    while (resultStr.length > 5 && resultStr.endsWith(this.MIN_CHAR)) {
      resultStr = resultStr.slice(0, -1);
    }
    if (resultStr <= prev || resultStr >= next) {
      return prev + this.MID_CHAR[0];
    }
    return resultStr;
  }
  /**
   * Converts a character to its base-36 value
   */
  static charToValue(char) {
    if (!char) return 0;
    const code = char.charCodeAt(0);
    if (code >= 48 && code <= 57) {
      return code - 48;
    }
    if (code >= 97 && code <= 122) {
      return code - 97 + 10;
    }
    if (code >= 65 && code <= 90) {
      return code - 65 + 10;
    }
    return 0;
  }
  /**
   * Converts a base-36 value to its character representation
   */
  static valueToChar(value) {
    if (value < 0 || value >= this.BASE_36) {
      throw new Error(`Value ${value} out of base-36 range`);
    }
    if (value < 10) {
      return String.fromCharCode(48 + value);
    } else {
      return String.fromCharCode(97 + value - 10);
    }
  }
  /**
   * Checks if rebalancing is needed based on rank density
   */
  static needsRebalancing(ranks) {
    if (ranks.length < 2) return false;
    const hasLongRanks = ranks.some((rank) => rank.length > 20);
    if (hasLongRanks) return true;
    const sorted = [...ranks].sort();
    for (let i = 1; i < sorted.length; i++) {
      const gap = this.compareRanks(sorted[i], sorted[i - 1]);
      if (gap < 1e-3) return true;
    }
    return false;
  }
  /**
   * Rebalances ranks to have even spacing
   */
  static rebalanceRanks(count) {
    if (count <= 0) return [];
    if (count === 1) return [this.MID_CHAR];
    const ranks = [];
    const step = 1 / (count + 1);
    for (let i = 1; i <= count; i++) {
      const position = step * i;
      ranks.push(this.positionToRank(position));
    }
    return ranks;
  }
  /**
   * Converts a decimal position (0-1) to a rank string
   */
  static positionToRank(position) {
    if (position <= 0) return this.MIN_CHAR;
    if (position >= 1) return this.MAX_CHAR;
    let result = "";
    let remaining = position;
    for (let i = 0; i < 5; i++) {
      remaining *= this.BASE_36;
      const digit = Math.floor(remaining);
      result += this.valueToChar(digit);
      remaining -= digit;
      if (remaining < 1e-3) break;
    }
    return result || this.MIN_CHAR;
  }
  /**
   * Validates that a rank string is valid
   */
  static isValidRank(rank) {
    if (!rank || rank.length === 0) return false;
    for (const char of rank) {
      const code = char.charCodeAt(0);
      const isDigit = code >= 48 && code <= 57;
      const isLowercase = code >= 97 && code <= 122;
      const isUppercase = code >= 65 && code <= 90;
      if (!isDigit && !isLowercase && !isUppercase) {
        return false;
      }
    }
    return true;
  }
  /**
   * Compares two ranks numerically
   * Returns negative if a < b, positive if a > b, 0 if equal
   */
  static compareRanks(a, b) {
    if (a === b) return 0;
    return a < b ? -1 : 1;
  }
};
FractionalRanking.BASE_36 = 36;
FractionalRanking.MIN_CHAR = "0";
FractionalRanking.MAX_CHAR = "z";
FractionalRanking.MID_CHAR = "h0000";
var generateRankBetween = FractionalRanking.generateRankBetween.bind(FractionalRanking);
var needsRebalancing = FractionalRanking.needsRebalancing.bind(FractionalRanking);
var rebalanceRanks = FractionalRanking.rebalanceRanks.bind(FractionalRanking);
var isValidRank = FractionalRanking.isValidRank.bind(FractionalRanking);
var compareRanks = FractionalRanking.compareRanks.bind(FractionalRanking);

// src/utils/duration.ts
function formatDuration(minutes) {
  const totalMinutes = Math.round(minutes);
  const hours = Math.floor(totalMinutes / 60);
  const mins = totalMinutes % 60;
  if (hours > 0) {
    return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
  }
  return `${totalMinutes}m`;
}
function formatDurationWords(minutes) {
  const totalMinutes = Math.round(minutes);
  const hours = Math.floor(totalMinutes / 60);
  const mins = totalMinutes % 60;
  if (hours === 0) return `${totalMinutes} minute${totalMinutes === 1 ? "" : "s"}`;
  const hourPart = `${hours} hour${hours === 1 ? "" : "s"}`;
  if (mins === 0) return hourPart;
  return `${hourPart} ${mins} minute${mins === 1 ? "" : "s"}`;
}
function formatHours(hours) {
  return formatDuration(hours * 60);
}

// src/utils/visitPaymentState.ts
var FAILED_PAYMENT_STATUSES = /* @__PURE__ */ new Set([
  PAYMENT_STATUS.PAYMENT_FAILED,
  "failed"
]);
var OUTSTANDING_PAYMENT_STATUSES = /* @__PURE__ */ new Set([
  PAYMENT_STATUS.NO_PAYMENT_METHOD
]);
function resolveVisitPaymentState(status, paymentStatus) {
  if (status === "paid" /* PAID */) return "paid";
  if (paymentStatus && FAILED_PAYMENT_STATUSES.has(paymentStatus)) return "failed";
  if (paymentStatus === PAYMENT_STATUS.AWAITING_MANUAL_PAYMENT) return "manual";
  if (paymentStatus && OUTSTANDING_PAYMENT_STATUSES.has(paymentStatus)) {
    return "outstanding";
  }
  if (status === "needs-review" /* NEEDS_REVIEW */) return "outstanding";
  return "pending";
}
var VISIT_PAYMENT_STATE_LABELS = {
  paid: "Paid",
  pending: "Pending",
  manual: "Manual payment",
  failed: "Failed",
  outstanding: "Outstanding"
};
function getVisitRevertCopy(status, paymentStatus) {
  if (status === "completed" /* COMPLETED */ || status === "paid" /* PAID */) {
    if (resolveVisitPaymentState(status, paymentStatus) === "paid") {
      return {
        actionLabel: "Refund & revert",
        subtitle: "Refund the payment and revert this visit"
      };
    }
    return {
      actionLabel: "Revert visit",
      subtitle: "Revert this completed visit"
    };
  }
  return {
    actionLabel: "Discard visit",
    subtitle: "Discard this in-progress visit and undo all tracked work"
  };
}

// src/utils/chargeWait.ts
var CHARGE_WAIT_MINUTES = [0, 15, 30, 60, 120];
var DEFAULT_CHARGE_WAIT_WHEN_ENABLED = 30;
function isChargeWaitMinutes(value) {
  return CHARGE_WAIT_MINUTES.includes(value);
}
function resolveChargeWaitMinutes(org) {
  return isChargeWaitMinutes(org?.chargeWaitMinutes) ? org.chargeWaitMinutes : 0;
}
function computeChargeAfter(minutes, now = /* @__PURE__ */ new Date()) {
  if (minutes === 0) return void 0;
  return new Date(now.getTime() + minutes * 6e4).toISOString();
}
function isChargeWaitCancelled(visit) {
  return Boolean(visit.chargeWaitCancelledAt);
}
function isVisitInsideChargeWait(visit, now = /* @__PURE__ */ new Date()) {
  if (isChargeWaitCancelled(visit)) return false;
  if (!visit.chargeAfter) return false;
  return visit.chargeAfter > now.toISOString();
}
function isChargeWaitDue(visit, now = /* @__PURE__ */ new Date()) {
  if (visit.status && visit.status !== "completed" /* COMPLETED */) return false;
  if (isChargeWaitCancelled(visit)) return false;
  if (!visit.chargeAfter) return false;
  if (visit.chargeWaitCompletedAt && visit.completedAt && visit.chargeWaitCompletedAt !== visit.completedAt) {
    return false;
  }
  return visit.chargeAfter <= now.toISOString();
}
function customerHasOpenChargeWait(visits, now = /* @__PURE__ */ new Date()) {
  return visits.some((visit) => isVisitInsideChargeWait(visit, now));
}
function isOfficeChargePending(visit, now = /* @__PURE__ */ new Date()) {
  return visit.paymentStatus === PAYMENT_STATUS.AWAITING_BATCH && isVisitInsideChargeWait(visit, now);
}
function chargeWaitStartUpdates(completedAt, minutes, now = /* @__PURE__ */ new Date()) {
  return {
    chargeAfter: computeChargeAfter(minutes, now),
    chargeWaitCompletedAt: completedAt,
    chargeWaitCancelledAt: null
  };
}
function chargeWaitCancelUpdates(now = /* @__PURE__ */ new Date()) {
  return {
    chargeAfter: null,
    chargeWaitCompletedAt: null,
    chargeWaitCancelledAt: now.toISOString()
  };
}
function chargeWaitClearUpdates() {
  return {
    chargeAfter: null,
    chargeWaitCompletedAt: null,
    chargeWaitCancelledAt: null
  };
}
function visitHasChargeWait(visit) {
  return Boolean(visit.chargeAfter || visit.chargeWaitCompletedAt);
}

// src/utils/visit.ts
var ASSESSMENT_NAME_PREFIX = { en: "Assessment", es: "Evaluaci\xF3n" };
var NAME_SAYS_ASSESSMENT = /(^|[^a-záéíóúñü])(assessment|evaluaci[oó]n)/i;
function visitDisplayName(visit, lang = "en", fallback = "Service") {
  const base = visit?.serviceName || visit?.serviceType || fallback;
  if (visit?.visitType !== "assessment" /* ASSESSMENT */) return base;
  const prefix = lang === "es" ? ASSESSMENT_NAME_PREFIX.es : ASSESSMENT_NAME_PREFIX.en;
  return NAME_SAYS_ASSESSMENT.test(base) ? base : `${prefix}: ${base}`;
}
function isFollowUpVisit(visit) {
  return !!visit && (visit.visitType === "follow_up" /* FOLLOW_UP */ || visit.isFollowupVisit === true || !!visit.originalVisitId);
}
function visitCountsTowardSubscription(visit) {
  if (!visit) return false;
  if (visit.visitType === "assessment" /* ASSESSMENT */) return false;
  if (isFollowUpVisit(visit)) return false;
  if (visit.isBillable === false) return false;
  return true;
}
function followUpNotifiesCustomer(visit) {
  return isFollowUpVisit(visit) && visit?.followupRequirements?.notifyCustomerOnCompletion === true;
}
function buildLockedServiceOptionUsage(customerSelectedOptions, templateServiceOptions) {
  if (!customerSelectedOptions?.length || !templateServiceOptions?.length) return [];
  const byId = new Map(templateServiceOptions.map((o) => [o.id, o]));
  const entries = [];
  for (const selection of customerSelectedOptions) {
    const option = byId.get(selection.optionId);
    if (!option) continue;
    if (option.rateType === "multi-select" /* MULTI_SELECT */) {
      const chosenIds = selection.choiceIds && selection.choiceIds.length > 0 ? selection.choiceIds : selection.choiceId ? [selection.choiceId] : [];
      const selectedChoices = chosenIds.map((id) => option.choices?.find((c) => c.id === id)).filter((c) => !!c).map((choice) => ({
        choiceId: choice.id,
        quantity: 1,
        name: choice.name,
        rate: choice.rate
      }));
      if (selectedChoices.length === 0) continue;
      entries.push({
        optionId: option.id,
        quantity: 1,
        name: option.name,
        rateType: option.rateType,
        billable: option.billable,
        taxable: option.taxable,
        unit: option.unit,
        builtInAmount: option.builtInAmount,
        invoiceDisplay: option.invoiceDisplay,
        zeroValueDisplay: option.zeroValueDisplay,
        customerSelectable: true,
        selectedChoices
      });
      continue;
    }
    if (!selection.enabled) continue;
    const quantity = option.builtInAmount && option.builtInAmount > 0 ? option.builtInAmount : 1;
    entries.push({
      optionId: option.id,
      quantity,
      rate: option.rate,
      name: option.name,
      rateType: option.rateType,
      billable: option.billable,
      taxable: option.taxable,
      unit: option.unit,
      builtInAmount: option.builtInAmount,
      invoiceDisplay: option.invoiceDisplay,
      zeroValueDisplay: option.zeroValueDisplay,
      customerSelectable: true
    });
  }
  return entries;
}
function mergeServiceOptionChoices(liveChoices, snapshotChoices, recordedChoiceIds) {
  const liveIds = new Set(liveChoices.map((c) => c.id));
  const retained = (snapshotChoices ?? []).filter(
    (c) => !liveIds.has(c.id) && recordedChoiceIds.has(c.id)
  );
  return [...liveChoices, ...retained];
}
function overlayLiveServiceOptionChoices(snapshotOptions, liveOptions, serviceOptionUsage) {
  if (!snapshotOptions?.length || !liveOptions?.length) return snapshotOptions;
  const liveById = new Map(liveOptions.map((o) => [o.id, o]));
  const recordedChoiceIds = /* @__PURE__ */ new Set();
  for (const usage of serviceOptionUsage ?? []) {
    for (const pick of usage.selectedChoices ?? []) recordedChoiceIds.add(pick.choiceId);
  }
  return snapshotOptions.map((opt) => {
    const liveChoices = liveById.get(opt.id)?.choices;
    if (!liveChoices) return opt;
    return {
      ...opt,
      choices: mergeServiceOptionChoices(liveChoices, opt.choices, recordedChoiceIds)
    };
  });
}
function resolveServiceOptionThreshold(serviceOptionThresholds, templateOption) {
  if (!templateOption) return void 0;
  const override = serviceOptionThresholds?.[templateOption.id];
  return override ?? templateOption.reviewThreshold;
}
function checkServiceOptionThresholds(serviceOptionUsage, templateServiceOptions, serviceOptionThresholds) {
  if (!serviceOptionUsage?.length || !templateServiceOptions?.length) return [];
  const byId = new Map(templateServiceOptions.map((o) => [o.id, o]));
  const exceptions = [];
  for (const usage of serviceOptionUsage) {
    const option = byId.get(usage.optionId);
    if (!option) continue;
    const threshold = resolveServiceOptionThreshold(serviceOptionThresholds, option);
    if (!threshold) continue;
    if (usage.quantity >= threshold) {
      exceptions.push(
        `Service option "${option.name}": ${usage.quantity} ${option.unit || "units"} exceeds review threshold of ${threshold}`
      );
    }
  }
  return exceptions;
}
function checkCrewNoteWithoutPhoto(hasCrewNote, hasPhoto) {
  if (hasCrewNote && !hasPhoto) {
    return ["Crew added a note with no photo attached"];
  }
  return [];
}
var DEFAULT_CREW_START_SPREAD_MINUTES = 15;
var MAX_CREW_START_SPREAD_MINUTES = 480;
function checkCrewStartTimeSpread(crewMemberTimes, settings) {
  if (settings?.crewStartSpreadEnabled !== true) return [];
  const configured = settings.crewStartSpreadMinutes;
  const windowMinutes = typeof configured === "number" && Number.isFinite(configured) && configured >= 0 ? configured : DEFAULT_CREW_START_SPREAD_MINUTES;
  const starts = (crewMemberTimes ?? []).map((member) => ({ name: member.memberName, at: new Date(member.startedAt).getTime() })).filter((entry) => Number.isFinite(entry.at));
  if (starts.length < 2) return [];
  let earliest = starts[0];
  let latest = starts[0];
  for (const entry of starts) {
    if (entry.at < earliest.at) earliest = entry;
    if (entry.at > latest.at) latest = entry;
  }
  const spreadMinutes = Math.round((latest.at - earliest.at) / 6e4);
  if (spreadMinutes <= windowMinutes) return [];
  const lastName = latest.name || "A crew member";
  const firstName = earliest.name || "the first crew member";
  return [
    `Crew times don't match: ${lastName} started ${formatDurationWords(spreadMinutes)} after ${firstName}, more than the ${formatDurationWords(windowMinutes)} allowed.`
  ];
}
function bannerFromSubscription(skipMakeupNote, bannerNotes, visitDate, today, now) {
  if (skipMakeupNote) {
    return { bannerNote: skipMakeupNote, bannerNoteUpdatedAt: now };
  }
  const texts = getActiveTemporaryNotes(bannerNotes, today, visitDate).map((n) => n.text.trim()).filter(Boolean);
  if (texts.length === 0) return {};
  return { bannerNote: texts.join("\n"), bannerNoteUpdatedAt: now };
}
function createVisit(input) {
  const now = (/* @__PURE__ */ new Date()).toISOString();
  const today = getLocalDateFromISO(now);
  const visitDate = input.scheduledDate || today;
  const attributedSchedule = input.scheduleId ? (input.subscription?.schedules ?? []).find((s) => s.id === input.scheduleId) : void 0;
  const windowSchedule = attributedSchedule && isOneTimeWindowSchedule(attributedSchedule) ? attributedSchedule : void 0;
  const serviceWindowStart = windowSchedule?.effectiveFrom?.slice(0, 10);
  const serviceDueDate = windowSchedule?.effectiveUntil?.slice(0, 10);
  const skipMakeup = input.subscription?.skipMakeup ?? void 0;
  const templateBillingMethod = input.serviceTemplate?.billingMethod;
  const skipMakeupBillsHourly = !!skipMakeup?.billHourly && !input.subscription?.bundleId && (templateBillingMethod === "per_visit" /* PER_VISIT */ || templateBillingMethod === "per_hour" /* PER_HOUR */);
  const proofOfService = isProofOfServiceVisit(
    input.serviceTemplate?.requireProofOfService,
    input.subscription
  );
  const visit = {
    id: input.id,
    orgId: input.orgId,
    customerId: input.customerId,
    serviceTemplateId: input.serviceTemplateId,
    crewId: input.crewId,
    rank: input.rank,
    status: input.status || "not-started" /* NOT_STARTED */,
    adminNotes: input.adminNotes,
    adminNotes_es: input.adminNotes_es,
    // IMPORTANT: No fallback for budgetedHours - callers must provide it explicitly.
    // Repository validation will catch missing values.
    budgetedHours: input.budgetedHours,
    subscriptionId: input.subscriptionId,
    scheduleId: input.scheduleId,
    scheduledDate: input.scheduledDate,
    serviceWindowStart,
    serviceDueDate,
    dispatchJobId: input.dispatchJobId,
    isFirstSubscriptionVisit: input.isFirstSubscriptionVisit || false,
    order: input.order,
    createdAt: now,
    updatedAt: now,
    // Persist a follow-up as the FOLLOW_UP type, not a separate boolean flag (like assessments).
    visitType: isFollowUpVisit(input) ? "follow_up" /* FOLLOW_UP */ : input.visitType,
    // Visit count multiplier. Follow-ups never consume a package slot (RUT-3713).
    appliedVisitCountMultiplier: isFollowUpVisit(input) ? 0 : input.appliedVisitCountMultiplier,
    // Follow-up visit relationship (link back to the original visit)
    originalVisitId: input.originalVisitId,
    // Billing override
    isBillable: input.isBillable,
    // Follow-up requirements
    followupRequirements: input.followupRequirements,
    // Populate denormalized fields from provided objects
    // Customer denormalization
    customerDisplayName: input.customer?.displayName,
    customerAddress: input.customer?.address,
    customerCoordinates: input.customer?.coordinates,
    customerMetrics: input.customer?.metrics,
    customerParcelPin: input.customer?.parcelData?.pin,
    customerParcelBoundaries: input.customer?.parcelBoundaries,
    // Service template denormalization
    serviceName: input.isFollowupVisit && input.serviceTemplate?.name ? `Follow-up: ${input.serviceTemplate.name}` : input.serviceTemplate?.name,
    // Skip make-up (RUT-2923 / RUT-3744): keep the template billing method so the
    // regular visit rate stays the floor. Stamp skipMakeupHourly + the modal
    // hourly rate (template BLR unless overridden) so VisitPricingService bills
    // max(regular visit rate, actual hours × that rate). Do not clear the
    // minimum/built-in hours — dropping them was the old "pure hourly" path.
    billingMethod: input.serviceTemplate?.billingMethod,
    hourlyRate: skipMakeupBillsHourly ? skipMakeup?.hourlyRateOverride ?? input.serviceTemplate?.hourlyRate : input.serviceTemplate?.hourlyRate,
    minimumCharge: input.serviceTemplate?.minimumCharge,
    builtInHours: input.serviceTemplate?.builtInHours,
    skipMakeupHourly: skipMakeupBillsHourly || void 0,
    volumePricing: input.serviceTemplate?.volumePricing,
    visitPricing: input.serviceTemplate?.visitPricing,
    serviceOptions: input.serviceTemplate?.serviceOptions,
    // Hour bounds for review flagging (from service template)
    hourBounds: input.serviceTemplate?.hourBounds,
    // An after photo is required when the photo cadence lands on this visit, or when
    // proof of service applies.
    photosRequired: isPhotoRequiredForVisit(
      input.serviceTemplate?.photoRequirement,
      input.subscription?.visitCounts?.allTime ?? 0
    ) || proofOfService,
    beforePhotosRequired: proofOfService,
    serviceTemplateCategory: input.serviceTemplate?.category,
    // Subscription denormalization (preserves agreed pricing)
    subscriptionRate: input.subscription?.rate,
    subscriptionDiscount: input.subscription?.discount ? { type: input.subscription.discount.type, value: input.subscription.discount.value } : void 0,
    subscriptionRateBreakdown: input.subscription?.rateBreakdown,
    selectedPackageOptionId: input.subscription?.selectedPackageOptionId,
    selectedPackageOptionName: input.subscription?.selectedPackageOptionName,
    pricePerAdditionalVisit: input.subscription?.pricePerAdditionalVisit,
    // Crew note for a pending scheduled stop (RUT-2773). Copied at creation so
    // weekly/recurring visits created before the stop date carry the note without
    // staff reopening each one. Source of truth remains Subscription.deactivationCrewNote.
    deactivationCrewNote: input.subscription?.deactivationCrewNote || void 0,
    // Skip make-up (RUT-2923): high-priority banner note + force review before billing.
    // Service-level bannerNotes (RUT-3570) fill the banner when skipMakeup has none.
    ...bannerFromSubscription(skipMakeup?.note, input.subscription?.bannerNotes, visitDate, today, now),
    reviewMetadata: skipMakeup ? {
      reviewRequired: true,
      reviewReason: "manual_flag" /* MANUAL_FLAG */,
      reviewRequestedAt: now,
      reviewRequestedBy: "system"
    } : void 0,
    // Tie the visit to its package (ServiceBundle) so member visits aren't
    // billed individually (RUT-2210 / RUT-3610). Static snapshot copied at
    // creation.
    bundleId: input.subscription?.bundleId,
    // Standalone per-visit value (RUT-2211): bundle visits bill the customer $0,
    // so subcontractor payout is taken against this snapshot instead.
    bundleMemberValue: input.subscription?.bundleMemberValue,
    // Customer-selected service options become locked serviceOptionUsage entries
    serviceOptionUsage: buildLockedServiceOptionUsage(
      input.subscription?.customerSelectedOptions,
      input.serviceTemplate?.serviceOptions
    )
  };
  return visit;
}
function compareVisitsForRouteOrder(a, b) {
  if (a.priority && !b.priority) return -1;
  if (!a.priority && b.priority) return 1;
  if (a.rank && b.rank) {
    if (a.rank < b.rank) return -1;
    if (a.rank > b.rank) return 1;
    return 0;
  }
  if (a.rank && !b.rank) return -1;
  if (!a.rank && b.rank) return 1;
  const orderA = a.order ?? a.routeOrder;
  const orderB = b.order ?? b.routeOrder;
  if (orderA !== void 0 && orderB !== void 0) {
    return orderA - orderB;
  }
  if (orderA !== void 0 && orderB === void 0) return 1;
  if (orderA === void 0 && orderB !== void 0) return -1;
  const nameA = getCustomerName(a).toLowerCase();
  const nameB = getCustomerName(b).toLowerCase();
  return nameA.localeCompare(nameB);
}
function getCustomerName(visit) {
  if (visit.customerName) return visit.customerName;
  if (visit.customerFirstName || visit.customerLastName) {
    return [visit.customerFirstName, visit.customerLastName].filter(Boolean).join(" ");
  }
  if (visit.customer?.name) return visit.customer.name;
  return "";
}
function sortVisitsForRoute(visits) {
  return [...visits].sort(compareVisitsForRouteOrder);
}
function buildVisitRouteOrderMap(visits) {
  const map = /* @__PURE__ */ new Map();
  sortVisitsForRoute(visits).forEach((visit, index) => {
    map.set(visit.id, index + 1);
  });
  return map;
}
function viewableVisitPhotos(visit) {
  return (visit.photos || []).filter(
    (photo) => photo.uploadStatus === "uploaded" && typeof photo.uri === "string" && photo.uri.startsWith("http")
  );
}
function visitHasPhotos(visit) {
  if (visit.hasPhotos !== void 0) return visit.hasPhotos;
  if (!visit.photos || visit.photos.length === 0) return false;
  return visit.photos.some((photo) => photo.uploadStatus === "uploaded");
}
function isReviewablePhoto(photo) {
  if (typeof photo !== "object" || photo === null) return false;
  const candidate = photo;
  return typeof candidate.id === "string" && candidate.id.length > 0 && typeof candidate.uri === "string" && candidate.uri.length > 0;
}
function isPhotoUnreviewed(photo) {
  return !photo.reviewedAt;
}
function computeHasUnreviewedPhotos(photos) {
  return (photos ?? []).filter(isReviewablePhoto).some(isPhotoUnreviewed);
}
function countUnreviewedPhotos(photos) {
  return (photos ?? []).filter(isReviewablePhoto).filter(isPhotoUnreviewed).length;
}
function stampOfficeStaffPhotosReviewed(photos, roleByUploaderId, now, reviewedById) {
  let stamped = 0;
  const next = photos.map((photo) => {
    if (photo.reviewedAt) return photo;
    if (!photo.uploadedById) return photo;
    const roleId = roleByUploaderId.get(photo.uploadedById);
    if (!isOfficeStaffRoleId(roleId)) return photo;
    stamped += 1;
    const { pendingApproval: _pendingApproval, ...rest } = photo;
    return { ...rest, reviewedAt: now, reviewedById };
  });
  return { photos: next, stamped };
}
function noteHasContent(content) {
  return typeof content === "string" && content.trim().length > 0;
}
function visitHasNotes(visit) {
  if (visit.hasNotes !== void 0) return visit.hasNotes;
  const hasAdminNotes = Boolean(visit.adminNotes && visit.adminNotes.trim().length > 0);
  const hasStructuredNotes = Boolean(visit.visitNotes && visit.visitNotes.length > 0);
  return hasAdminNotes || hasStructuredNotes;
}
function validateVisitBillingData(visit) {
  const errors = [];
  if (!visit.id) {
    errors.push("Visit ID is required");
  }
  if (!visit.customerId) {
    errors.push("Customer ID is required");
  }
  if (!visit.serviceTemplateId) {
    errors.push("Service template ID is required");
  }
  return {
    valid: errors.length === 0,
    errors
  };
}
var TERMINAL_STATUSES = [
  "completed" /* COMPLETED */,
  "paid" /* PAID */,
  "skipped" /* SKIPPED */,
  "cancelled" /* CANCELLED */,
  "discarded" /* DISCARDED */,
  "voided" /* VOIDED */,
  "refunded" /* REFUNDED */,
  "needs-review" /* NEEDS_REVIEW */
];
function isTerminalVisitStatus(status) {
  return TERMINAL_STATUSES.includes(status);
}
function isAssessmentInProgress(assessmentVisit) {
  return !!assessmentVisit && !isTerminalVisitStatus(assessmentVisit.status);
}
function getVisitCompletionDate(visit, timezone = DEFAULT_DISPLAY_TIMEZONE) {
  const toDate = (iso) => getDateInTimezone(iso, timezone);
  if (visit.status === "completed" /* COMPLETED */ || visit.status === "paid" /* PAID */ || visit.status === "voided" /* VOIDED */ || visit.status === "refunded" /* REFUNDED */ || visit.status === "needs-review" /* NEEDS_REVIEW */) {
    return toDate(visit.completedAt || visit.createdAt);
  }
  if (visit.status === "skipped" /* SKIPPED */) {
    return toDate(visit.skippedAt || visit.createdAt);
  }
  if (visit.status === "discarded" /* DISCARDED */) {
    return toDate(visit.discardedAt || visit.createdAt);
  }
  if (visit.status === "cancelled" /* CANCELLED */) {
    return toDate(visit.cancelledAt || visit.createdAt);
  }
  return toDate(visit.createdAt);
}
function getVisitTerminalTimestamp(visit) {
  const fallback = visit.createdAt;
  if (visit.status === "completed" /* COMPLETED */ || visit.status === "paid" /* PAID */ || visit.status === "voided" /* VOIDED */ || visit.status === "refunded" /* REFUNDED */ || visit.status === "needs-review" /* NEEDS_REVIEW */) {
    return visit.completedAt || fallback;
  }
  if (visit.status === "skipped" /* SKIPPED */) {
    return visit.skippedAt || fallback;
  }
  if (visit.status === "discarded" /* DISCARDED */) {
    return visit.discardedAt || fallback;
  }
  if (visit.status === "cancelled" /* CANCELLED */) {
    return visit.cancelledAt || fallback;
  }
  return fallback;
}
function getVisitDisplayDate(visit, timezone = DEFAULT_DISPLAY_TIMEZONE) {
  if (isTerminalVisitStatus(visit.status)) {
    return getVisitCompletionDate(visit, timezone);
  }
  return visit.scheduledDate || getDateInTimezone(visit.createdAt, timezone);
}
function isVisitScheduledAfter(visit, today) {
  const date = visit.scheduledDate || visit.scheduledServiceDate;
  return !!date && date > today;
}
var STATUS_DISPLAY_MAP = {
  ["not-started" /* NOT_STARTED */]: {
    icon: "clock",
    color: "#78716c",
    // stone-500
    textColor: "#57534e",
    // stone-600
    label: "Not Started",
    bgColor: "#fafaf9",
    // stone-50
    borderColor: "#e7e5e4"
    // stone-200
  },
  ["in-progress" /* IN_PROGRESS */]: {
    icon: "play",
    color: "#16a34a",
    // green-600
    textColor: "#15803d",
    // green-700
    label: "In Progress",
    bgColor: "#f0fdf4",
    // green-50
    borderColor: "#bbf7d0"
    // green-200
  },
  ["paused" /* PAUSED */]: {
    icon: "pause",
    // yellow-700, not -600: on its own yellow-50 fill the -600 glyph measures
    // 2.84:1 and fails even the relaxed 3:1 non-text bar.
    color: "#a16207",
    // yellow-700
    textColor: "#854d0e",
    // yellow-800
    label: "Paused",
    bgColor: "#fefce8",
    // yellow-50
    borderColor: "#fef08a"
    // yellow-200
  },
  ["completed" /* COMPLETED */]: {
    icon: "check",
    color: "#16a34a",
    // green-600
    textColor: "#15803d",
    // green-700
    label: "Completed",
    bgColor: "#ecfdf5",
    // emerald-50
    borderColor: "#a7f3d0"
    // emerald-200
  },
  ["paid" /* PAID */]: {
    icon: "dollar",
    color: "#16a34a",
    // green-600
    textColor: "#15803d",
    // green-700
    label: "Paid",
    bgColor: "#ecfdf5",
    // emerald-50
    borderColor: "#a7f3d0"
    // emerald-200
  },
  // Skipped / Discarded / Voided are terminal non-events: nothing to act on, so
  // they read as neutral stone and leave the warning family to NEEDS_REVIEW.
  // Their glyphs carry the identity, which is why each needs a distinct one.
  ["skipped" /* SKIPPED */]: {
    icon: "skip-forward",
    color: "#78716c",
    // stone-500
    textColor: "#57534e",
    // stone-600
    label: "Skipped",
    bgColor: "#fafaf9",
    // stone-50
    borderColor: "#e7e5e4"
    // stone-200
  },
  // The one visit STATUS that asks an admin to do something, so it owns the
  // warning family among the statuses. (The `outstanding` payment state below
  // is orange too — a different axis, rendered in a different badge.) Values are
  // the four shipped tokens: --warning, --warning-strong, --warning-subtle,
  // --warning-border.
  ["needs-review" /* NEEDS_REVIEW */]: {
    icon: "alert",
    color: "#ea580c",
    // --warning (orange-600)
    textColor: "#9b3412",
    // --warning-strong
    label: "Needs Review",
    bgColor: "#fff6f0",
    // --warning-subtle
    borderColor: "#fbd3bb"
    // --warning-border
  },
  ["cancelled" /* CANCELLED */]: {
    icon: "x-circle",
    color: "#dc2626",
    // red-600
    textColor: "#b91c1c",
    // red-700
    label: "Cancelled",
    bgColor: "#fef2f2",
    // red-50
    borderColor: "#fecaca"
    // red-200
  },
  ["discarded" /* DISCARDED */]: {
    icon: "trash",
    color: "#78716c",
    // stone-500
    textColor: "#57534e",
    // stone-600
    label: "Discarded",
    bgColor: "#fafaf9",
    // stone-50
    borderColor: "#e7e5e4"
    // stone-200
  },
  ["voided" /* VOIDED */]: {
    icon: "prohibit",
    color: "#78716c",
    // stone-500
    textColor: "#57534e",
    // stone-600
    label: "Voided",
    bgColor: "#fafaf9",
    // stone-50
    borderColor: "#e7e5e4"
    // stone-200
  },
  ["refunded" /* REFUNDED */]: {
    icon: "receipt",
    color: "#0891b2",
    // cyan-600
    textColor: "#155e75",
    // cyan-800
    label: "Refunded",
    bgColor: "#ecfeff",
    // cyan-50
    borderColor: "#a5f3fc"
    // cyan-200
  }
};
var NO_CHARGE_DISPLAY = {
  icon: "none",
  color: "#78716c",
  // stone-500
  textColor: "#57534e",
  // stone-600
  label: "No charge",
  bgColor: "#f5f5f4",
  // stone-100
  borderColor: "#e7e5e4"
  // stone-200
};
function collectedNothing(totalAmount) {
  return typeof totalAmount === "number" && totalAmount === 0;
}
function isNoChargeAmount(totalAmount) {
  return collectedNothing(totalAmount);
}
function isNoChargeVisit(status, totalAmount) {
  return status === "paid" /* PAID */ && collectedNothing(totalAmount);
}
function getVisitStatusDisplay(status, totalAmount) {
  if (isNoChargeVisit(status, totalAmount)) {
    return NO_CHARGE_DISPLAY;
  }
  return STATUS_DISPLAY_MAP[status] ?? STATUS_DISPLAY_MAP["not-started" /* NOT_STARTED */];
}
var MONEY_WORDED_VISIT_STATUSES = /* @__PURE__ */ new Set([
  "paid" /* PAID */,
  "refunded" /* REFUNDED */,
  "voided" /* VOIDED */
]);
function getVisitWorkStatusDisplay(status) {
  if (MONEY_WORDED_VISIT_STATUSES.has(status)) {
    return STATUS_DISPLAY_MAP["completed" /* COMPLETED */];
  }
  return STATUS_DISPLAY_MAP[status] ?? STATUS_DISPLAY_MAP["not-started" /* NOT_STARTED */];
}
var PAYMENT_STATE_DISPLAY = {
  paid: STATUS_DISPLAY_MAP["paid" /* PAID */],
  pending: {
    icon: "dollar",
    color: "#d97706",
    // amber-600
    textColor: "#92400e",
    // amber-800
    label: VISIT_PAYMENT_STATE_LABELS.pending,
    bgColor: "#fffbeb",
    // amber-50
    borderColor: "#fde68a"
    // amber-200
  },
  manual: {
    icon: "dollar",
    color: "#0284c7",
    // sky-600
    textColor: "#075985",
    // sky-800
    label: VISIT_PAYMENT_STATE_LABELS.manual,
    bgColor: "#f0f9ff",
    // sky-50
    borderColor: "#bae6fd"
    // sky-200
  },
  failed: {
    icon: "alert",
    color: "#dc2626",
    // red-600
    textColor: "#b91c1c",
    // red-700
    label: VISIT_PAYMENT_STATE_LABELS.failed,
    bgColor: "#fef2f2",
    // red-50
    borderColor: "#fecaca"
    // red-200
  },
  outstanding: {
    icon: "dollar",
    color: "#ea580c",
    // orange-600
    textColor: "#9b3412",
    // --warning-strong
    label: VISIT_PAYMENT_STATE_LABELS.outstanding,
    bgColor: "#fff7ed",
    // orange-50
    borderColor: "#fed7aa"
    // orange-200
  }
};
var BILLED_VISIT_STATUSES = /* @__PURE__ */ new Set([
  "completed" /* COMPLETED */,
  "paid" /* PAID */,
  "needs-review" /* NEEDS_REVIEW */,
  "refunded" /* REFUNDED */,
  "voided" /* VOIDED */
]);
var REVERSED_VISIT_STATUSES = /* @__PURE__ */ new Set([
  "refunded" /* REFUNDED */,
  "voided" /* VOIDED */
]);
var VISIT_PAYMENT_FACET_LABELS = {
  ...VISIT_PAYMENT_STATE_LABELS,
  no_charge: NO_CHARGE_DISPLAY.label,
  refunded: STATUS_DISPLAY_MAP["refunded" /* REFUNDED */].label,
  voided: STATUS_DISPLAY_MAP["voided" /* VOIDED */].label
};
var VISIT_PAYMENT_FACET_ORDER = [
  "paid",
  "pending",
  "manual",
  "failed",
  "outstanding",
  "no_charge",
  "refunded",
  "voided"
];
var PAYMENT_FACET_DISPLAY = {
  ...PAYMENT_STATE_DISPLAY,
  no_charge: NO_CHARGE_DISPLAY,
  refunded: STATUS_DISPLAY_MAP["refunded" /* REFUNDED */],
  voided: STATUS_DISPLAY_MAP["voided" /* VOIDED */]
};
function resolveVisitPaymentFacet(status, totalAmount, paymentStatus) {
  if (!BILLED_VISIT_STATUSES.has(status)) return null;
  if (REVERSED_VISIT_STATUSES.has(status)) {
    return status;
  }
  if (collectedNothing(totalAmount)) return "no_charge";
  return resolveVisitPaymentState(status, paymentStatus);
}
function getVisitPaymentFacetDisplay(facet) {
  return PAYMENT_FACET_DISPLAY[facet] ?? PAYMENT_STATE_DISPLAY.pending;
}
function getVisitPaymentStatusDisplay(status, totalAmount, paymentStatus, options) {
  const facet = resolveVisitPaymentFacet(status, totalAmount, paymentStatus);
  if (!facet) return null;
  const display = PAYMENT_FACET_DISPLAY[facet];
  if (facet === "pending" && isOfficeChargePending(
    { paymentStatus, chargeAfter: options?.chargeAfter },
    options?.now
  )) {
    return { ...display, label: "Charge pending" };
  }
  return display;
}
function getVisitDualStatusDisplay(status, totalAmount, paymentStatus, options) {
  return {
    work: getVisitWorkStatusDisplay(status),
    payment: getVisitPaymentStatusDisplay(status, totalAmount, paymentStatus, options)
  };
}
function formatVisitDualStatusLabel(status, totalAmount, paymentStatus, options) {
  const { work, payment } = getVisitDualStatusDisplay(status, totalAmount, paymentStatus, options);
  return payment ? `${work.label} \xB7 ${payment.label}` : work.label;
}
var VISIT_WORK_STATUS_MEMBERS = {
  ["cancelled" /* CANCELLED */]: ["cancelled" /* CANCELLED */],
  ["completed" /* COMPLETED */]: [
    "completed" /* COMPLETED */,
    "paid" /* PAID */,
    "refunded" /* REFUNDED */,
    "voided" /* VOIDED */
  ],
  ["discarded" /* DISCARDED */]: ["discarded" /* DISCARDED */],
  ["in-progress" /* IN_PROGRESS */]: ["in-progress" /* IN_PROGRESS */],
  ["needs-review" /* NEEDS_REVIEW */]: ["needs-review" /* NEEDS_REVIEW */],
  ["not-started" /* NOT_STARTED */]: ["not-started" /* NOT_STARTED */],
  ["paused" /* PAUSED */]: ["paused" /* PAUSED */],
  ["skipped" /* SKIPPED */]: ["skipped" /* SKIPPED */]
};
var VISIT_WORK_STATUSES = Object.keys(VISIT_WORK_STATUS_MEMBERS);
function expandWorkStatuses(workStatuses) {
  const out = /* @__PURE__ */ new Set();
  for (const work of workStatuses) {
    const members = VISIT_WORK_STATUS_MEMBERS[work];
    if (members) members.forEach((s) => out.add(s));
    else if (Object.values(VisitStatus).includes(work)) out.add(work);
  }
  return Array.from(out);
}
function collapseToWorkStatuses(statuses) {
  const selected = new Set(statuses);
  return VISIT_WORK_STATUSES.filter(
    (work) => VISIT_WORK_STATUS_MEMBERS[work].some((s) => selected.has(s))
  );
}
function countByWorkStatus(counts) {
  const out = {};
  if (!counts) return out;
  for (const work of VISIT_WORK_STATUSES) {
    const total = VISIT_WORK_STATUS_MEMBERS[work].reduce((sum, s) => sum + (counts[s] ?? 0), 0);
    if (total > 0) out[work] = total;
  }
  return out;
}
var VisitStatusRollup = /* @__PURE__ */ ((VisitStatusRollup2) => {
  VisitStatusRollup2["COMPLETE"] = "complete";
  VisitStatusRollup2["INCOMPLETE"] = "incomplete";
  VisitStatusRollup2["CANCELLED"] = "cancelled";
  VisitStatusRollup2["PENDING"] = "pending";
  return VisitStatusRollup2;
})(VisitStatusRollup || {});
var VISIT_STATUS_ROLLUPS = {
  ["complete" /* COMPLETE */]: [
    "needs-review" /* NEEDS_REVIEW */,
    "completed" /* COMPLETED */
  ],
  ["incomplete" /* INCOMPLETE */]: [
    "in-progress" /* IN_PROGRESS */,
    "paused" /* PAUSED */
  ],
  ["cancelled" /* CANCELLED */]: [
    "discarded" /* DISCARDED */,
    "skipped" /* SKIPPED */,
    "cancelled" /* CANCELLED */
  ],
  ["pending" /* PENDING */]: [
    "not-started" /* NOT_STARTED */
  ]
};
var VISIT_STATUS_ROLLUP_LABELS = {
  ["complete" /* COMPLETE */]: "Complete",
  ["incomplete" /* INCOMPLETE */]: "Incomplete",
  ["cancelled" /* CANCELLED */]: "Cancelled",
  ["pending" /* PENDING */]: "Pending"
};
function rollupToStatuses(rollup) {
  return expandWorkStatuses(VISIT_STATUS_ROLLUPS[rollup]);
}
function countVisitsByStatus(visits) {
  const counts = {};
  for (const visit of visits) {
    if (!visit.status) continue;
    counts[visit.status] = (counts[visit.status] ?? 0) + 1;
  }
  return counts;
}

// src/utils/todayRouteOrder.ts
var CREW_DONE_STATUSES = /* @__PURE__ */ new Set([
  "completed" /* COMPLETED */,
  "paid" /* PAID */,
  "needs-review" /* NEEDS_REVIEW */
]);
function parseVisitSubscriptionId(subscriptionId) {
  const hash = subscriptionId.indexOf("#");
  if (hash <= 0 || hash === subscriptionId.length - 1) return null;
  return {
    customerId: subscriptionId.slice(0, hash),
    serviceTemplateId: subscriptionId.slice(hash + 1)
  };
}
function isSubscriptionRouteStop(visit) {
  if (!visit.subscriptionId) return false;
  if (visit.visitType === "assessment" /* ASSESSMENT */ || isFollowUpVisit({
    visitType: visit.visitType,
    isFollowupVisit: visit.isFollowupVisit
  })) {
    return false;
  }
  const parsed = parseVisitSubscriptionId(visit.subscriptionId);
  const templateId = visit.serviceTemplateId ?? parsed?.serviceTemplateId;
  if (typeof templateId === "string" && templateId.startsWith(ONE_OFF_TEMPLATE_PREFIX)) {
    return false;
  }
  return true;
}
function longestIncreasingSubsequenceLength(sequence) {
  const tails = [];
  for (const value of sequence) {
    let lo = 0;
    let hi = tails.length;
    while (lo < hi) {
      const mid = lo + hi >> 1;
      if (tails[mid] < value) lo = mid + 1;
      else hi = mid;
    }
    if (lo === tails.length) tails.push(value);
    else tails[lo] = value;
  }
  return tails.length;
}
function countMovedStops(plannedOrderIds, completedOrderIds) {
  const plannedIndex = new Map(plannedOrderIds.map((id, index) => [id, index]));
  const sequence = completedOrderIds.map((id) => plannedIndex.get(id)).filter((index) => index !== void 0);
  if (sequence.length === 0) return 0;
  return sequence.length - longestIncreasingSubsequenceLength(sequence);
}
function cityFromVisitAddress(address, storedCity) {
  const trimmed = storedCity?.trim();
  if (trimmed) return trimmed;
  return formatAddressForDisplay(address)?.city || void 0;
}
function labelTodayRouteStop(visit) {
  const named = [
    visit.customerDisplayName,
    visit.customerName,
    visit.customer?.name
  ].find((value) => typeof value === "string" && value.trim().length > 0);
  if (named) return named.trim();
  return formatAddressForDisplay(visit.customerAddress)?.street?.trim() || "";
}
function toStopLabel(stop) {
  return { listPosition: stop.listPosition, name: stop.name };
}
function describeRouteOrderChange(stops, _plannedOrderIds, completedOrderIds) {
  const byId = new Map(stops.map((stop) => [stop.id, stop]));
  const completed = completedOrderIds.map((id) => byId.get(id)).filter((stop) => !!stop);
  if (completed.length < 2) return null;
  let bestStart = -1;
  let bestLength = 0;
  let runStart = 0;
  for (let i = 1; i <= completed.length; i++) {
    const stillDecreasing = i < completed.length && completed[i].listPosition === completed[i - 1].listPosition - 1;
    if (stillDecreasing) continue;
    const length = i - runStart;
    if (length > bestLength) {
      bestLength = length;
      bestStart = runStart;
    }
    runStart = i;
  }
  if (bestLength >= 3) {
    const run = completed.slice(bestStart, bestStart + bestLength);
    const cities = new Set(run.map((stop) => stop.city).filter((city2) => !!city2));
    const city = cities.size === 1 ? [...cities][0] : void 0;
    return {
      kind: "reverse",
      start: toStopLabel(run[run.length - 1]),
      end: toStopLabel(run[0]),
      city
    };
  }
  for (let i = 0; i < completed.length; i++) {
    for (let j = i + 1; j < completed.length; j++) {
      if (completed[i].listPosition > completed[j].listPosition) {
        return {
          kind: "before",
          later: toStopLabel(completed[i]),
          earlier: toStopLabel(completed[j])
        };
      }
    }
  }
  return null;
}
function crewRanksNeedRebalance(crew) {
  const ranks = crew.map((stop) => stop.rank).filter((rank) => !!rank);
  if (ranks.length !== crew.length) return true;
  return new Set(ranks).size !== ranks.length;
}
function assignRebalancedCrewRanks(crew) {
  const sorted = [...crew].sort((a, b) => {
    if (a.rank && b.rank) {
      if (a.rank < b.rank) return -1;
      if (a.rank > b.rank) return 1;
      return 0;
    }
    if (a.rank && !b.rank) return -1;
    if (!a.rank && b.rank) return 1;
    return 0;
  });
  const ranks = rebalanceRanks(sorted.length);
  return sorted.map((stop, index) => ({ id: stop.id, rank: ranks[index] }));
}
function mergeTodayRanks(crew, todayIdsInOrder) {
  const byId = new Map(crew.map((stop) => [stop.id, stop]));
  const todaySlots = todayIdsInOrder.map((id) => byId.get(id)?.rank).filter((rank) => !!rank).sort((a, b) => a < b ? -1 : a > b ? 1 : 0);
  const writes = [];
  todayIdsInOrder.forEach((id, index) => {
    const next = todaySlots[index];
    const current = byId.get(id)?.rank;
    if (next && current !== next) {
      writes.push({ id, rank: next });
    }
  });
  return writes;
}
function analyzeTodayRouteOrder(visits) {
  const dayDone = visits.length > 0 && visits.every((visit) => isTerminalVisitStatus(visit.status || ""));
  const numbered = visits.map((visit, index) => ({
    visit,
    listPosition: index + 1,
    name: labelTodayRouteStop(visit),
    city: cityFromVisitAddress(visit.customerAddress, visit.city)
  }));
  const subscriptionStops = numbered.filter(({ visit }) => isSubscriptionRouteStop(visit));
  const plannedSubscriptionIds = [];
  const seenPlanned = /* @__PURE__ */ new Set();
  for (const { visit } of subscriptionStops) {
    const id = visit.subscriptionId;
    if (seenPlanned.has(id)) continue;
    seenPlanned.add(id);
    plannedSubscriptionIds.push(id);
  }
  const finished = subscriptionStops.filter(
    ({ visit }) => CREW_DONE_STATUSES.has(visit.status || "") && !!visit.completedAt
  ).slice().sort((a, b) => (a.visit.completedAt || "").localeCompare(b.visit.completedAt || ""));
  const completedSubscriptionIds = [];
  const seenCompleted = /* @__PURE__ */ new Set();
  for (const { visit } of finished) {
    const id = visit.subscriptionId;
    if (seenCompleted.has(id)) continue;
    seenCompleted.add(id);
    completedSubscriptionIds.push(id);
  }
  const moved = countMovedStops(plannedSubscriptionIds, completedSubscriptionIds);
  const description = moved > 0 ? describeRouteOrderChange(
    subscriptionStops.map(({ visit, listPosition, name, city }) => ({
      id: visit.subscriptionId,
      listPosition,
      name,
      city
    })),
    plannedSubscriptionIds,
    completedSubscriptionIds
  ) : null;
  return {
    dayDone,
    moved,
    description,
    plannedSubscriptionIds,
    completedSubscriptionIds
  };
}

// src/utils/routeInsertion.ts
function findRankTies(stops) {
  const byRank = /* @__PURE__ */ new Map();
  for (const stop of stops) {
    if (!stop.rank) continue;
    const ids = byRank.get(stop.rank) ?? [];
    ids.push(stop.id);
    byRank.set(stop.rank, ids);
  }
  return [...byRank.entries()].filter(([, ids]) => ids.length > 1).map(([rank, ids]) => ({ rank, ids }));
}
function appendRouteRank(existingRanks) {
  const used = /* @__PURE__ */ new Set();
  let max = null;
  for (const rank of existingRanks) {
    if (!rank) continue;
    used.add(rank);
    if (max === null || rank > max) max = rank;
  }
  return nextUnusedAfter(max, used);
}
function prependRouteRank(existingRanks, currentTop) {
  const used = /* @__PURE__ */ new Set();
  for (const rank of existingRanks) {
    if (rank) used.add(rank);
  }
  let next = FractionalRanking.generateRankBetween(null, currentTop ?? null);
  while (used.has(next)) {
    next = FractionalRanking.generateRankBetween(null, next);
  }
  return next;
}
function uniqueRankAmong(existingRanks, preferred) {
  const used = /* @__PURE__ */ new Set();
  for (const rank of existingRanks) {
    if (rank) used.add(rank);
  }
  if (preferred && !used.has(preferred)) return preferred;
  return appendRouteRank(used);
}
function assignRoutePosition(existing, insertAt) {
  const ranked = existing.filter(
    (stop) => Boolean(stop.id && stop.rank)
  ).sort((a, b) => a.rank < b.rank ? -1 : a.rank > b.rank ? 1 : 0);
  const atEnd = insertAt === void 0 || insertAt < 0 || insertAt >= ranked.length;
  if (atEnd) {
    return { rank: appendRouteRank(ranked.map((stop) => stop.rank)), shifts: [] };
  }
  const used = new Set(ranked.map((stop) => stop.rank));
  const prev = insertAt > 0 ? ranked[insertAt - 1].rank : null;
  const occupant = ranked[insertAt];
  if (prev && prev < occupant.rank) {
    const mid = FractionalRanking.generateRankBetween(prev, occupant.rank);
    if (!used.has(mid)) return { rank: mid, shifts: [] };
  } else if (!prev) {
    const before = FractionalRanking.generateRankBetween(null, occupant.rank);
    if (!used.has(before)) return { rank: before, shifts: [] };
  }
  return shiftLaterStops(ranked, insertAt, prev);
}
function computeInsertionRank(drivingOrder, existingStops, newStopId) {
  return computeInsertionPlacement(drivingOrder, existingStops, newStopId)?.rank;
}
function computeInsertionPlacement(drivingOrder, existingStops, newStopId) {
  const newIndex = drivingOrder.indexOf(newStopId);
  if (newIndex < 0) return void 0;
  const others = existingStops.filter((stop) => stop.id !== newStopId);
  const rankById = /* @__PURE__ */ new Map();
  for (const stop of others) {
    if (stop.rank) rankById.set(stop.id, stop.rank);
  }
  let prevRank;
  for (let i = newIndex - 1; i >= 0; i--) {
    const r = rankById.get(drivingOrder[i]);
    if (r) {
      prevRank = r;
      break;
    }
  }
  let nextRank;
  for (let i = newIndex + 1; i < drivingOrder.length; i++) {
    const r = rankById.get(drivingOrder[i]);
    if (r) {
      nextRank = r;
      break;
    }
  }
  if (!prevRank && !nextRank) return void 0;
  const used = new Set(rankById.values());
  let candidate;
  if (prevRank && nextRank && prevRank >= nextRank) {
    const prevDistance = distanceToRankedNeighbor(drivingOrder, rankById, newIndex, -1);
    const nextDistance = distanceToRankedNeighbor(drivingOrder, rankById, newIndex, 1);
    candidate = prevDistance <= nextDistance ? FractionalRanking.generateRankBetween(prevRank, void 0) : FractionalRanking.generateRankBetween(void 0, nextRank);
  } else {
    candidate = FractionalRanking.generateRankBetween(prevRank, nextRank);
  }
  if (!used.has(candidate)) {
    return { rank: candidate, shifts: [] };
  }
  const rankedBefore = drivingOrder.slice(0, newIndex).filter((id) => rankById.has(id)).length;
  return assignRoutePosition(others, rankedBefore);
}
function nextUnusedAfter(prev, used) {
  let next = FractionalRanking.generateRankBetween(prev, null);
  while (used.has(next)) {
    next = FractionalRanking.generateRankBetween(next, null);
  }
  return next;
}
function shiftLaterStops(ranked, insertAt, prev) {
  const reserved = new Set(ranked.slice(0, insertAt).map((stop) => stop.rank));
  const rank = nextUnusedAfter(prev, reserved);
  reserved.add(rank);
  const shifts = [];
  let cursor = rank;
  for (const stop of ranked.slice(insertAt)) {
    cursor = nextUnusedAfter(cursor, reserved);
    shifts.push({ id: stop.id, rank: cursor });
    reserved.add(cursor);
  }
  return { rank, shifts };
}
function distanceToRankedNeighbor(drivingOrder, rankById, fromIndex, step) {
  let distance = 1;
  for (let i = fromIndex + step; i >= 0 && i < drivingOrder.length; i += step, distance++) {
    if (rankById.get(drivingOrder[i])) return distance;
  }
  return Number.POSITIVE_INFINITY;
}

// src/utils/polygonUtils.ts
function pixelToGeo(px, py, bbox, imageSize) {
  const lng = bbox.minLng + px / imageSize * (bbox.maxLng - bbox.minLng);
  const lat = bbox.maxLat - py / imageSize * (bbox.maxLat - bbox.minLat);
  return [lng, lat];
}
function pixelPolygonToGeo(pixelCoords, bbox, imageSize) {
  return pixelCoords.map(([px, py]) => pixelToGeo(px, py, bbox, imageSize));
}
function perpendicularDistance(point, lineStart, lineEnd) {
  if (lineStart[0] === lineEnd[0] && lineStart[1] === lineEnd[1]) {
    return Math.sqrt(
      Math.pow(point[0] - lineStart[0], 2) + Math.pow(point[1] - lineStart[1], 2)
    );
  }
  const dx = lineEnd[0] - lineStart[0];
  const dy = lineEnd[1] - lineStart[1];
  const mag = Math.sqrt(dx * dx + dy * dy);
  if (mag === 0) return 0;
  const normalizedDx = dx / mag;
  const normalizedDy = dy / mag;
  const pvx = point[0] - lineStart[0];
  const pvy = point[1] - lineStart[1];
  const pvdot = normalizedDx * pvx + normalizedDy * pvy;
  const ax = lineStart[0] + pvdot * normalizedDx;
  const ay = lineStart[1] + pvdot * normalizedDy;
  return Math.sqrt(Math.pow(point[0] - ax, 2) + Math.pow(point[1] - ay, 2));
}
function douglasPeucker(points, epsilon) {
  if (points.length < 3) {
    return points;
  }
  let maxDist = 0;
  let maxIdx = 0;
  for (let i = 1; i < points.length - 1; i++) {
    const dist = perpendicularDistance(
      points[i],
      points[0],
      points[points.length - 1]
    );
    if (dist > maxDist) {
      maxDist = dist;
      maxIdx = i;
    }
  }
  if (maxDist > epsilon) {
    const left = douglasPeucker(points.slice(0, maxIdx + 1), epsilon);
    const right = douglasPeucker(points.slice(maxIdx), epsilon);
    return [...left.slice(0, -1), ...right];
  } else {
    return [points[0], points[points.length - 1]];
  }
}
function simplifyRing(ring, tolerance) {
  if (ring.length < 4 || tolerance <= 0) return ring;
  const [x0, y0] = ring[0];
  let far = 0;
  let farD = -1;
  for (let i = 1; i < ring.length; i++) {
    const d = (ring[i][0] - x0) ** 2 + (ring[i][1] - y0) ** 2;
    if (d > farD) {
      farD = d;
      far = i;
    }
  }
  const first = douglasPeucker(ring.slice(0, far + 1), tolerance);
  const second = douglasPeucker([...ring.slice(far), ring[0]], tolerance);
  return [...first, ...second.slice(1, -1)];
}
function simplifyPolygon(coords, tolerance = 1e-5) {
  if (coords.length < 4) {
    return coords;
  }
  const simplified = douglasPeucker(coords, tolerance);
  if (simplified.length > 0 && (simplified[0][0] !== simplified[simplified.length - 1][0] || simplified[0][1] !== simplified[simplified.length - 1][1])) {
    simplified.push([...simplified[0]]);
  }
  return simplified;
}
function calculatePolygonAreaSqft(coords) {
  if (coords.length < 4) {
    return 0;
  }
  try {
    const lats = coords.map((c) => c[1]);
    const centerLat = lats.reduce((a, b) => a + b, 0) / lats.length;
    const mPerDegLat = 111320;
    const mPerDegLng = 111320 * Math.cos(centerLat * Math.PI / 180);
    let area = 0;
    const n = coords.length;
    for (let i = 0; i < n - 1; i++) {
      const x1 = coords[i][0] * mPerDegLng;
      const y1 = coords[i][1] * mPerDegLat;
      const x2 = coords[i + 1][0] * mPerDegLng;
      const y2 = coords[i + 1][1] * mPerDegLat;
      area += x1 * y2 - x2 * y1;
    }
    area = Math.abs(area) / 2;
    const sqMetersToSqFeet = 10.7639;
    return Math.round(area * sqMetersToSqFeet);
  } catch {
    return 0;
  }
}
function calculatePolygonCentroid(polygon) {
  const coords = polygon.length > 1 && polygon[0][0] === polygon[polygon.length - 1][0] && polygon[0][1] === polygon[polygon.length - 1][1] ? polygon.slice(0, -1) : polygon;
  if (coords.length === 0) {
    return [0, 0];
  }
  const lngs = coords.map((c) => c[0]);
  const lats = coords.map((c) => c[1]);
  return [
    lngs.reduce((a, b) => a + b, 0) / lngs.length,
    lats.reduce((a, b) => a + b, 0) / lats.length
  ];
}
function feetToDegrees(feet, latitude) {
  const meters = feet * 0.3048;
  const dLat = meters / 111320;
  const dLng = meters / (111320 * Math.cos(latitude * Math.PI / 180));
  return { dLng, dLat };
}
function degreesToFeet(dLng, dLat, latitude) {
  const mPerDegLat = 111320;
  const mPerDegLng = 111320 * Math.cos(latitude * Math.PI / 180);
  const dx = dLng * mPerDegLng;
  const dy = dLat * mPerDegLat;
  return Math.sqrt(dx * dx + dy * dy) * 3.28084;
}
function decomposePolygonEdges(polygon) {
  const edges = [];
  const n = polygon[0][0] === polygon[polygon.length - 1][0] && polygon[0][1] === polygon[polygon.length - 1][1] ? polygon.length - 1 : polygon.length;
  for (let i = 0; i < n; i++) {
    const next = (i + 1) % n;
    edges.push({
      start: polygon[i],
      end: polygon[next],
      index: i
    });
  }
  return edges;
}
function computeOutwardNormal(edge, centroid) {
  const dx = edge.end[0] - edge.start[0];
  const dy = edge.end[1] - edge.start[1];
  const len = Math.sqrt(dx * dx + dy * dy);
  if (len === 0) return [0, 0];
  let nx = -dy / len;
  let ny = dx / len;
  const midX = (edge.start[0] + edge.end[0]) / 2;
  const midY = (edge.start[1] + edge.end[1]) / 2;
  const toCentroidX = centroid[0] - midX;
  const toCentroidY = centroid[1] - midY;
  if (nx * toCentroidX + ny * toCentroidY > 0) {
    nx = -nx;
    ny = -ny;
  }
  return [nx, ny];
}
function raySegmentIntersection(origin, direction, segStart, segEnd) {
  const [ox, oy] = origin;
  const [dx, dy] = direction;
  const [sx, sy] = segStart;
  const [ex, ey] = segEnd;
  const segDx = ex - sx;
  const segDy = ey - sy;
  const denom = dx * segDy - dy * segDx;
  if (Math.abs(denom) < 1e-12) return null;
  const t = ((sx - ox) * segDy - (sy - oy) * segDx) / denom;
  const u = ((sx - ox) * dy - (sy - oy) * dx) / denom;
  if (t > 1e-9 && u >= 0 && u <= 1) {
    return t;
  }
  return null;
}
function pointInPolygon(point, polygon) {
  const [x, y] = point;
  const n = polygon.length;
  let inside = false;
  let j = n - 1;
  for (let i = 0; i < n; i++) {
    const xi = polygon[i][0];
    const yi = polygon[i][1];
    const xj = polygon[j][0];
    const yj = polygon[j][1];
    if (yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) {
      inside = !inside;
    }
    j = i;
  }
  return inside;
}
function haversineDistance(a, b) {
  const R = 6371e3;
  const lat1 = a[1] * Math.PI / 180;
  const lat2 = b[1] * Math.PI / 180;
  const dLat = (b[1] - a[1]) * Math.PI / 180;
  const dLng = (b[0] - a[0]) * Math.PI / 180;
  const h = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
  return R * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
}
var MIN_GEOFENCE_RADIUS_M = 100;
function boundingCircleRadiusM(center, polygon) {
  let max = 0;
  for (const v of polygon) {
    const d = haversineDistance(center, [v[0], v[1]]);
    if (d > max) max = d;
  }
  return max;
}
function clampGeofenceRadiusM(radiusM) {
  return Math.max(radiusM, MIN_GEOFENCE_RADIUS_M);
}
function clusterByDistance(centers, thresholdM) {
  const n = centers.length;
  const parent = Array.from({ length: n }, (_, i) => i);
  const find = (x) => {
    let r = x;
    while (parent[r] !== r) r = parent[r];
    while (parent[x] !== r) {
      const next = parent[x];
      parent[x] = r;
      x = next;
    }
    return r;
  };
  const union = (a, b) => {
    const ra = find(a);
    const rb = find(b);
    if (ra !== rb) parent[Math.max(ra, rb)] = Math.min(ra, rb);
  };
  for (let i = 0; i < n; i++) {
    for (let j = i + 1; j < n; j++) {
      if (haversineDistance(centers[i], centers[j]) <= thresholdM) union(i, j);
    }
  }
  const labelOf = /* @__PURE__ */ new Map();
  const labels = new Array(n);
  let nextLabel = 0;
  for (let i = 0; i < n; i++) {
    const root = find(i);
    if (!labelOf.has(root)) labelOf.set(root, nextLabel++);
    labels[i] = labelOf.get(root);
  }
  return labels;
}
function pointToSegmentDistanceFt(point, segStart, segEnd, latitude) {
  return pointToSegmentClosest(point, segStart, segEnd, latitude).distFt;
}
function pointToSegmentClosest(point, segStart, segEnd, latitude) {
  const [px, py] = point;
  const [sx, sy] = segStart;
  const [ex, ey] = segEnd;
  const dx = ex - sx;
  const dy = ey - sy;
  const lenSq = dx * dx + dy * dy;
  let closestX;
  let closestY;
  if (lenSq === 0) {
    closestX = sx;
    closestY = sy;
  } else {
    const t = Math.max(0, Math.min(1, ((px - sx) * dx + (py - sy) * dy) / lenSq));
    closestX = sx + t * dx;
    closestY = sy + t * dy;
  }
  return {
    distFt: degreesToFeet(px - closestX, py - closestY, latitude),
    closest: [closestX, closestY]
  };
}
function polygonCentroidInBoundary(polygon, boundary) {
  const centroid = calculatePolygonCentroid(polygon);
  return pointInPolygon(centroid, boundary);
}
function computeImageryBbox(lat, lng, zoom = 18, size = 600) {
  const metersPerPx = 156543.03 * Math.cos(lat * Math.PI / 180) / Math.pow(2, zoom);
  const halfExtentM = size / 2 * metersPerPx;
  const latPerMeter = 1 / 111320;
  const lngPerMeter = 1 / (111320 * Math.cos(lat * Math.PI / 180));
  const halfLat = halfExtentM * latPerMeter;
  const halfLng = halfExtentM * lngPerMeter;
  return {
    minLng: lng - halfLng,
    minLat: lat - halfLat,
    maxLng: lng + halfLng,
    maxLat: lat + halfLat
  };
}

// src/utils/routeOptimization.ts
function nearestNeighborOrder(stops) {
  if (stops.length <= 2) return stops.map((s) => s.id);
  const remaining = stops.slice(1);
  const order = [stops[0]];
  let current = stops[0];
  while (remaining.length > 0) {
    let nearestIndex = 0;
    let nearestDist = Infinity;
    for (let i = 0; i < remaining.length; i++) {
      const dist = haversineDistance(
        [current.lng, current.lat],
        [remaining[i].lng, remaining[i].lat]
      );
      if (dist < nearestDist) {
        nearestDist = dist;
        nearestIndex = i;
      }
    }
    current = remaining.splice(nearestIndex, 1)[0];
    order.push(current);
  }
  return order.map((s) => s.id);
}
function sameMembers(a, b) {
  if (a.length !== b.length) return false;
  const set = new Set(a);
  return b.every((id) => set.has(id));
}
function sameSequence(a, b) {
  return a.length === b.length && a.every((id, i) => id === b[i]);
}
function resolveRouteOrder(params) {
  const { stops, providerOrderedIds } = params;
  const inputIds = stops.map((s) => s.id);
  const providerComplete = providerOrderedIds != null && sameMembers(providerOrderedIds, inputIds);
  const orderedIds = providerComplete ? providerOrderedIds : nearestNeighborOrder(stops);
  return {
    orderedIds,
    method: providerComplete ? "provider" : "heuristic",
    unchanged: sameSequence(orderedIds, inputIds)
  };
}

// src/utils/sharedValue.ts
function getSharedNonEmptyValue(values) {
  const nonEmpty = values.map((v) => v ?? "").filter(Boolean);
  if (nonEmpty.length === 0) return "";
  return nonEmpty.every((v) => v === nonEmpty[0]) ? nonEmpty[0] : "";
}

// src/utils/gpsVisitTimeGap.ts
var GPS_TIME_GAP_THRESHOLD_MINUTES = 5;
var GPS_TIME_GAP_PHRASES = [
  "Started before GPS arrived",
  "Started after GPS arrived",
  "Finished after GPS left",
  "Finished before GPS left"
];
function parseMs(iso) {
  if (!iso) return null;
  const ms = Date.parse(iso);
  return Number.isFinite(ms) ? ms : null;
}
function minutesBetween(a, b) {
  const left = parseMs(a);
  const right = parseMs(b);
  if (left == null || right == null) return null;
  return Math.abs(left - right) / 6e4;
}
function computeGpsTimeGaps(input) {
  return {
    startGapMinutes: minutesBetween(input.startedAt, input.gpsArrivedAt) ?? input.gpsStartGapMinutes ?? null,
    finishGapMinutes: minutesBetween(input.completedAt, input.gpsLeftAt) ?? input.gpsFinishGapMinutes ?? null
  };
}
function exceedsGpsTimeGapThreshold(gapMinutes, threshold = GPS_TIME_GAP_THRESHOLD_MINUTES) {
  return gapMinutes != null && gapMinutes >= threshold;
}
function isGpsTimeMismatch(gaps, threshold = GPS_TIME_GAP_THRESHOLD_MINUTES) {
  return exceedsGpsTimeGapThreshold(gaps.startGapMinutes, threshold) || exceedsGpsTimeGapThreshold(gaps.finishGapMinutes, threshold);
}
function isGpsTimeMismatchVisit(visit, threshold = GPS_TIME_GAP_THRESHOLD_MINUTES) {
  return isGpsTimeMismatch(computeGpsTimeGaps(visit), threshold);
}
function startPhrase(startedAt, gpsArrivedAt) {
  return Date.parse(startedAt) < Date.parse(gpsArrivedAt) ? "Started before GPS arrived" : "Started after GPS arrived";
}
function finishPhrase(completedAt, gpsLeftAt) {
  return Date.parse(completedAt) > Date.parse(gpsLeftAt) ? "Finished after GPS left" : "Finished before GPS left";
}
function gpsStartGapLine(input) {
  const gap = minutesBetween(input.startedAt, input.gpsArrivedAt);
  if (gap == null || !input.startedAt || !input.gpsArrivedAt) return null;
  const minutes = Math.round(gap);
  const phrase = startPhrase(input.startedAt, input.gpsArrivedAt);
  return { minutes, phrase, text: `${minutes} min off GPS \xB7 ${phrase}` };
}
function gpsFinishGapLine(input) {
  const gap = minutesBetween(input.completedAt, input.gpsLeftAt);
  if (gap == null || !input.completedAt || !input.gpsLeftAt) return null;
  const minutes = Math.round(gap);
  const phrase = finishPhrase(input.completedAt, input.gpsLeftAt);
  return { minutes, phrase, text: `${minutes} min off GPS \xB7 ${phrase}` };
}
function gpsGapRowLine(input, threshold = GPS_TIME_GAP_THRESHOLD_MINUTES) {
  const start = gpsStartGapLine(input);
  const finish = gpsFinishGapLine(input);
  const startGap = minutesBetween(input.startedAt, input.gpsArrivedAt);
  const finishGap = minutesBetween(input.completedAt, input.gpsLeftAt);
  const startQualifies = exceedsGpsTimeGapThreshold(startGap, threshold);
  const finishQualifies = exceedsGpsTimeGapThreshold(finishGap, threshold);
  if (!startQualifies && !finishQualifies) return null;
  if (startQualifies && (!finishQualifies || (startGap ?? 0) >= (finishGap ?? 0))) {
    return start;
  }
  return finish;
}
function maxGpsGapMinutes(input) {
  const { startGapMinutes, finishGapMinutes } = computeGpsTimeGaps(input);
  const values = [startGapMinutes, finishGapMinutes].filter(
    (n) => n != null
  );
  if (values.length === 0) return null;
  return Math.max(...values);
}
var GPS_TIME_GAP_GROUP_HEADER = `Time doesn't match GPS \xB7 Biggest gap first \xB7 threshold ${GPS_TIME_GAP_THRESHOLD_MINUTES} min`;
var GPS_TIME_SOURCE_LABEL = {
  gps: "GPS",
  leader: "lead",
  tap: "tapped"
};
var GPS_FALLBACK_REASON_TEXT = {
  no_gps: "No GPS from their phone around this visit.",
  gps_dark_during_visit: "Their phone sent no GPS while the visit was worked.",
  brief_on_lot: "GPS saw them on the lot only briefly.",
  not_seen_on_lot: "GPS never saw them on the lot. They were somewhere else.",
  no_leave_seen: "GPS didn't see them leave.",
  no_property_location: "This property has no location to compare GPS with."
};

// src/utils/setupTracks.ts
var SETUP_TRACK_IDS = ["getPaid", "ownNumber", "people"];
var SETUP_TRACK_STEP_IDS = [
  "websiteAndAddress",
  "legalDetails",
  "bankAccount",
  "carrierReview",
  "startTrial",
  "importCustomers",
  "inviteCrew"
];
var SETUP_TRACKS = [
  {
    id: "getPaid",
    optional: false,
    waivedBy: "paymentsWaived",
    steps: [
      { id: "websiteAndAddress", completedBy: "websiteAndAddress", kind: "action", minutes: 2 },
      { id: "legalDetails", completedBy: "legalDetailsAnswered", kind: "action", minutes: 3 },
      // The payment partner's own form: identity and the payout bank account.
      { id: "bankAccount", completedBy: "activatePayments", kind: "action", minutes: 5 }
    ]
  },
  {
    id: "ownNumber",
    optional: false,
    steps: [
      // Same step as Get paid's — an EIN saved once counts for both. A business
      // with no EIN yet has answered Get paid but cannot register a brand.
      { id: "legalDetails", completedBy: "einOnFile", kind: "action", minutes: 3 },
      { id: "carrierReview", completedBy: "carrierApproved", kind: "wait" }
    ]
  },
  {
    id: "people",
    optional: true,
    steps: [
      { id: "startTrial", completedBy: "trialStarted", kind: "action", minutes: 2 },
      { id: "importCustomers", completedBy: "importCustomers", kind: "action", minutes: 3 },
      { id: "inviteCrew", completedBy: "inviteCrewMembers", kind: "action", minutes: 1 }
    ]
  }
];
var CARRIER_IN_REVIEW = /* @__PURE__ */ new Set([
  "brand_pending",
  "brand_verified",
  "campaign_pending"
]);
function carrierReviewPhase(status) {
  if (status === "approved") return "approved";
  if (status === "rejected") return "rejected";
  if (status && CARRIER_IN_REVIEW.has(status)) return "inReview";
  return "notFiled";
}
function factValue(fact, items, facts) {
  switch (fact) {
    case "websiteAndAddress":
    case "legalDetailsAnswered":
    case "einOnFile":
    case "trialStarted":
      return facts[fact];
    case "carrierApproved":
      return facts.carrierStatus === "approved";
    default:
      return items[fact] === true;
  }
}
function resolveSetupTracks(items, facts) {
  return SETUP_TRACKS.map((track) => {
    const waived = track.waivedBy ? facts[track.waivedBy] : false;
    let nextStepId = null;
    const steps = track.steps.map((step) => {
      const isDone = waived || factValue(step.completedBy, items, facts);
      let state;
      if (isDone) state = "done";
      else if (step.kind === "wait") state = "waiting";
      else if (nextStepId === null) {
        state = "next";
        nextStepId = step.id;
      } else state = "todo";
      return { id: step.id, kind: step.kind, ...step.minutes ? { minutes: step.minutes } : {}, state };
    });
    const done = steps.filter((s) => s.state === "done").length;
    return {
      id: track.id,
      optional: track.optional,
      steps,
      done,
      total: steps.length,
      complete: done === steps.length,
      nextStepId
    };
  });
}
function setupTracksComplete(tracks) {
  return tracks.every((track) => track.complete);
}
function setupCardDone(checklist) {
  if (!checklist) return true;
  if (checklist.allCompleted) return true;
  const tracks = checklist.tracks;
  if (!tracks) return true;
  const waitingOnOthers = carrierReviewPhase(checklist.facts?.carrierStatus) === "inReview";
  return tracks.every(
    (track) => track.steps.every((step) => step.state === "done" || step.kind === "wait" && waitingOnOthers)
  );
}
function setupTrackMinutesLeft(track) {
  return track.steps.reduce(
    (sum, step) => step.state === "done" || step.kind === "wait" ? sum : sum + (step.minutes ?? 0),
    0
  );
}

// src/utils/activeVisit.ts
var MAX_ACTIVE_VISIT_AGE_MS = 16 * 60 * 60 * 1e3;
var ACTIVE_STATUSES = /* @__PURE__ */ new Set(["in-progress" /* IN_PROGRESS */, "paused" /* PAUSED */]);
var TERMINAL_QUEUED_ACTIONS = /* @__PURE__ */ new Set(["visit-complete", "visit-skip"]);
function resolveActiveVisit(input) {
  const { visits, pendingActions, pendingCrewPatches, now } = input;
  const maxAgeMs = input.maxAgeMs ?? MAX_ACTIVE_VISIT_AGE_MS;
  const withinBound = (startedAt) => {
    if (!startedAt) return false;
    const startMs = Date.parse(startedAt);
    if (!Number.isFinite(startMs)) return false;
    return now - startMs <= maxAgeMs;
  };
  const candidates = [];
  const claimedByQueue = /* @__PURE__ */ new Set();
  for (const [visitId, action] of pendingActions) {
    const visit = visits.get(visitId);
    if (!visit) continue;
    if (action.type === "visit-start") {
      if (isTerminalVisitStatus(visit.status)) continue;
      const startedAt = action.startedAt ?? visit.startedAt;
      if (!withinBound(startedAt)) continue;
      candidates.push(build(visit, "in-progress" /* IN_PROGRESS */, startedAt, true, pendingCrewPatches?.get(visit.id)));
      claimedByQueue.add(visitId);
    } else if (action.type === "visit-pause" && ACTIVE_STATUSES.has(visit.status)) {
      if (!withinBound(visit.startedAt)) continue;
      candidates.push(build(visit, "paused" /* PAUSED */, visit.startedAt, false, pendingCrewPatches?.get(visit.id)));
      claimedByQueue.add(visitId);
    }
  }
  for (const visit of visits.values()) {
    if (claimedByQueue.has(visit.id)) continue;
    if (!ACTIVE_STATUSES.has(visit.status)) continue;
    const queued = pendingActions.get(visit.id);
    if (queued && TERMINAL_QUEUED_ACTIONS.has(queued.type)) continue;
    if (!withinBound(visit.startedAt)) continue;
    candidates.push(
      build(
        visit,
        visit.status,
        visit.startedAt,
        false,
        pendingCrewPatches?.get(visit.id)
      )
    );
  }
  if (candidates.length === 0) return null;
  candidates.sort((a, b) => Date.parse(b.startedAt) - Date.parse(a.startedAt));
  return candidates[0];
}
function selectLatestVisitRuling(echoes, memberId, options = {}) {
  if (!memberId) return null;
  let ruling = null;
  for (const echo of echoes) {
    if (!echo) continue;
    if (!Object.prototype.hasOwnProperty.call(echo, memberId)) continue;
    ruling = { visitId: echo[memberId] ?? null };
  }
  if (options.isClocked === false && ruling?.visitId != null) return null;
  return ruling;
}
function build(visit, status, startedAt, fromQueuedStart, crewPatch) {
  const baseSelected = Array.isArray(visit.selectedCrewMembers) ? visit.selectedCrewMembers : [];
  const selected = crewPatch ? Array.from(/* @__PURE__ */ new Set([...baseSelected, ...crewPatch.selectedCrewMembers])) : baseSelected;
  return {
    visitId: visit.id,
    customerName: visit.customerDisplayName || visit.customerName || "",
    serviceName: visit.serviceName || visit.serviceType || "",
    status,
    startedAt,
    selectedCrewMembers: selected,
    fromQueuedStart
  };
}

// src/utils/customerFacingStatus.ts
var CUSTOMER_PENDING_VISIT_STATUSES = /* @__PURE__ */ new Set([
  "not-started" /* NOT_STARTED */,
  "in-progress" /* IN_PROGRESS */,
  "paused" /* PAUSED */,
  "needs-review" /* NEEDS_REVIEW */
]);
function getCustomerVisitStatusDisplay(status) {
  if (status === "needs-review" /* NEEDS_REVIEW */) {
    return { ...getVisitStatusDisplay("not-started" /* NOT_STARTED */), label: "Pending" };
  }
  if (CUSTOMER_PENDING_VISIT_STATUSES.has(status)) {
    return { ...getVisitStatusDisplay(status), label: "Pending" };
  }
  return getVisitWorkStatusDisplay(status);
}
var CUSTOMER_PAYMENT_STATE_LABELS = {
  paid: "Paid",
  pending: "Pending",
  manual: "Due",
  failed: "Failed",
  outstanding: "Unpaid"
};
function getCustomerVisitPaymentStatusDisplay(status, totalAmount, paymentStatus) {
  if (customerInvoiceTotalsHidden(status)) return null;
  const display = getVisitPaymentStatusDisplay(status, totalAmount, paymentStatus);
  if (!display) return null;
  if (isNoChargeAmount(totalAmount)) return display;
  if (status === "refunded" /* REFUNDED */ || status === "voided" /* VOIDED */) return display;
  return {
    ...display,
    label: CUSTOMER_PAYMENT_STATE_LABELS[resolveVisitPaymentState(status, paymentStatus)]
  };
}
function getCustomerVisitDualStatusDisplay(status, totalAmount, paymentStatus) {
  return {
    work: getCustomerVisitStatusDisplay(status),
    payment: getCustomerVisitPaymentStatusDisplay(status, totalAmount, paymentStatus)
  };
}
function getCustomerPaymentStatusLabel(status) {
  switch (status) {
    case PAYMENT_STATUS.PAID:
      return "Paid";
    // Package visits carry no charge.
    case "included_in_package":
    case "no_charge":
      return "No Charge";
    case PAYMENT_STATUS.REFUNDED:
      return "Refunded";
    case PAYMENT_STATUS.VOIDED:
      return "Voided";
    case PAYMENT_STATUS.PAYMENT_FAILED:
    case "failed":
      return "Failed";
    // Never billed — exited before a charge. Not a declined card (RUT-3505).
    case PAYMENT_STATUS.PROCESSING_ERROR:
      return "Unpaid";
    // pending, processing, awaiting_batch, awaiting_manual_payment,
    // no_payment_method, and any unknown state.
    default:
      return "Pending";
  }
}
function getInvoicePaymentPresentation(status) {
  switch (status) {
    case PAYMENT_STATUS.PAID:
      return { kind: "paid", topLabel: "Complete", footerLabel: "Paid" };
    case "included_in_package":
    case "no_charge":
      return { kind: "no_charge", topLabel: "No Charge", footerLabel: "No charge" };
    case PAYMENT_STATUS.REFUNDED:
      return { kind: "reversed", topLabel: "Refunded", footerLabel: "Refunded" };
    case PAYMENT_STATUS.VOIDED:
      return { kind: "reversed", topLabel: "Voided", footerLabel: "Voided" };
    case PAYMENT_STATUS.PAYMENT_FAILED:
    case "failed":
      return { kind: "failed", topLabel: "Payment Failed", footerLabel: "Payment failed" };
    // Exited before a charge — never billed, not a card decline (RUT-3505).
    case PAYMENT_STATUS.PROCESSING_ERROR:
      return { kind: "unpaid", topLabel: "Unpaid", footerLabel: "Unpaid" };
    // A customer who settles up manually — they owe by the company's terms.
    case PAYMENT_STATUS.AWAITING_MANUAL_PAYMENT:
      return { kind: "due", topLabel: "Due", footerLabel: "Due" };
    // pending, processing, awaiting_batch, no_payment_method, and any unknown
    // state read as an autopay charge that simply hasn't run yet.
    default:
      return { kind: "pending", topLabel: "Pending", footerLabel: "Pending" };
  }
}
function customerInvoiceTotalsHidden(visitStatus) {
  return visitStatus === "needs-review" /* NEEDS_REVIEW */;
}
var HIDDEN_INVOICE_LINE_MONEY = "\u2014";
var HIDDEN_INVOICE_TOTAL = "Pending";
function invoiceMoneyCell(kind, totalsHidden, formatted) {
  if (totalsHidden) {
    return kind === "line" ? HIDDEN_INVOICE_LINE_MONEY : HIDDEN_INVOICE_TOTAL;
  }
  return formatted;
}
function stripHiddenCustomerInvoiceTotals(invoice) {
  return {
    ...invoice,
    totalsHidden: true,
    subtotal: 0,
    tax: 0,
    total: 0,
    totalCharged: 0,
    outstandingBalanceCollected: 0,
    creditApplied: 0,
    discountInfo: null,
    lineItems: (invoice.lineItems ?? []).map((li) => ({
      ...li,
      amount: 0,
      rate: 0
    }))
  };
}

// src/utils/messagePreview.ts
var UNSENT_MESSAGE_PREVIEW = "Message unsent";
function buildMessagePreview(content, attachments) {
  const trimmed = content.trim();
  if (trimmed) return trimmed.substring(0, 100);
  if (attachments && attachments.length > 0) {
    const hasVideo = attachments.some((a) => a.contentType.startsWith("video/"));
    const hasImage = attachments.some((a) => a.contentType.startsWith("image/"));
    if (hasVideo && hasImage) return `Sent ${attachments.length} attachments`;
    if (hasVideo) return attachments.length > 1 ? `Sent ${attachments.length} videos` : "Sent a video";
    if (hasImage) return attachments.length > 1 ? `Sent ${attachments.length} images` : "Sent an image";
    return attachments.length > 1 ? `Sent ${attachments.length} files` : "Sent a file";
  }
  return "Sent a message";
}

// src/utils/messageQuote.ts
var ELLIPSIS = "\u2026";
var ASCII_PUNCTUATION = {
  "\u2018": "'",
  "\u2019": "'",
  "\u201A": "'",
  "\u201B": "'",
  "\u201C": '"',
  "\u201D": '"',
  "\u201E": '"',
  "\u2013": "-",
  "\u2014": "-",
  "\u2015": "-",
  "\u2212": "-",
  "\u2026": "...",
  "\xA0": " ",
  "\u2022": "*",
  "\xB7": "*",
  "\u2032": "'",
  "\u2033": '"'
};
var ASCII_PUNCTUATION_PATTERN = new RegExp(
  `[${Object.keys(ASCII_PUNCTUATION).join("")}]`,
  "g"
);
function foldPunctuationToAscii(text) {
  return text.replace(ASCII_PUNCTUATION_PATTERN, (c) => ASCII_PUNCTUATION[c] ?? c);
}
var MESSAGE_QUOTE_MAX_EXCERPT_LENGTH = 240;
var MESSAGE_QUOTE_SMS_EXCERPT_LENGTH = 120;
function normalizeQuotableText(text) {
  return text.replace(/\s+/g, " ").trim();
}
function quoteExcerptCore(excerpt) {
  let core = normalizeQuotableText(excerpt);
  if (core.startsWith(ELLIPSIS)) core = core.slice(ELLIPSIS.length);
  if (core.endsWith(ELLIPSIS)) core = core.slice(0, -ELLIPSIS.length);
  return core.trim();
}
function truncateQuoteExcerpt(excerpt, maxLength) {
  const normalized = normalizeQuotableText(excerpt);
  if (normalized.length <= maxLength) return normalized;
  const opensMidSentence = normalized.startsWith(ELLIPSIS);
  const core = opensMidSentence ? normalized.slice(ELLIPSIS.length) : normalized;
  const budget = Math.max(maxLength - (opensMidSentence ? 2 : 1), 1);
  let cut = core.slice(0, budget);
  const lastSpace = cut.lastIndexOf(" ");
  if (lastSpace > budget * 0.6) cut = cut.slice(0, lastSpace);
  return `${opensMidSentence ? ELLIPSIS : ""}${cut.trimEnd()}${ELLIPSIS}`;
}
function buildQuoteExcerpt(sourceContent, selection) {
  const source = normalizeQuotableText(sourceContent);
  const selected = normalizeQuotableText(selection ?? "");
  if (!selected || selected === source) {
    return truncateQuoteExcerpt(source, MESSAGE_QUOTE_MAX_EXCERPT_LENGTH);
  }
  const start = source.indexOf(selected);
  if (start === -1) {
    return truncateQuoteExcerpt(source, MESSAGE_QUOTE_MAX_EXCERPT_LENGTH);
  }
  const opensMidSentence = start > 0;
  const endsMidSentence = start + selected.length < source.length;
  const bracketed = `${opensMidSentence ? ELLIPSIS : ""}${selected}${endsMidSentence ? ELLIPSIS : ""}`;
  return truncateQuoteExcerpt(bracketed, MESSAGE_QUOTE_MAX_EXCERPT_LENGTH);
}
function isQuotableMessage(message) {
  if (message.sender === "system" /* SYSTEM */) return false;
  if (message.unsentAt) return false;
  if (message.scheduledFor) return false;
  return normalizeQuotableText(message.content ?? "").length > 0;
}
function isQuoteStillVisible(quote, loadedMessages) {
  const original = loadedMessages.find((m) => m.messageId === quote.messageId);
  if (!original) return true;
  return !original.unsentAt;
}
function formatQuotedOutboundText(excerpt, body, maxExcerptLength, options = {}) {
  let trimmed = truncateQuoteExcerpt(excerpt, maxExcerptLength);
  if (!trimmed) return body;
  if (options.asciiPunctuation) trimmed = foldPunctuationToAscii(trimmed);
  return `Re: "${trimmed}"

${body}`;
}

// src/utils/chatConversation.ts
function isActiveMember(member) {
  return member.status === "active" /* ACTIVE */;
}
function buildCreateConversationRequest(participantIds, name) {
  if (participantIds.length === 0) {
    throw new Error("At least one participant is required");
  }
  if (participantIds.length === 1) {
    return { type: "direct", participantIds };
  }
  const trimmedName = name.trim();
  if (!trimmedName) {
    throw new Error("A group name is required");
  }
  return { type: "group", name: trimmedName, participantIds };
}
function selectCrewChannelMembers(members, crewId) {
  return members.filter(
    (member) => isActiveMember(member) && (member.crewAssignments ?? []).some((assignment) => assignment.crewId === crewId)
  );
}
function findReusableConversation(conversations, request, currentUserId) {
  if (request.type === "crew") {
    if (!request.crewId) return void 0;
    return conversations.find(
      (conversation) => conversation.conversationType === "crew" && conversation.crewId === request.crewId
    );
  }
  const desiredParticipants = /* @__PURE__ */ new Set([...request.participantIds, currentUserId]);
  return conversations.find(
    (conversation) => conversation.conversationType !== "crew" && conversation.participantIds.length === desiredParticipants.size && conversation.participantIds.every((id) => desiredParticipants.has(id))
  );
}
function toggleMessageReaction(existing, reaction) {
  const reactions = existing ?? [];
  const alreadyReacted = reactions.some(
    (r) => r.emoji === reaction.emoji && r.userId === reaction.userId
  );
  if (alreadyReacted) {
    return reactions.filter(
      (r) => !(r.emoji === reaction.emoji && r.userId === reaction.userId)
    );
  }
  return [...reactions, reaction];
}
function selectChatMessageDisplayText(message, viewerLanguage, isOwn) {
  const original = message.content ?? "";
  if (isOwn) return original;
  if (viewerLanguage === "es") return message.content_es || original;
  return original;
}
function resolveInitialChatTab(input) {
  const { canViewCustomers, teamConversationCount, customerConversationCount } = input;
  if (!canViewCustomers) return "team";
  if (customerConversationCount === 0 && teamConversationCount > 0) {
    return "team";
  }
  return "customers";
}

// src/utils/assistantActivity.ts
var TOOL_ACTIVITY_LABELS = {
  dispatch_jobs: "Dispatching crews",
  manage_subscription: "Updating the service",
  update_subscription_rates: "Updating rates",
  schedule_visits: "Scheduling visits",
  reschedule_visits: "Checking reschedule",
  cancel_visits: "Cancelling visits",
  flag_for_review: "Flagging for review",
  remove_flag: "Removing the flag",
  get_visits_for_review: "Checking reviews",
  complete_visit_review: "Completing the review",
  complete_visit: "Completing the visit",
  correct_visit_time: "Correcting visit time",
  query_customers: "Looking up customers",
  query_visits: "Looking up visits",
  get_summary: "Pulling a summary",
  query_payment_issues: "Checking payment issues",
  query_customer_charges: "Looking up charges",
  get_fleet_locations: "Locating crews",
  was_on_property: "Checking the trail",
  query_subscriptions: "Looking up services",
  manage_service_templates: "Updating service templates",
  manage_notes: "Updating notes",
  query_notes: "Reading notes",
  navigate_to: "Taking you there",
  query_rate_requests: "Checking rate requests",
  send_rate: "Sending the rate",
  query_crews: "Looking up crews",
  send_message: "Sending the message",
  send_customer_message: "Sending the message",
  offer_choices: "Checking what you mean",
  get_knowledge: "Finding guidance",
  audit_service_coverage: "Checking service coverage",
  audit_data_integrity: "Checking the records",
  get_my_time: "Checking your hours",
  bulk_manage_notes: "Updating notes",
  list_notifications: "Checking notifications",
  mark_notification_read: "Marking that read",
  mark_all_notifications_read: "Marking everything read",
  get_setup_checklist: "Checking setup",
  update_setup_checklist: "Updating setup",
  complete_setup_details: "Saving company details",
  send_product_feedback: "Sending that to the product team",
  get_automated_message: "Reading the automated message",
  update_automated_message: "Updating the automated message"
};
function toolActivityLabel(toolName) {
  return TOOL_ACTIVITY_LABELS[toolName] || "Working on it";
}
function knownToolActivityNames() {
  return Object.keys(TOOL_ACTIVITY_LABELS);
}
function assistantPhaseLabel(phase, toolName) {
  if (phase === "tool") return toolActivityLabel(toolName || "");
  if (phase === "writing") return "Writing the answer";
  if (phase === "confirming") return "Applying that";
  return "Reading your question";
}

// src/utils/assistantGrounding.ts
function isGrounded(toolCalls) {
  return toolCalls > 0;
}
function groundingLabel(toolCalls, toolNames) {
  if (toolNames && toolNames.length > 0) {
    const labels = [...new Set(toolNames.map((name) => toolActivityLabel(name)))];
    return labels.join(" \xB7 ");
  }
  if (isGrounded(toolCalls)) {
    return `Grounded in live data \xB7 ${toolCalls} ${toolCalls === 1 ? "source" : "sources"}`;
  }
  return "No live data checked";
}
function assistantGroundingFooter(opts) {
  if (opts.done) return null;
  if (typeof opts.toolCalls !== "number") return null;
  return groundingLabel(opts.toolCalls, opts.toolNames);
}

// src/utils/assistantBlocks.ts
function assistantBlockView(_block) {
  return null;
}
function isAssistantDockActionBlock(block) {
  if (!block || typeof block !== "object") return false;
  const type = block.type;
  return type === "navigation_action" || type === "suggestions";
}

// src/utils/assistantTurn.ts
function replayRequestBody(replay) {
  return {
    tool_name: replay.toolName,
    input: replay.input,
    ...replay.inputs && replay.inputs.length > 1 ? { inputs: replay.inputs } : {}
  };
}
function replayTargetKey(toolName, input) {
  if (toolName !== "manage_notes") return null;
  const norm = (value) => typeof value === "string" ? value.trim().toLowerCase() : value == null ? "" : String(value);
  const noteType = norm(input.note_type);
  if (noteType === "visit_notes" && norm(input.action) === "add") return null;
  return JSON.stringify([
    norm(input.action),
    norm(input.entity_type),
    noteType === "" || noteType === "admin_notes" ? "notes" : noteType,
    norm(input.visit_id),
    norm(input.date),
    norm(input.customer_name),
    norm(input.service_name),
    norm(input.note_id)
  ]);
}
function canonicalCallInput(value, top = true) {
  if (Array.isArray(value)) return `[${value.map((v) => canonicalCallInput(v, false)).join(",")}]`;
  if (value && typeof value === "object") {
    const record = value;
    const keys = Object.keys(record).filter((key) => !top || key !== "confirmed" && key !== "confirmation_token").sort();
    return `{${keys.map((key) => `${JSON.stringify(key)}:${canonicalCallInput(record[key], false)}`).join(",")}}`;
  }
  return JSON.stringify(value) ?? "null";
}
function sameWrite(toolName, entry, ran) {
  const target = replayTargetKey(toolName, ran);
  if (target !== null) return replayTargetKey(toolName, entry) === target;
  return canonicalCallInput(entry) === canonicalCallInput(ran);
}
function withoutRanCall(current, ran) {
  const left = (current.inputs ?? [current.input]).filter(
    (entry) => !sameWrite(current.toolName, entry, ran)
  );
  if (left.length === 0) return null;
  const input = left[left.length - 1];
  return left.length > 1 ? { toolName: current.toolName, input, inputs: left } : { toolName: current.toolName, input };
}
function withPreviewedCall(current, keepEarlier, toolName, input) {
  const target = replayTargetKey(toolName, input);
  const earlier = (keepEarlier && current && current.toolName === toolName ? current.inputs ?? [current.input] : []).filter((prior) => target === null || replayTargetKey(toolName, prior) !== target);
  const inputs = [...earlier, input];
  return inputs.length > 1 ? { toolName, input, inputs } : { toolName, input };
}
var RAW_TECHNICAL_ERROR = /is not a function|TypeError|Cannot read propert|undefined is not|null is not an object|Cannot destructure|Unexpected token/;
function looksLikeRawTechnicalError(text) {
  return RAW_TECHNICAL_ERROR.test(text);
}
var ASSISTANT_SAFE_ERROR = "Ruta AI hit an error. Try again.";
function asRecord(value) {
  return value && typeof value === "object" && !Array.isArray(value) ? value : null;
}
function publish(state) {
  const { pendingTools: _pending, ...view } = state;
  return {
    ...view,
    activityLabel: state.done ? null : state.activityLabel,
    showActivity: !state.done && state.text.trim().length === 0 && !!state.activityLabel
  };
}
function assistantTurnStatusLine(view) {
  if (view.done || !view.showActivity) return null;
  return view.activityLabel;
}
function assistantReplyChrome(input) {
  const done = input.done || input.hasAnswer;
  return {
    statusLine: assistantTurnStatusLine({
      done,
      showActivity: !input.hasAnswer && !!input.activityLabel,
      activityLabel: input.activityLabel ?? null
    }),
    groundingFooter: assistantGroundingFooter({
      done,
      toolCalls: input.toolCalls,
      toolNames: input.toolNames
    })
  };
}
function emptyAssistantTurn() {
  return publish({
    text: "",
    activityLabel: "Reading your question",
    showActivity: true,
    toolNames: [],
    suggestions: [],
    navigationActions: [],
    blocks: [],
    pendingReplay: null,
    pendingRetry: false,
    streamError: null,
    done: false,
    pendingTools: {}
  });
}
function replayInputWithPreviewToken(input, data) {
  const token = typeof data?.confirmation_token === "string" && data.confirmation_token ? data.confirmation_token : void 0;
  return token ? { ...input, confirmation_token: token } : { ...input };
}
function rememberTool(state, name) {
  if (!name || state.toolNames.includes(name)) return state;
  return { ...state, toolNames: [...state.toolNames, name] };
}
function applyAssistantEvent(current, event, pendingTools = {}) {
  const state = {
    text: current.text,
    activityLabel: current.activityLabel,
    showActivity: current.showActivity,
    toolNames: current.toolNames,
    suggestions: current.suggestions,
    navigationActions: current.navigationActions,
    blocks: current.blocks,
    pendingReplay: current.pendingReplay,
    pendingRetry: current.pendingRetry === true,
    confirmationPrompt: current.confirmationPrompt,
    streamError: current.streamError,
    toolCalls: current.toolCalls,
    done: current.done,
    afterToolResult: current.afterToolResult === true,
    pendingTools: { ...pendingTools }
  };
  const type = event.type;
  if (type === "status") {
    const phase = event.phase;
    const label = typeof event.label === "string" && event.label.trim() ? event.label : assistantPhaseLabel(
      phase === "tool" || phase === "writing" || phase === "confirming" || phase === "routing" ? phase : "routing",
      typeof event.tool_name === "string" ? event.tool_name : void 0
    );
    const next = publish({ ...state, activityLabel: label });
    return { view: next, pendingTools: state.pendingTools };
  }
  if (type === "text" && typeof event.text === "string" && event.text) {
    const needsBreak = state.afterToolResult === true && state.text.length > 0 && !/\s$/.test(state.text);
    const combined = state.text + (needsBreak ? "\n" : "") + event.text;
    const next = publish({
      ...state,
      text: looksLikeRawTechnicalError(combined) ? ASSISTANT_SAFE_ERROR : combined,
      afterToolResult: false
    });
    return { view: next, pendingTools: state.pendingTools };
  }
  if (type === "tool_call" && typeof event.tool_name === "string") {
    const input = asRecord(event.input) ?? {};
    const toolId = typeof event.tool_id === "string" ? event.tool_id : event.tool_name;
    const named = rememberTool(state, event.tool_name);
    named.pendingTools[toolId] = { name: event.tool_name, input };
    named.activityLabel = toolActivityLabel(event.tool_name);
    const next = publish(named);
    return { view: next, pendingTools: named.pendingTools };
  }
  if (type === "tool_result") {
    const toolId = typeof event.tool_id === "string" ? event.tool_id : "";
    const result = asRecord(event.result);
    const data = asRecord(result?.data);
    const waiting = !!(data && (data.requires_confirmation === true || data.preview === true));
    const pending = state.pendingTools[toolId];
    const alreadyConfirmed = pending?.input.confirmed === true;
    const notSent = data?.not_sent === true;
    if (notSent || waiting && alreadyConfirmed) {
      if (pending) {
        state.pendingReplay = {
          toolName: pending.name,
          input: replayInputWithPreviewToken(pending.input, data)
        };
      }
      state.pendingRetry = true;
      state.confirmationPrompt = void 0;
    } else if (waiting) {
      if (pending) {
        state.pendingReplay = withPreviewedCall(
          state.pendingReplay,
          !state.pendingRetry,
          pending.name,
          replayInputWithPreviewToken(pending.input, data)
        );
        state.pendingRetry = false;
      }
      if (typeof data?.confirmation_prompt === "string") {
        state.confirmationPrompt = data.confirmation_prompt;
      }
    } else if (state.pendingReplay && pending && state.pendingReplay.toolName === pending.name && (alreadyConfirmed || data?.wrote === true)) {
      const left = pending.name === "manage_notes" ? withoutRanCall(state.pendingReplay, pending.input) : null;
      state.pendingReplay = left;
      if (!left) {
        state.pendingRetry = false;
        state.confirmationPrompt = void 0;
      }
    }
    state.afterToolResult = true;
    const next = publish(state);
    return { view: next, pendingTools: state.pendingTools };
  }
  if (type === "content_block") {
    const block = asRecord(event.block);
    if (block?.type === "suggestions" && Array.isArray(block.suggestions)) {
      state.suggestions = block.suggestions.map((item) => {
        const row = asRecord(item);
        if (!row || typeof row.label !== "string" || typeof row.prompt !== "string") return null;
        return { label: row.label, prompt: row.prompt };
      }).filter((item) => item !== null);
    } else if (block?.type === "navigation_action" && typeof block.label === "string" && typeof block.path === "string") {
      state.navigationActions = [
        ...state.navigationActions,
        {
          label: block.label,
          path: block.path,
          state: asRecord(block.state) ?? void 0,
          variant: block.variant === "primary" || block.variant === "secondary" ? block.variant : void 0,
          autoNavigate: block.autoNavigate === true
        }
      ];
    } else {
      const view = assistantBlockView(block);
      if (view) state.blocks = [...state.blocks, view];
    }
    const next = publish(state);
    return { view: next, pendingTools: state.pendingTools };
  }
  if (type === "error") {
    const raw = typeof event.message === "string" ? event.message : ASSISTANT_SAFE_ERROR;
    const message = looksLikeRawTechnicalError(raw) ? ASSISTANT_SAFE_ERROR : raw;
    const next = publish({ ...state, streamError: message, done: true, activityLabel: null });
    return { view: next, pendingTools: state.pendingTools };
  }
  if (type === "done") {
    const fromEvent = Array.isArray(event.tools) ? event.tools.filter((name) => typeof name === "string") : state.toolNames;
    const count = typeof event.tool_calls === "number" ? event.tool_calls : fromEvent.length;
    const next = publish({
      ...state,
      done: true,
      activityLabel: null,
      toolNames: fromEvent.length > 0 ? fromEvent : state.toolNames,
      toolCalls: count
    });
    return { view: next, pendingTools: state.pendingTools };
  }
  return { view: publish(state), pendingTools: state.pendingTools };
}
function finishAssistantTurnOnStreamClose(view) {
  if (view.done) return view;
  return {
    ...view,
    done: true,
    activityLabel: null,
    showActivity: false
  };
}

// src/utils/messageImageDrag.ts
var MESSAGE_IMAGE_DRAG_MIME = "application/x-ruta-message-image";
function serializeMessageImageDrag(payload) {
  return JSON.stringify(payload);
}
function parseMessageImageDrag(raw) {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.url !== "string" || parsed.url.length === 0)
      return null;
    return {
      url: parsed.url,
      fileName: typeof parsed.fileName === "string" && parsed.fileName ? parsed.fileName : "image",
      contentType: typeof parsed.contentType === "string" && parsed.contentType ? parsed.contentType : "image/jpeg"
    };
  } catch {
    return null;
  }
}

// src/utils/messageUnread.ts
function isUnreadCustomerMessage(msg) {
  return msg.sender === "customer" /* CUSTOMER */ && !msg.read;
}
function findFirstUnreadIndex(messages) {
  return messages.findIndex(isUnreadCustomerMessage);
}
function collectUnreadCustomerMessageIds(messages) {
  return new Set(
    messages.filter(isUnreadCustomerMessage).map((msg) => msg.messageId)
  );
}
function findFirstUnreadChatMessageId(messages, args) {
  const { lastReadAt, currentUserId, unreadCount } = args;
  if (unreadCount <= 0) return null;
  if (!lastReadAt) return null;
  const readMs = new Date(lastReadAt).getTime();
  if (Number.isNaN(readMs)) return null;
  let first = null;
  for (const msg of messages) {
    if (msg.isOwn ?? msg.senderId === currentUserId) continue;
    const sentMs = new Date(msg.createdAt).getTime();
    if (Number.isNaN(sentMs) || sentMs <= readMs) continue;
    if (!first || sentMs < new Date(first.createdAt).getTime()) first = msg;
  }
  return first?.id ?? null;
}
function isUnreadCountStaleAfterRead(args) {
  const { unreadCount, lastMessageTime, markedReadAt } = args;
  if (unreadCount <= 0) return false;
  if (!markedReadAt) return false;
  if (!lastMessageTime) return true;
  const lastMs = new Date(lastMessageTime).getTime();
  const readMs = new Date(markedReadAt).getTime();
  if (Number.isNaN(lastMs) || Number.isNaN(readMs)) return true;
  return lastMs <= readMs;
}

// src/utils/messageSuggestedActions.ts
var KIND_STEP = {
  note: "Then add a crew-facing note with manage_notes on the next visit (notes) or the active service.",
  visit: "Then skip, cancel, or adjust the next visit (cancel_visits, confirmed=false). Moving a visit to another day isn't supported yet: say so and change nothing.",
  service: "Then deactivate, hold, or resume the matching service (manage_subscription, confirmed=false)."
};
function buildSuggestedActionSeed(action) {
  const customerName = action.references?.find((r) => r.entityType === "CUSTOMER")?.displayName ?? action.references?.[0]?.displayName ?? "this customer";
  const lines = [
    "MESSAGE SUGGESTION",
    `Customer: ${customerName}`,
    `Action: ${action.label}`
  ];
  if (action.quote) lines.push(`They texted: "${action.quote}"`);
  lines.push(KIND_STEP[action.kind]);
  lines.push(
    "If the live lookup shows no matching visit or service, say so in one line. Do not invent one. Do not say you will look it up."
  );
  return { prompt: lines.join("\n"), displayPrompt: action.label };
}
function collectPendingSuggestedActions(messages) {
  if (!messages?.length) return [];
  const seen = /* @__PURE__ */ new Set();
  const out = [];
  const newestFirst = [...messages].sort((a, b) => b.timestamp.localeCompare(a.timestamp));
  for (const message of newestFirst) {
    if (message.unsentAt || message.scheduledFor) continue;
    for (const action of message.suggestedActions ?? []) {
      if (action.status !== "pending") continue;
      const key = action.label.trim().toLowerCase();
      if (!key || seen.has(key)) continue;
      seen.add(key);
      out.push({
        ...action,
        messageId: message.messageId,
        messageTimestamp: message.timestamp
      });
    }
  }
  return out;
}

// src/utils/inboundConversationRouting.ts
function relevanceOf(candidate) {
  const summary = candidate.summary;
  if (!summary) {
    return { isAdminOutbound: false, time: "" };
  }
  return {
    isAdminOutbound: summary.lastMessageSender === "admin" /* ADMIN */,
    time: summary.lastMessageTime ?? ""
  };
}
function isMoreRelevant(a, b) {
  const relA = relevanceOf(a);
  const relB = relevanceOf(b);
  if (relA.isAdminOutbound !== relB.isAdminOutbound) {
    return relA.isAdminOutbound;
  }
  if (relA.time !== relB.time) {
    return relA.time > relB.time;
  }
  return false;
}
function selectInboundReplyCustomerId(candidates) {
  if (candidates.length === 0) {
    return void 0;
  }
  let best = candidates[0];
  for (let i = 1; i < candidates.length; i++) {
    if (isMoreRelevant(candidates[i], best)) {
      best = candidates[i];
    }
  }
  return best.customerId;
}

// src/utils/crewTimeCalculations.ts
function calculateMemberMinutes(entry, now) {
  if (!entry.startedAt) return 0;
  const endTime = entry.completedAt ? new Date(entry.completedAt) : now ? new Date(now) : /* @__PURE__ */ new Date();
  const startTime = new Date(entry.startedAt);
  let totalMs = endTime.getTime() - startTime.getTime();
  if (entry.pauseSegments && entry.pauseSegments.length > 0) {
    for (const pause of entry.pauseSegments) {
      const pauseStart = new Date(pause.pausedAt);
      const pauseEnd = pause.resumedAt ? new Date(pause.resumedAt) : endTime;
      const pauseDuration = pauseEnd.getTime() - pauseStart.getTime();
      totalMs -= pauseDuration;
    }
  }
  return Math.round(totalMs / (1e3 * 60) * 100) / 100;
}
function mergeVisitPauseSegments(crewMemberTimes, openEnd) {
  if (!crewMemberTimes || crewMemberTimes.length === 0) return [];
  const openEndMs = openEnd ? new Date(openEnd).getTime() : void 0;
  const intervals = crewMemberTimes.flatMap((m) => m.pauseSegments || []).map((seg) => {
    const start = new Date(seg.pausedAt).getTime();
    const end = seg.resumedAt ? new Date(seg.resumedAt).getTime() : openEndMs;
    return { start, end, ongoing: !seg.resumedAt };
  }).filter((i) => !Number.isNaN(i.start)).sort((a, b) => a.start - b.start);
  const merged = [];
  for (const cur of intervals) {
    const last = merged[merged.length - 1];
    const lastEnd = last ? last.end ?? Infinity : void 0;
    if (last && lastEnd !== void 0 && lastEnd >= cur.start) {
      const curEnd = cur.end ?? Infinity;
      last.end = lastEnd === Infinity || curEnd === Infinity ? void 0 : Math.max(last.end, cur.end);
      last.ongoing = last.ongoing || cur.ongoing;
    } else {
      merged.push({ start: cur.start, end: cur.end, ongoing: cur.ongoing });
    }
  }
  return merged.map((i) => ({
    pausedAt: new Date(i.start).toISOString(),
    resumedAt: i.ongoing || i.end === void 0 ? void 0 : new Date(i.end).toISOString()
  }));
}
function calculateVisitPausedMs(crewMemberTimes, openEnd) {
  const openEndMs = new Date(openEnd).getTime();
  return mergeVisitPauseSegments(crewMemberTimes, openEnd).reduce((total, seg) => {
    const start = new Date(seg.pausedAt).getTime();
    const end = seg.resumedAt ? new Date(seg.resumedAt).getTime() : openEndMs;
    return total + Math.max(0, end - start);
  }, 0);
}
function activeVisitMinutes(visit, openEnd) {
  const endIso = visit.completedAt || openEnd;
  if (!visit.startedAt || !endIso) return 0;
  const end = new Date(endIso).getTime();
  let ms = end - new Date(visit.startedAt).getTime();
  if (visit.crewMemberTimes && visit.crewMemberTimes.length > 0) {
    ms -= calculateVisitPausedMs(visit.crewMemberTimes, endIso);
  } else if (visit.pausedAt) {
    const pauseEnd = visit.resumedAt ? new Date(visit.resumedAt).getTime() : end;
    ms -= Math.max(0, pauseEnd - new Date(visit.pausedAt).getTime());
  }
  return Math.max(0, ms) / 6e4;
}
function localDayKey(ms) {
  const d = new Date(ms);
  return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
}
function classifyVisitPauseSegments(crewMemberTimes, openEnd) {
  return mergeVisitPauseSegments(crewMemberTimes, openEnd).map((seg) => {
    const startMs = new Date(seg.pausedAt).getTime();
    const isOvernightGap = seg.resumedAt ? localDayKey(startMs) !== localDayKey(new Date(seg.resumedAt).getTime()) : false;
    return { ...seg, isOvernightGap };
  });
}
function visitSpansMultipleDays(crewMemberTimes) {
  if (!crewMemberTimes || crewMemberTimes.length === 0) return false;
  const days = /* @__PURE__ */ new Set();
  for (const entry of crewMemberTimes) {
    if (entry.startedAt) days.add(localDayKey(new Date(entry.startedAt).getTime()));
    if (entry.completedAt) days.add(localDayKey(new Date(entry.completedAt).getTime()));
  }
  return days.size > 1;
}
function calculateTotalServiceTime(crewMemberTimes, now) {
  if (!crewMemberTimes || crewMemberTimes.length === 0) return 0;
  return crewMemberTimes.reduce((total, entry) => {
    return total + calculateMemberMinutes(entry, now);
  }, 0);
}
function initializeCrewMemberTimes(memberIds, memberData, startTime) {
  return memberIds.map((memberId) => {
    const data = memberData[memberId] || { name: "Unknown Member" };
    return {
      memberId,
      memberName: data.name,
      startedAt: startTime,
      isPaused: false,
      pauseSegments: [],
      employmentType: data.employmentType,
      companyName: data.employmentType === "subcontractor" ? data.companyName : void 0
    };
  });
}
function completeCrewMemberTime(entry, completedAt) {
  const totalMinutes = calculateMemberMinutes({ ...entry, completedAt });
  return {
    ...entry,
    completedAt,
    totalMinutes,
    isPaused: false
  };
}
function completeAllCrewMemberTimes(crewMemberTimes, completedAt) {
  if (!crewMemberTimes || crewMemberTimes.length === 0) return [];
  return crewMemberTimes.map((entry) => {
    if (entry.completedAt) return entry;
    return completeCrewMemberTime(entry, completedAt);
  });
}
function pauseCrewMemberTime(entry, pausedAt) {
  if (entry.completedAt) return entry;
  if (entry.isPaused) return entry;
  const pauseSegments = entry.pauseSegments || [];
  pauseSegments.push({ pausedAt });
  return {
    ...entry,
    isPaused: true,
    pauseSegments
  };
}
function resumeCrewMemberTime(entry, resumedAt) {
  if (!entry.isPaused || !entry.pauseSegments || entry.pauseSegments.length === 0) {
    return entry;
  }
  const pauseSegments = [...entry.pauseSegments];
  const lastPause = pauseSegments[pauseSegments.length - 1];
  if (lastPause && !lastPause.resumedAt) {
    lastPause.resumedAt = resumedAt;
  }
  return {
    ...entry,
    isPaused: false,
    pauseSegments
  };
}
function resumeAllCrewMemberTimes(crewMemberTimes, resumedAt) {
  if (!crewMemberTimes || crewMemberTimes.length === 0) return [];
  return crewMemberTimes.map((entry) => resumeCrewMemberTime(entry, resumedAt));
}
function addCrewMemberToVisit(existingTimes, memberId, memberData, startTime) {
  const times = existingTimes || [];
  const activeEntry = times.find((t) => t.memberId === memberId && !t.completedAt);
  if (activeEntry) return times;
  return [
    ...times,
    {
      memberId,
      memberName: memberData.name,
      startedAt: startTime,
      isPaused: false,
      pauseSegments: [],
      employmentType: memberData.employmentType,
      companyName: memberData.employmentType === "subcontractor" ? memberData.companyName : void 0
    }
  ];
}
function removeCrewMemberFromVisit(existingTimes, memberId, completedAt) {
  if (!existingTimes) return [];
  return existingTimes.map((entry) => {
    if (entry.memberId === memberId && !entry.completedAt) {
      return completeCrewMemberTime(entry, completedAt);
    }
    return entry;
  });
}
function memberIsCurrentlyOnVisit(visit, memberId) {
  if (!memberId) return false;
  if (visit.selectedCrewMembers?.includes(memberId)) return true;
  return !!visit.crewMemberTimes?.some(
    (entry) => entry.memberId === memberId && !entry.completedAt
  );
}
function memberWasOnVisitAt(visit, memberId, at) {
  if (!memberId) return false;
  const t = Date.parse(at);
  if (!Number.isFinite(t)) return false;
  const sessions = (visit.crewMemberTimes ?? []).filter((entry) => entry.memberId === memberId);
  if (sessions.length > 0) {
    return sessions.some((session) => {
      const start2 = session.startedAt ? Date.parse(session.startedAt) : Number.NaN;
      if (Number.isFinite(start2) && t < start2) return false;
      if (!session.completedAt) {
        return !Number.isFinite(start2) || t >= start2;
      }
      const end2 = Date.parse(session.completedAt);
      return Number.isFinite(end2) && t <= end2 && (!Number.isFinite(start2) || t >= start2);
    });
  }
  if (!visit.selectedCrewMembers?.includes(memberId)) return false;
  const start = visit.startedAt ? Date.parse(visit.startedAt) : Number.NaN;
  if (!Number.isFinite(start) || t < start) return false;
  const endRaw = visit.completedAt ?? visit.skippedAt ?? visit.cancelledAt ?? visit.discardedAt;
  if (!endRaw) return true;
  const end = Date.parse(endRaw);
  return Number.isFinite(end) && t <= end;
}
function visitAssignedCrewId(visit) {
  return visit.assignedCrewId || visit.crewId || void 0;
}
function memberCrewIdsOf(user, ...extraCrewIds) {
  const ids = /* @__PURE__ */ new Set();
  for (const assignment of user?.crewAssignments ?? []) {
    if (assignment?.crewId) ids.add(assignment.crewId);
  }
  if (user?.crewId) ids.add(user.crewId);
  for (const crewId of extraCrewIds) {
    if (crewId) ids.add(crewId);
  }
  return Array.from(ids);
}
function memberShouldTrackVisit(visit, memberId, memberCrewIds) {
  if (!memberId) return false;
  if (memberIsCurrentlyOnVisit(visit, memberId)) return true;
  const crewId = visitAssignedCrewId(visit);
  return !!crewId && memberCrewIds.includes(crewId);
}
function startedAtMs(value) {
  if (!value) return 0;
  const ms = Date.parse(value);
  return Number.isFinite(ms) ? ms : 0;
}
function pickMostRecentlyStartedVisit(visits) {
  let best;
  let bestMs = -1;
  for (const visit of visits) {
    const ms = startedAtMs(visit.startedAt);
    if (!best || ms >= bestMs) {
      best = visit;
      bestMs = ms;
    }
  }
  return best;
}

// src/utils/crewTrail/smoothing.ts
var METERS_PER_DEGREE_LAT = 111320;
var PROCESS_NOISE_DENSITY = 1;
var INITIAL_VELOCITY_VARIANCE = 100;
var ASSUMED_ACCURACY_METERS = 15;
var MAX_ACCURACY_THRESHOLD = 100;
var MAX_VALID_SPEED = 50;
var TRAIL_MAX_SPEED_MPS = 12;
function isOutlier(prev, curr, maxSpeed) {
  const dt = (new Date(curr.timestamp).getTime() - new Date(prev.timestamp).getTime()) / 1e3;
  if (dt <= 0) return false;
  const R = 6371e3;
  const dLat = (curr.latitude - prev.latitude) * Math.PI / 180;
  const dLng = (curr.longitude - prev.longitude) * Math.PI / 180;
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(prev.latitude * Math.PI / 180) * Math.cos(curr.latitude * Math.PI / 180) * Math.sin(dLng / 2) ** 2;
  const distance = R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const impliedSpeed = distance / dt;
  return impliedSpeed > maxSpeed;
}
function smoothAxis(measurements, intervals, variances) {
  const n = measurements.length;
  const postX = [];
  const postP = [];
  const predX = [];
  const predP = [];
  let x = [measurements[0], 0];
  let P = [
    [variances[0], 0],
    [0, INITIAL_VELOCITY_VARIANCE]
  ];
  predX.push([...x]);
  predP.push([[...P[0]], [...P[1]]]);
  postX.push([...x]);
  postP.push([[...P[0]], [...P[1]]]);
  for (let i = 1; i < n; i++) {
    const dt = intervals[i];
    const q = PROCESS_NOISE_DENSITY;
    const xp = [x[0] + x[1] * dt, x[1]];
    const fp = [
      [P[0][0] + dt * P[1][0], P[0][1] + dt * P[1][1]],
      [P[1][0], P[1][1]]
    ];
    const pp = [
      [fp[0][0] + dt * fp[0][1] + q * dt * dt * dt / 3, fp[0][1] + q * dt * dt / 2],
      [fp[1][0] + dt * fp[1][1] + q * dt * dt / 2, fp[1][1] + q * dt]
    ];
    predX.push([...xp]);
    predP.push([[...pp[0]], [...pp[1]]]);
    const innovationVariance = pp[0][0] + variances[i];
    const gainPos = pp[0][0] / innovationVariance;
    const gainVel = pp[1][0] / innovationVariance;
    const innovation = measurements[i] - xp[0];
    x = [xp[0] + gainPos * innovation, xp[1] + gainVel * innovation];
    P = [
      [(1 - gainPos) * pp[0][0], (1 - gainPos) * pp[0][1]],
      [pp[1][0] - gainVel * pp[0][0], pp[1][1] - gainVel * pp[0][1]]
    ];
    postX.push([...x]);
    postP.push([[...P[0]], [...P[1]]]);
  }
  const smoothed = postX.map((v) => [...v]);
  for (let i = n - 2; i >= 0; i--) {
    const dt = intervals[i + 1];
    const pp = predP[i + 1];
    const determinant = pp[0][0] * pp[1][1] - pp[0][1] * pp[1][0];
    if (!Number.isFinite(determinant) || determinant === 0) continue;
    const inverse = [
      [pp[1][1] / determinant, -pp[0][1] / determinant],
      [-pp[1][0] / determinant, pp[0][0] / determinant]
    ];
    const a = [
      [postP[i][0][0] + postP[i][0][1] * dt, postP[i][0][1]],
      [postP[i][1][0] + postP[i][1][1] * dt, postP[i][1][1]]
    ];
    const c = [
      [a[0][0] * inverse[0][0] + a[0][1] * inverse[1][0], a[0][0] * inverse[0][1] + a[0][1] * inverse[1][1]],
      [a[1][0] * inverse[0][0] + a[1][1] * inverse[1][0], a[1][0] * inverse[0][1] + a[1][1] * inverse[1][1]]
    ];
    const dx = smoothed[i + 1][0] - predX[i + 1][0];
    const dv = smoothed[i + 1][1] - predX[i + 1][1];
    smoothed[i] = [
      postX[i][0] + c[0][0] * dx + c[0][1] * dv,
      postX[i][1] + c[1][0] * dx + c[1][1] * dv
    ];
  }
  return smoothed.map((v) => v[0]);
}
function smoothTrailKalmanTimed(points, options = {}) {
  const { filterOutliers = true, maxAccuracy = MAX_ACCURACY_THRESHOLD, maxSpeed = MAX_VALID_SPEED } = options;
  const raw = (p) => ({
    longitude: p.longitude,
    latitude: p.latitude,
    timestamp: p.timestamp
  });
  if (points.length === 0) return [];
  if (points.length === 1) return [raw(points[0])];
  const sorted = [...points].sort(
    (a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime()
  );
  const speedCeiling = Number.isFinite(maxSpeed) && maxSpeed > 0 ? maxSpeed : MAX_VALID_SPEED;
  const accuracyCeiling = Number.isFinite(maxAccuracy) && maxAccuracy > 0 ? maxAccuracy : MAX_ACCURACY_THRESHOLD;
  const finite = sorted.filter(
    (p) => Number.isFinite(p.latitude) && Number.isFinite(p.longitude) && Number.isFinite(new Date(p.timestamp).getTime())
  );
  const withinCeiling = finite.filter((p) => !p.accuracy || p.accuracy <= accuracyCeiling);
  const usable = withinCeiling.length >= 2 ? withinCeiling : finite;
  if (usable.length < 2) return usable.map(raw);
  const kept = [usable[0]];
  for (let i = 1; i < usable.length; i++) {
    const previous = kept[kept.length - 1];
    const gap = new Date(usable[i].timestamp).getTime() - new Date(previous.timestamp).getTime();
    if (gap <= 0) continue;
    if (filterOutliers && isOutlier(previous, usable[i], speedCeiling)) continue;
    kept.push(usable[i]);
  }
  if (kept.length < 2) return kept.map(raw);
  const originLat = kept[0].latitude;
  const originLng = kept[0].longitude;
  const metersPerDegreeLng = METERS_PER_DEGREE_LAT * Math.cos(originLat * Math.PI / 180);
  const times = kept.map((p) => new Date(p.timestamp).getTime());
  const intervals = kept.map((_, i) => i === 0 ? 0 : Math.max((times[i] - times[i - 1]) / 1e3, 1e-3));
  const variances = kept.map((p) => {
    const accuracy = p.accuracy && p.accuracy > 0 ? p.accuracy : ASSUMED_ACCURACY_METERS;
    return accuracy * accuracy;
  });
  const north = smoothAxis(
    kept.map((p) => (p.latitude - originLat) * METERS_PER_DEGREE_LAT),
    intervals,
    variances
  );
  const east = smoothAxis(
    kept.map((p) => (p.longitude - originLng) * metersPerDegreeLng),
    intervals,
    variances
  );
  return kept.map((p, i) => ({
    latitude: originLat + north[i] / METERS_PER_DEGREE_LAT,
    longitude: originLng + east[i] / metersPerDegreeLng,
    timestamp: p.timestamp
  }));
}

// src/utils/crewTrail/segments.ts
var TRAIL_GAP_MS = 2e4;
var TRAIL_GAP_METERS = 35;
function trailMetersBetween(aLng, aLat, bLng, bLat) {
  const R = 6371e3;
  const dLat = (bLat - aLat) * Math.PI / 180;
  const dLng = (bLng - aLng) * Math.PI / 180;
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(aLat * Math.PI / 180) * Math.cos(bLat * Math.PI / 180) * Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
function isPausedAt(t, pauses) {
  return pauses.some((p) => t >= p.start && t <= p.end);
}
function buildPlaybackPoints(points, head) {
  if (!head) return points;
  return [
    // Stored fixes are ascending; drop anything ahead of the playhead so the head
    // stays last and the sequence remains ordered.
    ...points.filter((p) => new Date(p.timestamp).getTime() <= head.time),
    { longitude: head.lng, latitude: head.lat, timestamp: new Date(head.time).toISOString() }
  ];
}
function buildTrailSegments(points, pauses, windowStart, windowEnd) {
  const segments = [];
  let current = null;
  let prev = null;
  for (const p of points) {
    const t = new Date(p.timestamp).getTime();
    if (t < windowStart || t > windowEnd) {
      prev = null;
      continue;
    }
    const active = !isPausedAt(t, pauses);
    const coord = [p.longitude, p.latitude];
    const gap = prev !== null && t - prev.t > TRAIL_GAP_MS && trailMetersBetween(prev.lng, prev.lat, coord[0], coord[1]) > TRAIL_GAP_METERS;
    if (!current || current.active !== active || gap) {
      const seed = current && !gap ? current.coords[current.coords.length - 1] : null;
      current = { coords: seed ? [seed, coord] : [coord], active };
      segments.push(current);
    } else {
      current.coords.push(coord);
    }
    prev = { lng: coord[0], lat: coord[1], t };
  }
  return segments.filter((s) => s.coords.length >= 2);
}

// src/utils/crewTrail/playback.ts
function computePlaybackRange(sortedPoints) {
  if (sortedPoints.length < 2) return null;
  const start = new Date(sortedPoints[0].timestamp).getTime();
  const end = new Date(sortedPoints[sortedPoints.length - 1].timestamp).getTime();
  if (!(end > start)) return null;
  return { start, end, duration: end - start };
}
function calcBearing(lat1, lng1, lat2, lng2) {
  const toRad = (deg) => deg * Math.PI / 180;
  const toDeg = (rad) => rad * 180 / Math.PI;
  const y = Math.sin(toRad(lng2 - lng1)) * Math.cos(toRad(lat2));
  const x = Math.cos(toRad(lat1)) * Math.sin(toRad(lat2)) - Math.sin(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.cos(toRad(lng2 - lng1));
  return (toDeg(Math.atan2(y, x)) + 360) % 360;
}
function interpolateAt(time, locs) {
  if (locs.length === 0) return null;
  if (locs.length === 1) return { lat: locs[0].latitude, lng: locs[0].longitude, bearing: 0 };
  const nextIdx = locs.findIndex((l) => new Date(l.timestamp).getTime() > time);
  if (nextIdx === -1) {
    const last = locs[locs.length - 1];
    return { lat: last.latitude, lng: last.longitude, bearing: 0 };
  }
  if (nextIdx === 0) {
    const first = locs[0];
    return { lat: first.latitude, lng: first.longitude, bearing: 0 };
  }
  const prev = locs[nextIdx - 1];
  const next = locs[nextIdx];
  const prevT = new Date(prev.timestamp).getTime();
  const nextT = new Date(next.timestamp).getTime();
  const frac = nextT === prevT ? 0 : (time - prevT) / (nextT - prevT);
  return {
    lat: prev.latitude + (next.latitude - prev.latitude) * frac,
    lng: prev.longitude + (next.longitude - prev.longitude) * frac,
    bearing: calcBearing(prev.latitude, prev.longitude, next.latitude, next.longitude)
  };
}
function ratePerRealMsForDuration(durationMs, targetSeconds = 30) {
  if (durationMs <= 0) return 10;
  return durationMs / (targetSeconds * 1e3);
}

// src/utils/crewMemberColor.ts
var CREW_MEMBER_PALETTE = [
  "#dc2626",
  // 0 Red
  "#c2410c",
  // 1 Orange
  "#b45309",
  // 2 Amber
  "#4d7c0f",
  // 3 Lime
  "#15803d",
  // 4 Green
  "#0f766e",
  // 5 Teal
  "#0e7490",
  // 6 Cyan
  "#2563eb",
  // 7 Blue
  "#4f46e5",
  // 8 Indigo
  "#7c3aed",
  // 9 Violet
  "#a21caf",
  // 10 Fuchsia
  "#db2777"
  // 11 Pink
];
var CREW_MEMBER_PALETTE_NAMES = [
  "Red",
  "Orange",
  "Amber",
  "Lime",
  "Green",
  "Teal",
  "Cyan",
  "Blue",
  "Indigo",
  "Violet",
  "Fuchsia",
  "Pink"
];
function fnv1a32(input) {
  let hash = 2166136261;
  for (let i = 0; i < input.length; i++) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
}
function crewMemberColorIndex(memberId) {
  return fnv1a32(memberId) % CREW_MEMBER_PALETTE.length;
}
function crewMemberColor(memberId, assignedColor) {
  if (assignedColor) return assignedColor;
  return CREW_MEMBER_PALETTE[crewMemberColorIndex(memberId)];
}
function crewMemberInitials(name) {
  const parts = (name ?? "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return (parts[0][0] ?? "?").toUpperCase();
  return `${parts[0][0] ?? ""}${parts[parts.length - 1][0] ?? ""}`.toUpperCase();
}

// src/utils/crewPuckKind.ts
var CREW_MOVING_SPEED_MPS = 0.5;
function resolveCrewPuckKind(flags) {
  if (flags.isStale) return "stale";
  if (flags.onProperty) return "onProperty";
  if (flags.isMoving) return "moving";
  return "idle";
}
function crewPuckStatusLabel(kind, speedMps) {
  if (kind === "onProperty") return "On property";
  if (kind === "moving") {
    const mph = speedMps != null && speedMps > CREW_MOVING_SPEED_MPS ? Math.round(speedMps * 2.23694) : null;
    return mph != null ? `Moving \xB7 ${mph} mph` : "Moving";
  }
  if (kind === "stale") return "Last seen";
  return "Idle";
}

// src/utils/crewPuckSpec.ts
var CREW_PUCK_COLORS = {
  white: "#ffffff",
  /** GREEN[700] — on-property plate fill and house glyph. */
  propertyPlate: "#15803d",
  /** GREEN[800] — plate shade. */
  propertyPlateEdge: "#166534",
  coreFrom: "#16a34a",
  coreTo: "#15803d",
  /** STONE[400] ring when stale. */
  staleRing: "#a8a29e",
  staleTo: "#78716c",
  /** Photo wash when stale (stone-400 at 45%). */
  staleWash: "rgba(168, 162, 158, 0.45)",
  /** STONE[700] pause bars. */
  pause: "#44403c",
  /** STONE[600] age chip text. */
  ageText: "#57534e",
  ageBg: "rgba(255, 255, 255, 0.92)",
  /** STONE[900] / STONE[500] hover label. */
  tooltipName: "#1c1917",
  tooltipStatus: "#78716c",
  shadow: "rgba(0, 0, 0, 0.35)",
  idleShadow: "rgba(0, 0, 0, 0.25)",
  /** +N chip fill (dark disc). */
  clusterFill: "#1c1917"
};
var CREW_PUCK = {
  /** Photo / initials diameter. */
  face: 28,
  /** Thin member-color ring. */
  colorRing: 2,
  /** No thick white ring around the idle pin. */
  whiteStroke: 0,
  /** Idle outer diameter (face + 2 × colorRing). */
  size: 32,
  /**
   * Layout box for overlays (cone, house tab, tooltip origin). Mapbox
   * anchors this box's center on the ping.
   */
  stage: 88,
  /**
   * Teardrop body — same 32pt as the idle pin. The SW corner of
   * `border-radius: 50% 50% 50% 0` is the heading pointer.
   */
  teardrop: 32,
  /**
   * Added to headingDeg so `border-radius: 50% 50% 50% 0` (pointer at SW)
   * faces north at heading 0. CSS rotate is clockwise from up.
   */
  teardropRotateOffset: -135,
  headingConeLength: 32,
  headingConeSpread: 48,
  headingConeOpacity: 0.22,
  idleBadge: 16,
  idleBadgeRight: -3,
  idleBadgeBottom: -2,
  /** Dark-green rounded-square plate (side, border included). */
  propertyPlate: 42,
  propertyPlateRadius: 11,
  propertyPlateBorder: 2,
  propertyPlatePad: 4,
  /** White home tab hanging under the plate. */
  propertyTabWidth: 20,
  propertyTabHeight: 14,
  propertyTabRadius: 6,
  propertyTabOverlap: 7,
  ageFontSize: 9,
  agePadX: 5,
  agePadY: 1,
  ageRadius: 4,
  ageGap: 8,
  initialsSize: 11,
  initialsWeight: "700",
  tooltipNameSize: 13,
  tooltipStatusSize: 11,
  tooltipRadius: 10,
  tooltipPadX: 10,
  tooltipPadY: 7,
  tooltipGap: 8,
  staleOpacity: 0.85,
  staleGrayscale: 0.55,
  ghostOpacity: 0.55
};
var CREW_PUCK_INNER = CREW_PUCK.face;
var CREW_PUCK_OUTER = CREW_PUCK.face + 2 * CREW_PUCK.colorRing;
var CREW_PUCK_SVG = {
  pause: {
    viewBox: "0 0 8 8",
    bars: [
      { x: 1.5, y: 1.2, width: 1.8, height: 5.6, rx: 0.6 },
      { x: 4.7, y: 1.2, width: 1.8, height: 5.6, rx: 0.6 }
    ]
  },
  /** Filled house glyph — dark green on the white tab. */
  house: {
    viewBox: "0 0 12 12",
    path: "M6 1.6 L11 6.1 V11 H7.6 V7.6 H4.4 V11 H1 V6.1 Z"
  }
};
var STALE_LOCATION_THRESHOLD_MS = 2 * 60 * 1e3;
var LONG_IDLE_THRESHOLD_MS = 60 * 60 * 1e3;
function crewPuckUsableAvatarUrl(url) {
  if (url == null) return null;
  const trimmed = url.trim();
  if (!trimmed) return null;
  const lower = trimmed.toLowerCase();
  if (lower.startsWith("data:")) {
    const comma = lower.indexOf(",");
    const header = comma === -1 ? lower.slice(5) : lower.slice(5, comma);
    if (header.startsWith("image/svg") || header.includes("svg+xml")) return null;
    return trimmed;
  }
  const pathOnly = lower.split(/[?#]/, 1)[0];
  if (pathOnly.endsWith(".svg")) return null;
  return trimmed;
}
function crewPuckTeardropRotate(headingDeg) {
  return headingDeg + CREW_PUCK.teardropRotateOffset;
}
function crewPuckHexRgba(hex, opacity) {
  const raw = hex.replace("#", "");
  const n = raw.length === 3 ? raw.split("").map((c) => c + c).join("") : raw;
  const r = Number.parseInt(n.slice(0, 2), 16);
  const g = Number.parseInt(n.slice(2, 4), 16);
  const b = Number.parseInt(n.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}
function crewPuckConePath(spreadDeg = CREW_PUCK.headingConeSpread, radius = CREW_PUCK.headingConeLength) {
  const cx = radius;
  const cy = radius;
  const half = spreadDeg * Math.PI / 180 / 2;
  const a1 = -Math.PI / 2 - half;
  const a2 = -Math.PI / 2 + half;
  const x1 = cx + radius * Math.cos(a1);
  const y1 = cy + radius * Math.sin(a1);
  const x2 = cx + radius * Math.cos(a2);
  const y2 = cy + radius * Math.sin(a2);
  return `M${cx} ${cy} L${x1} ${y1} A${radius} ${radius} 0 0 1 ${x2} ${y2} Z`;
}
function resolveCrewPuckPaint(input) {
  const now = input.now ?? Date.now();
  const kind = resolveCrewPuckKind({
    isStale: input.isStale,
    onProperty: input.onProperty,
    isMoving: input.isMoving
  });
  const stale = Boolean(input.isStale);
  const ageMs = input.lastUpdateTime != null ? Math.max(0, now - input.lastUpdateTime) : 0;
  const ghost = stale && input.lastUpdateTime != null && ageMs >= LONG_IDLE_THRESHOLD_MS;
  const ring = stale ? CREW_PUCK_COLORS.staleRing : input.color || CREW_PUCK_COLORS.propertyPlate;
  const headingDeg = input.heading ?? 0;
  const teardropRotate = crewPuckTeardropRotate(headingDeg);
  const usableAvatarUrl = crewPuckUsableAvatarUrl(input.avatarUrl);
  return {
    kind,
    ring,
    faceFill: usableAvatarUrl ? "transparent" : ring,
    stale,
    ghost,
    statusLabel: crewPuckStatusLabel(kind, input.speed),
    ageLabel: ghost ? crewPuckAgeLabel(ageMs / 1e3) : null,
    showHeading: kind === "moving" && input.heading !== void 0,
    headingDeg,
    showIdle: kind === "idle",
    showOnProperty: kind === "onProperty",
    coreOpacity: ghost ? CREW_PUCK.ghostOpacity : stale ? CREW_PUCK.staleOpacity : 1,
    coreGrayscale: stale ? CREW_PUCK.staleGrayscale : 0,
    showRingShadow: !ghost,
    teardropRotate,
    faceCounterRotate: -teardropRotate,
    coneFill: crewPuckHexRgba(ring, CREW_PUCK.headingConeOpacity),
    usableAvatarUrl
  };
}
function crewPuckAgeLabel(ageSeconds) {
  const seconds = Math.floor(ageSeconds);
  if (seconds < 10) return "Just now";
  if (seconds < 60) return `${seconds}s ago`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
  return `${Math.floor(seconds / 86400)}d ago`;
}
var CREW_CLUSTER = {
  pixelRadius: 44,
  size: 36,
  ring: 4,
  fontSize: 13,
  fontWeight: "700",
  fill: CREW_PUCK_COLORS.clusterFill,
  labelColor: CREW_PUCK_COLORS.white,
  /** Mapbox view-annotation / HTML-marker z so the chip beats visit pins. */
  zIndex: 20,
  crewZIndex: 10,
  visitZIndex: 1,
  /** Screen pixels from cluster origin to each fanned puck center. */
  fanRadius: 78,
  hubDot: 6,
  lineWidth: 1.5,
  lineColor: "rgba(255, 255, 255, 0.9)"
};
function crewClusterCountLabel(count) {
  return `+${count}`;
}
function crewClusterFanOffsets(count, radius = CREW_CLUSTER.fanRadius) {
  if (count <= 0) return [];
  const start = -Math.PI / 2;
  return Array.from({ length: count }, (_, i) => {
    const angle = start + 2 * Math.PI * i / count;
    return { x: Math.cos(angle) * radius, y: Math.sin(angle) * radius };
  });
}
function crewClusterFanSpokes(count, origin, radius = CREW_CLUSTER.fanRadius) {
  return crewClusterFanOffsets(count, radius).map((offset) => ({
    x1: origin,
    y1: origin,
    x2: origin + offset.x,
    y2: origin + offset.y
  }));
}
function crewClusterSpokeBar(spoke, weight = CREW_CLUSTER.lineWidth) {
  const dx = spoke.x2 - spoke.x1;
  const dy = spoke.y2 - spoke.y1;
  const length = Math.hypot(dx, dy);
  return {
    left: spoke.x1 + dx / 2 - length / 2,
    top: spoke.y1 + dy / 2 - weight / 2,
    width: length,
    height: weight,
    rotateDeg: Math.atan2(dy, dx) * 180 / Math.PI
  };
}
function crewClusterRingSlices(colors, size = CREW_CLUSTER.size, ring = CREW_CLUSTER.ring) {
  const unique = colors.length > 0 ? colors : [CREW_PUCK_COLORS.propertyPlate];
  const radius = (size - ring) / 2;
  const circ = 2 * Math.PI * radius;
  const slice = circ / unique.length;
  const gap = circ - slice;
  return unique.map((color, i) => ({
    color,
    dashArray: `${slice} ${gap}`,
    dashOffset: -i * slice
  }));
}
function crewClusterRingRadius(size = CREW_CLUSTER.size, ring = CREW_CLUSTER.ring) {
  return (size - ring) / 2;
}
function lngLatToWorldPx(lng, lat, zoom) {
  const scale = 256 * 2 ** zoom;
  const x = (lng + 180) / 360 * scale;
  const latRad = lat * Math.PI / 180;
  const y = (0.5 - Math.log(Math.tan(Math.PI / 4 + latRad / 2)) / (2 * Math.PI)) * scale;
  return { x, y };
}
function groupCrewPucksByPixel(points, radiusPx = CREW_CLUSTER.pixelRadius) {
  const used = new Array(points.length).fill(false);
  const groups = [];
  const r2 = radiusPx * radiusPx;
  for (let i = 0; i < points.length; i++) {
    if (used[i]) continue;
    used[i] = true;
    const group = [points[i].item];
    for (let j = i + 1; j < points.length; j++) {
      if (used[j]) continue;
      const dx = points[i].x - points[j].x;
      const dy = points[i].y - points[j].y;
      if (dx * dx + dy * dy < r2) {
        used[j] = true;
        group.push(points[j].item);
      }
    }
    groups.push(group);
  }
  return groups;
}
function groupCrewPucksAtZoom(items, zoom, radiusPx = CREW_CLUSTER.pixelRadius) {
  const points = items.map((item) => {
    const pt = lngLatToWorldPx(item.longitude, item.latitude, zoom);
    return { item, x: pt.x, y: pt.y };
  });
  return groupCrewPucksByPixel(points, radiusPx);
}

// src/utils/crewSort.ts
var compareCrewByNumber = (a, b) => {
  const numA = parseInt(a.name.match(/\d+/)?.[0] || "0", 10);
  const numB = parseInt(b.name.match(/\d+/)?.[0] || "0", 10);
  if (numA && numB) return numA - numB;
  return a.name.localeCompare(b.name);
};
var sortCrewsByNumber = (crews) => [...crews].sort(compareCrewByNumber);

// src/utils/dispatchJob.ts
function isDispatchJobActive(job) {
  if (job.status === "queued" /* QUEUED */ || job.status === "processing" /* PROCESSING */) {
    return true;
  }
  const completed = job.completedVisitCount ?? 0;
  const cancelled = job.cancelledVisitCount ?? 0;
  return job.createdCount > 0 && completed + cancelled < job.createdCount;
}
function dispatchJobInProgressCount(job) {
  const completed = job.completedVisitCount ?? 0;
  const cancelled = job.cancelledVisitCount ?? 0;
  return Math.max(0, (job.createdCount ?? 0) - (completed + cancelled));
}
function dispatchJobCoversTemplate(job, service) {
  if (service.serviceTemplateId && job.serviceTemplateIds?.includes(service.serviceTemplateId)) {
    return true;
  }
  return !!(service.serviceTemplateName && job.serviceTemplateNames?.includes(service.serviceTemplateName));
}

// src/utils/aerialImagery.ts
function getWebMercatorBbox(lng, lat, zoom, size) {
  const metersPerPx = 156543.03 * Math.cos(lat * Math.PI / 180) / Math.pow(2, zoom);
  const halfExtent = size / 2 * metersPerPx;
  const x = lng * 2003750834e-2 / 180;
  const y = Math.log(Math.tan((90 + lat) * Math.PI / 360)) * 2003750834e-2 / Math.PI;
  return {
    minX: x - halfExtent,
    minY: y - halfExtent,
    maxX: x + halfExtent,
    maxY: y + halfExtent
  };
}
function getWgs84Bbox(lng, lat, zoom, size) {
  const metersPerPx = 156543.03 * Math.cos(lat * Math.PI / 180) / Math.pow(2, zoom);
  const halfExtentMeters = size / 2 * metersPerPx;
  const latDelta = halfExtentMeters / 111320;
  const lngDelta = halfExtentMeters / (111320 * Math.cos(lat * Math.PI / 180));
  return {
    minLng: lng - lngDelta,
    minLat: lat - latDelta,
    maxLng: lng + lngDelta,
    maxLat: lat + latDelta
  };
}
function generateArcgisUrl(lng, lat, zoom, size) {
  const bbox = getWebMercatorBbox(lng, lat, zoom, size);
  const params = new URLSearchParams({
    bbox: `${bbox.minX},${bbox.minY},${bbox.maxX},${bbox.maxY}`,
    bboxSR: "3857",
    size: `${size},${size}`,
    imageSR: "3857",
    format: "png",
    f: "image"
  });
  return `https://services.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/export?${params}`;
}
function generateGoogleUrl(lng, lat, zoom, size, apiKey) {
  const params = new URLSearchParams({
    center: `${lat},${lng}`,
    zoom: zoom.toString(),
    size: `${size}x${size}`,
    maptype: "satellite",
    key: apiKey
  });
  return `https://maps.googleapis.com/maps/api/staticmap?${params}`;
}
function generateMapboxUrl(lng, lat, zoom, size, accessToken) {
  return `https://api.mapbox.com/styles/v1/mapbox/satellite-v9/static/${lng},${lat},${zoom},0,0/${size}x${size}?access_token=${accessToken}`;
}
function generateMngeoUrl(lng, lat, zoom, size, layerId) {
  const bbox = getWgs84Bbox(lng, lat, zoom, size);
  const params = new URLSearchParams({
    SERVICE: "WMS",
    REQUEST: "GetMap",
    VERSION: "1.1.1",
    LAYERS: layerId,
    STYLES: "",
    FORMAT: "image/jpeg",
    BBOX: `${bbox.minLng},${bbox.minLat},${bbox.maxLng},${bbox.maxLat}`,
    WIDTH: size.toString(),
    HEIGHT: size.toString(),
    SRS: "EPSG:4326"
  });
  return `https://imageserver.gisdata.mn.gov/cgi-bin/wms?${params}`;
}
function generateAerialImageryUrls(options) {
  const { lng, lat, zoom = 18, size = 600, apiKeys } = options;
  const urls = {
    // Always available (free)
    arcgis: generateArcgisUrl(lng, lat, zoom, size),
    // MnGeo layers (free, Minnesota high-resolution)
    mngeo_fsa2023: generateMngeoUrl(lng, lat, zoom, size, "fsa2023"),
    mngeo_fsa2021: generateMngeoUrl(lng, lat, zoom, size, "fsa2021"),
    mngeo_met20: generateMngeoUrl(lng, lat, zoom, size, "met20"),
    mngeo_hen22: generateMngeoUrl(lng, lat, zoom, size, "hen22"),
    mngeo_hen18: generateMngeoUrl(lng, lat, zoom, size, "hen18"),
    mngeo_dak23: generateMngeoUrl(lng, lat, zoom, size, "dak23")
  };
  if (apiKeys?.google) {
    urls.google = generateGoogleUrl(lng, lat, zoom, size, apiKeys.google);
  }
  if (apiKeys?.mapbox) {
    urls.mapbox = generateMapboxUrl(lng, lat, zoom, size, apiKeys.mapbox);
  }
  return urls;
}
var IMAGERY_SOURCE_INFO = {
  mngeo_hen22: { label: "MnGeo Hennepin 2022", resolution: "6-inch", coverage: "Hennepin County" },
  mngeo_hen18: { label: "MnGeo Hennepin 2018", resolution: "3-inch", coverage: "Hennepin County" },
  mngeo_dak23: { label: "MnGeo Dakota 2023", resolution: "6-inch", coverage: "Dakota County" },
  mngeo_met20: { label: "MnGeo Metro 2020", resolution: "1-foot", coverage: "Twin Cities Metro" },
  mngeo_fsa2023: { label: "MnGeo FSA 2023", resolution: "0.3m", coverage: "Minnesota" },
  mngeo_fsa2021: { label: "MnGeo FSA 2021", resolution: "0.6m", coverage: "Minnesota" },
  arcgis: { label: "ArcGIS World Imagery", resolution: "~1m", coverage: "Global" },
  google: { label: "Google Maps", resolution: "~1m", coverage: "Global" },
  mapbox: { label: "Mapbox Satellite", resolution: "~1m", coverage: "Global" },
  naip_ndvi: { label: "NAIP NDVI Vegetation", resolution: "1m", coverage: "Continental US" }
};
var MNGEO_LAYER_IDS = {
  mngeo_fsa2023: "fsa2023",
  mngeo_fsa2021: "fsa2021",
  mngeo_met20: "met20",
  mngeo_hen22: "hen22",
  mngeo_hen18: "hen18",
  mngeo_dak23: "dak23"
};
async function fetchImageryAsBase64(options) {
  const { lng, lat, source, zoom = 18, size = 600, apiKeys } = options;
  let url;
  if (source.startsWith("mngeo_")) {
    const layerId = MNGEO_LAYER_IDS[source];
    if (!layerId) {
      throw new Error(`Unknown MnGeo layer: ${source}`);
    }
    url = generateMngeoUrl(lng, lat, zoom, size, layerId);
  } else if (source === "arcgis") {
    url = generateArcgisUrl(lng, lat, zoom, size);
  } else if (source === "google") {
    if (!apiKeys?.google) {
      throw new Error("Google API key required for Google imagery");
    }
    url = generateGoogleUrl(lng, lat, zoom, size, apiKeys.google);
  } else if (source === "mapbox") {
    if (!apiKeys?.mapbox) {
      throw new Error("Mapbox access token required for Mapbox imagery");
    }
    url = generateMapboxUrl(lng, lat, zoom, size, apiKeys.mapbox);
  } else {
    throw new Error(`Unknown imagery source: ${source}`);
  }
  const response = await fetch(url, {
    headers: {
      "User-Agent": "Ruta-API/1.0"
    }
  });
  if (!response.ok) {
    throw new Error(`Failed to fetch imagery: HTTP ${response.status}`);
  }
  const contentType = response.headers.get("content-type") ?? "";
  if (contentType.includes("xml")) {
    const text = await response.text();
    throw new Error(`Imagery service returned error: ${text.slice(0, 200)}`);
  }
  const arrayBuffer = await response.arrayBuffer();
  if (arrayBuffer.byteLength < 1e3) {
    throw new Error("Imagery service returned empty or invalid image");
  }
  const base64 = Buffer.from(arrayBuffer).toString("base64");
  const effectiveZoom = source === "mapbox" ? zoom + 1 : zoom;
  const bbox = getWgs84Bbox(lng, lat, effectiveZoom, size);
  return {
    imageBase64: base64,
    bbox,
    source
  };
}
function getBestMngeoLayer(lat, lng, city) {
  if (city) {
    const cityLower = city.toLowerCase();
    const hennepinCities = [
      "minneapolis",
      "edina",
      "bloomington",
      "eden prairie",
      "plymouth",
      "minnetonka",
      "st. louis park",
      "richfield",
      "golden valley",
      "hopkins",
      "brooklyn park",
      "maple grove",
      "brooklyn center",
      "crystal",
      "new hope",
      "robbinsdale",
      "st louis park"
    ];
    if (hennepinCities.some((c) => cityLower.includes(c))) {
      return "mngeo_hen22";
    }
    const dakotaCities = [
      "lakeville",
      "eagan",
      "burnsville",
      "apple valley",
      "rosemount",
      "farmington",
      "inver grove heights",
      "south st. paul",
      "west st. paul",
      "hastings",
      "mendota heights"
    ];
    if (dakotaCities.some((c) => cityLower.includes(c))) {
      return "mngeo_dak23";
    }
  }
  const metroBbox = {
    minLat: 44.73,
    maxLat: 45.3,
    minLng: -93.7,
    maxLng: -92.75
  };
  if (lat >= metroBbox.minLat && lat <= metroBbox.maxLat && lng >= metroBbox.minLng && lng <= metroBbox.maxLng) {
    return "mngeo_met20";
  }
  return "mngeo_fsa2023";
}

// src/utils/geofence.ts
var WORK_ZONE_CLUSTER_THRESHOLD_M = 60;
function isOutsideVisitGeofence(point, visit) {
  if (visit.parcelBoundaries && visit.parcelBoundaries.length >= 3) {
    return !pointInPolygon(point, visit.parcelBoundaries);
  }
  if (visit.customerCoordinates) {
    const radiusM = visit.customerGeofenceRadiusM ?? MIN_GEOFENCE_RADIUS_M;
    return haversineDistance(point, visit.customerCoordinates) > radiusM;
  }
  return false;
}
function distanceOutsideVisitGeofenceM(point, visit) {
  if (!isOutsideVisitGeofence(point, visit)) return 0;
  if (visit.parcelBoundaries && visit.parcelBoundaries.length >= 3) {
    return distanceToPolygonEdgeM(point, visit.parcelBoundaries);
  }
  if (visit.customerCoordinates) {
    const radiusM = visit.customerGeofenceRadiusM ?? MIN_GEOFENCE_RADIUS_M;
    return Math.max(0, haversineDistance(point, visit.customerCoordinates) - radiusM);
  }
  return 0;
}
function distanceToPolygonEdgeM(point, polygon) {
  let min = Infinity;
  const n = polygon.length;
  for (let i = 0; i < n; i++) {
    const a = polygon[i];
    const b = polygon[(i + 1) % n];
    if (a[0] === b[0] && a[1] === b[1]) continue;
    const { closest } = pointToSegmentClosest(
      point,
      [a[0], a[1]],
      [b[0], b[1]],
      point[1]
    );
    const d = haversineDistance(point, closest);
    if (d < min) min = d;
  }
  return min === Infinity ? 0 : min;
}
function round6(n) {
  return Math.round(n * 1e6) / 1e6;
}
function computePropertyGeofence(coordinates, boundaries) {
  if (boundaries && boundaries.length >= 3) {
    const center = calculatePolygonCentroid(boundaries);
    return {
      geofenceCenter: [round6(center[0]), round6(center[1])],
      geofenceRadiusM: Math.round(clampGeofenceRadiusM(boundingCircleRadiusM(center, boundaries)))
    };
  }
  return {
    geofenceCenter: [round6(coordinates[0]), round6(coordinates[1])],
    geofenceRadiusM: MIN_GEOFENCE_RADIUS_M
  };
}
function computeWorkZones(properties, thresholdM = WORK_ZONE_CLUSTER_THRESHOLD_M) {
  const geocoded = properties.filter(
    (p) => !!p.geofenceCenter
  );
  const assignments = /* @__PURE__ */ new Map();
  if (geocoded.length === 0) return assignments;
  const centers = geocoded.map((p) => p.geofenceCenter);
  const labels = clusterByDistance(centers, thresholdM);
  const clusters = /* @__PURE__ */ new Map();
  labels.forEach((label, i) => {
    const members = clusters.get(label) ?? [];
    members.push(i);
    clusters.set(label, members);
  });
  for (const memberIdxs of clusters.values()) {
    const members = memberIdxs.map((i) => geocoded[i]);
    const memberCenters = memberIdxs.map((i) => centers[i]);
    const workZoneId = members.reduce((min, p) => p.id < min ? p.id : min, members[0].id);
    const centroid = calculatePolygonCentroid(memberCenters);
    const workZoneCenter = [round6(centroid[0]), round6(centroid[1])];
    let radius = 0;
    for (const m of members) {
      const reach = haversineDistance(workZoneCenter, m.geofenceCenter) + (m.geofenceRadiusM ?? MIN_GEOFENCE_RADIUS_M);
      if (reach > radius) radius = reach;
    }
    const workZoneRadiusM = Math.round(clampGeofenceRadiusM(radius));
    for (const m of members) assignments.set(m.id, { workZoneId, workZoneCenter, workZoneRadiusM });
  }
  return assignments;
}

// src/utils/boundaryCrossing.ts
var BOUNDARY_REENTRY_WINDOW_MS = 5 * 6e4;
var EMPTY_BOUNDARY_SESSION = { isInside: false };
function advanceBoundaryCrossing(session, transition, reentryWindowMs = BOUNDARY_REENTRY_WINDOW_MS) {
  if (transition.type === "enter") {
    if (session.isInside) return session;
    const isFlap = session.firstEntryAt !== void 0 && session.lastExitAt !== void 0 && new Date(transition.timestamp).getTime() - new Date(session.lastExitAt).getTime() <= reentryWindowMs;
    return {
      isInside: true,
      firstEntryAt: isFlap ? session.firstEntryAt : transition.timestamp,
      lastExitAt: void 0
    };
  }
  if (!session.isInside) return session;
  return {
    isInside: false,
    firstEntryAt: session.firstEntryAt,
    lastExitAt: transition.timestamp
  };
}
function selectPromptCrossing(session) {
  if (session.isInside) {
    return session.firstEntryAt ? { type: "enter", timestamp: session.firstEntryAt } : void 0;
  }
  return session.lastExitAt ? { type: "exit", timestamp: session.lastExitAt } : void 0;
}

// src/utils/locationPermissionGate.ts
function resolveLocationGateAction(state) {
  const { foregroundGranted, backgroundGranted, preciseGranted, canAskAgain } = state;
  if (foregroundGranted && backgroundGranted && preciseGranted) {
    return "allow";
  }
  const preciseOnly = foregroundGranted && backgroundGranted && !preciseGranted;
  if (preciseOnly || !canAskAgain) {
    return "open-settings";
  }
  return "request";
}

// src/utils/batteryRestriction.ts
var OEM_APP_SLEEP_MANUFACTURERS = ["samsung"];
function hasOemAppSleepLayer(manufacturer) {
  if (!manufacturer) return false;
  const normalized = manufacturer.trim().toLowerCase();
  if (!normalized) return false;
  return OEM_APP_SLEEP_MANUFACTURERS.some((known) => normalized.startsWith(known));
}
function resolveBatteryRestrictionPrompt(state) {
  const { isAndroid, isClockedIn, batteryOptimized, dismissedThisShift, manufacturer } = state;
  if (!isAndroid) return "none";
  if (!isClockedIn) return "none";
  if (batteryOptimized !== true) return "none";
  if (dismissedThisShift) return "none";
  return hasOemAppSleepLayer(manufacturer) ? "oem-sleep" : "standard";
}

// src/utils/trailThinning.ts
function thinTrailByMinSpacing(points, minSpacingSeconds) {
  if (points.length <= 2) {
    return points;
  }
  const minSpacingMs = minSpacingSeconds * 1e3;
  const kept = [points[0]];
  let lastKeptTime = new Date(points[0].timestamp).getTime();
  for (let i = 1; i < points.length - 1; i++) {
    const time = new Date(points[i].timestamp).getTime();
    if (time - lastKeptTime >= minSpacingMs) {
      kept.push(points[i]);
      lastKeptTime = time;
    }
  }
  kept.push(points[points.length - 1]);
  return kept;
}

// src/utils/sam3Client.ts
var SAM3_API_URL = "https://serverless.roboflow.com/sam3/concept_segment";
var DEFAULT_SEGMENT_CONCEPTS = [
  "grass",
  "driveway",
  "sidewalk"
];
var CONCEPT_TO_TYPE = {
  grass: "turf" /* TURF */,
  driveway: "driveway" /* DRIVEWAY */,
  sidewalk: "sidewalk" /* SIDEWALK */
};
async function runSam3Inference(imageBase64, concepts, apiKey) {
  const prompts = concepts.map((concept) => ({
    type: "text",
    text: concept
  }));
  const payload = {
    image: {
      type: "base64",
      value: imageBase64
    },
    prompts,
    output_format: "polygon"
  };
  const url = `${SAM3_API_URL}?api_key=${encodeURIComponent(apiKey)}`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(payload)
  });
  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(
      `SAM3 API error: ${response.status} - ${errorText.slice(0, 500)}`
    );
  }
  return response.json();
}
function parseSam3Response(sam3Response, bbox, imageSize, parcelBoundary) {
  const measurements = [];
  const promptResults = sam3Response.prompt_results ?? sam3Response.results ?? [];
  for (const promptResult of promptResults) {
    let concept = promptResult.echo?.text ?? promptResult.prompt?.text ?? "unknown";
    concept = concept.toLowerCase();
    if (!(concept in CONCEPT_TO_TYPE)) {
      continue;
    }
    const measurementType = CONCEPT_TO_TYPE[concept];
    for (let predIdx = 0; predIdx < promptResult.predictions.length; predIdx++) {
      const pred = promptResult.predictions[predIdx];
      if (!pred.masks) continue;
      for (let maskIdx = 0; maskIdx < pred.masks.length; maskIdx++) {
        const pixelCoords = pred.masks[maskIdx];
        if (pixelCoords.length < 3) continue;
        const geoCoords = pixelPolygonToGeo(pixelCoords, bbox, imageSize);
        if (geoCoords.length > 0 && (geoCoords[0][0] !== geoCoords[geoCoords.length - 1][0] || geoCoords[0][1] !== geoCoords[geoCoords.length - 1][1])) {
          geoCoords.push([...geoCoords[0]]);
        }
        const simplifiedCoords = simplifyPolygon(geoCoords);
        if (simplifiedCoords.length < 4) continue;
        if (parcelBoundary && !polygonCentroidInBoundary(simplifiedCoords, parcelBoundary)) {
          continue;
        }
        const sqft = calculatePolygonAreaSqft(simplifiedCoords);
        if (sqft < 10) continue;
        const measurement = {
          type: measurementType,
          polygon: simplifiedCoords,
          sqft
        };
        if (predIdx > 0 || maskIdx > 0) {
          measurement.name = `${concept.charAt(0).toUpperCase() + concept.slice(1)} ${predIdx + 1}`;
        }
        measurements.push(measurement);
      }
    }
  }
  return measurements;
}
async function segmentImage(imageBase64, bbox, imageSize, apiKey, options) {
  const concepts = options?.concepts ?? [...DEFAULT_SEGMENT_CONCEPTS];
  const response = await runSam3Inference(imageBase64, concepts, apiKey);
  return parseSam3Response(
    response,
    bbox,
    imageSize,
    options?.parcelBoundary
  );
}

// src/utils/aggregateMeasurementMetrics.ts
function aggregateMeasurementMetrics(measurements) {
  const metrics = zeroFilledMetrics();
  for (const m of measurements) {
    const key = METRIC_TYPE_TO_KEY[m.type];
    if (!key) continue;
    metrics[key] = (metrics[key] ?? 0) + m.sqft;
  }
  return metrics;
}

// src/utils/badgeCount.ts
function toBadgeCount(unreadCount) {
  if (!Number.isFinite(unreadCount) || unreadCount <= 0) {
    return 0;
  }
  return Math.floor(unreadCount);
}

// src/utils/customerNotifications.ts
var DEFAULT_NOTIFICATION_SETTINGS = {
  serviceReminders: true,
  generalCommunications: true
};
var NOTIFICATION_TYPE_TO_PREFERENCE = {
  // Service Reminders - visit-related notifications (upcoming and completed)
  ["visit_reminder" /* VISIT_REMINDER */]: "serviceReminders",
  ["visit_scheduled" /* VISIT_SCHEDULED */]: "serviceReminders",
  ["visit_started" /* VISIT_STARTED */]: "serviceReminders",
  ["visit_paused" /* VISIT_PAUSED */]: "serviceReminders",
  ["visit_resumed" /* VISIT_RESUMED */]: "serviceReminders",
  ["visit_completed" /* VISIT_COMPLETED */]: "serviceReminders",
  ["visit_skipped" /* VISIT_SKIPPED */]: "serviceReminders",
  ["visit_rescheduled" /* VISIT_RESCHEDULED */]: "serviceReminders",
  ["visit_followup_created" /* VISIT_FOLLOWUP_CREATED */]: "serviceReminders",
  ["service_completed" /* SERVICE_COMPLETED */]: "serviceReminders",
  ["service_suspended" /* SERVICE_SUSPENDED */]: "serviceReminders",
  ["service_cancelled" /* SERVICE_CANCELLED */]: "serviceReminders",
  ["subscription_rate_provided" /* SUBSCRIPTION_RATE_PROVIDED */]: "serviceReminders",
  ["subscription_batch_rates_released" /* SUBSCRIPTION_BATCH_RATES_RELEASED */]: "serviceReminders",
  // The "rates aren't ready yet" acknowledgment sits with its siblings: a
  // customer who has turned service reminders off does not get it either (RUT-2614).
  ["subscription_rate_not_yet_available" /* SUBSCRIPTION_RATE_NOT_YET_AVAILABLE */]: "serviceReminders",
  // General Communications - promotions and company updates
  // Portal-login reminders are a soft nudge, not service-critical, so a customer
  // who opts out of general communications stops receiving them (RUT-2973).
  ["customer_portal_login_reminder" /* CUSTOMER_PORTAL_LOGIN_REMINDER */]: "generalCommunications",
  // The welcome greeting is a company introduction rather than something the
  // customer transacted for, so an opt-out may silence it (RUT-3371). Mapping it
  // here is what stops a customer who has turned off general communications from
  // being greeted by the automatic signup welcome; the separate per-customer pause
  // above stops it too. New customers default to generalCommunications on, so an
  // ordinary signup is unaffected. The operator-facing do-not-contact deactivation
  // (RUT-3075) ALREADY gates this category — see the generalCommunications branch in
  // shouldSendCustomerNotification below — so mapping the greeting here is also what
  // makes a deactivated profile go ungreeted.
  //
  // This is the opt-out axis only. On the SMS BILLING axis the welcome is still
  // transactional — its segments are built into the plan rather than counted against
  // the org's allowance (see NotificationService.sendSmsNotification). The two
  // classifications answer different questions and are both correct.
  ["customer_welcome" /* CUSTOMER_WELCOME */]: "generalCommunications"
};
var PAYMENT_NOTIFICATION_TYPES = /* @__PURE__ */ new Set([
  "payment_successful" /* PAYMENT_SUCCESSFUL */,
  "payment_failed" /* PAYMENT_FAILED */,
  "customer_add_card_reminder" /* CUSTOMER_ADD_CARD_REMINDER */,
  "payment_retry" /* PAYMENT_RETRY */,
  "payment_overdue" /* PAYMENT_OVERDUE */,
  "invoice_ready" /* INVOICE_READY */
]);
var ESSENTIAL_NOTIFICATION_TYPES = /* @__PURE__ */ new Set([
  "admin_message" /* ADMIN_MESSAGE */,
  "service_activated" /* SERVICE_ACTIVATED */,
  "service_enrollment_scheduled" /* SERVICE_ENROLLMENT_SCHEDULED */,
  ...PAYMENT_NOTIFICATION_TYPES
]);
function isEssentialNotificationType(notificationType) {
  return ESSENTIAL_NOTIFICATION_TYPES.has(notificationType);
}
function isPaymentNotificationType(notificationType) {
  return PAYMENT_NOTIFICATION_TYPES.has(notificationType);
}
var ESSENTIAL_NOTIFICATION_CATEGORIES = [
  {
    id: "directMessages",
    title: "Direct messages",
    description: "Personal messages sent to you directly by your service provider."
  },
  {
    id: "serviceStart",
    title: "Season & service-start reminders",
    description: "A heads-up when a seasonal service is about to begin again."
  },
  {
    id: "billing",
    title: "Billing & payments",
    description: "Anything involving money \u2014 receipts, a failed charge, an overdue balance, or a card that needs updating."
  }
];
var ESSENTIAL_NOTIFICATIONS_EXPLANATION = "Turning notifications off still leaves a basic level of essential communication in place. These always reach you and can\u2019t be turned off:";
function hasOutstandingBalance(customer) {
  return !!customer.balance && customer.balance.current > 0;
}
function isCustomerDeactivated(customer) {
  return !!customer?.deactivation;
}
function getPreferenceCategoryForNotificationType(notificationType) {
  return NOTIFICATION_TYPE_TO_PREFERENCE[notificationType] ?? null;
}
function getEffectiveNotificationSettings(customer) {
  if (!customer?.notificationSettings) {
    return DEFAULT_NOTIFICATION_SETTINGS;
  }
  return {
    ...DEFAULT_NOTIFICATION_SETTINGS,
    ...customer.notificationSettings
  };
}
function shouldSendCustomerNotification(customer, notificationType) {
  if (!customer) {
    return true;
  }
  if (customer.pauseNotifications && notificationType !== "admin_message" /* ADMIN_MESSAGE */) {
    const allowForOutstandingBalance = isPaymentNotificationType(notificationType) && hasOutstandingBalance(customer);
    if (!allowForOutstandingBalance) {
      return false;
    }
  }
  if (isEssentialNotificationType(notificationType)) {
    return true;
  }
  const category = getPreferenceCategoryForNotificationType(notificationType);
  if (!category) {
    return true;
  }
  if (category === "generalCommunications" && isCustomerDeactivated(customer)) {
    return false;
  }
  const settings = getEffectiveNotificationSettings(customer);
  return settings[category] === true;
}

// src/utils/customerQuestions.ts
function isMultiChoiceOption(option) {
  return option.rateType === "multi-select" /* MULTI_SELECT */ && option.selectionMode === "multiple";
}
function toggleChoiceSelection(current, choiceId, mode) {
  if (mode === "multiple") {
    return current.includes(choiceId) ? current.filter((id) => id !== choiceId) : [...current, choiceId];
  }
  return current.includes(choiceId) ? [] : [choiceId];
}
function needsCustomerAnswers(template, subscription) {
  const questions = (template?.serviceOptions || []).filter(
    (o) => o.customerSelectable
  );
  if (questions.length === 0) return false;
  const answered = new Set(
    (subscription?.customerSelectedOptions || []).map((a) => a.optionId)
  );
  return questions.some((q) => !answered.has(q.id));
}
var OPTION_STATE_VALUES = [
  "yes",
  "no",
  "unset"
];
function isOptionState(value) {
  return OPTION_STATE_VALUES.includes(value);
}
function isCustomerSelectableFlatOption(option) {
  return option.customerSelectable === true && option.rateType === "flat" /* FLAT */;
}
function listCustomerSelectableFlatOptions(serviceOptions) {
  return (serviceOptions || []).filter(isCustomerSelectableFlatOption);
}
function customerSelectedOptionStateToken(optionId, state) {
  return `${optionId}:${state}`;
}
function parseCustomerSelectedOptionStateToken(token) {
  const trimmed = token.trim();
  const idx = trimmed.lastIndexOf(":");
  if (idx <= 0) return null;
  const optionId = trimmed.slice(0, idx);
  const state = trimmed.slice(idx + 1);
  if (!optionId || !isOptionState(state)) return null;
  return { optionId, state };
}
function buildCustomerSelectedOptionStates(serviceOptions, customerSelectedOptions) {
  const questions = listCustomerSelectableFlatOptions(serviceOptions);
  if (questions.length === 0) return [];
  const byId = new Map(
    (customerSelectedOptions || []).map((row) => [row.optionId, row])
  );
  return questions.map((option) => {
    const row = byId.get(option.id);
    if (!row) return customerSelectedOptionStateToken(option.id, "unset");
    return customerSelectedOptionStateToken(
      option.id,
      row.enabled === true ? "yes" : "no"
    );
  });
}
function upsertCustomerSelectedOptionState(tokens, optionId, state) {
  const rest = (tokens || []).filter((token) => {
    const parsed = parseCustomerSelectedOptionStateToken(token);
    return !parsed || parsed.optionId !== optionId;
  });
  if (!state) return rest.length ? rest : void 0;
  return [...rest, customerSelectedOptionStateToken(optionId, state)];
}
function buildCustomerSelectedOptionLabels(serviceOptions, customerSelectedOptions) {
  if (!serviceOptions?.length || !customerSelectedOptions?.length) return [];
  const labels = [];
  for (const selection of customerSelectedOptions) {
    const option = serviceOptions.find((o) => o.id === selection.optionId);
    if (!option?.customerSelectable) continue;
    if (option.rateType === "multi-select" /* MULTI_SELECT */) {
      const chosenIds = selection.choiceIds && selection.choiceIds.length > 0 ? selection.choiceIds : selection.choiceId ? [selection.choiceId] : [];
      const names = chosenIds.map((id) => option.choices?.find((c) => c.id === id)?.name).filter((n) => !!n);
      if (names.length > 0) labels.push(`${option.name}: ${names.join(", ")}`);
    } else if (selection.enabled) {
      labels.push(`${option.name}: Yes`);
    }
  }
  return labels;
}

// src/utils/referralSource.ts
function resolveReferralSourceDisplay(referrerSource) {
  const trimmed = referrerSource?.trim();
  return trimmed ? trimmed : null;
}

// src/utils/oneOffSchedule.ts
function buildOneOffScheduleInput(form, bounds = {}) {
  const dateBounds = {
    effectiveFrom: bounds.effectiveFrom,
    effectiveUntil: bounds.effectiveUntil
  };
  if (form.type === "limited") {
    if (!Number.isInteger(form.visitLimit) || form.visitLimit < 1) return null;
    return { type: "limited", visitLimit: form.visitLimit, ...dateBounds };
  }
  if (form.type === "onDemand") {
    return {
      type: "recurring",
      frequency: "on_demand" /* ON_DEMAND */,
      ...dateBounds
    };
  }
  const seasonRestriction = form.periodIds && form.periodIds.length > 0 ? { periodIds: [...form.periodIds] } : {};
  if (form.frequency === "custom" /* CUSTOM */) {
    if (form.customInterval === void 0 || !Number.isInteger(form.customInterval) || form.customInterval < 1 || form.customUnit === void 0) {
      return null;
    }
    return {
      type: "recurring",
      frequency: "custom" /* CUSTOM */,
      customConfig: { interval: form.customInterval, unit: form.customUnit },
      ...dateBounds,
      ...seasonRestriction
    };
  }
  return { type: "recurring", frequency: form.frequency, ...dateBounds, ...seasonRestriction };
}

// src/utils/html.ts
function stripHtmlTags(html) {
  const separated = html.replace(
    /(<\/?(?:address|article|aside|blockquote|br|dd|div|dl|dt|figcaption|figure|footer|h[1-6]|header|hr|li|main|nav|ol|p|pre|section|table|tbody|td|tfoot|th|thead|tr|ul)\b)/gi,
    " $1"
  );
  let text;
  if (typeof DOMParser !== "undefined") {
    text = new DOMParser().parseFromString(separated, "text/html").body.textContent || "";
  } else {
    text = decodeHtmlEntities(separated.replace(/<(?:[^>"']|"[^"]*"|'[^']*')*>/g, ""));
  }
  return text.replace(/[^\S\n]+/g, " ").replace(/ ?\n ?/g, "\n").replace(/\n{3,}/g, "\n\n").trim();
}
function escapeHtml(value) {
  return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}
var NAMED_ENTITIES = {
  "&nbsp;": " ",
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">",
  "&quot;": '"',
  "&apos;": "'"
};
function decodeHtmlEntities(text) {
  return text.replace(/&nbsp;|&amp;|&lt;|&gt;|&quot;|&apos;/g, (match) => NAMED_ENTITIES[match]).replace(/&#(\d+);/g, (_, dec) => String.fromCodePoint(Number(dec))).replace(/&#x([0-9a-fA-F]+);/g, (_, hex) => String.fromCodePoint(parseInt(hex, 16)));
}

// src/utils/termsContent.ts
function normalizeTermsHtml(html) {
  if (!html) return "";
  return html.replace(/\r\n/g, "\n").replace(/<br\s*\/?>/gi, "<br>").replace(/\s+class="[^"]*"/gi, "").replace(/\s+class='[^']*'/gi, "").replace(/\s+style="[^"]*"/gi, "").replace(/\s+style='[^']*'/gi, "").replace(/\s+target="[^"]*"/gi, "").replace(/\s+rel='[^']*'/gi, "").replace(/\s+rel="[^"]*"/gi, "").replace(/&nbsp;/gi, " ").replace(/&#160;/g, " ").replace(/\s+/g, " ").replace(/>\s+</g, "><").replace(/<p>\s*<\/p>/gi, "").trim().toLowerCase();
}
function hasTermsContentChanged(previous, next) {
  if (next === void 0 || next === null) return false;
  return normalizeTermsHtml(previous) !== normalizeTermsHtml(next);
}
function previousTermsStampToRetain(previousStamp, newStamp, existingAcceptedAt) {
  if (!previousStamp || previousStamp === newStamp) return null;
  if (existingAcceptedAt.includes(previousStamp)) return null;
  return previousStamp;
}
function inheritedSubscriptionTermsAcceptedAt(args) {
  if (args.existingSubscriptionStamp) return args.existingSubscriptionStamp;
  if (args.impersonating) return void 0;
  return args.customerAcceptedAt ?? args.now;
}
function termsAcceptanceTimelineEvents(acceptances) {
  const seen = /* @__PURE__ */ new Set();
  const events = [];
  for (const acceptance of acceptances) {
    if (!acceptance.acceptedAt || seen.has(acceptance.acceptedAt)) continue;
    seen.add(acceptance.acceptedAt);
    events.push({ timestamp: acceptance.acceptedAt, label: "Terms Accepted" });
  }
  return events;
}

// src/utils/campaignAttachmentTokens.ts
var PHOTO_TOKEN_REGEX = /\[photo:\s*([^\]]+?)\s*\]/g;
function escapeHtmlAttr(value) {
  return value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function renderImg(a) {
  const src = escapeHtmlAttr(a.url);
  const alt = escapeHtmlAttr(a.fileName || "attachment");
  return `<img src="${src}" alt="${alt}" style="max-width:100%;height:auto;border-radius:8px;display:block;margin:12px 0" />`;
}
function renderFileLink(a) {
  const href = escapeHtmlAttr(a.url);
  const name = escapeHtmlAttr(a.fileName || "attachment");
  return `<a href="${href}" target="_blank" rel="noopener" style="display:inline-block;margin:12px 0;padding:10px 14px;background:#f3f4f6;border:1px solid #e5e7eb;border-radius:8px;color:#111827;text-decoration:none;font-weight:500">\u{1F4CE} ${name}</a>`;
}
function renderAttachment(a) {
  return (a.contentType || "").toLowerCase().startsWith("image/") ? renderImg(a) : renderFileLink(a);
}
function buildPhotoToken(attachment) {
  return `[photo: ${attachment.fileName || "attachment"}]`;
}
function expandAttachmentTokens(html, attachments) {
  const list = attachments ?? [];
  if (list.length === 0) return html;
  const consumed = /* @__PURE__ */ new Set();
  const replaced = html.replace(PHOTO_TOKEN_REGEX, (match, name) => {
    const target = name.trim().toLowerCase();
    for (let i = 0; i < list.length; i++) {
      if (consumed.has(i)) continue;
      const fn = (list[i].fileName || "").toLowerCase();
      if (fn === target) {
        consumed.add(i);
        return renderAttachment(list[i]);
      }
    }
    return match;
  });
  const leftover = list.map((a, i) => consumed.has(i) ? "" : renderAttachment(a)).join("");
  return replaced + leftover;
}

// src/utils/mmsAttachments.ts
var MMS_TYPE_SET = new Set(MMS_CONTENT_TYPES);
function isMmsSupportedImage(attachment) {
  return MMS_TYPE_SET.has((attachment.contentType || "").toLowerCase());
}
function partitionMmsAttachments(attachments) {
  const sendable = [];
  const tooLarge = [];
  const skipped = [];
  for (const attachment of attachments ?? []) {
    if (!isMmsSupportedImage(attachment)) {
      skipped.push(attachment);
      continue;
    }
    if (attachment.sizeBytes != null && attachment.sizeBytes > MMS_MAX_BYTES) {
      tooLarge.push(attachment);
      continue;
    }
    if (sendable.length >= MMS_MAX_MEDIA) {
      skipped.push(attachment);
      continue;
    }
    sendable.push(attachment);
  }
  return { sendable, tooLarge, skipped };
}
function mmsPreviewNotice(partition) {
  const { sendable, tooLarge, skipped } = partition;
  if (tooLarge.length === 0 && skipped.length === 0) return null;
  if (tooLarge.length > 0 && skipped.length === 0) {
    if (tooLarge.length === 1 && sendable.length === 0) {
      return "This photo is too large for text \u2014 it'll still go by email and in the conversation.";
    }
    if (tooLarge.length === 1) {
      return "1 photo is too large for text and won't be included. The others will go.";
    }
    return `${tooLarge.length} photos are too large for text and won't be included. The message still sends.`;
  }
  if (skipped.length > 0 && tooLarge.length === 0 && sendable.length === 0) {
    return skipped.length === 1 ? "This file won't be sent by text \u2014 email only." : `${skipped.length} files won't be sent by text \u2014 email only.`;
  }
  if (tooLarge.length > 0) {
    return `${tooLarge.length + skipped.length} attachments won't go on the text. The message still sends.`;
  }
  return skipped.length === 1 ? "1 file won't be sent by text \u2014 the photos will." : `${skipped.length} files won't be sent by text \u2014 the photos will.`;
}

// src/utils/justifiPaymentError.ts
var GENERIC_PAYMENT_RETRY_MESSAGE = "We could not process that payment. Please try again with your payment method, or use a different one.";
var JUSTIFI_ERROR_RULES = [
  {
    reason: "insufficient_funds",
    match: ["insufficient funds", "insufficient_funds"],
    message: "That payment was declined for insufficient funds. Please use a different payment method."
  },
  {
    reason: "expired_card",
    match: ["expired card", "expired_card", "card expired", "card has expired", "card is expired"],
    message: "That card has expired. Please update the expiration date or use a different payment method."
  },
  {
    reason: "incorrect_cvc",
    match: ["incorrect cvc", "incorrect_cvc", "invalid cvc", "invalid_cvc", "security code"],
    message: "The card's security code is incorrect. Please re-enter it, or use a different payment method."
  },
  {
    reason: "invalid_number",
    match: ["incorrect number", "invalid number", "invalid_number", "incorrect_number", "card number"],
    message: "That card number is invalid. Please re-enter it, or use a different payment method."
  },
  {
    reason: "ach_not_enabled",
    match: [
      "ach_payments_not_enabled",
      "bank account payments are not allowed",
      "ach payments are disabled",
      "ach payments are not enabled"
    ],
    message: "Bank account payments are not available yet. Please use a credit card, or contact your service provider."
  }
];
function mapJustifiPaymentErrorMessage(rawMessage) {
  const rule = matchJustifiDeclineRule(rawMessage);
  return rule ? rule.message : GENERIC_PAYMENT_RETRY_MESSAGE;
}
function matchJustifiDeclineRule(rawMessage) {
  const normalized = rawMessage?.toLowerCase().trim();
  if (!normalized) return void 0;
  return JUSTIFI_ERROR_RULES.find(
    (rule) => rule.match.some((needle) => normalized.includes(needle))
  );
}
function matchJustifiDeclineReason(rawMessage) {
  return matchJustifiDeclineRule(rawMessage)?.reason ?? null;
}

// src/utils/justifiTokenize.ts
function resolveJustifiTokenizeError(result) {
  if (!result || typeof result !== "object") return null;
  const payload = result;
  if (payload.error) {
    return mapJustifiPaymentErrorMessage(
      payload.error.message || payload.error.code
    );
  }
  if (payload.validationError) {
    return mapJustifiPaymentErrorMessage("validation error");
  }
  return null;
}
function normalizeLast4(value) {
  if (value === null || value === void 0 || value === "") return void 0;
  const s = String(value);
  return /^\d{1,3}$/.test(s) ? s.padStart(4, "0") : s;
}
function asOptionalString(value) {
  return value === null || value === void 0 || value === "" ? void 0 : String(value);
}
function parseJustifiTokenizeResult(result) {
  if (resolveJustifiTokenizeError(result)) return null;
  if (!result) return null;
  const bankAccount = result?.data?.bank_account || result?.bank_account;
  const card = result?.data?.card || result?.card || result?.payment_method;
  const isBankAccount = !!bankAccount;
  const paymentMethodId = result?.id || result?.token || result?.paymentMethodId || (isBankAccount ? bankAccount?.id || bankAccount?.token : card?.id || card?.token);
  if (!paymentMethodId) return null;
  const details = isBankAccount ? bankAccount : card;
  return {
    paymentMethodId,
    type: isBankAccount ? "bank_account" : "card",
    last4: normalizeLast4(details?.acct_last_four || details?.last4 || details?.lastFour),
    brand: isBankAccount ? void 0 : details?.brand,
    expMonth: isBankAccount ? void 0 : asOptionalString(details?.month || details?.exp_month || details?.expMonth),
    expYear: isBankAccount ? void 0 : asOptionalString(details?.year || details?.exp_year || details?.expYear),
    bankName: isBankAccount ? details?.bank_name : void 0
  };
}

// src/utils/clockInNudge.ts
function shouldShowClockInHero(params) {
  const { isClockedOut, hasCrewAssignment, isClockInExempt } = params;
  return isClockedOut && hasCrewAssignment && !isClockInExempt;
}
function shouldDimRouteCards(params) {
  const { isClockedIn, isClockInExempt } = params;
  return !isClockedIn && !isClockInExempt;
}

// src/utils/serviceOptionAnswers.ts
function getUnansweredRequiredServiceOptions(templateOptions, usage) {
  if (!templateOptions?.length) return [];
  const usageById = new Map((usage ?? []).map((u) => [u.optionId, u]));
  return templateOptions.filter((option) => {
    if (option.customerSelectable === true) return false;
    if (option.crewAnswerRequired === false) return false;
    const u = usageById.get(option.id);
    switch (option.rateType) {
      case "flat":
        return !u;
      case "multi-select": {
        const picks = u?.selectedChoices ?? [];
        if (picks.length === 0) return true;
        return picks.some((p) => p.quantity == null);
      }
      case "time-based":
        return u?.timeUsed == null;
      default:
        return u?.quantity == null;
    }
  });
}

// src/utils/crewAsks.ts
var ASK_RANK = {
  priorityNoteBeforeShift: 0,
  holdsVisitOpen: 10,
  priorityNote: 20,
  location: 30,
  officeNotice: 40
};
var NOT_STARTED = "not-started";
function otherTenant(visit, viewer) {
  return !!visit.orgId && visit.orgId !== viewer.orgId;
}
function askForPriorityNote(visit, viewer) {
  if (!visit.priority || visit.status !== NOT_STARTED) return [];
  if (otherTenant(visit, viewer)) return [];
  const notes = (visit.unreadNotes ?? []).filter((n) => n.noteType === "priorityNote");
  return notes.map((n) => ({
    id: `priority-note:${visit.id}:${n.noteId}`,
    type: "priority-note",
    visitId: visit.id,
    stop: visit.stop,
    rank: viewer.beforeShift ? ASK_RANK.priorityNoteBeforeShift : ASK_RANK.priorityNote,
    roles: ["leader", "member"]
  }));
}
var OPTION_ASK_STATUSES = /* @__PURE__ */ new Set(["in-progress", "paused"]);
function askForServiceOption(visit, viewer) {
  if (!OPTION_ASK_STATUSES.has(visit.status)) return [];
  if (otherTenant(visit, viewer)) return [];
  return getUnansweredRequiredServiceOptions(visit.serviceOptions, visit.serviceOptionUsage).map((o) => ({
    id: `service-option:${visit.id}:${o.id}`,
    type: "service-option",
    visitId: visit.id,
    optionId: o.id,
    stop: visit.stop,
    rank: ASK_RANK.holdsVisitOpen,
    roles: ["leader"]
  }));
}
var RULES = [askForPriorityNote, askForServiceOption];
function allAsks(visits, viewer) {
  return visits.flatMap((v) => RULES.flatMap((rule) => rule(v, viewer)));
}
function asksFor(visits, viewer) {
  return rankAsks(allAsks(visits, viewer).filter((a) => a.roles.includes(viewer.role)));
}
function asksWaitingOnOthers(visits, viewer) {
  return rankAsks(allAsks(visits, viewer).filter((a) => !a.roles.includes(viewer.role)));
}
function rankAsks(asks) {
  return [...asks].sort(
    (a, b) => a.rank - b.rank || (a.stop ?? Number.MAX_SAFE_INTEGER) - (b.stop ?? Number.MAX_SAFE_INTEGER) || a.id.localeCompare(b.id)
  );
}

// src/utils/visitActionClockGate.ts
var OFFICE_SERVICE_OPTION_EDIT_STATUSES = /* @__PURE__ */ new Set([
  "completed" /* COMPLETED */,
  "needs-review" /* NEEDS_REVIEW */,
  "paid" /* PAID */
]);
function isOfficeServiceOptionEditStatus(status) {
  return !!status && OFFICE_SERVICE_OPTION_EDIT_STATUSES.has(status);
}
function visitActionRequiresClockIn(params) {
  const { action, visitStatus, visitType, canManageVisits } = params;
  if (action === "photos" || action === "note") {
    return false;
  }
  if (action === "service-options" && isOfficeServiceOptionEditStatus(visitStatus)) {
    return false;
  }
  if (visitType === "assessment" /* ASSESSMENT */ && canManageVisits) {
    return false;
  }
  return true;
}

// src/utils/feedbackIssue.ts
var FEEDBACK_CATEGORY_LABELS = {
  bug: "Bug",
  suggestion: "Suggestion",
  other: "Feedback"
};
var SURFACE_LABELS = {
  webapp: "Staff dashboard",
  mobile: "Crew mobile",
  customer_portal: "Customer portal"
};
var FEEDBACK_TITLE_MESSAGE_MAX = 80;
function buildFeedbackIssueTitle(payload) {
  const category = FEEDBACK_CATEGORY_LABELS[payload.category] ?? FEEDBACK_CATEGORY_LABELS.other;
  const surface = SURFACE_LABELS[payload.context.surface] ?? payload.context.surface;
  const summary = firstLineSummary(payload.message, FEEDBACK_TITLE_MESSAGE_MAX);
  return `[${surface} \xB7 ${category}] ${summary}`;
}
function buildFeedbackIssueDescription(payload, options) {
  const sections = [];
  sections.push("## Report");
  sections.push(payload.message.trim() || "_(empty message)_");
  sections.push("");
  sections.push("## Category");
  sections.push(FEEDBACK_CATEGORY_LABELS[payload.category] ?? payload.category);
  sections.push("");
  sections.push("## Reporter");
  sections.push(formatReporterTable(payload.reporter));
  sections.push("");
  sections.push("## Context");
  sections.push(formatContextTable(payload.context, payload.receivedAt));
  if (options?.screenshotMarkdown) {
    sections.push("");
    sections.push("## Screenshot");
    sections.push(options.screenshotMarkdown);
  } else if (payload.hasScreenshot) {
    sections.push("");
    sections.push("## Screenshot");
    sections.push("_Screenshot was provided but could not be attached._");
  }
  return sections.join("\n");
}
function firstLineSummary(message, max) {
  const first = message.split(/\r?\n/).map((l) => l.trim()).find((l) => l.length > 0);
  if (!first) return "No message";
  if (first.length <= max) return first;
  return `${first.slice(0, max - 1)}\u2026`;
}
function formatReporterTable(reporter) {
  const rows = [
    ["Kind", reporter.kind],
    ["User ID", reporter.userId],
    ["Organization", reporter.orgId]
  ];
  if (reporter.name) rows.push(["Name", reporter.name]);
  if (reporter.email) rows.push(["Email", reporter.email]);
  if (reporter.phoneNumber) rows.push(["Phone", reporter.phoneNumber]);
  if (reporter.roleId) rows.push(["Role", reporter.roleId]);
  if (reporter.customerId) rows.push(["Customer ID", reporter.customerId]);
  return markdownTable(rows);
}
function formatContextTable(context, receivedAt) {
  const rows = [
    ["Surface", SURFACE_LABELS[context.surface] ?? context.surface],
    ["Page / screen", context.pagePath]
  ];
  if (context.pageTitle) rows.push(["Page title", context.pageTitle]);
  if (context.routeHistory && context.routeHistory.length > 0) {
    rows.push(["Route history", context.routeHistory.join(" \u2192 ")]);
  }
  if (context.appVersion) rows.push(["App version", context.appVersion]);
  if (context.buildNumber) rows.push(["Build", context.buildNumber]);
  if (context.platform) rows.push(["Platform", context.platform]);
  if (context.deviceModel) rows.push(["Device", context.deviceModel]);
  if (context.osVersion) rows.push(["OS", context.osVersion]);
  if (context.userAgent) rows.push(["User agent", context.userAgent]);
  if (context.locale) rows.push(["Locale", context.locale]);
  if (context.timezone) rows.push(["Timezone", context.timezone]);
  if (context.screenWidth !== void 0 && context.screenHeight !== void 0) {
    rows.push([
      "Screen",
      `${context.screenWidth}\xD7${context.screenHeight}`
    ]);
  }
  rows.push(["Client submitted at", context.submittedAt]);
  rows.push(["Server received at", receivedAt]);
  return markdownTable(rows);
}
function markdownTable(rows) {
  const lines = [
    "| Field | Value |",
    "| --- | --- |",
    ...rows.map(([k, v]) => `| ${escapeCell(k)} | ${escapeCell(v)} |`)
  ];
  return lines.join("\n");
}
function escapeCell(value) {
  return value.replace(/\|/g, "\\|").replace(/\n/g, " ");
}

// src/utils/feedbackReceivedCopy.ts
var FEEDBACK_ISSUE_IDENTIFIER_PATTERN = /^RUT-\d+$/i;
function isFeedbackIssueIdentifier(value) {
  return FEEDBACK_ISSUE_IDENTIFIER_PATTERN.test(value.trim());
}
function feedbackNoun(category) {
  return category === "suggestion" ? "feedback" : "report";
}
function feedbackReceivedCopy(category) {
  const noun = feedbackNoun(category);
  return {
    title: noun === "feedback" ? "Feedback received" : "Report received",
    body: `Thanks for reaching out. Your ${noun} is in, and the Ruta team will take a look shortly. We'll circle back if we need anything. Thank you!`,
    noun,
    followUpLabel: noun === "feedback" ? "Add to this feedback" : "Add to this report",
    notifyLabel: "Notify me when this is resolved"
  };
}
function feedbackResolvedTitle(category) {
  const noun = feedbackNoun(category);
  return noun === "feedback" ? "Your feedback is resolved" : "Your report is resolved";
}
function feedbackResolvedBody(issueIdentifier, resolution) {
  const outcome = resolution === "canceled" ? "canceled" : "done";
  return `${issueIdentifier} is ${outcome}. The Ruta team wanted you to know.`;
}
function filedFeedbackFromToolData(data) {
  if (!data || typeof data !== "object") return null;
  const d = data;
  if (d.shared !== true) return null;
  if (typeof d.issue_identifier !== "string") return null;
  const issueIdentifier = d.issue_identifier.trim().toUpperCase();
  if (!isFeedbackIssueIdentifier(issueIdentifier)) return null;
  const kind = typeof d.kind === "string" ? d.kind.trim().toLowerCase() : "";
  const category = kind === "suggestion" || kind === "idea" ? "suggestion" : kind === "other" || kind === "improvement" || kind === "feedback" ? "other" : "bug";
  const issueUrl = typeof d.issue_url === "string" && d.issue_url.trim() ? d.issue_url.trim() : void 0;
  return { issueIdentifier, category, ...issueUrl ? { issueUrl } : {} };
}
function linearStateIsTerminal(stateType) {
  if (stateType === "completed") return "done";
  if (stateType === "canceled") return "canceled";
  return null;
}

// src/helpers/priceFields.ts
var VISIT_PRICE_FIELDS = [
  "hourlyRate",
  "minimumCharge",
  "subscriptionRate",
  "subscriptionDiscount",
  "visitDiscount",
  "subscriptionRateBreakdown",
  "pricePerAdditionalVisit",
  "bundleMemberValue",
  "billingSnapshot",
  "estimatedPricing",
  "currentPricing",
  "finalPricing",
  "totalAmount",
  "taxAmount",
  "taxRate",
  "taxBreakdown",
  "attributedDisposalAmount",
  "outstandingBalanceCollected",
  "pendingBatchAmount",
  "refundMetadata",
  "changeHistory",
  // Written as top-level attributes at completion, not only inside *Pricing.
  "baseAmount",
  "serviceOptionsAmount",
  "subtotal",
  "processingFees",
  // Audit stamp written only when a price is changed (repricing, template
  // publish): it tells a crew that and when their customer's price moved.
  "rateUpdatedAt",
  "rateUpdatedBy"
];
var SUBSCRIPTION_PRICE_FIELDS = [
  "rate",
  "preRoundingRate",
  "hiddenRate",
  "rateBreakdown",
  "pricePerAdditionalVisit",
  "discount",
  "setupFee",
  "setupFeeChargedAmount",
  "minimumCharge",
  "bundleMemberValue",
  "packageOptionPricing",
  "packageChargeAmount",
  "packageRefundAmount",
  "packageRefundedTotal",
  "midSeasonSignOn",
  "pendingPlanChange",
  "rateMessage",
  "changeHistory",
  "totals",
  "rateUpdatedAt",
  "rateUpdatedBy"
];
var SERVICE_TEMPLATE_PRICE_FIELDS = [
  "hourlyRate",
  "minimumCharge",
  "roundUpToCents",
  "rateRounding",
  "subcontractorRateOverrides",
  "estimatedAnnualRevenue",
  "changeHistory"
];
var CUSTOMER_PRICE_FIELDS = ["balance", "taxRate", "taxRateData"];
var NESTED_PRICE_FIELDS = {
  /** Visit/template `volumePricing`. */
  volumePricing: ["perUnitRate"],
  /** Each `volumePricing.tiers[]` entry (the tier keeps its `upperBound`). */
  volumePricingTier: ["rate"],
  /** Each `serviceOptions[]` entry (visit + template) and its `choices[]`. */
  serviceOption: ["rate", "unitPrice"],
  serviceOptionChoice: ["rate"],
  /** Each `serviceOptionUsage[]` / `actualServiceOptions[]` entry and its `selectedChoices[]`. */
  serviceOptionUsage: ["rate"],
  /** Visit `reviewMetadata`. */
  reviewMetadata: ["adjustedAmount"],
  /** Subscription `pricingInputs`. Hours and measurements stay. */
  pricingInputs: ["hourlyRate", "rate", "minimumCharge", "preRoundingRate"],
  /** Subscription `skipMakeup`. */
  skipMakeup: ["hourlyRateOverride"],
  /**
   * Each template `packagePricing.options[]` entry. The model carries visit
   * counts only (`builtInVisits`, `budgetedVisits`); these keys are dropped in
   * case an older record or a future writer puts a price there.
   */
  packageOption: ["rate", "price", "amount", "pricePerAdditionalVisit"]
};
function isRecord(value) {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
function omit(record, keys) {
  const out = { ...record };
  for (const key of keys) delete out[key];
  return out;
}
function mapField(record, key, fn) {
  const value = record[key];
  if (isRecord(value)) record[key] = fn(value);
}
function mapArrayField(record, key, fn) {
  const value = record[key];
  if (Array.isArray(value)) {
    record[key] = value.map((item) => isRecord(item) ? fn(item) : item);
  }
}
function stripVolumePricing(vp) {
  const out = omit(vp, NESTED_PRICE_FIELDS.volumePricing);
  mapArrayField(out, "tiers", (tier) => omit(tier, NESTED_PRICE_FIELDS.volumePricingTier));
  return out;
}
function stripPackagePricing(pp) {
  const out = { ...pp };
  mapArrayField(out, "options", (option) => omit(option, NESTED_PRICE_FIELDS.packageOption));
  return out;
}
function stripServiceOption(option) {
  const out = omit(option, NESTED_PRICE_FIELDS.serviceOption);
  mapArrayField(out, "choices", (choice) => omit(choice, NESTED_PRICE_FIELDS.serviceOptionChoice));
  return out;
}
function stripServiceOptionUsage(usage) {
  const out = omit(usage, NESTED_PRICE_FIELDS.serviceOptionUsage);
  mapArrayField(out, "selectedChoices", (pick) => omit(pick, NESTED_PRICE_FIELDS.serviceOptionUsage));
  return out;
}
function stripTemplateLike(record) {
  mapField(record, "volumePricing", stripVolumePricing);
  mapField(record, "packagePricing", stripPackagePricing);
  mapArrayField(record, "serviceOptions", stripServiceOption);
  delete record.subcontractorRateOverrides;
  return record;
}
function stripVisitPrices(visit) {
  if (!isRecord(visit)) return visit;
  const out = omit(visit, VISIT_PRICE_FIELDS);
  mapField(out, "volumePricing", stripVolumePricing);
  mapArrayField(out, "serviceOptions", stripServiceOption);
  mapArrayField(out, "serviceOptionUsage", stripServiceOptionUsage);
  mapArrayField(out, "actualServiceOptions", stripServiceOptionUsage);
  mapField(out, "reviewMetadata", (rm) => omit(rm, NESTED_PRICE_FIELDS.reviewMetadata));
  return out;
}
function stripServiceTemplatePrices(template) {
  if (!isRecord(template)) return template;
  const out = omit(template, SERVICE_TEMPLATE_PRICE_FIELDS);
  return stripTemplateLike(out);
}
function stripSubscriptionPrices(subscription) {
  if (!isRecord(subscription)) return subscription;
  const out = omit(subscription, SUBSCRIPTION_PRICE_FIELDS);
  mapArrayField(out, "serviceOptions", stripServiceOption);
  mapField(out, "pricingInputs", (pi) => omit(pi, NESTED_PRICE_FIELDS.pricingInputs));
  mapField(out, "skipMakeup", (sm) => omit(sm, NESTED_PRICE_FIELDS.skipMakeup));
  mapField(out, "oneOffTemplate", (tpl) => stripTemplateLike({ ...tpl }));
  mapField(out, "serviceTemplate", stripServiceTemplatePrices);
  return out;
}
function stripCustomerPrices(customer) {
  if (!isRecord(customer)) return customer;
  return omit(customer, CUSTOMER_PRICE_FIELDS);
}

// src/helpers/serviceBundle.ts
function findPackageForTemplate(templateId, bundles) {
  return bundles.find(
    (b) => b.isActive && b.serviceTemplateIds.includes(templateId)
  ) ?? null;
}
function groupByPackage(items, getTemplateId, bundles) {
  const byTemplateId = /* @__PURE__ */ new Map();
  for (const item of items) {
    const id = getTemplateId(item);
    if (!id) continue;
    const list = byTemplateId.get(id) ?? [];
    list.push(item);
    byTemplateId.set(id, list);
  }
  const used = /* @__PURE__ */ new Set();
  const rows = [];
  for (const item of items) {
    const templateId = getTemplateId(item);
    if (!templateId) {
      rows.push({ kind: "single", item });
      continue;
    }
    if (used.has(templateId)) continue;
    const bundle = findPackageForTemplate(templateId, bundles);
    if (!bundle) {
      used.add(templateId);
      rows.push({ kind: "single", item });
      continue;
    }
    const groupItems = [];
    for (const id of bundle.serviceTemplateIds) {
      const members = byTemplateId.get(id);
      if (members) groupItems.push(...members);
      used.add(id);
    }
    rows.push({
      kind: "package",
      bundle,
      memberIds: [...bundle.serviceTemplateIds],
      items: groupItems
    });
  }
  return rows;
}
function isActiveOutsideBundle(member, bundleId) {
  return member.subscriptionStatus === "active" /* ACTIVE */ && member.bundleId !== bundleId;
}
function hasEveryMember(group, getTemplateId) {
  const present = new Set(group.items.map(getTemplateId));
  return group.memberIds.every((id) => present.has(id));
}
function showsAsOneBundle(group, getTemplateId, getState) {
  if (!hasEveryMember(group, getTemplateId)) return false;
  return !group.items.some((item) => isActiveOutsideBundle(getState(item), group.bundle.id));
}
function isOnBundle(group, getTemplateId, getState) {
  return group.memberIds.every(
    (id) => group.items.some((item) => {
      if (getTemplateId(item) !== id) return false;
      const state = getState(item);
      return state.subscriptionStatus === "active" /* ACTIVE */ && state.bundleId === group.bundle.id;
    })
  );
}

// src/helpers/serviceTemplateAction.ts
function resolveActionCompletionMessage(actions, actionStates) {
  if (!actions?.length) return void 0;
  const fragments = [];
  for (const action of actions) {
    if (action.actionType !== "send-message") continue;
    if (action.isActive === false) continue;
    const config = action.messageConfig;
    if (!config) continue;
    if (config.delivery === "immediate") continue;
    const enabled = actionStates?.[action.id]?.enabled === true;
    const raw = enabled ? config.messageWhenEnabled : config.messageWhenDisabled;
    const message = raw?.trim();
    if (message) fragments.push(message);
  }
  if (fragments.length === 0) return void 0;
  return fragments.join(" ");
}
function resolveActionCrewMessagePreview(config, enabled, language) {
  if (!config) return void 0;
  const base = enabled ? config.messageWhenEnabled : config.messageWhenDisabled;
  const translated = enabled ? config.messageWhenEnabled_es : config.messageWhenDisabled_es;
  const preferred = language === "es" ? translated?.trim() : void 0;
  return preferred || base?.trim() || void 0;
}

// src/helpers/metricPropagation.ts
var METRIC_FIELD_KEYS = Object.keys(
  METRIC_KEY_TO_TYPE
);
function capturedMetricFieldKeys(metrics) {
  if (!metrics) return [];
  return METRIC_FIELD_KEYS.filter((key) => metrics[key] != null);
}
function pricedMetricFieldKeys(volumePricing, capturedKeys) {
  if (!volumePricing?.enabled) return [];
  const applicable = volumePricing.applicableMetrics ?? [];
  return applicable.map((metric) => METRIC_TYPE_TO_KEY[metric]).filter(
    (key) => !!key && capturedKeys.includes(key)
  );
}
function pricesOffMetrics(volumePricing, capturedKeys) {
  return pricedMetricFieldKeys(volumePricing, capturedKeys).length > 0;
}
function repricesFromMetrics(service, capturedKeys) {
  if (service.pricingLocked) return false;
  return pricesOffMetrics(service.volumePricing, capturedKeys);
}
function pickCapturedMetrics(metrics) {
  const result = {};
  for (const key of capturedMetricFieldKeys(metrics)) {
    result[key] = metrics[key];
  }
  return result;
}

// src/helpers/serviceOptionLibrary.ts
function serviceOptionSignature(option) {
  return `${option.name.trim().toLowerCase()}|${option.rateType}|${option.rate}|${option.billable}`;
}
function flattenServiceOptions({
  templates,
  excludeTemplateId,
  existingSignatures,
  rejectTimeBased
}) {
  const flat = [];
  for (const template of templates) {
    if (excludeTemplateId && template.id === excludeTemplateId) continue;
    for (const option of template.serviceOptions ?? []) {
      if (rejectTimeBased && option.rateType === "time-based" /* TIME_BASED */) {
        continue;
      }
      if (existingSignatures?.has(serviceOptionSignature(option))) continue;
      flat.push({
        key: `${template.id}:${option.id}`,
        option,
        sourceTemplateId: template.id,
        sourceTemplateName: template.name
      });
    }
  }
  return flat;
}
function filterFlatServiceOptions(items, query) {
  const q = query.trim().toLowerCase();
  if (!q) return items;
  return items.filter(
    ({ option, sourceTemplateName }) => option.name.toLowerCase().includes(q) || sourceTemplateName.toLowerCase().includes(q)
  );
}
function summarizeServiceOptionFlags(option) {
  const flags = [];
  switch (option.rateType) {
    case "flat" /* FLAT */:
      flags.push("Flat fee");
      break;
    case "per-unit" /* PER_UNIT */:
      flags.push(`Per ${option.unit ?? "unit"}`);
      break;
    case "time-based" /* TIME_BASED */:
      flags.push("Time-based");
      break;
    case "multi-select" /* MULTI_SELECT */: {
      const count = option.choices?.length ?? 0;
      flags.push(`Multi-select \xB7 ${count} choice${count === 1 ? "" : "s"}`);
      flags.push(option.selectionMode === "multiple" ? "Choose any" : "Choose one");
      break;
    }
  }
  flags.push(option.billable ? "Billable" : "Free");
  if (option.taxable) flags.push("Taxable");
  if (option.invoiceDisplay) flags.push("On invoice");
  if (option.customerSelectable) flags.push("Customer-selectable");
  if (option.requiresDisposal) flags.push("Creates disposal");
  if (option.crewAnswerRequired === false) flags.push(OPTIONAL_ANSWER);
  if (option.detailViewDisplay === false) flags.push(HIDDEN_FROM_SERVICE_CARD);
  return flags;
}
var OPTIONAL_ANSWER = "Optional answer";
var HIDDEN_FROM_SERVICE_CARD = "Hidden from service card";
function summarizeServiceOptionSettings(option) {
  return [
    option.customerSelectable ? "Customer answers" : option.crewAnswerRequired === false ? OPTIONAL_ANSWER : "Crew must answer",
    option.detailViewDisplay === false ? HIDDEN_FROM_SERVICE_CARD : "On service card"
  ];
}

// src/helpers/crewMatching.ts
function getEligibleCrews(crews, target, serviceAreas, opts = {}) {
  const templateEligible = crews.filter(
    (c) => !c.allowedServiceTemplateIds?.length || c.allowedServiceTemplateIds.includes(target.serviceTemplateId)
  );
  const usableAreas = serviceAreas.filter(
    (a) => a.isActive !== false && (a.coordinates?.length ?? 0) >= 3
  );
  const coords = target.customerCoordinates;
  if (!coords) {
    return opts.requireAreaMatch && usableAreas.length > 0 ? [] : templateEligible;
  }
  if (usableAreas.length === 0) {
    return templateEligible;
  }
  const covering = usableAreas.filter((a) => pointInPolygon(coords, a.coordinates));
  if (covering.length === 0) {
    return opts.requireAreaMatch ? [] : templateEligible;
  }
  const areaCrewIds = new Set(covering.flatMap((a) => a.assignedCrewIds ?? []));
  if (areaCrewIds.size === 0) {
    return opts.requireAreaMatch ? [] : templateEligible;
  }
  return templateEligible.filter((c) => areaCrewIds.has(c.id));
}
function rankCrewsForService(target, crews, crewRoutes) {
  const scored = crews.map((crew) => {
    const route = crewRoutes[crew.id] ?? [];
    const servesSameHouse = route.some((s) => s.customerId === target.customerId);
    let nearest = Infinity;
    if (target.customerCoordinates) {
      for (const s of route) {
        if (s.coordinates) {
          const d = haversineDistance(target.customerCoordinates, s.coordinates);
          if (d < nearest) nearest = d;
        }
      }
    }
    return { crew, servesSameHouse, nearest, size: route.length };
  });
  scored.sort((a, b) => {
    if (a.servesSameHouse !== b.servesSameHouse) return a.servesSameHouse ? -1 : 1;
    if (a.nearest !== b.nearest) return a.nearest - b.nearest;
    if (a.size !== b.size) return a.size - b.size;
    return a.crew.id < b.crew.id ? -1 : a.crew.id > b.crew.id ? 1 : 0;
  });
  return scored.map((s) => s.crew);
}

// src/helpers/locationEstimate.ts
var LOCATION_ESTIMATE_MAX_ACCURACY_M = 50;
var LOCATION_ESTIMATE_MAX_SPEED_MPS = 50;
var MIN_UNCERTAINTY_M = 10;
function decideLocationEstimate(previous, next) {
  const nextAcc = next.accuracy != null && next.accuracy > 0 ? next.accuracy : void 0;
  const tooInaccurate = nextAcc != null && nextAcc > LOCATION_ESTIMATE_MAX_ACCURACY_M;
  if (!previous) {
    return { action: "accept", reason: "first-lock" };
  }
  if (tooInaccurate) return { action: "hold", reason: "poor-accuracy" };
  const meters = haversineDistance(
    [previous.longitude, previous.latitude],
    [next.longitude, next.latitude]
  );
  if (nextAcc != null && previous.accuracy != null && nextAcc + 10 < previous.accuracy && nextAcc <= 20) {
    return { action: "accept", reason: "better-lock" };
  }
  const uncertainty = Math.max(nextAcc ?? 0, previous.accuracy ?? 0, MIN_UNCERTAINTY_M);
  if (meters <= uncertainty) {
    return { action: "hold", reason: "within-accuracy" };
  }
  const dtSec = (new Date(next.timestamp).getTime() - new Date(previous.timestamp).getTime()) / 1e3;
  if (dtSec <= 0 || meters / dtSec > LOCATION_ESTIMATE_MAX_SPEED_MPS) {
    return { action: "hold", reason: "impossible-speed" };
  }
  return { action: "accept", reason: "moved" };
}

// src/helpers/crewRecommendation.ts
var MAX_PLAUSIBLE_RADIUS_M = 25e3;
var MIN_PLAUSIBLE_RADIUS_M = 3e3;
var NEARBY_SCALE_FACTOR = 2;
function rankCrewsByNearbyCustomers(crews, nearby) {
  if (crews.length === 0) return [];
  const located = nearby.filter((n) => Number.isFinite(n.distanceMeters) && n.distanceMeters >= 0);
  if (located.length === 0) return [];
  const nearest = located.reduce((min, n) => n.distanceMeters < min ? n.distanceMeters : min, Infinity);
  if (nearest > MAX_PLAUSIBLE_RADIUS_M) return [];
  const nearbyRadius = Math.max(MIN_PLAUSIBLE_RADIUS_M, nearest * NEARBY_SCALE_FACTOR);
  const counts = /* @__PURE__ */ new Map();
  let nearbyTotalCount = 0;
  for (const n of located) {
    if (n.distanceMeters > nearbyRadius) continue;
    nearbyTotalCount += 1;
    if (!n.crewId) continue;
    const entry = counts.get(n.crewId);
    if (entry) {
      entry.count += 1;
      if (n.distanceMeters < entry.nearest) entry.nearest = n.distanceMeters;
    } else {
      counts.set(n.crewId, { count: 1, nearest: n.distanceMeters });
    }
  }
  const byId = new Map(crews.map((c) => [c.id, c]));
  const scored = [...counts.entries()].filter(([crewId]) => byId.has(crewId)).map(([crewId, v]) => ({ crew: byId.get(crewId), ...v }));
  scored.sort((a, b) => {
    if (a.count !== b.count) return b.count - a.count;
    if (a.nearest !== b.nearest) return a.nearest - b.nearest;
    return a.crew.id < b.crew.id ? -1 : a.crew.id > b.crew.id ? 1 : 0;
  });
  return scored.map((s, i) => ({
    crew: s.crew,
    rank: i + 1,
    nearbyCustomerCount: s.count,
    nearbyTotalCount,
    distanceMeters: Math.round(s.nearest)
  }));
}

// src/helpers/rateRequestList.ts
var RATE_REQUESTED_LIST_FILTER = "rateVisibility:=invisible && (hiddenAt:>0 || (subscriptionStatus:=inactive && requestedAt:>0 && requestedBy:=customer))";
var LEGACY_RATE_REQUESTED_LIST_FILTER = "rateVisibility:=invisible && subscriptionStatus:=inactive && requestedAt:>0 && requestedBy:=customer";
function appendRateRequestedListFilters(filterConditions) {
  filterConditions.push(RATE_REQUESTED_LIST_FILTER);
}
function replaceHiddenAtRateRequestedFilter(filterConditions) {
  const index = filterConditions.indexOf(RATE_REQUESTED_LIST_FILTER);
  if (index < 0) return false;
  filterConditions[index] = LEGACY_RATE_REQUESTED_LIST_FILTER;
  return true;
}
function rateHideReviewFields(nextVisibility, current, now) {
  if (nextVisibility === "invisible" /* INVISIBLE */) {
    const rate = typeof current.rate === "number" ? current.rate : typeof current.hiddenRate === "number" ? current.hiddenRate : null;
    return {
      hiddenForReview: true,
      hiddenAt: now,
      hiddenRate: rate
    };
  }
  return {
    hiddenForReview: null,
    hiddenAt: null,
    hiddenRate: null
  };
}
function rateRequestListAgeAt(input) {
  for (const value of [input.requestedAt, input.hiddenAt, input.rateProvidedAt, input.createdAt]) {
    const iso = toOptionalIso(value);
    if (iso) return iso;
  }
  return void 0;
}
function isWaitingForReprice(sub) {
  if (sub.hiddenForReview === true) return true;
  if (sub.hiddenAt == null || sub.hiddenAt === "") return false;
  if (typeof sub.hiddenAt === "number") return sub.hiddenAt > 0;
  return true;
}
function hasNewRateSinceHide(sub) {
  return typeof sub.rate === "number" && typeof sub.hiddenRate === "number" && sub.rate !== sub.hiddenRate;
}
function canOfferRateSendOnUnhide(sub) {
  if (!isWaitingForReprice(sub)) return true;
  return hasNewRateSinceHide(sub);
}
function toOptionalIso(value) {
  if (value == null || value === "") return void 0;
  if (typeof value === "number") {
    if (value <= 0) return void 0;
    const ms = value < 1e12 ? value * 1e3 : value;
    return new Date(ms).toISOString();
  }
  const asNumber = Number(value);
  if (value.trim() !== "" && Number.isFinite(asNumber) && asNumber <= 0) {
    return void 0;
  }
  return value;
}

// src/helpers/lastSeasonPackage.ts
function packageChargePlanStamp(subscription, templateOptions) {
  const planId = subscription.selectedPackageOptionId || void 0;
  if (!planId) return {};
  const name = templateOptions?.find((o) => o.id === planId)?.name || subscription.selectedPackageOptionName || void 0;
  if (!name) return {};
  return { packageChargePlanId: planId, packageChargePlanName: name };
}
function seasonOf(stamp, candidates) {
  const at = new Date(stamp);
  if (Number.isNaN(at.getTime())) return void 0;
  return candidates.find((season) => {
    const { startInclusive, endExclusive } = packageChargeSeasonBounds(season);
    return at >= new Date(startInclusive) && at < new Date(endExclusive);
  });
}
function lastSeasonPackage(subscription, now = /* @__PURE__ */ new Date()) {
  if (!subscription) return null;
  const { packageChargedAt, packageRefundedAt, packageChargePlanId, packageChargePlanName } = subscription;
  if (!packageChargedAt || packageRefundedAt) return null;
  if (!packageChargePlanId || !packageChargePlanName?.trim()) return null;
  const current = packageChargeSeasonKey(now);
  const season = seasonOf(packageChargedAt, [current, current - 1]);
  if (season === void 0) return null;
  const amount = subscription.packageChargeAmount;
  return {
    planId: packageChargePlanId,
    planName: packageChargePlanName.trim(),
    ...typeof amount === "number" && Number.isFinite(amount) && amount > 0 ? { amount } : {},
    season,
    isCurrentSeason: season === current
  };
}
function inferChargedPackagePlan(params) {
  const { chargedAmount, options, optionPricing } = params;
  if (typeof chargedAmount !== "number" || !(chargedAmount > 0)) return void 0;
  const cents = Math.round(chargedAmount * 100);
  const matches = (optionPricing ?? []).filter(
    (p) => typeof p.rate === "number" && Math.round(p.rate * 100) === cents
  );
  const ids = [...new Set(matches.map((m) => m.optionId))];
  if (ids.length !== 1) return void 0;
  const option = options.find((o) => o.id === ids[0]);
  if (!option?.name) return void 0;
  return { planId: option.id, planName: option.name };
}

// src/helpers/acceptedRateChoices.ts
var TYPE_RECURRING = "Recurring";
var TYPE_ONE_TIME = "One time";
function isOpenSchedule2(schedule) {
  const status = schedule.fulfillment?.status;
  return status === ScheduleFulfillmentStatus.PENDING || status === ScheduleFulfillmentStatus.IN_PROGRESS;
}
function preferredCandidate(current, next) {
  if (current.open !== next.open) return next.open ? next : current;
  if (current.createdAt !== next.createdAt) {
    return next.createdAt > current.createdAt ? next : current;
  }
  if (current.typeLabel !== next.typeLabel) {
    return next.typeLabel === TYPE_RECURRING ? next : current;
  }
  return current;
}
function sortPeriodLabels(labels, template) {
  const catalog = template?.periods?.length ? template.periods : template?.seasonalAvailability ?? [];
  return labels.slice().sort((a, b) => {
    const pa = catalog.find((p) => p.name === a);
    const pb = catalog.find((p) => p.name === b);
    return (pa?.startMonth ?? 99) - (pb?.startMonth ?? 99) || (pa?.startDay ?? 0) - (pb?.startDay ?? 0) || a.localeCompare(b);
  });
}
function formatFallbackType(subscription) {
  if (subscription.isOneOffService) return TYPE_ONE_TIME;
  const frequency = subscription.scheduleConfig?.frequency;
  if (!frequency) return void 0;
  if (frequency === "one_time" /* ONE_TIME */) return TYPE_ONE_TIME;
  return TYPE_RECURRING;
}
function uniqueTypeLabels(labels) {
  const seen = /* @__PURE__ */ new Set();
  const ordered = [];
  for (const typeLabel of [TYPE_RECURRING, TYPE_ONE_TIME]) {
    if (labels.includes(typeLabel) && !seen.has(typeLabel)) {
      seen.add(typeLabel);
      ordered.push(typeLabel);
    }
  }
  return ordered;
}
function resolveAcceptedSeasonChoices(subscription, template) {
  if (!subscription) return [];
  const live = (subscription.schedules ?? []).filter(isLiveEnrollmentSchedule);
  const winners = /* @__PURE__ */ new Map();
  for (const schedule of live) {
    const display = resolveVisitScheduleDisplay(
      { schedules: [schedule] },
      schedule.id,
      template
    );
    const candidateBase = {
      typeLabel: display.typeLabel,
      open: isOpenSchedule2(schedule),
      createdAt: schedule.createdAt ?? ""
    };
    for (const periodLabel of display.periodLabels) {
      const next = { ...candidateBase, periodLabel };
      const current = winners.get(periodLabel);
      winners.set(periodLabel, current ? preferredCandidate(current, next) : next);
    }
  }
  return sortPeriodLabels([...winners.keys()], template).map((periodLabel) => {
    const winner = winners.get(periodLabel);
    return { periodLabel, typeLabel: winner.typeLabel };
  });
}
function formatTypeOnlyLines(subscription, template) {
  const live = (subscription.schedules ?? []).filter(isLiveEnrollmentSchedule);
  const types = live.map(
    (schedule) => resolveVisitScheduleDisplay(
      { schedules: [schedule] },
      schedule.id,
      template
    ).typeLabel
  );
  const unique = uniqueTypeLabels(types);
  if (unique.length) return unique.join("; ");
  return formatFallbackType(subscription);
}
function formatAcceptedRateChoices(subscription, template) {
  if (!subscription) return void 0;
  const seasons = resolveAcceptedSeasonChoices(subscription, template);
  if (seasons.length > 0) {
    return seasons.map((choice) => `${choice.periodLabel}: ${choice.typeLabel}`).join("; ");
  }
  return formatTypeOnlyLines(subscription, template);
}

// src/helpers/visitReviewRequirements.ts
function isSubscriptionVisitReviewRequired(reqs) {
  if (!reqs?.enableVisitReviews) return false;
  const count = reqs.reviewCount ?? 0;
  if (count <= 0) return false;
  return (reqs.visitsReviewed ?? 0) < count;
}
function remainingSubscriptionVisitReviews(reqs) {
  if (!reqs?.enableVisitReviews) return 0;
  const count = reqs.reviewCount ?? 0;
  return Math.max(0, count - (reqs.visitsReviewed ?? 0));
}
function subscriptionVisitReviewException(reqs) {
  if (!isSubscriptionVisitReviewRequired(reqs) || !reqs) return void 0;
  const reviewed = reqs.visitsReviewed ?? 0;
  return `Visit requires admin review (${reviewed + 1}/${reqs.reviewCount})`;
}
function incrementedVisitReviewRequirements(reqs) {
  return {
    ...reqs,
    visitsReviewed: (reqs.visitsReviewed ?? 0) + 1
  };
}

// src/helpers/assessmentCompletion.ts
function validateAssessmentCompletionInputs(input) {
  if (input.visitType !== "assessment" /* ASSESSMENT */) {
    return { ok: true };
  }
  if (isPropertyAssessmentTemplateId(input.serviceTemplateId)) {
    if (capturedMetricFieldKeys(input.customerMetrics).length === 0) {
      return {
        ok: false,
        reason: "property_metrics",
        message: "Cannot complete assessment \u2014 capture at least one surface metric."
      };
    }
    return { ok: true };
  }
  const billingMethod = input.billingMethod;
  const volumeEnabled = !!input.volumePricing?.enabled;
  const applicableMetrics = input.volumePricing?.applicableMetrics ?? [];
  const isPackage = billingMethod === "package" /* PACKAGE */;
  const isConsumable = billingMethod === "consumable" /* CONSUMABLE */;
  const isHourly = billingMethod === "per_hour" /* PER_HOUR */;
  const requiresBudgetedHours = !isHourly && !isPackage && !isConsumable && !volumeEnabled;
  const visitMetrics = input.customerMetrics ?? {};
  if (volumeEnabled && applicableMetrics.length > 0) {
    const missing = applicableMetrics.filter((enumKey) => {
      const fieldKey = metricEnumToFieldKey(enumKey);
      if (!fieldKey) return true;
      return (visitMetrics[fieldKey] ?? 0) <= 0;
    });
    if (missing.length > 0) {
      return {
        ok: false,
        reason: "volume_metrics",
        missingMetrics: missing,
        message: `Cannot complete assessment \u2014 capture a non-zero value for each surface metric (${missing.join(", ")}).`
      };
    }
    return { ok: true };
  }
  if (requiresBudgetedHours) {
    const hours = typeof input.budgetedHours === "number" ? input.budgetedHours : void 0;
    if (!hours || hours <= 0) {
      return {
        ok: false,
        reason: "budgeted_hours",
        message: "Cannot complete assessment \u2014 capture budgeted hours before completing."
      };
    }
  }
  return { ok: true };
}
function assessmentCompletionInputFromVisit(visit, template) {
  return {
    visitType: visit.visitType,
    serviceTemplateId: visit.serviceTemplateId,
    billingMethod: template?.billingMethod ?? visit.billingMethod,
    volumePricing: template?.volumePricing ?? visit.volumePricing,
    budgetedHours: visit.budgetedHours,
    customerMetrics: visit.customerMetrics
  };
}
function metricEnumToFieldKey(enumKey) {
  if (enumKey === "rock" || enumKey === "woodMulch" || enumKey === "turf") {
    return enumKey;
  }
  return METRIC_TYPE_TO_KEY[enumKey];
}

// src/helpers/displayLocale.ts
var TYPE_ES = {
  Recurring: "Recurrente",
  "One time": "Una vez"
};
var CADENCE_ES = {
  Daily: "Diario",
  Weekly: "Semanal",
  Monthly: "Mensual",
  "Once a year": "Una vez al a\xF1o",
  "On demand": "Bajo demanda",
  "One time": "Una vez",
  "Every other week": "Cada dos semanas",
  "Every other month": "Cada dos meses",
  "Every other year": "Cada dos a\xF1os",
  "Every 3 months": "Cada 3 meses",
  Seasonal: "Estacional",
  "Custom schedule": "Horario personalizado",
  "No schedule set": "Sin horario",
  "Once a season": "Una vez por temporada",
  "Twice a season": "Dos veces por temporada",
  "Twice a year": "Dos veces al a\xF1o"
};
var UNIT_ES = {
  day: { singular: "d\xEDa", plural: "d\xEDas" },
  days: { singular: "d\xEDa", plural: "d\xEDas" },
  week: { singular: "semana", plural: "semanas" },
  weeks: { singular: "semana", plural: "semanas" },
  month: { singular: "mes", plural: "meses" },
  months: { singular: "mes", plural: "meses" },
  year: { singular: "a\xF1o", plural: "a\xF1os" },
  years: { singular: "a\xF1o", plural: "a\xF1os" }
};
var MONTHS_EN = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
var MONTHS_ES = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre"
];
var MONTHS_EN_SHORT = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
var MONTHS_ES_SHORT = [
  "ene",
  "feb",
  "mar",
  "abr",
  "may",
  "jun",
  "jul",
  "ago",
  "sept",
  "oct",
  "nov",
  "dic"
];
function localizeTypeLabel(label, locale) {
  if (locale !== "es") return label;
  return TYPE_ES[label] ?? label;
}
function localizeCadenceLabel(label, locale) {
  if (locale !== "es" || !label) return label;
  const exact = CADENCE_ES[label];
  if (exact) return exact;
  const everyOther = label.match(/^Every other (\w+)$/i);
  if (everyOther) {
    const unit = UNIT_ES[everyOther[1].toLowerCase()];
    return unit ? `Cada dos ${unit.plural}` : label;
  }
  const everyN = label.match(/^Every (\d+) (\w+)$/i);
  if (everyN) {
    const n = Number(everyN[1]);
    const unit = UNIT_ES[everyN[2].toLowerCase()];
    if (unit) return `Cada ${n} ${n === 1 ? unit.singular : unit.plural}`;
  }
  const onceTwice = label.match(/^(Once|Twice) (a season|a year)$/i);
  if (onceTwice) {
    const count = onceTwice[1].toLowerCase() === "once" ? "Una vez" : "Dos veces";
    const scope = onceTwice[2].toLowerCase() === "a season" ? "por temporada" : "al a\xF1o";
    return `${count} ${scope}`;
  }
  const nTimes = label.match(/^(\d+) times (a season|a year)$/i);
  if (nTimes) {
    const scope = nTimes[2].toLowerCase() === "a season" ? "por temporada" : "al a\xF1o";
    return `${nTimes[1]} veces ${scope}`;
  }
  const visitsTotal = label.match(/^(\d+) visits total$/i);
  if (visitsTotal) return `${visitsTotal[1]} visitas en total`;
  return label;
}
function localizeGeneratedMonthLabel(label, locale) {
  if (locale !== "es" || !label) return label;
  const trimmed = label.trim();
  const fullIdx = MONTHS_EN.findIndex((m) => m.toLowerCase() === trimmed.toLowerCase());
  if (fullIdx >= 0) return MONTHS_ES[fullIdx];
  const shortIdx = MONTHS_EN_SHORT.findIndex((m) => m.toLowerCase() === trimmed.toLowerCase());
  if (shortIdx >= 0) return MONTHS_ES_SHORT[shortIdx];
  const leadingFull = trimmed.match(
    /^(January|February|March|April|May|June|July|August|September|October|November|December)(\b.*)$/i
  );
  if (leadingFull) {
    const idx = MONTHS_EN.findIndex((m) => m.toLowerCase() === leadingFull[1].toLowerCase());
    if (idx >= 0) return `${MONTHS_ES[idx]}${leadingFull[2]}`;
  }
  return label;
}
function localizeCrewDisplayName(name, locale) {
  if (!name) return "";
  if (locale !== "es") return name;
  return name.replace(/^Crew\b/i, "Equipo");
}
function localizeVisitScheduleDisplay(display, locale) {
  if (locale !== "es") return display;
  return {
    ...display,
    typeLabel: localizeTypeLabel(display.typeLabel, locale),
    cadenceLabel: display.cadenceLabel ? localizeCadenceLabel(display.cadenceLabel, locale) : display.cadenceLabel,
    periodLabels: display.periodLabels.map(
      (label) => localizeGeneratedMonthLabel(label, locale)
    )
  };
}
function displayIntlLocale(locale) {
  return locale === "es" ? "es" : "en-US";
}

// src/helpers/skipReasonLabel.ts
var SkipReasonKey = {
  CUSTOMER_REQUEST: "CUSTOMER_REQUEST",
  TOO_WET_DRY: "TOO_WET_DRY",
  SITE_ACCESS_BLOCKED: "SITE_ACCESS_BLOCKED",
  EQUIPMENT_ISSUE: "EQUIPMENT_ISSUE",
  WEATHER_CONDITIONS: "WEATHER_CONDITIONS",
  CUSTOMER_NOT_AVAILABLE: "CUSTOMER_NOT_AVAILABLE",
  SAFETY_CONCERNS: "SAFETY_CONCERNS",
  OTHER: "OTHER"
};
var SKIP_REASON_KEYS = Object.values(SkipReasonKey);
var SKIP_REASON_LABELS = {
  CUSTOMER_REQUEST: { en: "Customer Request", es: "Solicitud del Cliente" },
  TOO_WET_DRY: { en: "Too Wet/Dry", es: "Demasiado H\xFAmedo/Seco" },
  SITE_ACCESS_BLOCKED: { en: "Site Access Blocked", es: "Acceso al Sitio Bloqueado" },
  EQUIPMENT_ISSUE: { en: "Equipment Issue", es: "Problema de Equipo" },
  WEATHER_CONDITIONS: { en: "Weather Conditions", es: "Condiciones Clim\xE1ticas" },
  CUSTOMER_NOT_AVAILABLE: { en: "Customer Not Available", es: "Cliente No Disponible" },
  SAFETY_CONCERNS: { en: "Safety Concerns", es: "Preocupaciones de Seguridad" },
  OTHER: { en: "Other", es: "Otro" }
};
var PICKLIST_ID_TO_KEY = {
  "skip-customer-request": SkipReasonKey.CUSTOMER_REQUEST,
  "skip-too-wet-dry": SkipReasonKey.TOO_WET_DRY,
  "skip-access-blocked": SkipReasonKey.SITE_ACCESS_BLOCKED,
  "skip-equipment": SkipReasonKey.EQUIPMENT_ISSUE,
  "skip-weather": SkipReasonKey.WEATHER_CONDITIONS,
  "skip-customer-unavailable": SkipReasonKey.CUSTOMER_NOT_AVAILABLE,
  "skip-safety": SkipReasonKey.SAFETY_CONCERNS,
  "skip-other": SkipReasonKey.OTHER
};
var SKIP_REASON_KEY_TO_PICKLIST_ID = Object.fromEntries(
  Object.entries(PICKLIST_ID_TO_KEY).map(([id, key]) => [key, id])
);
var TRANSLATION_KEY_TO_KEY = {
  skipReasonCustomerRequest: SkipReasonKey.CUSTOMER_REQUEST,
  skipReasonTooWetDry: SkipReasonKey.TOO_WET_DRY,
  skipReasonAccessBlocked: SkipReasonKey.SITE_ACCESS_BLOCKED,
  skipReasonEquipment: SkipReasonKey.EQUIPMENT_ISSUE,
  skipReasonWeather: SkipReasonKey.WEATHER_CONDITIONS,
  skipReasonCustomerNotAvailable: SkipReasonKey.CUSTOMER_NOT_AVAILABLE,
  skipReasonSafety: SkipReasonKey.SAFETY_CONCERNS,
  skipReasonOther: SkipReasonKey.OTHER
};
function fold(value) {
  return value.normalize("NFD").replace(/\p{M}/gu, "").trim().toLowerCase();
}
var LABEL_TO_KEY = /* @__PURE__ */ new Map();
for (const key of SKIP_REASON_KEYS) {
  LABEL_TO_KEY.set(fold(key), key);
  LABEL_TO_KEY.set(fold(SKIP_REASON_LABELS[key].en), key);
  LABEL_TO_KEY.set(fold(SKIP_REASON_LABELS[key].es), key);
}
LABEL_TO_KEY.set(fold("Customer request"), SkipReasonKey.CUSTOMER_REQUEST);
LABEL_TO_KEY.set(fold("Too wet/dry"), SkipReasonKey.TOO_WET_DRY);
LABEL_TO_KEY.set(fold("Site access blocked"), SkipReasonKey.SITE_ACCESS_BLOCKED);
LABEL_TO_KEY.set(fold("Equipment issue"), SkipReasonKey.EQUIPMENT_ISSUE);
LABEL_TO_KEY.set(fold("Weather conditions"), SkipReasonKey.WEATHER_CONDITIONS);
LABEL_TO_KEY.set(fold("Customer not available"), SkipReasonKey.CUSTOMER_NOT_AVAILABLE);
LABEL_TO_KEY.set(fold("Safety concerns"), SkipReasonKey.SAFETY_CONCERNS);
var NOTE_JOINER = " - ";
function canonicalizeSkipReasonKey(value) {
  if (!value) return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  return PICKLIST_ID_TO_KEY[trimmed] ?? TRANSLATION_KEY_TO_KEY[trimmed] ?? LABEL_TO_KEY.get(fold(trimmed)) ?? null;
}
function canonicalizeSkipReason(skipReason) {
  if (typeof skipReason === "string") {
    return canonicalizeSkipReasonKey(skipReason) ?? skipReason;
  }
  if (!skipReason?.reason) return skipReason;
  const key = canonicalizeSkipReasonKey(skipReason.reason);
  if (!key || key === skipReason.reason) return skipReason;
  return { ...skipReason, reason: key };
}
function isDefaultCannedLabel(key, label) {
  const folded = fold(label);
  if (folded === fold(SKIP_REASON_LABELS[key].en)) return true;
  if (folded === fold(SKIP_REASON_LABELS[key].es)) return true;
  const picklistId = SKIP_REASON_KEY_TO_PICKLIST_ID[key];
  const seed = BUILT_IN_PICKLIST_ITEMS.find((item) => item.id === picklistId);
  return Boolean(seed && folded === fold(seed.label));
}
function labelForKey(key, locale, picklistItems) {
  const picklistId = SKIP_REASON_KEY_TO_PICKLIST_ID[key];
  const orgItem = picklistItems?.find((item) => item.id === picklistId);
  if (orgItem && orgItem.isActive !== false) {
    const orgLabel = orgItem.label?.trim();
    if (orgLabel && !isDefaultCannedLabel(key, orgLabel)) return orgLabel;
  }
  return SKIP_REASON_LABELS[key][locale];
}
function resolveSkipReasonLabel(stored, locale = "en", picklistItems) {
  if (!stored) return stored ?? "";
  const key = canonicalizeSkipReasonKey(stored);
  if (key) return labelForKey(key, locale, picklistItems);
  const idx = stored.indexOf(NOTE_JOINER);
  if (idx > 0) {
    const head = stored.slice(0, idx);
    const tail = stored.slice(idx + NOTE_JOINER.length);
    const headKey = canonicalizeSkipReasonKey(head);
    if (headKey) return `${labelForKey(headKey, locale, picklistItems)}${NOTE_JOINER}${tail}`;
  }
  return stored;
}
function formatSkipReasonDisplay(skipReason, locale = "en", joiner = NOTE_JOINER, picklistItems) {
  if (!skipReason) return "";
  const reason = skipReason.reason ? resolveSkipReasonLabel(skipReason.reason, locale, picklistItems) : "";
  const note = skipReason.customNote?.trim() ?? "";
  return [reason, note].filter((part) => part.length > 0).join(joiner);
}

// src/helpers/reviewReasonLabel.ts
var REVIEW_REASON_LABELS = {
  ["hours_exceeded_upper_bound" /* HOURS_EXCEEDED_UPPER_BOUND */]: "Hours exceeded budget",
  ["hours_below_lower_bound" /* HOURS_BELOW_LOWER_BOUND */]: "Hours below expected",
  ["manual_flag" /* MANUAL_FLAG */]: "Manual flag",
  ["quality_issue" /* QUALITY_ISSUE */]: "Quality issue",
  ["customer_complaint" /* CUSTOMER_COMPLAINT */]: "Customer complaint",
  ["crew_times_mismatch" /* CREW_TIMES_MISMATCH */]: "Crew times don't match",
  ["crew_note_no_photo" /* CREW_NOTE_NO_PHOTO */]: "Crew note without a photo",
  // Picklist labels stored as `reviewReason` when the org picklist loaded
  // (`FlagForReviewDialog` writes `item.label`, not the enum).
  "Manual flag": "Manual flag",
  "Quality issue": "Quality issue",
  "Customer complaint": "Customer complaint",
  "First time service": "First time service",
  "First visit / new customer": "First time service",
  // Built-in picklist ids, in case an older client persisted those.
  "review-manual-flag": "Manual flag",
  "review-quality-issue": "Quality issue",
  "review-customer-complaint": "Customer complaint"
};
var FOLDED_REASON_LABELS = /* @__PURE__ */ new Map();
for (const [key, label] of Object.entries(REVIEW_REASON_LABELS)) {
  FOLDED_REASON_LABELS.set(fold2(key), label);
}
FOLDED_REASON_LABELS.set(fold2("Manually flagged"), "Manual flag");
FOLDED_REASON_LABELS.set(fold2("Flagged"), "Manual flag");
FOLDED_REASON_LABELS.set(fold2("First visit"), "First time service");
function fold2(value) {
  return value.trim().toLowerCase();
}
function humanizeStoredReason(reason) {
  const words = reason.includes("_") ? reason.replace(/_/g, " ").replace(/\s+/g, " ").trim() : reason;
  return words || null;
}
function reviewReasonLabel(reason) {
  if (reason == null) return null;
  const trimmed = String(reason).trim();
  if (!trimmed) return null;
  return REVIEW_REASON_LABELS[trimmed] ?? FOLDED_REASON_LABELS.get(fold2(trimmed)) ?? humanizeStoredReason(trimmed);
}
function collectExceptions(visit) {
  return [...visit.billingExceptions ?? [], ...visit.exceptions ?? []].map((e) => String(e)).filter((e) => e.trim().length > 0);
}
function reviewReasonLabelFromExceptions(exceptions) {
  if (!exceptions) return null;
  for (const raw of exceptions) {
    const e = String(raw);
    if (!e.trim()) continue;
    if (e.startsWith(REVIEW_HOLD_TEXT.manual)) return REVIEW_REASON_LABELS["manual_flag" /* MANUAL_FLAG */];
    if (e.startsWith(REVIEW_HOLD_TEXT.followUpNotifies)) return "Follow-up";
    if (e.startsWith(REVIEW_HOLD_TEXT.templateReview)) return "Template requires review";
    if (e.startsWith(REVIEW_HOLD_TEXT.subscriptionReviewPrefix)) return "Requires review";
    if (e.startsWith(REVIEW_HOLD_TEXT.firstVisitPricing)) return REVIEW_REASON_LABELS["First time service"];
    if (e.startsWith(REVIEW_HOLD_TEXT.proofOfService)) return REVIEW_REASON_LABELS["First time service"];
    if (e.startsWith(REVIEW_HOLD_TEXT.serviceOptionPrefix)) return "Overage";
    if (e.startsWith(REVIEW_HOLD_TEXT.crewTimesPrefix)) {
      return REVIEW_REASON_LABELS["crew_times_mismatch" /* CREW_TIMES_MISMATCH */];
    }
    if (e.startsWith(REVIEW_HOLD_TEXT.hoursUpperPrefix)) {
      return REVIEW_REASON_LABELS["hours_exceeded_upper_bound" /* HOURS_EXCEEDED_UPPER_BOUND */];
    }
    if (e.startsWith(REVIEW_HOLD_TEXT.hoursLowerPrefix)) {
      return REVIEW_REASON_LABELS["hours_below_lower_bound" /* HOURS_BELOW_LOWER_BOUND */];
    }
    if (e.startsWith(REVIEW_HOLD_TEXT.variancePrefix)) return "Hours off budget";
    if (e.startsWith(REVIEW_HOLD_TEXT.crewNoteNoPhoto)) {
      return REVIEW_REASON_LABELS["crew_note_no_photo" /* CREW_NOTE_NO_PHOTO */];
    }
  }
  return null;
}
function visitReviewReasonLabel(visit) {
  if (!visit) return null;
  const fromReason = reviewReasonLabel(visit.reviewMetadata?.reviewReason);
  if (fromReason) return fromReason;
  return reviewReasonLabelFromExceptions(collectExceptions(visit));
}

// src/helpers/serviceActivation.ts
var FALLBACK_ACTIVATION_ERROR = "Please try again.";
function isOneProductSeason(periods) {
  if (periods.length === 0) return false;
  if (periods.length === 1) return true;
  const ranges = new Set(
    periods.map((p) => formatSeasonMonthRange([p])).filter(Boolean)
  );
  return ranges.size === 1;
}
function priorActivationPeriodIds(schedules, activePeriods) {
  const allowed = new Set(activePeriods.map((p) => p.id));
  const prior = /* @__PURE__ */ new Set();
  for (const schedule of schedules ?? []) {
    for (const id of schedule.periodIds ?? []) {
      if (allowed.has(id)) prior.add(id);
    }
  }
  return activePeriods.map((p) => p.id).filter((id) => prior.has(id));
}
function activationFailureMessage(error) {
  if (error instanceof Error) {
    const trimmed = error.message.trim();
    if (trimmed) return trimmed;
  }
  return FALLBACK_ACTIVATION_ERROR;
}
function getServiceActivationRequirements(template) {
  const allowRecurring = isScheduleTypeAllowed(template, ScheduleType.RECURRING);
  const allowLimited = isScheduleTypeAllowed(template, ScheduleType.LIMITED);
  const needsCadenceChoice = allowRecurring && allowLimited;
  const activePeriods = (template.periods ?? []).filter((p) => p.isActive).slice().sort((a, b) => a.startMonth - b.startMonth || a.startDay - b.startDay);
  const periodsSelectable = template.periodsSelectable === true;
  const needsPeriodChoice = periodsSelectable && activePeriods.length > 0 && !isOneProductSeason(activePeriods);
  const customerOptions = (template.serviceOptions ?? []).filter(
    (o) => o.customerSelectable === true
  );
  const packageOptions = template.billingMethod === "package" /* PACKAGE */ ? (template.packagePricing?.options ?? []).filter((o) => o.isActive !== false).slice().sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0)) : [];
  const needsConfig = needsCadenceChoice || needsPeriodChoice || customerOptions.length > 0 || packageOptions.length >= 2;
  return {
    allowRecurring,
    allowLimited,
    needsCadenceChoice,
    activePeriods,
    periodsSelectable,
    needsPeriodChoice,
    customerOptions,
    packageOptions,
    needsConfig
  };
}
function isActivationOptionAnswered(option, answer) {
  if (!answer) return false;
  if (option.rateType === "multi-select" /* MULTI_SELECT */) {
    if (option.selectionMode === "multiple") {
      return !!answer.choiceIds && answer.choiceIds.length > 0;
    }
    return !!answer.choiceId;
  }
  return answer.enabled !== void 0;
}
function validateServiceActivationSelection(reqs, selection) {
  const missingCadence = reqs.needsCadenceChoice && selection.isOneTime === void 0;
  const missingPeriods = reqs.needsPeriodChoice && !(selection.selectedPeriodIds && selection.selectedPeriodIds.length > 0);
  const unansweredOptionIds = reqs.customerOptions.filter((o) => !isActivationOptionAnswered(o, selection.optionAnswers?.[o.id])).map((o) => o.id);
  return {
    ok: !missingCadence && !missingPeriods && unansweredOptionIds.length === 0,
    missingCadence,
    missingPeriods,
    unansweredOptionIds
  };
}
function buildActivateSubscriptionBody(reqs, selection = {}) {
  const body = { action: "activate" };
  if (reqs.needsCadenceChoice) {
    if (selection.isOneTime !== void 0) body.isOneTime = selection.isOneTime;
  } else if (reqs.allowLimited && !reqs.allowRecurring) {
    body.isOneTime = true;
  } else if (reqs.allowRecurring && !reqs.allowLimited) {
    body.isOneTime = false;
  }
  if (reqs.periodsSelectable && reqs.activePeriods.length > 0) {
    const ids = selection.selectedPeriodIds && selection.selectedPeriodIds.length > 0 ? [...new Set(selection.selectedPeriodIds)] : isOneProductSeason(reqs.activePeriods) ? reqs.activePeriods.map((p) => p.id) : [];
    if (ids.length > 0) {
      body.selectedPeriodIds = ids;
      if (reqs.needsCadenceChoice && selection.isOneTime !== void 0) {
        body.periodScheduleAssignment = selection.isOneTime ? { recurring: [], limited: ids } : { recurring: ids, limited: [] };
      }
    }
  }
  if (reqs.customerOptions.length > 0) {
    body.customerSelectedOptions = reqs.customerOptions.map((o) => {
      const answer = selection.optionAnswers?.[o.id];
      const isMulti = o.rateType === "multi-select" /* MULTI_SELECT */;
      if (isMulti && o.selectionMode === "multiple") {
        const choiceIds = answer?.choiceIds ?? [];
        return { optionId: o.id, enabled: choiceIds.length > 0, choiceIds };
      }
      if (isMulti) {
        return { optionId: o.id, enabled: !!answer?.choiceId, choiceId: answer?.choiceId };
      }
      return { optionId: o.id, enabled: !!answer?.enabled };
    });
  }
  if (selection.selectedPackageOptionId) {
    body.selectedPackageOptionId = selection.selectedPackageOptionId;
  }
  return body;
}

// src/helpers/serviceDeactivation.ts
var CUSTOM_DEACTIVATION_REASON_ID = "deactivate-custom";
function fallbackDeactivationReasons() {
  return BUILT_IN_PICKLIST_ITEMS.filter(
    (item) => item.category === "deactivation_reason" /* DEACTIVATION_REASON */
  ).map((item) => ({ id: item.id, label: item.label }));
}
function deactivationReasonsFromPicklist(items) {
  const activeItems = items?.filter((item) => item.isActive);
  if (!activeItems?.length) return fallbackDeactivationReasons();
  return [...activeItems].sort((a, b) => a.sortOrder - b.sortOrder).map((item) => ({ id: item.id, label: item.label }));
}
function customDeactivationReasonLabel(options) {
  return options.find((option) => option.id === CUSTOM_DEACTIVATION_REASON_ID)?.label;
}
function resolveDeactivationReasons(selectedLabels, customReason, customLabel) {
  const trimmedCustom = customReason.trim();
  return selectedLabels.map((label) => label === customLabel ? trimmedCustom : label).filter((reason) => reason.length > 0);
}
function isDeactivationReasonsValid(selectedLabels, customReason, customLabel) {
  const customSelected = customLabel !== void 0 && selectedLabels.includes(customLabel);
  return !customSelected || customReason.trim().length > 0;
}
function buildDeactivationFormData(input) {
  const reasons = resolveDeactivationReasons(
    input.selectedReasons,
    input.customReason,
    input.customLabel
  );
  const scheduledDate = input.scheduleForLater && input.scheduledDate ? input.scheduledDate : void 0;
  return {
    notifyCustomer: input.notifyCustomer,
    reason: reasons.length > 0 ? reasons.join(", ") : void 0,
    reasons: reasons.length > 0 ? reasons : void 0,
    scheduledDate,
    customerMessage: input.notifyCustomer && input.customerMessage.trim() ? input.customerMessage.trim() : void 0,
    ...scheduledDate ? { deactivationCrewNote: input.crewNote.trim() } : {}
  };
}
function buildSingleServiceCancelBody(data) {
  return {
    action: "cancel" /* CANCEL */,
    ...data.scheduledDate ? { date: data.scheduledDate } : {},
    cancellationReason: data.reason,
    deactivationReasons: data.reasons,
    ...data.scheduledDate !== void 0 ? { deactivationCrewNote: data.deactivationCrewNote ?? "" } : {},
    notifyCustomer: data.notifyCustomer,
    customerMessage: data.customerMessage,
    adminNotes: data.reason || "Service deactivated"
  };
}
function buildCancelAllServicesBody(data, subscriptionIds) {
  return {
    reason: data.reason || "Deactivated all services",
    ...data.scheduledDate ? { date: data.scheduledDate } : {},
    subscriptionIds,
    skipMessage: !data.notifyCustomer,
    message: data.customerMessage,
    deactivationReasons: data.reasons,
    deactivationCrewNote: data.deactivationCrewNote
  };
}

// src/helpers/portalRequestReasons.ts
function resolveCustomerLabel(item) {
  if (item.customerLabel === "") return null;
  if (item.customerLabel != null && item.customerLabel.trim().length > 0) {
    return item.customerLabel.trim();
  }
  return BUILT_IN_CUSTOMER_LABELS[item.id] ?? null;
}
function portalReasonsFromPicklist(items, category) {
  return items.filter((item) => item.category === category && item.isActive !== false).sort((a, b) => a.sortOrder - b.sortOrder).flatMap((item) => {
    const label = resolveCustomerLabel(item);
    return label ? [{ id: item.id, label }] : [];
  });
}
function fallbackPortalReasons(category) {
  return BUILT_IN_PICKLIST_ITEMS.filter((item) => item.category === category).sort((a, b) => a.sortOrder - b.sortOrder).flatMap((item) => {
    const label = BUILT_IN_CUSTOMER_LABELS[item.id];
    return label ? [{ id: item.id, label }] : [];
  });
}
function visiblePortalReasons(items, category) {
  const fromOrg = portalReasonsFromPicklist(items, category);
  const hasAnyInCategory = items.some((item) => item.category === category);
  return hasAnyInCategory ? fromOrg : fallbackPortalReasons(category);
}
function isPortalCustomReasonId(id) {
  return id === PORTAL_SOMETHING_ELSE_ID || id === PORTAL_OTHER_ID;
}
function resolvePortalReasonLabel(input) {
  const customText = input.customText.trim();
  if (isPortalCustomReasonId(input.reasonId)) {
    return {
      reasonId: null,
      reasonLabel: customText.length > 0 ? customText : null,
      isCustomReason: customText.length > 0
    };
  }
  if (!input.reasonId) {
    return { reasonId: null, reasonLabel: null, isCustomReason: false };
  }
  const match = input.reasons.find((reason) => reason.id === input.reasonId);
  return {
    reasonId: match?.id ?? null,
    reasonLabel: match?.label ?? null,
    isCustomReason: false
  };
}
function buildDeactivateRequestMessage(input) {
  const lines = ["I would like to deactivate this service."];
  if (input.reasonLabel?.trim()) lines.push(`Reason: ${input.reasonLabel.trim()}`);
  if (input.note?.trim()) lines.push(input.note.trim());
  return lines.join("\n");
}
function buildPauseRequestMessage(input) {
  const lines = ["I would like to pause this service."];
  if (input.reasonLabel?.trim()) lines.push(`Reason: ${input.reasonLabel.trim()}`);
  lines.push(`Resume: ${input.resume}`);
  if (input.note?.trim()) lines.push(input.note.trim());
  return lines.join("\n");
}
function isPortalPauseRequestEnabled(showPortalPauseRequest) {
  return showPortalPauseRequest !== false;
}

// src/helpers/seasonRestart.ts
var YMD = /^(\d{4})-(\d{2})-(\d{2})$/;
function pad(n) {
  return String(n).padStart(2, "0");
}
function ymd(year, month, day) {
  const last = new Date(Date.UTC(year, month, 0)).getUTCDate();
  return `${year}-${pad(month)}-${pad(Math.min(day, last))}`;
}
function nextSeasonRestartYmd(periods, todayYmd) {
  const m = YMD.exec(todayYmd);
  if (!m) return void 0;
  const todayMd = Number(m[2]) * 100 + Number(m[3]);
  const seasons = (periods ?? []).filter(
    (p) => p.isActive !== false && p.startMonth >= 1 && p.startMonth <= 12 && p.startDay >= 1 && p.startDay <= 31
  );
  const inWrappedTail = seasons.some((p) => {
    if (p.endMonth == null || p.endDay == null) return false;
    const startMd = p.startMonth * 100 + p.startDay;
    const endMd = p.endMonth * 100 + p.endDay;
    return endMd < startMd && todayMd <= endMd;
  });
  const seasonYear = Number(m[1]) - (inWrappedTail ? 1 : 0);
  let soonest;
  for (const p of seasons) {
    const candidate = ymd(seasonYear + 1, p.startMonth, p.startDay);
    if (!soonest || candidate < soonest) soonest = candidate;
  }
  return soonest;
}

// src/helpers/periodReferences.ts
function collectRemovedPeriodIds(oldPeriods, newPeriods) {
  const next = new Set((newPeriods ?? []).map((p) => p.id).filter(Boolean));
  const removed = [];
  const seen = /* @__PURE__ */ new Set();
  for (const p of oldPeriods ?? []) {
    if (!p?.id || seen.has(p.id) || next.has(p.id)) continue;
    seen.add(p.id);
    removed.push(p.id);
  }
  return removed;
}
function referencedPeriodIds(sub, periodIds) {
  if (periodIds.length === 0) return [];
  const held = /* @__PURE__ */ new Set();
  for (const schedule of sub.schedules ?? []) {
    for (const id of schedule.periodIds ?? []) {
      if (id) held.add(id);
    }
  }
  return periodIds.filter((id) => held.has(id));
}
function subscriptionReferencesAnyPeriod(sub, periodIds) {
  return referencedPeriodIds(sub, periodIds).length > 0;
}
function findGhostPeriodIds(sub, validPeriodIds) {
  const valid = new Set(validPeriodIds);
  const ghosts = [];
  const seen = /* @__PURE__ */ new Set();
  const consider = (id) => {
    if (!id || valid.has(id) || seen.has(id)) return;
    seen.add(id);
    ghosts.push(id);
  };
  for (const schedule of sub.schedules ?? []) {
    for (const id of schedule.periodIds ?? []) consider(id);
  }
  return ghosts;
}
function applyPeriodIdRemap(sub, remap) {
  const map = remap instanceof Map ? remap : new Map(Object.entries(remap));
  if (map.size === 0) {
    return {
      schedules: sub.schedules ? [...sub.schedules] : void 0,
      changed: false
    };
  }
  let changed = false;
  let schedules;
  if (Array.isArray(sub.schedules)) {
    schedules = sub.schedules.map((s) => {
      if (!Array.isArray(s.periodIds)) return s;
      const next = remapIdList(s.periodIds, map);
      if (!next.changed) return s;
      changed = true;
      return { ...s, periodIds: next.list };
    });
  }
  return { schedules, changed };
}
function remapIdList(ids, map) {
  let changed = false;
  const out = [];
  const seen = /* @__PURE__ */ new Set();
  for (const id of ids) {
    const mapped = map.get(id) ?? id;
    if (mapped !== id) changed = true;
    if (seen.has(mapped)) {
      continue;
    }
    seen.add(mapped);
    out.push(mapped);
  }
  if (out.length !== ids.length) changed = true;
  return { list: out, changed };
}
function validatePeriodIdRemap(removedPeriodIds, remap, remainingPeriodIds) {
  const removed = new Set(removedPeriodIds);
  const remaining = new Set(remainingPeriodIds);
  const resolved = /* @__PURE__ */ new Map();
  if (!remap || Object.keys(remap).length === 0) {
    return { ok: true, remap: resolved };
  }
  for (const [from, to] of Object.entries(remap)) {
    if (!from || !to) {
      return {
        ok: false,
        error: "periodIdRemap entries must have non-empty from and to ids",
        remap: resolved
      };
    }
    if (from === to) {
      return {
        ok: false,
        error: `periodIdRemap cannot map a period to itself (${from})`,
        remap: resolved
      };
    }
    if (!removed.has(from)) {
      return {
        ok: false,
        error: `periodIdRemap source "${from}" is not being removed from this template`,
        remap: resolved
      };
    }
    if (removed.has(to)) {
      return {
        ok: false,
        error: `periodIdRemap target "${to}" is also being removed; remap to a period that remains`,
        remap: resolved
      };
    }
    if (!remaining.has(to)) {
      return {
        ok: false,
        error: `periodIdRemap target "${to}" is not on the updated period list`,
        remap: resolved
      };
    }
    resolved.set(from, to);
  }
  return { ok: true, remap: resolved };
}
function singleRemainingPeriodId(remainingPeriodIds) {
  let only = null;
  for (const id of remainingPeriodIds) {
    if (!id) continue;
    if (only !== null) return null;
    only = id;
  }
  return only;
}

// src/helpers/serviceNote.ts
function resolveServiceNoteForDate(subscription, periods, date) {
  const listed = listServiceNotesForDate(subscription, periods, date);
  return listed.find((n) => n.source === "period") ?? listed.find((n) => n.source === "general") ?? { source: "none" };
}
function listServiceNotesForDate(subscription, periods, date) {
  if (!subscription) return [];
  const notes = [];
  if (noteHasContent(subscription.adminNotes)) {
    notes.push({
      note: subscription.adminNotes,
      note_es: subscription.adminNotes_es,
      source: "general",
      updatedAt: subscription.adminNotesUpdatedAt
    });
  }
  const activePeriod = PeriodHelpers.getActivePeriod(periods ?? void 0, date);
  if (activePeriod && subscription.periodNotes?.length) {
    const periodNote = subscription.periodNotes.find(
      (pn) => pn.periodId === activePeriod.id
    );
    if (periodNote && noteHasContent(periodNote.note)) {
      notes.push({
        note: periodNote.note,
        note_es: periodNote.note_es,
        source: "period",
        periodId: activePeriod.id,
        updatedAt: periodNote.updatedAt
      });
    }
  }
  return notes;
}
function visitCalendarDate(scheduledDate, createdAt, timezone = DEFAULT_DISPLAY_TIMEZONE, nowIso = (/* @__PURE__ */ new Date()).toISOString()) {
  if (scheduledDate && isCalendarDate(scheduledDate)) return scheduledDate;
  if (createdAt) return getDateInTimezone(createdAt, timezone);
  return getDateInTimezone(nowIso, timezone);
}
function parseLocalCalendarDate(ymd2) {
  if (!ymd2) return void 0;
  const parts = ymd2.split("-").map((n) => Number(n));
  const [year, month, day] = parts;
  if (!year || !month || !day) return void 0;
  return new Date(year, month - 1, day);
}

// src/helpers/formatPackageVisitAllowance.ts
function formatPackageVisitAllowance({
  isUnlimitedVisits,
  builtInVisits
}) {
  if (isUnlimitedVisits) return "Unlimited visits";
  const n = builtInVisits ?? 0;
  return n === 1 ? "up to 1 visit" : `up to ${n} visits`;
}

// src/helpers/campaignAudienceLabel.ts
function plural2(n, one, many) {
  return `${n.toLocaleString("en-US")} ${n === 1 ? one : many}`;
}
function formatCampaignAudience({ customers, emails, texts }) {
  const head = plural2(customers, "customer", "customers");
  if (emails === void 0 && texts === void 0) return head;
  const parts = [];
  if (emails !== void 0 && emails > 0) parts.push(plural2(emails, "email", "emails"));
  if (texts !== void 0 && texts > 0) parts.push(plural2(texts, "text", "texts"));
  if (parts.length === 0) return head;
  return `${head} (${parts.join(", ")})`;
}
function formatStoredCampaignAudience(campaign) {
  if (typeof campaign.customerCount === "number") {
    return formatCampaignAudience({
      customers: campaign.customerCount,
      emails: campaign.emailCount ?? 0,
      texts: campaign.smsCount ?? 0
    });
  }
  return plural2(campaign.totalRecipients, "message", "messages");
}

// src/helpers/amountValidation.ts
function validateRequiredAmount(amount, fieldName = "amount") {
  if (amount === null || amount === void 0) {
    return {
      isValid: false,
      error: `${fieldName} is required but was not provided`
    };
  }
  if (typeof amount !== "number" || isNaN(amount)) {
    return {
      isValid: false,
      error: `${fieldName} must be a valid number`
    };
  }
  if (amount === 0) {
    return {
      isValid: false,
      error: `${fieldName} cannot be zero`
    };
  }
  if (amount < 0) {
    return {
      isValid: false,
      error: `${fieldName} cannot be negative`
    };
  }
  return {
    isValid: true,
    amount
  };
}
function validateOptionalAmount(amount, fieldName = "amount") {
  if (amount === null || amount === void 0) {
    return {
      isValid: true,
      amount: void 0
    };
  }
  if (typeof amount !== "number" || isNaN(amount)) {
    return {
      isValid: false,
      error: `${fieldName} must be a valid number`
    };
  }
  if (amount < 0) {
    return {
      isValid: false,
      error: `${fieldName} cannot be negative`
    };
  }
  return {
    isValid: true,
    amount
  };
}
function validateNonNegativeAmount(amount, fieldName = "amount") {
  if (amount === null || amount === void 0) {
    return {
      isValid: false,
      error: `${fieldName} is required but was not provided`
    };
  }
  if (typeof amount !== "number" || isNaN(amount)) {
    return {
      isValid: false,
      error: `${fieldName} must be a valid number`
    };
  }
  if (amount < 0) {
    return {
      isValid: false,
      error: `${fieldName} cannot be negative`
    };
  }
  return {
    isValid: true,
    amount
  };
}
function getSafeDisplayAmount(amount, fallback = 0) {
  if (typeof amount === "number" && !isNaN(amount)) {
    return amount;
  }
  return fallback;
}
function isAmountMissing(amount) {
  return amount === null || amount === void 0;
}
function isAmountZeroOrMissing(amount) {
  return amount === null || amount === void 0 || amount === 0;
}

// src/helpers/appVersion.ts
function sanitizeAppVersion(value) {
  if (typeof value !== "string") return void 0;
  const trimmed = value.trim();
  return /^\d+(\.\d+)*$/.test(trimmed) && trimmed.length <= 32 ? trimmed : void 0;
}
function parseVersion(version) {
  const sanitized = sanitizeAppVersion(version);
  return sanitized ? sanitized.split(".").map(Number) : null;
}
function isAppVersionBelow(installed, minimum) {
  if (!installed || !minimum) return false;
  const a = parseVersion(installed);
  const b = parseVersion(minimum);
  if (!a || !b) return false;
  const length = Math.max(a.length, b.length);
  for (let i = 0; i < length; i++) {
    const left = a[i] ?? 0;
    const right = b[i] ?? 0;
    if (left < right) return true;
    if (left > right) return false;
  }
  return false;
}

// src/helpers/address.ts
var UNIT_LINE = /^(#|\d|po\s+box\b|apt\b|apartment\b|unit\b|ste\b|suite\b|bldg\b|building\b|fl\b|floor\b|rm\b|room\b|lot\b|space\b|trlr\b)/i;
function resolveCustomerCity(address) {
  if (!address) return void 0;
  const city = parseGeocodedAddress(address)?.city?.trim();
  if (!city || !/[a-z]/i.test(city) || UNIT_LINE.test(city)) return void 0;
  return city;
}
function extractCity(address) {
  if (!address) return void 0;
  const parts = address.split(",").map((s) => s.trim()).filter(Boolean);
  if (parts.length >= 2) {
    return parts[1];
  }
  return void 0;
}
var UNKNOWN_CITY_BUCKET = "Unknown";
function extractCityBucket(address) {
  return extractCity(address) || UNKNOWN_CITY_BUCKET;
}

// src/helpers/typesense.ts
var TYPESENSE_CUSTOMERS_SCHEMA = {
  name: "customers",
  fields: [
    // Core Identity ('id' is managed by Typesense automatically)
    { name: "orgId", type: "string", facet: true },
    { name: "firstName", type: "string", optional: true, sort: true },
    { name: "lastName", type: "string", optional: true, sort: true },
    // Contact Information
    { name: "email", type: "string", optional: true },
    { name: "phone", type: "string", optional: true },
    { name: "primaryContactTypes", type: "string[]", optional: true, facet: true },
    { name: "primaryContactValues", type: "string[]", optional: true },
    { name: "hasPrimaryContact", type: "bool", optional: true, facet: true },
    { name: "emails", type: "string[]", optional: true },
    { name: "phones", type: "string[]", optional: true },
    { name: "contactNames", type: "string[]", optional: true },
    { name: "hasAnyEmail", type: "bool", optional: true, facet: true },
    { name: "hasAnyPhone", type: "bool", optional: true, facet: true },
    // Carrier-level text block — the customer replied STOP (RUT-3204)
    { name: "smsOptedOut", type: "bool", optional: true, facet: true },
    // Location
    { name: "address", type: "string", optional: true },
    { name: "city", type: "string", optional: true, facet: true },
    { name: "coordinates", type: "geopoint", optional: true },
    { name: "hasCoordinates", type: "bool", optional: true, facet: true },
    // Status & Source
    { name: "status", type: "string", optional: true, facet: true },
    { name: "source", type: "string", optional: true, facet: true },
    { name: "referrerSource", type: "string", optional: true },
    // Service Information
    { name: "serviceTemplates", type: "string[]", optional: true, facet: true },
    { name: "activeServiceCount", type: "int32", optional: true },
    // Payment Method Status
    { name: "hasPaymentMethod", type: "bool", optional: true, facet: true },
    { name: "paymentMethodStatus", type: "string", optional: true, facet: true },
    { name: "hasExpiredCard", type: "bool", optional: true, facet: true },
    { name: "hasExpiringCard", type: "bool", optional: true, facet: true },
    { name: "recentPaymentFailure", type: "bool", optional: true, facet: true },
    // Terms & conditions acceptance — setup icon on search cards (RUT-1494)
    { name: "hasAcceptedTerms", type: "bool", optional: true, facet: true },
    // In-collections flag — excludes the customer from payment-issue counts/lists (RUT-2560)
    { name: "inCollections", type: "bool", optional: true, facet: true },
    { name: "billsManually", type: "bool", optional: true, facet: true },
    // Deactivated flag — excludes the customer from marketing/outreach audiences (RUT-3075)
    { name: "deactivated", type: "bool", optional: true, facet: true },
    // Parcel (only parcelId - used for map marker grouping)
    { name: "parcelId", type: "string", optional: true },
    // Customer account — display on the list and search; accountId also filters
    { name: "accountId", type: "string", optional: true, facet: true },
    { name: "accountName", type: "string", optional: true },
    { name: "accountKind", type: "string", optional: true },
    { name: "accountLabel", type: "string", optional: true },
    // Lifecycle Timestamps
    { name: "customerSince", type: "int64", optional: true, sort: true },
    { name: "createdAt", type: "int64" },
    { name: "updatedAt", type: "int64", optional: true },
    { name: "deletedAt", type: "int64", optional: true },
    // Balance
    { name: "balance", type: "float", optional: true, sort: true },
    // Welcome Email Status
    { name: "hasWelcomeEmail", type: "bool", optional: true, facet: true },
    { name: "hasEmail", type: "bool", optional: true, facet: true },
    // Portal access
    { name: "lastPortalActiveAt", type: "string", optional: true }
  ],
  default_sorting_field: "createdAt"
};
var CUSTOMER_NAME_QUERY_BY = "firstName,lastName,contactNames";
var CUSTOMER_LOOKUP_QUERY_BY = `${CUSTOMER_NAME_QUERY_BY},email,address`;
var CUSTOMER_SEARCH_QUERY_BY = `${CUSTOMER_NAME_QUERY_BY},email,phone,address`;
var normalizedSort = (f) => f.sort ?? ["int32", "int64", "float", "bool", "geopoint"].includes(f.type);
var normalizedFacet = (f) => f.facet ?? false;
var normalizedIndex = (f) => f.index ?? true;
function diffCollectionFields(liveFields, desiredFields) {
  const existingFields = /* @__PURE__ */ new Map();
  for (const field of liveFields) existingFields.set(field.name, field);
  const fieldsToAdd = [];
  const fieldsToFix = [];
  const fieldsToOptimize = [];
  for (const desired of desiredFields) {
    const existing = existingFields.get(desired.name);
    if (existing === void 0) {
      fieldsToAdd.push(desired);
      continue;
    }
    const gainsCapability = !normalizedSort(existing) && normalizedSort(desired) || !normalizedFacet(existing) && normalizedFacet(desired) || !normalizedIndex(existing) && normalizedIndex(desired);
    const losesCapability = normalizedSort(existing) && !normalizedSort(desired) || normalizedFacet(existing) && !normalizedFacet(desired) || normalizedIndex(existing) && !normalizedIndex(desired);
    if (existing.type !== desired.type || gainsCapability) {
      fieldsToFix.push({ field: desired, currentField: existing });
    } else if (losesCapability) {
      fieldsToOptimize.push({ field: desired, currentField: existing });
    }
  }
  return { fieldsToAdd, fieldsToFix, fieldsToOptimize };
}
var TYPESENSE_SUBSCRIPTIONS_SCHEMA = {
  name: "subscriptions",
  fields: [
    // Core Identity ('id' is managed by Typesense automatically)
    { name: "orgId", type: "string", facet: true },
    { name: "customerId", type: "string", facet: true },
    // Customer Data (denormalized for search)
    { name: "customerName", type: "string", optional: true },
    { name: "customerFirstName", type: "string", optional: true, sort: true },
    { name: "customerLastName", type: "string", optional: true, sort: true },
    { name: "customerEmail", type: "string", optional: true },
    { name: "customerPhone", type: "string", optional: true },
    { name: "customerEmails", type: "string[]", optional: true },
    { name: "customerPhones", type: "string[]", optional: true },
    { name: "customerAddress", type: "string", optional: true },
    { name: "customerCity", type: "string", optional: true, facet: true },
    { name: "lastPortalActiveAt", type: "int64", optional: true },
    // Service Template Data (denormalized)
    { name: "serviceTemplateId", type: "string" },
    { name: "serviceTemplateName", type: "string", optional: true, facet: true, sort: true },
    // Display-only: read back for the services list and unified search, never in a
    // query_by. index:false keeps the value retrievable without building a text index
    // over the single largest field in the document (~29% of the payload).
    { name: "serviceTemplateDescription", type: "string", optional: true, index: false },
    { name: "serviceTemplateCategory", type: "string", optional: true, facet: true },
    { name: "serviceTemplatePricingMethod", type: "string", optional: true, facet: true },
    { name: "serviceTemplateVolumePricing", type: "string", optional: true },
    { name: "serviceTemplatePackagePricing", type: "string", optional: true },
    // State Management
    { name: "subscriptionStatus", type: "string", optional: true, facet: true },
    { name: "rateVisibility", type: "string", optional: true, facet: true },
    { name: "packageDeliveryState", type: "string", optional: true, facet: true },
    { name: "pricingLocked", type: "bool", optional: true, facet: true },
    { name: "isReviewed", type: "bool", optional: true, facet: true },
    { name: "isOneOffService", type: "bool", optional: true, facet: true },
    // Note: rateMismatchAmount removed - calculated client-side from template data
    { name: "hasMetrics", type: "bool", optional: true, facet: true },
    { name: "hasOutstandingCustomerQuestions", type: "bool", optional: true, facet: true },
    { name: "isMissingSeason", type: "bool", optional: true, facet: true },
    { name: "hasPriorityVisit", type: "bool", optional: true, facet: true },
    // Optional in the schema (pre-existing docs lack it until reindexed) but
    // always emitted by the doc builder (RUT-4118).
    { name: "isPendingStart", type: "bool", optional: true, facet: true },
    { name: "scheduledActivationDate", type: "string", optional: true, index: false },
    // Pricing
    { name: "rate", type: "float", optional: true, sort: true },
    { name: "ratePer", type: "string", optional: true, facet: true },
    { name: "billingMethod", type: "string", optional: true, facet: true, sort: true },
    { name: "perVisitRate", type: "float", optional: true },
    { name: "hourlyRate", type: "float", optional: true },
    { name: "flatRate", type: "float", optional: true },
    { name: "pricingInputs", type: "string", optional: true },
    { name: "hourBounds", type: "string", optional: true },
    { name: "minimumCharge", type: "float", optional: true },
    { name: "builtInHours", type: "float", optional: true },
    { name: "rateBreakdown", type: "string", optional: true },
    // Schedule
    { name: "frequency", type: "string", optional: true, facet: true },
    { name: "dayOfWeek", type: "int32", optional: true },
    { name: "dayOfMonth", type: "int32", optional: true },
    { name: "startDate", type: "int64", optional: true },
    { name: "endDate", type: "int64", optional: true },
    { name: "lastVisitDate", type: "int64", optional: true },
    { name: "scheduleConfig", type: "string", optional: true },
    { name: "adminNotificationConfig", type: "string", optional: true },
    // Customer-Selected Periods
    { name: "selectedPeriodIds", type: "string[]", optional: true },
    { name: "selectedPeriodNames", type: "string[]", optional: true, facet: true },
    { name: "customerSelectedOptionLabels", type: "string[]", optional: true },
    // `{optionId}:yes|no|unset` tokens so All Services can filter FLAT customer questions (RUT-3605)
    { name: "customerSelectedOptionStates", type: "string[]", optional: true },
    { name: "customerNotes", type: "string", optional: true },
    // Package State
    { name: "selectedPackageOptionId", type: "string", optional: true, facet: true },
    { name: "selectedPackageOptionName", type: "string", optional: true, sort: true },
    // Per-option season + per-visit rates (JSON PackageOptionPricing[]) — RUT-3185
    { name: "packageOptionPricing", type: "string", optional: true },
    { name: "packageState", type: "string", optional: true },
    // Request Flow State
    { name: "requestState", type: "string", optional: true, facet: true },
    { name: "requestedAt", type: "int64", optional: true },
    { name: "requestedBy", type: "string", optional: true },
    { name: "rateProvidedAt", type: "int64", optional: true, sort: true },
    { name: "rateViewedAt", type: "int64", optional: true },
    { name: "approvedAt", type: "int64", optional: true },
    { name: "approvedBy", type: "string", optional: true },
    { name: "rejectionReason", type: "string", optional: true },
    // Optional in the schema (pre-existing docs lack it until reindexed) but
    // always emitted by the doc builder — 0 means "not snoozed" (RUT-2698).
    { name: "rateRequestSnoozedUntil", type: "int64", optional: true },
    // Optional in the schema (pre-existing docs lack it until reindexed) but
    // always emitted by the doc builder — 0 means "not flagged for rate review".
    { name: "rateReviewFlaggedAt", type: "int64", optional: true },
    // Hide-for-review marker (RUT-4539). Optional until reindexed; the doc
    // builder always emits hiddenAt (0 = not hidden for review).
    { name: "hiddenAt", type: "int64", optional: true },
    { name: "hiddenForReview", type: "bool", optional: true },
    { name: "hiddenRate", type: "float", optional: true },
    // Work Assignment
    { name: "assignedCrewId", type: "string", optional: true, facet: true },
    { name: "assignedCrewName", type: "string", optional: true, sort: true },
    { name: "crewNotes", type: "string", optional: true },
    // Always-present mirror of "has a crew assigned" so unassigned subscriptions
    // can be filtered (Typesense rejects the empty `assignedCrewId:=` filter).
    { name: "isAssigned", type: "bool", optional: true, facet: true },
    // Service Execution
    { name: "estimatedDuration", type: "int32", optional: true },
    { name: "actualDuration", type: "int32", optional: true },
    { name: "serviceNotes", type: "string", optional: true },
    { name: "adminNotes", type: "string", optional: true },
    { name: "completionPhotos", type: "string", optional: true },
    { name: "completionNotes", type: "string", optional: true },
    // Metrics
    { name: "totalVisits", type: "int32", optional: true },
    { name: "completedVisits", type: "int32", optional: true },
    { name: "cancelledVisits", type: "int32", optional: true },
    { name: "totalRevenue", type: "float", optional: true },
    { name: "averageVisitDuration", type: "float", optional: true },
    { name: "customerSatisfactionScore", type: "float", optional: true },
    { name: "totalVisitsCompleted", type: "int32", optional: true },
    { name: "visitReviewRequirements", type: "string", optional: true },
    // Admin & Internal
    { name: "internalNotes", type: "string", optional: true },
    { name: "tags", type: "string", optional: true },
    { name: "customFields", type: "string", optional: true },
    { name: "sourceTemplateId", type: "string", optional: true },
    // Lifecycle
    { name: "createdAt", type: "int64" },
    { name: "createdBy", type: "string", optional: true },
    { name: "updatedAt", type: "int64", optional: true },
    { name: "updatedBy", type: "string", optional: true },
    { name: "deletedAt", type: "int64", optional: true }
  ],
  default_sorting_field: "createdAt"
};
function calculatePaymentStatus(paymentMethods, hasRecentPaymentFailure = false) {
  const now = /* @__PURE__ */ new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;
  const thirtyDaysFromNow = new Date(now.getTime() + 30 * 24 * 60 * 60 * 1e3);
  const futureYear = thirtyDaysFromNow.getFullYear();
  const futureMonth = thirtyDaysFromNow.getMonth() + 1;
  const hasPaymentMethod = paymentMethods.length > 0;
  if (!hasPaymentMethod) {
    return {
      hasPaymentMethod: false,
      paymentMethodStatus: "none",
      hasExpiredCard: false,
      hasExpiringCard: false,
      recentPaymentFailure: hasRecentPaymentFailure
    };
  }
  const cards = paymentMethods.filter((pm) => pm.type === "card");
  let hasExpiredCard = false;
  let hasExpiringCard = false;
  for (const card of cards) {
    if (!card.expMonth || !card.expYear) continue;
    const expMonth = parseInt(card.expMonth, 10);
    let expYear = parseInt(card.expYear, 10);
    if (expYear < 100) {
      expYear += 2e3;
    }
    if (expYear < currentYear || expYear === currentYear && expMonth < currentMonth) {
      hasExpiredCard = true;
    } else if (expYear < futureYear || expYear === futureYear && expMonth <= futureMonth) {
      hasExpiringCard = true;
    }
  }
  let paymentMethodStatus;
  if (hasExpiredCard) {
    paymentMethodStatus = "expired";
  } else if (hasExpiringCard) {
    paymentMethodStatus = "expiring_soon";
  } else {
    paymentMethodStatus = "valid";
  }
  return {
    hasPaymentMethod: true,
    paymentMethodStatus,
    hasExpiredCard,
    hasExpiringCard,
    recentPaymentFailure: hasRecentPaymentFailure
  };
}
function buildContactNames(contacts) {
  const seen = /* @__PURE__ */ new Set();
  const names = [];
  for (const c of contacts) {
    const full = [c.firstName, c.lastName].filter(Boolean).join(" ").trim();
    if (full && !seen.has(full.toLowerCase())) {
      seen.add(full.toLowerCase());
      names.push(full);
    }
  }
  return names;
}
function accountReferenceFromDocument(doc) {
  if (!doc.accountId) return null;
  return {
    id: doc.accountId,
    name: doc.accountName ?? "",
    kind: doc.accountKind === "organization" ? "organization" : "individual",
    ...doc.accountLabel ? { label: doc.accountLabel } : {}
  };
}
function customerToTypesenseDocument(customer, paymentStatus, primaryContacts, allContacts) {
  const toTimestamp = (isoDate) => {
    return isoDate ? Math.floor(new Date(isoDate).getTime() / 1e3) : void 0;
  };
  let coordinates = void 0;
  if (customer.coordinates && Array.isArray(customer.coordinates) && customer.coordinates.length === 2) {
    const [lon, lat] = customer.coordinates;
    if (typeof lat === "number" && typeof lon === "number" && !isNaN(lat) && !isNaN(lon) && lat >= -90 && lat <= 90 && lon >= -180 && lon <= 180) {
      coordinates = [lat, lon];
    }
  }
  let firstName = customer.firstName;
  let lastName = customer.lastName;
  if (!firstName && !lastName && customer.displayName) {
    const parts = customer.displayName.trim().split(/\s+/);
    if (parts.length >= 2) {
      firstName = parts[0];
      lastName = parts.slice(1).join(" ");
    } else if (parts.length === 1) {
      firstName = parts[0];
    }
  }
  const nullToUndefined = (value) => {
    return value === null ? void 0 : value;
  };
  return {
    // Core Identity
    id: customer.id,
    orgId: customer.orgId,
    firstName,
    lastName,
    // Contact Information
    email: customer.email,
    phone: customer.phone ? normalizePhone(customer.phone) || customer.phone : customer.phone,
    // Primary Contacts (from Contact entities for messaging)
    primaryContactTypes: primaryContacts?.map((c) => c.contactType?.toLowerCase()).filter(Boolean),
    primaryContactValues: primaryContacts?.map((c) => c.contactValue),
    hasPrimaryContact: !!primaryContacts && primaryContacts.length > 0,
    // All Contacts (from Contact entities + legacy customer fields)
    emails: allContacts?.emails,
    phones: allContacts?.phones?.map((p) => normalizePhone(p) || p),
    contactNames: allContacts?.names,
    hasAnyEmail: !!(allContacts?.emails && allContacts.emails.length > 0) || !!(customer.email && customer.email.trim().length > 0),
    hasAnyPhone: !!(allContacts?.phones && allContacts.phones.length > 0) || !!(customer.phone && customer.phone.trim().length > 0),
    smsOptedOut: allContacts?.smsOptedOut === true ? true : void 0,
    // Location
    address: customer.address,
    city: customer.city || resolveCustomerCity(customer.address),
    coordinates,
    hasCoordinates: !!coordinates,
    // Status & Source
    status: customer.status,
    source: customer.source,
    referrerSource: customer.referrerSource,
    // Service Information
    serviceTemplates: customer.serviceTemplates,
    activeServiceCount: customer.activeServiceCount,
    // Payment Method Status (from optional paymentStatus parameter)
    hasPaymentMethod: paymentStatus?.hasPaymentMethod,
    paymentMethodStatus: paymentStatus?.paymentMethodStatus,
    hasExpiredCard: paymentStatus?.hasExpiredCard,
    hasExpiringCard: paymentStatus?.hasExpiringCard,
    recentPaymentFailure: paymentStatus?.recentPaymentFailure,
    // In-collections suppression flag (RUT-2560). Only true is meaningful;
    // absence is treated as "not in collections" by the `inCollections:!=true` filters.
    inCollections: customer.inCollections,
    // Manual billing — index true only so `billsManually:!=true` matches omitted docs.
    billsManually: customer.billsManually === true ? true : void 0,
    // Deactivated suppression flag (RUT-3075). Only true is meaningful; absence
    // (or the null left by reactivation) is treated as "active" by the
    // `deactivated:!=true` filter that carves deactivated customers out of every
    // marketing/outreach audience.
    deactivated: customer.deactivation ? true : void 0,
    // Terms & conditions acceptance — surfaced as a setup icon on search cards (RUT-1494)
    hasAcceptedTerms: !!customer.termsAcceptedAt,
    // Parcel (only parcelId for map marker grouping)
    parcelId: nullToUndefined(customer.parcelData?.pin),
    // Customer account — copied from Customer.account (see denormalization.md)
    accountId: customer.account?.id,
    accountName: customer.account?.name,
    accountKind: customer.account?.kind,
    accountLabel: customer.account?.label,
    // Lifecycle Timestamps
    customerSince: toTimestamp(customer.customerSince),
    createdAt: Math.floor(new Date(customer.createdAt).getTime() / 1e3),
    updatedAt: toTimestamp(customer.updatedAt),
    deletedAt: toTimestamp(customer.deletedAt),
    // Balance
    balance: customer.balance?.current ?? 0,
    // Whether this customer has been welcomed, by any channel (RUT-3371) — the
    // index field keeps its original name; the meaning is "already greeted".
    hasWelcomeEmail: !!customer.welcomeEmailSentAt,
    hasEmail: !!customer.email && customer.email.trim().length > 0,
    // Portal access
    lastPortalActiveAt: customer.lastPortalActiveAt
  };
}
function extractCityFromAddress(address) {
  if (!address) return void 0;
  const parts = address.split(",").map((s) => s.trim());
  if (parts.length >= 2) {
    return parts[1];
  }
  return void 0;
}
function hasCustomerMetrics(pricingInputs, applicableMetrics) {
  if (areApplicableMetricsAbsent(pricingInputs?.absentMetrics, applicableMetrics)) return true;
  if (!pricingInputs?.customerMetrics) return false;
  const metrics = pricingInputs.customerMetrics;
  return Object.values(metrics).some((val) => typeof val === "number" && val > 0);
}
function deriveRequestState(subscription) {
  return subscription.subscriptionStatus === "requested" ? "pending" : subscription.rateProvidedAt && !subscription.respondedAt ? "awaiting_response" : subscription.respondedAt ? "responded" : void 0;
}
function subscriptionToTypesenseDocument(subscription, customerContacts) {
  const toTimestamp = (isoDate) => {
    return isoDate ? Math.floor(new Date(isoDate).getTime() / 1e3) : void 0;
  };
  const safeJsonStringify = (obj) => {
    return obj ? JSON.stringify(obj) : void 0;
  };
  const activeSubscriptionSchedules = activeSchedules(subscription);
  const activeSchedulePeriodIds = Array.from(
    new Set(activeSubscriptionSchedules.flatMap((s) => s.periodIds ?? []))
  );
  const isMissingSeason = !!subscription.seasonalAvailability?.length && activeSubscriptionSchedules.length > 0 && activeSchedulePeriodIds.length === 0;
  return {
    // Core Identity
    id: subscription.id,
    orgId: subscription.orgId,
    customerId: subscription.customerId,
    // Customer Data (denormalized for search)
    customerName: subscription.customerName,
    customerFirstName: subscription.customerFirstName,
    customerLastName: subscription.customerLastName,
    customerEmail: subscription.customerEmail,
    customerPhone: subscription.customerPhone ? normalizePhone(subscription.customerPhone) || subscription.customerPhone : subscription.customerPhone,
    customerEmails: customerContacts?.emails,
    customerPhones: customerContacts?.phones?.map((p) => normalizePhone(p) || p),
    customerAddress: subscription.customerAddress,
    customerCity: extractCityFromAddress(subscription.customerAddress),
    // Merged in by the index-time enrichment from the customer record.
    lastPortalActiveAt: toTimestamp(subscription.lastPortalActiveAt),
    // Service Template Data (denormalized)
    serviceTemplateId: subscription.serviceTemplateId,
    serviceTemplateName: subscription.serviceTemplateName,
    serviceTemplateDescription: subscription.serviceTemplateDescription,
    serviceTemplateCategory: subscription.serviceTemplateCategory,
    serviceTemplatePricingMethod: subscription.serviceTemplatePricingMethod,
    serviceTemplateVolumePricing: safeJsonStringify(subscription.serviceTemplateVolumePricing),
    serviceTemplatePackagePricing: safeJsonStringify(subscription.serviceTemplatePackagePricing),
    // State Management
    subscriptionStatus: subscription.subscriptionStatus,
    rateVisibility: subscription.rateVisibility,
    pricingLocked: subscription.pricingLocked,
    isReviewed: !!subscription.reviewedAt,
    isOneOffService: subscription.isOneOffService,
    // Note: rateMismatchAmount removed - calculated client-side from template data
    hasMetrics: hasCustomerMetrics(
      subscription.pricingInputs,
      subscription.serviceTemplateVolumePricing?.applicableMetrics
    ),
    hasOutstandingCustomerQuestions: needsCustomerAnswers(
      { serviceOptions: subscription.serviceTemplateServiceOptions },
      { customerSelectedOptions: subscription.customerSelectedOptions }
    ),
    isMissingSeason,
    hasPriorityVisit: subscription.hasPriorityVisit,
    // A future-start activation is held INACTIVE, so it needs its own flag to
    // reach the new-activations queue before its start date (RUT-4118).
    isPendingStart: isPendingStartStatus(subscription),
    scheduledActivationDate: isPendingStartStatus(subscription) ? String(subscription.scheduledActivationDate).trim() : void 0,
    packageDeliveryState: subscription.packageState ? subscription.packageState.visitsRemaining > 0 ? "active" : "expired" : void 0,
    // Pricing (normalize to 0 so Typesense can filter for "no rate" with rate:<=0)
    rate: subscription.rate ?? 0,
    ratePer: subscription.pricingInputs?.budgetedHours ? "hour" : subscription.pricingInputs?.visits ? "visit" : void 0,
    billingMethod: subscription.billingMethod,
    perVisitRate: subscription.pricePerAdditionalVisit,
    hourlyRate: subscription.pricingInputs?.budgetedHours ? subscription.rate && subscription.pricingInputs.budgetedHours > 0 ? subscription.rate / subscription.pricingInputs.budgetedHours : void 0 : void 0,
    flatRate: subscription.rate,
    pricingInputs: safeJsonStringify(subscription.pricingInputs),
    hourBounds: safeJsonStringify(subscription.hourBounds),
    minimumCharge: subscription.minimumCharge,
    builtInHours: subscription.builtInHours,
    rateBreakdown: safeJsonStringify(subscription.rateBreakdown),
    // Schedule
    frequency: subscription.scheduleConfig?.frequency,
    dayOfWeek: subscription.scheduleConfig?.dayOfWeek,
    dayOfMonth: subscription.scheduleConfig?.dayOfMonth,
    startDate: toTimestamp(subscription.serviceStartDate),
    endDate: toTimestamp(subscription.serviceEndDate),
    lastVisitDate: toTimestamp(subscription.lastCompletedVisitDate),
    scheduleConfig: safeJsonStringify(subscription.scheduleConfig),
    adminNotificationConfig: safeJsonStringify(subscription.adminNotificationConfig),
    // Customer-Selected Periods
    selectedPeriodIds: activeSchedulePeriodIds.length ? activeSchedulePeriodIds : void 0,
    selectedPeriodNames: activeSchedulePeriodIds.length && subscription.seasonalAvailability?.length ? activeSchedulePeriodIds.map((id) => subscription.seasonalAvailability.find((p) => p.id === id)?.name).filter(Boolean) : void 0,
    customerSelectedOptionLabels: (() => {
      const labels = buildCustomerSelectedOptionLabels(
        subscription.serviceTemplateServiceOptions,
        subscription.customerSelectedOptions
      );
      return labels.length ? labels : void 0;
    })(),
    customerSelectedOptionStates: (() => {
      const states = buildCustomerSelectedOptionStates(
        subscription.serviceTemplateServiceOptions,
        subscription.customerSelectedOptions
      );
      return states.length ? states : void 0;
    })(),
    customerNotes: subscription.customerNotes,
    // Package State
    selectedPackageOptionId: subscription.selectedPackageOptionId,
    selectedPackageOptionName: subscription.selectedPackageOptionName,
    packageOptionPricing: safeJsonStringify(subscription.packageOptionPricing),
    packageState: safeJsonStringify(subscription.packageState),
    // Request Flow State
    requestState: deriveRequestState(subscription),
    requestedAt: toTimestamp(subscription.requestedAt),
    requestedBy: subscription.requestedBy,
    rateProvidedAt: toTimestamp(subscription.rateProvidedAt),
    rateViewedAt: toTimestamp(subscription.rateViewedAt),
    // Config Activated (RUT-4239). A held future-start — not ACTIVE, has a
    // start date, customer already accepted — must use respondedAt even when
    // an older activatedAt remains from a previous live period. Live ACTIVE
    // rows keep activatedAt so a later rate-change respondedAt cannot move
    // the date. createdAt is last-resort for rows that never accepted.
    approvedAt: toTimestamp(
      isPendingStartStatus(subscription) && subscription.respondedAt ? subscription.respondedAt : subscription.activatedAt || subscription.respondedAt || subscription.createdAt
    ),
    approvedBy: subscription.rateProvidedBy,
    rejectionReason: subscription.deactivationReason,
    // Always emitted (0 = not snoozed) so read-time "actively snoozed" range
    // filters work — mirrors the isAssigned always-emitted pattern (RUT-2698).
    rateRequestSnoozedUntil: toTimestamp(subscription.rateRequestSnooze?.snoozedUntil) ?? 0,
    // Always emitted (0 = not flagged) so the rate-review list can filter
    // `rateReviewFlaggedAt:>0` — same pattern as the snooze field above.
    rateReviewFlaggedAt: toTimestamp(subscription.rateReviewFlag?.flaggedAt) ?? 0,
    hiddenAt: toTimestamp(subscription.hiddenAt) ?? 0,
    hiddenForReview: subscription.hiddenForReview === true,
    hiddenRate: subscription.hiddenRate,
    // Work Assignment
    assignedCrewId: subscription.assignedCrewId,
    // Always emitted (true/false) so "unassigned" subscriptions are filterable;
    // Typesense can't filter an optional field for being empty/unset.
    isAssigned: !!subscription.assignedCrewId,
    assignedCrewName: subscription.assignedCrewName,
    crewNotes: subscription.crewNotes,
    // Service Execution
    estimatedDuration: subscription.pricingInputs?.budgetedHours ? Math.round(subscription.pricingInputs.budgetedHours * 60) : void 0,
    actualDuration: void 0,
    // Would come from visit data
    serviceNotes: subscription.customerNotes || subscription.adminNotes,
    adminNotes: subscription.invoiceNotes,
    completionPhotos: safeJsonStringify(subscription.customerAttachments),
    completionNotes: subscription.adminNotes,
    // Metrics
    totalVisits: subscription.packageState?.totalVisits,
    completedVisits: subscription.packageState?.totalVisits && subscription.packageState?.visitsRemaining ? subscription.packageState.totalVisits - subscription.packageState.visitsRemaining : void 0,
    cancelledVisits: void 0,
    // Not tracked in subscription
    totalRevenue: subscription.totalRevenue,
    averageVisitDuration: void 0,
    // Would come from visit data
    customerSatisfactionScore: void 0,
    // Not in current model
    totalVisitsCompleted: subscription.totalVisitsCompleted,
    visitReviewRequirements: safeJsonStringify(subscription.visitReviewRequirements),
    // Admin & Internal
    internalNotes: subscription.adminNotes,
    tags: safeJsonStringify(subscription.tags),
    customFields: safeJsonStringify(subscription.customFields),
    sourceTemplateId: subscription.sourceTemplateId,
    // Lifecycle
    createdAt: Math.floor(new Date(subscription.createdAt).getTime() / 1e3),
    createdBy: subscription.requestedBy === "admin" ? subscription.requestedBy : "customer",
    updatedAt: toTimestamp(subscription.updatedAt),
    updatedBy: subscription.rateProvidedBy || subscription.scheduleUpdatedBy,
    deletedAt: toTimestamp(subscription.deletedAt)
  };
}
var TYPESENSE_VISITS_SCHEMA = {
  name: "visits",
  fields: [
    // Core Identity ('id' is managed by Typesense automatically)
    { name: "orgId", type: "string", facet: true },
    { name: "customerId", type: "string", facet: true },
    { name: "serviceTemplateId", type: "string", optional: true, facet: true },
    { name: "subscriptionId", type: "string", optional: true },
    { name: "crewId", type: "string", optional: true, facet: true },
    { name: "crewMemberNames", type: "string[]", optional: true, facet: true },
    // Natural-sort key built from the assigned crew's name (see buildCrewSortKey),
    // so "Crew 2" < "Crew 10" < "Crew 28". Powers crew ordering on All Visits (RUT-2641).
    { name: "crewSortKey", type: "string", optional: true, sort: true },
    // Fractional queue rank within a crew (LexoRank string). Powers route order on
    // Schedule → Today via Typesense (RUT-3334). DDB remains source of truth for writes.
    { name: "rank", type: "string", optional: true, sort: true },
    // Display (denormalized)
    { name: "customerDisplayName", type: "string", optional: true, sort: true },
    { name: "customerFirstName", type: "string", optional: true, sort: true },
    { name: "customerLastName", type: "string", optional: true, sort: true },
    { name: "customerAddress", type: "string", optional: true },
    { name: "customerCity", type: "string", optional: true, facet: true },
    { name: "serviceName", type: "string", optional: true, facet: true, sort: true },
    // Status (sortable so the All Visits list can group rows by status — RUT-2641)
    { name: "status", type: "string", facet: true, sort: true },
    { name: "priority", type: "bool", optional: true, facet: true },
    // Execution timestamps
    { name: "startedAt", type: "int64", optional: true },
    { name: "completedAt", type: "int64", optional: true },
    { name: "skippedAt", type: "int64", optional: true },
    { name: "cancelledAt", type: "int64", optional: true },
    { name: "terminalDate", type: "int64", optional: true, sort: true },
    // Scheduling — planned service date (RUT-2167), powers the "Scheduled"
    // column + date filter on Schedule → All Visits.
    { name: "scheduledServiceDate", type: "int64", optional: true, sort: true },
    // Billing
    { name: "totalAmount", type: "float", optional: true, sort: true },
    { name: "billingMethod", type: "string", optional: true, facet: true },
    { name: "taxRatePercentHundredths", type: "int32", optional: true, facet: true },
    { name: "taxAmount", type: "float", optional: true },
    { name: "taxableSubtotal", type: "float", optional: true },
    { name: "nonTaxableSubtotal", type: "float", optional: true },
    // Flags
    { name: "hasPhotos", type: "bool", optional: true, facet: true },
    { name: "hasNotes", type: "bool", optional: true, facet: true },
    { name: "hasUnreviewedPhotos", type: "bool", optional: true, facet: true },
    { name: "unreviewedPhotoCount", type: "int32", optional: true, facet: true },
    { name: "isFollowupVisit", type: "bool", optional: true, facet: true },
    // Lets Today's Sales tile links leave assessments out (RUT-4440).
    { name: "visitType", type: "string", optional: true },
    { name: "notifyAdminOnCompletion", type: "bool", optional: true, facet: true },
    // Dispatch
    { name: "dispatchJobId", type: "string", optional: true, facet: true },
    // Review
    { name: "reviewRequired", type: "bool", optional: true, facet: true },
    { name: "reviewAction", type: "string", optional: true, facet: true },
    { name: "reviewReason", type: "string", optional: true },
    // Time tracking
    { name: "totalServiceTime", type: "float", optional: true, sort: true },
    { name: "budgetedHours", type: "float", optional: true, sort: true },
    // Service options
    { name: "serviceOptionsSummary", type: "string", optional: true },
    // Disposal attribution
    { name: "attributedDisposalTime", type: "float", optional: true },
    { name: "attributedDisposalAmount", type: "float", optional: true },
    // Payment
    { name: "paymentStatus", type: "string", optional: true, facet: true },
    { name: "paymentFacet", type: "string", optional: true, facet: true },
    // Lifecycle
    { name: "createdAt", type: "int64", sort: true },
    { name: "updatedAt", type: "int64", optional: true },
    { name: "deletedAt", type: "int64", optional: true }
  ],
  default_sorting_field: "createdAt"
};
function buildCrewSortKey(crewName) {
  return crewName.trim().toLowerCase().replace(/\d+/g, (digits) => digits.padStart(10, "0"));
}
function visitToTypesenseDocument(visit, context = {}) {
  const removedMemberIds = context.removedMemberIds ?? /* @__PURE__ */ new Set();
  const toTimestamp = (isoDate) => {
    return isoDate ? Math.floor(new Date(isoDate).getTime() / 1e3) : void 0;
  };
  const dateStringToUtcSeconds = (dateStr) => {
    const [year, month, day] = dateStr.split("-").map(Number);
    return Date.UTC(year, month - 1, day) / 1e3;
  };
  const extractCity2 = extractCity;
  const revenueSplit = computeVisitRevenueSplit(visit);
  return {
    // Core Identity
    id: visit.id,
    orgId: visit.orgId,
    customerId: visit.customerId,
    serviceTemplateId: visit.serviceTemplateId,
    subscriptionId: visit.subscriptionId,
    crewId: visit.crewId,
    crewSortKey: context.crewName ? buildCrewSortKey(context.crewName) : void 0,
    rank: visit.rank || void 0,
    crewMemberNames: (() => {
      const names = (visit.crewMemberTimes ?? []).filter((m) => !(m.memberId && removedMemberIds.has(m.memberId))).map((m) => m.memberName?.trim()).filter((n) => !!n);
      const unique = Array.from(new Set(names));
      return unique.length ? unique : void 0;
    })(),
    // Display
    customerDisplayName: visit.customerDisplayName,
    customerFirstName: visit.customerFirstName,
    customerLastName: visit.customerLastName,
    customerAddress: visit.customerAddress,
    customerCity: extractCity2(visit.customerAddress),
    serviceName: visit.serviceName,
    // Status
    status: visit.status,
    // Coerce to boolean at the index boundary: priority is a boolean urgent-flag,
    // but historical records may hold a stray string ('urgent'/'high') that Typesense's
    // bool schema would reject. Normalizing here heals those records on reindex.
    priority: typeof visit.priority === "boolean" ? visit.priority : visit.priority === "urgent" || visit.priority === "high",
    // Execution timestamps
    startedAt: toTimestamp(visit.startedAt),
    completedAt: toTimestamp(visit.completedAt),
    skippedAt: toTimestamp(visit.skippedAt),
    cancelledAt: toTimestamp(visit.cancelledAt),
    terminalDate: toTimestamp(visit.completedAt) ?? toTimestamp(visit.skippedAt) ?? toTimestamp(visit.cancelledAt) ?? toTimestamp(visit.discardedAt),
    // Scheduling
    scheduledServiceDate: dateStringToUtcSeconds(getVisitDisplayDate(visit)),
    // Billing
    totalAmount: visit.totalAmount,
    billingMethod: visit.billingMethod,
    taxRatePercentHundredths: taxRatePercentToHundredths(visitTaxRatePercent(visit)),
    // visit.taxAmount only — the same value the tax report's city rows add up.
    taxAmount: visit.taxAmount ?? 0,
    taxableSubtotal: revenueSplit.taxableSubtotal,
    nonTaxableSubtotal: revenueSplit.nonTaxableSubtotal,
    // Flags
    // All three photo flags derive from the photos themselves whenever the array
    // is on the record, falling back to the stored flag only for projections
    // that strip it. `hasPhotos` used to trust the stored flag while the other
    // two were computed, so a visit whose stored flag had gone stale counted
    // toward the work-queue badge but was filtered out of the photo wall — a
    // badge advertising photos the page then couldn't show.
    //
    // `hasPhotos` keeps its original meaning (the visit has photos of any kind,
    // which is what the All Visits indicator and filter show). The two review
    // fields count only photos the office can actually act on — see
    // `isReviewablePhoto`.
    hasPhotos: visit.photos ? visit.photos.length > 0 : visit.hasPhotos,
    hasNotes: visit.hasNotes,
    hasUnreviewedPhotos: visit.photos ? computeHasUnreviewedPhotos(visit.photos) : visit.hasUnreviewedPhotos,
    unreviewedPhotoCount: visit.photos ? countUnreviewedPhotos(visit.photos) : void 0,
    isFollowupVisit: isFollowUpVisit(visit),
    visitType: visit.visitType || void 0,
    notifyAdminOnCompletion: visit.notifyAdminOnCompletion,
    // Dispatch
    dispatchJobId: visit.dispatchJobId,
    // Review
    reviewRequired: visit.reviewMetadata?.reviewRequired,
    reviewAction: visit.reviewMetadata?.reviewAction,
    reviewReason: visit.reviewMetadata?.reviewReason,
    // Time tracking
    totalServiceTime: visit.totalServiceTime,
    budgetedHours: visit.budgetedHours,
    // Service options summary
    serviceOptionsSummary: (() => {
      const options = visit.actualServiceOptions || visit.serviceOptionUsage;
      if (!options?.length) return void 0;
      const summary = options.filter(
        (o) => (o.quantity ?? 0) > 0 || (o.timeUsed ?? 0) > 0 || o.selectedChoices?.some((c) => (c.quantity ?? 0) > 0)
      ).map((o) => {
        const billable = o.billable !== false;
        const selectedChoices = o.selectedChoices?.length ? o.selectedChoices.map((c) => ({
          name: c.name,
          quantity: c.quantity,
          amount: billable ? (c.rate ?? 0) * (c.quantity ?? 1) : 0
        })) : void 0;
        const choicesAmount = selectedChoices?.reduce(
          (sum, c) => sum + (c.amount ?? 0),
          0
        ) ?? 0;
        const baseAmount = billable ? (o.rate ?? 0) * (o.quantity ?? 1) : 0;
        const amount = baseAmount + choicesAmount;
        return {
          name: o.name,
          amount,
          quantity: o.quantity,
          timeUsed: o.timeUsed,
          selectedChoices,
          invoiceDisplay: o.invoiceDisplay,
          zeroValueDisplay: o.zeroValueDisplay
        };
      }).filter((o) => {
        if (o.invoiceDisplay === false) return false;
        if (o.amount === 0 && o.zeroValueDisplay === "hide") return false;
        return true;
      }).map(({ invoiceDisplay, zeroValueDisplay, ...rest }) => rest);
      return summary.length ? JSON.stringify(summary) : void 0;
    })(),
    // Disposal attribution
    attributedDisposalTime: visit.attributedDisposalTime,
    attributedDisposalAmount: visit.attributedDisposalAmount,
    // Payment
    paymentStatus: visit.paymentStatus,
    paymentFacet: resolveVisitPaymentFacet(visit.status, visit.totalAmount, visit.paymentStatus) ?? void 0,
    // Lifecycle
    createdAt: Math.floor(new Date(visit.createdAt).getTime() / 1e3),
    updatedAt: toTimestamp(visit.updatedAt),
    deletedAt: toTimestamp(visit.deletedAt)
  };
}
function getTypesenseCollectionName(baseName, environment) {
  const env = environment || process.env.ENVIRONMENT || process.env.NODE_ENV || "dev";
  return `${env}_${baseName}`;
}

// src/helpers/paymentMethodHealth.ts
var HEALTH_BY_STATUS = {
  manual: { color: "neutral", label: "Manual payment" },
  failed: { color: "yellow", label: "Payment failed" },
  missing: { color: "red", label: "No payment method" },
  expired: { color: "red", label: "Card expired" },
  expiring: { color: "orange", label: "Card expiring soon" },
  healthy: { color: "green", label: "Payment method healthy" }
};
function toHealth(status) {
  return { status, ...HEALTH_BY_STATUS[status] };
}
function derivePaymentMethodHealthFromFlags(flags) {
  if (flags.hasPaymentMethod !== true) return toHealth("missing");
  if (flags.recentPaymentFailure === true) return toHealth("failed");
  if (flags.hasExpiredCard === true) return toHealth("expired");
  if (flags.hasExpiringCard === true) return toHealth("expiring");
  return toHealth("healthy");
}
var DEFAULT_EXPIRING_MONTHS = 1;
function getCardExpiryState(card, options = {}) {
  return cardExpiryState(
    card,
    options.now ?? /* @__PURE__ */ new Date(),
    options.expiringWithinMonths ?? DEFAULT_EXPIRING_MONTHS
  );
}
function cardExpiryState(card, now, expiringWithinMonths) {
  if (card.type !== "card") return null;
  if (card.expiryMonth == null || card.expiryYear == null) return null;
  const fullYear = card.expiryYear < 100 ? 2e3 + card.expiryYear : card.expiryYear;
  const expiryTotalMonths = fullYear * 12 + card.expiryMonth;
  const currentTotalMonths = now.getFullYear() * 12 + (now.getMonth() + 1);
  if (expiryTotalMonths < currentTotalMonths) return "expired";
  if (expiryTotalMonths - currentTotalMonths <= expiringWithinMonths) return "expiring";
  return "valid";
}
function paymentMethodHealthCardFromStored(method) {
  const monthRaw = method.expiryMonth ?? method.expMonth;
  const yearRaw = method.expiryYear ?? method.expYear;
  const expiryMonth = monthRaw == null || monthRaw === "" ? void 0 : Number(monthRaw);
  const expiryYear = yearRaw == null || yearRaw === "" ? void 0 : Number(yearRaw);
  return {
    type: method.type,
    expiryMonth: Number.isFinite(expiryMonth) ? expiryMonth : void 0,
    expiryYear: Number.isFinite(expiryYear) ? expiryYear : void 0
  };
}
function chargeMethodUsability(methods, options = {}) {
  if (methods.length === 0) return "none";
  let sawExpiredCard = false;
  for (const method of methods) {
    const state = getCardExpiryState(method, options);
    if (state === "expired") {
      sawExpiredCard = true;
      continue;
    }
    return "usable";
  }
  return sawExpiredCard ? "expired" : "usable";
}
function derivePaymentMethodHealth(customer, paymentMethods, options = {}) {
  const now = options.now ?? /* @__PURE__ */ new Date();
  const expiringWithinMonths = options.expiringWithinMonths ?? DEFAULT_EXPIRING_MONTHS;
  const billsManually = customer.billsManually === true;
  if (billsManually) {
    if (customer.hasRecentPaymentFailure === true) {
      return toHealth("failed");
    }
    return toHealth("manual");
  }
  if (paymentMethods.length === 0) {
    return toHealth("missing");
  }
  if (customer.hasRecentPaymentFailure === true) {
    return toHealth("failed");
  }
  let hasExpired = false;
  let hasExpiring = false;
  for (const pm of paymentMethods) {
    const state = cardExpiryState(pm, now, expiringWithinMonths);
    if (state === "expired") hasExpired = true;
    else if (state === "expiring") hasExpiring = true;
  }
  if (hasExpired) return toHealth("expired");
  if (hasExpiring) return toHealth("expiring");
  return toHealth("healthy");
}

// src/helpers/paymentIssuesFilter.ts
var PAYMENT_ISSUE_TYPE_VALUES = [
  "issues",
  "failed",
  "missing",
  "expired",
  "expiring"
];
var PAYMENT_ISSUE_STATUS_VALUES = [
  "active" /* ACTIVE */,
  "inactive" /* INACTIVE */
];
var DEFAULT_PAYMENT_ISSUES_FILTER = {
  paymentStatus: "issues",
  hasBalance: false,
  statuses: ["active" /* ACTIVE */]
};
function paymentIssuesTileCount(searchFound) {
  return searchFound;
}
function buildPaymentIssuesSearchParams(filter) {
  const params = {
    paymentStatus: filter.paymentStatus
  };
  if (filter.statuses.length === 1) {
    params.status = filter.statuses[0];
  }
  if (filter.hasBalance) {
    params.balanceFilter = "has_balance";
  }
  return params;
}

// src/helpers/workMetricsFilter.ts
var WORK_METRIC_KEYS = ["completed", "inProgress", "remaining"];
function isWorkMetricKey(value) {
  return typeof value === "string" && WORK_METRIC_KEYS.includes(value);
}
function buildWorkMetricFilter(metric, todayLocalDate) {
  return metric === "completed" ? { metric, date: todayLocalDate } : { metric };
}
var DEFAULT_WORK_LIST_SCOPE = "today";
function resolveWorkListScope(arrivedFromMetric) {
  return isWorkMetricKey(arrivedFromMetric) ? arrivedFromMetric : DEFAULT_WORK_LIST_SCOPE;
}
function isCountedByWorkMetric(visit, metric) {
  if (visit.visitType === "assessment" /* ASSESSMENT */) return false;
  if (metric === "remaining") {
    return visit.status === "not-started" /* NOT_STARTED */;
  }
  if (metric === "inProgress") {
    return visit.status === "in-progress" /* IN_PROGRESS */ || visit.status === "paused" /* PAUSED */;
  }
  return !NON_SALES_VISIT_STATUSES.has(visit.status);
}

// src/helpers/chargeFailureGuidance.ts
var NO_PAYMENT_METHOD_ERROR = "No payment method on file";
var PAYMENT_NOT_CONFIGURED_ERROR = "Payment processing not configured for this organization";
function isMissingPaymentMethodMessage(message) {
  const error = message.toLowerCase();
  return message === NO_PAYMENT_METHOD_ERROR || error.includes("no payment method on file") || error.includes("no card on file");
}
var PRE_CHARGE_REFUSAL_CODES = /* @__PURE__ */ new Set([
  "NO_OUTSTANDING_BALANCE"
]);
function reasonFromPreChargeMessage(message) {
  const trimmed = message?.trim();
  if (trimmed === NO_PAYMENT_METHOD_ERROR) return "PAYMENT_METHOD_REQUIRED";
  if (trimmed === PAYMENT_NOT_CONFIGURED_ERROR) return "PAYMENT_PROCESSING_NOT_CONFIGURED";
  return void 0;
}
function rejectedBeforeCharging(status) {
  if (status === void 0) return false;
  if (status === 408 || status === 429) return false;
  return status >= 400 && status < 500;
}
var UNINFORMATIVE_PROCESSOR_MESSAGES = new Set(
  [
    "Payment failed",
    "Payment was declined",
    "Payment processing failed",
    "Payment service temporarily unavailable",
    "Could not process payment",
    "declined",
    NO_PAYMENT_METHOD_ERROR,
    PAYMENT_NOT_CONFIGURED_ERROR
  ].map((message) => message.toLowerCase())
);
function informativeProcessorDetail(message) {
  const trimmed = message?.trim();
  if (!trimmed) return void 0;
  if (UNINFORMATIVE_PROCESSOR_MESSAGES.has(trimmed.toLowerCase())) return void 0;
  return trimmed;
}
var UNKNOWN_OUTCOME = {
  outcome: "unknown",
  action: "refresh-balance"
};
function describeChargeFailure(input = {}) {
  const processorDetail = informativeProcessorDetail(input.processorMessage);
  const reason = input.reason ?? (input.failureKind ? void 0 : reasonFromPreChargeMessage(input.processorMessage));
  const status = input.status ?? (input.code && PRE_CHARGE_REFUSAL_CODES.has(input.code) ? 422 : void 0);
  if (reason === "PAYMENT_METHOD_REQUIRED") {
    return {
      headline: "No payment method on file",
      chargedLine: "The customer was not charged \u2014 there was no card to charge.",
      nextStep: "Add a card under Payment Methods, or ask the customer to add one from their customer portal. If they'd rather not put a card on file, record a check or cash payment instead.",
      outcome: "not-charged",
      action: null
    };
  }
  if (reason === "PAYMENT_PROCESSING_NOT_CONFIGURED") {
    return {
      headline: "This business isn't connected to a payment processor yet",
      chargedLine: "The customer was not charged \u2014 the charge was never sent.",
      nextStep: "Finish payment setup under Settings, then run the card again. Until then, record payments as check or cash.",
      outcome: "not-charged",
      action: null
    };
  }
  if (reason === "PAYMENT_IDEMPOTENCY_MISMATCH") {
    return {
      headline: "This charge conflicted with an earlier attempt",
      chargedLine: "We don't know whether the customer was charged \u2014 the processor rejected a repeat that did not match the first request.",
      nextStep: "Refresh the balance. If it hasn't gone down, don't run the same charge again by hand \u2014 this is not a card decline.",
      ...UNKNOWN_OUTCOME
    };
  }
  if (reason === "PAYMENT_OUTCOME_UNKNOWN") {
    return {
      headline: "The charge came back without a result",
      chargedLine: "We don't know whether the customer was charged \u2014 the processor didn't return a transaction for this attempt.",
      nextStep: "Refresh the balance. If it hasn't gone down, run the card again; if it has, the charge went through and there is nothing more to do.",
      ...UNKNOWN_OUTCOME
    };
  }
  if (reason === "PAYMENT_PROVIDER_UNAVAILABLE" || input.failureKind === "transient") {
    return {
      headline: "Couldn't reach the payment processor",
      chargedLine: "We don't know whether the customer was charged \u2014 the processor never confirmed either way.",
      nextStep: "Refresh the balance in a minute. If it hasn't gone down, run the card again \u2014 running it right now risks charging the customer twice.",
      ...UNKNOWN_OUTCOME
    };
  }
  if (input.failureKind === "invalid_state") {
    return {
      headline: "The charge was never sent",
      chargedLine: "The customer was not charged.",
      nextStep: "Check that the customer has a valid card on file and that payment setup is finished under Settings, then run the card again.",
      outcome: "not-charged",
      action: null,
      processorDetail
    };
  }
  if (reason === "PAYMENT_DECLINED" || input.failureKind === "permanent") {
    const declinedForExpiry = input.cardExpiryState === "expired" || matchJustifiDeclineReason(input.processorMessage) === "expired_card";
    if (declinedForExpiry) {
      return {
        headline: "The card on file has expired",
        chargedLine: "The customer was not charged.",
        nextStep: "Running it again won't help. Under Payment Methods, add a current card and remove the expired one \u2014 or ask the customer to do it from their customer portal. You can record a check or cash payment in the meantime.",
        outcome: "not-charged",
        action: null,
        processorDetail
      };
    }
    return {
      headline: "The card was declined",
      chargedLine: "The customer was not charged.",
      nextStep: "The bank turned this charge down, so running the same card again will be declined again. Contact the customer to sort out their card, or record a check or cash payment instead.",
      outcome: "not-charged",
      action: null,
      processorDetail
    };
  }
  if (rejectedBeforeCharging(status)) {
    return {
      headline: processorDetail ?? "The charge wasn't sent",
      chargedLine: "The customer was not charged \u2014 the charge was never attempted.",
      nextStep: "Sort out what's blocking it above, then run the card again. If nothing here explains it, contact support.",
      outcome: "not-charged",
      action: null
    };
  }
  return {
    headline: "The charge didn't go through",
    chargedLine: "We don't know whether the customer was charged \u2014 the payment processor didn't tell us either way.",
    nextStep: "Refresh the balance before doing anything else. If it hasn't gone down, run the card again; if this keeps happening, contact support.",
    ...UNKNOWN_OUTCOME
  };
}
function summarizeChargeFailures(inputs) {
  const groups = [];
  let hasUnknownOutcome = false;
  for (const input of inputs) {
    const guidance = describeChargeFailure(input);
    if (guidance.outcome === "unknown") hasUnknownOutcome = true;
    const existing = groups.find((group) => group.headline === guidance.headline);
    if (existing) {
      existing.count += 1;
    } else {
      groups.push({
        headline: guidance.headline,
        nextStep: guidance.nextStep,
        count: 1
      });
    }
  }
  groups.sort((a, b) => b.count - a.count);
  return { total: inputs.length, groups, hasUnknownOutcome };
}

// src/helpers/unbilledProcessingErrorVisits.ts
function isUnbilledProcessingErrorVisit(visit) {
  if (visit.paymentStatus !== PAYMENT_STATUS.PROCESSING_ERROR) return false;
  if (visit.transactionId) return false;
  return typeof visit.totalAmount === "number" && visit.totalAmount > 0;
}
function unbilledProcessingErrorAmount(visits) {
  return visits.filter(isUnbilledProcessingErrorVisit).reduce((sum, visit) => sum + (visit.totalAmount ?? 0), 0);
}

// src/helpers/offlineFallback.ts
function shouldShowLoadErrorWall({
  isError,
  isLoading,
  cachedItemCount
}) {
  return isError && !isLoading && cachedItemCount === 0;
}

// src/api/errors.ts
var API_ERROR_CODES = {
  // Generic errors
  VALIDATION_ERROR: "VALIDATION_ERROR",
  NOT_FOUND: "NOT_FOUND",
  ALREADY_EXISTS: "ALREADY_EXISTS",
  CONFLICT: "CONFLICT",
  UNAUTHORIZED: "UNAUTHORIZED",
  FORBIDDEN: "FORBIDDEN",
  // Time entry / clock state errors
  INVALID_STATE_TRANSITION: "INVALID_STATE_TRANSITION",
  // Visit errors
  VISIT_NOT_FOUND: "VISIT_NOT_FOUND",
  VISIT_ALREADY_COMPLETED: "VISIT_ALREADY_COMPLETED",
  VISIT_ALREADY_STARTED: "VISIT_ALREADY_STARTED",
  VISIT_PHOTO_REQUIRED: "VISIT_PHOTO_REQUIRED",
  /** Starting a visit while a member is already on a different IN_PROGRESS visit. */
  CREW_MEMBER_ALREADY_ON_VISIT: "CREW_MEMBER_ALREADY_ON_VISIT",
  /** 403: caller is not on the visit's crew (RUT-4123). Permanent — retrying cannot succeed. */
  NOT_ON_VISIT_CREW: "NOT_ON_VISIT_CREW",
  /** 403: skip / undo skip / cancel / discard needs a crew leader or the office (RUT-4123). Permanent. */
  VISIT_ACTION_LEADER_ONLY: "VISIT_ACTION_LEADER_ONLY",
  /** 403: a location or geofence write named a member other than the caller (RUT-4123). Permanent. */
  MEMBER_MISMATCH: "MEMBER_MISMATCH",
  // Subscription errors
  SUBSCRIPTION_NOT_FOUND: "SUBSCRIPTION_NOT_FOUND",
  SUBSCRIPTION_INACTIVE: "SUBSCRIPTION_INACTIVE",
  SUBSCRIPTION_NOT_REVIEWED: "SUBSCRIPTION_NOT_REVIEWED",
  OUTSTANDING_CUSTOMER_QUESTIONS: "OUTSTANDING_CUSTOMER_QUESTIONS",
  // Customer errors
  CUSTOMER_NOT_FOUND: "CUSTOMER_NOT_FOUND",
  ADDRESS_EXISTS: "ADDRESS_EXISTS",
  ADDRESS_REQUIRED: "ADDRESS_REQUIRED",
  /** Operator barred this address from the portal — no registering it, no signing in. */
  ADDRESS_BLOCKED: "ADDRESS_BLOCKED",
  /** 403: customer is out of the service area and can't start a service themselves (RUT-4365). */
  OUT_OF_SERVICE_AREA: "OUT_OF_SERVICE_AREA",
  /** Office stamped this one service not available at the customer's address (RUT-3707). */
  SERVICE_UNAVAILABLE_AT_ADDRESS: "SERVICE_UNAVAILABLE_AT_ADDRESS",
  /** Address geocoded but has no house number (street-level only). */
  ADDRESS_MISSING_STREET_NUMBER: "ADDRESS_MISSING_STREET_NUMBER",
  // Crew errors
  CREW_NOT_FOUND: "CREW_NOT_FOUND",
  MEMBER_NOT_FOUND: "MEMBER_NOT_FOUND",
  /** Member has an open work session on a visit for this crew — client should ask whether to end it (RUT-2874). */
  MEMBER_ON_ACTIVE_VISIT: "MEMBER_ON_ACTIVE_VISIT",
  CREW_HAS_ASSIGNMENTS: "CREW_HAS_ASSIGNMENTS",
  // Auth errors
  INVALID_CREDENTIALS: "INVALID_CREDENTIALS",
  INVALID_OTP: "INVALID_OTP",
  RATE_LIMITED: "RATE_LIMITED",
  INVALID_REFRESH_TOKEN: "INVALID_REFRESH_TOKEN",
  USER_NOT_CONFIRMED: "USER_NOT_CONFIRMED",
  /** A sign-up code was entered for an email that is already verified, and signing in was not possible. */
  USER_ALREADY_CONFIRMED: "USER_ALREADY_CONFIRMED",
  USER_NOT_FOUND: "USER_NOT_FOUND",
  EMAIL_VERIFICATION_REQUIRED: "EMAIL_VERIFICATION_REQUIRED",
  CODE_MISMATCH: "CODE_MISMATCH",
  CODE_EXPIRED: "CODE_EXPIRED",
  WEAK_PASSWORD: "WEAK_PASSWORD",
  ORG_SWITCH_NOT_AUTHORIZED: "ORG_SWITCH_NOT_AUTHORIZED",
  /** Field crew (non-owner/admin) must use the Crew mobile app, not the webapp. */
  USE_CREW_APP: "USE_CREW_APP",
  // Identity errors (organizations / roles / users)
  ORGANIZATION_NOT_FOUND: "ORGANIZATION_NOT_FOUND",
  ROLE_NOT_FOUND: "ROLE_NOT_FOUND",
  ROLE_IN_USE: "ROLE_IN_USE",
  ROLE_IMMUTABLE: "ROLE_IMMUTABLE",
  SUBCONTRACTOR_COMPANY_NOT_FOUND: "SUBCONTRACTOR_COMPANY_NOT_FOUND",
  INVITATION_INVALID: "INVITATION_INVALID",
  SLUG_TAKEN: "SLUG_TAKEN",
  SERVICE_AREA_NOT_DEFINED: "SERVICE_AREA_NOT_DEFINED",
  // Data import errors
  IMPORT_FILE_TOO_LARGE: "IMPORT_FILE_TOO_LARGE",
  // Billing errors
  NO_OUTSTANDING_BALANCE: "NO_OUTSTANDING_BALANCE",
  PAYMENT_FAILED: "PAYMENT_FAILED",
  INVALID_WEBHOOK_SIGNATURE: "INVALID_WEBHOOK_SIGNATURE",
  // Credit adjustment with selected visits to pay off (RUT-1975)
  CREDIT_INSUFFICIENT_FOR_SELECTED_VISITS: "CREDIT_INSUFFICIENT_FOR_SELECTED_VISITS",
  VISIT_NOT_ELIGIBLE_FOR_CREDIT: "VISIT_NOT_ELIGIBLE_FOR_CREDIT",
  // In-app feedback (RUT-2602 / RUT-3900)
  FEEDBACK_NOT_CONFIGURED: "FEEDBACK_NOT_CONFIGURED",
  FEEDBACK_SUBMIT_FAILED: "FEEDBACK_SUBMIT_FAILED",
  FEEDBACK_NOT_FOUND: "FEEDBACK_NOT_FOUND"
};
function isStaleStateErrorCode(code) {
  if (!code) return false;
  const staleStateCodes = [
    API_ERROR_CODES.INVALID_STATE_TRANSITION,
    API_ERROR_CODES.VISIT_ALREADY_COMPLETED,
    API_ERROR_CODES.VISIT_ALREADY_STARTED,
    API_ERROR_CODES.NOT_FOUND,
    API_ERROR_CODES.ALREADY_EXISTS
  ];
  return staleStateCodes.includes(code);
}
var TIME_ENTRY_OFFLINE_ACTION_TYPES = [
  "clock-in",
  "clock-out",
  "break-start",
  "break-end"
];
function isTimeEntryOfflineActionType(actionType) {
  return TIME_ENTRY_OFFLINE_ACTION_TYPES.includes(actionType);
}
var VISIT_START_STARTED_AT_MAX_AGE_MS = 30 * 60 * 1e3;
var STARTED_AT_TOO_OLD_MESSAGE = "startedat cannot be more than 30 minutes in the past";
var ALREADY_ON_ACTIVE_VISIT_MESSAGE = "already on active visit";
function normalizedErrorMessage(params) {
  return (params.errorMessage ?? "").toLowerCase();
}
function isStaleVisitStartStartedAt(params) {
  if (params.actionType !== "visit-start") return false;
  if (normalizedErrorMessage(params).includes(STARTED_AT_TOO_OLD_MESSAGE)) return true;
  if (!params.startedAt) return false;
  const startedMs = Date.parse(params.startedAt);
  if (!Number.isFinite(startedMs)) return false;
  const nowMs = params.nowMs ?? Date.now();
  return nowMs - startedMs > VISIT_START_STARTED_AT_MAX_AGE_MS;
}
function isAlreadyOnActiveVisitConflict(params) {
  if (params.errorCode === API_ERROR_CODES.CREW_MEMBER_ALREADY_ON_VISIT || params.errorCode === API_ERROR_CODES.MEMBER_ON_ACTIVE_VISIT) {
    return true;
  }
  return normalizedErrorMessage(params).includes(ALREADY_ON_ACTIVE_VISIT_MESSAGE);
}
function conflictingMembersFromDetails(details) {
  if (!details || typeof details !== "object") return [];
  const members = details.conflictingMembers;
  if (!Array.isArray(members)) return [];
  const out = [];
  for (const member of members) {
    if (!member || typeof member !== "object") continue;
    const row = member;
    const parsed = {};
    if (typeof row.memberId === "string" && row.memberId.length > 0) parsed.memberId = row.memberId;
    if (typeof row.memberName === "string" && row.memberName.length > 0) parsed.memberName = row.memberName;
    if (typeof row.activeVisitId === "string" && row.activeVisitId.length > 0) parsed.activeVisitId = row.activeVisitId;
    if (typeof row.activeVisitCustomerName === "string" && row.activeVisitCustomerName.length > 0) {
      parsed.activeVisitCustomerName = row.activeVisitCustomerName;
    }
    if (parsed.memberId || parsed.memberName || parsed.activeVisitId || parsed.activeVisitCustomerName) {
      out.push(parsed);
    }
  }
  return out;
}
function conflictingActiveVisitIds(details) {
  return conflictingMembersFromDetails(details).map((member) => member.activeVisitId).filter((id) => Boolean(id));
}
function isSameVisitAlreadyActiveConflict(params) {
  if (params.actionType !== "visit-start") return false;
  if (!isAlreadyOnActiveVisitConflict(params)) return false;
  const visitId = params.visitId;
  if (!visitId) return false;
  return conflictingActiveVisitIds(params.details).includes(visitId);
}
function visitStartActionSatisfiedByStatus(actionType, serverStatus) {
  if (actionType !== "visit-start") return false;
  const status = serverStatus.toLowerCase();
  return status === "in-progress" /* IN_PROGRESS */ || status === "completed" /* COMPLETED */;
}
function shouldDiscardSatisfiedVisitStartAction(params) {
  if (params.actionType !== "visit-start") return false;
  if (params.serverStatus && visitStartActionSatisfiedByStatus(params.actionType, params.serverStatus)) {
    return true;
  }
  return isSameVisitAlreadyActiveConflict(params);
}
function visitCompleteActionSatisfiedByStatus(actionType, serverStatus) {
  if (actionType !== "visit-complete") return false;
  return isTerminalVisitStatus(serverStatus.toLowerCase());
}
function isVisitAlreadyCompletedRefusal(params) {
  if (params.errorCode === API_ERROR_CODES.VISIT_ALREADY_COMPLETED) return true;
  return normalizedErrorMessage(params).includes("already completed");
}
function shouldDiscardSatisfiedVisitCompleteAction(params) {
  if (params.actionType !== "visit-complete") return false;
  if (params.serverStatus && visitCompleteActionSatisfiedByStatus(params.actionType, params.serverStatus)) {
    return true;
  }
  return isVisitAlreadyCompletedRefusal(params);
}
function shouldDiscardResetVisitCompleteAction(params) {
  if (params.actionType !== "visit-complete") return false;
  const status = (params.serverStatus ?? "").toLowerCase();
  if (status !== "not-started" /* NOT_STARTED */) return false;
  if (!params.queuedAt || !params.serverUpdatedAt) return false;
  const queuedMs = Date.parse(params.queuedAt);
  const updatedMs = Date.parse(params.serverUpdatedAt);
  if (!Number.isFinite(queuedMs) || !Number.isFinite(updatedMs)) return false;
  return updatedMs > queuedMs;
}
function isHardVisitCompleteRefusal(params) {
  if (params.actionType !== "visit-complete") return false;
  if (params.errorCode === API_ERROR_CODES.VISIT_PHOTO_REQUIRED) return true;
  const message = normalizedErrorMessage(params);
  return message.includes("photo is required") || message.includes("visit_photo_required");
}
function canonicalizeServiceOptionUsage(usage) {
  const items = (usage ?? []).map((option) => ({
    optionId: option.optionId,
    quantity: option.quantity ?? 0,
    timeUsed: option.timeUsed ?? 0,
    selectedChoices: (option.selectedChoices ?? []).map((choice) => ({
      choiceId: choice.choiceId,
      quantity: choice.quantity ?? 0
    })).filter((choice) => choice.quantity !== 0).sort((a, b) => a.choiceId.localeCompare(b.choiceId))
  })).filter((option) => option.quantity !== 0 || option.timeUsed !== 0 || option.selectedChoices.length > 0).sort((a, b) => a.optionId.localeCompare(b.optionId));
  return JSON.stringify(items);
}
function visitServiceOptionsActionSatisfiedByUsage(actionType, pending, server) {
  if (actionType !== "visit-service-options") return false;
  if (server == null) return false;
  return canonicalizeServiceOptionUsage(pending) === canonicalizeServiceOptionUsage(server);
}
function shouldDiscardSatisfiedVisitServiceOptionsAction(params) {
  if (params.actionType !== "visit-service-options") return false;
  return visitServiceOptionsActionSatisfiedByUsage(
    params.actionType,
    params.pendingServiceOptions,
    params.serverServiceOptions
  );
}
function timeEntryActionSatisfiedByStatus(actionType, serverStatus) {
  if (!isTimeEntryOfflineActionType(actionType)) return false;
  const status = serverStatus.toLowerCase();
  switch (actionType) {
    case "clock-out":
      return status === "clocked-out" /* CLOCKED_OUT */;
    case "clock-in":
      return status === "clocked-in" /* CLOCKED_IN */ || status === "on-break" /* ON_BREAK */;
    case "break-start":
      return status === "on-break" /* ON_BREAK */;
    case "break-end":
      return status === "clocked-in" /* CLOCKED_IN */ || status === "clocked-out" /* CLOCKED_OUT */;
    default:
      return false;
  }
}
var IDEMPOTENT_TIME_ENTRY_REFUSALS = {
  "clock-out": ["must be clocked in to clock out"],
  "clock-in": ["you are already clocked in", "must end your break before clocking in"],
  "break-start": ["you are already on break"],
  "break-end": ["you are not currently on break", "must be clocked in and on break"]
};
function isIdempotentTimeEntryRefusal(params) {
  if (!isTimeEntryOfflineActionType(params.actionType)) return false;
  const message = normalizedErrorMessage(params);
  if (!message) return false;
  return (IDEMPOTENT_TIME_ENTRY_REFUSALS[params.actionType] ?? []).some(
    (fragment) => message.includes(fragment)
  );
}
function shouldDiscardSatisfiedTimeEntryAction(params) {
  if (!isTimeEntryOfflineActionType(params.actionType)) return false;
  if (params.serverStatus && timeEntryActionSatisfiedByStatus(params.actionType, params.serverStatus)) {
    return true;
  }
  return isIdempotentTimeEntryRefusal(params);
}
function shouldDiscardStaleOfflineAction(params) {
  if (isTimeEntryOfflineActionType(params.actionType)) {
    return shouldDiscardSatisfiedTimeEntryAction(params);
  }
  if (shouldDiscardSatisfiedVisitStartAction(params)) return true;
  if (shouldDiscardSatisfiedVisitCompleteAction(params)) return true;
  if (shouldDiscardResetVisitCompleteAction(params)) return true;
  if (shouldDiscardSatisfiedVisitServiceOptionsAction(params)) return true;
  if (params.isApiError) {
    return isStaleStateErrorCode(params.errorCode);
  }
  const message = normalizedErrorMessage(params);
  if (message.includes("cannot complete assessment")) return false;
  return message.includes("already completed") || message.includes("already in-progress") || message.includes("cannot be") || message.includes("invalid state");
}
function shouldKeepPendingOfflineAction(params) {
  if (isTimeEntryOfflineActionType(params.actionType)) {
    return !shouldDiscardSatisfiedTimeEntryAction(params);
  }
  return false;
}

// src/helpers/offlineActionDependency.ts
var VISIT_SCOPED_OFFLINE_ACTION_TYPES = [
  "visit-start",
  "visit-pause",
  "visit-resume",
  "visit-complete",
  "visit-skip",
  "visit-add-note",
  "visit-service-options",
  "visit-patch-crew-members",
  "visit-move"
];
function isVisitScopedOfflineActionType(actionType) {
  return VISIT_SCOPED_OFFLINE_ACTION_TYPES.includes(actionType);
}
function doesOfflineActionDependOn(later, earlier) {
  const laterVisitId = later.payload?.visitId;
  const earlierVisitId = earlier.payload?.visitId;
  if (laterVisitId && laterVisitId === earlierVisitId && isVisitScopedOfflineActionType(later.type) && isVisitScopedOfflineActionType(earlier.type)) {
    if (earlier.type === "visit-service-options") {
      return false;
    }
    return true;
  }
  const laterMemberId = later.payload?.crewMemberId;
  const earlierMemberId = earlier.payload?.crewMemberId;
  if (laterMemberId && laterMemberId === earlierMemberId && isTimeEntryOfflineActionType(later.type) && isTimeEntryOfflineActionType(earlier.type)) {
    return true;
  }
  return false;
}
function isOfflineActionBlockedByEarlier(later, earlierStillPending) {
  return earlierStillPending.some((earlier) => doesOfflineActionDependOn(later, earlier));
}

// src/helpers/aiUsage.ts
var TOKENS_PER_AI_CREDIT = 1e3;
function integrationTokenKey(id, kind) {
  return `${id}#${kind}`;
}
function aiModelTokenKey(id, model, kind) {
  return `${id}#${model}#${kind}`;
}
function parseAiModelTokenKey(key) {
  const first = key.indexOf("#");
  const last = key.lastIndexOf("#");
  if (first <= 0 || last <= first + 1) return void 0;
  const kind = key.slice(last + 1);
  if (!ALL_AI_TOKEN_KINDS.includes(kind)) return void 0;
  return { vendor: key.slice(0, first), model: key.slice(first + 1, last), kind };
}
function tokensToAiCredits(totalTokens) {
  if (!Number.isFinite(totalTokens) || totalTokens <= 0) return 0;
  return Math.ceil(totalTokens / TOKENS_PER_AI_CREDIT);
}
var AI_INTEGRATION_IDS = [
  "anthropic" /* ANTHROPIC */,
  "xai" /* XAI */
];
var ALL_AI_TOKEN_KINDS = [
  "input",
  "output",
  "cacheRead",
  "cacheCreation"
];
var CREDIT_BILLABLE_TOKEN_KINDS = [
  "input",
  "output",
  "cacheCreation"
];
function sumAiTokenKind(tokens, kind, vendors = AI_INTEGRATION_IDS) {
  if (!tokens) return 0;
  let total = 0;
  for (const vendor of vendors) {
    total += tokens[integrationTokenKey(vendor, kind)] ?? 0;
  }
  return total;
}
function sumAiTokens(tokens, kinds = ALL_AI_TOKEN_KINDS, vendors = AI_INTEGRATION_IDS) {
  let total = 0;
  for (const kind of kinds) total += sumAiTokenKind(tokens, kind, vendors);
  return total;
}

// src/helpers/entityRoutes.ts
var ENTITY_SEGMENTS = {
  CUSTOMER: "customers",
  VISIT: "visits",
  SUBSCRIPTION: "subscriptions",
  SERVICE_TEMPLATE: "service-templates",
  INVOICE: "invoices",
  CREW: "crews",
  CHAT_CONVERSATION: "conversations",
  ORGANIZATION_MEMBER: "members",
  RATE_REQUEST: "rate-requests",
  MESSAGE: "messages"
};
var SEGMENT_TO_ENTITY = Object.fromEntries(
  Object.entries(ENTITY_SEGMENTS).map(([k, v]) => [v, k])
);
function entityPath(type, params) {
  if (type === "SUBSCRIPTION") {
    const { customerId, subscriptionId } = params;
    return `/customers/${customerId}/subscriptions/${subscriptionId}`;
  }
  const segment = ENTITY_SEGMENTS[type];
  const { id } = params;
  return `/${segment}/${id}`;
}
function parseEntityPath(path) {
  const stripped = path.startsWith("/") ? path.slice(1) : path;
  const parts = stripped.split("/");
  if (parts.length === 4 && parts[0] === "customers" && parts[2] === "subscriptions") {
    return {
      type: "SUBSCRIPTION",
      params: { customerId: parts[1], subscriptionId: parts[3] }
    };
  }
  if (parts.length === 2) {
    const entityType = SEGMENT_TO_ENTITY[parts[0]];
    if (entityType) {
      return { type: entityType, params: { id: parts[1] } };
    }
  }
  return null;
}

// src/helpers/shopAdvisor.ts
function shopAdvisorDraftActionLink(input) {
  switch (input.kind) {
    case "review-flag" /* REVIEW_FLAG */:
      if (!input.visitId) {
        throw new Error("review-flag drafts need a visitId to open the flagged visit");
      }
      return entityPath("VISIT", { id: input.visitId });
    case "message" /* MESSAGE */:
      if (input.messageId) return entityPath("MESSAGE", { id: input.messageId });
      if (input.customerId) return entityPath("CUSTOMER", { id: input.customerId });
      throw new Error("message drafts need a customerId or messageId to open the composer");
    case "rate" /* RATE */:
      if (input.rateRequestId) return entityPath("RATE_REQUEST", { id: input.rateRequestId });
      if (input.visitId) return entityPath("VISIT", { id: input.visitId });
      if (input.customerId) return entityPath("CUSTOMER", { id: input.customerId });
      throw new Error("rate drafts need a rateRequestId, visitId, or customerId to open rate chrome");
    case "campaign" /* CAMPAIGN */:
      return "/campaigns";
  }
}

// src/helpers/portalBlock.ts
var DEFAULT_PORTAL_BLOCK_MESSAGE = "We're sorry, but this address is not in our service area.";
var PORTAL_BLOCK_MESSAGE_MAX_LENGTH = 500;
function isPortalBlocked(customer) {
  return customer?.deactivation?.blockPortalAccess === true;
}
function getPortalBlockMessage(customer) {
  const custom = customer?.deactivation?.portalMessage?.trim();
  return custom && custom.length > 0 ? custom : DEFAULT_PORTAL_BLOCK_MESSAGE;
}
function findPortalBlockedAt(candidates) {
  return candidates.find((candidate) => isPortalBlocked(candidate));
}

// src/helpers/unavailableAtAddress.ts
var SERVICE_UNAVAILABLE_AT_ADDRESS_MESSAGE = "This service is not available at this address.";
var UNAVAILABLE_SERVICE_REASON_MAX_LENGTH = 500;
function getUnavailableServiceAtAddress(customer, serviceTemplateId) {
  if (!serviceTemplateId) return void 0;
  const entry = customer?.unavailableServices?.[serviceTemplateId];
  if (!entry || typeof entry.reason !== "string" || !entry.reason.trim()) return void 0;
  return entry;
}
function isServiceUnavailableAtAddress(customer, serviceTemplateId) {
  return getUnavailableServiceAtAddress(customer, serviceTemplateId) !== void 0;
}
function getUnavailableAtAddressReason(customer, serviceTemplateId) {
  const entry = getUnavailableServiceAtAddress(customer, serviceTemplateId);
  if (!entry) return void 0;
  return entry.reason.trim() || SERVICE_UNAVAILABLE_AT_ADDRESS_MESSAGE;
}
function toPortalUnavailableAtAddress(customer, serviceTemplateId) {
  const reason = getUnavailableAtAddressReason(customer, serviceTemplateId);
  return reason ? { reason } : void 0;
}
function parseUnavailableServices(input, existing, stamp) {
  if (input === null) return { value: null };
  if (typeof input !== "object" || Array.isArray(input)) {
    return { error: "unavailableServices must be a map of service template id to a reason" };
  }
  const next = {};
  for (const [templateId, raw] of Object.entries(input)) {
    const id = templateId.trim();
    if (!id) {
      return { error: "Each unavailable service needs a service template id" };
    }
    if (!raw || typeof raw !== "object" || Array.isArray(raw)) {
      return { error: "Each unavailable service needs a reason" };
    }
    const reason = typeof raw.reason === "string" ? raw.reason.trim() : "";
    if (!reason) {
      return { error: "A reason is required to mark a service not available at this address" };
    }
    if (reason.length > UNAVAILABLE_SERVICE_REASON_MAX_LENGTH) {
      return {
        error: `The reason must be ${UNAVAILABLE_SERVICE_REASON_MAX_LENGTH} characters or fewer`
      };
    }
    const previous = existing?.[id];
    if (previous && previous.reason === reason) {
      next[id] = previous;
    } else {
      next[id] = { reason, setAt: stamp.setAt, setBy: stamp.setBy };
    }
  }
  return { value: Object.keys(next).length > 0 ? next : null };
}
function newlyUnavailableTemplateIds(previous, next) {
  if (!next) return [];
  return Object.keys(next).filter((id) => !previous?.[id]);
}

// src/helpers/convertCustomerToContact.ts
var CONVERT_TO_CONTACT_ROLES = [
  "SPOUSE" /* SPOUSE */,
  "MANAGER" /* MANAGER */,
  "TENANT" /* TENANT */,
  "BILLING" /* BILLING */,
  "OTHER" /* OTHER */
];
function isConvertToContactRole(role) {
  return CONVERT_TO_CONTACT_ROLES.includes(role);
}
function canConvertCustomerToContact(source, target) {
  if (source.id === target.id) return { ok: false, reason: "same-customer" };
  if (!customersShareProperty(source, target)) {
    return { ok: false, reason: "different-property" };
  }
  return { ok: true };
}
function customersShareProperty(a, b) {
  if (a.normalizedAddress && b.normalizedAddress) {
    return a.normalizedAddress === b.normalizedAddress;
  }
  const left = a.address?.trim();
  const right = b.address?.trim();
  return Boolean(left && right && left === right);
}

// src/helpers/assistantMarkdown.ts
var INLINE_SOURCE = '\\[([^\\]]+)\\]\\(([^)\\s]+)(?:\\s+"([^"]*)")?\\)|\\*\\*(.+?)\\*\\*|__(.+?)__|\\*(.+?)\\*|_(.+?)_';
function parseAssistantInlineSegments(input) {
  const segments = [];
  const re = new RegExp(INLINE_SOURCE, "g");
  let last = 0;
  let m;
  while (m = re.exec(input)) {
    if (m.index > last) {
      segments.push({ text: input.slice(last, m.index), bold: false, italic: false });
    }
    if (m[1] !== void 0) {
      segments.push({
        text: m[1],
        link: m[2],
        tooltip: m[3],
        bold: false,
        italic: false
      });
    } else if (m[4] !== void 0 || m[5] !== void 0) {
      segments.push({ text: m[4] ?? m[5], bold: true, italic: false });
    } else {
      segments.push({ text: m[6] ?? m[7], bold: false, italic: true });
    }
    last = m.index + m[0].length;
  }
  if (last < input.length) {
    segments.push({ text: input.slice(last), bold: false, italic: false });
  }
  return segments.length ? segments : [{ text: input, bold: false, italic: false }];
}

// src/helpers/paymentMethod.ts
function isPaymentMethodRequired(customer, organization) {
  if (organization?.requirePaymentMethod === false) {
    return false;
  }
  if (customer?.billsManually === true) {
    return false;
  }
  return true;
}
function isAchPaymentsEnabled(organization) {
  return organization?.achPaymentsEnabled === true;
}

// src/helpers/organization.ts
function orgShowsTeam(org) {
  return org?.firstRun?.hasCrews !== false;
}
function orgShowsSubcontractorPay(org) {
  return org?.firstRun?.hasSubcontractors !== false;
}
function orgShowsPayments(org) {
  const payPath = org?.firstRun?.payPath;
  return payPath !== "invoice" && payPath !== "collect_elsewhere";
}
function orgHasAnsweredImportForks(org) {
  return typeof org?.firstRun?.hasSubcontractors === "boolean" && typeof org?.firstRun?.hasCrews === "boolean" && typeof org?.firstRun?.payPath === "string";
}
function isAutoPauseForOverdueEnabled(org) {
  return org?.pauseServiceForOverdue !== false;
}
function getOrgMessagingName(org) {
  const messagingName = org.messagingName?.trim();
  return messagingName ? messagingName : org.name;
}
function normalizeTaxId(taxId) {
  if (taxId === void 0 || taxId === null) return void 0;
  const digits = String(taxId).replace(/\D/g, "");
  return digits.length > 0 ? digits : void 0;
}
function isValidTaxId(taxId) {
  return normalizeTaxId(taxId)?.length === 9;
}
function formatTaxId(taxId) {
  const digits = String(taxId ?? "").replace(/\D/g, "").slice(0, 9);
  if (digits.length <= 2) return digits;
  return `${digits.slice(0, 2)}-${digits.slice(2)}`;
}
function maskTaxId(taxId) {
  if (!taxId) return void 0;
  const digits = normalizeTaxId(taxId);
  return digits && digits.length >= 4 ? `\u2022\u2022-\u2022\u2022\u2022${digits.slice(-4)}` : "\u2022\u2022\u2022\u2022";
}
function mergeBusinessLegalDetails(incoming, existing, capturedAt) {
  const d = incoming ?? {};
  const text = (value) => {
    const trimmed = typeof value === "string" ? value.trim() : void 0;
    return trimmed ? trimmed : void 0;
  };
  const legalName = text(d.legalName) ?? existing?.legalName ?? "";
  const taxId = normalizeTaxId(d.taxId) ?? existing?.taxId;
  const dba = text(d.dba) ?? existing?.dba;
  const noTaxId = taxId ? false : typeof d.noTaxId === "boolean" ? d.noTaxId : existing?.noTaxId === true;
  const address = d.address ? {
    line1: text(d.address.line1) ?? existing?.address?.line1 ?? "",
    city: text(d.address.city) ?? existing?.address?.city ?? "",
    state: text(d.address.state) ?? existing?.address?.state ?? "",
    postalCode: text(d.address.postalCode) ?? existing?.address?.postalCode ?? "",
    ...text(d.address.line2) ?? existing?.address?.line2 ? { line2: text(d.address.line2) ?? existing?.address?.line2 } : {},
    ...text(d.address.country) ?? existing?.address?.country ? { country: text(d.address.country) ?? existing?.address?.country } : {}
  } : existing?.address;
  return {
    legalName,
    ...dba ? { dba } : {},
    ...taxId ? { taxId } : {},
    ...noTaxId ? { noTaxId: true } : {},
    ...address ? { address } : {},
    // Last written, not first captured — an edit refreshes it, which is what
    // makes a stale record recognisable.
    capturedAt
  };
}
function advanceMessagingRegistrationOnDetails(current, details) {
  const status = current?.status ?? "not_started";
  if (status !== "not_started" && status !== "ready_to_file") return void 0;
  const next = details?.taxId ? "ready_to_file" : "not_started";
  if (next === status) return void 0;
  return { ...current ?? {}, status: next, lastUpdated: (/* @__PURE__ */ new Date()).toISOString() };
}

// src/helpers/dailyCollectedSummary.ts
var DAILY_COLLECTED_SUMMARY_LOCAL_HOUR = 20;
function resolveOrgTimezone(timezone) {
  return timezone || DEFAULT_DISPLAY_TIMEZONE;
}
function tenantLocalDate(nowUtc, timezone) {
  return getDateInTimezone(nowUtc.toISOString(), timezone);
}
function isOrgDueForDailyCollectedSummary(nowUtc, timezone, hour = DAILY_COLLECTED_SUMMARY_LOCAL_HOUR) {
  return getHourInTimezone(nowUtc, timezone) === hour;
}
function tenantLocalDayWindow(dateStr, timezone) {
  return {
    start: startOfDayInTimezone(dateStr, timezone),
    end: endOfDayInTimezone(dateStr, timezone)
  };
}
function instantFallsOnLocalDate(instant, dateStr, timezone) {
  const { start, end } = tenantLocalDayWindow(dateStr, timezone);
  const ms = instant.getTime();
  return ms >= start.getTime() && ms <= end.getTime();
}
function dailyCollectedTotalsFromAggregate(aggregate) {
  const card = roundCurrency(aggregate?.paidRevenue?.onlineAmount ?? 0);
  const checkCash = roundCurrency(aggregate?.paidRevenue?.manualAmount ?? 0);
  const refunds = roundCurrency(aggregate?.refundAmount ?? 0);
  return {
    card,
    checkCash,
    refunds,
    total: roundCurrency(card + checkCash - refunds)
  };
}
function shouldSendDailyCollectedSummary(totals) {
  return totals.total !== 0;
}
function dailyCollectedSummaryIdempotencyKey(orgId, localDate) {
  return `daily-collected-summary-${orgId}-${localDate}`;
}
function revenueReportPathForDay(localDate) {
  return `/revenue?from=${localDate}&to=${localDate}`;
}

// src/featureFlags.ts
var FEATURE_FLAGS = {
  /**
   * When on for an organization, the company may use Ruta without completing
   * JustiFi merchant registration and is not nagged about it. Credit-card
   * processing stays unavailable until they register. Default off — every
   * cards-here company must register.
   *
   * Target by the `organization` group (group key = orgId).
   */
  SKIP_JUSTIFI_REGISTRATION: "skip-justifi-registration",
  /**
   * When on for an organization, a scheduled job compares crew GPS to the
   * visits they could have started or finished and records that comparison.
   * It never changes a visit. Default off. The first company to measure is
   * Quality Seasons (`14a7dc50-6549-4d77-9484-304edfdfeee4`). This change does
   * not turn the flag on. The 14-day comparison only has rows while it is on.
   *
   * Target by the `organization` group (group key = orgId).
   */
  GPS_AUTO_VISIT_SHADOW: "gps-auto-visit-shadow"
};
var POSTHOG_ORGANIZATION_GROUP = "organization";

// src/analytics/visitTap.ts
var VISIT_TAP_SOURCES = ["crew", "office", "bulk", "assistant"];
var VISIT_FLOW_VARIANTS = {
  crewPhone: "crew-phone",
  carplay: "carplay",
  officeWorkbench: "office-workbench",
  officeEditor: "office-editor",
  officeBulk: "office-bulk",
  assistant: "assistant"
};
function crewVisitFlowVariant(surface) {
  return surface === "carplay" ? VISIT_FLOW_VARIANTS.carplay : VISIT_FLOW_VARIANTS.crewPhone;
}
function visitTapProperties(input) {
  return {
    source: input.source,
    tap_time: input.tapTime,
    ...input.latitude != null && input.longitude != null ? { tap_latitude: input.latitude, tap_longitude: input.longitude } : {},
    ...input.accuracyM != null ? { tap_accuracy: input.accuracyM } : {},
    flow_variant: input.flowVariant,
    ...input.crewMemberId ? { crewMemberId: input.crewMemberId } : {}
  };
}

// src/analytics/signupLead.ts
var SIGNUP_LOGIN_CREATED = "signup_login_created";
var LEAD_HOST = "app.getruta.com";
function signupAttributionSource(attribution, referrer = "") {
  if (attribution.utm_source) return attribution.utm_source;
  if (attribution.gclid || attribution.gbraid || attribution.wbraid) return "google ads";
  try {
    if (referrer) return new URL(referrer).hostname.replace(/^www\./, "");
  } catch {
  }
  return "direct";
}
var INTERNAL_DOMAINS = ["getruta.com", "kingdom-sites.com", "with1031.com", "greenvalleylandscaping.com"];
var INTERNAL_ADDRESSES = /* @__PURE__ */ new Set(["derek@qualityseasons.com"]);
function isInternalEmail(email) {
  const normalized = email.trim().toLowerCase();
  const at = normalized.lastIndexOf("@");
  if (at < 1) return false;
  const local = normalized.slice(0, at).split("+")[0];
  const domain = normalized.slice(at + 1);
  if (INTERNAL_ADDRESSES.has(`${local}@${domain}`)) return true;
  return INTERNAL_DOMAINS.some((d) => domain === d || domain.endsWith(`.${d}`));
}
function escapeSlackText(value) {
  return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
var SIGNUP_SOURCES = ["web", "crew_app"];
function isSignupSource(value) {
  return typeof value === "string" && SIGNUP_SOURCES.includes(value);
}
function signupSourceLabel(source) {
  return source === "crew_app" ? "crew app" : "web";
}

// src/helpers/photoCapture.ts
function parseExifDateTime(value, offset) {
  if (value == null) return void 0;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? void 0 : value.toISOString();
  }
  if (typeof value === "number") {
    const d2 = new Date(value);
    return Number.isNaN(d2.getTime()) ? void 0 : d2.toISOString();
  }
  const raw = value.trim();
  if (!raw) return void 0;
  if (raw.includes("T") || /^\d{4}-\d{2}-\d{2}/.test(raw)) {
    const d2 = new Date(raw);
    return Number.isNaN(d2.getTime()) ? void 0 : d2.toISOString();
  }
  const m = raw.match(/^(\d{4}):(\d{2}):(\d{2})[ T](\d{2}):(\d{2}):(\d{2})/);
  if (!m) return void 0;
  const [, y, mo, day, hh, mm, ss] = m;
  const zone = normalizeOffset(offset);
  const iso = `${y}-${mo}-${day}T${hh}:${mm}:${ss}${zone ?? ""}`;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? void 0 : d.toISOString();
}
function normalizeOffset(offset) {
  if (!offset) return void 0;
  const o = offset.trim();
  if (o === "Z") return "Z";
  return /^[+-]\d{2}:\d{2}$/.test(o) ? o : void 0;
}
function gpsToDecimal(value, ref2) {
  let decimal;
  if (typeof value === "number") {
    decimal = value;
  } else if (Array.isArray(value) && value.length > 0) {
    const [deg = 0, min = 0, sec = 0] = value;
    decimal = deg + min / 60 + sec / 3600;
  }
  if (decimal == null || Number.isNaN(decimal) || !Number.isFinite(decimal)) {
    return void 0;
  }
  const hemisphere = (ref2 ?? "").trim().toUpperCase();
  if (decimal >= 0 && (hemisphere === "S" || hemisphere === "W")) {
    decimal = -decimal;
  }
  return decimal;
}
function normalizeExifCapture(raw) {
  if (!raw) return {};
  const result = {};
  const capturedAt = parseExifDateTime(raw.DateTimeOriginal, raw.OffsetTimeOriginal);
  if (capturedAt) result.capturedAt = capturedAt;
  let lat = typeof raw.latitude === "number" && Number.isFinite(raw.latitude) ? raw.latitude : gpsToDecimal(raw.GPSLatitude, raw.GPSLatitudeRef);
  let lon = typeof raw.longitude === "number" && Number.isFinite(raw.longitude) ? raw.longitude : gpsToDecimal(raw.GPSLongitude, raw.GPSLongitudeRef);
  const inRange = lat != null && lon != null && Math.abs(lat) <= 90 && Math.abs(lon) <= 180 && !(lat === 0 && lon === 0);
  if (inRange) {
    result.latitude = lat;
    result.longitude = lon;
  }
  return result;
}
function isValidIso(value) {
  if (!value) return false;
  return !Number.isNaN(new Date(value).getTime());
}
function resolvePhotoCaptureTime(photo) {
  return isValidIso(photo.capturedAt) ? photo.capturedAt : null;
}
function visitPhotoSortTimeMs(photo) {
  const captured = resolvePhotoCaptureTime(photo);
  if (captured) return Date.parse(captured);
  for (const fallback of [photo.uploadedAt, photo.timestamp]) {
    if (isValidIso(fallback)) return Date.parse(fallback);
  }
  return null;
}
function compareVisitPhotosByCaptureTime(a, b) {
  const aMs = visitPhotoSortTimeMs(a);
  const bMs = visitPhotoSortTimeMs(b);
  if (aMs == null && bMs == null) return (a.id ?? "").localeCompare(b.id ?? "");
  if (aMs == null) return 1;
  if (bMs == null) return -1;
  if (aMs !== bMs) return aMs - bMs;
  return (a.id ?? "").localeCompare(b.id ?? "");
}
function sortVisitPhotosByCaptureTime(photos) {
  return [...photos].sort(compareVisitPhotosByCaptureTime);
}

// src/helpers/visitPhotoSharing.ts
function resolveAutoSharePhotos(templateSetting, orgDefault) {
  switch (templateSetting) {
    case "on" /* ON */:
      return true;
    case "off" /* OFF */:
      return false;
    case "inherit" /* INHERIT */:
    case void 0:
      return orgDefault === true;
    default:
      return orgDefault === true;
  }
}
function isVisitInShareableState(visit) {
  return visit.status === "completed" /* COMPLETED */ || visit.status === "paid" /* PAID */;
}
function isOfficeInstructionPhoto(photo, instructionPhotoId) {
  return Boolean(instructionPhotoId && photo.id === instructionPhotoId);
}
function isPhotoEligibleForAutoShare(photo, instructionPhotoId) {
  if (isOfficeInstructionPhoto(photo, instructionPhotoId)) return false;
  return photo.uploadStatus === "uploaded" && photo.sharedWithCustomer == null;
}
function selectAutoSharePhotoUpdates(photos, instructionPhotoId) {
  const current = photos ?? [];
  let changed = false;
  const next = current.map((photo) => {
    if (isPhotoEligibleForAutoShare(photo, instructionPhotoId)) {
      changed = true;
      const { pendingApproval: _pendingApproval, ...rest } = photo;
      return { ...rest, sharedWithCustomer: true };
    }
    return photo;
  });
  return { photos: next, changed };
}
function isCustomerVisibleVisitPhoto(photo, instructionPhotoId) {
  if (isOfficeInstructionPhoto(photo, instructionPhotoId)) return false;
  return photo.sharedWithCustomer === true && photo.uploadStatus === "uploaded";
}
function selectCustomerVisibleVisitPhotos(photos, instructionPhotoId) {
  return (photos ?? []).filter((photo) => isCustomerVisibleVisitPhoto(photo, instructionPhotoId));
}
function projectCustomerVisibleVisitPhotos(photos, instructionPhotoId) {
  return sortVisitPhotosByCaptureTime(
    selectCustomerVisibleVisitPhotos(photos, instructionPhotoId)
  ).map((photo) => ({
    id: photo.id,
    uri: photo.uri,
    timestamp: photo.timestamp,
    capturedAt: photo.capturedAt,
    uploadedAt: photo.uploadedAt,
    note: photo.note,
    tags: photo.tags
  }));
}

// src/helpers/reviewNotification.ts
function resolveNotifyCustomerOnReview(templateSetting, orgDefault) {
  switch (templateSetting) {
    case "send" /* SEND */:
      return true;
    case "hold" /* HOLD */:
      return false;
    case "inherit" /* INHERIT */:
    case void 0:
      return orgDefault === true;
    default:
      return orgDefault === true;
  }
}

// src/helpers/showLaborHoursOnInvoice.ts
function resolveShowLaborHoursOnInvoice(templateSetting, companyDefault) {
  switch (templateSetting) {
    case "on" /* ON */:
      return true;
    case "off" /* OFF */:
      return false;
    case "inherit" /* INHERIT */:
    case void 0:
      return companyDefault === true;
    default:
      return companyDefault === true;
  }
}

// src/helpers/importProvenance.ts
function wasCreatedByImport(record) {
  return typeof record?.importId === "string" && record.importId.length > 0;
}

// src/helpers/postImportFirstRun.ts
var POST_IMPORT_TIMEZONE = DEFAULT_DISPLAY_TIMEZONE;
var IMPORT_SOURCES = ["jobs", "clip", "other"];
var PAY_PATHS = ["cards_here", "invoice", "collect_elsewhere"];
var SETUP_MODAL_ITEMS = ["payments", "invite_crew", "subcontractors", "confirm"];
var JOBS_FILE = /(^|[^a-z0-9])jobs?([^a-z0-9]|$)|job[-_\s]?history|03-jobs/i;
var CLIP_FILE = /(^|[^a-z0-9])clip([^a-z0-9]|$)/i;
function classifyImportSource(sourceFiles) {
  const names = sourceFiles.map((name) => name.toLowerCase());
  if (names.some((name) => JOBS_FILE.test(name))) return "jobs";
  if (names.some((name) => CLIP_FILE.test(name))) return "clip";
  return "other";
}
function chicagoCalendarDate(value, now = /* @__PURE__ */ new Date()) {
  if (typeof value === "string" && isCalendarDate(value)) return value;
  const iso = value instanceof Date ? value.toISOString() : value;
  if (!iso) return getDateInTimezone(now.toISOString(), POST_IMPORT_TIMEZONE);
  return getDateInTimezone(iso, POST_IMPORT_TIMEZONE);
}
function isChicagoDateInNextDays(scheduledDate, days, now = /* @__PURE__ */ new Date()) {
  if (!scheduledDate) return false;
  const visit = chicagoCalendarDate(scheduledDate, now);
  const today = chicagoCalendarDate(now.toISOString(), now);
  const last = addCalendarDays(today, days - 1);
  return visit >= today && visit <= last;
}
function countVisitsInNextDays(dates, days, now = /* @__PURE__ */ new Date()) {
  return dates.filter((date) => isChicagoDateInNextDays(date, days, now)).length;
}
function countFirstWeekVisibleHits(hits, days = 7, now = /* @__PURE__ */ new Date()) {
  const today = chicagoCalendarDate(now.toISOString(), now);
  const last = addCalendarDays(today, days - 1);
  let inWindow = 0;
  for (const hit of hits) {
    const date = hit.scheduledDate || hit.scheduledServiceDate;
    if (!date || !isCalendarDate(date)) continue;
    if (date > last) return 0;
    if (date >= today && date <= last) inWindow += 1;
  }
  return inWindow;
}
function buildImportCompletedMetrics(input) {
  const now = input.now ?? /* @__PURE__ */ new Date();
  const active = input.services.filter((service) => service.active);
  const queuedDates = active.map((service) => service.nextDueDate);
  return {
    source: classifyImportSource(input.sourceFiles),
    visits_minted: input.visitsMinted,
    visits_in_next_7d: countVisitsInNextDays(queuedDates, 7, now),
    visits_in_next_14d: countVisitsInNextDays(queuedDates, 14, now),
    services_active: active.length,
    services_with_no_queued_visits: active.filter((service) => !service.nextDueDate?.trim()).length,
    payment_issues_flagged: input.paymentIssuesFlagged
  };
}
function hasCompleteForks(state) {
  return typeof state?.hasSubcontractors === "boolean" && typeof state?.hasCrews === "boolean" && typeof state?.payPath === "string" && PAY_PATHS.includes(state.payPath);
}
function buildImportCompletedProperties(input) {
  return {
    org_id: input.orgId,
    role: input.role,
    ...input.metrics,
    has_subcontractors: input.forks.hasSubcontractors,
    has_crews: input.forks.hasCrews,
    pay_path: input.forks.payPath
  };
}
function visibleSetupModalItems(forks) {
  const items = [];
  if (forks.payPath === "cards_here") items.push("payments");
  if (forks.hasCrews) items.push("invite_crew");
  if (forks.hasSubcontractors) items.push("subcontractors");
  items.push("confirm");
  return items;
}
function isSetupModalItemVisible(item, forks) {
  return visibleSetupModalItems(forks).includes(item);
}
function mergeFirstRunState(existing, update) {
  return {
    ...existing ?? {},
    ...update,
    pendingMetrics: update.pendingMetrics ?? existing?.pendingMetrics
  };
}
function firstRunForksFromState(state) {
  if (!hasCompleteForks(state)) return null;
  return {
    hasSubcontractors: state.hasSubcontractors,
    hasCrews: state.hasCrews,
    payPath: state.payPath
  };
}

// src/helpers/weatherLimits.ts
var RANGES = {
  temperatureF: { min: -80, max: 150 },
  windMph: { min: 0, max: 250 },
  precipitationInches: { min: 0, max: 50 }
};
var LABELS = {
  maxF: "Maximum temperature",
  minF: "Minimum temperature",
  maxMph: "Maximum wind speed",
  maxInches: "Maximum precipitation"
};
function selectedDimensions(sensitivity) {
  return sensitivity.enabled === true ? sensitivity.dimensions ?? [] : [];
}
function round(value, unit) {
  const places = unit === "in" ? 100 : 10;
  return Math.round(value * places) / places;
}
function pruneWeatherLimits(sensitivity) {
  const dimensions = selectedDimensions(sensitivity);
  const raw = sensitivity.limits ?? {};
  const kept = {};
  if (dimensions.includes("temperature" /* TEMPERATURE */) && raw.temperature) kept.temperature = raw.temperature;
  if (dimensions.includes("wind" /* WIND */) && raw.wind) kept.wind = raw.wind;
  if (dimensions.includes("precipitation" /* PRECIPITATION */) && raw.precipitation) kept.precipitation = raw.precipitation;
  return Object.keys(kept).length > 0 ? kept : void 0;
}
function checkNumber(value, key, range) {
  if (value === void 0 || value === null) return null;
  if (typeof value !== "number" || !Number.isFinite(value)) {
    return `${LABELS[key]} must be a number`;
  }
  if (value < range.min || value > range.max) {
    return `${LABELS[key]} must be between ${range.min} and ${range.max}`;
  }
  return null;
}
function validateWeatherLimits(sensitivity) {
  if (!sensitivity) return null;
  const limits = pruneWeatherLimits(sensitivity);
  if (!limits) return null;
  const checks = [
    checkNumber(limits.temperature?.maxF, "maxF", RANGES.temperatureF),
    checkNumber(limits.temperature?.minF, "minF", RANGES.temperatureF),
    checkNumber(limits.wind?.maxMph, "maxMph", RANGES.windMph),
    checkNumber(limits.precipitation?.maxInches, "maxInches", RANGES.precipitationInches)
  ];
  const failed = checks.find((c) => c !== null);
  if (failed) return failed;
  const { maxF, minF } = limits.temperature ?? {};
  if (typeof maxF === "number" && typeof minF === "number" && minF > maxF) {
    return "Minimum temperature cannot be above the maximum temperature";
  }
  return null;
}
function normalizeWeatherSensitivity(sensitivity) {
  if (sensitivity === null || sensitivity === void 0) return sensitivity;
  const pruned = pruneWeatherLimits(sensitivity);
  const limits = {};
  if (pruned?.temperature) {
    const { maxF, minF } = pruned.temperature;
    limits.temperature = {
      ...typeof maxF === "number" ? { maxF: round(maxF, "other") } : {},
      ...typeof minF === "number" ? { minF: round(minF, "other") } : {}
    };
    if (Object.keys(limits.temperature).length === 0) delete limits.temperature;
  }
  if (typeof pruned?.wind?.maxMph === "number") {
    limits.wind = { maxMph: round(pruned.wind.maxMph, "other") };
  }
  if (typeof pruned?.precipitation?.maxInches === "number") {
    limits.precipitation = { maxInches: round(pruned.precipitation.maxInches, "in") };
  }
  const hasLimits = Object.keys(limits).length > 0;
  return {
    enabled: sensitivity.enabled === true,
    dimensions: sensitivity.dimensions ?? [],
    ...hasLimits ? { limits } : {}
  };
}

// src/theme/colors.ts
var BaseColors = {
  // Primary brand colors (green palette)
  primary: {
    50: "#f8faf8",
    100: "#e8f0e8",
    200: "#d0e1d0",
    300: "#a8c8a8",
    400: "#609060",
    500: "#486948",
    // Forest green — matches web --primary hsl(120 18.6% 34.7%)
    600: "#4A6B3A",
    700: "#3A5329",
    800: "#2A3B1D",
    900: "#1A2312"
  },
  // Button colors (rust orange palette)
  button: {
    50: "#fef5ee",
    100: "#fde6d3",
    200: "#fbc8a5",
    300: "#f9a06d",
    400: "#f67032",
    500: "#b7410e",
    // Main button rust orange
    600: "#a2370a",
    700: "#862d0b",
    800: "#6d2610",
    900: "#5a2110"
  },
  // Neutral colors
  neutral: {
    50: "#f9fafb",
    100: "#f3f4f6",
    200: "#e5e7eb",
    300: "#d1d5db",
    400: "#9ca3af",
    500: "#6b7280",
    600: "#4b5563",
    700: "#374151",
    800: "#1f2937",
    900: "#111827"
  },
  // Semantic colors
  success: {
    50: "#f0fdf4",
    100: "#dcfce7",
    200: "#bbf7d0",
    300: "#86efac",
    400: "#4ade80",
    500: "#22c55e",
    600: "#16a34a",
    700: "#15803d",
    800: "#166534",
    900: "#14532d"
  },
  warning: {
    50: "#fffbeb",
    100: "#fef3c7",
    200: "#fde68a",
    300: "#fcd34d",
    400: "#fbbf24",
    500: "#f59e0b",
    600: "#d97706",
    700: "#b45309",
    800: "#92400e",
    900: "#78350f"
  },
  error: {
    50: "#fef2f2",
    100: "#fee2e2",
    200: "#fecaca",
    300: "#fca5a5",
    400: "#f87171",
    500: "#ef4444",
    600: "#dc2626",
    700: "#b91c1c",
    800: "#991b1b",
    900: "#7f1d1d"
  },
  blue: {
    50: "#eff6ff",
    100: "#dbeafe",
    200: "#bfdbfe",
    300: "#93c5fd",
    400: "#60a5fa",
    500: "#3b82f6",
    600: "#2563eb",
    700: "#1d4ed8",
    800: "#1e40af",
    900: "#1e3a8a"
  },
  // Special colors
  nav: "#0a1f0a",
  // Deep forest — nav/hero surfaces only, never buttons (web --nav)
  terracotta: "#d66b3c",
  // Ruta terracotta — logo mark and attention states only, never a primary (portal --terracotta)
  white: "#ffffff",
  black: "#000000"
};
var StoneColors = {
  50: "#fafaf9",
  100: "#f5f5f4",
  200: "#e7e5e4",
  300: "#d6d3d1",
  400: "#a8a29e",
  500: "#78716c",
  600: "#57534e",
  700: "#44403c",
  800: "#292524",
  900: "#1c1917",
  950: "#0c0a09"
};
var Colors = {
  // Primary colors
  primary: BaseColors.primary[500],
  primaryLight: BaseColors.primary[100],
  primaryDark: BaseColors.primary[700],
  primaryForeground: BaseColors.white,
  // Background colors
  background: BaseColors.white,
  backgroundSecondary: BaseColors.neutral[50],
  backgroundMuted: BaseColors.neutral[100],
  // Foreground colors
  foreground: BaseColors.neutral[900],
  foregroundSecondary: BaseColors.neutral[600],
  foregroundMuted: BaseColors.neutral[500],
  // Border colors
  border: BaseColors.neutral[200],
  borderMuted: BaseColors.neutral[100],
  // Semantic colors
  success: BaseColors.success[500],
  successLight: BaseColors.success[100],
  successDark: BaseColors.success[700],
  successForeground: BaseColors.white,
  warning: BaseColors.warning[500],
  warningLight: BaseColors.warning[100],
  warningDark: BaseColors.warning[700],
  warningForeground: BaseColors.white,
  error: BaseColors.error[500],
  errorLight: BaseColors.error[100],
  errorDark: BaseColors.error[700],
  errorForeground: BaseColors.white,
  // Interactive colors
  link: BaseColors.blue[600],
  linkHover: BaseColors.blue[700],
  // Input colors
  input: BaseColors.neutral[200],
  inputForeground: BaseColors.neutral[900],
  inputBackground: BaseColors.white,
  placeholder: BaseColors.neutral[400],
  // Card colors
  card: BaseColors.white,
  cardForeground: BaseColors.neutral[900],
  cardHeader: "#fdfbf7",
  // Icon colors
  icon: BaseColors.primary[500],
  iconMuted: BaseColors.neutral[500],
  // Accent colors
  accent: BaseColors.neutral[100],
  accentForeground: BaseColors.neutral[900],
  // Button colors (rust orange)
  button: BaseColors.button[500],
  buttonLight: BaseColors.button[100],
  buttonDark: BaseColors.button[700],
  buttonForeground: BaseColors.white,
  // New semantic tokens for dark mode support
  // Shadow (consistent across themes)
  shadow: BaseColors.black,
  // Overlay
  overlay: "rgba(0, 0, 0, 0.5)",
  overlayHeavy: "rgba(0, 0, 0, 0.7)",
  // Avatar
  avatarBackground: StoneColors[100],
  avatarForeground: StoneColors[500],
  // Badges
  badgeSuccess: BaseColors.success[100],
  badgeSuccessText: BaseColors.success[800],
  badgeError: BaseColors.error[100],
  badgeErrorText: BaseColors.error[800],
  badgeWarning: BaseColors.warning[100],
  badgeWarningText: BaseColors.warning[800],
  badgeNeutral: BaseColors.neutral[100],
  badgeNeutralText: BaseColors.neutral[600],
  // Skeleton loading
  skeleton: BaseColors.neutral[200],
  skeletonHighlight: BaseColors.neutral[100],
  // Divider
  divider: BaseColors.neutral[200],
  // Header (brand - consistent across themes)
  headerBackground: BaseColors.nav,
  headerForeground: BaseColors.white,
  // Tab bar
  tabBarBackground: "rgba(10, 31, 10, 0.55)",
  tabBarForeground: BaseColors.white,
  tabBarInactive: "rgba(255, 255, 255, 0.6)",
  // Text on dark backgrounds (for headers, etc.)
  textOnDark: BaseColors.white,
  textOnDarkSecondary: "rgba(255, 255, 255, 0.7)"
};
var ColorsDark = {
  // Primary colors — brighter green in dark mode so accents read on near-black.
  // primaryLight backs pale-green pills (readable with primary-colored text);
  // primaryDark stays a pale green used as readable text/icon color on dark.
  primary: BaseColors.primary[400],
  primaryLight: BaseColors.primary[300],
  primaryDark: BaseColors.primary[300],
  primaryForeground: BaseColors.white,
  // Background colors (dark)
  background: StoneColors[950],
  backgroundSecondary: StoneColors[950],
  backgroundMuted: StoneColors[900],
  // Foreground colors (light on dark)
  foreground: StoneColors[50],
  foregroundSecondary: StoneColors[400],
  foregroundMuted: StoneColors[500],
  // Border colors
  border: StoneColors[700],
  borderMuted: StoneColors[800],
  // Semantic colors
  success: BaseColors.success[500],
  successLight: BaseColors.success[900],
  successDark: BaseColors.success[300],
  successForeground: BaseColors.white,
  warning: BaseColors.warning[500],
  warningLight: BaseColors.warning[900],
  warningDark: BaseColors.warning[300],
  warningForeground: BaseColors.white,
  error: BaseColors.error[500],
  errorLight: BaseColors.error[900],
  errorDark: BaseColors.error[300],
  errorForeground: BaseColors.white,
  // Interactive colors
  link: BaseColors.blue[400],
  linkHover: BaseColors.blue[300],
  // Input colors
  input: StoneColors[700],
  inputForeground: StoneColors[50],
  inputBackground: StoneColors[800],
  placeholder: StoneColors[500],
  // Card colors
  card: StoneColors[800],
  cardForeground: StoneColors[50],
  cardHeader: StoneColors[700],
  // Icon colors
  icon: StoneColors[50],
  iconMuted: StoneColors[500],
  // Accent colors
  accent: StoneColors[800],
  accentForeground: StoneColors[50],
  // Button colors (rust orange - stays vibrant)
  button: BaseColors.button[500],
  buttonLight: BaseColors.button[900],
  buttonDark: BaseColors.button[300],
  buttonForeground: BaseColors.white,
  // New semantic tokens
  // Shadow (consistent across themes)
  shadow: BaseColors.black,
  // Overlay
  overlay: "rgba(0, 0, 0, 0.7)",
  overlayHeavy: "rgba(0, 0, 0, 0.85)",
  // Avatar
  avatarBackground: StoneColors[700],
  avatarForeground: StoneColors[300],
  // Badges (inverted for dark mode)
  badgeSuccess: BaseColors.success[900],
  badgeSuccessText: BaseColors.success[200],
  badgeError: BaseColors.error[900],
  badgeErrorText: BaseColors.error[200],
  badgeWarning: BaseColors.warning[900],
  badgeWarningText: BaseColors.warning[200],
  badgeNeutral: StoneColors[700],
  badgeNeutralText: StoneColors[300],
  // Skeleton loading
  skeleton: StoneColors[700],
  skeletonHighlight: StoneColors[600],
  // Divider
  divider: StoneColors[700],
  // Header (brand - consistent across themes)
  headerBackground: BaseColors.nav,
  headerForeground: BaseColors.white,
  // Tab bar
  tabBarBackground: "rgba(10, 31, 10, 0.75)",
  tabBarForeground: BaseColors.white,
  tabBarInactive: "rgba(255, 255, 255, 0.6)",
  // Text on dark backgrounds
  textOnDark: BaseColors.white,
  textOnDarkSecondary: "rgba(255, 255, 255, 0.7)"
};
var CSSVariables = {
  light: {
    "--color-primary": "120 18.6 34.7",
    // Forest green #486948
    "--color-primary-foreground": "0 0 100",
    "--color-button": "24 88 47",
    // HSL values for #b7410e (rust orange)
    "--color-button-foreground": "0 0 100",
    "--color-background": "0 0 100",
    "--color-foreground": "215 25 27",
    "--color-muted": "210 40 96",
    "--color-muted-foreground": "215 16 47",
    "--color-popover": "0 0 100",
    "--color-popover-foreground": "215 25 27",
    "--color-card": "0 0 100",
    "--color-card-foreground": "215 25 27",
    "--color-border": "214 32 91",
    "--color-input": "214 32 91",
    "--color-accent": "210 40 96",
    "--color-accent-foreground": "215 25 27",
    "--color-success": "142 76 73",
    "--color-success-foreground": "0 0 100",
    "--color-warning": "38 92 50",
    "--color-warning-foreground": "0 0 100",
    "--color-destructive": "0 84 60",
    "--color-destructive-foreground": "0 0 100",
    "--color-ring": "120 18.6 34.7"
    // Match primary color
  },
  dark: {
    "--color-primary": "120 18.6 34.7",
    // Same primary color in dark mode
    "--color-primary-foreground": "0 0 100",
    "--color-button": "24 88 47",
    // HSL values for #b7410e (rust orange)
    "--color-button-foreground": "0 0 100",
    "--color-background": "215 28 17",
    "--color-foreground": "213 31 91",
    "--color-muted": "215 30 25",
    "--color-muted-foreground": "218 11 65",
    "--color-popover": "215 28 17",
    "--color-popover-foreground": "213 31 91",
    "--color-card": "215 28 17",
    "--color-card-foreground": "213 31 91",
    "--color-border": "215 30 25",
    "--color-input": "215 30 25",
    "--color-accent": "215 30 25",
    "--color-accent-foreground": "213 31 91",
    "--color-success": "142 76 73",
    "--color-success-foreground": "0 0 100",
    "--color-warning": "38 92 50",
    "--color-warning-foreground": "0 0 100",
    "--color-destructive": "0 63 31",
    "--color-destructive-foreground": "213 31 91",
    "--color-ring": "120 18.6 34.7"
    // Match primary color
  }
};
var getColor = (colorKey) => Colors[colorKey];
var getColorForTheme = (theme, colorKey) => (theme === "dark" ? ColorsDark : Colors)[colorKey];
var getCSSVariable = (theme, variable) => CSSVariables[theme][variable];

// src/notifications/templates.ts
import Mustache from "mustache";

// src/notifications/displayDates.ts
var REQUESTED_START_LABEL = "Requested";
var DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;
function formatDisplayDate(value, language = "en") {
  const m = DATE_ONLY.exec(value.trim());
  if (!m) return value;
  const [, y, mo, d] = m;
  const month = Number(mo);
  const day = Number(d);
  if (month < 1 || month > 12 || day < 1 || day > 31) return value;
  if (language === "es") {
    return new Date(Date.UTC(Number(y), month - 1, day)).toLocaleDateString("es-ES", {
      day: "numeric",
      month: "long",
      year: "numeric",
      timeZone: "UTC"
    });
  }
  return `${mo}-${d}-${y}`;
}
function localizeDateOnlyFields(data, language = "en") {
  if (typeof data === "string") return formatDisplayDate(data, language);
  if (Array.isArray(data)) return data.map((v) => localizeDateOnlyFields(v, language));
  if (data && typeof data === "object" && Object.getPrototypeOf(data) === Object.prototype) {
    const out = {};
    for (const [k, v] of Object.entries(data)) out[k] = localizeDateOnlyFields(v, language);
    return out;
  }
  return data;
}

// src/notifications/cadence.ts
var AUTO_MESSAGE_SITTING_GAP_MS = 4 * 60 * 60 * 1e3;
var AUTO_MESSAGE_SITTING_TIMEZONE = DEFAULT_DISPLAY_TIMEZONE;
var CADENCE_EXEMPT_TYPES = /* @__PURE__ */ new Set([
  "admin_message" /* ADMIN_MESSAGE */,
  "customer_welcome" /* CUSTOMER_WELCOME */,
  "subscription_rate_not_yet_available" /* SUBSCRIPTION_RATE_NOT_YET_AVAILABLE */
]);
function appliesAutoMessageCadence(type) {
  return !CADENCE_EXEMPT_TYPES.has(type);
}
function autoMessageCadenceAppliesToRole(targetRoles) {
  return !!targetRoles?.includes("customer" /* CUSTOMER */);
}
function autoMessageCadence(input = {}) {
  if (input.isNewThread) return "opener";
  if (input.lastActivityAt == null || input.lastActivityAt === "") return "opener";
  const last = toMs(input.lastActivityAt);
  const now = input.now == null ? Date.now() : toMs(input.now);
  if (!Number.isFinite(last) || !Number.isFinite(now)) return "opener";
  return now - last >= AUTO_MESSAGE_SITTING_GAP_MS ? "opener" : "follow_up";
}
function applyAutoMessageAddressing(input) {
  const customerFirstName = cleanName(input.customerFirstName);
  const ownerFirstName = cleanName(input.ownerFirstName);
  const { format } = input;
  let body = stripGreeting(input.content, customerFirstName);
  const ownGreeting = body === input.content && new RegExp(`^\\s*(?:<p[^>]*>\\s*)?${GREETING_WORD}${NAME_END}`, "iu").test(input.content);
  body = stripSignOff(body, ownerFirstName);
  const link = splitTrailingLink(body, format);
  body = link ? stripSignOff(link.body, ownerFirstName) : body;
  body = capitalizeBody(body, format).trim();
  if (!body) {
    return link ? restoreTrailingNewline(input.content, link.link) : body;
  }
  if (input.cadence === "follow_up") {
    const out = link ? `${body}${link.separator}${link.link}` : body;
    return restoreTrailingNewline(input.content, out);
  }
  let addressed = body;
  if (customerFirstName && !ownGreeting) {
    addressed = addGreeting(addressed, customerFirstName, format);
  }
  let signed = false;
  if (ownerFirstName && !hasOtherSignOff(addressed)) {
    addressed = addSignOff(addressed, ownerFirstName, format);
    signed = true;
  }
  if (link) {
    addressed = signed ? `${addressed}${LINK_AFTER_SIGN_OFF[format]}${link.link}` : `${addressed}${link.separator}${link.link}`;
  }
  return restoreTrailingNewline(input.content, addressed);
}
function endsWithAutoMessageSignOff(content, ownerFirstName) {
  const owner = cleanName(ownerFirstName);
  if (!owner) return false;
  return new RegExp(`\\n${DASH}\\s*${nameAlternatives(owner)}${NAME_END}\\s*$`, "iu").test(content);
}
var LINK_AFTER_SIGN_OFF = {
  plain: "\n",
  text: "\n\n",
  html: "\n"
};
function cleanName(value) {
  const trimmed = value?.replace(/\s+/g, " ").trim();
  return trimmed || void 0;
}
function toMs(value) {
  if (typeof value === "number") return value;
  if (value instanceof Date) return value.getTime();
  return Date.parse(value);
}
function escapeRegex(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
var GENERIC_NAME = String.raw`[\p{L}][\p{L}'’-]*`;
var NAME_END = String.raw`(?![\p{L}])`;
var DASH = "[\u2013\u2014-]";
var GREETING_WORD = String.raw`(?:Hi|Hello|Hey|Howdy|Dear|Good\s+(?:morning|afternoon|evening|day))`;
var GREETING_NOUN = "(?:there|everyone|all|folks)";
var ADDRESS_PUNCT = "[,!:\u2013\u2014-]";
var SIGN_OFF_WORD = String.raw`(?:Thanks(?:\s+(?:again|so\s+much))?|Thank\s+you(?:\s+(?:again|so\s+much))?|Many\s+thanks|Best(?:\s+(?:regards|wishes))?|Kind\s+regards|Warm\s+regards|Regards|Cheers|Sincerely|Warmly|Talk\s+soon)`;
var OWNER_TITLE = String.raw`(?:,?\s*(?:Founder\s+(?:and|&)\s+Owner|Owner))?`;
function nameAlternatives(name) {
  if (!name) return GENERIC_NAME;
  const variants = Array.from(/* @__PURE__ */ new Set([name, name.split(" ")[0]])).sort((a, b) => b.length - a.length).map((n) => escapeRegex(n).replace(/ /g, String.raw`\s+`));
  return `(?:${variants.join("|")})`;
}
function greetingPattern(firstName, punctRequiredOnBareName) {
  const name = nameAlternatives(firstName);
  const forms = [
    firstName ? (
      // "Hello Sam and family," is the company's own greeting: only a greeting
      // that ends at the name is ours to replace.
      `${GREETING_WORD}\\s+(?:${name}|${GREETING_NOUN})${NAME_END}\\s*(?:${ADDRESS_PUNCT}|(?=\\n|<|$))`
    ) : (
      // Name unknown: only a single word that is clearly an address ("Hi Sam,"),
      // never the start of "Hello Green Valley customers, …".
      `${GREETING_WORD}\\s+(?:${GREETING_NOUN}${NAME_END}\\s*${ADDRESS_PUNCT}?|${name}${NAME_END}\\s*${ADDRESS_PUNCT})`
    ),
    `${GREETING_WORD}\\s*${ADDRESS_PUNCT}`,
    // `{{customerFirstName}}, your…` with the name blank renders `, your…`.
    ","
  ];
  if (firstName) {
    forms.push(`${name}${NAME_END}\\s*${ADDRESS_PUNCT}${punctRequiredOnBareName ? "" : "?"}`);
  }
  return `(?:${forms.join("|")})`;
}
function stripGreeting(content, firstName) {
  const htmlPara = new RegExp(
    `^\\s*<p[^>]*>\\s*${greetingPattern(firstName, false)}\\s*</p>\\s*`,
    "iu"
  );
  if (htmlPara.test(content)) {
    return content.replace(htmlPara, "");
  }
  const leading = new RegExp(`^\\s*(<p[^>]*>\\s*)?${greetingPattern(firstName, true)}\\s*`, "iu");
  return content.replace(leading, (_m, tag) => tag ?? "");
}
function ownerSignOffPattern(ownerFirstName) {
  const sep = String.raw`(?:\s|<br\s*\/?>)`;
  if (!ownerFirstName) {
    return `(?:${DASH}\\s*${GENERIC_NAME}${NAME_END}${OWNER_TITLE})`;
  }
  const owner = nameAlternatives(ownerFirstName);
  return `(?:(?:${SIGN_OFF_WORD}\\s*[,!.]?${sep}+|${DASH}\\s*)${owner}${NAME_END}${OWNER_TITLE}\\s*[.!]?)`;
}
function stripSignOff(content, ownerFirstName) {
  const signOff = ownerSignOffPattern(ownerFirstName);
  const htmlPara = new RegExp(`\\s*<p[^>]*>\\s*${signOff}\\s*</p>\\s*$`, "iu");
  if (htmlPara.test(content)) {
    return content.replace(htmlPara, "");
  }
  const inPara = new RegExp(`(?:\\s|<br\\s*\\/?>)+${signOff}\\s*(</p>\\s*)$`, "iu");
  if (inPara.test(content)) {
    return content.replace(inPara, (_m, close) => close);
  }
  const lead = ownerFirstName ? String.raw`(?:^|\s+)` : String.raw`(?:^|\s*\n\s*)`;
  const trailing = new RegExp(`${lead}${signOff}\\s*$`, "iu");
  return content.replace(trailing, "");
}
function hasOtherSignOff(content) {
  const closingLine = String.raw`[^\n<]{1,60}?\s*(?:<\/p>\s*)?$`;
  const worded = new RegExp(
    `(?:^|\\n|<br\\s*\\/?>|<p[^>]*>)[ \\t]*${SIGN_OFF_WORD}\\s*[,!.]?[ \\t]*(?:\\n|<br\\s*\\/?>)\\s*${closingLine}`,
    "iu"
  );
  const dashed = new RegExp(`(?:\\n|<p[^>]*>)\\s*${DASH}\\s+${closingLine}`, "iu");
  const endsBulletList = new RegExp(`(?:^|\\n)[ \\t]*${DASH}\\s[^\\n]*\\n[ \\t]*${DASH}\\s[^\\n]*\\s*$`, "u");
  return worded.test(content) || dashed.test(content) && !endsBulletList.test(content) && !lastLineIsListItem(content);
}
function lastLineIsListItem(content) {
  const last = content.replace(/<\/p>\s*$/i, "").trimEnd().split(/\n|<p[^>]*>/).pop() ?? "";
  const words = last.replace(/^\s*[–—-]\s+/, "").split(/\s+/).filter((w) => /\p{L}/u.test(w));
  return words.some((w) => /^\p{Ll}/u.test(w) && !/^(?:of|and|the|at|&|crew|team|staff|office)$/i.test(w));
}
function splitTrailingLink(content, format) {
  if (format === "html") {
    const m2 = content.match(
      /^([\s\S]*?\S)(\s*)(<p[^>]*>(?:(?!<\/?p[\s>])[\s\S]){0,300}?(?:https?:\/\/|<a\s)(?:(?!<\/?p[\s>])[\s\S])*<\/p>)\s*$/iu
    );
    return m2 && isLinkParagraph(m2[3]) ? { body: m2[1], separator: m2[2] || "\n", link: m2[3] } : void 0;
  }
  const m = content.match(
    /^([\s\S]*?\S)([ \t]*\n\s*|(?<=[.!?])[ \t]+)((?:[^\n:.!?]{1,40}:[ \t]*)?https?:\/\/\S+)\s*$/u
  );
  return m ? { body: m[1], separator: m[2], link: m[3] } : void 0;
}
function isLinkParagraph(paragraph) {
  const withoutLinks = paragraph.replace(/<a\b[\s\S]*?<\/a>/giu, "").replace(/https?:\/\/\S+/giu, "").replace(/<[^>]+>/g, "").replace(/&[a-z]+;|&#\d+;/giu, " ");
  return withoutLinks.replace(/\s+/g, " ").trim().length <= 30;
}
function capitalizeBody(content, format) {
  const trimmed = content.trimStart();
  if (!trimmed) return content;
  if (format === "html") {
    return trimmed.replace(/^(<[^>]+>)(\s*)(\p{Ll})/u, (_m, tag, ws, ch) => tag + ws + ch.toUpperCase());
  }
  return trimmed.replace(/^(\p{Ll})/u, (ch) => ch.toUpperCase());
}
function addGreeting(content, firstName, format) {
  if (format === "html") {
    const greeting = `<p style="font-size: 16px; margin-bottom: 20px;">Hi ${firstName},</p>`;
    return content ? `${greeting}

${content}` : greeting;
  }
  if (format === "text") {
    return content ? `Hi ${firstName},

${content}` : `Hi ${firstName},`;
  }
  if (!content) return `Hi ${firstName}`;
  return `Hi ${firstName} - ${content}`;
}
function addSignOff(content, ownerFirstName, format) {
  if (format === "html") {
    const signOff = `<p style="font-size: 16px; margin-bottom: 20px;">- ${ownerFirstName}</p>`;
    return content ? `${content}
${signOff}` : signOff;
  }
  if (format === "text") {
    return content ? `${content}

- ${ownerFirstName}` : `- ${ownerFirstName}`;
  }
  return content ? `${content}
- ${ownerFirstName}` : `- ${ownerFirstName}`;
}
function restoreTrailingNewline(original, next) {
  return original.endsWith("\n") && !next.endsWith("\n") ? `${next}
` : next;
}

// src/notifications/templates.ts
var NOTIFICATION_TYPE_CONFIGS = {
  // Rate & Pricing Notifications
  ["rate_request_submitted" /* RATE_REQUEST_SUBMITTED */]: {
    type: "rate_request_submitted" /* RATE_REQUEST_SUBMITTED */,
    name: "Rate Request Submitted",
    description: "Sent to admins when a new rate request is submitted",
    channels: ["email" /* EMAIL */, "in_app" /* IN_APP */, "sms" /* SMS */, "push" /* PUSH */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "rate_pricing",
    requiredData: ["rateRequestId", "customerName", "serviceAddress"],
    optionalData: ["phone", "email", "notes"],
    triggerEvents: ["rate_request.created"],
    bypassKillSwitch: true
  },
  ["rate_request_updated" /* RATE_REQUEST_UPDATED */]: {
    type: "rate_request_updated" /* RATE_REQUEST_UPDATED */,
    name: "Rate Request Updated",
    description: "Sent when rate request pricing is provided",
    channels: ["email" /* EMAIL */, "sms" /* SMS */, "in_app" /* IN_APP */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["customer" /* CUSTOMER */],
    enabledByDefault: true,
    category: "rate_pricing",
    requiredData: ["rateRequestId", "customerName", "pricing"],
    optionalData: ["customMessage", "validUntil"]
  },
  ["rate_accepted" /* RATE_ACCEPTED */]: {
    type: "rate_accepted" /* RATE_ACCEPTED */,
    name: "Rate Accepted",
    description: "Sent when a customer accepts a rate",
    channels: ["email" /* EMAIL */, "in_app" /* IN_APP */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "rate_pricing",
    requiredData: ["rateRequestId", "customerName", "acceptedRate"]
  },
  ["rate_declined" /* RATE_DECLINED */]: {
    type: "rate_declined" /* RATE_DECLINED */,
    name: "Rate Declined",
    description: "Sent when a customer declines a rate",
    channels: ["email" /* EMAIL */, "in_app" /* IN_APP */],
    defaultPriority: "low" /* LOW */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "rate_pricing",
    requiredData: ["rateRequestId", "customerName", "reason"]
  },
  ["rate_request_resurfaced" /* RATE_REQUEST_RESURFACED */]: {
    type: "rate_request_resurfaced" /* RATE_REQUEST_RESURFACED */,
    name: "Rate Request Resurfaced",
    description: "Sent to admins when a snoozed rate request reaches its resurface date and counts as pending again",
    channels: ["in_app" /* IN_APP */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "rate_pricing",
    requiredData: ["customerName", "serviceName"],
    optionalData: ["snoozedUntil"]
  },
  // Scheduling & Visit Notifications
  ["visit_scheduled" /* VISIT_SCHEDULED */]: {
    type: "visit_scheduled" /* VISIT_SCHEDULED */,
    name: "Visit Scheduled",
    description: "Sent when a service visit is scheduled",
    channels: ["email" /* EMAIL */, "sms" /* SMS */, "in_app" /* IN_APP */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["customer" /* CUSTOMER */, "crew" /* CREW */],
    enabledByDefault: true,
    category: "scheduling",
    requiredData: ["visitId", "scheduledDate", "serviceType"],
    optionalData: ["crewName", "estimatedDuration"]
  },
  ["visit_reminder" /* VISIT_REMINDER */]: {
    type: "visit_reminder" /* VISIT_REMINDER */,
    name: "Visit Reminder",
    description: "Reminder sent before a scheduled visit",
    channels: ["sms" /* SMS */, "push" /* PUSH */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["customer" /* CUSTOMER */],
    enabledByDefault: true,
    category: "scheduling",
    requiredData: ["visitId", "scheduledDate", "reminderTime"]
  },
  ["visit_started" /* VISIT_STARTED */]: {
    type: "visit_started" /* VISIT_STARTED */,
    name: "Visit Started",
    description: "Sent when a visit is started",
    channels: ["in_app" /* IN_APP */, "push" /* PUSH */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["crew" /* CREW */, "admin" /* ADMIN */],
    enabledByDefault: true,
    category: "scheduling",
    requiredData: ["visitId", "propertyAddress", "crewMemberId"],
    optionalData: ["customerName", "serviceType"]
  },
  ["visit_paused" /* VISIT_PAUSED */]: {
    type: "visit_paused" /* VISIT_PAUSED */,
    name: "Visit Paused",
    description: "Sent when a visit is paused",
    channels: ["in_app" /* IN_APP */, "push" /* PUSH */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["crew" /* CREW */, "admin" /* ADMIN */],
    enabledByDefault: true,
    category: "scheduling",
    requiredData: ["visitId", "propertyAddress", "crewMemberId"],
    optionalData: ["pauseReason"]
  },
  ["visit_resumed" /* VISIT_RESUMED */]: {
    type: "visit_resumed" /* VISIT_RESUMED */,
    name: "Visit Resumed",
    description: "Sent when a visit is resumed",
    channels: ["in_app" /* IN_APP */, "push" /* PUSH */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["crew" /* CREW */, "admin" /* ADMIN */],
    enabledByDefault: true,
    category: "scheduling",
    requiredData: ["visitId", "propertyAddress", "crewMemberId"]
  },
  ["visit_skipped" /* VISIT_SKIPPED */]: {
    type: "visit_skipped" /* VISIT_SKIPPED */,
    name: "Visit Skipped",
    description: "Sent to admins when a crew skips a visit, including the skip reason",
    channels: ["email" /* EMAIL */, "in_app" /* IN_APP */, "push" /* PUSH */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["crew" /* CREW */, "admin" /* ADMIN */],
    enabledByDefault: true,
    category: "scheduling",
    // Only the two fields the trigger can ALWAYS supply are required (RUT-2949).
    // `propertyAddress` and `crewMemberId` used to be required, but the skip
    // trigger never had a reliable crew member id and a rare visit can lack an
    // address — requiring them made the whole alert throw and silently no-op. The
    // body degrades gracefully when the address is absent.
    requiredData: ["visitId", "skipReason"],
    optionalData: ["customerName", "propertyAddress", "serviceName"],
    triggerEvents: ["visit.skipped"]
  },
  // Discard alert (RUT-3348). Mirrors VISIT_SKIPPED: a staff-only admin alert
  // carrying the discard reason. In-app + push always deliver; SMS is per-admin
  // opt-in through the 'discardedVisits' notification preference (defaults off),
  // the same lever pattern as first-in / last-out (RUT-1576). Staff-only
  // (ADMIN, no CUSTOMER) so the admin-preference SMS gate actually applies.
  ["visit_discarded" /* VISIT_DISCARDED */]: {
    type: "visit_discarded" /* VISIT_DISCARDED */,
    name: "Visit Discarded",
    description: "Sent to admins when a visit is discarded, including the discard reason",
    channels: ["in_app" /* IN_APP */, "push" /* PUSH */, "sms" /* SMS */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "scheduling",
    // Only the two fields the discard trigger can ALWAYS supply are required
    // (mirrors RUT-2949): the body degrades gracefully to the customer name,
    // then a generic phrase, when no address is present, so the alert can never
    // silently no-op on a missing required field.
    requiredData: ["visitId", "discardReason"],
    triggerEvents: ["visit.discarded"]
  },
  ["visit_completed" /* VISIT_COMPLETED */]: {
    type: "visit_completed" /* VISIT_COMPLETED */,
    name: "Visit Completed",
    description: "Sent when a service visit is completed",
    channels: ["email" /* EMAIL */, "sms" /* SMS */, "in_app" /* IN_APP */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["customer" /* CUSTOMER */],
    enabledByDefault: true,
    category: "scheduling",
    requiredData: ["visitId", "completedDate"],
    // `balanceDue` is a pre-formatted currency string ("$120.00"), supplied
    // only to customers who must act on the money — no payment method on file,
    // or a manual (check/cash) payer. Anyone who will be auto-charged, whether
    // on completion or in the overnight batch, is withheld from: a balance
    // would read as a bill for money already on its way out of their account.
    optionalData: ["invoiceId", "photos", "notes", "nextVisitDate", "completionInstructions", "serviceTemplateId", "customMessage", "balanceDue"],
    triggerEvents: ["visit.completed"]
  },
  ["visit_followup_created" /* VISIT_FOLLOWUP_CREATED */]: {
    type: "visit_followup_created" /* VISIT_FOLLOWUP_CREATED */,
    name: "Follow-up Visit Created",
    description: "Sent when a follow-up visit is automatically created by a service action",
    channels: ["sms" /* SMS */, "in_app" /* IN_APP */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["customer" /* CUSTOMER */],
    enabledByDefault: true,
    category: "scheduling",
    requiredData: ["visitId", "customerId", "actionName"],
    optionalData: ["actionMessage", "actionMessage_es", "originalVisitId"],
    triggerEvents: ["action.followup_created"]
  },
  ["visit_notes_added" /* VISIT_NOTES_ADDED */]: {
    type: "visit_notes_added" /* VISIT_NOTES_ADDED */,
    name: "Visit Notes Added",
    description: "Sent to admins when crew adds a visit note the office can see on the visit",
    channels: ["in_app" /* IN_APP */, "push" /* PUSH */, "sms" /* SMS */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "scheduling",
    requiredData: ["visitId", "customerId", "customerName"],
    optionalData: ["noteCount", "addedBy", "contentDescription", "propertyAddress"]
  },
  ["visit_photos_added" /* VISIT_PHOTOS_ADDED */]: {
    type: "visit_photos_added" /* VISIT_PHOTOS_ADDED */,
    name: "Visit Photos Added",
    description: "Sent to admins when crew adds photos to a visit; photos for the same visit accumulate into one notification",
    channels: ["in_app" /* IN_APP */],
    defaultPriority: "low" /* LOW */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "scheduling",
    requiredData: ["visitId", "customerId", "customerName"],
    optionalData: ["photoCount", "addedBy", "contentDescription", "propertyAddress"],
    batchable: true
  },
  ["visit_photo_approval_needed" /* VISIT_PHOTO_APPROVAL_NEEDED */]: {
    type: "visit_photo_approval_needed" /* VISIT_PHOTO_APPROVAL_NEEDED */,
    name: "Visit Photo Needs Approval",
    description: "HISTORICAL \u2014 no longer sent since the approval hold was removed (RUT-3528). Kept so notifications delivered before then still render in admin feeds",
    channels: ["in_app" /* IN_APP */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "scheduling",
    requiredData: ["visitId", "customerId", "customerName"],
    optionalData: ["photoCount", "addedBy", "contentDescription"],
    batchable: true
  },
  ["followup_visit_completed" /* FOLLOWUP_VISIT_COMPLETED */]: {
    type: "followup_visit_completed" /* FOLLOWUP_VISIT_COMPLETED */,
    name: "Follow-up Visit Completed",
    description: "Sent to admins when a follow-up visit with notification enabled is completed",
    channels: ["in_app" /* IN_APP */, "push" /* PUSH */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "scheduling",
    requiredData: ["visitId", "customerName", "serviceName"],
    optionalData: ["completedAt"],
    triggerEvents: ["visit.followup_completed"]
  },
  ["visit_completed_reminder" /* VISIT_COMPLETED_REMINDER */]: {
    type: "visit_completed_reminder" /* VISIT_COMPLETED_REMINDER */,
    name: "Visit Completion Reminder",
    description: "Sent to admins when a visit they opted into (per visit or per service) is completed",
    channels: ["in_app" /* IN_APP */, "push" /* PUSH */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "scheduling",
    requiredData: ["visitId", "customerName", "serviceName"],
    // fromVisitBell/armedByName/armedOn explain why the alert arrived (RUT-2933).
    optionalData: ["completedAt", "fromVisitBell", "armedByName", "armedOn"],
    triggerEvents: ["visit.completed"]
  },
  ["visit_cancelled" /* VISIT_CANCELLED */]: {
    type: "visit_cancelled" /* VISIT_CANCELLED */,
    name: "Visit Cancelled",
    description: "Sent when a visit is cancelled",
    channels: ["in_app" /* IN_APP */, "push" /* PUSH */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["crew" /* CREW */, "admin" /* ADMIN */],
    enabledByDefault: true,
    category: "scheduling",
    requiredData: ["visitId", "cancelledDate", "reason"]
  },
  ["visit_rescheduled" /* VISIT_RESCHEDULED */]: {
    type: "visit_rescheduled" /* VISIT_RESCHEDULED */,
    name: "Visit Rescheduled",
    description: "Sent when a visit is rescheduled",
    channels: ["email" /* EMAIL */, "sms" /* SMS */, "in_app" /* IN_APP */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["customer" /* CUSTOMER */, "crew" /* CREW */],
    enabledByDefault: true,
    category: "scheduling",
    requiredData: ["visitId", "oldDate", "newDate"]
  },
  ["visit_priority_set" /* VISIT_PRIORITY_SET */]: {
    type: "visit_priority_set" /* VISIT_PRIORITY_SET */,
    name: "Visit Priority Set",
    description: "Sent when a visit is marked as high priority",
    channels: ["in_app" /* IN_APP */, "push" /* PUSH */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["crew" /* CREW */],
    enabledByDefault: true,
    category: "scheduling",
    requiredData: ["visitId", "customerId", "customerName"],
    optionalData: ["serviceName", "customerAddress"],
    triggerEvents: ["visit.priority.set"]
  },
  ["visit_priority_reminder" /* VISIT_PRIORITY_REMINDER */]: {
    type: "visit_priority_reminder" /* VISIT_PRIORITY_REMINDER */,
    name: "Visit Priority Reminder",
    description: "Sent each morning a priority visit's reminder date arrives",
    channels: ["in_app" /* IN_APP */, "push" /* PUSH */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["crew" /* CREW */],
    enabledByDefault: true,
    category: "scheduling",
    requiredData: ["visitId", "customerId", "customerName"],
    optionalData: ["serviceName", "priorityNote"],
    triggerEvents: ["visit.priority.reminder"]
  },
  // Crew Management Notifications
  ["crew_assigned" /* CREW_ASSIGNED */]: {
    type: "crew_assigned" /* CREW_ASSIGNED */,
    name: "Crew Assigned",
    description: "Sent when crew is assigned to a job",
    channels: ["in_app" /* IN_APP */, "push" /* PUSH */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["crew" /* CREW */],
    enabledByDefault: true,
    category: "crew",
    requiredData: ["crewId", "jobId", "assignmentDate"]
  },
  ["crew_registration" /* CREW_REGISTRATION */]: {
    type: "crew_registration" /* CREW_REGISTRATION */,
    name: "Crew Registration",
    description: "Sent to admins when new crew member registers",
    channels: ["email" /* EMAIL */, "in_app" /* IN_APP */, "push" /* PUSH */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "crew",
    requiredData: ["crewMemberId", "memberName", "registrationDate"],
    triggerEvents: ["crew.member_registered"]
  },
  ["crew_clock_in" /* CREW_CLOCK_IN */]: {
    type: "crew_clock_in" /* CREW_CLOCK_IN */,
    name: "Crew Clock In",
    description: "Sent when crew member clocks in",
    channels: ["in_app" /* IN_APP */],
    defaultPriority: "low" /* LOW */,
    targetRoles: ["admin" /* ADMIN */, "crew" /* CREW */],
    enabledByDefault: false,
    category: "crew",
    requiredData: ["crewMemberId", "clockInTime", "location"],
    triggerEvents: ["crew.clock_in"],
    batchable: true
  },
  ["crew_clock_out" /* CREW_CLOCK_OUT */]: {
    type: "crew_clock_out" /* CREW_CLOCK_OUT */,
    name: "Crew Clock Out",
    description: "Sent when crew member clocks out",
    channels: ["in_app" /* IN_APP */],
    defaultPriority: "low" /* LOW */,
    targetRoles: ["admin" /* ADMIN */, "crew" /* CREW */],
    enabledByDefault: false,
    category: "crew",
    requiredData: ["crewMemberId", "clockOutTime", "hoursWorked"],
    triggerEvents: ["crew.clock_out"],
    batchable: true
  },
  ["crew_bulk_clock_out" /* CREW_BULK_CLOCK_OUT */]: {
    type: "crew_bulk_clock_out" /* CREW_BULK_CLOCK_OUT */,
    name: "Crew Bulk Clock Out",
    description: "Sent when an admin clocks out several crew members at once",
    channels: ["in_app" /* IN_APP */],
    defaultPriority: "low" /* LOW */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: false,
    category: "crew",
    requiredData: ["clockedOutCount"],
    triggerEvents: ["crew.bulk_clock_out"],
    batchable: false
  },
  ["crew_new_visit_scheduled" /* CREW_NEW_VISIT_SCHEDULED */]: {
    type: "crew_new_visit_scheduled" /* CREW_NEW_VISIT_SCHEDULED */,
    name: "New Service on Crew List",
    description: "Sent to a crew when a new service lands on their list",
    channels: ["push" /* PUSH */, "in_app" /* IN_APP */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["crew" /* CREW */],
    enabledByDefault: true,
    category: "crew",
    // The address is a nicety, not a gate: requiring it made the whole alert
    // fail validation for address-less visits (and, while the sender read a
    // field visits don't carry, for every visit — the alert never sent at
    // all). The copy falls back to the customer name instead.
    requiredData: ["customerName", "serviceType"],
    optionalData: ["serviceAddress", "crewName", "visitId"],
    triggerEvents: ["visit.created"]
  },
  // RUT-3592: an assessment landing on a crew's list gets its own badge, but the
  // same body as a regular new visit.
  ["crew_assessment_created" /* CREW_ASSESSMENT_CREATED */]: {
    type: "crew_assessment_created" /* CREW_ASSESSMENT_CREATED */,
    name: "Assessment Created",
    description: "Sent to a crew when a new assessment lands on their list",
    channels: ["push" /* PUSH */, "in_app" /* IN_APP */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["crew" /* CREW */],
    enabledByDefault: true,
    category: "crew",
    requiredData: ["customerName", "serviceType"],
    optionalData: ["serviceAddress", "crewName", "visitId"],
    triggerEvents: ["visit.created"]
  },
  ["crew_dispatch_executed" /* CREW_DISPATCH_EXECUTED */]: {
    type: "crew_dispatch_executed" /* CREW_DISPATCH_EXECUTED */,
    name: "Crew Dispatch Executed",
    description: "Sent to admins when a crew leader dispatches visits from mobile",
    channels: ["in_app" /* IN_APP */, "push" /* PUSH */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "crew",
    requiredData: ["crewId", "crewLeaderName", "subscriptionsDispatched", "scheduledDate"]
  },
  ["crew_auto_assigned" /* CREW_AUTO_ASSIGNED */]: {
    type: "crew_auto_assigned" /* CREW_AUTO_ASSIGNED */,
    name: "Crew Auto-Assigned",
    description: "Sent to admins when a crew is auto-assigned to a new service",
    channels: ["in_app" /* IN_APP */],
    defaultPriority: "low" /* LOW */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "crew",
    requiredData: ["subscriptionId", "customerId", "customerName", "serviceTemplateName", "crewId", "crewName", "fromServiceTemplateName"]
  },
  ["crew_assignment_conflict" /* CREW_ASSIGNMENT_CONFLICT */]: {
    type: "crew_assignment_conflict" /* CREW_ASSIGNMENT_CONFLICT */,
    name: "Crew Assignment Conflict",
    description: "Sent to admins when auto-assignment fails due to multiple crews",
    channels: ["in_app" /* IN_APP */, "email" /* EMAIL */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "crew",
    requiredData: ["subscriptionId", "customerId", "customerName", "serviceTemplateName", "relatedCrews"]
  },
  ["crew_service_removed" /* CREW_SERVICE_REMOVED */]: {
    type: "crew_service_removed" /* CREW_SERVICE_REMOVED */,
    name: "Service Removed from Crew",
    description: "Sent to crew leaders when a service is removed from their crew",
    channels: ["push" /* PUSH */, "in_app" /* IN_APP */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["crew" /* CREW */],
    enabledByDefault: true,
    category: "crew",
    requiredData: ["customerName", "serviceType"],
    triggerEvents: ["subscription.crew_unassigned"]
  },
  ["crew_service_deactivated" /* CREW_SERVICE_DEACTIVATED */]: {
    type: "crew_service_deactivated" /* CREW_SERVICE_DEACTIVATED */,
    name: "In-Season Service Deactivated",
    description: "Sent to a crew leader when an in-season service assigned to their crew is deactivated",
    channels: ["push" /* PUSH */, "in_app" /* IN_APP */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["crew" /* CREW */],
    enabledByDefault: true,
    category: "crew",
    requiredData: ["customerName", "serviceType", "effectiveDate"],
    triggerEvents: ["subscription.deactivated"]
  },
  ["crew_visits_dispatched" /* CREW_VISITS_DISPATCHED */]: {
    type: "crew_visits_dispatched" /* CREW_VISITS_DISPATCHED */,
    name: "Bulk Visits Dispatched",
    description: "Sent to crew leaders when bulk visits are dispatched to their crew",
    channels: ["push" /* PUSH */, "in_app" /* IN_APP */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["crew" /* CREW */],
    enabledByDefault: true,
    category: "crew",
    requiredData: ["crewId", "visitCount"],
    optionalData: ["jobId"],
    triggerEvents: ["dispatch.crew_visits_dispatched"]
  },
  ["crew_member_added" /* CREW_MEMBER_ADDED */]: {
    type: "crew_member_added" /* CREW_MEMBER_ADDED */,
    name: "Crew Member Added",
    description: "Sent to admins when a member is added to a crew",
    channels: ["in_app" /* IN_APP */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "crew",
    requiredData: ["memberName", "crewName", "crewRole"],
    triggerEvents: ["crew.member_added"]
  },
  ["crew_inactive_2h" /* CREW_INACTIVE_2H */]: {
    type: "crew_inactive_2h" /* CREW_INACTIVE_2H */,
    name: "Crew Member Inactive 2h",
    description: "Sent to admins when a clocked-in crew member has had no activity for over two hours",
    channels: ["in_app" /* IN_APP */, "push" /* PUSH */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "crew",
    requiredData: ["crewMemberId", "memberName", "inactiveSinceIso", "inactiveMinutes"]
  },
  ["crew_location_dropped" /* CREW_LOCATION_DROPPED */]: {
    type: "crew_location_dropped" /* CREW_LOCATION_DROPPED */,
    name: "Crew Location Tracking Dropped",
    description: "Admin alert when a clocked-in crew member is location-dark and the office can name a fix \u2014 permission off, or the phone reached us after location went quiet (RUT-3395). Never-shared / silence-alone cases are not sent. Older stored payloads may still use the RUT-3172 never-shared / this-shift flags.",
    channels: ["in_app" /* IN_APP */, "push" /* PUSH */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "crew",
    requiredData: ["crewMemberId", "memberName", "minutesSincePing"],
    // Boolean flags stay OPTIONAL on purpose (RUT-3172 / RUT-3395):
    // validateNotificationData treats any falsy value as missing, so a boolean
    // that is legitimately `false` would block the alert entirely.
    optionalData: [
      "noLocationThisShift",
      "noLocationOnRecord",
      "minutesSinceClockIn",
      "permissionOff",
      "phoneOnlineAfterSilence",
      "lastKnownAt"
    ]
  },
  ["crew_left_geofence" /* CREW_LEFT_GEOFENCE */]: {
    type: "crew_left_geofence" /* CREW_LEFT_GEOFENCE */,
    name: "Crew Left Visit Property Without Clocking Out",
    description: "Sent to admins when a crew member on an in-progress visit has been continuously outside the visit's property for a while without clocking out \u2014 they likely left without finishing the visit.",
    channels: ["in_app" /* IN_APP */, "push" /* PUSH */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "crew",
    requiredData: ["crewMemberId", "memberName", "visitId", "customerName", "minutesOutside"]
  },
  // Office alert when a crew phone's store binary is below the oldest supported
  // release — the phone can no longer receive OTAs, so the in-app update prompt
  // never arrives and someone has to chase the store install (RUT-3583).
  ["crew_app_outdated" /* CREW_APP_OUTDATED */]: {
    type: "crew_app_outdated" /* CREW_APP_OUTDATED */,
    name: "Crew App Needs Store Update",
    description: "Sent to admins when a crew member's phone is running a store binary older than the oldest supported release. Over-the-air updates can no longer reach that phone \u2014 the office needs to get them to update from the App Store or Play Store (RUT-3583).",
    channels: ["in_app" /* IN_APP */, "push" /* PUSH */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "crew",
    requiredData: ["crewMemberId", "memberName", "appVersion", "minSupportedAppVersion"]
  },
  // Optional admin alert when a crew member acknowledges an urgent message
  // ("nudge") — off by default, gated by the org-level crewAckAlertSettings
  // lever (RUT-2925). requiredData is intentionally empty so the alert can
  // never be silently swallowed after its idempotency key is reserved (RUT-2929).
  ["crew_urgent_message_acknowledged" /* CREW_URGENT_MESSAGE_ACKNOWLEDGED */]: {
    type: "crew_urgent_message_acknowledged" /* CREW_URGENT_MESSAGE_ACKNOWLEDGED */,
    name: "Crew Acknowledged Urgent Message",
    description: "Sent to admins when a crew member acknowledges an urgent message, when enabled",
    channels: ["in_app" /* IN_APP */],
    defaultPriority: "low" /* LOW */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "crew",
    requiredData: []
  },
  // Optional admin alert when a crew member acknowledges a note — off by
  // default, gated by the org-level crewAckAlertSettings lever (RUT-2925).
  ["crew_note_acknowledged" /* CREW_NOTE_ACKNOWLEDGED */]: {
    type: "crew_note_acknowledged" /* CREW_NOTE_ACKNOWLEDGED */,
    name: "Crew Acknowledged Note",
    description: "Sent to admins when a crew member acknowledges a note, when enabled",
    channels: ["in_app" /* IN_APP */],
    defaultPriority: "low" /* LOW */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "crew",
    requiredData: []
  },
  // First-in / last-out org edges (RUT-1576, reframed by RUT-3991). Off unless
  // the org turns them on. They repeat whenever the org count crosses 0↔≥1.
  // SMS is carried so the office can get them outside Ruta — the text itself
  // is still per-person opt-in through the 'teamDayAlerts' preference.
  ["team_day_started" /* TEAM_DAY_STARTED */]: {
    type: "team_day_started" /* TEAM_DAY_STARTED */,
    name: "First Team Member Clocked In",
    description: "Sent to admins when the first team member clocks in (org 0 \u2192 \u22651), when enabled",
    channels: ["in_app" /* IN_APP */, "sms" /* SMS */],
    defaultPriority: "low" /* LOW */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "crew",
    requiredData: ["clockInTime"]
  },
  ["team_day_ended" /* TEAM_DAY_ENDED */]: {
    type: "team_day_ended" /* TEAM_DAY_ENDED */,
    name: "Last Team Member Clocked Out",
    description: "Sent to admins when the last clocked-in team member clocks out (org \u22651 \u2192 0), when enabled",
    channels: ["in_app" /* IN_APP */, "sms" /* SMS */],
    defaultPriority: "low" /* LOW */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "crew",
    requiredData: ["clockOutTime"]
  },
  ["one_time_deadline_at_risk" /* ONE_TIME_DEADLINE_AT_RISK */]: {
    type: "one_time_deadline_at_risk" /* ONE_TIME_DEADLINE_AT_RISK */,
    name: "One-Time Service Deadline At Risk",
    description: "Sent to admins when a one-time service's do-by deadline is approaching (or passed) and no visit has been scheduled yet",
    channels: ["in_app" /* IN_APP */, "push" /* PUSH */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "service",
    requiredData: ["customerId", "customerName", "serviceName", "dueDate"]
  },
  // Payment & Invoice Notifications
  ["payment_successful" /* PAYMENT_SUCCESSFUL */]: {
    type: "payment_successful" /* PAYMENT_SUCCESSFUL */,
    name: "Payment Successful",
    description: "Sent when payment is processed successfully",
    channels: ["email" /* EMAIL */, "sms" /* SMS */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["customer" /* CUSTOMER */],
    enabledByDefault: true,
    category: "payments",
    requiredData: ["invoiceId", "amount", "paymentDate"],
    optionalData: ["receiptUrl"]
  },
  // The office-facing counterpart to PAYMENT_SUCCESSFUL (which goes to the
  // customer). In-app only — money landing is a "glance at the screen" event,
  // not something worth an email or an SMS per visit (RUT-3168).
  ["visit_payment_received" /* VISIT_PAYMENT_RECEIVED */]: {
    type: "visit_payment_received" /* VISIT_PAYMENT_RECEIVED */,
    name: "Payment Received",
    description: "Sent to admins when a visit is paid",
    channels: ["in_app" /* IN_APP */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "payments",
    requiredData: ["customerName", "amount"],
    optionalData: ["serviceName", "paymentMethodType", "paymentMethodLast4"]
  },
  ["batch_charge_completed" /* BATCH_CHARGE_COMPLETED */]: {
    type: "batch_charge_completed" /* BATCH_CHARGE_COMPLETED */,
    name: "Nightly Charges Complete",
    description: "Sent to admins when a scheduled charge run \u2014 overnight, the morning retry, or package charging \u2014 finishes for the organization",
    channels: ["in_app" /* IN_APP */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "payments",
    requiredData: ["chargedCustomers", "chargedVisits", "totalCollected"],
    optionalData: ["failedCustomers", "isRetry", "isPackage", "failedNames", "skippedCount"]
  },
  ["payment_failed" /* PAYMENT_FAILED */]: {
    type: "payment_failed" /* PAYMENT_FAILED */,
    name: "Payment Failed",
    description: "Sent when payment processing fails",
    channels: ["email" /* EMAIL */, "sms" /* SMS */, "in_app" /* IN_APP */],
    defaultPriority: "urgent" /* URGENT */,
    targetRoles: ["customer" /* CUSTOMER */, "admin" /* ADMIN */],
    enabledByDefault: true,
    category: "payments",
    // invoiceId is optional: batch charges group multiple visits under a batchId and
    // have no single invoice. The templates render invoiceId conditionally, so the
    // alert degrades gracefully without it (customer, amount, reason still show).
    requiredData: ["amount", "failureReason"],
    optionalData: ["invoiceId", "retryUrl"],
    triggerEvents: ["payment.failed"]
  },
  // No card on file + a balance owed (RUT-4519). Customer email/SMS only.
  // A no-card charge event sends this instead of PAYMENT_FAILED.
  ["customer_add_card_reminder" /* CUSTOMER_ADD_CARD_REMINDER */]: {
    type: "customer_add_card_reminder" /* CUSTOMER_ADD_CARD_REMINDER */,
    name: "Add a Card Reminder",
    description: "Sent when a charge is skipped because the customer has no card on file and still owes a balance",
    channels: ["email" /* EMAIL */, "sms" /* SMS */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["customer" /* CUSTOMER */],
    enabledByDefault: true,
    category: "payments",
    requiredData: ["balanceDue"],
    optionalData: ["addCardLink", "orgPhone"]
  },
  ["payment_retry" /* PAYMENT_RETRY */]: {
    type: "payment_retry" /* PAYMENT_RETRY */,
    name: "Payment Retry",
    description: "Reminder to retry failed payment",
    channels: ["email" /* EMAIL */, "sms" /* SMS */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["customer" /* CUSTOMER */],
    enabledByDefault: true,
    category: "payments",
    requiredData: ["invoiceId", "amount", "retryCount"]
  },
  ["payment_overdue" /* PAYMENT_OVERDUE */]: {
    type: "payment_overdue" /* PAYMENT_OVERDUE */,
    name: "Payment Overdue",
    description: "Sent when payment is overdue",
    channels: ["email" /* EMAIL */, "in_app" /* IN_APP */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["customer" /* CUSTOMER */, "admin" /* ADMIN */],
    enabledByDefault: true,
    category: "payments",
    requiredData: ["invoiceId", "amount", "daysOverdue"]
  },
  ["invoice_ready" /* INVOICE_READY */]: {
    type: "invoice_ready" /* INVOICE_READY */,
    name: "Invoice Ready",
    description: "Sent when invoice is ready for viewing",
    channels: ["email" /* EMAIL */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["customer" /* CUSTOMER */],
    enabledByDefault: true,
    category: "payments",
    requiredData: ["invoiceId", "invoiceNumber", "amount"],
    optionalData: ["downloadUrl"]
  },
  ["payment_method_added" /* PAYMENT_METHOD_ADDED */]: {
    type: "payment_method_added" /* PAYMENT_METHOD_ADDED */,
    name: "Payment Method Added",
    description: "Sent to admins when a customer adds their first payment method",
    channels: ["in_app" /* IN_APP */, "push" /* PUSH */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "payments",
    requiredData: ["customerId", "customerName", "paymentMethodType"],
    optionalData: ["brand"]
  },
  // Service Management Notifications
  ["service_completed" /* SERVICE_COMPLETED */]: {
    type: "service_completed" /* SERVICE_COMPLETED */,
    name: "Service Completed",
    description: "Sent when a service is completed",
    channels: ["email" /* EMAIL */, "sms" /* SMS */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["customer" /* CUSTOMER */],
    enabledByDefault: true,
    category: "service",
    requiredData: ["serviceId", "completionDate"]
  },
  ["service_activated" /* SERVICE_ACTIVATED */]: {
    type: "service_activated" /* SERVICE_ACTIVATED */,
    name: "Service Activated",
    description: "Sent when a service is activated",
    channels: ["email" /* EMAIL */, "sms" /* SMS */, "in_app" /* IN_APP */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["customer" /* CUSTOMER */],
    enabledByDefault: true,
    category: "service",
    requiredData: ["subscriptionId", "serviceName", "startDate"],
    triggerEvents: ["subscription.activated"]
  },
  ["service_enrollment_scheduled" /* SERVICE_ENROLLMENT_SCHEDULED */]: {
    type: "service_enrollment_scheduled" /* SERVICE_ENROLLMENT_SCHEDULED */,
    name: "Service Starting Later",
    description: "Sent when a customer or the office activates a service that starts on a later date",
    // IN_APP only: the ticket is the customer-thread row. An SMS template still
    // exists so createConversationMessage can render the thread copy. Do not
    // put EMAIL/SMS on channels — that would text "is now active"-adjacent copy
    // while the service is still held.
    channels: ["in_app" /* IN_APP */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["customer" /* CUSTOMER */],
    enabledByDefault: true,
    category: "service",
    requiredData: ["subscriptionId", "serviceName", "startDate"],
    triggerEvents: ["subscription.enrollment_scheduled"]
  },
  ["service_suspended" /* SERVICE_SUSPENDED */]: {
    type: "service_suspended" /* SERVICE_SUSPENDED */,
    name: "Service Suspended",
    description: "Sent when a service is suspended",
    channels: ["email" /* EMAIL */, "in_app" /* IN_APP */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["customer" /* CUSTOMER */, "admin" /* ADMIN */],
    enabledByDefault: true,
    category: "service",
    requiredData: ["subscriptionId", "suspendReason"]
  },
  ["service_cancelled" /* SERVICE_CANCELLED */]: {
    type: "service_cancelled" /* SERVICE_CANCELLED */,
    name: "Service Deactivated",
    description: "Sent when a service is deactivated",
    channels: ["email" /* EMAIL */, "sms" /* SMS */, "in_app" /* IN_APP */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["customer" /* CUSTOMER */, "admin" /* ADMIN */],
    enabledByDefault: true,
    category: "service",
    // Only advertise variables that are actually populated when this notification
    // is sent. `serviceName`/`cancelDate` come from the dispatch `data`;
    // `customerFirstName`, `orgName`, and `portalLink` are enriched from the
    // customer/org context at send time. `subscriptionId` is supplied for routing
    // only and is never rendered into customer-facing copy, so it is intentionally
    // not offered to the template editor. `cancellationReason` is not supplied
    // and must not be offered. `cancellationDate` is filled at send/render as
    // an alias of `cancelDate` so existing org templates do not print
    // "deactivated effective ." (RUT-2435 / RUT-4238); the editor still only
    // offers `cancelDate`.
    requiredData: ["serviceName", "cancelDate"],
    optionalData: ["customerFirstName", "orgName", "customMessage", "portalLink"],
    triggerEvents: ["subscription.cancelled"]
  },
  ["service_deactivation_completed" /* SERVICE_DEACTIVATION_COMPLETED */]: {
    type: "service_deactivation_completed" /* SERVICE_DEACTIVATION_COMPLETED */,
    name: "Scheduled Deactivation Completed",
    description: "Sent to admins \u2014 and the leaders of the assigned crew, when one exists \u2014 when a service that was scheduled to deactivate reaches its date and is deactivated",
    channels: ["in_app" /* IN_APP */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["admin" /* ADMIN */, "crew" /* CREW */],
    enabledByDefault: true,
    category: "service",
    requiredData: ["serviceName", "customerName", "deactivatedDate"],
    triggerEvents: ["subscription.scheduled_deactivation_completed"]
  },
  // Subscription Notifications
  ["subscription_requested" /* SUBSCRIPTION_REQUESTED */]: {
    type: "subscription_requested" /* SUBSCRIPTION_REQUESTED */,
    name: "Service Rate Requested",
    description: "Sent to admins when a customer requests a rate for a new service",
    channels: ["email" /* EMAIL */, "in_app" /* IN_APP */, "push" /* PUSH */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "service",
    requiredData: ["subscriptionId", "customerName", "serviceTemplateName"],
    optionalData: ["customerNotes"],
    triggerEvents: ["subscription.requested"],
    bypassKillSwitch: true
  },
  ["subscription_rate_provided" /* SUBSCRIPTION_RATE_PROVIDED */]: {
    type: "subscription_rate_provided" /* SUBSCRIPTION_RATE_PROVIDED */,
    name: "Service Rate Provided",
    description: "Sent when a rate is provided for a service",
    channels: ["email" /* EMAIL */, "sms" /* SMS */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["customer" /* CUSTOMER */],
    enabledByDefault: true,
    category: "service",
    requiredData: ["subscriptionId", "serviceTemplateName"],
    optionalData: ["customMessage", "adminNotes", "rate"]
  },
  ["subscription_batch_rates_released" /* SUBSCRIPTION_BATCH_RATES_RELEASED */]: {
    type: "subscription_batch_rates_released" /* SUBSCRIPTION_BATCH_RATES_RELEASED */,
    name: "Service Rates Sent",
    description: "Sent to a customer when rates for several of their services are sent at once",
    channels: ["email" /* EMAIL */, "sms" /* SMS */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["customer" /* CUSTOMER */],
    enabledByDefault: true,
    category: "service",
    requiredData: ["subscriptions", "customerName"],
    // `pendingRatesNote` carries the "still finalizing X rates" sentence for a
    // service the same customer asked about whose rate isn't ready to send yet
    // (RUT-2614), so they get one message instead of two. Absent = renders nothing.
    optionalData: ["customMessage", "pendingRatesNote"],
    triggerEvents: ["subscription.batch_rates_released"],
    batchable: false,
    bypassKillSwitch: true
  },
  // Automatic acknowledgment when a customer asks for a rate on a service whose
  // rates aren't ready to send yet (RUT-2614). Usually triggered by the request
  // itself, when nothing else they asked for is sendable — but held a couple of
  // minutes before it goes out, so that somebody clicking through several
  // services gets one message naming all of them rather than a text per click
  // (RUT-3372). It is also how the note reaches a customer whose org has
  // rewritten its rates-ready copy, where the note has no slot to ride along in;
  // that path is not held, since it is one deliberate act by the office. The send
  // records it in the customer's message history like every other automated
  // message.
  ["subscription_rate_not_yet_available" /* SUBSCRIPTION_RATE_NOT_YET_AVAILABLE */]: {
    type: "subscription_rate_not_yet_available" /* SUBSCRIPTION_RATE_NOT_YET_AVAILABLE */,
    name: "Rates Still Being Finalized",
    description: "Sent to a customer who requests a rate for a service whose rates aren't ready to send yet",
    channels: ["email" /* EMAIL */, "sms" /* SMS */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["customer" /* CUSTOMER */],
    enabledByDefault: true,
    category: "service",
    requiredData: ["pendingServiceNames"]
  },
  ["subscription_batch_cancelled" /* SUBSCRIPTION_BATCH_CANCELLED */]: {
    type: "subscription_batch_cancelled" /* SUBSCRIPTION_BATCH_CANCELLED */,
    name: "Multiple Services Deactivated",
    description: "Sent to a customer when several of their services are deactivated at once",
    channels: ["email" /* EMAIL */, "sms" /* SMS */, "in_app" /* IN_APP */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["customer" /* CUSTOMER */],
    enabledByDefault: true,
    category: "service",
    requiredData: ["subscriptions", "cancellationReason"],
    optionalData: ["cancellationDate", "customerFirstName", "customerLastName", "customMessage"],
    triggerEvents: ["subscription.batch_cancelled"]
  },
  ["subscription_accepted" /* SUBSCRIPTION_ACCEPTED */]: {
    type: "subscription_accepted" /* SUBSCRIPTION_ACCEPTED */,
    name: "Service Accepted",
    description: "Sent when a customer accepts a service",
    channels: ["email" /* EMAIL */, "in_app" /* IN_APP */, "push" /* PUSH */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "service",
    requiredData: ["subscriptionId", "customerName", "serviceTemplateName"],
    optionalData: ["acceptedChoices", "customerNotes", "startDate"],
    triggerEvents: ["subscription.accepted"],
    bypassKillSwitch: true
  },
  ["subscription_paused" /* SUBSCRIPTION_PAUSED */]: {
    type: "subscription_paused" /* SUBSCRIPTION_PAUSED */,
    name: "Service Paused",
    description: "Sent when a service is paused",
    channels: ["email" /* EMAIL */, "sms" /* SMS */, "in_app" /* IN_APP */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["customer" /* CUSTOMER */],
    enabledByDefault: true,
    category: "service",
    requiredData: ["serviceName", "pausedAt"],
    optionalData: ["pausedUntil", "customerName"],
    triggerEvents: ["subscription.paused"]
  },
  ["subscription_resumed" /* SUBSCRIPTION_RESUMED */]: {
    type: "subscription_resumed" /* SUBSCRIPTION_RESUMED */,
    name: "Service Resumed",
    description: "Sent when a paused service is resumed",
    channels: ["email" /* EMAIL */, "sms" /* SMS */, "in_app" /* IN_APP */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["customer" /* CUSTOMER */],
    enabledByDefault: true,
    category: "service",
    requiredData: ["serviceName"],
    optionalData: ["previousPausedUntil", "customerName"],
    triggerEvents: ["subscription.resumed"]
  },
  ["subscription_notes_updated" /* SUBSCRIPTION_NOTES_UPDATED */]: {
    type: "subscription_notes_updated" /* SUBSCRIPTION_NOTES_UPDATED */,
    name: "Customer Notes Updated",
    description: "Sent to admins when a customer updates their notes or photos on a service",
    channels: ["in_app" /* IN_APP */, "push" /* PUSH */],
    defaultPriority: "low" /* LOW */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "service",
    requiredData: ["subscriptionId", "customerName", "serviceTemplateName"],
    optionalData: ["hasNotes", "attachmentCount", "contentDescription"],
    triggerEvents: ["subscription.notes_updated"]
  },
  ["subscription_customer_selections_changed" /* SUBSCRIPTION_CUSTOMER_SELECTIONS_CHANGED */]: {
    type: "subscription_customer_selections_changed" /* SUBSCRIPTION_CUSTOMER_SELECTIONS_CHANGED */,
    name: "Customer Answers Changed",
    description: "Sent to admins and the assigned crew leader when a customer changes their answers on an active service",
    channels: ["in_app" /* IN_APP */, "push" /* PUSH */],
    defaultPriority: "low" /* LOW */,
    targetRoles: ["admin" /* ADMIN */, "crew" /* CREW */],
    enabledByDefault: true,
    category: "service",
    requiredData: ["subscriptionId", "customerName", "serviceTemplateName"],
    optionalData: ["changeCount"],
    triggerEvents: ["subscription.customer_selections_changed"]
  },
  ["subscription_package_option_changed" /* SUBSCRIPTION_PACKAGE_OPTION_CHANGED */]: {
    type: "subscription_package_option_changed" /* SUBSCRIPTION_PACKAGE_OPTION_CHANGED */,
    name: "Service Plan Changed",
    description: "Sent when a customer switches their service plan, for example from per-time to unlimited",
    channels: ["email" /* EMAIL */, "sms" /* SMS */, "in_app" /* IN_APP */, "push" /* PUSH */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["customer" /* CUSTOMER */, "admin" /* ADMIN */],
    enabledByDefault: true,
    category: "service",
    requiredData: ["subscriptionId", "customerName", "serviceTemplateName", "previousPlanName", "newPlanName"],
    optionalData: ["serviceName"],
    triggerEvents: ["subscription.package_option_changed"]
  },
  ["subscription_plan_change_requested" /* SUBSCRIPTION_PLAN_CHANGE_REQUESTED */]: {
    type: "subscription_plan_change_requested" /* SUBSCRIPTION_PLAN_CHANGE_REQUESTED */,
    name: "Plan Change Requested",
    description: "Sent to the office when a plan switch is staged. It stays on Home until confirm or cancel.",
    channels: ["email" /* EMAIL */, "in_app" /* IN_APP */, "push" /* PUSH */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "service",
    requiredData: ["subscriptionId", "customerName", "serviceTemplateName", "previousPlanName", "newPlanName"],
    optionalData: ["serviceName", "differenceLabel"],
    triggerEvents: ["subscription.plan_change_requested"]
  },
  // Job Management Notifications
  ["job_review_required" /* JOB_REVIEW_REQUIRED */]: {
    type: "job_review_required" /* JOB_REVIEW_REQUIRED */,
    name: "Job Review Required",
    description: "Sent when a job requires admin review",
    channels: ["email" /* EMAIL */, "in_app" /* IN_APP */, "push" /* PUSH */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "jobs",
    requiredData: ["jobId", "reviewReason"],
    triggerEvents: ["job.review_required"]
  },
  ["job_approved" /* JOB_APPROVED */]: {
    type: "job_approved" /* JOB_APPROVED */,
    name: "Job Approved",
    description: "Sent when a job is approved",
    channels: ["in_app" /* IN_APP */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["crew" /* CREW */],
    enabledByDefault: true,
    category: "jobs",
    requiredData: ["jobId", "approvedBy"]
  },
  ["job_rejected" /* JOB_REJECTED */]: {
    type: "job_rejected" /* JOB_REJECTED */,
    name: "Job Rejected",
    description: "Sent when a job is rejected",
    channels: ["in_app" /* IN_APP */, "email" /* EMAIL */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["crew" /* CREW */],
    enabledByDefault: true,
    category: "jobs",
    requiredData: ["jobId", "rejectionReason"]
  },
  // System & Admin Notifications
  ["system_alert" /* SYSTEM_ALERT */]: {
    type: "system_alert" /* SYSTEM_ALERT */,
    name: "System Alert",
    description: "Critical system alerts",
    channels: ["email" /* EMAIL */, "sms" /* SMS */, "in_app" /* IN_APP */],
    defaultPriority: "urgent" /* URGENT */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "system",
    requiredData: ["alertType", "message"]
  },
  ["account_update" /* ACCOUNT_UPDATE */]: {
    type: "account_update" /* ACCOUNT_UPDATE */,
    name: "Account Update",
    description: "Account information updates",
    channels: ["email" /* EMAIL */],
    defaultPriority: "low" /* LOW */,
    targetRoles: ["admin" /* ADMIN */, "customer" /* CUSTOMER */],
    enabledByDefault: true,
    category: "system",
    requiredData: ["updateType", "details"]
  },
  ["organization_update" /* ORGANIZATION_UPDATE */]: {
    type: "organization_update" /* ORGANIZATION_UPDATE */,
    name: "Organization Update",
    description: "Organization-wide updates",
    channels: ["email" /* EMAIL */, "in_app" /* IN_APP */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "system",
    requiredData: ["updateType", "details"]
  },
  ["holiday_delay_warning" /* HOLIDAY_DELAY_WARNING */]: {
    type: "holiday_delay_warning" /* HOLIDAY_DELAY_WARNING */,
    name: "Upcoming Holiday",
    description: "Sent to the office a week before a US federal holiday, when that week's service schedule is likely to slip",
    channels: ["email" /* EMAIL */, "in_app" /* IN_APP */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "system",
    requiredData: ["holidayName", "holidayDate"],
    // Not required: the validator treats any falsy value as missing, and a
    // count of days is a field that could legitimately be zero.
    optionalData: ["daysUntilHoliday"]
  },
  ["customer_welcome" /* CUSTOMER_WELCOME */]: {
    type: "customer_welcome" /* CUSTOMER_WELCOME */,
    name: "Customer Welcome",
    // RUT-3371: the greeting now hangs off the customer creating their profile,
    // not off their first rate request — a customer who registers and never asks
    // for a rate used to hear nothing at all. It carries NO rate-request wording;
    // that moved to CUSTOMER_RATE_REQUEST_RECEIVED.
    description: "Sent to a customer when they finish creating their profile",
    channels: ["email" /* EMAIL */, "sms" /* SMS */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["customer" /* CUSTOMER */],
    enabledByDefault: true,
    category: "messaging",
    requiredData: ["customerName"],
    optionalData: ["orgName", "ownerName", "portalLink"]
  },
  // Customer-facing acknowledgement of a rate request (RUT-3371). Everything the
  // old welcome said about pricing lives here now, so the two messages never say
  // the same thing.
  ["customer_rate_request_received" /* CUSTOMER_RATE_REQUEST_RECEIVED */]: {
    type: "customer_rate_request_received" /* CUSTOMER_RATE_REQUEST_RECEIVED */,
    name: "Rate Request Received",
    description: "Sent to a customer to confirm their rate request reached the office",
    channels: ["email" /* EMAIL */, "sms" /* SMS */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["customer" /* CUSTOMER */],
    enabledByDefault: true,
    category: "rate_pricing",
    requiredData: ["customerName"],
    optionalData: ["serviceTemplateName", "orgName", "portalLink"]
  },
  // Customer Portal Notifications
  ["customer_portal_registered" /* CUSTOMER_PORTAL_REGISTERED */]: {
    type: "customer_portal_registered" /* CUSTOMER_PORTAL_REGISTERED */,
    name: "Customer Portal Registration",
    description: "Sent to admins when a new customer registers through the portal",
    channels: ["email" /* EMAIL */, "in_app" /* IN_APP */, "push" /* PUSH */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "service",
    requiredData: ["customerName", "customerAddress"],
    optionalData: ["customerEmail", "customerPhone", "referrerSource"],
    triggerEvents: ["customer.portal_registered"]
  },
  // Reminder to a customer who hasn't logged into their portal yet (RUT-2973).
  // Modeled on CUSTOMER_WELCOME: same customer-facing EMAIL + SMS default and the
  // {{portalLink}} call-to-action. Sending is gated by the org's
  // portalLoginReminderEnabled lever (default off) and the cadence/cap logic in
  // the portalLoginReminders cron — this config only describes the type.
  ["customer_portal_login_reminder" /* CUSTOMER_PORTAL_LOGIN_REMINDER */]: {
    type: "customer_portal_login_reminder" /* CUSTOMER_PORTAL_LOGIN_REMINDER */,
    name: "Portal Login Reminder",
    description: "Sent to a customer who hasn't logged into their profile yet",
    channels: ["email" /* EMAIL */, "sms" /* SMS */],
    defaultPriority: "low" /* LOW */,
    targetRoles: ["customer" /* CUSTOMER */],
    enabledByDefault: true,
    category: "messaging",
    requiredData: ["customerFirstName"],
    optionalData: ["orgName", "portalLink"]
  },
  ["access_request_submitted" /* ACCESS_REQUEST_SUBMITTED */]: {
    type: "access_request_submitted" /* ACCESS_REQUEST_SUBMITTED */,
    name: "Access Request Submitted",
    description: "Sent to admins when someone requests access to an existing customer account",
    channels: ["email" /* EMAIL */, "in_app" /* IN_APP */, "push" /* PUSH */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "system",
    requiredData: ["requesterName", "requesterContact", "relationship", "customerName", "customerAddress", "customerId"]
  },
  // Customer Messaging Notifications
  ["customer_message" /* CUSTOMER_MESSAGE */]: {
    type: "customer_message" /* CUSTOMER_MESSAGE */,
    name: "Customer Message",
    description: "Sent to admins when a customer sends a message",
    channels: ["email" /* EMAIL */, "sms" /* SMS */, "in_app" /* IN_APP */, "push" /* PUSH */],
    defaultPriority: "high" /* HIGH */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "messaging",
    requiredData: ["customerId", "customerName", "messagePreview", "messageId"],
    bypassKillSwitch: true
  },
  ["admin_message" /* ADMIN_MESSAGE */]: {
    type: "admin_message" /* ADMIN_MESSAGE */,
    name: "Admin Message",
    description: "Sent to customers when an admin sends a message",
    channels: ["email" /* EMAIL */, "sms" /* SMS */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["customer" /* CUSTOMER */],
    enabledByDefault: true,
    category: "messaging",
    requiredData: ["adminName", "messagePreview", "messageId", "orgId"],
    bypassKillSwitch: true
  },
  // Shop Advisors (RUT-3751). One type for all four agents. In-app only —
  // never email/SMS/push, never customer-facing. Title on the Alerts row is
  // the agent name; body is the one fact.
  ["shop_advisor" /* SHOP_ADVISOR */]: {
    type: "shop_advisor" /* SHOP_ADVISOR */,
    name: "Shop Advisor",
    description: "Office alert from a Shop Advisor. Title is the agent name; body is the one fact",
    channels: ["in_app" /* IN_APP */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "system",
    requiredData: ["agentName", "fact"],
    optionalData: ["visitId", "draftId", "customerId", "kind"]
  },
  // Reporter opted in on the report-received modal (RUT-3900). In-app only —
  // fires once when the linked Linear issue reaches Done or Canceled.
  ["feedback_resolved" /* FEEDBACK_RESOLVED */]: {
    type: "feedback_resolved" /* FEEDBACK_RESOLVED */,
    name: "Report Resolved",
    description: "Tells the person who filed a report when the Ruta team marks it done or canceled",
    channels: ["in_app" /* IN_APP */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "system",
    requiredData: ["issueIdentifier", "title", "body"]
  },
  // Crew leader saved today's drive order as the crew's permanent route
  // from the crew app (RUT-4282). Office-only; in-app like clock-in.
  ["crew_route_order_changed" /* CREW_ROUTE_ORDER_CHANGED */]: {
    type: "crew_route_order_changed" /* CREW_ROUTE_ORDER_CHANGED */,
    name: "Crew Route Order Changed",
    description: "Tells the office when someone saves today's stop order as the crew's route from the crew app",
    channels: ["in_app" /* IN_APP */],
    defaultPriority: "medium" /* MEDIUM */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: true,
    category: "crew",
    requiredData: ["crewName", "memberName", "movedCount"],
    optionalData: ["crewId", "oneStop"],
    triggerEvents: ["crew.route_order_changed"]
  },
  // Optional daily cash-flow summary (RUT-4165). Off by default; only Owner
  // and Admin can turn it on. No SMS — in-app + push, email if they ask.
  ["daily_collected_summary" /* DAILY_COLLECTED_SUMMARY */]: {
    type: "daily_collected_summary" /* DAILY_COLLECTED_SUMMARY */,
    name: "Daily collected total",
    description: "End-of-day total of card charges, checks and cash, and refunds",
    channels: ["in_app" /* IN_APP */, "push" /* PUSH */, "email" /* EMAIL */],
    defaultPriority: "low" /* LOW */,
    targetRoles: ["admin" /* ADMIN */],
    enabledByDefault: false,
    category: "payments",
    requiredData: ["cardAmount", "checkCashAmount", "refundAmount", "totalCollected"],
    optionalData: ["dateLabel", "reportUrl"]
  }
};
var defaultTemplateReplacer = (template, data) => {
  const processedData = { ...data };
  Object.keys(processedData).forEach((key) => {
    const value = processedData[key];
    if ((key.includes("amount") || key.includes("price") || key.includes("rate")) && typeof value === "number") {
      processedData[key] = `$${value.toFixed(2)}`;
    }
    if ((key.includes("date") || key.includes("Date") || key.includes("Time")) && value instanceof Date) {
      processedData[key] = value.toLocaleDateString();
    }
  });
  Mustache.escape = (text) => text;
  const result = Mustache.render(template, processedData);
  return result;
};
var NOTIFICATION_TEMPLATES = {
  // Rate & Pricing Templates
  ["rate_request_submitted" /* RATE_REQUEST_SUBMITTED */]: {
    type: "rate_request_submitted" /* RATE_REQUEST_SUBMITTED */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "New Rate Request from {{customerName}}",
        preview: "A new rate request has been submitted for {{serviceAddress}}",
        content: `A new rate request has been submitted:

Customer: {{customerName}}
Address: {{serviceAddress}}
Phone: {{phone}}
Email: {{email}}

Notes: {{notes}}

Please review and provide pricing.`,
        actionText: "View Rate Request"
      },
      ["sms" /* SMS */]: {
        content: "New rate request from {{customerName}} at {{serviceAddress}}. Review now."
      },
      ["in_app" /* IN_APP */]: {
        subject: "New Rate Request",
        content: "{{customerName}} requested a rate for {{serviceAddress}}",
        actionText: "Review",
        es: {
          subject: "Nueva solicitud de tarifa",
          content: "{{customerName}} solicit\xF3 una tarifa para {{serviceAddress}}",
          actionText: "Revisar"
        }
      },
      ["push" /* PUSH */]: {
        subject: "New Rate Request",
        content: "{{customerName}} at {{serviceAddress}}",
        es: {
          subject: "Nueva solicitud de tarifa",
          content: "{{customerName}} en {{serviceAddress}}"
        }
      }
    }
  },
  ["rate_request_updated" /* RATE_REQUEST_UPDATED */]: {
    type: "rate_request_updated" /* RATE_REQUEST_UPDATED */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "Your Rate is Ready",
        preview: "We have prepared a rate for your service request",
        content: `Hi {{customerFirstName}},

Great news! We have reviewed your service request and prepared a custom rate for you.

Service Address: {{serviceAddress}}
Rate: {{pricing}}
Valid Until: {{validUntil}}

{{customMessage}}

Please review and let us know if you would like to proceed.`,
        actionText: "View Rate"
      },
      ["sms" /* SMS */]: {
        content: "Your service rate is ready! Price: {{pricing}}. View details and accept."
      },
      ["in_app" /* IN_APP */]: {
        subject: "Rate Ready",
        content: "Your service rate of {{pricing}} is ready for review",
        actionText: "View Rate",
        es: {
          subject: "Tarifa lista",
          content: "Tu tarifa de {{pricing}} est\xE1 lista para revisar",
          actionText: "Ver tarifa"
        }
      }
    }
  },
  ["rate_accepted" /* RATE_ACCEPTED */]: {
    type: "rate_accepted" /* RATE_ACCEPTED */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "Rate Accepted by {{customerName}}",
        preview: "Customer has accepted the rate you sent",
        content: `Great news! {{customerName}} has accepted the rate.

Accepted Rate: {{acceptedRate}}
Service Address: {{serviceAddress}}

The customer is ready to proceed with scheduling.`,
        actionText: "Schedule Service"
      },
      ["in_app" /* IN_APP */]: {
        subject: "Rate Accepted",
        content: "{{customerName}} accepted {{acceptedRate}} rate",
        actionText: "Schedule",
        es: {
          subject: "Tarifa aceptada",
          content: "{{customerName}} acept\xF3 la tarifa de {{acceptedRate}}",
          actionText: "Programar"
        }
      }
    }
  },
  ["rate_declined" /* RATE_DECLINED */]: {
    type: "rate_declined" /* RATE_DECLINED */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "Rate Declined by {{customerName}}",
        preview: "Customer has declined the rate you sent",
        content: `{{customerName}} has declined the rate.

Reason: {{reason}}
Service Address: {{serviceAddress}}

You may want to follow up with an alternative offer.`,
        actionText: "View Details"
      },
      ["in_app" /* IN_APP */]: {
        subject: "Rate Declined",
        content: "{{customerName}} declined. Reason: {{reason}}",
        actionText: "Follow Up",
        es: {
          subject: "Tarifa rechazada",
          content: "{{customerName}} la rechaz\xF3. Motivo: {{reason}}",
          actionText: "Dar seguimiento"
        }
      }
    }
  },
  ["rate_request_resurfaced" /* RATE_REQUEST_RESURFACED */]: {
    type: "rate_request_resurfaced" /* RATE_REQUEST_RESURFACED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Rate request resurfaced",
        content: "Rate request resurfaced \u2014 {{customerName}}'s {{serviceName}}",
        actionText: "Send Pricing",
        es: {
          subject: "Solicitud de tarifa reapareci\xF3",
          content: "Solicitud de tarifa reapareci\xF3 \u2014 {{serviceName}} de {{customerName}}",
          actionText: "Enviar precio"
        }
      }
    }
  },
  // Scheduling & Visit Templates
  ["visit_scheduled" /* VISIT_SCHEDULED */]: {
    type: "visit_scheduled" /* VISIT_SCHEDULED */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "Service Visit Scheduled for {{scheduledDate}}",
        preview: "Your {{serviceType}} service has been scheduled",
        content: `Your service visit has been scheduled!

Service: {{serviceType}}
Date: {{scheduledDate}}
Crew: {{crewName}}
Estimated Duration: {{estimatedDuration}}

We will send you a reminder before the visit.`,
        actionText: "View Details"
      },
      ["sms" /* SMS */]: {
        content: "{{serviceType}} scheduled for {{scheduledDate}}. Crew: {{crewName}}"
      },
      ["in_app" /* IN_APP */]: {
        subject: "Visit Scheduled",
        content: "{{serviceType}} on {{scheduledDate}}",
        actionText: "View",
        es: {
          subject: "Visita programada",
          content: "{{serviceType}} el {{scheduledDate}}",
          actionText: "Ver"
        }
      }
    }
  },
  ["visit_reminder" /* VISIT_REMINDER */]: {
    type: "visit_reminder" /* VISIT_REMINDER */,
    channels: {
      ["sms" /* SMS */]: {
        content: "Reminder: {{serviceType}} service tomorrow at {{scheduledDate}}"
      },
      ["push" /* PUSH */]: {
        subject: "Service Tomorrow",
        content: "{{serviceType}} scheduled for {{scheduledDate}}"
      }
    }
  },
  ["visit_started" /* VISIT_STARTED */]: {
    type: "visit_started" /* VISIT_STARTED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Visit Started",
        content: "Visit at {{propertyAddress}} has been started",
        es: {
          subject: "Visita iniciada",
          content: "La visita en {{propertyAddress}} ha comenzado"
        }
      },
      ["push" /* PUSH */]: {
        subject: "Visit Started",
        content: "Visit at {{propertyAddress}} has been started",
        es: {
          subject: "Visita iniciada",
          content: "La visita en {{propertyAddress}} ha comenzado"
        }
      }
    }
  },
  ["visit_paused" /* VISIT_PAUSED */]: {
    type: "visit_paused" /* VISIT_PAUSED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Visit Paused",
        content: "Visit at {{propertyAddress}} has been paused",
        es: {
          subject: "Visita pausada",
          content: "La visita en {{propertyAddress}} ha sido pausada"
        }
      },
      ["push" /* PUSH */]: {
        subject: "Visit Paused",
        content: "Visit at {{propertyAddress}} has been paused",
        es: {
          subject: "Visita pausada",
          content: "La visita en {{propertyAddress}} ha sido pausada"
        }
      }
    }
  },
  ["visit_resumed" /* VISIT_RESUMED */]: {
    type: "visit_resumed" /* VISIT_RESUMED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Visit Resumed",
        content: "Visit at {{propertyAddress}} has been resumed",
        es: {
          subject: "Visita reanudada",
          content: "La visita en {{propertyAddress}} se ha reanudado"
        }
      },
      ["push" /* PUSH */]: {
        subject: "Visit Resumed",
        content: "Visit at {{propertyAddress}} has been resumed",
        es: {
          subject: "Visita reanudada",
          content: "La visita en {{propertyAddress}} se ha reanudado"
        }
      }
    }
  },
  ["visit_skipped" /* VISIT_SKIPPED */]: {
    type: "visit_skipped" /* VISIT_SKIPPED */,
    channels: {
      // Bodies degrade gracefully when the property address is missing (RUT-2949):
      // they fall back to the customer's name, then to a generic phrase, so the
      // alert always reads sensibly and never leaves a dangling "Visit at  ".
      ["email" /* EMAIL */]: {
        subject: "Visit Skipped{{#customerName}} - {{customerName}}{{/customerName}}{{#serviceName}} \u2014 {{serviceName}}{{/serviceName}}",
        preview: "{{#serviceName}}{{serviceName}}{{#customerName}} for {{customerName}}{{/customerName}} was skipped{{/serviceName}}{{^serviceName}}{{#propertyAddress}}A visit at {{propertyAddress}} was skipped{{/propertyAddress}}{{^propertyAddress}}{{#customerName}}{{customerName}}'s visit was skipped{{/customerName}}{{^customerName}}A visit was skipped{{/customerName}}{{/propertyAddress}}{{/serviceName}}",
        content: `A visit was skipped and flagged for review.

{{#serviceName}}Service: {{serviceName}}
{{/serviceName}}{{#propertyAddress}}Property: {{propertyAddress}}
{{/propertyAddress}}{{^propertyAddress}}{{#customerName}}Customer: {{customerName}}
{{/customerName}}{{/propertyAddress}}Reason: {{skipReason}}`,
        actionText: "View Visit"
      },
      ["in_app" /* IN_APP */]: {
        // Office bell: customer name + local address, then the fact (RUT-3696).
        // Address-only and name-only fallbacks stay so a missing field never
        // leaves a dangling "Visit at  " (RUT-2949). Reason stays on the body
        // so the row can still strip it onto its own line (RUT-3557).
        // Service display name is optional — when present it sits next to the
        // identity so the row names what was skipped (RUT-4005).
        subject: "Visit Skipped",
        content: "{{#customerName}}{{customerName}}{{#propertyAddress}}, {{propertyAddress}}{{/propertyAddress}}{{#serviceName}} \u2014 {{serviceName}}{{/serviceName}} \u2014 visit has been skipped and flagged for review.{{/customerName}}{{^customerName}}{{#propertyAddress}}{{#serviceName}}{{serviceName}} at {{propertyAddress}} has been skipped and flagged for review.{{/serviceName}}{{^serviceName}}Visit at {{propertyAddress}} has been skipped and flagged for review.{{/serviceName}}{{/propertyAddress}}{{^propertyAddress}}{{#serviceName}}{{serviceName}} has been skipped and flagged for review.{{/serviceName}}{{^serviceName}}A visit has been skipped and flagged for review.{{/serviceName}}{{/propertyAddress}}{{/customerName}} Reason: {{skipReason}}",
        es: {
          subject: "Visita omitida",
          content: "{{#customerName}}{{customerName}}{{#propertyAddress}}, {{propertyAddress}}{{/propertyAddress}}{{#serviceName}} \u2014 {{serviceName}}{{/serviceName}} \u2014 la visita fue omitida y marcada para revisi\xF3n.{{/customerName}}{{^customerName}}{{#propertyAddress}}{{#serviceName}}{{serviceName}} en {{propertyAddress}} fue omitida y marcada para revisi\xF3n.{{/serviceName}}{{^serviceName}}La visita en {{propertyAddress}} fue omitida y marcada para revisi\xF3n.{{/serviceName}}{{/propertyAddress}}{{^propertyAddress}}{{#serviceName}}{{serviceName}} fue omitida y marcada para revisi\xF3n.{{/serviceName}}{{^serviceName}}Una visita fue omitida y marcada para revisi\xF3n.{{/serviceName}}{{/propertyAddress}}{{/customerName}} Motivo: {{skipReason}}"
        }
      },
      ["push" /* PUSH */]: {
        subject: "Visit Skipped",
        content: "{{#customerName}}{{customerName}}{{#propertyAddress}}, {{propertyAddress}}{{/propertyAddress}}{{#serviceName}} \u2014 {{serviceName}}{{/serviceName}} \u2014 visit skipped.{{/customerName}}{{^customerName}}{{#propertyAddress}}{{#serviceName}}{{serviceName}} at {{propertyAddress}} skipped.{{/serviceName}}{{^serviceName}}Visit at {{propertyAddress}} skipped.{{/serviceName}}{{/propertyAddress}}{{^propertyAddress}}{{#serviceName}}{{serviceName}} skipped.{{/serviceName}}{{^serviceName}}A visit was skipped.{{/serviceName}}{{/propertyAddress}}{{/customerName}} Reason: {{skipReason}}",
        es: {
          subject: "Visita omitida",
          content: "{{#customerName}}{{customerName}}{{#propertyAddress}}, {{propertyAddress}}{{/propertyAddress}}{{#serviceName}} \u2014 {{serviceName}}{{/serviceName}} \u2014 visita omitida.{{/customerName}}{{^customerName}}{{#propertyAddress}}{{#serviceName}}Se omiti\xF3 {{serviceName}} en {{propertyAddress}}.{{/serviceName}}{{^serviceName}}Se omiti\xF3 la visita en {{propertyAddress}}.{{/serviceName}}{{/propertyAddress}}{{^propertyAddress}}{{#serviceName}}Se omiti\xF3 {{serviceName}}.{{/serviceName}}{{^serviceName}}Se omiti\xF3 una visita.{{/serviceName}}{{/propertyAddress}}{{/customerName}} Motivo: {{skipReason}}"
        }
      }
    }
  },
  // Discard alert (RUT-3348). Bodies degrade gracefully when the property
  // address is missing — they fall back to the customer's name, then to a
  // generic phrase — so the alert always reads sensibly and never leaves a
  // dangling "Visit at  ".
  //
  // The SMS entry is NOT the text an admin receives — that string is built by
  // generateAdminSmsContent in the API. It still has to exist: the send path
  // drops any channel whose template renders null, so without it the admin text
  // would never be attempted at all.
  ["visit_discarded" /* VISIT_DISCARDED */]: {
    type: "visit_discarded" /* VISIT_DISCARDED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Visit Discarded",
        content: "{{#propertyAddress}}Visit at {{propertyAddress}} was discarded.{{/propertyAddress}}{{^propertyAddress}}{{#customerName}}{{customerName}}'s visit was discarded.{{/customerName}}{{^customerName}}A visit was discarded.{{/customerName}}{{/propertyAddress}} Reason: {{discardReason}}",
        es: {
          subject: "Visita descartada",
          content: "{{#propertyAddress}}La visita en {{propertyAddress}} fue descartada.{{/propertyAddress}}{{^propertyAddress}}{{#customerName}}La visita de {{customerName}} fue descartada.{{/customerName}}{{^customerName}}Una visita fue descartada.{{/customerName}}{{/propertyAddress}} Motivo: {{discardReason}}"
        }
      },
      ["push" /* PUSH */]: {
        subject: "Visit Discarded",
        content: "{{#propertyAddress}}Visit at {{propertyAddress}} discarded.{{/propertyAddress}}{{^propertyAddress}}{{#customerName}}{{customerName}}'s visit discarded.{{/customerName}}{{^customerName}}A visit was discarded.{{/customerName}}{{/propertyAddress}} Reason: {{discardReason}}",
        es: {
          subject: "Visita descartada",
          content: "{{#propertyAddress}}Se descart\xF3 la visita en {{propertyAddress}}.{{/propertyAddress}}{{^propertyAddress}}{{#customerName}}Se descart\xF3 la visita de {{customerName}}.{{/customerName}}{{^customerName}}Se descart\xF3 una visita.{{/customerName}}{{/propertyAddress}} Motivo: {{discardReason}}"
        }
      },
      ["sms" /* SMS */]: {
        content: "{{#propertyAddress}}Visit at {{propertyAddress}} discarded.{{/propertyAddress}}{{^propertyAddress}}{{#customerName}}{{customerName}}'s visit discarded.{{/customerName}}{{^customerName}}A visit was discarded.{{/customerName}}{{/propertyAddress}} Reason: {{discardReason}}"
      }
    }
  },
  ["visit_completed" /* VISIT_COMPLETED */]: {
    type: "visit_completed" /* VISIT_COMPLETED */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "Your {{serviceName}} is complete \u2014 thank you for your business",
        preheader: "Your {{serviceName}} has been completed successfully",
        content: `
    <p style="font-size: 16px; margin-bottom: 20px;">Hi {{customerFirstName}},</p>

    <p style="font-size: 16px; margin-bottom: 20px;">Your {{serviceName}} is complete.{{#hasSpecialInstructions}} A suggested care guide for this service is now available.{{/hasSpecialInstructions}}</p>
    {{#customMessage}}
    <p style="font-size: 16px; margin-bottom: 20px;">{{customMessage}}</p>
    {{/customMessage}}
    {{#balanceDue}}
    <p style="font-size: 16px; margin-bottom: 20px;">Your account balance is {{balanceDue}}.</p>
    {{/balanceDue}}
  `,
        action: {
          label: "View details",
          url: "{{receiptLink}}"
        }
      },
      ["sms" /* SMS */]: {
        content: "{{customerFirstName}}, your {{serviceName}} is complete.{{#hasSpecialInstructions}} A suggested care guide is now available.{{/hasSpecialInstructions}}{{#customMessage}} {{customMessage}}{{/customMessage}}{{#balanceDue}} Your account balance is {{balanceDue}}.{{/balanceDue}}",
        action: {
          label: "{{#hasSpecialInstructions}}See details & suggested care guide{{/hasSpecialInstructions}}{{^hasSpecialInstructions}}See details{{/hasSpecialInstructions}}",
          url: "{{receiptLink}}"
        }
      },
      ["in_app" /* IN_APP */]: {
        subject: "Visit Completed",
        content: "{{serviceName}} completed",
        actionText: "View",
        es: {
          subject: "Visita completada",
          content: "Se complet\xF3 {{serviceName}}",
          actionText: "Ver"
        }
      }
    }
  },
  ["visit_followup_created" /* VISIT_FOLLOWUP_CREATED */]: {
    type: "visit_followup_created" /* VISIT_FOLLOWUP_CREATED */,
    channels: {
      ["sms" /* SMS */]: {
        content: "{{actionMessage}}"
      },
      ["in_app" /* IN_APP */]: {
        subject: "{{actionName}}",
        content: "{{actionMessage}}",
        actionText: "View",
        es: {
          actionText: "Ver"
        }
      }
    }
  },
  ["visit_notes_added" /* VISIT_NOTES_ADDED */]: {
    type: "visit_notes_added" /* VISIT_NOTES_ADDED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Crew Note Added",
        content: "{{addedBy}} added {{contentDescription}} to visit for {{customerName}}{{#propertyAddress}}, {{propertyAddress}}{{/propertyAddress}}",
        actionText: "View",
        es: {
          subject: "Nota del equipo agregada",
          content: "{{addedBy}} agreg\xF3 {{contentDescription}} a la visita de {{customerName}}{{#propertyAddress}}, {{propertyAddress}}{{/propertyAddress}}",
          actionText: "Ver"
        }
      },
      ["push" /* PUSH */]: {
        subject: "Crew Note Added",
        content: "{{addedBy}} added {{contentDescription}} for {{customerName}}{{#propertyAddress}}, {{propertyAddress}}{{/propertyAddress}}",
        es: {
          subject: "Nota del equipo agregada",
          content: "{{addedBy}} agreg\xF3 {{contentDescription}} para {{customerName}}{{#propertyAddress}}, {{propertyAddress}}{{/propertyAddress}}"
        }
      },
      ["sms" /* SMS */]: {
        content: "{{addedBy}} added {{contentDescription}} to the visit for {{customerName}}{{#propertyAddress}}, {{propertyAddress}}{{/propertyAddress}}."
      }
    }
  },
  ["visit_photos_added" /* VISIT_PHOTOS_ADDED */]: {
    type: "visit_photos_added" /* VISIT_PHOTOS_ADDED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Photos Added",
        content: "{{addedBy}} added {{contentDescription}} to visit for {{customerName}}{{#propertyAddress}}, {{propertyAddress}}{{/propertyAddress}}",
        actionText: "View",
        es: {
          subject: "Fotos agregadas",
          content: "{{addedBy}} agreg\xF3 {{contentDescription}} a la visita de {{customerName}}{{#propertyAddress}}, {{propertyAddress}}{{/propertyAddress}}",
          actionText: "Ver"
        }
      }
    }
  },
  ["visit_photo_approval_needed" /* VISIT_PHOTO_APPROVAL_NEEDED */]: {
    type: "visit_photo_approval_needed" /* VISIT_PHOTO_APPROVAL_NEEDED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Photo Needs Approval",
        content: "{{addedBy}} added {{contentDescription}} to visit for {{customerName}} after photos were shared \u2014 review to approve",
        actionText: "Review",
        es: {
          subject: "Foto pendiente de aprobaci\xF3n",
          content: "{{addedBy}} agreg\xF3 {{contentDescription}} a la visita de {{customerName}} despu\xE9s de compartir las fotos \u2014 revisa para aprobar",
          actionText: "Revisar"
        }
      }
    }
  },
  ["followup_visit_completed" /* FOLLOWUP_VISIT_COMPLETED */]: {
    type: "followup_visit_completed" /* FOLLOWUP_VISIT_COMPLETED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Follow-up Completed",
        content: "Follow-up visit for {{customerName}} ({{serviceName}}) has been completed",
        actionText: "View",
        es: {
          subject: "Seguimiento completado",
          content: "La visita de seguimiento de {{customerName}} ({{serviceName}}) ha sido completada",
          actionText: "Ver"
        }
      },
      ["push" /* PUSH */]: {
        subject: "Follow-up Completed",
        content: "{{customerName}} \u2014 follow-up visit completed",
        es: {
          subject: "Seguimiento completado",
          content: "{{customerName}} \u2014 visita de seguimiento completada"
        }
      }
    }
  },
  /**
   * The alert explains why the recipient is getting it (RUT-2933). It fires from two
   * independent opt-ins that used to read identically on arrival:
   *   - `fromVisitBell` — a one-off bell an admin armed on this single visit. The copy
   *     names the armer and the date so an alert landing a day later is recognisable.
   *     It names the armer rather than saying "you" because this is a role notification
   *     delivered to EVERY admin, not just whoever armed it.
   *   - otherwise — a standing rule on the service, which nobody armed per-visit.
   * `armedByName`/`armedOn` are absent on visits armed before RUT-2933; the Mustache
   * sections collapse to a shorter sentence rather than rendering an empty blank.
   */
  ["visit_completed_reminder" /* VISIT_COMPLETED_REMINDER */]: {
    type: "visit_completed_reminder" /* VISIT_COMPLETED_REMINDER */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Visit Completed",
        content: "Visit for {{customerName}} ({{serviceName}}) has been completed. {{#fromVisitBell}}A completion alert was requested for this visit{{#armedByName}} by {{armedByName}}{{/armedByName}}{{#armedOn}} on {{armedOn}}{{/armedOn}}.{{/fromVisitBell}}{{^fromVisitBell}}Completion alerts are on for this service.{{/fromVisitBell}}",
        actionText: "View",
        es: {
          subject: "Visita completada",
          content: "La visita de {{customerName}} ({{serviceName}}) ha sido completada. {{#fromVisitBell}}Se solicit\xF3 una alerta de finalizaci\xF3n para esta visita{{#armedByName}} por {{armedByName}}{{/armedByName}}{{#armedOn}} el {{armedOn}}{{/armedOn}}.{{/fromVisitBell}}{{^fromVisitBell}}Las alertas de finalizaci\xF3n est\xE1n activadas para este servicio.{{/fromVisitBell}}",
          actionText: "Ver"
        }
      },
      ["push" /* PUSH */]: {
        subject: "Visit Completed",
        content: "{{customerName}} \u2014 visit completed. {{#fromVisitBell}}Alert requested{{#armedByName}} by {{armedByName}}{{/armedByName}}{{#armedOn}} on {{armedOn}}{{/armedOn}}.{{/fromVisitBell}}{{^fromVisitBell}}Completion alerts are on for this service.{{/fromVisitBell}}",
        es: {
          subject: "Visita completada",
          content: "{{customerName}} \u2014 visita completada. {{#fromVisitBell}}Se solicit\xF3 una alerta{{#armedByName}} por {{armedByName}}{{/armedByName}}{{#armedOn}} el {{armedOn}}{{/armedOn}}.{{/fromVisitBell}}{{^fromVisitBell}}Las alertas de finalizaci\xF3n est\xE1n activadas para este servicio.{{/fromVisitBell}}"
        }
      }
    }
  },
  ["visit_cancelled" /* VISIT_CANCELLED */]: {
    type: "visit_cancelled" /* VISIT_CANCELLED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Visit Cancelled",
        content: "Visit cancelled: {{reason}}",
        es: {
          subject: "Visita cancelada",
          content: "Visita cancelada: {{reason}}"
        }
      },
      ["push" /* PUSH */]: {
        subject: "Visit Cancelled",
        content: "Visit cancelled: {{reason}}",
        es: {
          subject: "Visita cancelada",
          content: "Visita cancelada: {{reason}}"
        }
      }
    }
  },
  ["visit_rescheduled" /* VISIT_RESCHEDULED */]: {
    type: "visit_rescheduled" /* VISIT_RESCHEDULED */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "Service Visit Rescheduled",
        preview: "Your visit has been moved to a new date",
        content: `Your service visit has been rescheduled.

Original Date: {{oldDate}}
New Date: {{newDate}}

We apologize for any inconvenience.`,
        actionText: "View Details"
      },
      ["sms" /* SMS */]: {
        content: "Visit moved from {{oldDate}} to {{newDate}}"
      },
      ["in_app" /* IN_APP */]: {
        subject: "Visit Rescheduled",
        content: "New date: {{newDate}}",
        actionText: "View",
        es: {
          subject: "Visita reprogramada",
          content: "Nueva fecha: {{newDate}}",
          actionText: "Ver"
        }
      }
    }
  },
  ["visit_priority_set" /* VISIT_PRIORITY_SET */]: {
    type: "visit_priority_set" /* VISIT_PRIORITY_SET */,
    channels: {
      ["in_app" /* IN_APP */]: {
        // Crews navigate by location, so lead with the property address (RUT-3298)
        // and fall back to the customer name for visits stored without one.
        subject: "High Priority Visit",
        content: "{{#customerAddress}}{{customerAddress}} is marked as a high-priority visit.{{/customerAddress}}{{^customerAddress}}Visit for {{customerName}} is marked as high priority.{{/customerAddress}}",
        actionText: "View",
        es: {
          subject: "Visita de alta prioridad",
          content: "{{#customerAddress}}{{customerAddress}} est\xE1 marcada como visita de alta prioridad.{{/customerAddress}}{{^customerAddress}}La visita de {{customerName}} est\xE1 marcada como de alta prioridad.{{/customerAddress}}",
          actionText: "Ver"
        }
      },
      ["push" /* PUSH */]: {
        subject: "High Priority Visit",
        content: "{{#customerAddress}}{{customerAddress}} is marked as a high-priority visit.{{/customerAddress}}{{^customerAddress}}Visit for {{customerName}} is marked as high priority.{{/customerAddress}}",
        es: {
          subject: "Visita de alta prioridad",
          content: "{{#customerAddress}}{{customerAddress}} est\xE1 marcada como visita de alta prioridad.{{/customerAddress}}{{^customerAddress}}La visita de {{customerName}} est\xE1 marcada como de alta prioridad.{{/customerAddress}}"
        }
      }
    }
  },
  ["visit_priority_reminder" /* VISIT_PRIORITY_REMINDER */]: {
    type: "visit_priority_reminder" /* VISIT_PRIORITY_REMINDER */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Reminder for today",
        content: "{{customerName}}",
        actionText: "View",
        es: {
          subject: "Recordatorio para hoy",
          actionText: "Ver"
        }
      },
      ["push" /* PUSH */]: {
        subject: "Reminder for today",
        content: "{{customerName}}",
        es: {
          subject: "Recordatorio para hoy"
        }
      }
    }
  },
  // Crew Management Templates
  ["crew_assigned" /* CREW_ASSIGNED */]: {
    type: "crew_assigned" /* CREW_ASSIGNED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "New Job Assignment",
        content: "You have been assigned to job #{{jobId}} on {{assignmentDate}}",
        actionText: "View Job",
        es: {
          subject: "Nueva asignaci\xF3n de trabajo",
          content: "Se te asign\xF3 el trabajo #{{jobId}} para el {{assignmentDate}}",
          actionText: "Ver trabajo"
        }
      },
      ["push" /* PUSH */]: {
        subject: "New Job Assignment",
        content: "Job #{{jobId}} on {{assignmentDate}}",
        es: {
          subject: "Nueva asignaci\xF3n de trabajo",
          content: "Trabajo #{{jobId}} para el {{assignmentDate}}"
        }
      }
    }
  },
  ["crew_registration" /* CREW_REGISTRATION */]: {
    type: "crew_registration" /* CREW_REGISTRATION */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "New Crew Member Registration",
        preview: "{{memberName}} has registered",
        content: `A new crew member has registered:

Name: {{memberName}}
Registration Date: {{registrationDate}}

Please review and approve their profile.`,
        actionText: "Review Profile"
      },
      ["in_app" /* IN_APP */]: {
        subject: "New Crew Member",
        content: "{{memberName}} registered",
        actionText: "Review",
        es: {
          subject: "Nuevo miembro del equipo",
          content: "{{memberName}} se registr\xF3",
          actionText: "Revisar"
        }
      },
      ["push" /* PUSH */]: {
        subject: "New Crew Member",
        content: "{{memberName}} registered",
        es: {
          subject: "Nuevo miembro del equipo",
          content: "{{memberName}} se registr\xF3"
        }
      }
    }
  },
  ["crew_clock_in" /* CREW_CLOCK_IN */]: {
    type: "crew_clock_in" /* CREW_CLOCK_IN */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Clock In",
        content: "{{memberName}} clocked in at {{clockInTime}}",
        es: {
          subject: "Entrada marcada",
          content: "{{memberName}} marc\xF3 entrada a las {{clockInTime}}"
        }
      }
    }
  },
  ["crew_clock_out" /* CREW_CLOCK_OUT */]: {
    type: "crew_clock_out" /* CREW_CLOCK_OUT */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Clock Out",
        content: "{{memberName}} worked {{hoursWorked}} hours",
        es: {
          subject: "Salida marcada",
          content: "{{memberName}} trabaj\xF3 {{hoursWorked}} horas"
        }
      }
    }
  },
  ["crew_bulk_clock_out" /* CREW_BULK_CLOCK_OUT */]: {
    type: "crew_bulk_clock_out" /* CREW_BULK_CLOCK_OUT */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Crew Clocked Out",
        content: "{{clockedOutCount}} crew members were clocked out",
        es: {
          subject: "Salidas del equipo marcadas",
          content: "Se marc\xF3 la salida de {{clockedOutCount}} miembros del equipo"
        }
      }
    }
  },
  // First-in / last-out org edges (RUT-3991). Deliberately nameless: the office
  // reads that people are working, or that everyone who was working is out —
  // not who punched, and not that the day is over.
  ["team_day_started" /* TEAM_DAY_STARTED */]: {
    type: "team_day_started" /* TEAM_DAY_STARTED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "First team member clocked in",
        content: "First team member clocked in at {{clockInTime}}",
        es: {
          subject: "El primer miembro del equipo marc\xF3 entrada",
          content: "El primer miembro del equipo marc\xF3 entrada a las {{clockInTime}}"
        }
      },
      ["sms" /* SMS */]: {
        content: "First team member clocked in at {{clockInTime}}."
      }
    }
  },
  ["team_day_ended" /* TEAM_DAY_ENDED */]: {
    type: "team_day_ended" /* TEAM_DAY_ENDED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Last team member clocked out",
        content: "Last team member clocked out at {{clockOutTime}}",
        es: {
          subject: "El \xFAltimo miembro del equipo marc\xF3 salida",
          content: "El \xFAltimo miembro del equipo marc\xF3 salida a las {{clockOutTime}}"
        }
      },
      ["sms" /* SMS */]: {
        content: "Last team member clocked out at {{clockOutTime}}."
      }
    }
  },
  ["crew_new_visit_scheduled" /* CREW_NEW_VISIT_SCHEDULED */]: {
    type: "crew_new_visit_scheduled" /* CREW_NEW_VISIT_SCHEDULED */,
    channels: {
      ["push" /* PUSH */]: {
        // Explicit "new on your list" so the crew does not have to notice the
        // stop in the route list. Leads with address + service; customer name
        // after. Same address-led lock as RUT-3415 / RUT-2792 (RUT-3600).
        subject: "New on your list",
        content: "{{#serviceAddress}}{{serviceAddress}} \u2014 {{serviceType}} for {{customerName}}{{#crewName}} ({{crewName}}){{/crewName}}{{/serviceAddress}}{{^serviceAddress}}{{serviceType}} for {{customerName}}{{#crewName}} ({{crewName}}){{/crewName}}{{/serviceAddress}}",
        es: {
          subject: "Nuevo en tu lista",
          content: "{{#serviceAddress}}{{serviceAddress}} \u2014 {{serviceType}} para {{customerName}}{{#crewName}} ({{crewName}}){{/crewName}}{{/serviceAddress}}{{^serviceAddress}}{{serviceType}} para {{customerName}}{{#crewName}} ({{crewName}}){{/crewName}}{{/serviceAddress}}"
        }
      },
      ["in_app" /* IN_APP */]: {
        subject: "New on your list",
        content: "{{#serviceAddress}}{{serviceAddress}} \u2014 {{serviceType}} for {{customerName}}{{#crewName}} ({{crewName}}){{/crewName}}{{/serviceAddress}}{{^serviceAddress}}{{serviceType}} for {{customerName}}{{#crewName}} ({{crewName}}){{/crewName}}{{/serviceAddress}}",
        es: {
          subject: "Nuevo en tu lista",
          content: "{{#serviceAddress}}{{serviceAddress}} \u2014 {{serviceType}} para {{customerName}}{{#crewName}} ({{crewName}}){{/crewName}}{{/serviceAddress}}{{^serviceAddress}}{{serviceType}} para {{customerName}}{{#crewName}} ({{crewName}}){{/crewName}}{{/serviceAddress}}"
        }
      }
    }
  },
  ["crew_assessment_created" /* CREW_ASSESSMENT_CREATED */]: {
    type: "crew_assessment_created" /* CREW_ASSESSMENT_CREATED */,
    channels: {
      ["push" /* PUSH */]: {
        subject: "Assessment created",
        content: "{{#serviceAddress}}{{serviceAddress}} \u2014 {{serviceType}} for {{customerName}}{{#crewName}} ({{crewName}}){{/crewName}}{{/serviceAddress}}{{^serviceAddress}}{{serviceType}} for {{customerName}}{{#crewName}} ({{crewName}}){{/crewName}}{{/serviceAddress}}",
        es: {
          subject: "Evaluaci\xF3n creada",
          content: "{{#serviceAddress}}{{serviceAddress}} \u2014 {{serviceType}} para {{customerName}}{{#crewName}} ({{crewName}}){{/crewName}}{{/serviceAddress}}{{^serviceAddress}}{{serviceType}} para {{customerName}}{{#crewName}} ({{crewName}}){{/crewName}}{{/serviceAddress}}"
        }
      },
      ["in_app" /* IN_APP */]: {
        subject: "Assessment created",
        content: "{{#serviceAddress}}{{serviceAddress}} \u2014 {{serviceType}} for {{customerName}}{{#crewName}} ({{crewName}}){{/crewName}}{{/serviceAddress}}{{^serviceAddress}}{{serviceType}} for {{customerName}}{{#crewName}} ({{crewName}}){{/crewName}}{{/serviceAddress}}",
        es: {
          subject: "Evaluaci\xF3n creada",
          content: "{{#serviceAddress}}{{serviceAddress}} \u2014 {{serviceType}} para {{customerName}}{{#crewName}} ({{crewName}}){{/crewName}}{{/serviceAddress}}{{^serviceAddress}}{{serviceType}} para {{customerName}}{{#crewName}} ({{crewName}}){{/crewName}}{{/serviceAddress}}"
        }
      }
    }
  },
  ["crew_dispatch_executed" /* CREW_DISPATCH_EXECUTED */]: {
    type: "crew_dispatch_executed" /* CREW_DISPATCH_EXECUTED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Crew Dispatch",
        content: "{{crewLeaderName}} dispatched {{subscriptionsDispatched}} visits for {{scheduledDate}}",
        actionText: "View",
        es: {
          subject: "Despacho de equipo",
          content: "{{crewLeaderName}} despach\xF3 {{subscriptionsDispatched}} visitas para el {{scheduledDate}}",
          actionText: "Ver"
        }
      },
      ["push" /* PUSH */]: {
        subject: "Crew Dispatch",
        content: "{{crewLeaderName}} dispatched {{subscriptionsDispatched}} visits",
        es: {
          subject: "Despacho de equipo",
          content: "{{crewLeaderName}} despach\xF3 {{subscriptionsDispatched}} visitas"
        }
      }
    }
  },
  ["crew_auto_assigned" /* CREW_AUTO_ASSIGNED */]: {
    type: "crew_auto_assigned" /* CREW_AUTO_ASSIGNED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Crew Auto-Assigned",
        content: "{{crewName}} auto-assigned to {{customerName}}'s {{serviceTemplateName}} based on {{fromServiceTemplateName}}",
        actionText: "View",
        es: {
          subject: "Equipo asignado autom\xE1ticamente",
          content: "{{crewName}} fue asignado autom\xE1ticamente a {{serviceTemplateName}} de {{customerName}} a partir de {{fromServiceTemplateName}}",
          actionText: "Ver"
        }
      }
    }
  },
  ["crew_assignment_conflict" /* CREW_ASSIGNMENT_CONFLICT */]: {
    type: "crew_assignment_conflict" /* CREW_ASSIGNMENT_CONFLICT */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Crew Assignment Conflict",
        content: "Multiple crews serve {{customerName}}. Manual assignment needed for {{serviceTemplateName}}.",
        actionText: "Assign Crew",
        es: {
          subject: "Conflicto de asignaci\xF3n de equipo",
          content: "Varios equipos atienden a {{customerName}}. Se necesita asignar manualmente {{serviceTemplateName}}.",
          actionText: "Asignar equipo"
        }
      },
      ["email" /* EMAIL */]: {
        subject: "Crew Assignment Required - {{customerName}}",
        preview: "Manual crew assignment needed",
        content: `A new subscription for {{customerName}} needs manual crew assignment.

Service: {{serviceTemplateName}}
Related Crews: {{relatedCrews}}

Multiple crews already serve this customer, so automatic assignment was skipped.`,
        actionText: "Assign Crew"
      }
    }
  },
  ["crew_service_removed" /* CREW_SERVICE_REMOVED */]: {
    type: "crew_service_removed" /* CREW_SERVICE_REMOVED */,
    channels: {
      ["push" /* PUSH */]: {
        subject: "{{serviceType}} Removed",
        content: "{{serviceType}} for {{customerName}} removed from your route",
        es: {
          subject: "{{serviceType}} eliminado",
          content: "{{serviceType}} para {{customerName}} se elimin\xF3 de tu ruta"
        }
      },
      ["in_app" /* IN_APP */]: {
        subject: "{{serviceType}} Removed",
        content: "{{serviceType}} for {{customerName}} removed from your route",
        es: {
          subject: "{{serviceType}} eliminado",
          content: "{{serviceType}} para {{customerName}} se elimin\xF3 de tu ruta"
        }
      }
    }
  },
  ["crew_service_deactivated" /* CREW_SERVICE_DEACTIVATED */]: {
    type: "crew_service_deactivated" /* CREW_SERVICE_DEACTIVATED */,
    channels: {
      ["push" /* PUSH */]: {
        subject: "{{serviceType}} Deactivated",
        content: "{{serviceType}} for {{customerName}} deactivated, effective {{effectiveDate}}",
        es: {
          subject: "{{serviceType}} desactivado",
          content: "{{serviceType}} para {{customerName}} fue desactivado, con efecto a partir del {{effectiveDate}}"
        }
      },
      ["in_app" /* IN_APP */]: {
        subject: "{{serviceType}} Deactivated",
        content: "{{serviceType}} for {{customerName}} deactivated, effective {{effectiveDate}}",
        es: {
          subject: "{{serviceType}} desactivado",
          content: "{{serviceType}} para {{customerName}} fue desactivado, con efecto a partir del {{effectiveDate}}"
        }
      }
    }
  },
  ["crew_visits_dispatched" /* CREW_VISITS_DISPATCHED */]: {
    type: "crew_visits_dispatched" /* CREW_VISITS_DISPATCHED */,
    channels: {
      ["push" /* PUSH */]: {
        subject: "Visits Dispatched",
        content: "{{visitCount}} visits dispatched to your crew",
        es: {
          subject: "Visitas despachadas",
          content: "Se despacharon {{visitCount}} visitas a tu equipo"
        }
      },
      ["in_app" /* IN_APP */]: {
        subject: "Visits Dispatched",
        content: "{{visitCount}} visits dispatched to your crew",
        es: {
          subject: "Visitas despachadas",
          content: "Se despacharon {{visitCount}} visitas a tu equipo"
        }
      }
    }
  },
  ["crew_member_added" /* CREW_MEMBER_ADDED */]: {
    type: "crew_member_added" /* CREW_MEMBER_ADDED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Crew Member Added",
        content: "{{memberName}} was added to {{crewName}} as {{crewRole}}",
        actionText: "View",
        es: {
          subject: "Miembro agregado al equipo",
          content: "{{memberName}} fue agregado a {{crewName}} como {{crewRole}}",
          actionText: "Ver"
        }
      }
    }
  },
  ["crew_inactive_2h" /* CREW_INACTIVE_2H */]: {
    type: "crew_inactive_2h" /* CREW_INACTIVE_2H */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Crew member inactive over 2 hours",
        content: "{{memberName}} has been clocked in but inactive for {{inactiveMinutes}} minutes",
        actionText: "Review",
        es: {
          subject: "Miembro inactivo por m\xE1s de 2 horas",
          content: "{{memberName}} est\xE1 con entrada marcada pero lleva {{inactiveMinutes}} minutos sin actividad",
          actionText: "Revisar"
        }
      },
      ["push" /* PUSH */]: {
        subject: "Crew member inactive",
        content: "{{memberName}} has been clocked in but inactive for over 2 hours",
        es: {
          subject: "Miembro inactivo",
          content: "{{memberName}} tiene la entrada marcada pero lleva m\xE1s de 2 horas sin actividad"
        }
      }
    }
  },
  // New alerts name a cause the office can act on (RUT-3395). `permissionOff`
  // and `phoneOnlineAfterSilence` take precedence. The RUT-3172 never-shared /
  // this-shift / dropout copy stays for older stored payloads that still have
  // those flags and no cause.
  ["crew_location_dropped" /* CREW_LOCATION_DROPPED */]: {
    type: "crew_location_dropped" /* CREW_LOCATION_DROPPED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "{{#permissionOff}}Crew location permission is off{{/permissionOff}}{{^permissionOff}}{{#phoneOnlineAfterSilence}}Crew phone is online but not sharing location{{/phoneOnlineAfterSilence}}{{/permissionOff}}{{^permissionOff}}{{^phoneOnlineAfterSilence}}{{#noLocationThisShift}}{{#noLocationOnRecord}}Crew member has never shared location{{/noLocationOnRecord}}{{^noLocationOnRecord}}Crew member has not shared location this shift{{/noLocationOnRecord}}{{/noLocationThisShift}}{{^noLocationThisShift}}Crew location tracking stopped{{/noLocationThisShift}}{{/phoneOnlineAfterSilence}}{{/permissionOff}}",
        content: "{{#permissionOff}}{{memberName}} has been clocked in with no location update for {{minutesSincePing}} minutes. Location permission is off on their phone \u2014 ask them to re-enable Always and precise location.{{/permissionOff}}{{^permissionOff}}{{#phoneOnlineAfterSilence}}{{memberName}} has been clocked in with no location update for {{minutesSincePing}} minutes. Their phone reached us after location went quiet \u2014 ask them to open the Ruta crew app so tracking can start again.{{/phoneOnlineAfterSilence}}{{/permissionOff}}{{^permissionOff}}{{^phoneOnlineAfterSilence}}{{^noLocationThisShift}}{{memberName}} has been clocked in with no location update for {{minutesSincePing}} minutes \u2014 check that location sharing is still on for their phone.{{/noLocationThisShift}}{{#noLocationThisShift}}{{#noLocationOnRecord}}{{memberName}} has been clocked in for {{minutesSinceClockIn}} minutes and has never shared a location \u2014 there is none on record for them at all. The Ruta app is most likely not installed or not signed in on their own phone.{{/noLocationOnRecord}}{{^noLocationOnRecord}}{{memberName}} has been clocked in for {{minutesSinceClockIn}} minutes and has not shared a location once this shift \u2014 check that the Ruta app is open and location sharing is on for their phone.{{/noLocationOnRecord}}{{/noLocationThisShift}}{{/phoneOnlineAfterSilence}}{{/permissionOff}}",
        actionText: "Review",
        es: {
          subject: "{{#permissionOff}}El permiso de ubicaci\xF3n est\xE1 desactivado{{/permissionOff}}{{^permissionOff}}{{#phoneOnlineAfterSilence}}El tel\xE9fono est\xE1 en l\xEDnea pero no comparte ubicaci\xF3n{{/phoneOnlineAfterSilence}}{{/permissionOff}}{{^permissionOff}}{{^phoneOnlineAfterSilence}}{{#noLocationThisShift}}{{#noLocationOnRecord}}El miembro nunca ha compartido su ubicaci\xF3n{{/noLocationOnRecord}}{{^noLocationOnRecord}}El miembro no ha compartido ubicaci\xF3n en este turno{{/noLocationOnRecord}}{{/noLocationThisShift}}{{^noLocationThisShift}}Se perdi\xF3 la ubicaci\xF3n del miembro{{/noLocationThisShift}}{{/phoneOnlineAfterSilence}}{{/permissionOff}}",
          content: "{{#permissionOff}}{{memberName}} tiene la entrada marcada y no ha enviado ubicaci\xF3n en {{minutesSincePing}} minutos. El permiso de ubicaci\xF3n est\xE1 desactivado \u2014 p\xEDdele que reactive Siempre y la ubicaci\xF3n precisa.{{/permissionOff}}{{^permissionOff}}{{#phoneOnlineAfterSilence}}{{memberName}} tiene la entrada marcada y no ha enviado ubicaci\xF3n en {{minutesSincePing}} minutos. Su tel\xE9fono se conect\xF3 despu\xE9s de que se silenci\xF3 la ubicaci\xF3n \u2014 p\xEDdele que abra la app de Ruta para que se reanude el rastreo.{{/phoneOnlineAfterSilence}}{{/permissionOff}}{{^permissionOff}}{{^phoneOnlineAfterSilence}}{{^noLocationThisShift}}{{memberName}} tiene la entrada marcada y no ha enviado ubicaci\xF3n en {{minutesSincePing}} minutos \u2014 verifica que el tel\xE9fono siga compartiendo la ubicaci\xF3n.{{/noLocationThisShift}}{{#noLocationThisShift}}{{#noLocationOnRecord}}{{memberName}} lleva {{minutesSinceClockIn}} minutos con la entrada marcada y nunca ha compartido una ubicaci\xF3n \u2014 no hay ninguna registrada. Es muy probable que la app de Ruta no est\xE9 instalada o sin sesi\xF3n iniciada en su propio tel\xE9fono.{{/noLocationOnRecord}}{{^noLocationOnRecord}}{{memberName}} lleva {{minutesSinceClockIn}} minutos con la entrada marcada y no ha compartido ninguna ubicaci\xF3n en este turno \u2014 verifica que la app de Ruta est\xE9 abierta y que el tel\xE9fono comparta la ubicaci\xF3n.{{/noLocationOnRecord}}{{/noLocationThisShift}}{{/phoneOnlineAfterSilence}}{{/permissionOff}}",
          actionText: "Revisar"
        }
      },
      ["push" /* PUSH */]: {
        subject: "{{#permissionOff}}Crew location permission is off{{/permissionOff}}{{^permissionOff}}{{#phoneOnlineAfterSilence}}Crew phone online, not sharing location{{/phoneOnlineAfterSilence}}{{/permissionOff}}{{^permissionOff}}{{^phoneOnlineAfterSilence}}{{#noLocationThisShift}}{{#noLocationOnRecord}}Crew member never shared location{{/noLocationOnRecord}}{{^noLocationOnRecord}}No crew location this shift{{/noLocationOnRecord}}{{/noLocationThisShift}}{{^noLocationThisShift}}Crew location stopped{{/noLocationThisShift}}{{/phoneOnlineAfterSilence}}{{/permissionOff}}",
        content: "{{#permissionOff}}{{#lastKnownAt}}Last known at {{lastKnownAt}}. {{/lastKnownAt}}Ask {{memberName}} to re-enable Always and precise location.{{/permissionOff}}{{^permissionOff}}{{#phoneOnlineAfterSilence}}{{#lastKnownAt}}Last known at {{lastKnownAt}}. {{/lastKnownAt}}Ask {{memberName}} to open the Ruta crew app.{{/phoneOnlineAfterSilence}}{{/permissionOff}}{{^permissionOff}}{{^phoneOnlineAfterSilence}}{{^noLocationThisShift}}{{#lastKnownAt}}{{memberName}}'s location has not been known since {{lastKnownAt}} while clocked in. Ask them to open the Ruta app.{{/lastKnownAt}}{{^lastKnownAt}}{{memberName}}'s location has not been known while clocked in. Ask them to open the Ruta app.{{/lastKnownAt}}{{/noLocationThisShift}}{{#noLocationThisShift}}{{#noLocationOnRecord}}{{memberName}} has never shared a location \u2014 the Ruta app is probably not on their phone.{{/noLocationOnRecord}}{{^noLocationOnRecord}}{{memberName}} has not shared a location once since clocking in. Ask them to open the Ruta app.{{/noLocationOnRecord}}{{/noLocationThisShift}}{{/phoneOnlineAfterSilence}}{{/permissionOff}}",
        es: {
          subject: "{{#permissionOff}}El permiso de ubicaci\xF3n est\xE1 desactivado{{/permissionOff}}{{^permissionOff}}{{#phoneOnlineAfterSilence}}Tel\xE9fono en l\xEDnea, sin ubicaci\xF3n{{/phoneOnlineAfterSilence}}{{/permissionOff}}{{^permissionOff}}{{^phoneOnlineAfterSilence}}{{#noLocationThisShift}}{{#noLocationOnRecord}}El miembro nunca ha compartido su ubicaci\xF3n{{/noLocationOnRecord}}{{^noLocationOnRecord}}Sin ubicaci\xF3n en este turno{{/noLocationOnRecord}}{{/noLocationThisShift}}{{^noLocationThisShift}}Se perdi\xF3 la ubicaci\xF3n{{/noLocationThisShift}}{{/phoneOnlineAfterSilence}}{{/permissionOff}}",
          content: "{{#permissionOff}}{{#lastKnownAt}}\xDAltima ubicaci\xF3n conocida a las {{lastKnownAt}}. {{/lastKnownAt}}P\xEDdele a {{memberName}} que reactive Siempre y la ubicaci\xF3n precisa.{{/permissionOff}}{{^permissionOff}}{{#phoneOnlineAfterSilence}}{{#lastKnownAt}}\xDAltima ubicaci\xF3n conocida a las {{lastKnownAt}}. {{/lastKnownAt}}P\xEDdele a {{memberName}} que abra la app de Ruta.{{/phoneOnlineAfterSilence}}{{/permissionOff}}{{^permissionOff}}{{^phoneOnlineAfterSilence}}{{^noLocationThisShift}}{{#lastKnownAt}}La ubicaci\xF3n de {{memberName}} no se conoce desde las {{lastKnownAt}} con la entrada marcada. P\xEDdele que abra la app de Ruta.{{/lastKnownAt}}{{^lastKnownAt}}La ubicaci\xF3n de {{memberName}} no se conoce con la entrada marcada. P\xEDdele que abra la app de Ruta.{{/lastKnownAt}}{{/noLocationThisShift}}{{#noLocationThisShift}}{{#noLocationOnRecord}}{{memberName}} nunca ha compartido una ubicaci\xF3n \u2014 es probable que la app de Ruta no est\xE9 en su tel\xE9fono.{{/noLocationOnRecord}}{{^noLocationOnRecord}}{{memberName}} no ha compartido ninguna ubicaci\xF3n desde que marc\xF3 entrada. P\xEDdele que abra la app de Ruta.{{/noLocationOnRecord}}{{/noLocationThisShift}}{{/phoneOnlineAfterSilence}}{{/permissionOff}}"
        }
      }
    }
  },
  ["crew_left_geofence" /* CREW_LEFT_GEOFENCE */]: {
    type: "crew_left_geofence" /* CREW_LEFT_GEOFENCE */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Crew left a visit's property",
        content: "{{memberName}} has been away from {{customerName}}'s property for {{minutesOutside}} minutes without clocking out of the visit.",
        actionText: "Review",
        es: {
          subject: "El equipo sali\xF3 de la propiedad de una visita",
          content: "{{memberName}} lleva {{minutesOutside}} minutos fuera de la propiedad de {{customerName}} sin marcar la salida de la visita.",
          actionText: "Revisar"
        }
      },
      ["push" /* PUSH */]: {
        subject: "Crew left without clocking out",
        content: "{{memberName}} left {{customerName}}'s property without clocking out of the visit.",
        es: {
          subject: "El equipo sali\xF3 sin marcar la salida",
          content: "{{memberName}} sali\xF3 de la propiedad de {{customerName}} sin marcar la salida de la visita."
        }
      }
    }
  },
  ["crew_app_outdated" /* CREW_APP_OUTDATED */]: {
    type: "crew_app_outdated" /* CREW_APP_OUTDATED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Crew app needs a store update",
        content: "{{memberName}} is on app v{{appVersion}}. The oldest supported version is v{{minSupportedAppVersion}}. Over-the-air updates can no longer reach their phone \u2014 ask them to update from the App Store or Play Store.",
        actionText: "Review",
        es: {
          subject: "La app del equipo necesita actualizarse desde la tienda",
          content: "{{memberName}} tiene la app v{{appVersion}}. La versi\xF3n m\xE1s antigua admitida es v{{minSupportedAppVersion}}. Las actualizaciones por aire ya no llegan a su tel\xE9fono \u2014 p\xEDdele que actualice desde App Store o Play Store.",
          actionText: "Revisar"
        }
      },
      ["push" /* PUSH */]: {
        subject: "Crew app needs a store update",
        content: "{{memberName}} is on v{{appVersion}} \u2014 ask them to update from the App Store or Play Store.",
        es: {
          subject: "La app del equipo necesita actualizarse",
          content: "{{memberName}} tiene la v{{appVersion}} \u2014 p\xEDdele que actualice desde App Store o Play Store."
        }
      }
    }
  },
  ["crew_urgent_message_acknowledged" /* CREW_URGENT_MESSAGE_ACKNOWLEDGED */]: {
    type: "crew_urgent_message_acknowledged" /* CREW_URGENT_MESSAGE_ACKNOWLEDGED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Urgent message acknowledged",
        content: "{{memberName}} acknowledged your urgent message.",
        actionText: "View",
        es: {
          subject: "Mensaje urgente confirmado",
          content: "{{memberName}} confirm\xF3 tu mensaje urgente.",
          actionText: "Ver"
        }
      }
    }
  },
  ["crew_note_acknowledged" /* CREW_NOTE_ACKNOWLEDGED */]: {
    type: "crew_note_acknowledged" /* CREW_NOTE_ACKNOWLEDGED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Note acknowledged",
        content: "{{memberName}} acknowledged {{noteLabel}}.",
        actionText: "View",
        es: {
          subject: "Nota confirmada",
          content: "{{memberName}} confirm\xF3 {{noteLabel}}.",
          actionText: "Ver"
        }
      }
    }
  },
  ["one_time_deadline_at_risk" /* ONE_TIME_DEADLINE_AT_RISK */]: {
    type: "one_time_deadline_at_risk" /* ONE_TIME_DEADLINE_AT_RISK */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "One-time service deadline at risk",
        content: "{{serviceName}} for {{customerName}} is due by {{dueDate}} and has no visit scheduled yet \u2014 dispatch it soon.",
        actionText: "Review",
        es: {
          subject: "Fecha l\xEDmite de servicio \xFAnico en riesgo",
          content: "{{serviceName}} para {{customerName}} debe completarse antes del {{dueDate}} y a\xFAn no tiene una visita programada \u2014 desp\xE1chalo pronto.",
          actionText: "Revisar"
        }
      },
      ["push" /* PUSH */]: {
        subject: "One-time service deadline at risk",
        content: "{{serviceName}} for {{customerName}} is due by {{dueDate}} with no visit scheduled yet.",
        es: {
          subject: "Fecha l\xEDmite de servicio \xFAnico en riesgo",
          content: "{{serviceName}} para {{customerName}} debe completarse antes del {{dueDate}} y a\xFAn no tiene una visita programada."
        }
      }
    }
  },
  // Payment & Invoice Templates
  ["payment_successful" /* PAYMENT_SUCCESSFUL */]: {
    type: "payment_successful" /* PAYMENT_SUCCESSFUL */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "Payment Received - Thank You!",
        preview: "Your payment of {{amount}} has been processed",
        content: `Thank you for your payment!

Amount: {{amount}}
Invoice #: {{invoiceId}}
Payment Date: {{paymentDate}}

Your receipt is available for download.`,
        actionText: "Download Receipt"
      },
      ["sms" /* SMS */]: {
        content: "Payment of {{amount}} received. Thank you!"
      }
    }
  },
  ["visit_payment_received" /* VISIT_PAYMENT_RECEIVED */]: {
    type: "visit_payment_received" /* VISIT_PAYMENT_RECEIVED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "{{amount}} from {{customerName}}",
        content: "{{#serviceName}}{{serviceName}} \u2014 p{{/serviceName}}{{^serviceName}}P{{/serviceName}}ayment received.",
        actionText: "View visit",
        es: {
          subject: "{{amount}} de {{customerName}}",
          content: "{{#serviceName}}{{serviceName}} \u2014 p{{/serviceName}}{{^serviceName}}P{{/serviceName}}ago recibido.",
          actionText: "Ver visita"
        }
      }
    }
  },
  ["batch_charge_completed" /* BATCH_CHARGE_COMPLETED */]: {
    type: "batch_charge_completed" /* BATCH_CHARGE_COMPLETED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        // `isRetry` switches to the morning retry run's wording ("recovered",
        // "still could not be charged"); the nightly batch run omits it and
        // renders exactly as before.
        subject: "{{#isPackage}}{{totalCollected}} in package charges{{/isPackage}}{{^isPackage}}{{totalCollected}} {{#isRetry}}recovered this morning{{/isRetry}}{{^isRetry}}collected overnight{{/isRetry}}{{/isPackage}}",
        content: "{{#isPackage}}{{chargedCustomers}} package{{^oneCustomer}}s{{/oneCustomer}} charged.{{#failedCustomers}} {{failedCustomers}} failed{{#failedNames}}: {{failedNames}}{{/failedNames}}.{{/failedCustomers}}{{#skippedCount}} {{skippedCount}} skipped.{{/skippedCount}}{{/isPackage}}{{^isPackage}}{{chargedCustomers}} customer{{^oneCustomer}}s{{/oneCustomer}} charged across {{chargedVisits}} visit{{^oneVisit}}s{{/oneVisit}}.{{#failedCustomers}} {{failedCustomers}} {{#isRetry}}still {{/isRetry}}could not be charged.{{/failedCustomers}}{{/isPackage}}",
        es: {
          subject: "{{#isPackage}}{{totalCollected}} en cargos de paquete{{/isPackage}}{{^isPackage}}{{totalCollected}} {{#isRetry}}recuperados esta ma\xF1ana{{/isRetry}}{{^isRetry}}cobrados durante la noche{{/isRetry}}{{/isPackage}}",
          content: "{{#isPackage}}{{chargedCustomers}} paquete{{^oneCustomer}}s{{/oneCustomer}} cobrado{{^oneCustomer}}s{{/oneCustomer}}.{{#failedCustomers}} {{failedCustomers}} fallaron{{#failedNames}}: {{failedNames}}{{/failedNames}}.{{/failedCustomers}}{{#skippedCount}} {{skippedCount}} omitidos.{{/skippedCount}}{{/isPackage}}{{^isPackage}}{{chargedCustomers}} cliente{{^oneCustomer}}s{{/oneCustomer}} cobrado{{^oneCustomer}}s{{/oneCustomer}} en {{chargedVisits}} visita{{^oneVisit}}s{{/oneVisit}}.{{#failedCustomers}} {{failedCustomers}} {{#isRetry}}a\xFAn {{/isRetry}}no se pudieron cobrar.{{/failedCustomers}}{{/isPackage}}"
        }
      }
    }
  },
  ["payment_failed" /* PAYMENT_FAILED */]: {
    type: "payment_failed" /* PAYMENT_FAILED */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "Payment Issue - Action Required",
        preheader: "Please update your payment method",
        content: `
    <p style="font-size: 16px; margin-bottom: 20px;">Hi {{customerFirstName}},</p>

    <p style="font-size: 16px; margin-bottom: 20px;">We were unable to process your payment. Please update your payment method.</p>

    <div style="background-color: #f3f4f6; border-left: 4px solid #0a1f0a; padding: 20px; margin: 20px 0; border-radius: 0 8px 8px 0;">
      {{#amount}}<p style="margin: 0 0 5px 0; font-size: 14px; color: #4b5563;"><strong>Amount Due:</strong> {{amount}}</p>{{/amount}}
      {{#invoiceId}}<p style="margin: 0; font-size: 14px; color: #4b5563;"><strong>Invoice:</strong> {{invoiceId}}</p>{{/invoiceId}}
    </div>
  `,
        action: {
          label: "Update Payment Method",
          url: "{{paymentLink}}"
        }
      },
      ["sms" /* SMS */]: {
        content: "{{customerFirstName}}, there was an issue processing your payment for {{orgName}}. Please update your payment method: {{paymentLink}}"
      },
      ["in_app" /* IN_APP */]: {
        subject: "Payment failed for {{customerName}}",
        content: "{{failureReason}}. Amount: {{amount}}",
        actionText: "Retry",
        es: {
          subject: "Pago fallido de {{customerName}}",
          content: "{{failureReason}}. Monto: {{amount}}",
          actionText: "Reintentar"
        }
      }
    }
  },
  ["customer_add_card_reminder" /* CUSTOMER_ADD_CARD_REMINDER */]: {
    type: "customer_add_card_reminder" /* CUSTOMER_ADD_CARD_REMINDER */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "Your {{orgName}} balance: please add a card",
        preheader: "Add a card so we can charge your balance",
        content: `
    <p style="font-size: 16px; margin-bottom: 20px;">Hi {{customerFirstName}},</p>

    <p style="font-size: 16px; margin-bottom: 20px;">You have a balance of <strong>{{balanceDue}}</strong> with {{orgName}}. We don't have a card on file for you, so we weren't able to charge it.</p>

    <div style="background-color: #f3f4f6; border-left: 4px solid #0a1f0a; padding: 20px; margin: 20px 0; border-radius: 0 8px 8px 0;">
      <p style="margin: 0; font-size: 14px; color: #4b5563;"><strong>Balance due {{balanceDue}}</strong></p>
    </div>

    <p style="font-size: 16px; margin-bottom: 20px;">Add a card in your {{orgName}} account and we'll charge this balance and any future charges to it.</p>

    {{#orgPhone}}
    <p style="font-size: 16px; margin-bottom: 20px;">Questions? Reply to this email or call us at {{orgPhone}}.</p>
    {{/orgPhone}}

    <p style="font-size: 16px; margin-bottom: 20px;">Thanks,<br>{{orgName}}</p>
  `,
        action: {
          label: "Add card",
          url: "{{addCardLink}}"
        }
      },
      ["sms" /* SMS */]: {
        content: "Hi {{customerFirstName}}, it's {{orgName}}. You have a balance of {{balanceDue}} and we don't have a card on file to charge it. Add one here: {{addCardLink}}{{#orgPhone}} Questions? Call {{orgPhone}}.{{/orgPhone}}"
      }
    }
  },
  ["payment_retry" /* PAYMENT_RETRY */]: {
    type: "payment_retry" /* PAYMENT_RETRY */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "Payment Retry Reminder",
        preview: "Please retry your payment of {{amount}}",
        content: `This is a reminder to retry your payment.

Amount Due: {{amount}}
Invoice #: {{invoiceId}}
Retry Attempt: {{retryCount}}

Please update your payment method if needed.`,
        actionText: "Retry Payment"
      },
      ["sms" /* SMS */]: {
        content: "Reminder: {{amount}} payment due. Retry attempt {{retryCount}}."
      }
    }
  },
  ["payment_overdue" /* PAYMENT_OVERDUE */]: {
    type: "payment_overdue" /* PAYMENT_OVERDUE */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "Payment Overdue - {{daysOverdue}} Days",
        preview: "Your payment is {{daysOverdue}} days overdue",
        content: `Your payment is now {{daysOverdue}} days overdue.

Amount Due: {{amount}}
Invoice #: {{invoiceId}}

Please make payment to avoid service interruption.`,
        actionText: "Pay Now"
      },
      ["in_app" /* IN_APP */]: {
        subject: "Payment Overdue",
        content: "{{amount}} is {{daysOverdue}} days overdue",
        actionText: "Pay",
        es: {
          subject: "Pago vencido",
          content: "{{amount}} lleva {{daysOverdue}} d\xEDas vencido",
          actionText: "Pagar"
        }
      }
    }
  },
  ["invoice_ready" /* INVOICE_READY */]: {
    type: "invoice_ready" /* INVOICE_READY */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "Invoice {{invoiceNumber}} Ready",
        preview: "Your invoice for {{amount}} is ready",
        content: `Your invoice is ready for viewing.

Invoice #: {{invoiceNumber}}
Amount: {{amount}}

You can download a PDF copy for your records.`,
        actionText: "View Invoice"
      }
    }
  },
  ["payment_method_added" /* PAYMENT_METHOD_ADDED */]: {
    type: "payment_method_added" /* PAYMENT_METHOD_ADDED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Payment Method Added",
        content: "{{customerName}} added a {{paymentMethodType}}",
        actionText: "View",
        es: {
          subject: "M\xE9todo de pago agregado",
          content: "{{customerName}} agreg\xF3 un m\xE9todo de pago ({{paymentMethodType}})",
          actionText: "Ver"
        }
      },
      ["push" /* PUSH */]: {
        subject: "Payment Method Added",
        content: "{{customerName}} added a {{paymentMethodType}}",
        es: {
          subject: "M\xE9todo de pago agregado",
          content: "{{customerName}} agreg\xF3 un m\xE9todo de pago ({{paymentMethodType}})"
        }
      }
    }
  },
  // Service Management Templates
  ["service_completed" /* SERVICE_COMPLETED */]: {
    type: "service_completed" /* SERVICE_COMPLETED */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "Service Completed",
        preview: "Your service has been completed",
        content: `Your service has been completed successfully!

Service ID: {{serviceId}}
Completion Date: {{completionDate}}

Thank you for your business!`
      },
      ["sms" /* SMS */]: {
        content: "Service completed on {{completionDate}}. Thank you!"
      }
    }
  },
  ["service_activated" /* SERVICE_ACTIVATED */]: {
    type: "service_activated" /* SERVICE_ACTIVATED */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "Service Activated - {{orgName}}",
        preheader: "Your service is now active",
        content: `
    <p style="font-size: 16px; margin-bottom: 20px;">Hi {{customerFirstName}},</p>

    <p style="font-size: 16px; margin-bottom: 20px;">Your {{serviceName}} service with {{orgName}} is now active. We are grateful to serve you and we appreciate the added work!</p>
  `,
        action: {
          label: "Review Your Services",
          url: "{{portalLink}}/services"
        }
      },
      ["sms" /* SMS */]: {
        content: "Hi {{customerFirstName}}, your {{serviceName}} service with {{orgName}} is now active. We are grateful to serve you and we appreciate the added work!"
      },
      ["in_app" /* IN_APP */]: {
        subject: "Service Activated",
        content: "{{serviceName}} is now active",
        actionText: "View",
        es: {
          subject: "Servicio activado",
          content: "{{serviceName}} ya est\xE1 activo",
          actionText: "Ver"
        }
      }
    }
  },
  ["service_enrollment_scheduled" /* SERVICE_ENROLLMENT_SCHEDULED */]: {
    type: "service_enrollment_scheduled" /* SERVICE_ENROLLMENT_SCHEDULED */,
    channels: {
      ["sms" /* SMS */]: {
        content: "Hi {{customerFirstName}}, your {{serviceName}} service with {{orgName}} is activated and starts {{startDate}}."
      },
      ["in_app" /* IN_APP */]: {
        subject: "Service Starting Later",
        content: "{{serviceName}} activated, starts {{startDate}}",
        actionText: "View",
        es: {
          subject: "Servicio con inicio posterior",
          content: "{{serviceName}} activado, comienza {{startDate}}",
          actionText: "Ver"
        }
      }
    }
  },
  ["service_suspended" /* SERVICE_SUSPENDED */]: {
    type: "service_suspended" /* SERVICE_SUSPENDED */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "Service Suspended",
        preview: "Your service has been temporarily suspended",
        content: `Your service has been suspended.

Subscription ID: {{subscriptionId}}
Reason: {{suspendReason}}

Please contact us to resolve this issue.`,
        actionText: "Contact Support"
      },
      ["in_app" /* IN_APP */]: {
        subject: "Service Suspended",
        content: "Reason: {{suspendReason}}",
        actionText: "Resolve",
        es: {
          subject: "Servicio suspendido",
          content: "Motivo: {{suspendReason}}",
          actionText: "Resolver"
        }
      }
    }
  },
  ["service_cancelled" /* SERVICE_CANCELLED */]: {
    type: "service_cancelled" /* SERVICE_CANCELLED */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "{{serviceName}} has been deactivated",
        preview: "Your {{serviceName}} service has been deactivated",
        content: `Hi {{customerFirstName}},

Your {{serviceName}} service with {{orgName}} has been deactivated effective {{cancelDate}}.
{{#customMessage}}

{{customMessage}}
{{/customMessage}}

If you have any questions, please reach out to us.`,
        action: {
          label: "View Your Profile",
          url: "{{portalLink}}"
        }
      },
      ["sms" /* SMS */]: {
        content: "Hi {{customerFirstName}}, your {{serviceName}} with {{orgName}} has been deactivated.{{#customMessage}} {{customMessage}}{{/customMessage}} If you have any questions, please reach out to us."
      },
      ["in_app" /* IN_APP */]: {
        subject: "{{serviceName}} Deactivated",
        content: "{{serviceName}} deactivated effective {{cancelDate}}",
        es: {
          subject: "{{serviceName}} desactivado",
          content: "{{serviceName}} desactivado con efecto a partir del {{cancelDate}}"
        }
      }
    }
  },
  ["service_deactivation_completed" /* SERVICE_DEACTIVATION_COMPLETED */]: {
    type: "service_deactivation_completed" /* SERVICE_DEACTIVATION_COMPLETED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "{{serviceName}} deactivated",
        content: "{{customerName}}\u2019s {{serviceName}} reached its scheduled deactivation date ({{deactivatedDate}})",
        actionText: "View",
        es: {
          subject: "{{serviceName}} desactivado",
          content: "{{serviceName}} de {{customerName}} lleg\xF3 a su fecha de desactivaci\xF3n programada ({{deactivatedDate}})",
          actionText: "Ver"
        }
      }
    }
  },
  // Subscription Templates
  ["subscription_requested" /* SUBSCRIPTION_REQUESTED */]: {
    type: "subscription_requested" /* SUBSCRIPTION_REQUESTED */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "New Rate Request from {{customerName}}",
        preview: "You have a new rate request for {{serviceTemplateName}}",
        content: `You have a new rate request from {{customerName}} for {{serviceTemplateName}} service.

{{#customerNotes}}
Customer notes: "{{customerNotes}}"
{{/customerNotes}}

Please review and provide pricing through your admin dashboard.`,
        actionText: "View Customer"
      },
      ["in_app" /* IN_APP */]: {
        subject: "New Rate Request",
        content: "{{customerName}} requested a rate for {{serviceTemplateName}}",
        actionText: "View",
        es: {
          subject: "Nueva solicitud de tarifa",
          content: "{{customerName}} solicit\xF3 una tarifa para {{serviceTemplateName}}",
          actionText: "Ver"
        }
      },
      ["push" /* PUSH */]: {
        subject: "New Rate Request",
        content: "{{customerName}} requested a rate for {{serviceTemplateName}}",
        es: {
          subject: "Nueva solicitud de tarifa",
          content: "{{customerName}} solicit\xF3 una tarifa para {{serviceTemplateName}}"
        }
      }
    }
  },
  ["subscription_rate_provided" /* SUBSCRIPTION_RATE_PROVIDED */]: {
    type: "subscription_rate_provided" /* SUBSCRIPTION_RATE_PROVIDED */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "{{orgName}} - Service Rate Available",
        preview: "Pricing is ready for {{serviceTemplateName}}",
        content: `Hi {{customerFirstName}}!

{{orgName}} has provided pricing for {{serviceTemplateName}}.

{{customMessage}}

View details and respond: {{portalLink}}`,
        actionText: "View Details"
      },
      ["sms" /* SMS */]: {
        content: "Hi {{customerFirstName}}! {{orgName}} has pricing for {{serviceTemplateName}}. View: {{portalLink}}"
      }
    }
  },
  ["subscription_batch_rates_released" /* SUBSCRIPTION_BATCH_RATES_RELEASED */]: {
    type: "subscription_batch_rates_released" /* SUBSCRIPTION_BATCH_RATES_RELEASED */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "Your Rates Are Ready",
        preheader: "Review and accept your personalized rates",
        content: `
    <p style="font-size: 16px; margin-bottom: 20px; text-align: left;">Hi {{customerFirstName}},</p>

    <p style="font-size: 16px; margin-bottom: 20px; text-align: left;">Your rates are ready. Review your services and activate with one click.</p>

    {{#customMessage}}<div style="margin-bottom: 20px;"><p style="font-size: 16px; margin: 0; text-align: left;">{{customMessage}}</p></div>{{/customMessage}}

    {{#pendingRatesNote}}<div style="margin-bottom: 20px;"><p style="font-size: 16px; margin: 0; text-align: left;">{{pendingRatesNote}}</p></div>{{/pendingRatesNote}}
  `,
        action: {
          label: "View Your Services",
          url: "{{ratesLink}}"
        }
      },
      ["sms" /* SMS */]: {
        content: "{{#customMessage}}Hi {{customerFirstName}}, {{customMessage}} {{ratesLink}}{{/customMessage}}{{^customMessage}}Hi {{customerFirstName}} - Your personalized rates from {{orgName}} are ready. View and accept here: {{ratesLink}}{{/customMessage}}{{#pendingRatesNote}} {{pendingRatesNote}}{{/pendingRatesNote}}"
      }
    }
  },
  ["subscription_rate_not_yet_available" /* SUBSCRIPTION_RATE_NOT_YET_AVAILABLE */]: {
    type: "subscription_rate_not_yet_available" /* SUBSCRIPTION_RATE_NOT_YET_AVAILABLE */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "We received your request",
        preheader: "We're still finalizing these rates",
        content: `
    <p style="font-size: 16px; margin-bottom: 20px; text-align: left;">We're still finalizing {{pendingServiceNames}} rates for the upcoming season and will send them your way as soon as they're available. Thank you for your patience.</p>
  `
      },
      ["sms" /* SMS */]: {
        content: "We're still finalizing {{pendingServiceNames}} rates for the upcoming season and will send them your way as soon as they're available. Thank you for your patience."
      }
    }
  },
  ["subscription_batch_cancelled" /* SUBSCRIPTION_BATCH_CANCELLED */]: {
    type: "subscription_batch_cancelled" /* SUBSCRIPTION_BATCH_CANCELLED */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "{{orgName}} - Service Deactivation Notice",
        preview: "Your services have been deactivated",
        content: `Hi {{customerFirstName}}!

We're writing to inform you that your {{orgName}} services have been deactivated.

Deactivated services:
{{#subscriptions}}
\u2022 {{serviceTemplateName}}
{{/subscriptions}}

Reason: {{cancellationReason}}
{{#cancellationDate}}
Effective date: {{cancellationDate}}
{{/cancellationDate}}
{{#customMessage}}

{{customMessage}}
{{/customMessage}}

All scheduled visits for these services have been cancelled. If you have any questions or would like to restart services in the future, please contact us.

Thank you for choosing {{orgName}}.

Best regards,
The {{orgName}} Team`,
        actionText: "Contact Us"
      },
      ["sms" /* SMS */]: {
        content: "{{orgName}}: Your services have been deactivated.\n\nServices:\n{{#subscriptions}}\u2022 {{serviceTemplateName}}\n{{/subscriptions}}\nReason: {{cancellationReason}}.{{#customMessage}} {{customMessage}}{{/customMessage}} Contact us with questions."
      },
      ["in_app" /* IN_APP */]: {
        subject: "Services Deactivated",
        content: "Your {{orgName}} services have been deactivated: {{cancellationReason}}{{#customMessage}} \u2014 {{customMessage}}{{/customMessage}}",
        es: {
          subject: "Servicios desactivados",
          content: "Tus servicios de {{orgName}} fueron desactivados: {{cancellationReason}}{{#customMessage}} \u2014 {{customMessage}}{{/customMessage}}"
        }
      }
    }
  },
  ["subscription_accepted" /* SUBSCRIPTION_ACCEPTED */]: {
    type: "subscription_accepted" /* SUBSCRIPTION_ACCEPTED */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "Rate Accepted - {{customerName}}",
        preview: "{{customerName}} accepted your rate",
        content: `Great news! {{customerName}} has accepted your rate for {{serviceTemplateName}} service.{{#acceptedChoices}}

{{acceptedChoices}}{{/acceptedChoices}}
{{#startDate}}
Requested {{startDate}} \u2014 do not dispatch before then.
{{/startDate}}
{{#customerNotes}}
Customer note: "{{customerNotes}}"
{{/customerNotes}}

Their service is now active. Next step: assign a crew and schedule their first visit.`,
        actionText: "View Customer"
      },
      ["in_app" /* IN_APP */]: {
        subject: "Rate Accepted",
        content: '{{customerName}} accepted {{serviceTemplateName}}{{#acceptedChoices}} ({{acceptedChoices}}){{/acceptedChoices}}{{#startDate}} \xB7 requested {{startDate}}{{/startDate}}{{#customerNotes}} \xB7 "{{customerNotes}}"{{/customerNotes}} \u2014 needs scheduling',
        actionText: "View",
        es: {
          subject: "Tarifa aceptada",
          content: '{{customerName}} acept\xF3 {{serviceTemplateName}}{{#acceptedChoices}} ({{acceptedChoices}}){{/acceptedChoices}}{{#startDate}} \xB7 comienza {{startDate}}{{/startDate}}{{#customerNotes}} \xB7 "{{customerNotes}}"{{/customerNotes}} \u2014 necesita programaci\xF3n',
          actionText: "Ver"
        }
      },
      ["push" /* PUSH */]: {
        subject: "Rate Accepted",
        content: '{{customerName}} accepted {{serviceTemplateName}}{{#acceptedChoices}} ({{acceptedChoices}}){{/acceptedChoices}}{{#startDate}} \xB7 requested {{startDate}}{{/startDate}}{{#customerNotes}} \xB7 "{{customerNotes}}"{{/customerNotes}}',
        es: {
          subject: "Tarifa aceptada",
          content: '{{customerName}} acept\xF3 {{serviceTemplateName}}{{#acceptedChoices}} ({{acceptedChoices}}){{/acceptedChoices}}{{#startDate}} \xB7 comienza {{startDate}}{{/startDate}}{{#customerNotes}} \xB7 "{{customerNotes}}"{{/customerNotes}}'
        }
      }
    }
  },
  ["subscription_paused" /* SUBSCRIPTION_PAUSED */]: {
    type: "subscription_paused" /* SUBSCRIPTION_PAUSED */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "{{serviceName}} Service Paused",
        preview: "Your service has been paused",
        content: `Hi {{customerFirstName}},

Your {{serviceName}} service with {{orgName}} has been paused.

{{#pausedUntil}}
Your service is scheduled to resume on {{pausedUntil}}.
{{/pausedUntil}}

If you have any questions, please don't hesitate to reach out.`,
        actionText: "View Your Services"
      },
      ["sms" /* SMS */]: {
        content: "Hi {{customerFirstName}}, your {{serviceName}} service with {{orgName}} has been paused.{{#pausedUntil}} Scheduled to resume on {{pausedUntil}}.{{/pausedUntil}}"
      },
      ["in_app" /* IN_APP */]: {
        subject: "Service Paused",
        content: "{{serviceName}} has been paused",
        actionText: "View",
        es: {
          subject: "Servicio pausado",
          content: "{{serviceName}} ha sido pausado",
          actionText: "Ver"
        }
      }
    }
  },
  ["subscription_resumed" /* SUBSCRIPTION_RESUMED */]: {
    type: "subscription_resumed" /* SUBSCRIPTION_RESUMED */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "{{serviceName}} Service Resumed",
        preview: "Your service has been resumed",
        content: `Hi {{customerFirstName}},

Your {{serviceName}} service with {{orgName}} has been resumed and is now active.`,
        actionText: "View Your Services"
      },
      ["sms" /* SMS */]: {
        content: "Hi {{customerFirstName}}, your {{serviceName}} service with {{orgName}} has been resumed and is now active."
      },
      ["in_app" /* IN_APP */]: {
        subject: "Service Resumed",
        content: "{{serviceName}} has been resumed",
        actionText: "View",
        es: {
          subject: "Servicio reanudado",
          content: "{{serviceName}} ha sido reanudado",
          actionText: "Ver"
        }
      }
    }
  },
  ["subscription_notes_updated" /* SUBSCRIPTION_NOTES_UPDATED */]: {
    type: "subscription_notes_updated" /* SUBSCRIPTION_NOTES_UPDATED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Customer Notes Updated",
        content: "{{customerName}} updated {{contentDescription}} for {{serviceTemplateName}}",
        actionText: "View",
        es: {
          subject: "Notas del cliente actualizadas",
          content: "{{customerName}} actualiz\xF3 {{contentDescription}} de {{serviceTemplateName}}",
          actionText: "Ver"
        }
      },
      ["push" /* PUSH */]: {
        subject: "Customer Notes Updated",
        content: "{{customerName}} updated {{contentDescription}} for {{serviceTemplateName}}",
        es: {
          subject: "Notas del cliente actualizadas",
          content: "{{customerName}} actualiz\xF3 {{contentDescription}} de {{serviceTemplateName}}"
        }
      }
    }
  },
  ["subscription_customer_selections_changed" /* SUBSCRIPTION_CUSTOMER_SELECTIONS_CHANGED */]: {
    type: "subscription_customer_selections_changed" /* SUBSCRIPTION_CUSTOMER_SELECTIONS_CHANGED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Customer Answers Changed",
        content: "{{customerName}} changed their answers for {{serviceTemplateName}}",
        actionText: "View",
        es: {
          subject: "Respuestas del cliente modificadas",
          content: "{{customerName}} cambi\xF3 sus respuestas para {{serviceTemplateName}}",
          actionText: "Ver"
        }
      },
      ["push" /* PUSH */]: {
        subject: "Customer Answers Changed",
        content: "{{customerName}} changed their answers for {{serviceTemplateName}}",
        es: {
          subject: "Respuestas del cliente modificadas",
          content: "{{customerName}} cambi\xF3 sus respuestas para {{serviceTemplateName}}"
        }
      }
    }
  },
  ["subscription_package_option_changed" /* SUBSCRIPTION_PACKAGE_OPTION_CHANGED */]: {
    type: "subscription_package_option_changed" /* SUBSCRIPTION_PACKAGE_OPTION_CHANGED */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "Your {{serviceName}} plan is now {{newPlanName}}",
        preview: "You switched from {{previousPlanName}} to {{newPlanName}}",
        content: `Hi {{customerFirstName}},

You switched your {{serviceName}} plan with {{orgName}} from {{previousPlanName}} to {{newPlanName}}.`,
        actionText: "View Your Service"
      },
      ["sms" /* SMS */]: {
        content: "Hi {{customerFirstName}}, you switched your {{serviceName}} plan from {{previousPlanName}} to {{newPlanName}}."
      },
      ["in_app" /* IN_APP */]: {
        subject: "Service Plan Changed",
        content: "{{customerName}} switched {{serviceTemplateName}} from {{previousPlanName}} to {{newPlanName}}",
        actionText: "View",
        es: {
          subject: "Plan de servicio cambiado",
          content: "{{customerName}} cambi\xF3 {{serviceTemplateName}} de {{previousPlanName}} a {{newPlanName}}",
          actionText: "Ver"
        }
      },
      ["push" /* PUSH */]: {
        subject: "Service Plan Changed",
        content: "{{customerName}} switched {{serviceTemplateName}} from {{previousPlanName}} to {{newPlanName}}",
        es: {
          subject: "Plan de servicio cambiado",
          content: "{{customerName}} cambi\xF3 {{serviceTemplateName}} de {{previousPlanName}} a {{newPlanName}}"
        }
      }
    }
  },
  ["subscription_plan_change_requested" /* SUBSCRIPTION_PLAN_CHANGE_REQUESTED */]: {
    type: "subscription_plan_change_requested" /* SUBSCRIPTION_PLAN_CHANGE_REQUESTED */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "Plan switch waiting \xB7 {{customerName}} \xB7 {{serviceTemplateName}}",
        preview: "{{previousPlanName}} \u2192 {{newPlanName}}",
        content: `A plan switch is waiting for {{customerName}} on {{serviceTemplateName}}: {{previousPlanName}} \u2192 {{newPlanName}}.

{{#differenceLabel}}Difference: {{differenceLabel}}
{{/differenceLabel}}
Confirm or cancel it from Home or the customer's service.`,
        actionText: "Review switch"
      },
      ["in_app" /* IN_APP */]: {
        subject: "Plan switch waiting",
        content: "{{customerName}} \xB7 {{serviceTemplateName}} {{previousPlanName}} \u2192 {{newPlanName}}{{#differenceLabel}} ({{differenceLabel}}){{/differenceLabel}}",
        actionText: "Review",
        es: {
          subject: "Cambio de plan en espera",
          content: "{{customerName}} \xB7 {{serviceTemplateName}} {{previousPlanName}} \u2192 {{newPlanName}}{{#differenceLabel}} ({{differenceLabel}}){{/differenceLabel}}",
          actionText: "Revisar"
        }
      },
      ["push" /* PUSH */]: {
        subject: "Plan switch waiting",
        content: "{{customerName}} \xB7 {{serviceTemplateName}} {{previousPlanName}} \u2192 {{newPlanName}}",
        es: {
          subject: "Cambio de plan en espera",
          content: "{{customerName}} \xB7 {{serviceTemplateName}} {{previousPlanName}} \u2192 {{newPlanName}}"
        }
      }
    }
  },
  // Job Management Templates
  ["job_review_required" /* JOB_REVIEW_REQUIRED */]: {
    type: "job_review_required" /* JOB_REVIEW_REQUIRED */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "Job Review Required - {{serviceName}}",
        preview: "Job #{{jobId}} for {{customerName}} needs review",
        content: `A completed job requires your review.

Job Details:
\u2022 Job ID: {{jobId}}
\u2022 Customer: {{customerName}}
\u2022 Service: {{serviceName}}
\u2022 Completed At: {{completedAt}}
{{#flaggedBy}}\u2022 Flagged by: {{flaggedBy}}
{{/flaggedBy}}
Review Reason(s):
{{reviewReason}}
{{#reviewNotes}}
Note left when flagged:
{{reviewNotes}}
{{/reviewNotes}}
This job requires manual review before payment can be processed.

Please review and take appropriate action.`,
        actionText: "Review Job"
      },
      ["in_app" /* IN_APP */]: {
        subject: "Review Required - {{customerName}}{{#serviceName}} \xB7 {{serviceName}}{{/serviceName}}",
        content: '{{serviceName}} for {{customerName}}: {{reviewReason}}{{#flaggedBy}} \u2014 flagged by {{flaggedBy}}{{/flaggedBy}}{{#reviewNotes}} ("{{reviewNotes}}"){{/reviewNotes}}',
        actionText: "Review",
        es: {
          subject: "Revisi\xF3n requerida - {{customerName}}{{#serviceName}} \xB7 {{serviceName}}{{/serviceName}}",
          content: '{{serviceName}} para {{customerName}}: {{reviewReason}}{{#flaggedBy}} \u2014 marcado por {{flaggedBy}}{{/flaggedBy}}{{#reviewNotes}} ("{{reviewNotes}}"){{/reviewNotes}}',
          actionText: "Revisar"
        }
      },
      ["push" /* PUSH */]: {
        subject: "Review Required",
        content: "{{customerName}} \u2014 a visit requires review{{#flaggedBy}}, flagged by {{flaggedBy}}{{/flaggedBy}}",
        es: {
          subject: "Revisi\xF3n requerida",
          content: "{{customerName}} \u2014 una visita requiere revisi\xF3n{{#flaggedBy}}, marcada por {{flaggedBy}}{{/flaggedBy}}"
        }
      }
    }
  },
  ["job_approved" /* JOB_APPROVED */]: {
    type: "job_approved" /* JOB_APPROVED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Job Approved",
        content: "Job #{{jobId}} approved by {{approvedBy}}",
        es: {
          subject: "Trabajo aprobado",
          content: "Trabajo #{{jobId}} aprobado por {{approvedBy}}"
        }
      }
    }
  },
  ["job_rejected" /* JOB_REJECTED */]: {
    type: "job_rejected" /* JOB_REJECTED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Job Rejected",
        content: "Job #{{jobId}} rejected: {{rejectionReason}}",
        actionText: "View Details",
        es: {
          subject: "Trabajo rechazado",
          content: "Trabajo #{{jobId}} rechazado: {{rejectionReason}}",
          actionText: "Ver detalles"
        }
      },
      ["email" /* EMAIL */]: {
        subject: "Job Rejected - Action Required",
        preview: "Job #{{jobId}} has been rejected",
        content: `Your job has been rejected and requires attention.

Job ID: {{jobId}}
Reason: {{rejectionReason}}

Please review and make necessary corrections.`,
        actionText: "View Job"
      }
    }
  },
  // System & Admin Templates
  ["system_alert" /* SYSTEM_ALERT */]: {
    type: "system_alert" /* SYSTEM_ALERT */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "[ALERT] {{alertType}}",
        preview: "System alert requiring immediate attention",
        content: `SYSTEM ALERT

Type: {{alertType}}
Message: {{message}}

Please take immediate action.`,
        actionText: "View Details"
      },
      ["sms" /* SMS */]: {
        content: "ALERT: {{alertType}} - {{message}}"
      },
      ["in_app" /* IN_APP */]: {
        subject: "System Alert",
        content: "{{alertType}}: {{message}}",
        actionText: "Acknowledge",
        es: {
          subject: "Alerta del sistema",
          content: "{{alertType}}: {{message}}",
          actionText: "Confirmar"
        }
      }
    }
  },
  ["account_update" /* ACCOUNT_UPDATE */]: {
    type: "account_update" /* ACCOUNT_UPDATE */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "Account Update: {{updateType}}",
        preview: "Your account has been updated",
        content: `Your account has been updated.

Update Type: {{updateType}}
Details: {{details}}

If you did not make this change, please contact support.`,
        actionText: "View Account"
      }
    }
  },
  ["organization_update" /* ORGANIZATION_UPDATE */]: {
    type: "organization_update" /* ORGANIZATION_UPDATE */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "Organization Update: {{updateType}}",
        preview: "Important organization update",
        content: `An important organization update:

Update Type: {{updateType}}
Details: {{details}}

Please review for any required actions.`,
        actionText: "View Details"
      },
      ["in_app" /* IN_APP */]: {
        subject: "Org Update",
        content: "{{updateType}}: {{details}}",
        actionText: "View",
        es: {
          subject: "Actualizaci\xF3n de la organizaci\xF3n",
          content: "{{updateType}}: {{details}}",
          actionText: "Ver"
        }
      }
    }
  },
  ["holiday_delay_warning" /* HOLIDAY_DELAY_WARNING */]: {
    type: "holiday_delay_warning" /* HOLIDAY_DELAY_WARNING */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "Upcoming Holiday: {{holidayName}} \u2014 Service Delays Expected",
        preview: "{{holidayName}} is {{daysUntilHoliday}} days away",
        content: `{{holidayName}} falls on {{holidayDate}}, {{daysUntilHoliday}} days from now.

Crews normally do not work federal holidays, so visits scheduled that day \u2014 and the ones behind them that week \u2014 are likely to run late.

Now is a good time to review that week's schedule and move anything that cannot slip.`,
        actionText: "Review the schedule"
      },
      ["in_app" /* IN_APP */]: {
        subject: "Upcoming holiday: {{holidayName}}",
        content: "{{holidayName}} is on {{holidayDate}} ({{daysUntilHoliday}} days away) \u2014 review that week's schedule for visits that may run late.",
        actionText: "Review",
        es: {
          subject: "Feriado pr\xF3ximo: {{holidayName}}",
          content: "{{holidayName}} es el {{holidayDate}} (en {{daysUntilHoliday}} d\xEDas) \u2014 revisa el calendario de esa semana por visitas que podr\xEDan retrasarse.",
          actionText: "Revisar"
        }
      }
    }
  },
  // RUT-3371. The owner's own greeting, sent the moment a customer finishes
  // creating their profile. Deliberately says nothing about a rate request —
  // that acknowledgement is CUSTOMER_RATE_REQUEST_RECEIVED below, so a customer
  // who registers and one who asks for pricing never get the same words twice.
  // The signature only renders when the org's owner name resolves.
  ["customer_welcome" /* CUSTOMER_WELCOME */]: {
    type: "customer_welcome" /* CUSTOMER_WELCOME */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "Welcome to {{orgName}}",
        preheader: "Your profile is ready \u2014 explore our services",
        content: `
    <p style="font-size: 16px; margin-bottom: 20px; text-align: left;">Hi {{customerFirstName}},</p>

    <p style="font-size: 16px; margin-bottom: 20px; text-align: left;">I'm glad you found us. Consistent quality and service is what {{orgName}} is known for, and I personally make sure it stays that way. Reach out to me anytime right here.</p>

    <p style="font-size: 16px; margin-bottom: 20px; text-align: left;">Explore our services in your profile. We are ready to serve you.</p>

    {{#ownerName}}<p style="font-size: 16px; margin-bottom: 20px; text-align: left;">\u2014 {{ownerName}}, Founder and Owner</p>{{/ownerName}}
  `,
        action: {
          label: "Explore Our Services",
          url: "{{portalLink}}"
        }
      },
      ["sms" /* SMS */]: {
        content: "Hi {{customerFirstName}}, I'm glad you found us. Consistent quality and service is what {{orgName}} is known for, and I personally make sure it stays that way. Reach out to me anytime right here. Explore our services in your profile: {{portalLink}}{{#ownerName}} \u2014 {{ownerName}}, Founder and Owner{{/ownerName}}"
      }
    }
  },
  // RUT-3371 / RUT-3741. Confirms the request landed. Deliberately names no
  // service — naming one sounds like they already picked a product. Combined
  // multi-service acks (RUT-3372) use this same copy, so they do not list
  // services either. Customized org templates are left as the operator saved them.
  ["customer_rate_request_received" /* CUSTOMER_RATE_REQUEST_RECEIVED */]: {
    type: "customer_rate_request_received" /* CUSTOMER_RATE_REQUEST_RECEIVED */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "We got your rate request",
        preheader: "Your pricing is on its way",
        content: `
    <p style="font-size: 16px; margin-bottom: 20px; text-align: left;">Hi {{customerFirstName}},</p>

    <p style="font-size: 16px; margin-bottom: 20px; text-align: left;">We received your request for rates and will send your pricing soon.</p>
  `,
        action: {
          label: "View Your Profile",
          url: "{{portalLink}}"
        }
      },
      ["sms" /* SMS */]: {
        content: "Hi {{customerFirstName}}! We received your request for rates and {{orgName}} will send your pricing soon. View details: {{portalLink}}"
      }
    }
  },
  // Portal login reminder (RUT-2973). Default wording drafted from CUSTOMER_WELCOME —
  // a short, friendly "you haven't set up your profile yet, tap to log in" nudge with
  // the same {{portalLink}} call-to-action. Admin-editable in the notification editor.
  ["customer_portal_login_reminder" /* CUSTOMER_PORTAL_LOGIN_REMINDER */]: {
    type: "customer_portal_login_reminder" /* CUSTOMER_PORTAL_LOGIN_REMINDER */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "Log in to your {{orgName}} profile",
        preheader: "Your profile is ready \u2014 tap to log in",
        content: `
    <p style="font-size: 16px; margin-bottom: 20px; text-align: left;">Hi {{customerFirstName}},</p>

    <p style="font-size: 16px; margin-bottom: 20px; text-align: left;">You haven't logged into your {{orgName}} profile yet. It's the easiest place to see your upcoming visits, view pricing, and manage your services \u2014 all in one spot.</p>

    <p style="font-size: 16px; margin-bottom: 20px; text-align: left;">Tap the button below to log in and finish setting up your profile.</p>
  `,
        action: {
          label: "Log In to Your Profile",
          url: "{{portalLink}}"
        }
      },
      ["sms" /* SMS */]: {
        content: "Hi {{customerFirstName}}! You haven't logged into your {{orgName}} profile yet \u2014 tap to log in and see your services: {{portalLink}}"
      }
    }
  },
  // Customer Portal Templates
  ["customer_portal_registered" /* CUSTOMER_PORTAL_REGISTERED */]: {
    type: "customer_portal_registered" /* CUSTOMER_PORTAL_REGISTERED */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "New Customer Registration: {{customerName}}",
        preview: "A new customer has registered through the profile",
        content: `A new customer has registered through the customer profile:

Customer: {{customerName}}
Address: {{customerAddress}}
{{#customerEmail}}Email: {{customerEmail}}{{/customerEmail}}
{{#customerPhone}}Phone: {{customerPhone}}{{/customerPhone}}
{{#referrerSource}}Referrer: {{referrerSource}}{{/referrerSource}}

Log in to your dashboard to review and send rates.`,
        actionText: "View Customer"
      },
      ["in_app" /* IN_APP */]: {
        subject: "New Customer Registration",
        content: "{{customerName}} registered a new profile.",
        actionText: "View",
        es: {
          subject: "Nuevo registro de cliente",
          content: "{{customerName}} registr\xF3 un perfil nuevo.",
          actionText: "Ver"
        }
      },
      ["push" /* PUSH */]: {
        subject: "New Customer Registration",
        content: "{{customerName}} registered a new profile.",
        es: {
          subject: "Nuevo registro de cliente",
          content: "{{customerName}} registr\xF3 un perfil nuevo."
        }
      }
    }
  },
  // Access Request Templates
  ["access_request_submitted" /* ACCESS_REQUEST_SUBMITTED */]: {
    type: "access_request_submitted" /* ACCESS_REQUEST_SUBMITTED */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "Access Request: {{requesterName}} for {{customerAddress}}",
        preview: "{{requesterName}} is requesting access to {{customerName}}",
        content: `A new access request has been submitted:

Requester: {{requesterName}}
Contact: {{requesterContact}}
Relationship: {{relationship}}

Existing Customer: {{customerName}}
Address: {{customerAddress}}

Please review and verify the contact in your admin dashboard.`,
        actionText: "Review Request"
      },
      ["in_app" /* IN_APP */]: {
        subject: "Access Request",
        content: "{{requesterName}} ({{relationship}}) requesting access to {{customerName}}",
        actionText: "Review",
        es: {
          subject: "Solicitud de acceso",
          content: "{{requesterName}} ({{relationship}}) solicita acceso a {{customerName}}",
          actionText: "Revisar"
        }
      },
      ["push" /* PUSH */]: {
        subject: "Access Request",
        content: "{{requesterName}} requesting access to {{customerName}}",
        es: {
          subject: "Solicitud de acceso",
          content: "{{requesterName}} solicita acceso a {{customerName}}"
        }
      }
    }
  },
  // Customer Messaging Templates
  ["customer_message" /* CUSTOMER_MESSAGE */]: {
    type: "customer_message" /* CUSTOMER_MESSAGE */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "New message from {{customerName}}",
        preview: "You have a new message from a customer",
        content: `You have received a new message from {{customerName}}:

{{messagePreview}}...

Log in to view the full message and respond.`,
        actionText: "View Message"
      },
      ["sms" /* SMS */]: {
        content: "New message from {{customerName}}: {{messagePreview}}... Reply in the dashboard."
      },
      ["in_app" /* IN_APP */]: {
        subject: "New customer message",
        content: "{{customerName}}: {{messagePreview}}...",
        actionText: "View",
        es: {
          subject: "Nuevo mensaje de un cliente",
          content: "{{customerName}}: {{messagePreview}}...",
          actionText: "Ver"
        }
      },
      ["push" /* PUSH */]: {
        subject: "New Customer Message",
        content: "{{customerName}}: {{messagePreview}}",
        es: {
          subject: "Nuevo mensaje de un cliente",
          content: "{{customerName}}: {{messagePreview}}"
        }
      }
    }
  },
  ["admin_message" /* ADMIN_MESSAGE */]: {
    type: "admin_message" /* ADMIN_MESSAGE */,
    channels: {
      ["email" /* EMAIL */]: {
        subject: "Message from {{orgName}}",
        preheader: "Message from {{adminName}}",
        // Manually-composed admin → customer message (RUT-1652): rendered as a
        // personal note. Intentionally omits the recipient-name greeting at the
        // top and the author-name signature at the bottom so the admin's typed
        // text reads on its own, not like an automated notification. Automated
        // templates keep their {{customerFirstName}} greeting.
        content: `
    <div style="background-color: #f3f4f6; padding: 20px; margin: 20px 0; border-radius: 8px;">
      <p style="margin: 0; font-size: 16px; line-height: 1.6; color: #111827;">{{messagePreview}}</p>
    </div>
  `,
        action: {
          label: "View Your Account",
          url: "{{portalLink}}"
        }
      },
      ["sms" /* SMS */]: {
        // Reads on its own as a personal note — no "{{adminName}}:" prefix,
        // matching the email above (RUT-1652).
        content: "{{messagePreview}}"
      }
    }
  },
  ["shop_advisor" /* SHOP_ADVISOR */]: {
    type: "shop_advisor" /* SHOP_ADVISOR */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "{{agentName}}",
        content: "{{fact}}",
        es: {
          subject: "{{agentName}}",
          content: "{{fact}}"
        }
      }
    }
  },
  ["feedback_resolved" /* FEEDBACK_RESOLVED */]: {
    type: "feedback_resolved" /* FEEDBACK_RESOLVED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "{{title}}",
        content: "{{body}}",
        es: {
          subject: "{{title}}",
          content: "{{body}}"
        }
      }
    }
  },
  ["crew_route_order_changed" /* CREW_ROUTE_ORDER_CHANGED */]: {
    type: "crew_route_order_changed" /* CREW_ROUTE_ORDER_CHANGED */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "Route order changed",
        content: "{{crewName}}'s route order changed from the crew app by {{memberName}} \xB7 {{movedCount}} {{#oneStop}}stop{{/oneStop}}{{^oneStop}}stops{{/oneStop}}",
        actionText: "View route",
        es: {
          subject: "Orden de ruta cambiado",
          content: "El orden de ruta de {{crewName}} cambi\xF3 desde la app de cuadrilla por {{memberName}} \xB7 {{movedCount}} {{#oneStop}}parada{{/oneStop}}{{^oneStop}}paradas{{/oneStop}}",
          actionText: "Ver ruta"
        }
      }
    }
  },
  ["daily_collected_summary" /* DAILY_COLLECTED_SUMMARY */]: {
    type: "daily_collected_summary" /* DAILY_COLLECTED_SUMMARY */,
    channels: {
      ["in_app" /* IN_APP */]: {
        subject: "{{totalCollected}} collected today",
        content: "Card {{cardAmount}} \xB7 Check/cash {{checkCashAmount}} \xB7 Refunds {{refundAmount}}",
        actionText: "View payments",
        es: {
          subject: "{{totalCollected}} cobrados hoy",
          content: "Tarjeta {{cardAmount}} \xB7 Cheque/efectivo {{checkCashAmount}} \xB7 Reembolsos {{refundAmount}}",
          actionText: "Ver pagos"
        }
      },
      ["push" /* PUSH */]: {
        subject: "{{totalCollected}} collected today",
        content: "Card {{cardAmount}} \xB7 Check/cash {{checkCashAmount}} \xB7 Refunds {{refundAmount}}",
        es: {
          subject: "{{totalCollected}} cobrados hoy",
          content: "Tarjeta {{cardAmount}} \xB7 Cheque/efectivo {{checkCashAmount}} \xB7 Reembolsos {{refundAmount}}"
        }
      },
      ["email" /* EMAIL */]: {
        subject: "{{totalCollected}} collected today",
        preheader: "Card {{cardAmount}}, check/cash {{checkCashAmount}}, refunds {{refundAmount}}",
        content: "Today you collected {{totalCollected}}: {{cardAmount}} card, {{checkCashAmount}} check/cash, {{refundAmount}} refunds.",
        actionText: "View payments"
      }
    }
  }
};
function getTemplate(type, channel) {
  return NOTIFICATION_TEMPLATES[type]?.channels[channel];
}
var MUSTACHE_VAR_RE = /\{\{[#^/]?(\w+)\}\}/g;
function extractMustacheVariableNames(...sources) {
  const names = /* @__PURE__ */ new Set();
  for (const source of sources) {
    if (!source) continue;
    for (const match of source.matchAll(MUSTACHE_VAR_RE)) {
      names.add(match[1]);
    }
  }
  return [...names];
}
function extractChannelVariableNames(channel) {
  return extractMustacheVariableNames(
    channel.subject,
    channel.content,
    channel.preview,
    channel.preheader,
    channel.actionText,
    channel.action?.label,
    channel.action?.url
  );
}
var CONTEXT_SUPPLIED_FOR_EDITOR = [
  "customerName",
  "customerFirstName",
  "customerEmail",
  "customerPhone",
  "orgName",
  "portalLink"
];
function collectEditableNotificationVariables(type) {
  const config = NOTIFICATION_TYPE_CONFIGS[type];
  const names = /* @__PURE__ */ new Set([
    ...config?.requiredData ?? [],
    ...config?.optionalData ?? [],
    ...CONTEXT_SUPPLIED_FOR_EDITOR,
    "ratesLink",
    "receiptLink"
  ]);
  const templateSet = NOTIFICATION_TEMPLATES[type];
  if (templateSet) {
    for (const channelName of ["email" /* EMAIL */, "sms" /* SMS */]) {
      const channel = templateSet.channels[channelName];
      if (channel) {
        for (const name of extractChannelVariableNames(channel)) names.add(name);
      }
    }
  }
  return [...names];
}
function alwaysPresentNotificationVariables(type) {
  const config = NOTIFICATION_TYPE_CONFIGS[type];
  return /* @__PURE__ */ new Set([
    ...config?.requiredData ?? [],
    "customerName",
    "customerFirstName",
    "orgName",
    "portalLink",
    "ratesLink",
    "receiptLink"
  ]);
}
function getTemplateWithOverride(type, channel, override) {
  const defaultTemplate = getTemplate(type, channel);
  if (!defaultTemplate || !override) return defaultTemplate;
  if (channel === "email" /* EMAIL */) {
    const hasActionOverride = override.emailActionText !== void 0 || override.emailActionUrl !== void 0;
    const mergedAction = hasActionOverride ? {
      label: override.emailActionText ?? defaultTemplate.action?.label ?? "",
      url: override.emailActionUrl ?? defaultTemplate.action?.url ?? ""
    } : defaultTemplate.action;
    return {
      ...defaultTemplate,
      subject: override.emailSubject ?? defaultTemplate.subject,
      content: override.emailContent ?? defaultTemplate.content,
      action: mergedAction
    };
  }
  if (channel === "sms" /* SMS */) {
    return {
      ...defaultTemplate,
      content: override.smsContent ?? defaultTemplate.content
    };
  }
  return defaultTemplate;
}
function firstNonEmptyString(...values) {
  for (const value of values) {
    if (typeof value === "string" && value.trim()) return value.trim();
  }
  return "";
}
function fillDeactivationAliases(data) {
  const reason = firstNonEmptyString(data.deactivationReason, data.cancellationReason);
  const date = firstNonEmptyString(data.deactivationDate, data.cancellationDate, data.cancelDate);
  return {
    ...data,
    ...reason ? { cancellationReason: reason, deactivationReason: reason } : {},
    ...date ? { cancellationDate: date, deactivationDate: date } : {}
  };
}
function fillServiceCancelledDates(data, now = /* @__PURE__ */ new Date()) {
  const today = getDateInTimezone(now.toISOString(), DEFAULT_DISPLAY_TIMEZONE);
  const cancel = typeof data.cancelDate === "string" ? data.cancelDate.trim() : "";
  const alias = typeof data.cancellationDate === "string" ? data.cancellationDate.trim() : "";
  const renamed = typeof data.deactivationDate === "string" ? data.deactivationDate.trim() : "";
  const date = cancel || alias || renamed || today;
  return { ...data, cancelDate: date, cancellationDate: date, deactivationDate: date };
}
function renderTemplate(type, channel, data, replacer = defaultTemplateReplacer, override, language = "en") {
  const template = getTemplateWithOverride(type, channel, override);
  if (!template) {
    return void 0;
  }
  const aliased = fillDeactivationAliases(data);
  const rawData = type === "service_cancelled" /* SERVICE_CANCELLED */ ? fillServiceCancelledDates(aliased) : aliased;
  const filledData = localizeDateOnlyFields(rawData, "en");
  const esData = language === "es" ? localizeDateOnlyFields(rawData, "es") : filledData;
  const es = language === "es" ? template.es : void 0;
  const subjectTemplate = es?.subject ?? template.subject;
  const contentTemplate = es?.content ?? template.content;
  const actionTextTemplate = es?.actionText ?? template.actionText;
  const action = template.action ? {
    label: replacer(template.action.label, filledData),
    url: replacer(template.action.url, rawData)
  } : void 0;
  let content = replacer(contentTemplate, es?.content ? esData : filledData);
  const companyWritten = channel === "email" /* EMAIL */ ? override?.emailContent != null : override?.smsContent != null;
  if (!companyWritten && shouldApplyAutoMessageCadence(type, channel, filledData)) {
    const isHtml = channel === "email" /* EMAIL */ && /<[a-z][\s\S]*>/i.test(content);
    const format = channel === "sms" /* SMS */ ? "plain" : isHtml ? "html" : "text";
    content = applyAutoMessageAddressing({
      content,
      cadence: data.autoMessageCadence,
      format,
      customerFirstName: typeof data.customerFirstName === "string" ? data.customerFirstName : void 0,
      ownerFirstName: typeof data.ownerFirstName === "string" ? data.ownerFirstName : void 0
    });
  }
  return {
    subject: subjectTemplate ? replacer(subjectTemplate, es?.subject ? esData : filledData) : void 0,
    content,
    preview: template.preview ? replacer(template.preview, filledData) : void 0,
    preheader: template.preheader ? replacer(template.preheader, filledData) : void 0,
    actionText: actionTextTemplate ? replacer(actionTextTemplate, es?.actionText ? esData : filledData) : void 0,
    action
  };
}
function shouldApplyAutoMessageCadence(type, channel, data) {
  if (channel !== "email" /* EMAIL */ && channel !== "sms" /* SMS */) return false;
  if (!appliesAutoMessageCadence(type)) return false;
  if (!autoMessageCadenceAppliesToRole(NOTIFICATION_TYPE_CONFIGS[type]?.targetRoles)) return false;
  return data.autoMessageCadence === "opener" || data.autoMessageCadence === "follow_up";
}
function renderSmsWithAction(type, data, override) {
  const rendered = renderTemplate(type, "sms" /* SMS */, data, defaultTemplateReplacer, override);
  if (!rendered) return void 0;
  if (rendered.action && rendered.action.url && !rendered.content.includes(rendered.action.url)) {
    const separator = endsWithAutoMessageSignOff(rendered.content, data.ownerFirstName) ? "\n" : " ";
    return `${rendered.content}${separator}${rendered.action.label}: ${rendered.action.url}`;
  }
  return rendered.content;
}
function resolveTemplateLinkData(data) {
  return {
    ...data,
    ratesLink: data.servicesUrl || data.portalLink || data.ratesLink,
    receiptLink: data.serviceModalUrl || data.receiptUrl || data.portalLink
  };
}
function getNotificationConfig(type) {
  const config = NOTIFICATION_TYPE_CONFIGS[type];
  if (!config) {
    throw new Error(`Unknown notification type: ${type}`);
  }
  return config;
}
function getNotificationsByRole(role) {
  return Object.values(NOTIFICATION_TYPE_CONFIGS).filter((config) => config.targetRoles.includes(role));
}
function validateNotificationData(type, data) {
  const config = getNotificationConfig(type);
  const missingFields = config.requiredData.filter((field) => !data[field]);
  return {
    valid: missingFields.length === 0,
    missingFields: missingFields.length > 0 ? missingFields : void 0
  };
}
function stripReasonSuffix(message, reason) {
  if (!message || !reason) return message;
  for (const label of ["Reason", "Motivo"]) {
    const suffix = `${label}: ${reason}`;
    if (message.endsWith(suffix)) {
      return message.slice(0, message.length - suffix.length).trimEnd();
    }
  }
  return message;
}
function getNotificationsByCategory() {
  const byCategory = {};
  Object.values(NOTIFICATION_TYPE_CONFIGS).forEach((config) => {
    if (!byCategory[config.category]) {
      byCategory[config.category] = [];
    }
    byCategory[config.category].push(config);
  });
  return byCategory;
}
var NOTIFICATION_CATEGORY_LABELS = {
  rate_pricing: "Rate & Pricing",
  scheduling: "Scheduling & Visits",
  crew: "Crew Management",
  payments: "Payments & Invoicing",
  service: "Service Management",
  jobs: "Job Management",
  system: "System & Admin",
  messaging: "Messaging",
  onboarding: "Onboarding"
};
var NOTIFICATION_CHANNEL_LABELS = {
  ["email" /* EMAIL */]: "Email",
  ["sms" /* SMS */]: "SMS",
  ["in_app" /* IN_APP */]: "In-App",
  ["push" /* PUSH */]: "Push"
};
var NOTIFICATION_VARIABLE_DESCRIPTIONS = {
  // Customer & contact
  customerName: "Full name of the customer",
  customerFirstName: "First name of the customer",
  customerAddress: "Service address of the customer",
  // Service & subscription
  serviceName: 'Name of the service (e.g. "Lawn Mowing")',
  serviceTemplateName: "Name of the service template",
  serviceType: "Type of service being performed",
  subscriptionId: "Unique ID of the subscription",
  startDate: "Date the service starts",
  // Organization
  orgName: "Your company name",
  // Visit
  visitId: "Unique ID of the visit",
  completedDate: "Date the visit was completed",
  notes: "Crew notes from the visit",
  completionInstructions: "Care instructions from the service template, shown after visit completion",
  // Payment & billing
  amount: "Dollar amount (formatted)",
  invoiceId: "Invoice number",
  failureReason: "Reason the payment failed",
  // Deactivation (old cancellation* keys still resolve — RUT-4420)
  cancellationReason: "Reason for deactivation",
  cancellationDate: "Effective date of deactivation",
  deactivationReason: "Reason for deactivation",
  deactivationDate: "Effective date of deactivation",
  cancelDate: "Date the service was deactivated",
  subscriptions: "List of affected subscriptions",
  // Pause/resume
  pausedUntil: "Date the service is scheduled to resume",
  pausedAt: "Date the service was paused",
  // Links
  portalLink: "Link to the customer portal",
  receiptLink: "Link to the visit receipt",
  paymentLink: "Link to update payment method",
  addCardLink: "Link to add a card on the customer portal",
  orgPhone: "Your company phone number",
  ratesLink: "Link to view and accept rates",
  // Messaging
  ownerName: "Name of the business owner, used to sign the welcome message",
  adminName: "Name of the admin sending the message",
  messagePreview: "Preview of the message content",
  customMessage: "Custom message added by admin",
  // Rates
  customerNotes: "Notes provided by the customer",
  pendingRatesNote: "Note about a service whose rate isn't ready to send yet",
  pendingServiceNames: "Services whose rates aren't ready to send yet",
  // Derived / send-time
  hasSpecialInstructions: "Whether this service includes a suggested care guide",
  receiptUrl: "Link to the visit receipt",
  servicesUrl: "Link to the customer's services",
  portalLoginLink: "Link to log into the customer profile",
  customerEmail: "Customer email address",
  customerPhone: "Customer phone number",
  nextVisitDate: "Date of the next scheduled visit",
  previousVisitDate: "Date of the previous visit",
  balanceDue: "Amount the customer currently owes",
  serviceAddress: "Service address of the customer",
  photos: "Photos from the visit"
};
var NOTIFICATION_VARIABLE_LABELS = {
  customerName: "Full Name",
  customerFirstName: "First Name",
  customerAddress: "Address",
  customerEmail: "Email",
  customerPhone: "Phone",
  customerNotes: "Customer Notes",
  serviceName: "Service",
  serviceTemplateName: "Service Template",
  serviceType: "Service Type",
  serviceAddress: "Service Address",
  orgName: "Company Name",
  completedDate: "Completed Date",
  notes: "Visit Notes",
  completionInstructions: "Care Instructions",
  hasSpecialInstructions: "Suggested Care Guide",
  amount: "Amount",
  invoiceId: "Invoice Number",
  failureReason: "Failure Reason",
  balanceDue: "Balance Due",
  cancellationReason: "Deactivation Reason",
  cancellationDate: "Deactivation Date",
  deactivationReason: "Deactivation Reason",
  deactivationDate: "Deactivation Date",
  cancelDate: "Deactivation Date",
  pausedUntil: "Resume Date",
  pausedAt: "Paused Date",
  portalLink: "Customer's home page",
  portalLoginLink: "Profile Login",
  receiptLink: "Receipt",
  receiptUrl: "Receipt",
  paymentLink: "Payment Link",
  addCardLink: "Add Card Link",
  orgPhone: "Company Phone",
  ratesLink: "Rates Link",
  servicesUrl: "Services Link",
  adminName: "Admin Name",
  messagePreview: "Message Preview",
  customMessage: "Custom Message",
  pendingRatesNote: "Pending Rates Note",
  pendingServiceNames: "Pending Services",
  nextVisitDate: "Next Visit",
  previousVisitDate: "Previous Visit",
  photos: "Photos"
};
var CONTEXT_SUPPLIED_NOTIFICATION_VARIABLES = CONTEXT_SUPPLIED_FOR_EDITOR;
function getNotificationVariableLabel(name) {
  if (NOTIFICATION_VARIABLE_LABELS[name]) return NOTIFICATION_VARIABLE_LABELS[name];
  return name.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/^./, (c) => c.toUpperCase());
}
var CUSTOMER_EDITABLE_NOTIFICATION_TYPES = [
  "visit_completed" /* VISIT_COMPLETED */,
  "payment_failed" /* PAYMENT_FAILED */,
  "customer_add_card_reminder" /* CUSTOMER_ADD_CARD_REMINDER */,
  "service_activated" /* SERVICE_ACTIVATED */,
  "service_cancelled" /* SERVICE_CANCELLED */,
  "subscription_batch_rates_released" /* SUBSCRIPTION_BATCH_RATES_RELEASED */,
  // Ships with the operator's wording, but an org can rewrite it in the
  // notification editor like its rates-ready sibling (RUT-2614).
  "subscription_rate_not_yet_available" /* SUBSCRIPTION_RATE_NOT_YET_AVAILABLE */,
  "subscription_batch_cancelled" /* SUBSCRIPTION_BATCH_CANCELLED */,
  "subscription_paused" /* SUBSCRIPTION_PAUSED */,
  "subscription_resumed" /* SUBSCRIPTION_RESUMED */,
  "admin_message" /* ADMIN_MESSAGE */,
  "customer_welcome" /* CUSTOMER_WELCOME */,
  "customer_rate_request_received" /* CUSTOMER_RATE_REQUEST_RECEIVED */,
  "customer_portal_login_reminder" /* CUSTOMER_PORTAL_LOGIN_REMINDER */
];

// src/notifications/addCardReminder.ts
var DAY_MS = 24 * 60 * 60 * 1e3;
function paymentReminderPeriod(reminderDays, nowMs = Date.now()) {
  const days = Math.max(1, reminderDays);
  return Math.floor(Math.floor(nowMs / DAY_MS) / days);
}
function addCardReminderIdempotencyKey(customerId, reminderDays, nowMs = Date.now()) {
  return `add-card-reminder-${customerId}-period-${paymentReminderPeriod(reminderDays, nowMs)}`;
}

// src/notifications/typeLabels.ts
var NOTIFICATION_TYPE_LABELS = {
  ["rate_request_submitted" /* RATE_REQUEST_SUBMITTED */]: "Rate request received",
  ["rate_request_updated" /* RATE_REQUEST_UPDATED */]: "Rate updated",
  ["rate_accepted" /* RATE_ACCEPTED */]: "Rate accepted",
  ["rate_declined" /* RATE_DECLINED */]: "Rate declined",
  ["visit_scheduled" /* VISIT_SCHEDULED */]: "Visit scheduled",
  ["visit_reminder" /* VISIT_REMINDER */]: "Visit reminder",
  ["visit_started" /* VISIT_STARTED */]: "Visit started",
  ["visit_completed" /* VISIT_COMPLETED */]: "Visit completed",
  ["visit_skipped" /* VISIT_SKIPPED */]: "Visit skipped",
  ["visit_cancelled" /* VISIT_CANCELLED */]: "Visit cancelled",
  ["visit_rescheduled" /* VISIT_RESCHEDULED */]: "Visit rescheduled",
  ["visit_followup_created" /* VISIT_FOLLOWUP_CREATED */]: "Follow-up scheduled",
  ["visit_notes_added" /* VISIT_NOTES_ADDED */]: "Crew note added",
  ["visit_photos_added" /* VISIT_PHOTOS_ADDED */]: "Photos added",
  ["visit_photo_approval_needed" /* VISIT_PHOTO_APPROVAL_NEEDED */]: "Photo needs approval",
  ["followup_visit_completed" /* FOLLOWUP_VISIT_COMPLETED */]: "Follow-up completed",
  ["visit_completed_reminder" /* VISIT_COMPLETED_REMINDER */]: "Visit completed",
  ["crew_route_order_changed" /* CREW_ROUTE_ORDER_CHANGED */]: "Route order changed",
  ["payment_successful" /* PAYMENT_SUCCESSFUL */]: "Payment received",
  ["visit_payment_received" /* VISIT_PAYMENT_RECEIVED */]: "Payment received",
  ["batch_charge_completed" /* BATCH_CHARGE_COMPLETED */]: "Nightly charges complete",
  ["daily_collected_summary" /* DAILY_COLLECTED_SUMMARY */]: "Daily collected total",
  ["payment_failed" /* PAYMENT_FAILED */]: "Payment failed",
  ["customer_add_card_reminder" /* CUSTOMER_ADD_CARD_REMINDER */]: "Add a card reminder",
  ["payment_retry" /* PAYMENT_RETRY */]: "Payment retry",
  ["payment_overdue" /* PAYMENT_OVERDUE */]: "Payment overdue",
  ["invoice_ready" /* INVOICE_READY */]: "Invoice ready",
  ["payment_method_added" /* PAYMENT_METHOD_ADDED */]: "Payment method added",
  ["service_completed" /* SERVICE_COMPLETED */]: "Service completed",
  ["service_activated" /* SERVICE_ACTIVATED */]: "Service activated",
  ["service_enrollment_scheduled" /* SERVICE_ENROLLMENT_SCHEDULED */]: "Service activated, starts later",
  ["service_suspended" /* SERVICE_SUSPENDED */]: "Service suspended",
  ["service_cancelled" /* SERVICE_CANCELLED */]: "Service deactivated",
  ["service_deactivation_completed" /* SERVICE_DEACTIVATION_COMPLETED */]: "Scheduled deactivation completed",
  ["subscription_requested" /* SUBSCRIPTION_REQUESTED */]: "Rate requested",
  ["subscription_rate_provided" /* SUBSCRIPTION_RATE_PROVIDED */]: "Rate provided",
  ["subscription_rate_not_yet_available" /* SUBSCRIPTION_RATE_NOT_YET_AVAILABLE */]: "Rates being finalized",
  ["subscription_batch_rates_released" /* SUBSCRIPTION_BATCH_RATES_RELEASED */]: "Rates sent",
  ["subscription_batch_cancelled" /* SUBSCRIPTION_BATCH_CANCELLED */]: "Services deactivated",
  ["subscription_accepted" /* SUBSCRIPTION_ACCEPTED */]: "Service accepted",
  ["subscription_paused" /* SUBSCRIPTION_PAUSED */]: "Service paused",
  ["subscription_resumed" /* SUBSCRIPTION_RESUMED */]: "Service resumed",
  ["subscription_notes_updated" /* SUBSCRIPTION_NOTES_UPDATED */]: "Service notes updated",
  ["subscription_customer_selections_changed" /* SUBSCRIPTION_CUSTOMER_SELECTIONS_CHANGED */]: "Service answers changed",
  ["subscription_package_option_changed" /* SUBSCRIPTION_PACKAGE_OPTION_CHANGED */]: "Service plan changed",
  ["subscription_plan_change_requested" /* SUBSCRIPTION_PLAN_CHANGE_REQUESTED */]: "Plan switch waiting",
  ["customer_welcome" /* CUSTOMER_WELCOME */]: "Welcome",
  // Distinct from RATE_REQUEST_SUBMITTED's 'Rate request received' above: that
  // one tells the office, this one confirms it back to the customer, and both can
  // land in the same conversation view.
  ["customer_rate_request_received" /* CUSTOMER_RATE_REQUEST_RECEIVED */]: "Rate request confirmed",
  ["customer_portal_registered" /* CUSTOMER_PORTAL_REGISTERED */]: "Portal access set up",
  ["customer_portal_login_reminder" /* CUSTOMER_PORTAL_LOGIN_REMINDER */]: "Log in reminder",
  ["account_update" /* ACCOUNT_UPDATE */]: "Account update",
  ["feedback_resolved" /* FEEDBACK_RESOLVED */]: "Report resolved"
};
function getNotificationTypeLabel(type) {
  if (!type) return void 0;
  return NOTIFICATION_TYPE_LABELS[type];
}

// src/notifications/pendingRates.ts
function formatServiceNameList(names) {
  const cleaned = names.map((n) => n.trim()).filter((n) => n.length > 0);
  if (cleaned.length === 0) return "";
  if (cleaned.length === 1) return cleaned[0];
  if (cleaned.length === 2) return `${cleaned[0]} and ${cleaned[1]}`;
  return `${cleaned.slice(0, -1).join(", ")}, and ${cleaned[cleaned.length - 1]}`;
}
function buildPendingRatesNote(serviceNames) {
  const list = formatServiceNameList(serviceNames);
  if (!list) return "";
  return `One note: We're still finalizing ${list} rates for the upcoming season and will send them your way as soon as they're available.`;
}

// src/notifications/sampleData.ts
var NOTIFICATION_SAMPLE_DATA = {
  customerName: "John Smith",
  customerFirstName: "John",
  customerAddress: "123 Main St, Springfield, IL",
  customerEmail: "john@example.com",
  customerPhone: "(555) 123-4567",
  serviceName: "Lawn Mowing",
  serviceTemplateName: "Lawn Mowing",
  serviceType: "Lawn Mowing",
  serviceAddress: "123 Main St, Springfield, IL",
  subscriptionId: "sub_12345",
  orgName: "Your Company",
  visitId: "visit_67890",
  completedDate: "March 28, 2026",
  notes: "Front and back yard completed. Trimmed edges along the driveway.",
  amount: "$85.00",
  invoiceId: "INV-1234",
  failureReason: "Card declined \u2014 insufficient funds",
  cancellationReason: "Customer requested",
  cancellationDate: "April 1, 2026",
  deactivationReason: "Customer requested",
  deactivationDate: "April 1, 2026",
  cancelDate: "April 1, 2026",
  pausedUntil: "May 1, 2026",
  pausedAt: "March 28, 2026",
  adminName: "Sarah Johnson",
  messagePreview: "Just wanted to follow up about your upcoming service...",
  customMessage: "",
  customerNotes: "Please mow around the garden beds carefully.",
  // Several templates carry a sentence — and different link wording — that only
  // appears when the service has special instructions (a suggested care guide).
  // The sample turns that on so the preview shows the LONGER of the two
  // messages a customer can receive, which is the one worth checking before it
  // goes out (RUT-3144). Mustache treats any non-empty string as present.
  hasSpecialInstructions: "true",
  completionInstructions: "Water the new sod every morning for the first two weeks.",
  nextVisitDate: "April 4, 2026",
  previousVisitDate: "March 21, 2026",
  balanceDue: "$120.00",
  addCardLink: "https://yourcompany.getruta.com/login?redirect=%2Fadd-payment-method",
  orgPhone: "(555) 010-0000",
  pendingRatesNote: "Snow Plowing rates aren't ready yet.",
  pendingServiceNames: "Snow Plowing",
  photos: "3 photos"
};

// src/notifications/portalUrl.ts
function readEnv(key) {
  return typeof process !== "undefined" ? process.env?.[key] : void 0;
}
function buildPortalUrl(org, path) {
  const baseDomain = readEnv("CUSTOMER_PORTAL_BASE_DOMAIN") || "getruta.com";
  const baseUrl = readEnv("CUSTOMER_PORTAL_BASE_URL") || `https://customer.${baseDomain}`;
  const envName = readEnv("ENVIRONMENT") || "prod";
  if (org.customDomain && org.customDomainStatus === "active") {
    return `https://${org.customDomain}${path}`;
  }
  if (org.slug) {
    const envPrefix = envName === "prod" ? "" : `${envName}.`;
    return `https://${envPrefix}${org.slug}.${baseDomain}${path}`;
  }
  return `${baseUrl}${path}`;
}
var ADD_CARD_LOGIN_PATH = `/login?redirect=${encodeURIComponent("/add-payment-method")}`;
function buildAddCardPaymentLink(org) {
  return buildPortalUrl(org, ADD_CARD_LOGIN_PATH);
}
function buildPaymentUrl(org, path) {
  const baseDomain = readEnv("CUSTOMER_PORTAL_BASE_DOMAIN") || "getruta.com";
  const envName = readEnv("ENVIRONMENT") || "dev";
  const envPrefix = envName === "prod" ? "" : `${envName}.`;
  const paymentHost = readEnv("CUSTOMER_PORTAL_PAYMENT_DOMAIN") || `${envPrefix}payments.${baseDomain}`;
  if (!org.slug) {
    throw new Error("buildPaymentUrl requires an org slug \u2014 the payment domain resolves org by path");
  }
  return `https://${paymentHost}/${org.slug}${path}`;
}

// src/notifications/campaignRender.ts
import Mustache3 from "mustache";
import { marked } from "marked";

// src/notifications/email/baseLayout.ts
import Mustache2 from "mustache";

// src/notifications/email/constants.ts
function readEnv2(key) {
  return typeof process !== "undefined" ? process.env?.[key] : void 0;
}
var EMAIL_COLORS = {
  button: "#0a1f0a",
  buttonHover: "#143d14",
  textPrimary: "#111827",
  textSecondary: "#4b5563",
  textMuted: "#6b7280",
  background: "#ffffff",
  backgroundMuted: "#f9fafb",
  cardBackground: "#f3f4f6",
  border: "#e5e7eb",
  link: "#0a1f0a",
  success: BaseColors.success[500],
  warning: BaseColors.warning[500],
  error: BaseColors.error[500]
};
var EMAIL_DEFAULTS = {
  fromEmail: "noreply@getruta.com",
  rutaLogoUrl: "https://assets.getruta.com/logo-email.png",
  defaultBrandColor: BaseColors.nav,
  fontFamily: "'Prompt', Arial, Helvetica, sans-serif",
  webappUrl: readEnv2("WEBAPP_URL") || "https://app.getruta.com",
  // Displayed email-logo width in px. Kept in sync with EMAIL_LOGO_DISPLAY_WIDTH
  // in shared/emailLogo.ts (the generated raster is 2× this). Drives both the
  // CSS max-width and the explicit width attribute on the <img> so the logo
  // stays correctly sized even when the client strips CSS.
  logoDisplayWidth: 160
};

// src/notifications/email/baseLayout.ts
var BASE_TEMPLATE = `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <title>{{branding.companyName}}</title>
  <!--[if mso]>
  <noscript>
    <xml>
      <o:OfficeDocumentSettings>
        <o:PixelsPerInch>96</o:PixelsPerInch>
      </o:OfficeDocumentSettings>
    </xml>
  </noscript>
  <![endif]-->
  <style>
    @import url('https://fonts.googleapis.com/css2?family=Prompt:wght@400;500;600;700&display=swap');

    body {
      margin: 0;
      padding: 0;
      width: 100%;
      background-color: ${EMAIL_COLORS.backgroundMuted};
      font-family: ${EMAIL_DEFAULTS.fontFamily};
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    .email-wrapper {
      width: 100%;
      background-color: ${EMAIL_COLORS.backgroundMuted};
      padding: 40px 0;
    }

    .email-container {
      max-width: 600px;
      margin: 0 auto;
      text-align: left;
      background-color: ${EMAIL_COLORS.background};
      border-radius: 12px;
      overflow: hidden;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    }

    .email-header {
      padding: 32px 32px 24px;
      text-align: center;
      border-bottom: 1px solid ${EMAIL_COLORS.border};
    }

    .email-header img {
      max-width: ${EMAIL_DEFAULTS.logoDisplayWidth}px;
      height: auto;
    }

    .email-header-text {
      color: ${EMAIL_COLORS.textPrimary};
      font-size: 24px;
      font-weight: 700;
      letter-spacing: 0.05em;
      margin: 0;
    }

    .email-body {
      padding: 32px;
      color: ${EMAIL_COLORS.textPrimary};
      font-size: 16px;
      line-height: 1.6;
    }

    .email-footer {
      padding: 24px 32px;
      text-align: left;
      border-top: 1px solid ${EMAIL_COLORS.border};
      color: ${EMAIL_COLORS.textMuted};
      font-size: 12px;
    }

    .email-footer a {
      color: ${EMAIL_COLORS.textMuted};
      text-decoration: none;
    }

    .email-footer a:hover {
      text-decoration: underline;
    }

    .btn {
      display: block;
      width: 100%;
      box-sizing: border-box;
      padding: 14px 28px;
      background-color: ${EMAIL_COLORS.button};
      color: #ffffff !important;
      text-decoration: none;
      border-radius: 8px;
      font-weight: 600;
      font-size: 16px;
      text-align: center;
    }

    .btn:hover {
      background-color: ${EMAIL_COLORS.buttonHover};
    }

    .preheader {
      display: none !important;
      visibility: hidden;
      mso-hide: all;
      font-size: 1px;
      line-height: 1px;
      max-height: 0;
      max-width: 0;
      opacity: 0;
      overflow: hidden;
    }

    @media only screen and (max-width: 620px) {
      .email-container {
        width: 100% !important;
        border-radius: 0 !important;
      }

      .email-body {
        padding: 24px !important;
      }

      .email-header {
        padding: 24px 24px 20px !important;
      }
    }
  </style>
</head>
<body>
  {{#preheader}}
  <span class="preheader">{{preheader}}</span>
  {{/preheader}}

  <div class="email-wrapper">
    <table role="presentation" cellpadding="0" cellspacing="0" width="100%">
      <tr>
        <td align="center">
          <div class="email-container">
            <div class="email-header">
              {{#resolvedLogoUrl}}
              <img src="{{{resolvedLogoUrl}}}" alt="{{branding.companyName}}" width="${EMAIL_DEFAULTS.logoDisplayWidth}" style="max-width: ${EMAIL_DEFAULTS.logoDisplayWidth}px; height: auto;" />
              {{/resolvedLogoUrl}}
              {{^resolvedLogoUrl}}
              <p class="email-header-text">{{branding.companyName}}</p>
              {{/resolvedLogoUrl}}
            </div>

            <div class="email-body">
              {{{content}}}
            </div>

            <div class="email-footer">
              <p style="margin: 0 0 8px 0;">
                &copy; {{currentYear}} {{branding.companyName}}
                {{#branding.website}}
                &middot; <a href="{{branding.website}}">{{branding.website}}</a>
                {{/branding.website}}
              </p>
              {{#showUnsubscribe}}
              {{#branding.preferencesUrl}}
              <p style="margin: 0;">
                <a href="{{branding.preferencesUrl}}">Manage notification preferences</a>
              </p>
              {{/branding.preferencesUrl}}
              {{/showUnsubscribe}}
            </div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</body>
</html>
`;
function renderBaseLayout(context) {
  const resolvedLogoUrl = context.branding.emailLogoUrl || context.branding.logoUrl || "";
  return Mustache2.render(BASE_TEMPLATE, {
    ...context,
    resolvedLogoUrl,
    currentYear: (/* @__PURE__ */ new Date()).getFullYear()
  });
}

// src/notifications/email/authoredLineBreaks.ts
var BLOCK_TAG = "(?:p|div|br|hr|h[1-6]|ul|ol|li|table|thead|tbody|tfoot|tr|td|th|blockquote|section|header|footer|article|figure|pre|center)";
var NEXT_IS_BLOCK = new RegExp(`^[^\\S\\n]*<\\/?${BLOCK_TAG}\\b`, "i");
var PREV_IS_BLOCK = new RegExp(`<\\/?${BLOCK_TAG}\\b[^>]*>\\s*$`, "i");
function preserveAuthoredLineBreaks(content) {
  if (!content) return content;
  const normalized = content.replace(/\r\n/g, "\n");
  if (!normalized.includes("\n")) return normalized;
  let out = "";
  let cursor = 0;
  const runs = /\n+/g;
  let match;
  while ((match = runs.exec(normalized)) !== null) {
    out += normalized.slice(cursor, match.index);
    const rest = normalized.slice(match.index + match[0].length);
    if (PREV_IS_BLOCK.test(out) || NEXT_IS_BLOCK.test(rest)) {
      out += match[0];
    } else {
      out += match[0].length > 1 ? "<br><br>" : "<br>";
    }
    cursor = match.index + match[0].length;
  }
  return out + normalized.slice(cursor);
}

// src/notifications/email/branding.ts
function readEnv3(key) {
  return typeof process !== "undefined" ? process.env?.[key] : void 0;
}
function getCustomerBranding(org, preferencesUrl) {
  return {
    logoUrl: org.logoUrl || "",
    emailLogoUrl: org.emailLogoUrl,
    brandColor: org.brandColor || "#0a1f0a",
    companyName: getOrgMessagingName(org),
    website: org.website,
    preferencesUrl
  };
}
function getAdminBranding(preferencesUrl) {
  const assetsDomain = readEnv3("COMPANY_ASSETS_CLOUDFRONT_DOMAIN") || "dev.assets.getruta.com";
  const adminLogoUrl = `https://${assetsDomain}/ruta-logo-email-dark.png`;
  return {
    logoUrl: adminLogoUrl,
    emailLogoUrl: adminLogoUrl,
    brandColor: "#0a1f0a",
    companyName: "Ruta",
    website: "https://getruta.com",
    preferencesUrl
  };
}

// src/notifications/email/renderCustomerEmail.ts
function renderCustomerEmail(options) {
  const { type, data, organization, override, isSystem = false, actionOverride } = options;
  const branding = organization ? getCustomerBranding(
    organization,
    isSystem ? void 0 : buildPortalUrl(organization, "/settings")
  ) : getAdminBranding();
  const dataWithBranding = {
    ...data,
    companyName: branding.companyName,
    orgName: branding.companyName
  };
  const rendered = renderTemplate(
    type,
    "email" /* EMAIL */,
    dataWithBranding,
    void 0,
    override
  );
  if (!rendered) {
    throw new Error(`No email template for notification type: ${type}`);
  }
  const action = actionOverride ?? rendered.action;
  const actionHtml = action && action.url ? `
    <div style="text-align: center; margin: 32px 0;">
      <a href="${action.url}" class="btn">${action.label} &#8594;</a>
    </div>
  ` : "";
  const content = preserveAuthoredLineBreaks(rendered.content);
  const htmlBody = renderBaseLayout({
    branding,
    content: content + actionHtml,
    preheader: rendered.preheader,
    showUnsubscribe: !isSystem,
    currentYear: (/* @__PURE__ */ new Date()).getFullYear()
  });
  const textBody = buildPlainTextBody(content, action);
  return {
    subject: rendered.subject ?? "",
    htmlBody,
    textBody
  };
}
function htmlToPlainText(html) {
  return html.replace(/<br\s*\/?>(\s*)/gi, "\n").replace(/<\/p>\s*/gi, "\n\n").replace(/<\/div>\s*/gi, "\n\n").replace(/<[^>]+>/g, "").replace(/&nbsp;/g, " ").replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/\n{3,}/g, "\n\n").trim();
}
function buildPlainTextBody(contentHtml, action) {
  const text = htmlToPlainText(contentHtml);
  if (action && action.url) {
    const cta = action.label ? `${action.label}: ${action.url}` : action.url;
    return `${text}

${cta}`.trim();
  }
  return text;
}

// src/notifications/campaignRender.ts
function renderCampaignTemplate(template, data) {
  Mustache3.escape = (text) => text;
  return Mustache3.render(template, data);
}
var emailMarkdownRenderer = new marked.Renderer();
emailMarkdownRenderer.link = (href, title, text) => {
  const safeHref = href ?? "";
  const titleAttr = title ? ` title="${title}"` : "";
  return `<a href="${safeHref}"${titleAttr} style="color: #2563eb; text-decoration: underline;" target="_blank" rel="noopener">${text}</a>`;
};
var noListTokenizer = new marked.Tokenizer();
noListTokenizer.list = () => void 0;
function messageContentToHtml(raw) {
  return marked.parse(raw, {
    gfm: true,
    breaks: true,
    renderer: emailMarkdownRenderer,
    tokenizer: noListTokenizer
  });
}
function renderAttachmentsText(attachments) {
  if (!attachments || attachments.length === 0) return "";
  return "\n\n" + attachments.map((a) => a.url).join("\n");
}
function campaignUsesBalance(campaign) {
  return Boolean(
    campaign.emailContent?.includes("{{balance}}") || campaign.smsContent?.includes("{{balance}}")
  );
}
function buildCampaignTemplateData(customer, subscriptionContext, org, customerEmail, customerPhone, balance) {
  const customerFirstName = customer.firstName || "";
  const customerName = [customer.firstName, customer.lastName].filter(Boolean).join(" ") || "";
  const serviceNames = subscriptionContext.map((s) => s.serviceTemplateName).filter(Boolean);
  const serviceName = serviceNames[0] || "";
  const serviceNamesStr = serviceNames.join(", ");
  const primarySubscriptionId = subscriptionContext[0]?.subscriptionId || "";
  const serviceLink = primarySubscriptionId ? buildPortalUrl(org, `/services/${primarySubscriptionId}`) : buildPortalUrl(org, "/services");
  const servicesLink = buildPortalUrl(org, "/services");
  const portalLink = buildPortalUrl(org, "/login");
  const paymentLink = buildAddCardPaymentLink(org);
  const portalLoginLink = customerEmail ? buildPortalUrl(org, `/login?email=${encodeURIComponent(customerEmail)}`) : buildPortalUrl(org, "/login");
  return {
    customerFirstName,
    customerName,
    customerEmail: customerEmail || "",
    customerPhone: customerPhone || "",
    serviceName,
    serviceNames: serviceNamesStr,
    serviceLink,
    servicesLink,
    portalLink,
    portalLoginLink,
    paymentLink,
    orgName: getOrgMessagingName(org),
    balance
  };
}
function buildCampaignEmail(params) {
  const {
    renderedContent,
    renderedSubject,
    attachments,
    senderName,
    organization,
    customerFirstName,
    customerName,
    emailAction
  } = params;
  const bodyHtml = expandAttachmentTokens(messageContentToHtml(renderedContent), attachments);
  const portalUrl = buildPortalUrl(organization, "/login");
  const paymentUrl = buildAddCardPaymentLink(organization);
  const actionOverride = emailAction ? {
    label: emailAction.label,
    url: emailAction.url === "paymentLink" ? paymentUrl : portalUrl
  } : void 0;
  const { subject, htmlBody, textBody } = renderCustomerEmail({
    type: "admin_message" /* ADMIN_MESSAGE */,
    organization,
    data: {
      customerName: customerFirstName || customerName,
      // Legacy template variable — receives the full linkified HTML including
      // inline campaign images.
      messagePreview: bodyHtml,
      adminName: senderName,
      portalLink: portalUrl,
      paymentLink: paymentUrl
    },
    actionOverride
  });
  const attachmentsText = renderAttachmentsText(attachments);
  return {
    subject: renderedSubject || subject,
    htmlBody,
    textBody: attachmentsText ? textBody + attachmentsText : textBody
  };
}

// src/notifications/sms/render.ts
var SMS_STOP_FOOTER = "\n\nReply STOP to opt out";
function messageContentToSmsText(raw) {
  return raw.replace(
    /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g,
    (_match, label, url) => label.trim() === url.trim() ? url : `${label.trim()}: ${url}`
  );
}
function appendStopFooter(message) {
  return `${message}${SMS_STOP_FOOTER}`;
}
function hasUnicode(text) {
  for (let i = 0; i < text.length; i++) {
    if (text.charCodeAt(i) > 127) return true;
  }
  return false;
}
function listUnicodeChars(text) {
  const seen = /* @__PURE__ */ new Set();
  const out = [];
  for (const ch of text) {
    const cp = ch.codePointAt(0);
    if (cp !== void 0 && cp > 127 && !seen.has(ch)) {
      seen.add(ch);
      out.push(ch);
    }
  }
  return out;
}
function getSmsStats(text) {
  const isUnicode = hasUnicode(text);
  const charsPerSegment = isUnicode ? 70 : 160;
  const length = text.length;
  const segments = Math.ceil(length / charsPerSegment) || 1;
  return { length, charsPerSegment, segments, isUnicode };
}
function countSmsTexts(text) {
  return getSmsStats(text).segments;
}

// src/notifications/shortLink.ts
var SHORT_CODE_LENGTH = 8;
var SHORT_CODE_ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
var SHORT_CODE_PLACEHOLDER = "xxxxxxxx";
var REJECTION_CEILING = Math.floor(256 / SHORT_CODE_ALPHABET.length) * SHORT_CODE_ALPHABET.length;
function readEnv4(key) {
  return typeof process !== "undefined" ? process.env?.[key] : void 0;
}
var baseUrlOverride;
function configureShortLinkBaseUrl(base) {
  baseUrlOverride = base;
}
function getShortLinkBaseUrl() {
  const raw = (baseUrlOverride ?? readEnv4("SHORTLINK_BASE_URL"))?.trim();
  if (!raw) {
    return void 0;
  }
  return raw.replace(/\/+$/, "");
}
function isShortLinkEnabled() {
  return getShortLinkBaseUrl() !== void 0;
}
function buildShortUrl(code) {
  const base = getShortLinkBaseUrl();
  if (!base) {
    throw new Error(
      "buildShortUrl called with no SHORTLINK_BASE_URL configured \u2014 check isShortLinkEnabled() first"
    );
  }
  return `${base}/${code}`;
}
function shortUrlLength() {
  const base = getShortLinkBaseUrl();
  if (!base) {
    return 0;
  }
  return base.length + 1 + SHORT_CODE_LENGTH;
}
function generateShortCode(nextByte, length = SHORT_CODE_LENGTH) {
  let code = "";
  let guard = 0;
  const maxDraws = length * 64;
  while (code.length < length) {
    if (guard++ > maxDraws) {
      throw new Error("generateShortCode: byte source failed to yield usable values");
    }
    const byte = nextByte() & 255;
    if (byte >= REJECTION_CEILING) {
      continue;
    }
    code += SHORT_CODE_ALPHABET[byte % SHORT_CODE_ALPHABET.length];
  }
  return code;
}
function isValidShortCode(code) {
  if (code.length !== SHORT_CODE_LENGTH) {
    return false;
  }
  for (const ch of code) {
    if (!SHORT_CODE_ALPHABET.includes(ch)) {
      return false;
    }
  }
  return true;
}
var URL_PATTERN = /https?:\/\/[^\s<>"']+[^\s<>"'.,;:!?)\]}]/g;
function collectUrls(text) {
  const matches = text.match(URL_PATTERN) ?? [];
  return [...new Set(matches)];
}
function isWorthShortening(url) {
  const base = getShortLinkBaseUrl();
  if (!base) {
    return false;
  }
  if (url.startsWith(`${base}/`)) {
    return false;
  }
  return url.length > shortUrlLength();
}
function collectShortenableUrls(text) {
  return collectUrls(text).filter(isWorthShortening);
}
function applyShortUrls(text, shortUrlByLongUrl) {
  const longUrls = Object.keys(shortUrlByLongUrl).sort((a, b) => b.length - a.length);
  let result = text;
  for (const longUrl of longUrls) {
    const shortUrl = shortUrlByLongUrl[longUrl];
    if (!shortUrl) {
      continue;
    }
    result = result.split(longUrl).join(shortUrl);
  }
  return result;
}
function previewShortenedText(text) {
  if (!isShortLinkEnabled()) {
    return text;
  }
  const placeholder = buildShortUrl(SHORT_CODE_PLACEHOLDER);
  const map = {};
  for (const url of collectShortenableUrls(text)) {
    map[url] = placeholder;
  }
  return applyShortUrls(text, map);
}

// src/notifications/adminPreferences.ts
var ADMIN_NOTIFICATION_PREFERENCE_KEYS = [
  "rateRequests",
  "customerMessages",
  "paymentIssues",
  "serviceChanges",
  "reviewRequired",
  "systemAlerts",
  "teamDayAlerts",
  "discardedVisits",
  "crewNotes",
  "visitPhotos",
  "visitUpdates",
  "skippedVisits",
  "crewChanges",
  "crewActivity",
  "deadlines",
  "paymentsReceived",
  "dailyCollectedSummary",
  "registrations",
  "accessRequests"
];
var ADMIN_NOTIFICATION_PREFERENCE_LABELS = {
  rateRequests: "Rate requests",
  customerMessages: "Customer messages",
  paymentIssues: "Payment issues",
  serviceChanges: "Service changes",
  reviewRequired: "Needs review",
  systemAlerts: "System alerts",
  teamDayAlerts: "First & last team member clocked in/out",
  discardedVisits: "Discarded visits",
  crewNotes: "Crew notes",
  visitPhotos: "Visit photos",
  visitUpdates: "Visit updates",
  skippedVisits: "Skipped visits",
  crewChanges: "Crew changes",
  crewActivity: "Crew activity",
  deadlines: "Deadlines",
  paymentsReceived: "Payments received",
  dailyCollectedSummary: "Daily collected total",
  registrations: "Customer registrations",
  accessRequests: "Access requests"
};
var ADMIN_NOTIFICATION_PREFERENCE_DEFAULTS = Object.freeze({
  rateRequests: Object.freeze({ email: true, sms: false, inApp: true }),
  customerMessages: Object.freeze({ email: true, sms: false, inApp: true }),
  // RUT-4511: payment-failed admin email now actually dispatches, so the
  // default matches other urgent office mail (rate requests, review). Texts
  // stay opt-in.
  paymentIssues: Object.freeze({ email: true, sms: false, inApp: true }),
  serviceChanges: Object.freeze({ email: false, sms: false, inApp: true }),
  reviewRequired: Object.freeze({ email: true, sms: false, inApp: true }),
  systemAlerts: Object.freeze({ email: true, sms: true, inApp: true }),
  // First-in / last-out carry no email template at all, so email stays off
  // rather than drawing a switch that could never deliver (RUT-1576, same
  // reasoning as RUT-3147). Whether these alerts exist for the org is a
  // separate, org-level lever — this only decides how a staff member receives
  // them once they do.
  teamDayAlerts: Object.freeze({ email: false, sms: false, inApp: true }),
  // A discarded visit always lands in the admin's in-app + push feed; the text
  // is opt-in (RUT-3348). There is no discard email template, so email stays off
  // rather than drawing a switch that could never deliver (same reasoning as
  // teamDayAlerts / RUT-3147).
  discardedVisits: Object.freeze({ email: false, sms: false, inApp: true }),
  crewNotes: Object.freeze({ email: false, sms: false, inApp: true }),
  visitPhotos: Object.freeze({ email: false, sms: false, inApp: true }),
  visitUpdates: Object.freeze({ email: false, sms: false, inApp: true }),
  // Visit skipped already emails the office; default on so mapping it onto a
  // switch does not silently stop those emails for accounts that never saved.
  skippedVisits: Object.freeze({ email: true, sms: false, inApp: true }),
  crewChanges: Object.freeze({ email: true, sms: false, inApp: true }),
  crewActivity: Object.freeze({ email: false, sms: false, inApp: true }),
  deadlines: Object.freeze({ email: false, sms: false, inApp: true }),
  paymentsReceived: Object.freeze({ email: false, sms: false, inApp: true }),
  // Optional end-of-day cash-flow text (RUT-4165). Off everywhere until an
  // Owner or Admin turns a switch on — crew never see the row.
  dailyCollectedSummary: Object.freeze({ email: false, sms: false, inApp: false }),
  registrations: Object.freeze({ email: true, sms: false, inApp: true }),
  accessRequests: Object.freeze({ email: true, sms: false, inApp: true })
});
var FALLBACK_CHANNEL_DEFAULTS = Object.freeze({
  email: false,
  sms: false,
  inApp: true
});
var ADMIN_PREFERENCE_HIDDEN_TYPES = /* @__PURE__ */ new Set([
  "visit_photo_approval_needed" /* VISIT_PHOTO_APPROVAL_NEEDED */
]);
var OFFICE_STAFF_ONLY_NOTIFICATION_TYPES = /* @__PURE__ */ new Set([
  "daily_collected_summary" /* DAILY_COLLECTED_SUMMARY */
]);
var ADMIN_NOTIFICATION_PREFERENCE_BY_TYPE = {
  // Rate & pricing
  ["rate_request_submitted" /* RATE_REQUEST_SUBMITTED */]: "rateRequests",
  ["rate_request_updated" /* RATE_REQUEST_UPDATED */]: "rateRequests",
  ["rate_accepted" /* RATE_ACCEPTED */]: "rateRequests",
  ["rate_declined" /* RATE_DECLINED */]: "rateRequests",
  ["rate_request_resurfaced" /* RATE_REQUEST_RESURFACED */]: "rateRequests",
  ["subscription_requested" /* SUBSCRIPTION_REQUESTED */]: "rateRequests",
  ["subscription_rate_provided" /* SUBSCRIPTION_RATE_PROVIDED */]: "rateRequests",
  ["subscription_batch_rates_released" /* SUBSCRIPTION_BATCH_RATES_RELEASED */]: "rateRequests",
  ["subscription_accepted" /* SUBSCRIPTION_ACCEPTED */]: "rateRequests",
  // Customer messages
  ["customer_message" /* CUSTOMER_MESSAGE */]: "customerMessages",
  ["admin_message" /* ADMIN_MESSAGE */]: "customerMessages",
  // Payment issues
  ["payment_failed" /* PAYMENT_FAILED */]: "paymentIssues",
  ["payment_retry" /* PAYMENT_RETRY */]: "paymentIssues",
  ["payment_overdue" /* PAYMENT_OVERDUE */]: "paymentIssues",
  // Service changes
  ["service_cancelled" /* SERVICE_CANCELLED */]: "serviceChanges",
  ["service_suspended" /* SERVICE_SUSPENDED */]: "serviceChanges",
  ["service_activated" /* SERVICE_ACTIVATED */]: "serviceChanges",
  ["service_enrollment_scheduled" /* SERVICE_ENROLLMENT_SCHEDULED */]: "serviceChanges",
  ["subscription_batch_cancelled" /* SUBSCRIPTION_BATCH_CANCELLED */]: "serviceChanges",
  ["subscription_package_option_changed" /* SUBSCRIPTION_PACKAGE_OPTION_CHANGED */]: "serviceChanges",
  ["subscription_plan_change_requested" /* SUBSCRIPTION_PLAN_CHANGE_REQUESTED */]: "reviewRequired",
  ["service_deactivation_completed" /* SERVICE_DEACTIVATION_COMPLETED */]: "serviceChanges",
  ["subscription_notes_updated" /* SUBSCRIPTION_NOTES_UPDATED */]: "serviceChanges",
  ["subscription_customer_selections_changed" /* SUBSCRIPTION_CUSTOMER_SELECTIONS_CHANGED */]: "serviceChanges",
  // Needs review
  ["job_review_required" /* JOB_REVIEW_REQUIRED */]: "reviewRequired",
  ["visit_photo_approval_needed" /* VISIT_PHOTO_APPROVAL_NEEDED */]: "reviewRequired",
  // System alerts
  ["system_alert" /* SYSTEM_ALERT */]: "systemAlerts",
  ["organization_update" /* ORGANIZATION_UPDATE */]: "systemAlerts",
  ["holiday_delay_warning" /* HOLIDAY_DELAY_WARNING */]: "systemAlerts",
  // Shop Advisors (RUT-3751). In-app only.
  ["shop_advisor" /* SHOP_ADVISOR */]: "systemAlerts",
  ["feedback_resolved" /* FEEDBACK_RESOLVED */]: "systemAlerts",
  // First & last team member clocked in/out (RUT-1576 / RUT-3991)
  ["team_day_started" /* TEAM_DAY_STARTED */]: "teamDayAlerts",
  ["team_day_ended" /* TEAM_DAY_ENDED */]: "teamDayAlerts",
  // Discarded visits (RUT-3348) — this mapping is what gates the admin's discard
  // text: without it the SMS send path would treat a text as always-on rather
  // than opt-in.
  ["visit_discarded" /* VISIT_DISCARDED */]: "discardedVisits",
  ["visit_notes_added" /* VISIT_NOTES_ADDED */]: "crewNotes",
  ["visit_photos_added" /* VISIT_PHOTOS_ADDED */]: "visitPhotos",
  ["visit_started" /* VISIT_STARTED */]: "visitUpdates",
  ["visit_paused" /* VISIT_PAUSED */]: "visitUpdates",
  ["visit_resumed" /* VISIT_RESUMED */]: "visitUpdates",
  ["visit_cancelled" /* VISIT_CANCELLED */]: "visitUpdates",
  ["followup_visit_completed" /* FOLLOWUP_VISIT_COMPLETED */]: "visitUpdates",
  ["visit_completed_reminder" /* VISIT_COMPLETED_REMINDER */]: "visitUpdates",
  ["visit_skipped" /* VISIT_SKIPPED */]: "skippedVisits",
  ["crew_registration" /* CREW_REGISTRATION */]: "crewChanges",
  ["crew_dispatch_executed" /* CREW_DISPATCH_EXECUTED */]: "crewChanges",
  ["crew_auto_assigned" /* CREW_AUTO_ASSIGNED */]: "crewChanges",
  ["crew_assignment_conflict" /* CREW_ASSIGNMENT_CONFLICT */]: "crewChanges",
  ["crew_member_added" /* CREW_MEMBER_ADDED */]: "crewChanges",
  ["crew_clock_in" /* CREW_CLOCK_IN */]: "crewActivity",
  ["crew_clock_out" /* CREW_CLOCK_OUT */]: "crewActivity",
  ["crew_bulk_clock_out" /* CREW_BULK_CLOCK_OUT */]: "crewActivity",
  ["crew_inactive_2h" /* CREW_INACTIVE_2H */]: "crewActivity",
  ["crew_location_dropped" /* CREW_LOCATION_DROPPED */]: "crewActivity",
  ["crew_left_geofence" /* CREW_LEFT_GEOFENCE */]: "crewActivity",
  ["crew_app_outdated" /* CREW_APP_OUTDATED */]: "crewActivity",
  ["crew_urgent_message_acknowledged" /* CREW_URGENT_MESSAGE_ACKNOWLEDGED */]: "crewActivity",
  ["crew_note_acknowledged" /* CREW_NOTE_ACKNOWLEDGED */]: "crewActivity",
  ["crew_route_order_changed" /* CREW_ROUTE_ORDER_CHANGED */]: "crewActivity",
  ["one_time_deadline_at_risk" /* ONE_TIME_DEADLINE_AT_RISK */]: "deadlines",
  ["visit_payment_received" /* VISIT_PAYMENT_RECEIVED */]: "paymentsReceived",
  ["batch_charge_completed" /* BATCH_CHARGE_COMPLETED */]: "paymentsReceived",
  ["payment_method_added" /* PAYMENT_METHOD_ADDED */]: "paymentsReceived",
  ["daily_collected_summary" /* DAILY_COLLECTED_SUMMARY */]: "dailyCollectedSummary",
  ["customer_portal_registered" /* CUSTOMER_PORTAL_REGISTERED */]: "registrations",
  ["access_request_submitted" /* ACCESS_REQUEST_SUBMITTED */]: "accessRequests"
};
function isAdminNotificationPreferenceKey(key) {
  return ADMIN_NOTIFICATION_PREFERENCE_KEYS.includes(key);
}
function getAdminPreferenceKeyForType(type) {
  return ADMIN_NOTIFICATION_PREFERENCE_BY_TYPE[type] ?? null;
}
function isStaffDispatchType(type) {
  const config = NOTIFICATION_TYPE_CONFIGS[type];
  if (!config) return false;
  if (!config.targetRoles.includes("admin" /* ADMIN */)) return false;
  if (!config.targetRoles.includes("customer" /* CUSTOMER */)) return true;
  return type === "payment_failed" /* PAYMENT_FAILED */;
}
function defaultsForType(type) {
  const categoryKey = getAdminPreferenceKeyForType(type);
  return categoryKey ? ADMIN_NOTIFICATION_PREFERENCE_DEFAULTS[categoryKey] : FALLBACK_CHANNEL_DEFAULTS;
}
function isAdminTypeChannelCapable(type, channel) {
  const config = NOTIFICATION_TYPE_CONFIGS[type];
  if (!config) return false;
  if (!config.targetRoles.includes("admin" /* ADMIN */)) return false;
  if (!config.channels.includes(channel)) return false;
  if (channel === "in_app" /* IN_APP */) return true;
  return isStaffDispatchType(type);
}
function isAdminChannelCapable(key, channel) {
  return Object.entries(ADMIN_NOTIFICATION_PREFERENCE_BY_TYPE).some(([type, mapped]) => {
    if (mapped !== key) return false;
    return isAdminTypeChannelCapable(type, channel);
  });
}
function isAdminSmsCapable(key) {
  return isAdminChannelCapable(key, "sms" /* SMS */);
}
function getAdminSmsCapableKeys() {
  return ADMIN_NOTIFICATION_PREFERENCE_KEYS.filter(isAdminSmsCapable);
}
function isAdminEmailCapable(key) {
  return isAdminChannelCapable(key, "email" /* EMAIL */);
}
function resolveAdminChannelSettings(key, stored) {
  const defaults = isAdminNotificationPreferenceKey(key) ? ADMIN_NOTIFICATION_PREFERENCE_DEFAULTS[key] : defaultsForType(key);
  return {
    email: stored?.email ?? defaults.email,
    sms: stored?.sms ?? defaults.sms,
    inApp: stored?.inApp ?? defaults.inApp
  };
}
function resolveAdminSettingsForType(type, stored) {
  const defaults = defaultsForType(type);
  const typeStored = stored?.[type];
  const categoryKey = getAdminPreferenceKeyForType(type);
  const categoryStored = categoryKey ? stored?.[categoryKey] : void 0;
  return {
    email: typeStored?.email ?? categoryStored?.email ?? defaults.email,
    sms: typeStored?.sms ?? categoryStored?.sms ?? defaults.sms,
    inApp: typeStored?.inApp ?? categoryStored?.inApp ?? defaults.inApp
  };
}
function listAdminPreferenceTypeRows(options) {
  const categoryOrder = Object.keys(NOTIFICATION_CATEGORY_LABELS);
  const rows = [];
  const hideOfficeStaffOnly = options != null && !isOfficeStaffRoleId(options.roleId ?? void 0);
  for (const config of Object.values(NOTIFICATION_TYPE_CONFIGS)) {
    if (ADMIN_PREFERENCE_HIDDEN_TYPES.has(config.type)) continue;
    if (hideOfficeStaffOnly && OFFICE_STAFF_ONLY_NOTIFICATION_TYPES.has(config.type)) continue;
    if (!config.targetRoles.includes("admin" /* ADMIN */)) continue;
    const capable = ["email" /* EMAIL */, "sms" /* SMS */, "in_app" /* IN_APP */].some((channel) => isAdminTypeChannelCapable(config.type, channel));
    if (!capable) continue;
    rows.push({
      type: config.type,
      name: config.name,
      description: config.description,
      category: config.category,
      categoryLabel: NOTIFICATION_CATEGORY_LABELS[config.category]
    });
  }
  rows.sort((a, b) => {
    const categoryDiff = categoryOrder.indexOf(a.category) - categoryOrder.indexOf(b.category);
    if (categoryDiff !== 0) return categoryDiff;
    return a.name.localeCompare(b.name);
  });
  return rows;
}
function groupAdminPreferenceTypeRows(rows = listAdminPreferenceTypeRows()) {
  const grouped = /* @__PURE__ */ new Map();
  for (const row of rows) {
    const list = grouped.get(row.categoryLabel);
    if (list) list.push(row);
    else grouped.set(row.categoryLabel, [row]);
  }
  return [...grouped.entries()];
}

// src/notifications/bellFilters.ts
var BELL_FILTER_GROUPS = [
  {
    id: "photos",
    label: "Photo uploads",
    tooltip: "Hide when a crew adds photos to a visit. They still show on Photo Review.",
    types: ["visit_photos_added" /* VISIT_PHOTOS_ADDED */]
  },
  {
    id: "notes",
    label: "Crew notes",
    tooltip: "Hide when a crew adds a note to a visit.",
    types: ["visit_notes_added" /* VISIT_NOTES_ADDED */]
  },
  {
    id: "discard",
    label: "Discarded visits",
    tooltip: "Hide when a visit is discarded.",
    types: ["visit_discarded" /* VISIT_DISCARDED */]
  },
  {
    id: "payment",
    label: "Payments",
    tooltip: "Hide payment alerts \u2014 received, failed, and overdue.",
    types: [
      "payment_failed" /* PAYMENT_FAILED */,
      "payment_overdue" /* PAYMENT_OVERDUE */,
      "payment_retry" /* PAYMENT_RETRY */,
      "visit_payment_received" /* VISIT_PAYMENT_RECEIVED */,
      "batch_charge_completed" /* BATCH_CHARGE_COMPLETED */
    ]
  },
  {
    id: "rate_request",
    label: "Rate requests",
    tooltip: "Hide when a customer asks for a rate.",
    types: [
      "rate_request_submitted" /* RATE_REQUEST_SUBMITTED */,
      "rate_request_updated" /* RATE_REQUEST_UPDATED */,
      "rate_request_resurfaced" /* RATE_REQUEST_RESURFACED */,
      "subscription_requested" /* SUBSCRIPTION_REQUESTED */
    ]
  },
  {
    id: "registration",
    label: "Registrations",
    tooltip: "Hide when a customer creates a portal account.",
    types: ["customer_portal_registered" /* CUSTOMER_PORTAL_REGISTERED */]
  }
];
var BELL_FILTER_BUTTON_TOOLTIP = "Hide chosen types from this list";
var CREW_VISIBLE_BELL_FILTER_GROUP_IDS = /* @__PURE__ */ new Set([
  "photos",
  "notes",
  "discard"
]);
function isBellFilterOfficeRole(roleId) {
  if (!roleId) return true;
  if (roleId === "admin" /* ADMIN */) return true;
  if (roleId === "crew" /* CREW */ || roleId === "customer" /* CUSTOMER */) return false;
  return roleId === BUILT_IN_ROLE_IDS.OWNER || roleId === BUILT_IN_ROLE_IDS.ADMIN || roleId === BUILT_IN_ROLE_IDS.CREW_LEADER || roleId === BUILT_IN_ROLE_IDS.SUBCONTRACTOR_LEAD;
}
function getBellFilterGroupsForRole(roleId) {
  if (isBellFilterOfficeRole(roleId)) return BELL_FILTER_GROUPS;
  return BELL_FILTER_GROUPS.filter((group) => CREW_VISIBLE_BELL_FILTER_GROUP_IDS.has(group.id));
}
var NOTIFICATION_TYPE_VALUES = new Set(Object.values(NotificationType));
var HIDEABLE_NOTIFICATION_TYPES = new Set(
  BELL_FILTER_GROUPS.flatMap((group) => group.types)
);
function parseExcludeTypesParam(raw) {
  if (!raw) return [];
  const seen = /* @__PURE__ */ new Set();
  for (const part of raw.split(",")) {
    const value = part.trim();
    if (NOTIFICATION_TYPE_VALUES.has(value)) {
      seen.add(value);
    }
  }
  return [...seen];
}
function serializeExcludeTypesParam(types) {
  return [...new Set(types)].sort().join(",");
}
function mergeBellExcludeTypes(userHidden) {
  const seen = /* @__PURE__ */ new Set(["customer_message" /* CUSTOMER_MESSAGE */, ...userHidden]);
  return [...seen];
}
function isBellFilterGroupHidden(hiddenTypes, groupId) {
  const group = BELL_FILTER_GROUPS.find((g) => g.id === groupId);
  if (!group) return false;
  return group.types.every((type) => hiddenTypes.includes(type));
}
function toggleBellFilterGroup(hiddenTypes, groupId) {
  const group = BELL_FILTER_GROUPS.find((g) => g.id === groupId);
  if (!group) return [...hiddenTypes];
  const next = new Set(hiddenTypes);
  const hide = !isBellFilterGroupHidden(hiddenTypes, groupId);
  for (const type of group.types) {
    if (hide) next.add(type);
    else next.delete(type);
  }
  return [...next];
}
function sanitizeHiddenInAppTypes(types) {
  const seen = /* @__PURE__ */ new Set();
  for (const type of types) {
    if (HIDEABLE_NOTIFICATION_TYPES.has(type)) {
      seen.add(type);
    }
  }
  return [...seen];
}
function isHiddenInAppType(type, hiddenTypes) {
  if (!type) return false;
  return hiddenTypes.includes(type);
}

// src/notifications/askForCardCampaign.ts
var ASK_FOR_CARD_TEMPLATE_ID = "builtin:ask-for-card";
var ASK_FOR_CARD_NAME = "Ask for a card";
var ASK_FOR_CARD_EMAIL_SUBJECT = "Add a card on file \u2014 it takes a minute";
var ASK_FOR_CARD_EMAIL_CONTENT = `Hi {{customerFirstName}},

Please add a card to your {{orgName}} account. If you had one with us before, this is the new place to keep it. Adding it takes a minute, and we'll charge it after each visit.

Thanks,
{{orgName}}`;
var ASK_FOR_CARD_SMS_CONTENT = "Hi {{customerFirstName}}, add a card to your {{orgName}} account. If you had one with us before, this is the new place to keep it. Adding it takes a minute: {{paymentLink}}";
var ASK_FOR_CARD_EMAIL_ACTION = {
  label: "Add your card",
  url: "paymentLink"
};
function askForCardAudienceFilter() {
  return {
    rules: [],
    customerCities: [],
    activeOnly: true,
    paymentStatus: "missing"
  };
}
function builtinAskForCardTemplate(orgId) {
  return {
    templateId: ASK_FOR_CARD_TEMPLATE_ID,
    orgId,
    name: ASK_FOR_CARD_NAME,
    emailSubject: ASK_FOR_CARD_EMAIL_SUBJECT,
    emailContent: ASK_FOR_CARD_EMAIL_CONTENT,
    smsContent: ASK_FOR_CARD_SMS_CONTENT,
    emailAction: { label: ASK_FOR_CARD_EMAIL_ACTION.label, url: ASK_FOR_CARD_EMAIL_ACTION.url },
    builtIn: true,
    createdBy: "ruta",
    createdByName: "Ruta",
    createdAt: "1970-01-01T00:00:00.000Z",
    updatedAt: "1970-01-01T00:00:00.000Z"
  };
}
function isBuiltinMessageTemplateId(id) {
  return id.startsWith("builtin:");
}

// src/analytics/events.ts
var SharedSubscriptionEvent = /* @__PURE__ */ ((SharedSubscriptionEvent2) => {
  SharedSubscriptionEvent2["RATE_ACCEPTED"] = "subscription_rate_accepted";
  SharedSubscriptionEvent2["RATE_DECLINED"] = "subscription_rate_declined";
  return SharedSubscriptionEvent2;
})(SharedSubscriptionEvent || {});
var SharedSubscriptionEvents = {
  rateAccepted: (props) => ({
    event: "subscription_rate_accepted" /* RATE_ACCEPTED */,
    properties: props
  }),
  rateDeclined: (props) => ({
    event: "subscription_rate_declined" /* RATE_DECLINED */,
    properties: props
  })
};

// src/transformations/validation.ts
var TransformationError = class extends Error {
  constructor(message, entityType, field, value) {
    super(message);
    this.entityType = entityType;
    this.field = field;
    this.value = value;
    this.name = "TransformationError";
  }
};
function validateRequiredFields(record, requiredFields, entityType) {
  for (const field of requiredFields) {
    if (record[field] === void 0 || record[field] === null) {
      throw new TransformationError(
        `Missing required field: ${field}`,
        entityType,
        field
      );
    }
    if (typeof record[field] === "string" && record[field].trim() === "") {
      throw new TransformationError(
        `Empty required field: ${field}`,
        entityType,
        field,
        record[field]
      );
    }
  }
}
function validateDdbRecord(record, expectedEntityType) {
  const requiredDdbFields = ["PK", "SK", "entityType"];
  validateRequiredFields(record, requiredDdbFields, String(expectedEntityType));
  if (record.entityType !== expectedEntityType) {
    throw new TransformationError(
      `Invalid entity type. Expected: ${expectedEntityType}, Got: ${record.entityType}`,
      String(expectedEntityType),
      "entityType",
      record.entityType
    );
  }
  if (!record.PK || typeof record.PK !== "string" || !record.PK.includes("#")) {
    throw new TransformationError(
      "Invalid PK format",
      String(expectedEntityType),
      "PK",
      record.PK
    );
  }
  if (!record.SK || typeof record.SK !== "string" || !record.SK.includes("#")) {
    throw new TransformationError(
      "Invalid SK format",
      String(expectedEntityType),
      "SK",
      record.SK
    );
  }
}
function safeTransform(input, transformer, entityType) {
  try {
    if (!input) {
      throw new TransformationError("Input is null or undefined", entityType);
    }
    return transformer(input);
  } catch (error) {
    if (error instanceof TransformationError) {
      throw error;
    }
    throw new TransformationError(
      `Transformation failed: ${error instanceof Error ? error.message : "Unknown error"}`,
      entityType,
      void 0,
      input
    );
  }
}
function safeTransformArray(inputs, transformer, entityType) {
  const results = [];
  for (const input of inputs) {
    try {
      if (!input) {
        console.warn(`Skipping null/undefined ${entityType} record`);
        continue;
      }
      const result = transformer(input);
      results.push(result);
    } catch (error) {
      if (error instanceof TransformationError) {
        console.warn(`Skipping invalid ${entityType} record:`, error.message, {
          field: error.field,
          value: error.value
        });
      } else {
        console.warn(
          `Skipping ${entityType} record due to transformation error:`,
          error instanceof Error ? error.message : "Unknown error"
        );
      }
    }
  }
  return results;
}

// src/transformations/batch.ts
function rateBatchToDdbRecord(rateBatch) {
  return safeTransform(
    rateBatch,
    (input) => {
      validateRequiredFields(
        input,
        ["batchId", "orgId", "customerId", "subscriptions", "releasedBy", "createdAt"],
        "RateBatchRecord"
      );
      const record = {
        ...input,
        // Add DynamoDB storage fields
        PK: DDB_KEY_BUILDERS.orgPK(input.orgId),
        SK: DDB_KEY_BUILDERS.rateBatchSK(input.batchId),
        entityType: "RATE_BATCH"
      };
      return record;
    },
    "RateBatchRecord"
  );
}
function cancellationBatchToDdbRecord(cancellationBatch) {
  return safeTransform(
    cancellationBatch,
    (input) => {
      validateRequiredFields(
        input,
        ["batchId", "orgId", "customerId", "subscriptions", "cancelledBy", "createdAt"],
        "CancellationBatchRecord"
      );
      const record = {
        ...input,
        // Add DynamoDB storage fields
        PK: DDB_KEY_BUILDERS.orgPK(input.orgId),
        SK: `CANCELLATION_BATCH#${input.batchId}`,
        entityType: "CANCELLATION_BATCH"
      };
      return record;
    },
    "CancellationBatchRecord"
  );
}
function rateBatchFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      const { PK: _PK, SK: _SK, entityType: _entityType, ...rateBatch } = input;
      validateRequiredFields(
        rateBatch,
        ["batchId", "orgId", "customerId", "subscriptions", "releasedBy", "createdAt"],
        "RateBatchRecord"
      );
      return rateBatch;
    },
    "RateBatchRecord"
  );
}
function cancellationBatchFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      const { PK: _PK, SK: _SK, entityType: _entityType, ...cancellationBatch } = input;
      validateRequiredFields(
        cancellationBatch,
        ["batchId", "orgId", "customerId", "subscriptions", "cancelledBy", "createdAt"],
        "CancellationBatchRecord"
      );
      return cancellationBatch;
    },
    "CancellationBatchRecord"
  );
}
function rateBatchesFromDdbRecords(records) {
  return safeTransformArray(records, rateBatchFromDdbRecord, "BATCH" /* BATCH */);
}
function cancellationBatchesFromDdbRecords(records) {
  return safeTransformArray(
    records,
    cancellationBatchFromDdbRecord,
    "BATCH" /* BATCH */
  );
}

// src/transformations/contact.ts
var ContactEntityType = /* @__PURE__ */ ((ContactEntityType2) => {
  ContactEntityType2["CUSTOMER_CONTACT"] = "CUSTOMER_CONTACT";
  ContactEntityType2["CUSTOMER_EMAIL"] = "CUSTOMER_EMAIL";
  return ContactEntityType2;
})(ContactEntityType || {});
function contactItemToDdbRecord(contactItem) {
  const contactPrefix = contactItem.contactType === "EMAIL" /* EMAIL */ ? "EMAIL" : "PHONE";
  return {
    ...contactItem,
    // Add DynamoDB storage fields
    PK: DDB_KEY_BUILDERS.orgPK(contactItem.orgId),
    SK: `CONTACT#${contactPrefix}#${contactItem.contactValue}`,
    GSI3PK: `${contactPrefix}#${contactItem.contactValue}`,
    GSI3SK: DDB_KEY_BUILDERS.customerSK(contactItem.customerId),
    entityType: "CUSTOMER_CONTACT" /* CUSTOMER_CONTACT */
  };
}
function contactItemFromDdbRecord(record) {
  const {
    PK: _PK,
    SK: _SK,
    GSI3PK: _GSI3PK,
    GSI3SK: _GSI3SK,
    entityType: _entityType,
    ...contactItem
  } = record;
  return contactItem;
}
function contactItemsFromDdbRecords(records) {
  return records.map(contactItemFromDdbRecord);
}
function customerEmailToDdbRecord(email, orgId, customerId) {
  return {
    ...email,
    // Add DynamoDB storage fields
    PK: DDB_KEY_BUILDERS.orgPK(orgId),
    SK: `CUSTOMER#${customerId}#EMAIL#${email.id}`,
    GSI1PK: `EMAIL#${email.email.toLowerCase().trim()}`,
    GSI1SK: DDB_KEY_BUILDERS.customerSK(customerId),
    entityType: "CUSTOMER_EMAIL" /* CUSTOMER_EMAIL */,
    orgId,
    customerId
  };
}
function customerEmailFromDdbRecord(record) {
  const {
    PK: _PK,
    SK: _SK,
    GSI1PK: _GSI1PK,
    GSI1SK: _GSI1SK,
    entityType: _entityType,
    orgId: _orgId,
    customerId: _customerId,
    ...email
  } = record;
  return email;
}
function customerEmailsFromDdbRecords(records) {
  return records.map(customerEmailFromDdbRecord);
}

// src/transformations/crew.ts
function crewToDdbRecord(crew, auditInfo) {
  return {
    ...crew,
    // Add DynamoDB storage fields
    PK: DDB_KEY_BUILDERS.orgPK(crew.orgId),
    SK: DDB_KEY_BUILDERS.crewSK(crew.id),
    GSI1PK: DDB_KEY_BUILDERS.crewSK(crew.id),
    GSI1SK: `METADATA#${crew.id}`,
    // Add audit fields if provided
    createdBy: auditInfo?.createdBy,
    updatedBy: auditInfo?.updatedBy,
    entityType: "CREW" /* CREW */
  };
}
function crewFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      validateDdbRecord(input, "CREW" /* CREW */);
      const {
        PK: _PK,
        SK: _SK,
        GSI1PK: _GSI1PK,
        GSI1SK: _GSI1SK,
        createdBy: _createdBy,
        updatedBy: _updatedBy,
        entityType: _entityType,
        ...crew
      } = input;
      return crew;
    },
    "CREW" /* CREW */
  );
}
function crewsFromDdbRecords(records) {
  return safeTransformArray(records, crewFromDdbRecord, "CREW" /* CREW */);
}

// src/transformations/customer.ts
function customerToDdbRecord(customer) {
  return safeTransform(
    customer,
    (input) => {
      validateRequiredFields(
        input,
        ["id", "orgId", "displayName", "status", "createdAt"],
        "Customer"
      );
      const cleanPhone = input.phone?.replace(/\D/g, "") || "";
      const sortableName = `${(input.displayName || "").toUpperCase()}#${input.id}`;
      const record = {
        ...input,
        // Add DynamoDB storage fields
        PK: DDB_KEY_BUILDERS.orgPK(input.orgId),
        SK: DDB_KEY_BUILDERS.customerSK(input.id),
        // GSI1: Status-based queries (primary pattern for customer queries)
        GSI1PK: DDB_KEY_BUILDERS.customerStatusGSI(input.orgId, input.status),
        GSI1SK: input.lastActivityAt || input.updatedAt || input.createdAt,
        // GSI2: Name-based sorting queries
        GSI2PK: DDB_KEY_BUILDERS.orgPK(input.orgId),
        GSI2SK: `CUSTOMER_NAME#${sortableName}`,
        // GSI3: Address-based dedup queries
        GSI3PK: input.normalizedAddress ? DDB_KEY_BUILDERS.customerAddressGSI(input.orgId, input.normalizedAddress) : void 0,
        GSI3SK: input.normalizedAddress ? DDB_KEY_BUILDERS.customerSK(input.id) : void 0,
        // GSI4: Phone-based queries (moved from GSI2)
        GSI4PK: input.phone && cleanPhone ? DDB_KEY_BUILDERS.customerPhoneGSI(cleanPhone) : void 0,
        GSI4SK: input.phone && cleanPhone ? DDB_KEY_BUILDERS.customerSK(input.id) : void 0,
        entityType: "CUSTOMER" /* CUSTOMER */
      };
      validateDdbRecord(record, "CUSTOMER" /* CUSTOMER */);
      return record;
    },
    "Customer"
  );
}
function customerFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      validateDdbRecord(input, "CUSTOMER" /* CUSTOMER */);
      const {
        PK: _PK,
        SK: _SK,
        GSI1PK: _GSI1PK,
        GSI1SK: _GSI1SK,
        GSI2PK: _GSI2PK,
        GSI2SK: _GSI2SK,
        GSI3PK: _GSI3PK,
        GSI3SK: _GSI3SK,
        GSI4PK: _GSI4PK,
        GSI4SK: _GSI4SK,
        entityType: _entityType,
        ...customer
      } = input;
      validateRequiredFields(
        customer,
        ["id", "orgId", "displayName", "status", "createdAt"],
        "Customer"
      );
      if (customer.address) {
        customer.address = formatAddressToString(customer.address);
      }
      return customer;
    },
    "Customer"
  );
}
function customersFromDdbRecords(records) {
  return safeTransformArray(
    records,
    customerFromDdbRecord,
    "CUSTOMER" /* CUSTOMER */
  );
}

// src/transformations/customerHistory.ts
function termsAcceptanceToDdbRecord(acceptance) {
  return safeTransform(
    acceptance,
    (input) => {
      validateRequiredFields(
        input,
        [
          "id",
          "orgId",
          "customerId",
          "acceptedAt",
          "rutaTermsUrl",
          "rutaPrivacyUrl",
          "createdAt"
        ],
        "TermsAcceptance"
      );
      const record = {
        ...input,
        PK: DDB_KEY_BUILDERS.orgPK(input.orgId),
        SK: DDB_KEY_BUILDERS.termsAcceptanceSK(
          input.customerId,
          input.acceptedAt
        ),
        entityType: "TERMS_ACCEPTANCE" /* TERMS_ACCEPTANCE */
      };
      validateDdbRecord(record, "TERMS_ACCEPTANCE" /* TERMS_ACCEPTANCE */);
      return record;
    },
    "TermsAcceptance"
  );
}
function termsAcceptanceFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      validateDdbRecord(input, "TERMS_ACCEPTANCE" /* TERMS_ACCEPTANCE */);
      const {
        PK: _PK,
        SK: _SK,
        entityType: _entityType,
        ...domainFields
      } = input;
      return domainFields;
    },
    "TermsAcceptanceDbRecord"
  );
}
function termsAcceptancesFromDdbRecords(records) {
  return safeTransformArray(
    records,
    termsAcceptanceFromDdbRecord,
    "TermsAcceptanceDbRecords"
  );
}
function portalLoginToDdbRecord(login) {
  return safeTransform(
    login,
    (input) => {
      validateRequiredFields(
        input,
        ["id", "orgId", "customerId", "loggedInAt", "contact", "createdAt"],
        "PortalLogin"
      );
      const record = {
        ...input,
        PK: DDB_KEY_BUILDERS.orgPK(input.orgId),
        SK: DDB_KEY_BUILDERS.portalLoginSK(input.customerId, input.loggedInAt),
        entityType: "PORTAL_LOGIN" /* PORTAL_LOGIN */
      };
      validateDdbRecord(record, "PORTAL_LOGIN" /* PORTAL_LOGIN */);
      return record;
    },
    "PortalLogin"
  );
}
function portalLoginFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      validateDdbRecord(input, "PORTAL_LOGIN" /* PORTAL_LOGIN */);
      const {
        PK: _PK,
        SK: _SK,
        entityType: _entityType,
        ...domainFields
      } = input;
      return domainFields;
    },
    "PortalLoginDbRecord"
  );
}
function portalLoginsFromDdbRecords(records) {
  return safeTransformArray(
    records,
    portalLoginFromDdbRecord,
    "PortalLoginDbRecords"
  );
}

// src/transformations/invoice.ts
function invoiceToDdbRecord(invoice) {
  return safeTransform(
    invoice,
    (input) => {
      validateRequiredFields(
        input,
        ["id", "orgId", "customerId", "invoiceNumber", "amount", "status", "createdAt"],
        "Invoice"
      );
      const record = {
        ...input,
        // Add DynamoDB storage fields
        PK: DDB_KEY_BUILDERS.orgPK(input.orgId),
        SK: DDB_KEY_BUILDERS.invoiceSK(input.id),
        // GSI1: Customer-based queries
        GSI1PK: `ORG#${input.orgId}#CUSTOMER#${input.customerId}`,
        GSI1SK: `INVOICE#${input.id}`,
        entityType: "INVOICE" /* INVOICE */
      };
      validateDdbRecord(record, "INVOICE" /* INVOICE */);
      return record;
    },
    "Invoice"
  );
}
function invoiceFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      validateDdbRecord(input, "INVOICE" /* INVOICE */);
      const {
        PK: _PK,
        SK: _SK,
        GSI1PK: _GSI1PK,
        GSI1SK: _GSI1SK,
        entityType: _entityType,
        ...invoice
      } = input;
      validateRequiredFields(
        invoice,
        ["id", "orgId", "customerId", "invoiceNumber", "amount", "status", "createdAt"],
        "Invoice"
      );
      return invoice;
    },
    "Invoice"
  );
}
function invoicesFromDdbRecords(records) {
  return safeTransformArray(records, invoiceFromDdbRecord, "INVOICE" /* INVOICE */);
}

// src/transformations/ledger.ts
function ledgerEntryToDdbRecord(entry) {
  return safeTransform(
    entry,
    (input) => {
      validateRequiredFields(
        input,
        [
          "id",
          "orgId",
          "customerId",
          "type",
          "amount",
          "description",
          "balanceAfter",
          "createdAt",
          "createdBy"
        ],
        "LedgerEntry"
      );
      const timestamp = input.createdAt;
      const record = {
        ...input,
        // Add DynamoDB storage fields
        PK: DDB_KEY_BUILDERS.orgPK(input.orgId),
        SK: DDB_KEY_BUILDERS.ledgerSK(input.customerId, timestamp, input.id),
        // GSI1: Query ledger entries by customer chronologically
        GSI1PK: DDB_KEY_BUILDERS.ledgerCustomerGSI1PK(
          input.orgId,
          input.customerId
        ),
        GSI1SK: DDB_KEY_BUILDERS.ledgerEntryGSI1SK(timestamp),
        // GSI2: Query by entry type
        GSI2PK: DDB_KEY_BUILDERS.ledgerCustomerGSI1PK(
          input.orgId,
          input.customerId
        ),
        GSI2SK: DDB_KEY_BUILDERS.ledgerTypeGSI2SK(input.type, timestamp),
        // GSI3: Query by visit reference (only for entries with visitId)
        GSI3PK: input.visitId ? DDB_KEY_BUILDERS.ledgerVisitGSI3PK(input.orgId, input.visitId) : void 0,
        GSI3SK: input.visitId ? DDB_KEY_BUILDERS.ledgerEntryGSI1SK(timestamp) : void 0,
        entityType: "LEDGER_ENTRY" /* LEDGER_ENTRY */
      };
      validateDdbRecord(record, "LEDGER_ENTRY" /* LEDGER_ENTRY */);
      return record;
    },
    "LedgerEntry"
  );
}
function ledgerEntryFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      validateDdbRecord(input, "LEDGER_ENTRY" /* LEDGER_ENTRY */);
      const {
        PK: _PK,
        SK: _SK,
        GSI1PK: _GSI1PK,
        GSI1SK: _GSI1SK,
        GSI2PK: _GSI2PK,
        GSI2SK: _GSI2SK,
        GSI3PK: _GSI3PK,
        GSI3SK: _GSI3SK,
        entityType: _entityType,
        ...domainFields
      } = input;
      return domainFields;
    },
    "LedgerDbRecord"
  );
}
function ledgerEntriesFromDdbRecords(records) {
  return safeTransformArray(
    records,
    ledgerEntryFromDdbRecord,
    "LedgerDbRecords"
  );
}

// src/transformations/location.ts
function locationToDdbRecord(location) {
  return safeTransform(
    location,
    (input) => {
      validateRequiredFields(
        input,
        ["memberId", "orgId", "latitude", "longitude", "timestamp"],
        "MemberLocation"
      );
      const now = (/* @__PURE__ */ new Date()).toISOString();
      const ttlDate = /* @__PURE__ */ new Date();
      ttlDate.setDate(ttlDate.getDate() + 90);
      const ttl = Math.floor(ttlDate.getTime() / 1e3);
      const record = {
        ...input,
        // Add DynamoDB storage fields
        PK: DDB_KEY_BUILDERS.memberLocationPK(input.memberId),
        SK: DDB_KEY_BUILDERS.timestampSK(input.timestamp),
        createdAt: now,
        TTL: ttl,
        type: LOCATION_RECORD_TYPE
      };
      return record;
    },
    "MemberLocation"
  );
}
function locationFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      const {
        PK: _PK,
        SK: _SK,
        createdAt: _createdAt,
        TTL: _TTL,
        type: _type,
        ...location
      } = input;
      validateRequiredFields(
        location,
        ["memberId", "orgId", "latitude", "longitude", "timestamp"],
        "MemberLocation"
      );
      return location;
    },
    "MemberLocation"
  );
}
function locationsFromDdbRecords(records) {
  return safeTransformArray(records, locationFromDdbRecord, "LOCATION" /* LOCATION */);
}

// src/transformations/locationSegment.ts
var COORD_DECIMALS = 6;
function round3(value, decimals) {
  const factor = 10 ** decimals;
  return Math.round(value * factor) / factor;
}
function optionalNumber(value, decimals) {
  return typeof value === "number" && Number.isFinite(value) ? round3(value, decimals) : null;
}
function locationSegmentStartTs(record) {
  return record.SK.slice(DDB_KEY_PATTERNS.LOCATION_SEGMENT_PREFIX.length);
}
function packPoints(windowStartMs, points) {
  const packed = points.map((point) => [
    new Date(point.timestamp).getTime() - windowStartMs,
    round3(point.latitude, COORD_DECIMALS),
    round3(point.longitude, COORD_DECIMALS),
    optionalNumber(point.accuracy, 1),
    optionalNumber(point.speed, 2),
    optionalNumber(point.heading, 1)
  ]);
  return JSON.stringify(packed);
}
function buildLocationSegment(points, ttlSeconds) {
  if (points.length === 0) {
    throw new Error("buildLocationSegment: at least one point is required");
  }
  const sorted = [...points].sort((a, b) => a.timestamp.localeCompare(b.timestamp));
  const capped = sorted.length > LOCATION_SEGMENT_MAX_POINTS ? sorted.slice(0, LOCATION_SEGMENT_MAX_POINTS) : sorted;
  const first = capped[0];
  const newest = capped[capped.length - 1];
  const windowStart = locationSegmentWindowStart(first.timestamp);
  const windowStartMs = new Date(windowStart).getTime();
  const record = {
    PK: DDB_KEY_BUILDERS.memberLocationPK(first.memberId),
    SK: DDB_KEY_BUILDERS.locationSegmentSK(windowStart),
    type: LOCATION_SEGMENT_RECORD_TYPE,
    memberId: first.memberId,
    orgId: first.orgId,
    isClocked: newest.isClocked,
    v: 1,
    pts: packPoints(windowStartMs, capped),
    TTL: ttlSeconds
  };
  if (newest.crewId) record.crewId = newest.crewId;
  if (newest.visitId) record.visitId = newest.visitId;
  if (typeof newest.batteryLevel === "number") record.batteryLevel = newest.batteryLevel;
  return record;
}
function locationSegmentToPoints(record) {
  const windowStartMs = new Date(locationSegmentStartTs(record)).getTime();
  let packed;
  try {
    packed = JSON.parse(record.pts);
  } catch {
    console.error(`[locationSegment] Unparseable pts on ${record.PK} / ${record.SK}`);
    return [];
  }
  return packed.map(([tOffsetMs, latitude, longitude, accuracy, speed, heading]) => {
    const point = {
      memberId: record.memberId,
      orgId: record.orgId,
      latitude,
      longitude,
      timestamp: new Date(windowStartMs + tOffsetMs).toISOString(),
      isClocked: record.isClocked
    };
    if (record.crewId) point.crewId = record.crewId;
    if (record.visitId) point.visitId = record.visitId;
    if (typeof record.batteryLevel === "number") point.batteryLevel = record.batteryLevel;
    if (accuracy !== null) point.accuracy = accuracy;
    if (speed !== null) point.speed = speed;
    if (heading !== null) point.heading = heading;
    return point;
  });
}
function mergeLocationSegment(existing, incoming, ttlSeconds) {
  const merged = new globalThis.Map();
  for (const point of locationSegmentToPoints(existing)) {
    merged.set(point.timestamp, point);
  }
  let added = false;
  for (const point of incoming) {
    if (!merged.has(point.timestamp)) added = true;
    merged.set(point.timestamp, point);
  }
  if (!added) {
    return null;
  }
  const record = buildLocationSegment([...merged.values()], ttlSeconds);
  record.v = existing.v + 1;
  return record;
}

// src/transformations/message.ts
function messageToDdbRecord(message) {
  return {
    ...message,
    // Add DynamoDB storage fields (most already included in Message interface)
    PK: DDB_KEY_BUILDERS.conversationPK(message.orgId, message.conversationId),
    SK: `MESSAGE#${message.timestamp}#${message.messageId}`,
    GSI1PK: `${DDB_KEY_BUILDERS.orgPK(message.orgId)}#CUSTOMER#${message.customerId}`,
    GSI1SK: `MESSAGE#${message.timestamp}`,
    // Scheduled drafts join the sparse due index so the poller can find them;
    // delivered/immediate messages carry no scheduledFor and stay out of it (RUT-2256).
    ...message.scheduledFor ? {
      GSI2PK: DDB_KEY_BUILDERS.scheduledMessageDueGSI2PK(),
      GSI2SK: DDB_KEY_BUILDERS.scheduledMessageDueGSI2SK(message.scheduledFor)
    } : {},
    entityType: "MESSAGE" /* MESSAGE */
  };
}
function messageFromDdbRecord(record) {
  const {
    PK: _PK,
    SK: _SK,
    GSI1PK: _GSI1PK,
    GSI1SK: _GSI1SK,
    GSI2PK: _GSI2PK,
    GSI2SK: _GSI2SK,
    entityType: _entityType,
    ...message
  } = record;
  return message;
}
function messagesFromDdbRecords(records) {
  return records.map(messageFromDdbRecord);
}
function conversationSummaryToDdbRecord(summary) {
  return {
    ...summary,
    // Add DynamoDB storage fields — the same keys MessageRepository reads and upserts
    // (ORG#{orgId} / CONVERSATION#CUSTOMER#{customerId}); the inbox list reads GSI2.
    PK: DDB_KEY_BUILDERS.orgPK(summary.orgId),
    SK: DDB_KEY_BUILDERS.conversationSK(summary.customerId),
    GSI2PK: DDB_KEY_BUILDERS.conversationGSI2PK(summary.orgId),
    GSI2SK: DDB_KEY_BUILDERS.conversationGSI2SK(summary.lastMessageTime),
    entityType: "CONVERSATION_SUMMARY" /* CONVERSATION_SUMMARY */
  };
}
function conversationSummaryFromDdbRecord(record) {
  const { PK, SK, entityType: _entityType, GSI2PK: _gsi2pk, GSI2SK: _gsi2sk, ...summary } = record;
  if (!summary.orgId && PK) {
    const orgMatch = PK.match(/^ORG#([^#]+)/);
    if (orgMatch) {
      summary.orgId = orgMatch[1];
    }
  }
  if (!summary.customerId && SK) {
    const customerMatch = SK.match(/CUSTOMER#(.+)$/);
    if (customerMatch) {
      summary.customerId = customerMatch[1];
    }
  }
  return summary;
}
function conversationSummariesFromDdbRecords(records) {
  return records.map(conversationSummaryFromDdbRecord);
}

// src/transformations/noteRead.ts
function noteReadToDdbRecord(noteRead) {
  return safeTransform(
    noteRead,
    (input) => {
      validateRequiredFields(
        input,
        ["organizationId", "userId", "noteId", "noteType", "readAt"],
        "NoteRead"
      );
      const record = {
        ...input,
        // Add DynamoDB storage fields
        PK: DDB_KEY_BUILDERS.noteReadPK(input.organizationId, input.userId),
        SK: DDB_KEY_BUILDERS.noteReadSK(input.noteId),
        // GSI1: Visit or subscription-based queries to find all users who read a note
        GSI1PK: input.visitId ? DDB_KEY_BUILDERS.noteReadVisitGSI1PK(input.organizationId, input.visitId) : input.subscriptionId ? DDB_KEY_BUILDERS.noteReadSubscriptionGSI1PK(input.organizationId, input.subscriptionId) : void 0,
        GSI1SK: DDB_KEY_BUILDERS.noteReadUserGSI1SK(input.userId),
        entityType: "NOTE_READ" /* NOTE_READ */
      };
      validateDdbRecord(record, "NOTE_READ" /* NOTE_READ */);
      return record;
    },
    "NoteRead"
  );
}
function noteReadFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      validateDdbRecord(input, "NOTE_READ" /* NOTE_READ */);
      const {
        PK: _PK,
        SK: _SK,
        GSI1PK: _GSI1PK,
        GSI1SK: _GSI1SK,
        entityType: _entityType,
        ...noteRead
      } = input;
      validateRequiredFields(
        noteRead,
        ["organizationId", "userId", "noteId", "noteType", "readAt"],
        "NoteRead"
      );
      return noteRead;
    },
    "NoteRead"
  );
}
function noteReadsFromDdbRecords(records) {
  return safeTransformArray(records, noteReadFromDdbRecord, "NOTE_READ" /* NOTE_READ */);
}

// src/transformations/priorityReminder.ts
function priorityReminderToDdbRecord(input) {
  return safeTransform(
    input,
    (value) => {
      validateRequiredFields(
        value,
        ["organizationId", "visitId", "crewId", "remindOn"],
        "PriorityReminder"
      );
      const record = {
        organizationId: value.organizationId,
        visitId: value.visitId,
        crewId: value.crewId,
        remindOn: value.remindOn,
        PK: DDB_KEY_BUILDERS.priorityReminderPK(
          value.organizationId,
          value.remindOn
        ),
        SK: DDB_KEY_BUILDERS.visitSK(value.visitId),
        entityType: "PRIORITY_REMINDER" /* PRIORITY_REMINDER */
      };
      return record;
    },
    "PriorityReminder"
  );
}
function priorityReminderFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      const {
        PK: _PK,
        SK: _SK,
        entityType: _entityType,
        ...reminder
      } = input;
      validateRequiredFields(
        reminder,
        ["organizationId", "visitId", "crewId", "remindOn"],
        "PriorityReminder"
      );
      return reminder;
    },
    "PriorityReminder"
  );
}
function priorityRemindersFromDdbRecords(records) {
  return safeTransformArray(
    records,
    priorityReminderFromDdbRecord,
    "PRIORITY_REMINDER" /* PRIORITY_REMINDER */
  );
}

// src/transformations/photoPurgePointer.ts
function photoPurgePointerToDdbRecord(input) {
  return safeTransform(
    input,
    (value) => {
      validateRequiredFields(
        value,
        ["organizationId", "visitId", "photoId", "r2Key", "deletedAt", "purgeAt"],
        "PhotoPurgePointer"
      );
      const record = {
        organizationId: value.organizationId,
        visitId: value.visitId,
        photoId: value.photoId,
        r2Key: value.r2Key,
        deletedAt: value.deletedAt,
        purgeAt: value.purgeAt,
        PK: DDB_KEY_BUILDERS.photoPurgePK(value.organizationId),
        SK: DDB_KEY_BUILDERS.photoPurgeSK(
          value.purgeAt,
          value.visitId,
          value.photoId
        ),
        entityType: "PHOTO_PURGE_POINTER" /* PHOTO_PURGE_POINTER */
      };
      return record;
    },
    "PhotoPurgePointer"
  );
}
function photoPurgePointerFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      const {
        PK: _PK,
        SK: _SK,
        entityType: _entityType,
        ...pointer
      } = input;
      validateRequiredFields(
        pointer,
        ["organizationId", "visitId", "photoId", "r2Key", "deletedAt", "purgeAt"],
        "PhotoPurgePointer"
      );
      return pointer;
    },
    "PhotoPurgePointer"
  );
}
function photoPurgePointersFromDdbRecords(records) {
  return safeTransformArray(
    records,
    photoPurgePointerFromDdbRecord,
    "PHOTO_PURGE_POINTER" /* PHOTO_PURGE_POINTER */
  );
}

// src/transformations/notification.ts
function notificationToDdbRecord(notification) {
  return safeTransform(
    notification,
    (input) => {
      validateRequiredFields(
        input,
        ["id", "orgId", "userId", "type", "title", "message", "priority", "createdAt"],
        "Notification"
      );
      const record = {
        ...input,
        // Add DynamoDB storage fields
        PK: DDB_KEY_BUILDERS.orgPK(input.orgId),
        SK: `NOTIFICATION#${input.id}`,
        // GSI1: User-based queries with timestamp for sorting
        GSI1PK: `ORG#${input.orgId}#USER#${input.userId}`,
        GSI1SK: `NOTIFICATION#${input.createdAt}`,
        entityType: "NOTIFICATION" /* NOTIFICATION */
      };
      validateDdbRecord(record, "NOTIFICATION" /* NOTIFICATION */);
      return record;
    },
    "Notification"
  );
}
function notificationFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      validateDdbRecord(input, "NOTIFICATION" /* NOTIFICATION */);
      const {
        PK: _PK,
        SK: _SK,
        GSI1PK: _GSI1PK,
        GSI1SK: _GSI1SK,
        entityType: _entityType,
        ...notification
      } = input;
      validateRequiredFields(
        notification,
        ["id", "orgId", "userId", "type", "title", "message", "priority", "createdAt"],
        "Notification"
      );
      return notification;
    },
    "Notification"
  );
}
function notificationsFromDdbRecords(records) {
  return safeTransformArray(
    records,
    notificationFromDdbRecord,
    "NOTIFICATION" /* NOTIFICATION */
  );
}

// src/transformations/organization.ts
function organizationToDdbRecord(org) {
  return org;
}
function organizationFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      return input;
    },
    "Organization"
  );
}
function organizationMemberToDdbRecord(member) {
  const cleanPhone = member.phoneNumber?.replace(/\D/g, "") || "";
  return {
    ...member,
    // Add DynamoDB storage fields
    PK: DDB_KEY_BUILDERS.orgPK(member.orgId),
    SK: DDB_KEY_BUILDERS.memberSK(member.id),
    // GSI1: Phone number lookups
    GSI1PK: member.phoneNumber && cleanPhone ? DDB_KEY_BUILDERS.orgMemberPhoneGSI(cleanPhone) : void 0,
    GSI1SK: DDB_KEY_BUILDERS.memberSK(member.id),
    // GSI2: Invite token lookups
    GSI2PK: member.inviteToken ? DDB_KEY_BUILDERS.inviteTokenGSI(member.inviteToken) : void 0,
    GSI2SK: DDB_KEY_BUILDERS.memberSK(member.id),
    // GSI3: Role-based queries
    GSI3PK: DDB_KEY_BUILDERS.roleGSI(member.orgId, member.role),
    GSI3SK: DDB_KEY_BUILDERS.statusGSI(
      member.status,
      member.invitedAt || member.joinedAt || member.createdAt
    ),
    entityType: "ORGANIZATION_MEMBER" /* ORGANIZATION_MEMBER */
  };
}
function organizationMemberFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      validateDdbRecord(input, "ORGANIZATION_MEMBER" /* ORGANIZATION_MEMBER */);
      const {
        PK: _PK,
        SK: _SK,
        GSI1PK: _GSI1PK,
        GSI1SK: _GSI1SK,
        GSI2PK: _GSI2PK,
        GSI2SK: _GSI2SK,
        GSI3PK: _GSI3PK,
        GSI3SK: _GSI3SK,
        entityType: _entityType,
        ...member
      } = input;
      return member;
    },
    "ORGANIZATION_MEMBER" /* ORGANIZATION_MEMBER */
  );
}
function organizationMembersFromDdbRecords(records) {
  return safeTransformArray(
    records,
    organizationMemberFromDdbRecord,
    "ORGANIZATION_MEMBER" /* ORGANIZATION_MEMBER */
  );
}

// src/transformations/otp.ts
function otpToDdbRecord(otp) {
  return safeTransform(
    otp,
    (input) => {
      validateRequiredFields(
        input,
        ["contact", "otpCode", "expiresAt", "entityType", "createdAt"],
        "OtpRecord"
      );
      const record = {
        ...input,
        // Add DynamoDB storage fields
        // OTP uses contact (phone/email) as PK
        PK: DDB_KEY_BUILDERS.otpPK(input.contact),
        // SK uses timestamp for ordering
        SK: DDB_KEY_BUILDERS.codeSK(Date.now().toString()),
        // TTL for automatic DynamoDB cleanup
        TTL: input.expiresAt
      };
      return record;
    },
    "OtpRecord"
  );
}
function otpFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      const { PK: _PK, SK: _SK, TTL: _TTL, ...otp } = input;
      validateRequiredFields(
        otp,
        ["contact", "otpCode", "expiresAt", "entityType", "createdAt"],
        "OtpRecord"
      );
      return otp;
    },
    "OtpRecord"
  );
}
function otpsFromDdbRecords(records) {
  return safeTransformArray(records, otpFromDdbRecord, "OTP" /* OTP */);
}

// src/transformations/paymentMethod.ts
function paymentMethodToDdbRecord(paymentMethod) {
  return safeTransform(
    paymentMethod,
    (input) => {
      validateRequiredFields(
        input,
        ["paymentMethodId", "orgId", "customerId", "type", "last4", "createdAt"],
        "PaymentMethod"
      );
      const record = {
        ...input,
        // Add DynamoDB storage fields
        PK: DDB_KEY_BUILDERS.orgPK(input.orgId),
        SK: DDB_KEY_BUILDERS.paymentMethodSK(input.customerId, input.paymentMethodId),
        // GSI1: Customer-based queries for payment method management
        GSI1PK: `ORG#${input.orgId}#CUSTOMER#${input.customerId}`,
        GSI1SK: `PAYMENT_METHOD#${input.paymentMethodId}`,
        entityType: "PAYMENT_METHOD" /* PAYMENT_METHOD */
      };
      validateDdbRecord(record, "PAYMENT_METHOD" /* PAYMENT_METHOD */);
      return record;
    },
    "PaymentMethod"
  );
}
function paymentMethodFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      validateDdbRecord(input, "PAYMENT_METHOD" /* PAYMENT_METHOD */);
      const {
        PK: _PK,
        SK: _SK,
        GSI1PK: _GSI1PK,
        GSI1SK: _GSI1SK,
        entityType: _entityType,
        ...paymentMethod
      } = input;
      validateRequiredFields(
        paymentMethod,
        ["paymentMethodId", "orgId", "customerId", "type", "last4", "createdAt"],
        "PaymentMethod"
      );
      return paymentMethod;
    },
    "PaymentMethod"
  );
}
function paymentMethodsFromDdbRecords(records) {
  return safeTransformArray(
    records,
    paymentMethodFromDdbRecord,
    "PAYMENT_METHOD" /* PAYMENT_METHOD */
  );
}

// src/transformations/rateRequest.ts
function rateRequestToDdbRecord(rateRequest) {
  return safeTransform(
    rateRequest,
    (input) => {
      validateRequiredFields(
        input,
        ["id", "orgId", "customerId", "status", "createdAt"],
        "RateRequest"
      );
      const record = {
        ...input,
        // Add DynamoDB storage fields
        PK: DDB_KEY_BUILDERS.orgPK(input.orgId),
        SK: DDB_KEY_BUILDERS.rateRequestSK(input.id),
        // GSI1: Status-based queries for rate request management
        GSI1PK: DDB_KEY_BUILDERS.rateRequestStatusGSI(input.orgId, input.status),
        GSI1SK: input.createdAt,
        entityType: "RATE_REQUEST" /* RATE_REQUEST */
      };
      validateDdbRecord(record, "RATE_REQUEST" /* RATE_REQUEST */);
      return record;
    },
    "RateRequest"
  );
}
function rateRequestFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      validateDdbRecord(input, "RATE_REQUEST" /* RATE_REQUEST */);
      const {
        PK: _PK,
        SK: _SK,
        GSI1PK: _GSI1PK,
        GSI1SK: _GSI1SK,
        entityType: _entityType,
        ...rateRequest
      } = input;
      validateRequiredFields(
        rateRequest,
        ["id", "orgId", "customerId", "status", "createdAt"],
        "RateRequest"
      );
      return rateRequest;
    },
    "RateRequest"
  );
}
function rateRequestsFromDdbRecords(records) {
  return safeTransformArray(
    records,
    rateRequestFromDdbRecord,
    "RATE_REQUEST" /* RATE_REQUEST */
  );
}

// src/transformations/separateCustomer.ts
var PROPERTY_ONLY_COPY_FIELDS = [
  "address",
  "city",
  "normalizedAddress",
  "zipCode",
  "coordinates",
  "metrics",
  "absentMetrics",
  "parcelData",
  "parcelBoundaries",
  "parcelFetchedAt",
  "parcelDataVersion",
  "aerialImageUrl",
  "aerialImageSource",
  "aerialImageFetchedAt",
  "geofenceCenter",
  "geofenceRadiusM",
  "workZoneId",
  "workZoneCenter",
  "workZoneRadiusM"
];
function buildSeparateCustomerFromProperty(params) {
  const { source, orgId, newCustomerId, requester, now } = params;
  const firstName = requester.firstName.trim();
  const lastName = requester.lastName?.trim() || void 0;
  const displayName = [firstName, lastName].filter(Boolean).join(" ");
  const newCustomer = {
    id: newCustomerId,
    orgId,
    displayName,
    firstName,
    lastName,
    // A separate customer starts with no contact methods of their own — the
    // approved requester's contact is attached by the caller. Never copy the
    // source customer's email/phone.
    address: source.address,
    status: "prospect" /* PROSPECT */,
    source: "rate_request" /* RATE_REQUEST */,
    customerSince: now,
    createdAt: now,
    updatedAt: now
  };
  applyPropertyFields(newCustomer, source);
  return newCustomer;
}
function applyPropertyFields(target, source) {
  for (const field of PROPERTY_ONLY_COPY_FIELDS) {
    const value = source[field];
    if (value !== void 0) {
      Object.assign(target, { [field]: value });
    }
  }
  return target;
}

// src/transformations/serviceArea.ts
function serviceAreaToDdbRecord(serviceArea, orgId) {
  return {
    ...serviceArea,
    // Add DynamoDB storage fields
    PK: DDB_KEY_BUILDERS.orgPK(orgId),
    SK: DDB_KEY_BUILDERS.serviceAreaSK(serviceArea.id),
    GSI1PK: DDB_KEY_BUILDERS.orgPK(orgId),
    GSI1SK: DDB_KEY_BUILDERS.serviceAreaSK(serviceArea.id),
    entityType: "SERVICE_AREA" /* SERVICE_AREA */
  };
}
function serviceAreaFromDdbRecord(record) {
  const {
    PK: _PK,
    SK: _SK,
    GSI1PK: _GSI1PK,
    GSI1SK: _GSI1SK,
    entityType: _entityType,
    ...serviceArea
  } = record;
  return serviceArea;
}
function serviceAreasFromDdbRecords(records) {
  return records.map(serviceAreaFromDdbRecord);
}

// src/transformations/serviceTemplate.ts
function serviceTemplateToDdbRecord(serviceTemplate) {
  return {
    ...serviceTemplate,
    // Add DynamoDB storage fields
    PK: DDB_KEY_BUILDERS.orgPK(serviceTemplate.organizationId),
    SK: DDB_KEY_BUILDERS.serviceTemplateSK(serviceTemplate.id),
    GSI1PK: DDB_KEY_BUILDERS.orgPK(serviceTemplate.organizationId),
    GSI1SK: DDB_KEY_BUILDERS.serviceTemplateSK(serviceTemplate.id),
    entityType: "SERVICE_TEMPLATE" /* SERVICE_TEMPLATE */
  };
}
function serviceTemplateFromDdbRecord(record) {
  const {
    PK: _PK,
    SK: _SK,
    GSI1PK: _GSI1PK,
    GSI1SK: _GSI1SK,
    entityType: _entityType,
    ...serviceTemplate
  } = record;
  if (serviceTemplate.periods) {
    serviceTemplate.periods = PeriodHelpers.sortByCalendarOrder(serviceTemplate.periods);
  }
  if (serviceTemplate.seasonalAvailability) {
    serviceTemplate.seasonalAvailability = PeriodHelpers.sortByCalendarOrder(
      serviceTemplate.seasonalAvailability
    );
  }
  return serviceTemplate;
}
function serviceTemplatesFromDdbRecords(records) {
  return records.map(serviceTemplateFromDdbRecord);
}
function inferPricingMethod(template) {
  switch (template.billingMethod) {
    case "per_hour" /* PER_HOUR */:
      return "per_hour" /* PER_HOUR */;
    case "package" /* PACKAGE */:
      return "package" /* PACKAGE */;
    case "consumable" /* CONSUMABLE */:
      return "consumable" /* CONSUMABLE */;
    case "per_visit" /* PER_VISIT */:
      if (template.pricingMethod === "fixed_price" /* FIXED_PRICE */) {
        return "fixed_price" /* FIXED_PRICE */;
      }
      if (template.volumePricing?.enabled === true) {
        return "unit_based" /* UNIT_BASED */;
      }
      return "billable_labor_rate" /* BILLABLE_LABOR_RATE */;
    default:
      return "billable_labor_rate" /* BILLABLE_LABOR_RATE */;
  }
}

// src/transformations/subscription.ts
function isActiveSubscription(subscriptionStatus) {
  return subscriptionStatus === "active" /* ACTIVE */;
}
function isPendingRateRequest(subscription) {
  return subscription.subscriptionStatus === "inactive" /* INACTIVE */ && subscription.rateVisibility === "invisible" /* INVISIBLE */ && !!subscription.requestedAt && subscription.requestedBy === "customer" && !subscription.deletedAt;
}
function isPendingPlanChangeRequest(subscription) {
  return subscription?.pendingPlanChange?.status === "pending";
}
function subscriptionToDdbRecord(subscription, orgId) {
  const record = {
    ...subscription,
    // Add DynamoDB storage fields
    PK: DDB_KEY_BUILDERS.orgPK(orgId),
    SK: DDB_KEY_BUILDERS.subscriptionSK(
      subscription.customerId,
      subscription.serviceTemplateId
    ),
    // GSI1: Organization + Template + Status Index with Customer Name Sorting
    // Supports: Template-based queries with DynamoDB-native customer name sorting
    GSI1PK: `ORG#${orgId}#TEMPLATE#${subscription.serviceTemplateId}#STATUS#${subscription.subscriptionStatus}`,
    GSI1SK: `${subscription.customerLastName || "ZZZZZ"}#${subscription.customerFirstName || "ZZZZZ"}#${subscription.customerId}`,
    // GSI2: Service Template Index (enable efficient template queries)
    // Supports: Template-based queries, work queue filtering without filter expressions
    GSI2PK: DDB_KEY_BUILDERS.subscriptionTemplateGSI2PK(
      orgId,
      subscription.serviceTemplateId
    ),
    GSI2SK: `${subscription.subscriptionStatus}#${subscription.rateVisibility}#${subscription.customerId}`,
    entityType: "SUBSCRIPTION" /* SUBSCRIPTION */
  };
  if (isActiveSubscription(subscription.subscriptionStatus)) {
    record.GSI3PK = DDB_KEY_BUILDERS.subscriptionActiveGSI3PK(orgId);
    record.GSI3SK = DDB_KEY_BUILDERS.subscriptionSchedulingGSI3SK({
      assignedCrewId: subscription.assignedCrewId,
      customerId: subscription.customerId,
      serviceTemplateId: subscription.serviceTemplateId
    });
  }
  if (isPendingRateRequest(subscription)) {
    const requestedAt = subscription.requestedAt || subscription.createdAt;
    record.GSI4PK = `ORG#${orgId}#PENDING_RATES`;
    record.GSI4SK = `${requestedAt}#${subscription.customerId}#${subscription.serviceTemplateId}`;
  }
  return record;
}
function subscriptionFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      validateDdbRecord(input, "SUBSCRIPTION" /* SUBSCRIPTION */);
      const {
        PK: _PK,
        SK: _SK,
        GSI1PK: _GSI1PK,
        GSI1SK: _GSI1SK,
        GSI2PK: _GSI2PK,
        GSI2SK: _GSI2SK,
        GSI3PK: _GSI3PK,
        GSI3SK: _GSI3SK,
        GSI4PK: _GSI4PK,
        GSI4SK: _GSI4SK,
        entityType: _entityType,
        ...subscription
      } = input;
      if (subscription.seasonalAvailability) {
        subscription.seasonalAvailability = PeriodHelpers.sortByCalendarOrder(
          subscription.seasonalAvailability
        );
      }
      return subscription;
    },
    "SUBSCRIPTION" /* SUBSCRIPTION */
  );
}
function subscriptionsFromDdbRecords(records) {
  return safeTransformArray(
    records,
    subscriptionFromDdbRecord,
    "SUBSCRIPTION" /* SUBSCRIPTION */
  );
}
function subscriptionToCustomerPortalView(subscription) {
  if (subscription.rateVisibility === "invisible" /* INVISIBLE */ && subscription.subscriptionStatus !== "active" /* ACTIVE */) {
    const safeFields = {
      // Core identifiers
      id: subscription.id,
      serviceTemplateId: subscription.serviceTemplateId,
      customerId: subscription.customerId,
      // Bundle membership is structure, not a price (RUT-3612).
      bundleId: subscription.bundleId,
      // State fields - CRITICAL for UI state determination
      subscriptionStatus: subscription.subscriptionStatus,
      rateVisibility: subscription.rateVisibility,
      // Billing method (structural — drives UI layout, not a price)
      billingMethod: subscription.billingMethod,
      // Timestamps
      createdAt: subscription.createdAt,
      updatedAt: subscription.updatedAt,
      requestedAt: subscription.requestedAt,
      respondedAt: subscription.respondedAt,
      activatedAt: subscription.activatedAt,
      serviceStartDate: subscription.serviceStartDate,
      serviceEndDate: subscription.serviceEndDate,
      // Customer data
      customerNotes: subscription.customerNotes,
      customerNotesReleasedToCrew: subscription.customerNotesReleasedToCrew,
      customerAttachments: subscription.customerAttachments,
      // Invoice notes (shown to customers on invoices)
      invoiceNotes: subscription.invoiceNotes,
      invoiceNotes_es: subscription.invoiceNotes_es,
      // Staff-authored note always shown to the customer on the service page
      customerServiceNote: subscription.customerServiceNote,
      customerServiceNote_es: subscription.customerServiceNote_es,
      // Rate note is customer-facing even before the rate itself is shared
      // (RUT-3999). Distinct from customerServiceNote and rateHiddenMessage.
      rateMessage: subscription.rateMessage,
      // Schedule & assignment (operational)
      assignedCrewId: subscription.assignedCrewId,
      scheduleConfig: subscription.scheduleConfig,
      schedules: subscription.schedules,
      // Visit tracking (operational)
      visitCounts: subscription.visitCounts,
      lastCompletedVisitId: subscription.lastCompletedVisitId,
      lastCompletedVisitDate: subscription.lastCompletedVisitDate,
      // Package state (visit tracking, not pricing)
      packageState: subscription.packageState,
      selectedPackageOptionId: subscription.selectedPackageOptionId,
      // Customer-selected service options (customer-owned data)
      customerSelectedOptions: subscription.customerSelectedOptions,
      // Service template info
      serviceTemplateName: subscription.serviceTemplateName,
      isOneOffService: subscription.isOneOffService,
      // Pause state
      pausedUntil: subscription.pausedUntil,
      pausedAt: subscription.pausedAt,
      // Pending start (RUT-4066): an office activation with a future start
      // date is often made before the rate is shown to the customer. The date
      // is not pricing — without it the portal reads "Request a rate" instead
      // of "Starts <date>".
      scheduledActivationDate: subscription.scheduledActivationDate
    };
    return safeFields;
  }
  const { adminNotes, adminNotes_es, adminNotesUpdatedAt, periodNotes, adminAttachments, internalNotes, temporaryNotes, bannerNotes, ...customerSafe } = subscription;
  return customerSafe;
}

// src/transformations/timeEntry.ts
function timeEntryToDdbRecord(timeEntry, orgId) {
  return safeTransform(
    timeEntry,
    (input) => {
      validateRequiredFields(
        input,
        ["id", "crewMemberId", "crewId", "eventType", "timestamp", "location", "createdAt"],
        "TimeEntry"
      );
      const record = {
        ...input,
        // Add DynamoDB storage fields
        PK: DDB_KEY_BUILDERS.orgPK(orgId),
        SK: DDB_KEY_BUILDERS.clockEventSK(input.id),
        // GSI1: Session tracking (for finding active clock sessions)
        GSI1PK: DDB_KEY_BUILDERS.clockSessionGSI(input.crewMemberId),
        GSI1SK: `${DDB_KEY_PATTERNS.CLOCK_EVENT_PREFIX}${input.timestamp}`,
        // GSI2: Member queries (for getting all time entries for a member)
        GSI2PK: DDB_KEY_BUILDERS.crewMemberGSI(input.crewMemberId),
        GSI2SK: `${DDB_KEY_PATTERNS.CLOCK_EVENT_PREFIX}${input.timestamp}`,
        entityType: "CLOCK_EVENT" /* CLOCK_EVENT */
      };
      validateDdbRecord(record, "CLOCK_EVENT" /* CLOCK_EVENT */);
      return record;
    },
    "TimeEntry"
  );
}
function timeEntryFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      validateDdbRecord(input, "CLOCK_EVENT" /* CLOCK_EVENT */);
      const {
        PK: _PK,
        SK: _SK,
        GSI1PK: _GSI1PK,
        GSI1SK: _GSI1SK,
        GSI2PK: _GSI2PK,
        GSI2SK: _GSI2SK,
        entityType: _entityType,
        ...timeEntry
      } = input;
      validateRequiredFields(
        timeEntry,
        ["id", "crewMemberId", "crewId", "eventType", "timestamp", "location", "createdAt"],
        "TimeEntry"
      );
      return timeEntry;
    },
    "TimeEntry"
  );
}
function timeEntriesFromDdbRecords(records) {
  return safeTransformArray(
    records,
    timeEntryFromDdbRecord,
    "CLOCK_EVENT" /* CLOCK_EVENT */
  );
}

// src/transformations/visit.ts
function visitToDdbRecord(visit) {
  const isTerminal = isTerminalVisitStatus(visit.status);
  const completionDate = isTerminal ? getVisitCompletionDate(visit) : void 0;
  return {
    ...visit,
    // Primary keys
    PK: DDB_KEY_BUILDERS.orgPK(visit.orgId),
    SK: DDB_KEY_BUILDERS.visitSK(visit.id),
    // GSI1: Customer history (sorted by terminal date desc, createdAt for pending)
    GSI1PK: DDB_KEY_BUILDERS.visitCustomerGSI1PK(visit.orgId, visit.customerId),
    GSI1SK: DDB_KEY_BUILDERS.visitCustomerGSI1SK(getVisitTerminalTimestamp(visit), visit.id),
    // GSI2: Status-based queries
    GSI2PK: DDB_KEY_BUILDERS.visitStatusGSI2PK(visit.orgId, visit.status),
    GSI2SK: isTerminal && completionDate ? DDB_KEY_BUILDERS.visitStatusCompletionDateGSI2SK(completionDate, visit.id) : DDB_KEY_BUILDERS.visitStatusCrewRankGSI2SK(visit.crewId, visit.rank || ""),
    // GSI3: Crew queue (pending) + history (terminal)
    GSI3PK: DDB_KEY_BUILDERS.visitCrewGSI3PK(visit.orgId, visit.crewId),
    GSI3SK: isTerminal && completionDate ? DDB_KEY_BUILDERS.visitCrewDoneGSI3SK(completionDate, visit.id) : DDB_KEY_BUILDERS.visitCrewQueueGSI3SK(visit.rank || ""),
    // GSI4: Completion date billing (sparse - terminal only)
    ...isTerminal && completionDate ? {
      GSI4PK: DDB_KEY_BUILDERS.visitCompletionDateGSI4PK(visit.orgId, completionDate),
      GSI4SK: `VISIT#${visit.id}`
    } : {},
    // GSI5: Dispatch job queries (sparse - only set when dispatchJobId exists)
    ...visit.dispatchJobId ? {
      GSI5PK: DDB_KEY_BUILDERS.visitDispatchJobGSI5PK(visit.orgId, visit.dispatchJobId),
      GSI5SK: `VISIT#${visit.id}`
    } : {},
    entityType: "VISIT" /* VISIT */
  };
}
function visitFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      validateDdbRecord(input, "VISIT" /* VISIT */);
      const {
        PK: _PK,
        SK: _SK,
        GSI1PK: _GSI1PK,
        GSI1SK: _GSI1SK,
        GSI2PK: _GSI2PK,
        GSI2SK: _GSI2SK,
        GSI3PK: _GSI3PK,
        GSI3SK: _GSI3SK,
        GSI4PK: _GSI4PK,
        GSI4SK: _GSI4SK,
        GSI5PK: _GSI5PK,
        GSI5SK: _GSI5SK,
        entityType: _entityType,
        ...visit
      } = input;
      return visit;
    },
    "VISIT" /* VISIT */
  );
}
function visitsFromDdbRecords(records) {
  return safeTransformArray(records, visitFromDdbRecord, "VISIT" /* VISIT */);
}

// src/transformations/parcelMeasurement.ts
function parcelMeasurementToDdbRecord(measurement, orgId) {
  return {
    ...measurement,
    // Add DynamoDB storage fields
    PK: DDB_KEY_BUILDERS.orgPK(orgId),
    SK: DDB_KEY_BUILDERS.parcelMeasurementSK(measurement.id),
    GSI1PK: DDB_KEY_BUILDERS.parcelMeasurementCustomerGSI1PK(
      measurement.customerId
    ),
    GSI1SK: DDB_KEY_BUILDERS.parcelMeasurementGSI1SK(measurement.id),
    entityType: "PARCEL_MEASUREMENT" /* PARCEL_MEASUREMENT */,
    organizationId: orgId
  };
}
function parcelMeasurementFromDdbRecord(record) {
  const {
    PK: _PK,
    SK: _SK,
    GSI1PK: _GSI1PK,
    GSI1SK: _GSI1SK,
    entityType: _entityType,
    organizationId: _organizationId,
    ...measurement
  } = record;
  return measurement;
}
function parcelMeasurementsFromDdbRecords(records) {
  return records.map(parcelMeasurementFromDdbRecord);
}

// src/transformations/metroParcel.ts
function metroParcelToDdbRecord(parcel) {
  return {
    ...parcel,
    // Add DynamoDB storage fields
    PK: METRO_PARCEL_KEY_BUILDERS.pk(parcel.pin),
    SK: METRO_PARCEL_KEY_BUILDERS.sk(),
    GSI1PK: METRO_PARCEL_KEY_BUILDERS.gsi1pk(parcel.city),
    GSI1SK: METRO_PARCEL_KEY_BUILDERS.gsi1sk(parcel.streetName, parcel.streetNumber)
  };
}
function metroParcelFromDdbRecord(record) {
  const { PK, SK: _SK, GSI1PK: _GSI1PK, GSI1SK: _GSI1SK, ...parcel } = record;
  if (!parcel.pin && PK?.startsWith("PIN#")) {
    parcel.pin = PK.substring(4);
  }
  return parcel;
}
function metroParcelsFromDdbRecords(records) {
  return records.map(metroParcelFromDdbRecord);
}
function metroParcelToCustomerParcelData(parcel) {
  return {
    // Property Identification
    pin: parcel.pin,
    countyPin: parcel.countyPin,
    statePin: parcel.statePin,
    // Property Address
    propertyAddress: {
      number: parcel.streetNumber,
      street: parcel.streetName,
      city: parcel.city,
      zip: parcel.zip
    },
    // Ownership Information
    ownership: {
      primaryOwner: parcel.ownerName,
      additionalOwners: parcel.additionalOwners,
      mailingAddress: parcel.mailingAddress || ""
    },
    // Property Characteristics
    property: {
      acres: parcel.acres,
      lotSqFt: parcel.lotSqFt,
      homestead: parcel.homestead,
      yearBuilt: parcel.yearBuilt || "",
      homeStyle: parcel.homeStyle || "",
      finishedSqFt: parcel.finishedSqFt || 0,
      basementType: parcel.basementType,
      garage: parcel.garage,
      garageSqFt: parcel.garageSqFt,
      heatingType: parcel.heatingType || "",
      coolingType: parcel.coolingType || "",
      dwellingType: parcel.dwellingType || "",
      numberOfUnits: parcel.numberOfUnits
    },
    // Valuation & Tax Information
    valuation: {
      landValue: parcel.landValue,
      buildingValue: parcel.buildingValue,
      totalValue: parcel.totalValue,
      taxCapacity: parcel.taxCapacity,
      totalTax: parcel.totalTax,
      specialAssessments: parcel.specialAssessments,
      taxYear: parcel.taxYear || "",
      marketYear: parcel.marketYear || ""
    },
    // Legal & Administrative
    legal: {
      platName: parcel.platName,
      lot: parcel.lot,
      block: parcel.block,
      section: parcel.section || "",
      township: parcel.township || "",
      range: parcel.range || "",
      rangeDirection: parcel.rangeDirection || "",
      schoolDistrict: parcel.schoolDistrict || "",
      watershed: parcel.watershed || "",
      county: parcel.county
    },
    // Property Classification
    classification: {
      useClass: parcel.useClass,
      multiUse: parcel.multiUse,
      taxExempt: parcel.taxExempt,
      greenAcres: parcel.greenAcres,
      openSpace: parcel.openSpace,
      agPreserve: parcel.agPreserve
    },
    // Sale Information
    lastSale: parcel.lastSaleDate ? {
      date: parcel.lastSaleDate,
      value: parcel.lastSaleValue || 0
    } : void 0
  };
}

// src/transformations/messageCampaign.ts
function messageCampaignToDdbRecord(campaign) {
  return {
    ...campaign,
    PK: DDB_KEY_BUILDERS.orgPK(campaign.orgId),
    SK: DDB_KEY_BUILDERS.messageCampaignSK(campaign.campaignId),
    GSI1PK: DDB_KEY_BUILDERS.messageCampaignStatusGSI1PK(campaign.status),
    GSI1SK: campaign.createdAt,
    GSI2PK: DDB_KEY_BUILDERS.messageCampaignOrgGSI2PK(campaign.orgId),
    GSI2SK: campaign.createdAt,
    entityType: "MESSAGE_CAMPAIGN" /* MESSAGE_CAMPAIGN */
  };
}
function messageCampaignFromDdbRecord(record) {
  const {
    PK: _PK,
    SK: _SK,
    GSI1PK: _GSI1PK,
    GSI1SK: _GSI1SK,
    GSI2PK: _GSI2PK,
    GSI2SK: _GSI2SK,
    entityType: _entityType,
    ...campaign
  } = record;
  return campaign;
}
function messageCampaignsFromDdbRecords(records) {
  return records.map(messageCampaignFromDdbRecord);
}
function messageDeliveryToDdbRecord(delivery) {
  const record = {
    ...delivery,
    PK: DDB_KEY_BUILDERS.messageDeliveryPK(delivery.campaignId),
    SK: DDB_KEY_BUILDERS.messageDeliverySK(delivery.deliveryId),
    GSI2PK: DDB_KEY_BUILDERS.messageDeliveryOrgCampaignGSI2PK(
      delivery.orgId,
      delivery.campaignId
    ),
    GSI2SK: DDB_KEY_BUILDERS.messageDeliveryStatusGSI2SK(
      delivery.status,
      delivery.createdAt
    ),
    entityType: "MESSAGE_DELIVERY" /* MESSAGE_DELIVERY */
  };
  if (delivery.status === "pending" /* PENDING */) {
    record.GSI1PK = DDB_KEY_BUILDERS.messageDeliveryPendingGSI1PK();
    record.GSI1SK = delivery.createdAt;
  }
  return record;
}
function messageDeliveryFromDdbRecord(record) {
  const {
    PK: _PK,
    SK: _SK,
    GSI1PK: _GSI1PK,
    GSI1SK: _GSI1SK,
    GSI2PK: _GSI2PK,
    GSI2SK: _GSI2SK,
    entityType: _entityType,
    ...delivery
  } = record;
  return delivery;
}
function messageDeliveriesFromDdbRecords(records) {
  return records.map(messageDeliveryFromDdbRecord);
}
function messageCampaignScheduleToDdbRecord(schedule) {
  const isDue = schedule.status === "active" /* ACTIVE */ && !!schedule.nextRunAt;
  return {
    ...schedule,
    PK: DDB_KEY_BUILDERS.orgPK(schedule.orgId),
    SK: DDB_KEY_BUILDERS.messageCampaignScheduleSK(schedule.scheduleId),
    ...isDue ? {
      GSI1PK: DDB_KEY_BUILDERS.messageCampaignScheduleDueGSI1PK(),
      GSI1SK: schedule.nextRunAt
    } : {},
    GSI2PK: DDB_KEY_BUILDERS.messageCampaignScheduleOrgGSI2PK(schedule.orgId),
    GSI2SK: schedule.createdAt,
    entityType: "MESSAGE_CAMPAIGN_SCHEDULE" /* MESSAGE_CAMPAIGN_SCHEDULE */
  };
}
function messageCampaignScheduleFromDdbRecord(record) {
  const {
    PK: _PK,
    SK: _SK,
    GSI1PK: _GSI1PK,
    GSI1SK: _GSI1SK,
    GSI2PK: _GSI2PK,
    GSI2SK: _GSI2SK,
    entityType: _entityType,
    ...schedule
  } = record;
  return schedule;
}

// src/transformations/messageTemplate.ts
function messageTemplateToDdbRecord(template) {
  return {
    ...template,
    PK: DDB_KEY_BUILDERS.orgPK(template.orgId),
    SK: DDB_KEY_BUILDERS.messageTemplateSK(template.templateId),
    GSI2PK: DDB_KEY_BUILDERS.messageTemplateOrgGSI2PK(template.orgId),
    GSI2SK: template.createdAt,
    entityType: "MESSAGE_TEMPLATE" /* MESSAGE_TEMPLATE */
  };
}
function messageTemplateFromDdbRecord(record) {
  const {
    PK: _PK,
    SK: _SK,
    GSI2PK: _GSI2PK,
    GSI2SK: _GSI2SK,
    entityType: _entityType,
    ...template
  } = record;
  return template;
}
function messageTemplatesFromDdbRecords(records) {
  return records.map(messageTemplateFromDdbRecord);
}

// src/transformations/disposalPile.ts
function disposalPileToDdbRecord(disposalPile) {
  return safeTransform(
    disposalPile,
    (input) => {
      validateRequiredFields(
        input,
        ["id", "orgId", "coordinates", "contributions", "status", "serviceTemplateId", "scheduledDate", "createdAt"],
        "DisposalPile"
      );
      const record = {
        ...input,
        // Add DynamoDB storage fields
        PK: DDB_KEY_BUILDERS.orgPK(input.orgId),
        SK: DDB_KEY_BUILDERS.disposalPileSK(input.id),
        // GSI3: Crew + Date queries (for crew route views)
        GSI3PK: input.crewId ? DDB_KEY_BUILDERS.disposalPileCrewGSI3PK(input.orgId, input.crewId) : DDB_KEY_BUILDERS.disposalPileCrewGSI3PK(input.orgId, "UNASSIGNED"),
        GSI3SK: DDB_KEY_BUILDERS.disposalPileDateGSI3SK(input.scheduledDate, input.id),
        entityType: "DISPOSAL_PILE" /* DISPOSAL_PILE */
      };
      validateDdbRecord(record, "DISPOSAL_PILE" /* DISPOSAL_PILE */);
      return record;
    },
    "DisposalPile"
  );
}
function disposalPileFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      validateDdbRecord(input, "DISPOSAL_PILE" /* DISPOSAL_PILE */);
      const {
        PK: _PK,
        SK: _SK,
        GSI3PK: _GSI3PK,
        GSI3SK: _GSI3SK,
        entityType: _entityType,
        ...disposalPile
      } = input;
      validateRequiredFields(
        disposalPile,
        ["id", "orgId", "coordinates", "contributions", "status", "serviceTemplateId", "scheduledDate", "createdAt"],
        "DisposalPile"
      );
      return disposalPile;
    },
    "DisposalPile"
  );
}
function disposalPilesFromDdbRecords(records) {
  return safeTransformArray(
    records,
    disposalPileFromDdbRecord,
    "DISPOSAL_PILE" /* DISPOSAL_PILE */
  );
}

// src/transformations/dispatchJob.ts
function dispatchJobToDdbRecord(job) {
  return safeTransform(
    job,
    (input) => {
      validateRequiredFields(
        input,
        ["jobId", "orgId", "status", "triggeredBy", "createdAt"],
        "DispatchJob"
      );
      const record = {
        ...input,
        // Add DynamoDB storage fields
        PK: DDB_KEY_BUILDERS.orgPK(input.orgId),
        SK: DDB_KEY_BUILDERS.dispatchJobSK(input.jobId),
        entityType: "DISPATCH_JOB" /* DISPATCH_JOB */
      };
      if (isDispatchJobActive(input)) {
        record.GSI2PK = DDB_KEY_BUILDERS.dispatchJobActiveGSI2PK(input.orgId);
        record.GSI2SK = DDB_KEY_BUILDERS.dispatchJobActiveGSI2SK(
          input.createdAt,
          input.jobId
        );
      }
      validateDdbRecord(record, "DISPATCH_JOB" /* DISPATCH_JOB */);
      return record;
    },
    "DispatchJob"
  );
}
function dispatchJobFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      validateDdbRecord(input, "DISPATCH_JOB" /* DISPATCH_JOB */);
      const {
        PK: _PK,
        SK: _SK,
        GSI2PK: _GSI2PK,
        GSI2SK: _GSI2SK,
        entityType: _entityType,
        ...job
      } = input;
      validateRequiredFields(
        job,
        ["jobId", "orgId", "status", "triggeredBy", "createdAt"],
        "DispatchJob"
      );
      return job;
    },
    "DispatchJob"
  );
}
function dispatchJobsFromDdbRecords(records) {
  return safeTransformArray(
    records,
    dispatchJobFromDdbRecord,
    "DISPATCH_JOB" /* DISPATCH_JOB */
  );
}
function dispatchBatchToDdbRecord(batch) {
  return safeTransform(
    batch,
    (input) => {
      validateRequiredFields(
        input,
        ["batchId", "jobId", "orgId", "subscriptions", "status", "triggeredBy", "createdAt"],
        "DispatchBatch"
      );
      const record = {
        ...input,
        // Add DynamoDB storage fields
        PK: DDB_KEY_BUILDERS.dispatchBatchPK(input.jobId),
        SK: DDB_KEY_BUILDERS.dispatchBatchSK(input.batchId),
        entityType: "DISPATCH_BATCH" /* DISPATCH_BATCH */
      };
      validateDdbRecord(record, "DISPATCH_BATCH" /* DISPATCH_BATCH */);
      return record;
    },
    "DispatchBatch"
  );
}
function dispatchBatchFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      validateDdbRecord(input, "DISPATCH_BATCH" /* DISPATCH_BATCH */);
      const {
        PK: _PK,
        SK: _SK,
        entityType: _entityType,
        ...batch
      } = input;
      validateRequiredFields(
        batch,
        ["batchId", "jobId", "orgId", "subscriptions", "status", "triggeredBy", "createdAt"],
        "DispatchBatch"
      );
      return batch;
    },
    "DispatchBatch"
  );
}
function dispatchBatchesFromDdbRecords(records) {
  return safeTransformArray(
    records,
    dispatchBatchFromDdbRecord,
    "DISPATCH_BATCH" /* DISPATCH_BATCH */
  );
}

// src/transformations/role.ts
function roleToDdbRecord(role) {
  return {
    ...role,
    PK: DDB_KEY_BUILDERS.orgPK(role.orgId),
    SK: DDB_KEY_BUILDERS.roleSK(role.id),
    entityType: "ROLE" /* ROLE */
  };
}
function roleFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      validateDdbRecord(input, "ROLE" /* ROLE */);
      const {
        PK: _PK,
        SK: _SK,
        entityType: _entityType,
        ...role
      } = input;
      return role;
    },
    "ROLE" /* ROLE */
  );
}
function rolesFromDdbRecords(records) {
  return safeTransformArray(records, roleFromDdbRecord, "ROLE" /* ROLE */);
}

// src/transformations/chat.ts
function chatConversationToDdbRecord(conversation) {
  return {
    ...conversation,
    PK: DDB_KEY_BUILDERS.orgPK(conversation.orgId),
    SK: DDB_KEY_BUILDERS.chatConvoSK(conversation.id),
    entityType: "CHAT_CONVERSATION" /* CHAT_CONVERSATION */
  };
}
function chatConversationFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      validateDdbRecord(input, "CHAT_CONVERSATION" /* CHAT_CONVERSATION */);
      const { PK: _PK, SK: _SK, entityType: _entityType, ...conversation } = input;
      return conversation;
    },
    "CHAT_CONVERSATION" /* CHAT_CONVERSATION */
  );
}
function chatConversationsFromDdbRecords(records) {
  return safeTransformArray(
    records,
    chatConversationFromDdbRecord,
    "CHAT_CONVERSATION" /* CHAT_CONVERSATION */
  );
}
function chatMessageToDdbRecord(message) {
  return {
    ...message,
    PK: DDB_KEY_BUILDERS.chatMsgPK(message.conversationId),
    SK: DDB_KEY_BUILDERS.chatMsgSK(message.id),
    entityType: "CHAT_MESSAGE" /* CHAT_MESSAGE */
  };
}
function chatMessageFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      validateDdbRecord(input, "CHAT_MESSAGE" /* CHAT_MESSAGE */);
      const { PK: _PK, SK: _SK, entityType: _entityType, ...message } = input;
      return message;
    },
    "CHAT_MESSAGE" /* CHAT_MESSAGE */
  );
}
function chatMessagesFromDdbRecords(records) {
  return safeTransformArray(
    records,
    chatMessageFromDdbRecord,
    "CHAT_MESSAGE" /* CHAT_MESSAGE */
  );
}
function chatMembershipToDdbRecord(membership) {
  return {
    ...membership,
    PK: DDB_KEY_BUILDERS.chatMembershipPK(membership.orgId, membership.userId),
    SK: DDB_KEY_BUILDERS.chatMembershipSK(membership.conversationId),
    GSI1PK: DDB_KEY_BUILDERS.chatMembershipGSI1PK(
      membership.orgId,
      membership.userId
    ),
    GSI1SK: membership.lastMessageAt ? DDB_KEY_BUILDERS.chatMembershipGSI1SK(membership.lastMessageAt) : void 0,
    entityType: "CHAT_MEMBERSHIP" /* CHAT_MEMBERSHIP */
  };
}
function chatMembershipFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      validateDdbRecord(input, "CHAT_MEMBERSHIP" /* CHAT_MEMBERSHIP */);
      const {
        PK: _PK,
        SK: _SK,
        GSI1PK: _GSI1PK,
        GSI1SK: _GSI1SK,
        entityType: _entityType,
        ...membership
      } = input;
      return membership;
    },
    "CHAT_MEMBERSHIP" /* CHAT_MEMBERSHIP */
  );
}
function chatMembershipsFromDdbRecords(records) {
  return safeTransformArray(
    records,
    chatMembershipFromDdbRecord,
    "CHAT_MEMBERSHIP" /* CHAT_MEMBERSHIP */
  );
}
function chatMessageAckToDdbRecord(ack, orgId) {
  return {
    ...ack,
    PK: DDB_KEY_BUILDERS.chatMsgAckPK(ack.messageId),
    SK: DDB_KEY_BUILDERS.chatMsgAckSK(ack.userId),
    entityType: "CHAT_MESSAGE_ACK" /* CHAT_MESSAGE_ACK */,
    orgId
  };
}
function chatMessageAckFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      validateDdbRecord(input, "CHAT_MESSAGE_ACK" /* CHAT_MESSAGE_ACK */);
      const {
        PK: _PK,
        SK: _SK,
        entityType: _entityType,
        orgId: _orgId,
        ...ack
      } = input;
      return ack;
    },
    "CHAT_MESSAGE_ACK" /* CHAT_MESSAGE_ACK */
  );
}
function chatMessageAcksFromDdbRecords(records) {
  return safeTransformArray(
    records,
    chatMessageAckFromDdbRecord,
    "CHAT_MESSAGE_ACK" /* CHAT_MESSAGE_ACK */
  );
}

// src/transformations/subcontractorCompany.ts
function subcontractorCompanyToDdbRecord(company) {
  return {
    ...company,
    PK: DDB_KEY_BUILDERS.orgPK(company.organizationId),
    SK: DDB_KEY_BUILDERS.subcontractorCompanySK(company.id),
    entityType: "SUBCONTRACTOR_COMPANY" /* SUBCONTRACTOR_COMPANY */
  };
}
function subcontractorCompanyFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      validateDdbRecord(input, "SUBCONTRACTOR_COMPANY" /* SUBCONTRACTOR_COMPANY */);
      const {
        PK: _PK,
        SK: _SK,
        entityType: _entityType,
        ...company
      } = input;
      return company;
    },
    "SUBCONTRACTOR_COMPANY" /* SUBCONTRACTOR_COMPANY */
  );
}
function subcontractorCompaniesFromDdbRecords(records) {
  return safeTransformArray(records, subcontractorCompanyFromDdbRecord, "SUBCONTRACTOR_COMPANY" /* SUBCONTRACTOR_COMPANY */);
}

// src/transformations/subcontractorDayPayment.ts
function subcontractorDayPaymentToDdbRecord(payment) {
  return {
    ...payment,
    PK: DDB_KEY_BUILDERS.orgPK(payment.organizationId),
    SK: DDB_KEY_BUILDERS.subcontractorDayPaymentSK(payment.companyId, payment.date),
    entityType: "SUBCONTRACTOR_DAY_PAYMENT" /* SUBCONTRACTOR_DAY_PAYMENT */
  };
}
function subcontractorDayPaymentFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      validateDdbRecord(input, "SUBCONTRACTOR_DAY_PAYMENT" /* SUBCONTRACTOR_DAY_PAYMENT */);
      const {
        PK: _PK,
        SK: _SK,
        entityType: _entityType,
        ...payment
      } = input;
      return payment;
    },
    "SUBCONTRACTOR_DAY_PAYMENT" /* SUBCONTRACTOR_DAY_PAYMENT */
  );
}
function subcontractorDayPaymentsFromDdbRecords(records) {
  return safeTransformArray(
    records,
    subcontractorDayPaymentFromDdbRecord,
    "SUBCONTRACTOR_DAY_PAYMENT" /* SUBCONTRACTOR_DAY_PAYMENT */
  );
}

// src/transformations/weatherAlert.ts
function weatherAlertToDdbRecord(alert, orgId) {
  return {
    ...alert,
    PK: DDB_KEY_BUILDERS.orgPK(orgId),
    SK: DDB_KEY_BUILDERS.weatherAlertSK(alert.serviceAreaId),
    entityType: "WEATHER_FORECAST_ALERT" /* WEATHER_FORECAST_ALERT */
  };
}
function weatherAlertFromDdbRecord(record) {
  const {
    PK: _PK,
    SK: _SK,
    entityType: _entityType,
    ...alert
  } = record;
  return alert;
}

// src/transformations/picklistItem.ts
function picklistItemToDdbRecord(item) {
  return {
    ...item,
    PK: DDB_KEY_BUILDERS.orgPK(item.orgId),
    SK: DDB_KEY_BUILDERS.picklistItemSK(item.id),
    entityType: "PICKLIST_ITEM" /* PICKLIST_ITEM */
  };
}
function picklistItemFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      validateDdbRecord(input, "PICKLIST_ITEM" /* PICKLIST_ITEM */);
      const {
        PK: _PK,
        SK: _SK,
        entityType: _entityType,
        ...item
      } = input;
      return item;
    },
    "PICKLIST_ITEM" /* PICKLIST_ITEM */
  );
}
function picklistItemsFromDdbRecords(records) {
  return safeTransformArray(records, picklistItemFromDdbRecord, "PICKLIST_ITEM" /* PICKLIST_ITEM */);
}

// src/transformations/notificationTemplateOverride.ts
function notificationTemplateOverrideToDdbRecord(item) {
  return {
    ...item,
    PK: DDB_KEY_BUILDERS.orgPK(item.orgId),
    SK: DDB_KEY_BUILDERS.notificationTemplateSK(item.notificationType),
    entityType: "NOTIFICATION_TEMPLATE_OVERRIDE" /* NOTIFICATION_TEMPLATE_OVERRIDE */
  };
}
function notificationTemplateOverrideFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      validateDdbRecord(input, "NOTIFICATION_TEMPLATE_OVERRIDE" /* NOTIFICATION_TEMPLATE_OVERRIDE */);
      const {
        PK: _PK,
        SK: _SK,
        entityType: _entityType,
        ...item
      } = input;
      return item;
    },
    "NOTIFICATION_TEMPLATE_OVERRIDE" /* NOTIFICATION_TEMPLATE_OVERRIDE */
  );
}
function notificationTemplateOverridesFromDdbRecords(records) {
  return safeTransformArray(records, notificationTemplateOverrideFromDdbRecord, "NOTIFICATION_TEMPLATE_OVERRIDE" /* NOTIFICATION_TEMPLATE_OVERRIDE */);
}

// src/transformations/serviceBundle.ts
function serviceBundleToDdbRecord(bundle) {
  return safeTransform(
    bundle,
    (input) => {
      validateRequiredFields(
        input,
        ["id", "orgId", "name", "pricingPolicy", "serviceTemplateIds", "createdAt"],
        "ServiceBundle"
      );
      const record = {
        ...input,
        PK: DDB_KEY_BUILDERS.orgPK(input.orgId),
        SK: DDB_KEY_BUILDERS.serviceBundleSK(input.id),
        entityType: "SERVICE_BUNDLE" /* SERVICE_BUNDLE */
      };
      validateDdbRecord(record, "SERVICE_BUNDLE" /* SERVICE_BUNDLE */);
      return record;
    },
    "ServiceBundle"
  );
}
function serviceBundleFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      validateDdbRecord(input, "SERVICE_BUNDLE" /* SERVICE_BUNDLE */);
      const {
        PK: _PK,
        SK: _SK,
        entityType: _entityType,
        // Legacy `price` is interpreted below and never carried forward.
        price: legacyPrice,
        ...rest
      } = input;
      const pricingPolicy = rest.pricingPolicy ?? { mode: "fixed", amount: legacyPrice };
      return { ...rest, pricingPolicy };
    },
    "SERVICE_BUNDLE" /* SERVICE_BUNDLE */
  );
}
function serviceBundlesFromDdbRecords(records) {
  return safeTransformArray(
    records,
    serviceBundleFromDdbRecord,
    "SERVICE_BUNDLE" /* SERVICE_BUNDLE */
  );
}

// src/transformations/paymentPlan.ts
function paymentPlanToDdbRecord(plan) {
  return safeTransform(
    plan,
    (input) => {
      validateRequiredFields(
        input,
        [
          "id",
          "orgId",
          "customerId",
          "bundleId",
          "status",
          "collectionMode",
          "installments",
          "createdAt"
        ],
        "PaymentPlan"
      );
      const record = {
        ...input,
        PK: DDB_KEY_BUILDERS.orgPK(input.orgId),
        SK: DDB_KEY_BUILDERS.paymentPlanSK(input.customerId, input.id),
        entityType: "PAYMENT_PLAN" /* PAYMENT_PLAN */
      };
      validateDdbRecord(record, "PAYMENT_PLAN" /* PAYMENT_PLAN */);
      return record;
    },
    "PaymentPlan"
  );
}
function paymentPlanFromDdbRecord(record) {
  return safeTransform(
    record,
    (input) => {
      validateDdbRecord(input, "PAYMENT_PLAN" /* PAYMENT_PLAN */);
      const { PK: _PK, SK: _SK, entityType: _entityType, ...rest } = input;
      return rest;
    },
    "PAYMENT_PLAN" /* PAYMENT_PLAN */
  );
}
function paymentPlansFromDdbRecords(records) {
  return safeTransformArray(
    records,
    paymentPlanFromDdbRecord,
    "PAYMENT_PLAN" /* PAYMENT_PLAN */
  );
}

// src/transformations/platformInvoice.ts
function platformInvoiceToDdbRecord(invoice) {
  return {
    ...invoice,
    PK: DDB_KEY_BUILDERS.orgPK(invoice.orgId),
    SK: DDB_KEY_BUILDERS.platformInvoiceSK(invoice.billedAt, invoice.id),
    entityType: "PLATFORM_INVOICE" /* PLATFORM_INVOICE */
  };
}
function ddbRecordToPlatformInvoice(record) {
  const {
    PK: _pk,
    SK: _sk,
    entityType: _entityType,
    ...invoice
  } = record;
  return invoice;
}

// src/transformations/aiImportJob.ts
function keysFor(job) {
  return {
    PK: DDB_KEY_BUILDERS.orgPK(job.orgId),
    SK: DDB_KEY_BUILDERS.aiImportJobSK(job.importId, job.kind),
    entityType: "AI_IMPORT_JOB" /* AI_IMPORT_JOB */
  };
}
function aiImportJobToDdbRecord(job) {
  if (job.kind === "EXTRACT" /* EXTRACT */) {
    return { ...job, ...keysFor(job) };
  }
  return { ...job, ...keysFor(job) };
}
function aiImportJobFromDdbRecord(record) {
  if (record.kind === "EXTRACT" /* EXTRACT */) {
    const { PK: _PK2, SK: _SK2, entityType: _entityType2, ...job2 } = record;
    return job2;
  }
  const { PK: _PK, SK: _SK, entityType: _entityType, ...job } = record;
  return job;
}

// src/transformations/importLayoutRecipe.ts
function importLayoutRecipeToCurrentRecord(recipe) {
  return {
    ...recipe,
    PK: DDB_KEY_BUILDERS.importLayoutPK(recipe.fingerprint),
    SK: DDB_KEY_BUILDERS.importLayoutRecipeSK(recipe.schemaVersion),
    entityType: "IMPORT_LAYOUT_RECIPE" /* IMPORT_LAYOUT_RECIPE */,
    slot: "current",
    GSI1PK: DDB_KEY_BUILDERS.importLayoutRecipesGSI1PK(),
    GSI1SK: DDB_KEY_BUILDERS.importLayoutRecipesGSI1SK(recipe.status, recipe.updatedAt, recipe.fingerprint)
  };
}
function importLayoutRecipeToRevisionRecord(recipe) {
  return {
    ...recipe,
    PK: DDB_KEY_BUILDERS.importLayoutPK(recipe.fingerprint),
    SK: DDB_KEY_BUILDERS.importLayoutRevisionSK(recipe.schemaVersion, recipe.revision),
    entityType: "IMPORT_LAYOUT_RECIPE" /* IMPORT_LAYOUT_RECIPE */,
    slot: "revision"
  };
}
function importLayoutRecipeFromDdbRecord(record) {
  const {
    PK: _PK,
    SK: _SK,
    entityType: _entityType,
    slot: _slot,
    GSI1PK: _GSI1PK,
    GSI1SK: _GSI1SK,
    ...recipe
  } = record;
  return {
    ...recipe,
    headers: [...recipe.headers ?? []],
    orgHashes: [...recipe.orgHashes ?? []],
    confirmedBy: [...recipe.confirmedBy ?? []],
    disputedBy: [...recipe.disputedBy ?? []]
  };
}
function importLayoutFamilyToDdbRecord(pointer) {
  return {
    ...pointer,
    PK: DDB_KEY_BUILDERS.importLayoutFamilyPK(pointer.familyKey),
    SK: DDB_KEY_BUILDERS.importLayoutFamilySK(pointer.fingerprint),
    entityType: "IMPORT_LAYOUT_FAMILY" /* IMPORT_LAYOUT_FAMILY */
  };
}
function importLayoutFamilyFromDdbRecord(record) {
  const { PK: _PK, SK: _SK, entityType: _entityType, ...pointer } = record;
  return pointer;
}

// src/transformations/agentDraft.ts
function agentDraftToDdbRecord(draft) {
  return {
    ...draft,
    PK: DDB_KEY_BUILDERS.orgPK(draft.orgId),
    SK: DDB_KEY_BUILDERS.agentDraftSK(draft.draftId),
    entityType: "AGENT_DRAFT" /* AGENT_DRAFT */
  };
}
function agentDraftFromDdbRecord(record) {
  const {
    PK: _PK,
    SK: _SK,
    entityType: _entityType,
    ...draft
  } = record;
  return draft;
}

// src/transformations/agentRunLog.ts
var AGENT_RUN_LOG_TTL_DAYS = 90;
function agentRunLogExpiresAt(createdAt) {
  return Math.floor(Date.parse(createdAt) / 1e3) + AGENT_RUN_LOG_TTL_DAYS * 24 * 60 * 60;
}
function agentRunLogToDdbRecord(log) {
  return {
    ...log,
    PK: DDB_KEY_BUILDERS.orgPK(log.orgId),
    SK: DDB_KEY_BUILDERS.agentRunLogSK(log.runId),
    entityType: "AGENT_RUN_LOG" /* AGENT_RUN_LOG */,
    ...log.drafted === null ? { TTL: agentRunLogExpiresAt(log.createdAt) } : {}
  };
}
function agentRunLogFromDdbRecord(record) {
  const {
    PK: _PK,
    SK: _SK,
    entityType: _entityType,
    TTL: _TTL,
    ...log
  } = record;
  return log;
}

// src/transformations/signupDraft.ts
var FORBIDDEN = /* @__PURE__ */ new Set(["password", "taxId", "ein", "ssn", "newPassword"]);
var ATTRIBUTION_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gclid", "gbraid", "wbraid"];
function sanitizeSignupAttribution(input) {
  if (!input || typeof input !== "object" || Array.isArray(input)) return void 0;
  const out = {};
  for (const key of ATTRIBUTION_KEYS) {
    const value = input[key];
    if (typeof value === "string" && value.trim() && value.trim().length <= 200) out[key] = value.trim();
  }
  return Object.keys(out).length ? out : void 0;
}
function sanitizeSignupDraftFields(input) {
  const out = {};
  const take = (key) => {
    if (FORBIDDEN.has(key)) return;
    const value = input[key];
    if (typeof value !== "string") return;
    const trimmed = value.trim();
    if (trimmed) out[key] = trimmed;
  };
  take("email");
  take("firstName");
  take("lastName");
  take("phone");
  take("company");
  take("website");
  take("address");
  take("legalName");
  take("cognitoSub");
  take("serviceArea");
  if (isSignupSource(input.source)) out.source = input.source;
  const attribution = sanitizeSignupAttribution(input.firstTouchAttribution);
  if (attribution) out.firstTouchAttribution = attribution;
  if (out.email) out.email = out.email.toLowerCase();
  return out;
}
function signupDraftToDdbRecord(draft) {
  const email = draft.email?.trim().toLowerCase();
  return {
    PK: DDB_KEY_BUILDERS.signupDraftPK(draft.id),
    SK: DDB_KEY_BUILDERS.signupDraftSK(draft.id),
    ...email ? {
      GSI1PK: DDB_KEY_BUILDERS.signupDraftEmailGSI1PK(email),
      GSI1SK: DDB_KEY_BUILDERS.signupDraftEmailGSI1SK(draft.id)
    } : {},
    entityType: "SIGNUP_DRAFT" /* SIGNUP_DRAFT */,
    id: draft.id,
    ...draft.sessionId ? { sessionId: draft.sessionId } : {},
    ...draft.email ? { email } : {},
    ...draft.firstName ? { firstName: draft.firstName } : {},
    ...draft.lastName ? { lastName: draft.lastName } : {},
    ...draft.phone ? { phone: draft.phone } : {},
    ...draft.company ? { company: draft.company } : {},
    ...draft.website ? { website: draft.website } : {},
    ...draft.address ? { address: draft.address } : {},
    ...draft.legalName ? { legalName: draft.legalName } : {},
    ...draft.cognitoSub ? { cognitoSub: draft.cognitoSub } : {},
    ...draft.serviceArea ? { serviceArea: draft.serviceArea } : {},
    ...draft.source ? { source: draft.source } : {},
    ...sanitizeSignupAttribution(draft.firstTouchAttribution) ? { firstTouchAttribution: sanitizeSignupAttribution(draft.firstTouchAttribution) } : {},
    createdAt: draft.createdAt,
    updatedAt: draft.updatedAt
  };
}
function signupDraftFromDdbRecord(record) {
  return {
    id: record.id,
    ...record.sessionId ? { sessionId: record.sessionId } : {},
    ...record.email ? { email: record.email } : {},
    ...record.firstName ? { firstName: record.firstName } : {},
    ...record.lastName ? { lastName: record.lastName } : {},
    ...record.phone ? { phone: record.phone } : {},
    ...record.company ? { company: record.company } : {},
    ...record.website ? { website: record.website } : {},
    ...record.address ? { address: record.address } : {},
    ...record.legalName ? { legalName: record.legalName } : {},
    ...record.cognitoSub ? { cognitoSub: record.cognitoSub } : {},
    ...record.serviceArea ? { serviceArea: record.serviceArea } : {},
    ...isSignupSource(record.source) ? { source: record.source } : {},
    ...sanitizeSignupAttribution(record.firstTouchAttribution) ? { firstTouchAttribution: sanitizeSignupAttribution(record.firstTouchAttribution) } : {},
    createdAt: record.createdAt,
    updatedAt: record.updatedAt
  };
}

// src/transformations/operatorNotes.ts
function ref(id, name) {
  return { id, name };
}
function operatorNoteToDdbRecord(orgId, note) {
  return {
    PK: OPERATOR_NOTES_KEYS.partition(orgId),
    SK: OPERATOR_NOTES_KEYS.note(note.id),
    entityType: "OPERATOR_NOTES" /* OPERATOR_NOTES */,
    noteId: note.id,
    text: note.text,
    authorId: note.author.id,
    authorName: note.author.name,
    createdAt: note.createdAt
  };
}
function ddbRecordToOperatorNote(record) {
  return {
    id: record.noteId,
    text: record.text,
    author: ref(record.authorId, record.authorName),
    createdAt: record.createdAt
  };
}
function operatorTaskToDdbRecord(orgId, task) {
  return {
    PK: OPERATOR_NOTES_KEYS.partition(orgId),
    SK: OPERATOR_NOTES_KEYS.task(task.id),
    entityType: "OPERATOR_NOTES" /* OPERATOR_NOTES */,
    taskId: task.id,
    title: task.title,
    dueDate: task.dueDate,
    assigneeId: task.assignee.id,
    assigneeName: task.assignee.name,
    authorId: task.author.id,
    authorName: task.author.name,
    createdAt: task.createdAt,
    done: task.done,
    ...task.doneAt ? { doneAt: task.doneAt } : {},
    ...task.doneBy ? { doneById: task.doneBy.id, doneByName: task.doneBy.name } : {}
  };
}
function ddbRecordToOperatorTask(record) {
  return {
    id: record.taskId,
    title: record.title,
    dueDate: record.dueDate,
    assignee: ref(record.assigneeId, record.assigneeName),
    author: ref(record.authorId, record.authorName),
    createdAt: record.createdAt,
    done: record.done === true,
    ...record.doneAt ? { doneAt: record.doneAt } : {},
    ...record.doneById && record.doneByName ? { doneBy: ref(record.doneById, record.doneByName) } : {}
  };
}
function operatorSuccessOwnerToDdbRecord(orgId, value) {
  return {
    PK: OPERATOR_NOTES_KEYS.partition(orgId),
    SK: OPERATOR_NOTES_KEYS.owner(),
    entityType: "OPERATOR_NOTES" /* OPERATOR_NOTES */,
    ownerId: value.owner?.id ?? null,
    ownerName: value.owner?.name ?? null,
    assignedAt: value.assignedAt,
    assignedById: value.assignedBy.id,
    assignedByName: value.assignedBy.name
  };
}
function ddbRecordToOperatorSuccessOwner(record) {
  return {
    owner: record.ownerId && record.ownerName ? ref(record.ownerId, record.ownerName) : null,
    assignedAt: record.assignedAt,
    assignedBy: ref(record.assignedById, record.assignedByName)
  };
}

// src/transformations/operatorAudit.ts
function operatorAuditToDdbRecord(record) {
  return {
    ...record,
    PK: OPERATOR_AUDIT_KEYS.partition(record.orgId),
    SK: OPERATOR_AUDIT_KEYS.record(record.occurredAt, record.id),
    entityType: "OPERATOR_AUDIT" /* OPERATOR_AUDIT */
  };
}
function ddbRecordToOperatorAudit(record) {
  const { PK: _pk, SK: _sk, entityType: _entityType, ...audit } = record;
  return audit;
}

// src/transformations/customerAccount.ts
function customerAccountToDdbRecord(account) {
  return {
    ...account,
    PK: DDB_KEY_BUILDERS.orgPK(account.orgId),
    SK: DDB_KEY_BUILDERS.customerAccountSK(account.id),
    entityType: "CUSTOMER_ACCOUNT" /* CUSTOMER_ACCOUNT */
  };
}
function customerAccountFromDdbRecord(record) {
  const { PK: _pk, SK: _sk, entityType: _type, ...account } = record;
  return account;
}
function customerAccountMembershipRecord(orgId, { customerId, accountId, contactReferences }) {
  return {
    PK: DDB_KEY_BUILDERS.orgPK(orgId),
    SK: DDB_KEY_BUILDERS.customerAccountMembershipSK(customerId),
    entityType: "ACCOUNT_PROPERTY" /* ACCOUNT_PROPERTY */,
    orgId,
    customerId,
    accountId,
    contactReferences
  };
}
function customerAccountMembershipFromDdbRecord(record) {
  return {
    customerId: record.customerId,
    accountId: record.accountId,
    contactReferences: record.contactReferences ?? []
  };
}
function customerAccountMemberRecord(orgId, accountId, customerId) {
  return {
    PK: DDB_KEY_BUILDERS.orgPK(orgId),
    SK: DDB_KEY_BUILDERS.customerAccountMemberSK(accountId, customerId),
    entityType: "ACCOUNT_MEMBER" /* ACCOUNT_MEMBER */,
    orgId,
    accountId,
    customerId
  };
}

// src/api/auth.ts
function isValidPhoneNumber(phoneNumber) {
  const e164Regex = /^\+[1-9]\d{1,14}$/;
  return e164Regex.test(phoneNumber);
}
function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
function isValidOtpCode(otpCode) {
  return /^\d{6}$/.test(otpCode);
}
var EMAIL_SIGN_IN_CODE_LENGTH = 8;
function isValidEmailSignInCode(code) {
  return code.length === EMAIL_SIGN_IN_CODE_LENGTH && /^\d+$/.test(code);
}
function generateOtpCode() {
  return Math.floor(1e5 + Math.random() * 9e5).toString();
}
function shouldSkipRefreshDuringCooldown(trigger, lastTransientFailureMs, nowMs, cooldownMs) {
  if (trigger === "manual") return false;
  if (lastTransientFailureMs === null) return false;
  return nowMs - lastTransientFailureMs < cooldownMs;
}

// src/api/timeEntry.ts
var VALID_TRANSITIONS = {
  ["clocked-out" /* CLOCKED_OUT */]: ["clock-in" /* CLOCK_IN */],
  ["clocked-in" /* CLOCKED_IN */]: ["clock-out" /* CLOCK_OUT */, "break-start" /* BREAK_START */],
  ["on-break" /* ON_BREAK */]: ["break-end" /* BREAK_END */]
};
var NEXT_STATE = {
  ["clock-in" /* CLOCK_IN */]: "clocked-in" /* CLOCKED_IN */,
  ["clock-out" /* CLOCK_OUT */]: "clocked-out" /* CLOCKED_OUT */,
  ["break-start" /* BREAK_START */]: "on-break" /* ON_BREAK */,
  ["break-end" /* BREAK_END */]: "clocked-in" /* CLOCKED_IN */
};
function validateStateTransition(currentStatus, eventType) {
  const validEvents = VALID_TRANSITIONS[currentStatus];
  const nextState = NEXT_STATE[eventType];
  if (!validEvents.includes(eventType)) {
    const errorMessages = {
      [`${"clocked-out" /* CLOCKED_OUT */}-${"clock-out" /* CLOCK_OUT */}`]: "You must be clocked in to clock out",
      [`${"clocked-out" /* CLOCKED_OUT */}-${"break-start" /* BREAK_START */}`]: "You must be clocked in to start a break",
      [`${"clocked-out" /* CLOCKED_OUT */}-${"break-end" /* BREAK_END */}`]: "You must be clocked in and on break to end a break",
      [`${"clocked-in" /* CLOCKED_IN */}-${"clock-in" /* CLOCK_IN */}`]: "You are already clocked in",
      [`${"clocked-in" /* CLOCKED_IN */}-${"break-end" /* BREAK_END */}`]: "You are not currently on break",
      [`${"on-break" /* ON_BREAK */}-${"clock-in" /* CLOCK_IN */}`]: "You must end your break before clocking in again",
      [`${"on-break" /* ON_BREAK */}-${"clock-out" /* CLOCK_OUT */}`]: "You must end your break before clocking out",
      [`${"on-break" /* ON_BREAK */}-${"break-start" /* BREAK_START */}`]: "You are already on break"
    };
    const key = `${currentStatus}-${eventType}`;
    const error = errorMessages[key] || `Invalid transition from ${currentStatus} with event ${eventType}`;
    return {
      isValid: false,
      nextState: currentStatus,
      error,
      errorCode: API_ERROR_CODES.INVALID_STATE_TRANSITION
    };
  }
  return {
    isValid: true,
    nextState
  };
}
function getNextState(eventType) {
  return NEXT_STATE[eventType];
}
function getValidEvents(status) {
  return VALID_TRANSITIONS[status];
}

// src/api/websocket.ts
var WS_MESSAGE_TYPES = {
  NOTIFICATION: "notification",
  DATA_UPDATE: "data_update"
};
var WS_ENTITY_TYPES = {
  LOCATION_TRACKING: "location-tracking",
  NOTIFICATIONS: "notifications",
  VISITS: "visits",
  CUSTOMERS: "customers",
  SUBSCRIPTIONS: "subscriptions",
  INVOICES: "invoices",
  RATE_REQUESTS: "rate-requests",
  MESSAGE_CAMPAIGNS: "message-campaigns",
  DISPATCH_JOBS: "dispatch-jobs",
  CONVERSATIONS: "conversations",
  CHAT: "chat_message"
};

// src/utils/notificationEmailLink.ts
function emailReplyLink(address) {
  if (address.length > 254 || !/^[A-Za-z0-9.!#$%&'*+\/=?^_`{|}~-]+@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/.test(address)) return void 0;
  const [local, domain] = address.split("@");
  if (local.length > 64 || local.startsWith(".") || local.endsWith(".") || local.includes("..")) return void 0;
  return `mailto:${encodeURIComponent(local)}@${domain.toLowerCase()}`;
}
function handleNotificationEmailLink(actionLink, open) {
  if (!actionLink || !/^mailto:/i.test(actionLink)) return false;
  if (/[?#]/.test(actionLink)) return true;
  try {
    const address = decodeURIComponent(actionLink.slice(7));
    const url = emailReplyLink(address);
    if (url) open(url);
  } catch {
  }
  return true;
}

// src/helpers/salesSections.ts
var OTHER_CATEGORY = "Other";
var byName = (a, b) => a.localeCompare(b, void 0, { sensitivity: "base", numeric: true });
function catalogCompare(aOrder, aName, bOrder, bName) {
  const aHas = typeof aOrder === "number" && Number.isFinite(aOrder);
  const bHas = typeof bOrder === "number" && Number.isFinite(bOrder);
  if (aHas && bHas && aOrder !== bOrder)
    return aOrder - bOrder;
  if (aHas !== bHas) return aHas ? -1 : 1;
  return byName(aName, bName);
}
function salesSections(rows, categoryOf, nameOf, sortOrderOf = () => void 0) {
  const byCategory = /* @__PURE__ */ new Map();
  for (const row of rows) {
    const category = categoryOf(row)?.trim() || OTHER_CATEGORY;
    const key = [...byCategory.keys()].find(
      (k) => k.toLowerCase() === category.toLowerCase()
    ) ?? category;
    byCategory.set(key, [...byCategory.get(key) ?? [], row]);
  }
  const rowCompare = (a, b) => catalogCompare(sortOrderOf(a), nameOf(a), sortOrderOf(b), nameOf(b));
  return [...byCategory.entries()].map(([category, list]) => ({ category, rows: [...list].sort(rowCompare) })).sort((a, b) => {
    if (a.category === OTHER_CATEGORY) return 1;
    if (b.category === OTHER_CATEGORY) return -1;
    return catalogCompare(
      sortOrderOf(a.rows[0]),
      a.category,
      sortOrderOf(b.rows[0]),
      b.category
    );
  });
}

// src/helpers/packageOptionRates.ts
var round22 = (n) => Math.round(n * 100) / 100;
function activeOptions(template) {
  const options = template?.packagePricing?.options ?? [];
  return options.filter((o) => o.isActive !== false).slice().sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
}
function parseRate(v) {
  if (typeof v === "number" && Number.isFinite(v)) return v;
  if (typeof v === "string") {
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : 0;
  }
  return 0;
}
function positive(n) {
  return typeof n === "number" && Number.isFinite(n) && n > 0 ? n : 0;
}
function suggestPerVisit(template, blh) {
  const blr = template?.hourlyRate ?? 0;
  const hours = blh ?? 0;
  return blr > 0 && hours > 0 ? round22(blr * hours) : 0;
}
function suggestSeason(perVisit, visits, roundUpToCents, rateRounding) {
  if (!(perVisit > 0 && visits > 0)) return 0;
  return applyCharmThenMoneyEnding(round22(perVisit * visits), {
    roundUpToCents,
    rateRounding: rateRoundingAppliesToSeason(rateRounding) ? rateRounding : void 0
  });
}
function suggestBlhFromPerVisit(template, perVisit) {
  const blr = template?.hourlyRate ?? 0;
  if (blr <= 0 || perVisit <= 0) return 0;
  return round22(perVisit / blr);
}
function visitsForPricing(opt, sub, budgetedVisitsByOptionId) {
  const fromConfig = budgetedVisitsForPricing(opt);
  if (fromConfig > 0) return fromConfig;
  if (sub && opt.id === sub.selectedPackageOptionId) {
    const ps = sub.packageState;
    const fromState = positive(ps?.builtInVisits) || positive(ps?.totalVisits);
    if (fromState > 0) return Math.round(fromState);
  }
  const fromMap = budgetedVisitsByOptionId?.get(opt.id);
  if (fromMap && fromMap > 0) return Math.round(fromMap);
  return 0;
}
function resolveOptionRates(sub, opt, template, budgetedVisitsByOptionId) {
  const visits = visitsForPricing(opt, sub, budgetedVisitsByOptionId);
  const blh = sub.pricingInputs?.budgetedHours ?? 0;
  const suggestedPerVisit = suggestPerVisit(template, blh);
  const stored = (sub.packageOptionPricing ?? []).find(
    (p) => p.optionId === opt.id
  );
  let perVisit = 0;
  let season = 0;
  if (stored) {
    perVisit = positive(stored.pricePerAdditionalVisit);
    season = positive(stored.rate);
  } else if (opt.id === sub.selectedPackageOptionId) {
    season = positive(parseRate(sub.rate));
    perVisit = positive(sub.pricePerAdditionalVisit);
  }
  const perVisitForSeasonFormula = perVisit > 0 ? perVisit : suggestedPerVisit;
  const suggestedSeason = suggestSeason(
    perVisitForSeasonFormula,
    visits,
    template?.roundUpToCents,
    template?.rateRounding
  );
  const showPerVisitSuggest = suggestedPerVisit > 0 && (perVisit <= 0 || Math.abs(perVisit - suggestedPerVisit) >= 0.01);
  const showSeasonSuggest = suggestedSeason > 0 && (season <= 0 || Math.abs(season - suggestedSeason) >= 0.01);
  return {
    perVisit,
    season,
    visits,
    suggestedPerVisit,
    suggestedSeason,
    showPerVisitSuggest,
    showSeasonSuggest
  };
}

// src/helpers/packageOptionPatch.ts
function firstPlanPickPatch(service, optionId) {
  if (!optionId || service.selectedPackageOptionId || service.template?.billingMethod !== "package" /* PACKAGE */ || service.subscriptionStatus === "active" /* ACTIVE */)
    return {};
  return service.template.packagePricing?.options?.some(
    (option) => option.id === optionId && option.isActive !== false
  ) ? { selectedPackageOptionId: optionId } : {};
}
function packageOptionRows(service) {
  const planId = service.selectedPackageOptionId ?? resolvePackageOption(
    service.template?.packagePricing?.options,
    service.selectedPackageOptionId
  )?.id;
  const pricingSource = {
    ...service,
    selectedPackageOptionId: planId,
    packageOptionPricing: service.packageOptionPricing?.map(
      (price) => price.optionId === planId ? {
        ...price,
        rate: service.rate ?? price.rate,
        pricePerAdditionalVisit: service.pricePerAdditionalVisit ?? price.pricePerAdditionalVisit
      } : price
    )
  };
  return activeOptions(service.template).map((option) => ({
    option,
    rates: resolveOptionRates(pricingSource, option, service.template),
    isTheirPlan: option.id === planId
  }));
}
function packageOptionPatch(service, optionId, edit, options) {
  const rows = packageOptionRows(service);
  const template = service.template;
  const packageOptionPricing = rows.map(({ option, rates, isTheirPlan }) => {
    let perVisit = isTheirPlan ? service.pricePerAdditionalVisit ?? rates.perVisit : rates.perVisit;
    let season = isTheirPlan ? service.rate ?? rates.season : rates.season;
    if (option.id === optionId) {
      if ("perVisit" in edit) {
        perVisit = edit.perVisit;
        const storedSeason = (isTheirPlan ? service.rate : void 0) ?? service.packageOptionPricing?.find(
          (price) => price.optionId === option.id
        )?.rate;
        const formula = suggestSeason(
          perVisit,
          rates.visits,
          template?.roundUpToCents,
          template?.rateRounding
        );
        if (!options?.preserveSeason || storedSeason == null) {
          if (formula > 0) season = formula;
        } else season = storedSeason;
      } else season = edit.season;
    }
    return {
      optionId: option.id,
      rate: round22(season),
      pricePerAdditionalVisit: round22(perVisit)
    };
  });
  const plan = rows.find((row) => row.isTheirPlan);
  const planPricing = plan ? packageOptionPricing.find((price) => price.optionId === plan.option.id) : void 0;
  return {
    packageOptionPricing,
    ...planPricing ? {
      rate: planPricing.rate,
      pricePerAdditionalVisit: planPricing.pricePerAdditionalVisit
    } : {},
    ...firstPlanPickPatch(service, plan?.option.id)
  };
}

// src/helpers/campaignAudience.ts
var PER_PAGE = 250;
var MAX_PAGES = 100;
function displayNameOf(hit) {
  return [hit.firstName, hit.lastName].filter(Boolean).join(" ").trim() || "Unknown";
}
async function fetchAudienceCustomers(search, query) {
  const res = await search.customers({ ...query, hasAnyContact: true });
  const map = /* @__PURE__ */ new Map();
  for (const hit of res?.hits ?? []) {
    if (!hit?.id || map.has(hit.id)) continue;
    map.set(hit.id, {
      id: hit.id,
      displayName: displayNameOf(hit),
      hasEmail: !!hit.hasAnyEmail,
      hasPhone: !!hit.hasAnyPhone,
      smsOptedOut: hit.smsOptedOut === true
    });
  }
  const found = typeof res?.found === "number" ? res.found : map.size;
  return { map, capped: found > map.size, found };
}
async function customerIdsInPeriod(search, rule, cities, status) {
  const ids = /* @__PURE__ */ new Set();
  let capped = false;
  let found = 0;
  for (let page = 1; ; page++) {
    const res = await search.subscriptions({
      serviceTemplateId: rule.serviceTemplateId,
      periodName: rule.periodName,
      customerCities: cities,
      status,
      page,
      perPage: PER_PAGE
    });
    const hits = res?.hits ?? [];
    if (typeof res?.found === "number" && res.found > found) found = res.found;
    for (const h of hits) {
      const id = (h?.document ?? h)?.customerId;
      if (id) ids.add(id);
    }
    if (hits.length === 0 || hits.length < PER_PAGE) break;
    if (found > 0 && page * PER_PAGE >= found) break;
    if (page >= MAX_PAGES) {
      capped = true;
      break;
    }
  }
  return { ids, capped: capped || found > ids.size };
}
async function resolveCampaignAudienceWith(search, filter) {
  const cities = filter.customerCities.length ? filter.customerCities : void 0;
  const hasActiveService = filter.activeOnly || void 0;
  const subscriptionStatus = filter.activeOnly ? "active" : void 0;
  const { paymentStatus, balanceFilter, customerType } = filter;
  const includes = filter.rules.filter((r) => r.serviceTemplateId && !r.exclude);
  const excludes = filter.rules.filter((r) => r.serviceTemplateId && r.exclude);
  const details = /* @__PURE__ */ new Map();
  let capped = false;
  let reportedFound = null;
  const customerQuery = {
    customerCities: cities,
    hasActiveService,
    paymentStatus,
    balanceFilter,
    status: customerType,
    excludeDeactivated: true
  };
  const idsForRule = async (rule) => {
    const { map, capped: c, found } = await fetchAudienceCustomers(search, {
      ...customerQuery,
      serviceTemplateIds: [rule.serviceTemplateId]
    });
    capped = capped || c;
    if (c && found > map.size) reportedFound = found;
    map.forEach((v, k) => details.set(k, v));
    let ids = new Set(map.keys());
    if (rule.periodName) {
      reportedFound = null;
      const season = await customerIdsInPeriod(search, rule, cities, subscriptionStatus);
      capped = capped || season.capped;
      ids = new Set([...ids].filter((id) => season.ids.has(id)));
    }
    return ids;
  };
  let base;
  if (includes.length > 0) {
    let acc = null;
    for (const rule of includes) {
      const ids = await idsForRule(rule);
      if (acc === null) acc = ids;
      else {
        reportedFound = null;
        const prev = acc;
        acc = new Set([...prev].filter((id) => ids.has(id)));
      }
    }
    base = acc ?? /* @__PURE__ */ new Set();
  } else {
    const { map, capped: c, found } = await fetchAudienceCustomers(search, customerQuery);
    capped = capped || c;
    if (c && found > map.size) reportedFound = found;
    map.forEach((v, k) => details.set(k, v));
    base = new Set(map.keys());
  }
  for (const rule of excludes) {
    reportedFound = null;
    const ids = await idsForRule(rule);
    ids.forEach((id) => base.delete(id));
  }
  const customers = [...base].map((id) => details.get(id)).filter((c) => !!c).sort((a, b) => a.displayName.localeCompare(b.displayName));
  const loaded = customers.length;
  const matched = reportedFound != null && reportedFound > loaded ? reportedFound : loaded;
  return { customers, loaded, matched, capped: capped || matched > loaded };
}
export {
  ADDITIONAL_LABOR_HOURS_DESCRIPTION,
  ADD_CARD_LOGIN_PATH,
  ADMIN_NOTIFICATION_PREFERENCE_BY_TYPE,
  ADMIN_NOTIFICATION_PREFERENCE_DEFAULTS,
  ADMIN_NOTIFICATION_PREFERENCE_KEYS,
  ADMIN_NOTIFICATION_PREFERENCE_LABELS,
  ADMIN_NOTIFICATION_TYPE,
  ADMIN_PREFERENCE_HIDDEN_TYPES,
  AGENT_RUN_LOG_TTL_DAYS,
  AI_INTEGRATION_IDS,
  ALL_AI_TOKEN_KINDS,
  ALL_METRIC_TYPES,
  ALL_PERMISSIONS_MASK,
  API_ERROR_CODES,
  ASK_FOR_CARD_EMAIL_ACTION,
  ASK_FOR_CARD_EMAIL_CONTENT,
  ASK_FOR_CARD_EMAIL_SUBJECT,
  ASK_FOR_CARD_NAME,
  ASK_FOR_CARD_SMS_CONTENT,
  ASK_FOR_CARD_TEMPLATE_ID,
  ASK_RANK,
  ASSESSMENT_NAME_PREFIX,
  ASSISTANT_SAFE_ERROR,
  AUTO_MESSAGE_SITTING_GAP_MS,
  AUTO_MESSAGE_SITTING_TIMEZONE,
  AgentDraftKind,
  AgentDraftStatus,
  AiImportJobKind,
  AiImportJobStatus,
  AutoSharePhotosSetting,
  BANNED_WORDS,
  BELL_FILTER_BUTTON_TOOLTIP,
  BELL_FILTER_GROUPS,
  BILLING_METHOD_WORDS,
  BOUNDARY_REENTRY_WINDOW_MS,
  BUILT_IN_CUSTOMER_LABELS,
  BUILT_IN_PICKLIST_ITEMS,
  BUILT_IN_ROLE_IDS,
  BUILT_IN_ROLE_TEMPLATES,
  BaseColors,
  BillingMethod,
  CAMPAIGN_BALANCE_FILTERS,
  CAMPAIGN_CUSTOMER_TYPE_FILTERS,
  CAMPAIGN_PAYMENT_STATUS_FILTERS,
  CARD_COST_PERCENT_ALL_IN,
  CHANGE_FIELD_WORDS,
  CHARGE_WAIT_MINUTES,
  CLIENT_REPORTABLE_INTEGRATION_IDS,
  CONCEPT_TO_TYPE,
  CONTEXT_SUPPLIED_NOTIFICATION_VARIABLES,
  CONVERT_TO_CONTACT_ROLES,
  CREDIT_BILLABLE_TOKEN_KINDS,
  CREW_CLUSTER,
  CREW_MEMBER_PALETTE,
  CREW_MEMBER_PALETTE_NAMES,
  CREW_MOVING_SPEED_MPS,
  CREW_PUCK,
  CREW_PUCK_COLORS,
  CREW_PUCK_INNER,
  CREW_PUCK_OUTER,
  CREW_PUCK_SVG,
  CREW_VISIBLE_BELL_FILTER_GROUP_IDS,
  CSSVariables,
  CUSTOMER_ACCOUNT_KIND_LABELS,
  CUSTOMER_ACCOUNT_LISTED_PROPERTIES,
  CUSTOMER_ACCOUNT_MAX_CHANGES_PER_SAVE,
  CUSTOMER_ACTIVATION_MAX_PHOTOS,
  CUSTOMER_DEACTIVATION_REASONS,
  CUSTOMER_DEACTIVATION_REASON_LABELS,
  CUSTOMER_EDITABLE_NOTIFICATION_TYPES,
  CUSTOMER_LOOKUP_QUERY_BY,
  CUSTOMER_MESSAGE_ATTACHMENT_TYPES,
  CUSTOMER_MESSAGE_DOCUMENT_EXTENSIONS,
  CUSTOMER_MESSAGE_DOCUMENT_TYPES,
  CUSTOMER_MESSAGE_IMAGE_TYPES,
  CUSTOMER_METRIC_TYPES,
  CUSTOMER_NAME_QUERY_BY,
  CUSTOMER_PRICE_FIELDS,
  CUSTOMER_SEARCH_QUERY_BY,
  CUSTOM_AMOUNT_FIELDS,
  CUSTOM_DEACTIVATION_REASON_ID,
  CUSTOM_OPTION_ID,
  CUSTOM_SCHEDULE_LABEL,
  CUSTOM_TEMPLATE_MARK,
  ChargingMode,
  Colors,
  ColorsDark,
  ContactEntityType,
  ContactRole,
  ContactType,
  ContactVerificationStatus,
  CreateVisitSchema,
  CreationStatus,
  CrewAssignmentSource,
  CrewMemberClockStatus,
  CrewRole,
  CustomScheduleUnit,
  CustomerDeactivationReason,
  CustomerMetricType,
  CustomerSource,
  CustomerStatus,
  DAILY_COLLECTED_SUMMARY_LOCAL_HOUR,
  DDB_KEY_BUILDERS,
  DDB_KEY_PATTERNS,
  DEFAULT_CHARGE_WAIT_WHEN_ENABLED,
  DEFAULT_CREW_START_SPREAD_MINUTES,
  DEFAULT_DISPLAY_TIMEZONE,
  DEFAULT_HOLIDAY_WARNING_DAYS,
  DEFAULT_MN_LOCATION_NUMBER,
  DEFAULT_NOTIFICATION_SETTINGS,
  DEFAULT_PAYMENT_FEE_RATES,
  DEFAULT_PAYMENT_ISSUES_FILTER,
  DEFAULT_PLATFORM_BILLING_PLAN,
  DEFAULT_PLATFORM_PLAN_ID,
  DEFAULT_PORTAL_BLOCK_MESSAGE,
  DEFAULT_SEGMENT_CONCEPTS,
  DEFAULT_VALUES,
  DIRECTIONAL_MAP,
  DISCREPANCY_KINDS,
  DayOfWeek,
  DayPreferencePriority,
  DispatchBatchStatus,
  DispatchJobStatus,
  DisposalPileStatus,
  EMAIL_COLORS,
  EMAIL_DEFAULTS,
  EMAIL_SIGN_IN_CODE_LENGTH,
  EMPTY_BOUNDARY_SESSION,
  ESSENTIAL_NOTIFICATIONS_EXPLANATION,
  ESSENTIAL_NOTIFICATION_CATEGORIES,
  EVENT_TYPES,
  EmailValidation,
  EmploymentType,
  EntityType,
  FEATURE_FLAGS,
  FEEDBACK_CATEGORY_LABELS,
  FEEDBACK_ISSUE_IDENTIFIER_PATTERN,
  FEEDBACK_TITLE_MESSAGE_MAX,
  FIELD_NAMES,
  FractionalRanking,
  GENERIC_PAYMENT_RETRY_MESSAGE,
  GENERIC_SERVICE_LABEL,
  GEOFENCE_RECORD_TYPE,
  GEOFENCE_TTL_DAYS,
  GPS_FALLBACK_REASON_TEXT,
  GPS_TIME_GAP_GROUP_HEADER,
  GPS_TIME_GAP_PHRASES,
  GPS_TIME_GAP_THRESHOLD_MINUTES,
  GPS_TIME_SOURCE_LABEL,
  GeneralStatus,
  GeofenceEventType,
  HIDDEN_INVOICE_LINE_MONEY,
  HIDDEN_INVOICE_TOTAL,
  HIDEABLE_NOTIFICATION_TYPES,
  IMAGERY_SOURCE_INFO,
  IMPORT_CUSTOMER_STATUSES,
  IMPORT_DISCOUNT_TYPES,
  IMPORT_ENGINES,
  IMPORT_LAYOUT_RECIPE_MAX_ORG_HASHES,
  IMPORT_LAYOUT_RECIPE_STATUSES,
  IMPORT_SOURCES,
  IMPORT_SUBSCRIPTION_STATUSES,
  INSIGHTS_API_ROUTES,
  INTEGRATION_COSTS,
  IntegrationId,
  InvoiceStatus,
  JUSTIFI_LOCKED_PLATFORM_INVOICES,
  JobStatus,
  LANGUAGE,
  LEAD_HOST,
  LEAD_SOURCE_OTHER_ID,
  LEFT_OUT_REASONS,
  LEFT_OUT_SERVICE_REASONS,
  LEFT_OUT_WORDS,
  LEGACY_PLATFORM_DEAL_NAME,
  LEGACY_PLATFORM_FEE,
  LEGACY_RATE_REQUESTED_LIST_FILTER,
  LEGACY_RCS_STATUS_BUSINESS_VERIFIED,
  LINE_ITEM_ROUNDING_NOTE,
  LOCATION_CLOCK_SKEW_ALLOWANCE_MS,
  LOCATION_ESTIMATE_MAX_ACCURACY_M,
  LOCATION_ESTIMATE_MAX_SPEED_MPS,
  LOCATION_FLUSH_INTERVAL_MS,
  LOCATION_MIN_BUFFER_SPACING_MS,
  LOCATION_RECORD_TYPE,
  LOCATION_SEGMENT_MAX_POINTS,
  LOCATION_SEGMENT_RECORD_TYPE,
  LOCATION_SEGMENT_WINDOW_MS,
  LONG_IDLE_THRESHOLD_MS,
  LedgerEntryType,
  LineItemType,
  LocationTrackingStatus,
  MAX_ACTIVE_VISIT_AGE_MS,
  MAX_CAMPAIGN_REPEAT_DAYS,
  MAX_CLIENT_INTEGRATION_USAGE_AMOUNT,
  MAX_CREW_START_SPREAD_MINUTES,
  MAX_IMAGE_UPLOAD_BYTES,
  MAX_IMAGE_UPLOAD_MB,
  MAX_OFFLINE_LOCATION_AGE_MS,
  MAX_PLAUSIBLE_RADIUS_M,
  MAX_POLICY_DOCUMENT_BYTES,
  MEASUREMENT_TYPE_COLORS,
  MEASUREMENT_TYPE_LABELS,
  MESSAGE_CONTACT_MODE,
  MESSAGE_IMAGE_DRAG_MIME,
  MESSAGE_QUOTE_MAX_EXCERPT_LENGTH,
  MESSAGE_QUOTE_SMS_EXCERPT_LENGTH,
  MESSAGING_INFRA_FIXED_MONTHLY,
  METRIC_FIELD_KEYS,
  METRIC_KEY_TO_TYPE,
  METRIC_TYPE_TO_KEY,
  METRO_PARCEL_KEY_BUILDERS,
  MIN_CAMPAIGN_REPEAT_DAYS,
  MIN_GEOFENCE_RADIUS_M,
  MIN_PLAUSIBLE_RADIUS_M,
  MMS_CONTENT_TYPES,
  MMS_MAX_BYTES,
  MMS_MAX_MEDIA,
  MN_ESERVICES_FILE_FORMATS_URL,
  MN_ESERVICES_LOCATION_INFO_URL,
  MN_GENERAL_RATE_TAX_TYPE,
  MONEY_ENDING_PRESETS,
  MONEY_QUESTION_KINDS,
  MessageCampaignScheduleStatus,
  MessageCampaignStatus,
  MessageChannel,
  MessageDeliveryStatus,
  MessagePriority,
  MessageSender,
  NAME_AND,
  NAME_HONORIFIC,
  NAME_SUFFIX,
  NEARBY_SCALE_FACTOR,
  NESTED_PRICE_FIELDS,
  NON_SALES_VISIT_STATUSES,
  NOTIFICATION_CATEGORY_LABELS,
  NOTIFICATION_CHANNEL_LABELS,
  NOTIFICATION_PRIORITY,
  NOTIFICATION_SAMPLE_DATA,
  NOTIFICATION_TEMPLATES,
  NOTIFICATION_TYPE_CONFIGS,
  NOTIFICATION_VARIABLE_DESCRIPTIONS,
  NOTIFICATION_VARIABLE_LABELS,
  NO_EXTRA_VISIT_PRICE_WARNING,
  NO_PAYMENT_METHOD_ERROR,
  NO_PRICE_OPTION_ID,
  NO_SCHEDULE_LABEL,
  NULLABLE_FIELDS,
  NoteType,
  NotificationChannel,
  NotificationPriority,
  NotificationStatus,
  NotificationType,
  NotifyCustomerOnReviewSetting,
  OEM_APP_SLEEP_MANUFACTURERS,
  OFFICE_SERVICE_OPTION_EDIT_STATUSES,
  OFFICE_STAFF_ONLY_NOTIFICATION_TYPES,
  OLD_IMPORTER_REVIEW_MESSAGE,
  OLD_IMPORTER_REVIEW_REASON,
  ONE_OFF_TEMPLATE_PREFIX,
  ON_DEMAND_LABEL,
  OPERATOR_AUDIT_KEYS,
  OPERATOR_NOTES_KEYS,
  ORDINAL_MAP,
  OTHER_CATEGORY,
  OrganizationMemberStatus,
  PACKAGE_CHARGE_LEDGER_SOURCE,
  PACKAGE_CHARGE_TYPE,
  PACKAGE_INVOICE_ID_PATTERN,
  PACKAGE_INVOICE_PARTIAL_REFUND_LINE,
  PACKAGE_INVOICE_REFUND_LINE,
  PAYMENT_ISSUE_STATUS_VALUES,
  PAYMENT_ISSUE_TYPE_VALUES,
  PAYMENT_NOT_CONFIGURED_ERROR,
  PAYMENT_STATUS,
  PAY_PATHS,
  PHOTO_RETENTION_DAYS,
  PHOTO_RETENTION_MS,
  PHOTO_TAG_DESCRIPTIONS,
  PHOTO_TAG_LABELS,
  PHOTO_TAG_ORDER,
  PHOTO_TOKEN_REGEX,
  PLATFORM_AI_INCLUDED_COPY,
  PLATFORM_AI_OVERAGE_ENABLED,
  PLATFORM_COST_BASIS,
  PLATFORM_OVERAGE,
  PLATFORM_OVERAGE_COPY,
  PLATFORM_OVERAGE_STANDALONE_MINIMUM,
  PLATFORM_PER_TEXT_LABEL,
  PLATFORM_PLAN_IDS,
  PLATFORM_TIERS,
  PLATFORM_TRIAL_DAYS,
  PLATFORM_USAGE_ORG_ID,
  POLICY_DOCUMENTS,
  POLICY_DOCUMENT_CONTENT_TYPE,
  POLICY_DOCUMENT_LABELS,
  POLICY_DOCUMENT_REJECTION,
  POLICY_DOCUMENT_TOO_LARGE,
  POLICY_URL_REJECTION,
  PORTAL_BLOCK_MESSAGE_MAX_LENGTH,
  PORTAL_OTHER_ID,
  PORTAL_SOMETHING_ELSE_ID,
  POSTHOG_ORGANIZATION_GROUP,
  POST_IMPORT_TIMEZONE,
  PRICING_STATE,
  PROPERTY_ASSESSMENT_METRICS,
  PROPERTY_ASSESSMENT_SERVICE_NAME,
  PROPERTY_ASSESSMENT_SERVICE_TEMPLATE_ID,
  PROPERTY_ONLY_COPY_FIELDS,
  PaymentMethodStatus,
  PaymentMethodType,
  PaymentStatus,
  PeriodHelpers,
  Permission,
  PermissionStatus,
  PhoneType,
  PhotoTag,
  PicklistCategory,
  PricingInputType,
  PricingMethod,
  ProvisioningStatus,
  PushNotificationType,
  QUESTION_SEVERITIES,
  RATE_REQUESTED_LIST_FILTER,
  RECIPE_SOURCES,
  REFUNDED_TO_CARD_LABEL,
  REQUESTED_START_LABEL,
  RESERVED_SLUGS,
  REVIEW_HOLD_TEXT,
  REVIEW_REASON_LABELS,
  RUTA_PRIVACY_URL,
  RUTA_TERMS_URL,
  RateRequestStatus,
  RateVisibility,
  RefundReason,
  RefundStatus,
  RefundType,
  RutaPayStatus,
  SEASONAL_LABEL,
  SERVICE_DISCOUNT_100_LABEL,
  SERVICE_TEMPLATE_PRICE_FIELDS,
  SERVICE_UNAVAILABLE_AT_ADDRESS_MESSAGE,
  SETUP_CHECKLIST_ITEM_KEYS,
  SETUP_MODAL_ITEMS,
  SETUP_TRACKS,
  SETUP_TRACK_IDS,
  SETUP_TRACK_STEP_IDS,
  SHOP_ADVISOR_AGENT_DISPLAY_NAMES,
  SHORT_CODE_ALPHABET,
  SHORT_CODE_LENGTH,
  SHORT_CODE_PLACEHOLDER,
  SIGNUP_LOGIN_CREATED,
  SIGNUP_SOURCES,
  SKIP_REASON_KEYS,
  SKIP_REASON_KEY_TO_PICKLIST_ID,
  SKIP_REASON_LABELS,
  SMS_CONSENT_DETAILS,
  SMS_CONSENT_DISCLOSURE,
  SMS_CONSENT_VERSION,
  SMS_PROGRAM_CONSENT_VERSION,
  SMS_SEGMENTS_PER_BILLED_TEXT,
  SMS_STOP_FOOTER,
  SNOW_PLAN_CUTOFF,
  SNOW_PLAN_TIMEZONE,
  SNOW_SEASON_END,
  STALE_LOCATION_THRESHOLD_MS,
  STARTER_AI_CREDIT_ALLOWANCE,
  STARTER_TEXTS_COUNTED_FROM,
  STATE_MAP,
  STREET_NUMBER_REQUIRED_MESSAGE,
  STREET_SUFFIX_MAP,
  SUBCONTRACTOR_LEAD_ASSIGNABLE_ROLE_IDS,
  SUBSCRIPTION_FREQUENCY,
  SUBSCRIPTION_IMPORTED_FIELD_NAMES,
  SUBSCRIPTION_PRICE_FIELDS,
  SUBSCRIPTION_STATE,
  SUPPORTED_ORG_TIMEZONES,
  ScheduleFrequency,
  ScheduleFulfillmentStatus,
  ScheduleType,
  ServiceAreaType,
  ServiceOptionRateType,
  ServiceRateStatus,
  ServiceTemplateHelpers,
  ServiceTemplateStatus,
  ServiceType,
  SharedSubscriptionEvent,
  SharedSubscriptionEvents,
  ShopAdvisorAgent,
  ShowLaborHoursSetting,
  SkipReasonKey,
  SmsConsentSource,
  SubcontractorPayType,
  SubscriptionAction,
  SubscriptionChangeTriggeredBy,
  SubscriptionChangeType,
  SubscriptionStatus,
  SubscriptionTier,
  TEMPLATE_ORIGINS,
  TIME_ENTRY_OFFLINE_ACTION_TYPES,
  TOKENS_PER_AI_CREDIT,
  TRAIL_GAP_METERS,
  TRAIL_GAP_MS,
  TRAIL_MAX_SPEED_MPS,
  TYPESENSE_CUSTOMERS_SCHEMA,
  TYPESENSE_SUBSCRIPTIONS_SCHEMA,
  TYPESENSE_VISITS_SCHEMA,
  TaxApiError,
  TimeBasedUnit,
  TimeEntryEventType,
  TransformationError,
  TranslatableEntityType,
  UNAVAILABLE_SERVICE_REASON_MAX_LENGTH,
  UNCATEGORIZED_SERVICE_CATEGORY,
  UNIT_TYPE_MAP,
  UNIT_WORDS,
  UNKNOWN_CITY_BUCKET,
  UNSENT_MESSAGE_PREVIEW,
  UnitType,
  UploadPurpose,
  UserRole,
  VISITS_IN_FILE_WORDS,
  VISIT_FLOW_VARIANTS,
  VISIT_PAYMENT_FACET_LABELS,
  VISIT_PAYMENT_FACET_ORDER,
  VISIT_PAYMENT_STATE_LABELS,
  VISIT_PRICE_FIELDS,
  VISIT_START_STARTED_AT_MAX_AGE_MS,
  VISIT_STATUS_ROLLUPS,
  VISIT_STATUS_ROLLUP_LABELS,
  VISIT_STATUS_TRANSITIONS,
  VISIT_TAP_SOURCES,
  VISIT_WORK_STATUSES,
  VISIT_WORK_STATUS_MEMBERS,
  VOIDED_PACKAGE_DEBIT_PREFIX,
  VisitApprovalStatus,
  VisitEventType,
  VisitPosition,
  VisitPricingService,
  VisitReviewReason,
  VisitReviewStatus,
  VisitSaveSchema,
  VisitStatus,
  VisitStatusRollup,
  VisitType,
  VolumePricingType,
  WORK_ZONE_CLUSTER_THRESHOLD_M,
  WS_ENTITY_TYPES,
  WS_MESSAGE_TYPES,
  WeatherDimension,
  accountReferenceFromDocument,
  activationFailureMessage,
  activeLimitedScheduleWithCapacity,
  activeOptions,
  activeRecurringSchedule,
  activeSchedules,
  activeVisitMinutes,
  addCalendarDays,
  addCardReminderIdempotencyKey,
  addCrewMemberToVisit,
  addressHasStreetNumber,
  advanceBoundaryCrossing,
  advanceMessagingRegistrationOnDetails,
  agentDraftFromDdbRecord,
  agentDraftToDdbRecord,
  agentRunLogExpiresAt,
  agentRunLogFromDdbRecord,
  agentRunLogToDdbRecord,
  aggregateMeasurementMetrics,
  aiConversationFromDdbRecord,
  aiConversationToDdbRecord,
  aiImportJobFromDdbRecord,
  aiImportJobToDdbRecord,
  aiModelTokenKey,
  allowsCustomerStartDate,
  alwaysPresentNotificationVariables,
  analyzeTodayRouteOrder,
  answerQuestion,
  appendRateRequestedListFilters,
  appendRouteRank,
  appendStopFooter,
  appliesAutoMessageCadence,
  appliesRoundUpToCents,
  appliesToAbsentMetric,
  applyAnswers,
  applyAssistantEvent,
  applyAutoMessageAddressing,
  applyCharmThenMoneyEnding,
  applyDiscount,
  applyDisplayRounding,
  applyMoneyEndingRound,
  applyPackageChargeInvoiceRefund,
  applyPackagePerVisitEdit,
  applyPeriodIdRemap,
  applyPeriodScheduleAssignment,
  applyPropertyFields,
  applyProposalPatches,
  applyShortUrls,
  areApplicableMetricsAbsent,
  askForCardAudienceFilter,
  askForPriorityNote,
  askForServiceOption,
  asksFor,
  asksWaitingOnOthers,
  assessmentCompletionInputFromVisit,
  assignRebalancedCrewRanks,
  assignRoutePosition,
  assistantBlockView,
  assistantGroundingFooter,
  assistantPhaseLabel,
  assistantReplyChrome,
  assistantTurnStatusLine,
  autoMessageCadence,
  autoMessageCadenceAppliesToRole,
  BaseColors as base,
  billedTextsFrom,
  billingMethodOf,
  boundingCircleRadiusM,
  budgetedVisitsForPricing,
  buildActivateSubscriptionBody,
  buildActivationSchedule,
  buildAddCardPaymentLink,
  buildBatchInvoice,
  buildCampaignEmail,
  buildCampaignTemplateData,
  buildCancelAllServicesBody,
  buildContactNames,
  buildCreateConversationRequest,
  buildCrewSortKey,
  buildCustomerSelectedOptionLabels,
  buildCustomerSelectedOptionStates,
  buildCustomerStatement,
  buildDeactivateRequestMessage,
  buildDeactivationFormData,
  buildFeedbackIssueDescription,
  buildFeedbackIssueTitle,
  buildImportCompletedMetrics,
  buildImportCompletedProperties,
  buildImportedSubscriptionSchedule,
  buildInvoiceFromLedgerEntry,
  buildLocationSegment,
  buildLockedServiceOptionUsage,
  buildMessagePreview,
  buildMnEservicesSalesTaxCsv,
  buildOneOffScheduleInput,
  buildPackageChargeInvoice,
  buildPaginatedResult,
  buildPauseRequestMessage,
  buildPaymentIssuesSearchParams,
  buildPaymentUrl,
  buildPendingRatesNote,
  buildPhotoToken,
  buildPlatformInvoiceLineItems,
  buildPlaybackPoints,
  buildPortalUrl,
  buildProcessorActivity,
  buildPropertyAssessmentVolumePricing,
  buildQuoteExcerpt,
  buildSeparateCustomerFromProperty,
  buildServiceOptionsInput,
  buildShortUrl,
  buildSingleServiceCancelBody,
  buildSmsConsentDisclosure,
  buildSmsConsentLabel,
  buildSuggestedActionSeed,
  buildTrailSegments,
  buildVisitRouteOrderMap,
  buildWorkMetricFilter,
  builtInPlatformPolicies,
  builtinAskForCardTemplate,
  bundleTotalFromMemberRates,
  businessNameWords,
  cachedDateTimeFormat,
  cadenceAnchorDate,
  cadenceCountFromDate,
  cadenceIntervalDays,
  calcBearing,
  calculateBundlePrice,
  calculateGsiUpdates,
  calculateHoursFromPrice,
  calculateMemberMinutes,
  calculateMidSeasonSignOn,
  calculatePaymentStatus,
  calculatePolygonAreaSqft,
  calculatePolygonCentroid,
  calculatePricing,
  calculateServiceOptionLineAmount,
  calculateSubcontractorPayoutForVisit,
  calculateSubscriptionRate,
  calculateSubscriptionRateFromEntities,
  calculateTotalServiceTime,
  calculateVisitPausedMs,
  calculateVisitPrice,
  calendarDateToUtcSeconds,
  calendarDateUtcBounds,
  campaignUsesBalance,
  canAssignRole,
  canConvertCustomerToContact,
  canOfferRateSendOnUnhide,
  cancellationBatchFromDdbRecord,
  cancellationBatchToDdbRecord,
  cancellationBatchesFromDdbRecords,
  canonicalizeSkipReason,
  canonicalizeSkipReasonKey,
  capitalizeFirst,
  capitalizedOnlyBusinessWords,
  capturedMetricFieldKeys,
  cardCostOfVolume,
  cardNet,
  carrierReviewPhase,
  catalogCompare,
  changeLine,
  changeValueWords,
  chargeMethodUsability,
  chargeWaitCancelUpdates,
  chargeWaitClearUpdates,
  chargeWaitStartUpdates,
  chargedAs,
  charmCentsFromRateRounding,
  chatConversationFromDdbRecord,
  chatConversationToDdbRecord,
  chatConversationsFromDdbRecords,
  chatMembershipFromDdbRecord,
  chatMembershipToDdbRecord,
  chatMembershipsFromDdbRecords,
  chatMessageAckFromDdbRecord,
  chatMessageAckToDdbRecord,
  chatMessageAcksFromDdbRecords,
  chatMessageFromDdbRecord,
  chatMessageToDdbRecord,
  chatMessagesFromDdbRecords,
  checkCrewNoteWithoutPhoto,
  checkCrewStartTimeSpread,
  checkServiceOptionThresholds,
  chicagoCalendarDate,
  cityFromVisitAddress,
  clampDueDay,
  clampGeofenceRadiusM,
  classifyImportSource,
  classifyPlatformCustomer,
  classifyVisitPauseSegments,
  cleanStatementDescription,
  clusterByDistance,
  collapseToWorkStatuses,
  collectEditableNotificationVariables,
  collectPendingSuggestedActions,
  collectRemovedPeriodIds,
  collectShortenableUrls,
  collectUnreadCustomerMessageIds,
  collectUrls,
  Colors as colors,
  ColorsDark as colorsDark,
  compareAddresses,
  compareByServiceTemplateOrder,
  compareCrewByNumber,
  compareQuestions,
  compareRanks,
  compareServiceCategories,
  compareVisitPhotosByCaptureTime,
  compareVisitsForRouteOrder,
  completeAllCrewMemberTimes,
  completeCrewMemberTime,
  computeChargeAfter,
  computeGpsTimeGaps,
  computeHasUnreviewedPhotos,
  computeImageryBbox,
  computeInsertionPlacement,
  computeInsertionRank,
  computeNextDueDate,
  computeOutwardNormal,
  computePlatformUsageSummary,
  computePlaybackRange,
  computePropertyGeofence,
  computeVisitRevenueSplit,
  computeWorkZones,
  configureShortLinkBaseUrl,
  conflictingMembersFromDetails,
  contactItemFromDdbRecord,
  contactItemToDdbRecord,
  contactItemsFromDdbRecords,
  contactPostalAddress,
  conversationSummariesFromDdbRecords,
  conversationSummaryFromDdbRecord,
  conversationSummaryToDdbRecord,
  convertScheduleCadence,
  countActiveSubscriptions,
  countByWorkStatus,
  countFirstWeekVisibleHits,
  countInactiveSubscriptions,
  countMovedStops,
  countSmsTexts,
  countUnreviewedPhotos,
  countVisitsByStatus,
  countVisitsInNextDays,
  createVisit,
  crewClusterCountLabel,
  crewClusterFanOffsets,
  crewClusterFanSpokes,
  crewClusterRingRadius,
  crewClusterRingSlices,
  crewClusterSpokeBar,
  crewFromDdbRecord,
  crewMemberColor,
  crewMemberColorIndex,
  crewMemberInitials,
  crewPuckAgeLabel,
  crewPuckConePath,
  crewPuckHexRgba,
  crewPuckStatusLabel,
  crewPuckTeardropRotate,
  crewPuckUsableAvatarUrl,
  crewRanksNeedRebalance,
  crewToDdbRecord,
  crewVisitFlowVariant,
  crewsFromDdbRecords,
  currentDispatchWindow,
  currentPackageInvoiceTotal,
  currentServicePeriods,
  customAmountPatches,
  customAmountProblem,
  customDeactivationReasonLabel,
  customVariant,
  customerAccountFromDdbRecord,
  customerAccountMemberRecord,
  customerAccountMembershipFromDdbRecord,
  customerAccountMembershipRecord,
  customerAccountReference,
  customerAccountToDdbRecord,
  customerAccountTypeLabel,
  customerEmailFromDdbRecord,
  customerEmailToDdbRecord,
  customerEmailsFromDdbRecords,
  customerFromDdbRecord,
  customerHasOpenChargeWait,
  customerInvoiceTotalsHidden,
  customerLineItemDescription,
  customerSelectedOptionStateToken,
  customerToDdbRecord,
  customerToTypesenseDocument,
  customersFromDdbRecords,
  customersShareProperty,
  dailyCollectedSummaryIdempotencyKey,
  dailyCollectedTotalsFromAggregate,
  ddbRecordToOperatorAudit,
  ddbRecordToOperatorNote,
  ddbRecordToOperatorSuccessOwner,
  ddbRecordToOperatorTask,
  ddbRecordToPlatformInvoice,
  deactivationReasonsFromPicklist,
  decideLocationEstimate,
  decodeCursor,
  decomposePolygonEdges,
  defaultTemplateReplacer,
  degreesToFeet,
  derivePaymentMethodHealth,
  derivePaymentMethodHealthFromFlags,
  deriveRateLifecycle,
  deriveRequestState,
  deriveUniqueServiceTemplateSlug,
  describeChargeFailure,
  describePackageChargeDates,
  describePlanChangeMoney,
  describeRouteOrderChange,
  diffCollectionFields,
  dispatchBatchFromDdbRecord,
  dispatchBatchToDdbRecord,
  dispatchBatchesFromDdbRecords,
  dispatchJobCoversTemplate,
  dispatchJobFromDdbRecord,
  dispatchJobInProgressCount,
  dispatchJobToDdbRecord,
  dispatchJobsFromDdbRecords,
  displayIntlLocale,
  disposalPileFromDdbRecord,
  disposalPileToDdbRecord,
  disposalPilesFromDdbRecords,
  distanceOutsideVisitGeofenceM,
  doesOfflineActionDependOn,
  dueDateForPeriodEnd,
  effectiveWindowsOverlap,
  emailReplyLink,
  emptyAssistantTurn,
  encodeCursor,
  endOfDayInTimezone,
  endsWithAutoMessageSignOff,
  enrolledServicePeriods,
  ensureUrlScheme,
  entityPath,
  enumerateAutoDispatchDates,
  escapeHtml,
  escapeSlackText,
  estimateAnnualSubscriptionRevenue,
  estimateNotStartedVisitValue,
  estimateServiceValue,
  estimateSubscriptionValue,
  evaluatePackageSubscriptionCharge,
  exactHoursFromPerVisit,
  exceedsGpsTimeGapThreshold,
  expandAttachmentTokens,
  expandWorkStatuses,
  extraVisitFields,
  extraVisitPriceFits,
  extraVisitPriceProblem,
  extractCity,
  extractCityBucket,
  extractLocalDate,
  extractMustacheVariableNames,
  extractPackageInvoiceId,
  extractPaginationParams,
  fallbackDeactivationReasons,
  fallbackPortalReasons,
  feedbackNoun,
  feedbackReceivedCopy,
  feedbackResolvedBody,
  feedbackResolvedTitle,
  feetToDegrees,
  fetchAudienceCustomers,
  fetchImageryAsBase64,
  fieldChanged,
  filedFeedbackFromToolData,
  fillDeactivationAliases,
  fillServiceCancelledDates,
  filterActiveSubscriptions,
  filterFlatServiceOptions,
  filterInactiveSubscriptions,
  filterNamesAnAudience,
  findFirstUnreadChatMessageId,
  findFirstUnreadIndex,
  findGhostPeriodIds,
  findHolidaysToWarnAbout,
  findPackageForTemplate,
  findPortalBlockedAt,
  findRankTies,
  findReusableConversation,
  findScheduleById,
  findScheduleIndex,
  finishAssistantTurnOnStreamClose,
  firstPlanPickPatch,
  firstRunForksFromState,
  flattenServiceOptions,
  fnv1a32,
  foldPunctuationToAscii,
  followUpNotifiesCustomer,
  formatAcceptedRateChoices,
  formatAddressForDisplay,
  formatAddressToString,
  formatCadenceLabel,
  formatCalendarDateShort,
  formatCampaignAudience,
  formatCustomInterval,
  formatCustomerRatePricingLine,
  formatCustomerScheduleCadence,
  formatDisplayDate,
  formatDuration,
  formatDurationWords,
  formatFullName,
  formatHolidayDate,
  formatHours,
  formatIncludedQuantityNote,
  formatInvoiceSignedAmount,
  formatIsoDate,
  formatLaborCrewSize,
  formatLineItemQuantity,
  formatLocalAddress,
  formatMerchantContractRates,
  formatMnFilingPeriodEnd,
  formatOwnerName,
  formatPackageMonthDay,
  formatPackageVisitAllowance,
  formatPaymentFeeRateReminder,
  formatPhoneDisplay,
  formatPhoneE164,
  formatQuotedOutboundText,
  formatRateRounding,
  formatRoundDollars,
  formatScheduleCadence,
  formatSeasonMonthRange,
  formatServiceNameList,
  formatSkipReasonDisplay,
  formatStoredCampaignAudience,
  formatTaxFilingPeriodLabel,
  formatTaxId,
  formatTemplateCadence,
  formatTimeForDisplay,
  formatUnifiedRoundUp,
  formatUsd,
  formatValidationErrors,
  formatVisitCount,
  formatVisitDualStatusLabel,
  formatVisitTimeWithZone,
  formatWholeDollars,
  generateAerialImageryUrls,
  generateCompositeStateKey,
  generateOtpCode,
  generateRankBetween,
  generateShortCode,
  generateSlug,
  generateUniqueSlug,
  geoapifyRoutePlannerCredits,
  geoapifyRoutingCredits,
  geoapifySimpleRequestCredits,
  getActiveTemporaryNotes,
  getAdminBranding,
  getAdminPreferenceKeyForType,
  getAdminSmsCapableKeys,
  getBellFilterGroupsForRole,
  getBestMngeoLayer,
  getCSSVariable,
  getCardExpiryState,
  getChicagoYmd,
  getColor,
  getColorForTheme,
  getContactPersonName,
  getCustomerBranding,
  getCustomerDisplayAddress,
  getCustomerDisplayName,
  getCustomerPaymentStatusLabel,
  getCustomerVisitDualStatusDisplay,
  getCustomerVisitPaymentStatusDisplay,
  getCustomerVisitStatusDisplay,
  getDateInTimezone,
  getDeviceIdentifier,
  getEffectiveNotificationSettings,
  getEffectiveSeasonPrice,
  getEligibleCrews,
  getFixedMonthlySaasCosts,
  getHourInTimezone,
  getISOWeekEnd,
  getISOWeekNumber,
  getISOWeekStart,
  getISOWeekString,
  getISOWeekYear,
  getInvoicePaymentPresentation,
  getLocalDateFromISO,
  getLocalISOString,
  getMemberDisplayName,
  getMessagingInfraMonthlyFixedCost,
  getMidSeasonEligibility,
  getNextState,
  getNotificationConfig,
  getNotificationTypeLabel,
  getNotificationVariableLabel,
  getNotificationsByCategory,
  getNotificationsByRole,
  getOrgMessagingName,
  getOrganizationMemberDisplayName,
  getPackagePlanEditMode,
  getPackageSeasonDates,
  getPlatformTier,
  getPortalBlockMessage,
  getPreferenceCategoryForNotificationType,
  getSafeDisplayAmount,
  getScheduleVisitsPerYear,
  getSchedules,
  getServiceActivationRequirements,
  getServiceDisplayName,
  getSharedNonEmptyValue,
  getShortLinkBaseUrl,
  getSmsStats,
  getSnowPlanLockReason,
  getSubscriptionDescription,
  getSubscriptionVisitsPerYear,
  getTemplate,
  getTemplateVisitsPerYear,
  getTemplateWithOverride,
  getTodayLocalDateString,
  getTypesenseCollectionName,
  getUnansweredRequiredServiceOptions,
  getUnavailableAtAddressReason,
  getUnavailableServiceAtAddress,
  getUserDisplayName,
  getValidEvents,
  getViewerTimezone,
  getVisitCompletionDate,
  getVisitDisplayDate,
  getVisitDualStatusDisplay,
  getVisitPaymentFacetDisplay,
  getVisitPaymentStatusDisplay,
  getVisitRevertCopy,
  getVisitStatusDisplay,
  getVisitSubscriptionId,
  getVisitTerminalTimestamp,
  getVisitWorkStatusDisplay,
  getWeekDateRange,
  gpsFinishGapLine,
  gpsGapRowLine,
  gpsStartGapLine,
  groundingLabel,
  groupAdminPreferenceTypeRows,
  groupByPackage,
  groupCrewPucksAtZoom,
  groupCrewPucksByPixel,
  groupServiceItemsByCategory,
  handleNotificationEmailLink,
  hasAnyMetricValue,
  hasApproximateLineQuantity,
  hasCompleteForks,
  hasLimitedSchedule,
  hasListableServiceRate,
  hasNewRateSinceHide,
  hasOemAppSleepLayer,
  hasOpenSchedule,
  hasPricedRate,
  hasRecurringSchedule,
  hasTermsContentChanged,
  hasUnicode,
  haversineDistance,
  hoursWords,
  htmlToPlainText,
  hundredthsInSameMinute,
  importLayoutFamilyFromDdbRecord,
  importLayoutFamilyToDdbRecord,
  importLayoutRecipeFromDdbRecord,
  importLayoutRecipeToCurrentRecord,
  importLayoutRecipeToRevisionRecord,
  inclusiveCalendarDays,
  incrementedVisitReviewRequirements,
  inferChargedPackagePlan,
  inferPricingMethod,
  inheritedPeriodIds,
  inheritedSubscriptionTermsAcceptedAt,
  initializeCrewMemberTimes,
  insightsApiRoute,
  instantFallsOnLocalDate,
  integrationTokenKey,
  interpolateAt,
  invoiceChargeLineItems,
  invoiceDetailPath,
  invoiceDiscountRow,
  invoiceFromDdbRecord,
  invoiceModalParams,
  invoiceMoneyCell,
  invoicePaymentSection,
  invoiceToDdbRecord,
  invoicesFromDdbRecords,
  isAchPaymentsEnabled,
  isActivationOptionAnswered,
  isActiveMember,
  isActiveOutsideBundle,
  isActiveService,
  isActiveServiceWithoutDispatchCadence,
  isAddressLikeSearchQuery,
  isAdminChannelCapable,
  isAdminEmailCapable,
  isAdminNotificationPreferenceKey,
  isAdminSmsCapable,
  isAdminTypeChannelCapable,
  isAlreadyOnActiveVisitConflict,
  isAmountMissing,
  isAmountZeroOrMissing,
  isAppVersionBelow,
  isAssessmentInProgress,
  isAssistantDockActionBlock,
  isAutoPauseForOverdueEnabled,
  isAwaitingCustomerAction,
  isBellFilterGroupHidden,
  isBellFilterOfficeRole,
  isBillableService,
  isBookEngineProposal,
  isBuiltinMessageTemplateId,
  isBusinessName,
  isCalendarDate,
  isCatalogPlatformFee,
  isChargeWaitCancelled,
  isChargeWaitDue,
  isChargeWaitMinutes,
  isChicagoDateInNextDays,
  isClientReportableIntegrationId,
  isConvertToContactRole,
  isCountedByWorkMetric,
  isCustomerDeactivated,
  isCustomerSelectableFlatOption,
  isCustomerVisibleVisitPhoto,
  isDeactivationReasonsValid,
  isDispatchJobActive,
  isEligibleForPlatformTrial,
  isEssentialNotificationType,
  isExcludedInvoiceLine,
  isFabricatedDefaultListRate,
  isFeedbackIssueIdentifier,
  isFirstChargeAfterPlatformTrial,
  isFirstVisitAutoPricingEnabled,
  isFirstVisitOnSubscription,
  isFollowUpVisit,
  isGpsTimeMismatch,
  isGpsTimeMismatchVisit,
  isGrounded,
  isHardVisitCompleteRefusal,
  isHiddenInAppType,
  isIdempotentTimeEntryRefusal,
  isInactiveService,
  isInternalEmail,
  isInvoiceRefundDisplayLine,
  isLaborLineItem,
  isLedgerRefundType,
  isLegacyPlatformFee,
  isLiveEnrollmentSchedule,
  isLockedAfterPlatformTrial,
  isMissingPaymentMethodMessage,
  isMmsSupportedImage,
  isMoneyQuestion,
  isMultiChoiceOption,
  isNamedOverageLine,
  isNextVisitCleared,
  isNoChargeAmount,
  isNoChargeVisit,
  isOfficeChargePending,
  isOfficeInstructionPhoto,
  isOfficeServiceOptionEditStatus,
  isOfficeStaffRoleId,
  isOfflineActionBlockedByEarlier,
  isOnBundle,
  isOnDemandFrequency,
  isOnOrAfterSnowPlanCutoff,
  isOnPlatformTrial,
  isOneOffScheduleInSeason,
  isOneOffSubscription,
  isOneProductSeason,
  isOneTimeWindowSchedule,
  isOpenPackagePaymentIssue,
  isOpenSchedule,
  isOpenVisitEarlierThanCadenceInterval,
  isOrgDueForDailyCollectedSummary,
  isOutsideVisitGeofence,
  isPackageChargedForSeason,
  isPackagePaymentLedgerEntry,
  isPackageRefundLedgerEntry,
  isPausedService,
  isPaymentMethodRequired,
  isPaymentNotificationType,
  isPendingPlanChangeRequest,
  isPendingRateRequest,
  isPendingService,
  isPendingStartStatus,
  isPeriodCatchUpCadence,
  isPeriodPaid,
  isPhotoEligibleForAutoShare,
  isPhotoRequiredForVisit,
  isPhotoTag,
  isPhotoUnreviewed,
  isPlainCopy,
  isPortalBlocked,
  isPortalCustomReasonId,
  isPortalPauseRequestEnabled,
  isProofOfServiceVisit,
  isPropertyAssessmentTemplateId,
  isPropertyAssessmentVisit,
  isQuotableMessage,
  isQuoteStillVisible,
  isRateInvisible,
  isRateReadyForCustomer,
  isRateRequestSnoozeActive,
  isRateVisible,
  isRawPackageChargeLedgerDescription,
  isRecurringFrequency,
  isRefundCreditLine,
  isReservedSlug,
  isRetiredForActiveSubscribers,
  isReviewRequiredForVisit,
  isReviewablePhoto,
  isSameVisitAlreadyActiveConflict,
  isScheduleActive,
  isScheduleTypeAllowed,
  isServiceTemplateActivatable,
  isServiceUnavailableAtAddress,
  isSetupModalItemVisible,
  isShortLinkEnabled,
  isSignupSource,
  isSnowSeasonPackage,
  isStaleStateErrorCode,
  isStaleVisitStartStartedAt,
  isStoredPackageInvoice,
  isSubscriptionPackageUnlimited,
  isSubscriptionRouteStop,
  isSubscriptionVisitReviewRequired,
  isSurnameFirst,
  isTemplateOfferableForProperty,
  isTemporaryNoteActive,
  isTemporaryNoteActiveForVisit,
  isTerminalVisitStatus,
  isTimeEntryOfflineActionType,
  isUnbilledProcessingErrorVisit,
  isUnitBasedMetricSet,
  isUnreadCountStaleAfterRead,
  isValidAddressString,
  isValidCustomAmount,
  isValidEmail,
  isValidEmailSignInCode,
  isValidOtpCode,
  isValidPhone,
  isValidPhoneNumber,
  isValidPhoneType,
  isValidPolicyUrl,
  isValidRank,
  isValidRateRounding,
  isValidServiceTemplateSlug,
  isValidShortCode,
  isValidSlug,
  isValidTaxId,
  isVisitInShareableState,
  isVisitInsideChargeWait,
  isVisitScheduledAfter,
  isWaitingForReprice,
  isWithinDispatchWindow,
  isWithinQuietHours,
  isWorkMetricKey,
  isWorthShortening,
  joinDisplayParts,
  joinWords,
  keyAmount,
  kindKeyOfVariant,
  knownToolActivityNames,
  labelTodayRouteStop,
  lastSeasonPackage,
  latestReadyPeriod,
  ledgerActivityDescription,
  ledgerActivityKind,
  ledgerDisplaySignedAmount,
  ledgerEntriesFromDdbRecords,
  ledgerEntryFromDdbRecord,
  ledgerEntryToDdbRecord,
  leftOutLabel,
  leftOutTotals,
  legacyAddressMatchKeys,
  limitedScheduleCoversPeriod,
  linearStateIsTerminal,
  linkifyMessageText,
  listAdminPreferenceTypeRows,
  listCustomerSelectableFlatOptions,
  listIntegrationCosts,
  listPerVisitAmount,
  listServiceNotesForDate,
  listTaxFilingPeriods,
  listUnicodeChars,
  lngLatToWorldPx,
  localDateTimeToUtc,
  localizeCadenceLabel,
  localizeCrewDisplayName,
  localizeDateOnlyFields,
  localizeGeneratedMonthLabel,
  localizeTypeLabel,
  localizeVisitScheduleDisplay,
  locationFromDdbRecord,
  locationSegmentStartTs,
  locationSegmentToPoints,
  locationSegmentWindowStart,
  locationToDdbRecord,
  locationsFromDdbRecords,
  longestIncreasingSubsequenceLength,
  looksLikeRawTechnicalError,
  lowerFirst,
  mapJustifiPaymentErrorMessage,
  markAsked,
  maskHasPermission,
  maskTaxId,
  maskToPermissions,
  matchJustifiDeclineReason,
  maxGpsGapMinutes,
  maxOpenVisitsForAutoDispatch,
  memberCrewIdsOf,
  memberIsCurrentlyOnVisit,
  memberShouldTrackVisit,
  memberWasOnVisitAt,
  merchantContractRatesFromOrg,
  mergeBellExcludeTypes,
  mergeBusinessLegalDetails,
  mergeFirstRunState,
  mergeLocationSegment,
  mergeServiceOptionChoices,
  mergeTemporaryNoteEdits,
  mergeTodayRanks,
  mergeVisitPauseSegments,
  messageCampaignFromDdbRecord,
  messageCampaignScheduleFromDdbRecord,
  messageCampaignScheduleToDdbRecord,
  messageCampaignToDdbRecord,
  messageCampaignsFromDdbRecords,
  messageContentToHtml,
  messageContentToSmsText,
  messageDeliveriesFromDdbRecords,
  messageDeliveryFromDdbRecord,
  messageDeliveryToDdbRecord,
  messageFromDdbRecord,
  messageTemplateFromDdbRecord,
  messageTemplateToDdbRecord,
  messageTemplatesFromDdbRecords,
  messageToDdbRecord,
  messagesFromDdbRecords,
  metroParcelFromDdbRecord,
  metroParcelToCustomerParcelData,
  metroParcelToDdbRecord,
  metroParcelsFromDdbRecords,
  minimumChargeCoverageHours,
  minimumLineSubLabel,
  minutesBetween,
  mmsPreviewNotice,
  mnEservicesAmountsFromRevenue,
  monthAbbr,
  monthName,
  namesFromPackageInvoiceLine,
  nearestNeighborOrder,
  needsCustomerAnswers,
  needsRebalancing,
  nestBundleInvoiceLines,
  newlyUnavailableTemplateIds,
  nextAutoDispatchDate,
  nextBusinessDay,
  nextPackageState,
  nextSeasonRestartYmd,
  nonPayingLabel,
  normalizeAddress,
  normalizeAddressString,
  normalizeBillingMethod,
  normalizeCity2 as normalizeCity,
  normalizeExifCapture,
  normalizeLast4,
  normalizeMnLocationNumber,
  normalizeMoneyEnding,
  normalizePhone,
  normalizePhoneSearchQuery,
  normalizePhotoTags,
  normalizePlatformPlanId,
  normalizeQuotableText,
  normalizeRateRounding,
  normalizeRcsRegistrationStatus,
  normalizeRcsStatus,
  normalizeRcsUpgradeKind,
  normalizeState,
  normalizeStreet,
  normalizeStreetName,
  normalizeStreetNumber2 as normalizeStreetNumber,
  normalizeTaxId,
  normalizeTermsHtml,
  normalizeWeatherSensitivity,
  normalizeZip,
  normalizedFacet,
  normalizedIndex,
  normalizedSort,
  noteHasContent,
  noteReadFromDdbRecord,
  noteReadToDdbRecord,
  noteReadsFromDdbRecords,
  notificationFromDdbRecord,
  notificationTemplateOverrideFromDdbRecord,
  notificationTemplateOverrideToDdbRecord,
  notificationTemplateOverridesFromDdbRecords,
  notificationToDdbRecord,
  notificationsFromDdbRecords,
  openPackageInvoiceOnDeactivate,
  operatorAuditToDdbRecord,
  operatorNoteToDdbRecord,
  operatorSuccessOwnerToDdbRecord,
  operatorTaskToDdbRecord,
  optionRate,
  orgHasAnsweredImportForks,
  orgShowsPayments,
  orgShowsSubcontractorPay,
  orgShowsTeam,
  organizationFromDdbRecord,
  organizationMemberFromDdbRecord,
  organizationMemberToDdbRecord,
  organizationMembersFromDdbRecords,
  organizationToDdbRecord,
  otpFromDdbRecord,
  otpToDdbRecord,
  otpsFromDdbRecords,
  outboundMessagingFromDailyUsage,
  overageMayInvoiceStandalone,
  overlayLiveServiceOptionChoices,
  packageChargeActivityDescription,
  packageChargeCollectionLabel,
  packageChargeInvoiceId,
  packageChargeInvoiceNumber,
  packageChargeLedgerDescription,
  packageChargeLineDescription,
  packageChargePlanStamp,
  packageChargeRefundable,
  packageChargeSeasonBounds,
  packageChargeSeasonFromStamp,
  packageChargeSeasonKey,
  packageChargeStableMetadataDate,
  packageOptionDisplayName,
  packageOptionPatch,
  packageOptionRows,
  packagePaymentProcessingFee,
  packagePaymentRevenueAmount,
  packagePerVisitFormulaLabel,
  packagePerVisitInputValue,
  packagePricingSaveFromPerVisit,
  packageTemplateMapsFromSubscriptions,
  packageVisitsForPricing,
  BaseColors as palette,
  parcelMeasurementFromDdbRecord,
  parcelMeasurementToDdbRecord,
  parcelMeasurementsFromDdbRecords,
  parseAiModelTokenKey,
  parseAssistantInlineSegments,
  parseCustomerSelectedOptionStateToken,
  parseEntityPath,
  parseExcludeTypesParam,
  parseFullName,
  parseGeocodedAddress,
  parseISOWeekString,
  parseIsoDate,
  parseJustifiTokenizeResult,
  parseLocalCalendarDate,
  parseMessageImageDrag,
  parseOwnerName,
  parseRate,
  parseSam3Response,
  parseSubscriptionKey,
  parseUnavailableServices,
  parseVisitSubscriptionId,
  partitionMmsAttachments,
  pauseCrewMemberTime,
  paymentIssuesTileCount,
  paymentMethodFromDdbRecord,
  paymentMethodHealthCardFromStored,
  paymentMethodToDdbRecord,
  paymentMethodsFromDdbRecords,
  paymentPlanFromDdbRecord,
  paymentPlanToDdbRecord,
  paymentPlansFromDdbRecords,
  paymentReminderPeriod,
  percentOfFullRateOn,
  periodBounds,
  permissionsToMask,
  photoPurgePointerFromDdbRecord,
  photoPurgePointerToDdbRecord,
  photoPurgePointersFromDdbRecords,
  photoTagLabel,
  pickCapturedMetrics,
  pickDispatchSchedule,
  pickDueOneTimeWindowSchedule,
  pickExampleBefore,
  pickMostRecentlyStartedVisit,
  picklistItemFromDdbRecord,
  picklistItemToDdbRecord,
  picklistItemsFromDdbRecords,
  pixelPolygonToGeo,
  pixelToGeo,
  planName,
  planPackageCharges,
  planWithOrgAiAllowance,
  platformDealName,
  platformInvoiceToDdbRecord,
  platformTrialDaysLeft,
  platformTrialEndsAt,
  platformTrialPeriod,
  plural,
  pointInPolygon,
  pointToSegmentClosest,
  pointToSegmentDistanceFt,
  policyDocumentStorageKey,
  polygonCentroidInBoundary,
  portalLoginFromDdbRecord,
  portalLoginToDdbRecord,
  portalLoginsFromDdbRecords,
  portalReasonsFromPicklist,
  positive,
  prependRouteRank,
  presentPlatformInvoice,
  presentStoredInvoiceForList,
  presentStoredInvoiceForView,
  presentStoredInvoiceLineItems,
  preserveAuthoredLineBreaks,
  previewShortenedText,
  previousTermsStampToRetain,
  priceReadingOf,
  pricedMetricFieldKeys,
  pricesOffMetrics,
  priorActivationPeriodIds,
  priorityReminderFromDdbRecord,
  priorityReminderToDdbRecord,
  priorityRemindersFromDdbRecords,
  projectCustomerVisibleVisitPhotos,
  projectSmsCampaign,
  projectSubscriptionRevenue,
  prunableTemplateIds,
  pruneUnusedTemplates,
  pruneWeatherLimits,
  questionTemplateIds,
  quoteExcerptCore,
  quoteMidSeasonSignOn,
  quotePlanChange,
  quotedAmountsFromMemberRates,
  rankAsks,
  rankCrewsByNearbyCustomers,
  rankCrewsForService,
  rateAgreesWithInputs,
  rateBatchFromDdbRecord,
  rateBatchToDdbRecord,
  rateBatchesFromDdbRecords,
  rateBreakdown,
  rateForInputs,
  rateHideReviewFields,
  ratePerRealMsForDuration,
  rateRequestFromDdbRecord,
  rateRequestListAgeAt,
  rateRequestToDdbRecord,
  rateRequestsFromDdbRecords,
  rateRoundingAppliesToPerVisit,
  rateRoundingAppliesToSeason,
  raySegmentIntersection,
  rebalanceRanks,
  recurringPeriodRestriction,
  referencedPeriodIds,
  remainingCycleFraction,
  remainingSubscriptionVisitReviews,
  removeCrewMemberFromVisit,
  removeUnitDesignation,
  renderAttachmentsText,
  renderBaseLayout,
  renderCampaignTemplate,
  renderCustomerEmail,
  renderSmsWithAction,
  renderTemplate,
  replaceHiddenAtRateRequestedFilter,
  replayInputWithPreviewToken,
  replayRequestBody,
  replayTargetKey,
  repricePackageChargeInvoice,
  repricesFromMetrics,
  requiresPaymentMethod,
  requiresRateConfiguration,
  resolveAcceptedSeasonChoices,
  resolveActionCompletionMessage,
  resolveActionCrewMessagePreview,
  resolveActiveVisit,
  resolveAdminChannelSettings,
  resolveAdminSettingsForType,
  resolveAutoSharePhotos,
  resolveBatteryRestrictionPrompt,
  resolveCadenceLabel,
  resolveCadenceLabelOrDefault,
  resolveCampaignAudienceWith,
  resolveChargeWaitMinutes,
  resolveCrewPeriodDisplay,
  resolveCrewPuckKind,
  resolveCrewPuckPaint,
  resolveCustomerCadenceLabel,
  resolveCustomerCity,
  resolveCustomerLabel,
  resolveDeactivationBanner,
  resolveDeactivationReasons,
  resolveDispatchCadence,
  resolveEffectiveBuiltInHours,
  resolveEffectiveMinimumCharge,
  resolveEffectiveReviewCadence,
  resolveEffectiveServiceTemplate,
  resolveInitialChatTab,
  resolveJustifiTokenizeError,
  resolveListBillingMethod,
  resolveListPricingMethod,
  resolveLocationGateAction,
  resolveNotifyCustomerOnReview,
  resolveOptionRates,
  resolveOrgTimezone,
  resolvePackageChargeAmount,
  resolvePackageChargeCustomerName,
  resolvePackageChargeListRate,
  resolvePackageOption,
  resolvePackageRefundTemplateIdFromMaps,
  resolvePackageTemplateIdFromMaps,
  resolvePairedTemplateIds,
  resolvePeriodIdsForSchedule,
  resolvePhotoCaptureTime,
  resolvePlatformBillingPlan,
  resolvePlatformPolicies,
  resolvePortalReasonLabel,
  resolveRealServiceName,
  resolveReferralSourceDisplay,
  resolveRouteOrder,
  resolveServiceItemCategory,
  resolveServiceNoteForDate,
  resolveServiceOptionThreshold,
  resolveSetupTracks,
  resolveShowLaborHoursOnInvoice,
  resolveSkipReasonLabel,
  resolveTemplateCustomerVisibility,
  resolveTemplateLinkData,
  resolveUnitBasedMetrics,
  resolveVisitPaymentFacet,
  resolveVisitPaymentState,
  resolveVisitScheduleDisplay,
  resolveWorkListScope,
  restoreDiscountedLineAmounts,
  resumeAllCrewMemberTimes,
  resumeCrewMemberTime,
  retryChargeableAfterPackageReprice,
  revenueReportPathForDay,
  reviewReasonLabel,
  reviewReasonLabelFromExceptions,
  roleFromDdbRecord,
  roleToDdbRecord,
  rolesFromDdbRecords,
  rollupSubscriptionStatus,
  rollupToStatuses,
  round22 as round2,
  roundCurrency,
  roundDownToMoneyEnding,
  roundHoursToHundredths,
  roundMnWholeDollars,
  roundMoneyToCents,
  roundNearestToMoneyEnding,
  roundToCentsEnding,
  roundToMoneyEnding,
  roundUpToMoneyEnding,
  runSam3Inference,
  rutaPayPriceGap,
  safeTransform,
  safeTransformArray,
  salesSections,
  sanitizeAppVersion,
  sanitizeHiddenInAppTypes,
  sanitizeSignupAttribution,
  sanitizeSignupDraftFields,
  scheduledStopOf,
  seasonExtraPayments,
  seasonFromPackageInvoiceId,
  seasonKey,
  seasonOrdinal,
  seasonPackageChargeToRefund,
  seasonRefundOnDeactivate,
  seasonStoredRateFromPerVisit,
  seedPackageCalculatorEdit,
  segmentImage,
  selectAutoSharePhotoUpdates,
  selectChatMessageDisplayText,
  selectCrewChannelMembers,
  selectCustomerVisibleVisitPhotos,
  selectInboundReplyCustomerId,
  selectLatestVisitRuling,
  selectPromptCrossing,
  serializeExcludeTypesParam,
  serializeMessageImageDrag,
  serviceAreaFromDdbRecord,
  serviceAreaToDdbRecord,
  serviceAreasFromDdbRecords,
  serviceBundleFromDdbRecord,
  serviceBundleToDdbRecord,
  serviceBundlesFromDdbRecords,
  serviceDetailPeriodLabels,
  serviceOptionSignature,
  serviceTemplateFromDdbRecord,
  serviceTemplateToDdbRecord,
  serviceTemplatesFromDdbRecords,
  setupCardDone,
  setupTrackMinutesLeft,
  setupTracksComplete,
  shopAdvisorAgentDisplayName,
  shopAdvisorDraftActionLink,
  shortUrlLength,
  shouldAcceptAsOneTimeSchedule,
  shouldApplyFirstVisitAutoPricing,
  shouldDimRouteCards,
  shouldDiscardResetVisitCompleteAction,
  shouldDiscardSatisfiedTimeEntryAction,
  shouldDiscardSatisfiedVisitCompleteAction,
  shouldDiscardSatisfiedVisitServiceOptionsAction,
  shouldDiscardSatisfiedVisitStartAction,
  shouldDiscardStaleOfflineAction,
  shouldFlagForReview,
  shouldKeepPendingOfflineAction,
  shouldSeedActivePeriod,
  shouldSendCustomerNotification,
  shouldSendDailyCollectedSummary,
  shouldShowClockInHero,
  shouldShowLoadErrorWall,
  shouldShowScheduledDeactivation,
  shouldSkipRefreshDuringCooldown,
  showsAsOneBundle,
  signupAttributionSource,
  signupDraftFromDdbRecord,
  signupDraftToDdbRecord,
  signupSourceLabel,
  simplifyPolygon,
  simplifyRing,
  singleRemainingPeriodId,
  slugifyServiceName,
  smoothTrailKalmanTimed,
  smsConsentEvidenceFields,
  solveExactHours,
  solveInputsForRate,
  sortCrewsByNumber,
  sortVisitPhotosByCaptureTime,
  sortVisitsForRoute,
  sortedTiers,
  stampOfficeStaffPhotosReviewed,
  startOfDayInTimezone,
  starterTextsCountFrom,
  storedInvoiceDiscountAmount,
  storedInvoiceDiscountInfo,
  storedInvoiceRefundMetadata,
  stripCustomerPrices,
  stripHiddenCustomerInvoiceTotals,
  stripHtmlTags,
  stripReasonSuffix,
  stripServiceTemplatePrices,
  stripSubscriptionPrices,
  stripVisitPrices,
  subcontractorCompaniesFromDdbRecords,
  subcontractorCompanyFromDdbRecord,
  subcontractorCompanyToDdbRecord,
  subcontractorDayPaymentFromDdbRecord,
  subcontractorDayPaymentToDdbRecord,
  subcontractorDayPaymentsFromDdbRecords,
  subscriptionAtKey,
  subscriptionFromDdbRecord,
  subscriptionIdFromPackageInvoiceId,
  subscriptionKey,
  subscriptionReferencesAnyPeriod,
  subscriptionToCustomerPortalView,
  subscriptionToDdbRecord,
  subscriptionToTypesenseDocument,
  subscriptionVisitReviewException,
  subscriptionsFromDdbRecords,
  suggestBlhFromPerVisit,
  suggestPerVisit,
  suggestSeason,
  suggestSlug,
  sumAiTokenKind,
  sumAiTokens,
  summarizeChargeFailures,
  summarizeDailySales,
  summarizeServiceOptionFlags,
  summarizeServiceOptionSettings,
  summarizeSmsReachability,
  synthesizeServiceTemplateFromSubscription,
  taxFilingSettingsWritePayload,
  taxRatePercentToHundredths,
  tenantLocalDate,
  tenantLocalDayWindow,
  termsAcceptanceFromDdbRecord,
  termsAcceptanceTimelineEvents,
  termsAcceptanceToDdbRecord,
  termsAcceptancesFromDdbRecords,
  textContainsPackageInvoiceId,
  textsCountFrom,
  textsPrepaidThrough,
  Colors as theme,
  ColorsDark as themeDark,
  thinTrailByMinSpacing,
  timeAgreesWithRate,
  timeEntriesFromDdbRecords,
  timeEntryActionSatisfiedByStatus,
  timeEntryFromDdbRecord,
  timeEntryToDdbRecord,
  toBadgeCount,
  toCalendarDate,
  toPortalUnavailableAtAddress,
  toggleBellFilterGroup,
  toggleChoiceSelection,
  toggleMessageReaction,
  togglePhotoTag,
  tokensToAiCredits,
  toolActivityLabel,
  trailMetersBetween,
  truncateQuoteExcerpt,
  unbilledProcessingErrorAmount,
  unifiedRoundUpFromStorage,
  unifiedRoundUpToStorage,
  uniqueRankAmong,
  unitWords,
  unitsAtPrice,
  unpaidClosedPeriods,
  unrefundedSeasonExtraPayments,
  unrefundedSeasonExtraTotal,
  upsertCustomerSelectedOptionState,
  upsertPackageOptionPricing,
  validateAndNormalizePhone,
  validateAssessmentCompletionInputs,
  validateDdbRecord,
  validateHourBounds,
  validateMidSeasonProrationSchedule,
  validateNonNegativeAmount,
  validateNotificationData,
  validateOptionalAmount,
  validatePerHourBounds,
  validatePerVisitBudget,
  validatePeriodIdRemap,
  validatePeriods,
  validateRequiredAmount,
  validateRequiredFields,
  validateScheduleAddition,
  validateServiceActivationSelection,
  validateSlug,
  validateStateTransition,
  validateSubcontractorRateOverrides,
  validateTemporaryNotes,
  validateVisitBillingData,
  validateVisitForCreation,
  validateVisitForSave,
  validateWeatherLimits,
  variantKey,
  viewableVisitPhotos,
  visiblePortalReasons,
  visibleSetupModalItems,
  visitActionRequiresClockIn,
  visitAssignedCrewId,
  visitCalendarDate,
  visitCompleteActionSatisfiedByStatus,
  visitCountsTowardSubscription,
  visitDisplayName,
  visitFromDdbRecord,
  visitHasChargeWait,
  visitHasNotes,
  visitHasPhotos,
  visitInvoiceDiscountAmount,
  visitInvoiceLinesWithoutDiscount,
  visitPhotoSortTimeMs,
  visitReviewReasonLabel,
  visitServiceOptionsActionSatisfiedByUsage,
  visitSpansMultipleDays,
  visitStartActionSatisfiedByStatus,
  visitTapProperties,
  visitTaxRatePercent,
  visitToDdbRecord,
  visitToTypesenseDocument,
  visitsForPricing,
  visitsFromDdbRecords,
  visitsIncluded,
  volumeUnitRateFor,
  waivedPackagePaymentId,
  wasCreatedByImport,
  weatherAlertFromDdbRecord,
  weatherAlertToDdbRecord,
  withLedgerActivityDisplay,
  withPeriodPaid,
  withPeriodUnpaid,
  zChecksSummary,
  zCustomAmountSpec,
  zEngineInfo,
  zEngineRecipeInfo,
  zImportCadence,
  zImportChangeValue,
  zImportDiscount,
  zImportQuestionOf,
  zImportScheduleConfig,
  zLeftOutGroup,
  zProposalPatchOf,
  zQuestionSubject,
  zRateBreakdownLine,
  zSourceExample,
  zStoredAnswer,
  zSubscriptionChange,
  zeroFilledMetrics
};
//# sourceMappingURL=index.mjs.map